var _toConsumableArray = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _toArray = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");
var _slicedToArray = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _classCallCheck = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _asyncToGenerator = require("/root/builder-surface/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
/*! drapcode-common - 1.0.19 */
!function (t, e) {
  'object' == typeof exports && 'object' == typeof module ? module.exports = e() : 'function' == typeof define && define.amd ? define([], e) : 'object' == typeof exports ? exports["drapcode-common"] = e() : t["drapcode-common"] = e();
}(window, function () {
  return function (t) {
    var e = {};
    function n(r) {
      if (e[r]) return e[r].exports;
      var i = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: 'Module'
      }), Object.defineProperty(t, '__esModule', {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, 'default', {
        enumerable: !0,
        value: t
      }), 2 & e && 'string' != typeof t) for (var i in t) n.d(r, i, function (e) {
        return t[e];
      }.bind(null, i));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t['default'];
      } : function () {
        return t;
      };
      return n.d(e, 'a', e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 14);
  }([function (t, e, n) {
    "use strict";

    (function (t) {
      var r = n(4);
      var i = Object.prototype.toString,
        o = Object.getPrototypeOf,
        a = (s = Object.create(null), function (t) {
          var e = i.call(t);
          return s[e] || (s[e] = e.slice(8, -1).toLowerCase());
        });
      var s;
      var c = function c(t) {
          return t = t.toLowerCase(), function (e) {
            return a(e) === t;
          };
        },
        l = function l(t) {
          return function (e) {
            return typeof e === t;
          };
        },
        u = Array.isArray,
        d = l('undefined');
      var h = c('ArrayBuffer');
      var f = l('string'),
        p = l('function'),
        g = l('number'),
        v = function v(t) {
          return null !== t && 'object' == typeof t;
        },
        m = function m(t) {
          if ('object' !== a(t)) return !1;
          var e = o(t);
          return !(null !== e && e !== Object.prototype && null !== Object.getPrototypeOf(e) || Symbol.toStringTag in t || Symbol.iterator in t);
        },
        b = c('Date'),
        y = c('File'),
        w = c('Blob'),
        x = c('FileList'),
        O = c('URLSearchParams');
      function C(t, e) {
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$allOwnKeys = _ref.allOwnKeys,
          n = _ref$allOwnKeys === void 0 ? !1 : _ref$allOwnKeys;
        if (null == t) return;
        var r, i;
        if ('object' != typeof t && (t = [t]), u(t)) for (r = 0, i = t.length; r < i; r++) e.call(null, t[r], r, t);else {
          var _i2 = n ? Object.getOwnPropertyNames(t) : Object.keys(t),
            _o2 = _i2.length;
          var _a2;
          for (r = 0; r < _o2; r++) _a2 = _i2[r], e.call(null, t[_a2], _a2, t);
        }
      }
      function S(t, e) {
        e = e.toLowerCase();
        var n = Object.keys(t);
        var r,
          i = n.length;
        for (; i-- > 0;) if (r = n[i], e === r.toLowerCase()) return r;
        return null;
      }
      var k = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : 'undefined' != typeof window ? window : t,
        T = function T(t) {
          return !d(t) && t !== k;
        };
      var j = (E = 'undefined' != typeof Uint8Array && o(Uint8Array), function (t) {
        return E && t instanceof E;
      });
      var E;
      var P = c('HTMLFormElement'),
        A = function (_ref2) {
          var t = _ref2.hasOwnProperty;
          return function (e, n) {
            return t.call(e, n);
          };
        }(Object.prototype),
        M = c('RegExp'),
        D = function D(t, e) {
          var n = Object.getOwnPropertyDescriptors(t),
            r = {};
          C(n, function (n, i) {
            var o;
            !1 !== (o = e(n, i, t)) && (r[i] = o || n);
          }), Object.defineProperties(t, r);
        },
        L = 'abcdefghijklmnopqrstuvwxyz',
        _ = '0123456789',
        N = {
          DIGIT: _,
          ALPHA: L,
          ALPHA_DIGIT: L + L.toUpperCase() + _
        };
      var I = c('AsyncFunction');
      e["a"] = {
        isArray: u,
        isArrayBuffer: h,
        isBuffer: function isBuffer(t) {
          return null !== t && !d(t) && null !== t.constructor && !d(t.constructor) && p(t.constructor.isBuffer) && t.constructor.isBuffer(t);
        },
        isFormData: function isFormData(t) {
          var e;
          return t && ('function' == typeof FormData && t instanceof FormData || p(t.append) && ('formdata' === (e = a(t)) || 'object' === e && p(t.toString) && '[object FormData]' === t.toString()));
        },
        isArrayBufferView: function isArrayBufferView(t) {
          var e;
          return e = 'undefined' != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && h(t.buffer), e;
        },
        isString: f,
        isNumber: g,
        isBoolean: function isBoolean(t) {
          return !0 === t || !1 === t;
        },
        isObject: v,
        isPlainObject: m,
        isUndefined: d,
        isDate: b,
        isFile: y,
        isBlob: w,
        isRegExp: M,
        isFunction: p,
        isStream: function isStream(t) {
          return v(t) && p(t.pipe);
        },
        isURLSearchParams: O,
        isTypedArray: j,
        isFileList: x,
        forEach: C,
        merge: function t() {
          var _ref3 = T(this) && this || {},
            e = _ref3.caseless,
            n = {},
            r = function r(_r2, i) {
              var o = e && S(n, i) || i;
              m(n[o]) && m(_r2) ? n[o] = t(n[o], _r2) : m(_r2) ? n[o] = t({}, _r2) : u(_r2) ? n[o] = _r2.slice() : n[o] = _r2;
            };
          for (var _t2 = 0, _e2 = arguments.length; _t2 < _e2; _t2++) arguments[_t2] && C(arguments[_t2], r);
          return n;
        },
        extend: function extend(t, e, n) {
          var _ref4 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
            i = _ref4.allOwnKeys;
          return C(e, function (e, i) {
            n && p(e) ? t[i] = Object(r["a"])(e, n) : t[i] = e;
          }, {
            allOwnKeys: i
          }), t;
        },
        trim: function trim(t) {
          return t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        },
        stripBOM: function stripBOM(t) {
          return 65279 === t.charCodeAt(0) && (t = t.slice(1)), t;
        },
        inherits: function inherits(t, e, n, r) {
          t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, 'super', {
            value: e.prototype
          }), n && Object.assign(t.prototype, n);
        },
        toFlatObject: function toFlatObject(t, e, n, r) {
          var i, a, s;
          var c = {};
          if (e = e || {}, null == t) return e;
          do {
            for (i = Object.getOwnPropertyNames(t), a = i.length; a-- > 0;) s = i[a], r && !r(s, t, e) || c[s] || (e[s] = t[s], c[s] = !0);
            t = !1 !== n && o(t);
          } while (t && (!n || n(t, e)) && t !== Object.prototype);
          return e;
        },
        kindOf: a,
        kindOfTest: c,
        endsWith: function endsWith(t, e, n) {
          t = String(t), (void 0 === n || n > t.length) && (n = t.length), n -= e.length;
          var r = t.indexOf(e, n);
          return -1 !== r && r === n;
        },
        toArray: function toArray(t) {
          if (!t) return null;
          if (u(t)) return t;
          var e = t.length;
          if (!g(e)) return null;
          var n = new Array(e);
          for (; e-- > 0;) n[e] = t[e];
          return n;
        },
        forEachEntry: function forEachEntry(t, e) {
          var n = (t && t[Symbol.iterator]).call(t);
          var r;
          for (; (r = n.next()) && !r.done;) {
            var _n2 = r.value;
            e.call(t, _n2[0], _n2[1]);
          }
        },
        matchAll: function matchAll(t, e) {
          var n;
          var r = [];
          for (; null !== (n = t.exec(e));) r.push(n);
          return r;
        },
        isHTMLForm: P,
        hasOwnProperty: A,
        hasOwnProp: A,
        reduceDescriptors: D,
        freezeMethods: function freezeMethods(t) {
          D(t, function (e, n) {
            if (p(t) && -1 !== ['arguments', 'caller', 'callee'].indexOf(n)) return !1;
            var r = t[n];
            p(r) && (e.enumerable = !1, 'writable' in e ? e.writable = !1 : e.set || (e.set = function () {
              throw Error('Can not rewrite read-only method \'' + n + '\'');
            }));
          });
        },
        toObjectSet: function toObjectSet(t, e) {
          var n = {},
            r = function r(t) {
              t.forEach(function (t) {
                n[t] = !0;
              });
            };
          return u(t) ? r(t) : r(String(t).split(e)), n;
        },
        toCamelCase: function toCamelCase(t) {
          return t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (t, e, n) {
            return e.toUpperCase() + n;
          });
        },
        noop: function noop() {},
        toFiniteNumber: function toFiniteNumber(t, e) {
          return t = +t, Number.isFinite(t) ? t : e;
        },
        findKey: S,
        global: k,
        isContextDefined: T,
        ALPHABET: N,
        generateString: function generateString() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : N.ALPHA_DIGIT;
          var n = '';
          var r = e.length;
          for (; t--;) n += e[Math.random() * r | 0];
          return n;
        },
        isSpecCompliantForm: function isSpecCompliantForm(t) {
          return !!(t && p(t.append) && 'FormData' === t[Symbol.toStringTag] && t[Symbol.iterator]);
        },
        toJSONObject: function toJSONObject(t) {
          var e = new Array(10),
            _n3 = function n(t, r) {
              if (v(t)) {
                if (e.indexOf(t) >= 0) return;
                if (!('toJSON' in t)) {
                  e[r] = t;
                  var _i3 = u(t) ? [] : {};
                  return C(t, function (t, e) {
                    var o = _n3(t, r + 1);
                    !d(o) && (_i3[e] = o);
                  }), e[r] = void 0, _i3;
                }
              }
              return t;
            };
          return _n3(t, 0);
        },
        isAsyncFn: I,
        isThenable: function isThenable(t) {
          return t && (v(t) || p(t)) && p(t.then) && p(t.catch);
        }
      };
    }).call(this, n(7));
  }, function (t, e, n) {
    "use strict";

    var r = n(0);
    function i(t, e, n, r, i) {
      Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = 'AxiosError', e && (this.code = e), n && (this.config = n), r && (this.request = r), i && (this.response = i);
    }
    r["a"].inherits(i, Error, {
      toJSON: function toJSON() {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: r["a"].toJSONObject(this.config),
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      }
    });
    var o = i.prototype,
      a = {};
    ['ERR_BAD_OPTION_VALUE', 'ERR_BAD_OPTION', 'ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK', 'ERR_FR_TOO_MANY_REDIRECTS', 'ERR_DEPRECATED', 'ERR_BAD_RESPONSE', 'ERR_BAD_REQUEST', 'ERR_CANCELED', 'ERR_NOT_SUPPORT', 'ERR_INVALID_URL'].forEach(function (t) {
      a[t] = {
        value: t
      };
    }), Object.defineProperties(i, a), Object.defineProperty(o, 'isAxiosError', {
      value: !0
    }), i.from = function (t, e, n, a, s, c) {
      var l = Object.create(o);
      return r["a"].toFlatObject(t, l, function (t) {
        return t !== Error.prototype;
      }, function (t) {
        return 'isAxiosError' !== t;
      }), i.call(l, t.message, e, n, a, s), l.cause = t, l.name = t.name, c && Object.assign(l, c), l;
    }, e["a"] = i;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r = n(0),
        i = n(1),
        o = n(5);
      function a(t) {
        return r["a"].isPlainObject(t) || r["a"].isArray(t);
      }
      function s(t) {
        return r["a"].endsWith(t, '[]') ? t.slice(0, -2) : t;
      }
      function c(t, e, n) {
        return t ? t.concat(e).map(function (t, e) {
          return t = s(t), !n && e ? '[' + t + ']' : t;
        }).join(n ? '.' : '') : e;
      }
      var l = r["a"].toFlatObject(r["a"], {}, null, function (t) {
        return /^is[A-Z]/.test(t);
      });
      e["a"] = function (e, n, u) {
        if (!r["a"].isObject(e)) throw new TypeError('target must be an object');
        n = n || new (o["a"] || FormData)();
        var d = (u = r["a"].toFlatObject(u, {
            metaTokens: !0,
            dots: !1,
            indexes: !1
          }, !1, function (t, e) {
            return !r["a"].isUndefined(e[t]);
          })).metaTokens,
          h = u.visitor || m,
          f = u.dots,
          p = u.indexes,
          g = (u.Blob || 'undefined' != typeof Blob && Blob) && r["a"].isSpecCompliantForm(n);
        if (!r["a"].isFunction(h)) throw new TypeError('visitor must be a function');
        function v(e) {
          if (null === e) return '';
          if (r["a"].isDate(e)) return e.toISOString();
          if (!g && r["a"].isBlob(e)) throw new i["a"]('Blob is not supported. Use a Buffer instead.');
          return r["a"].isArrayBuffer(e) || r["a"].isTypedArray(e) ? g && 'function' == typeof Blob ? new Blob([e]) : t.from(e) : e;
        }
        function m(t, e, i) {
          var o = t;
          if (t && !i && 'object' == typeof t) if (r["a"].endsWith(e, '{}')) e = d ? e : e.slice(0, -2), t = JSON.stringify(t);else if (r["a"].isArray(t) && function (t) {
            return r["a"].isArray(t) && !t.some(a);
          }(t) || (r["a"].isFileList(t) || r["a"].endsWith(e, '[]')) && (o = r["a"].toArray(t))) return e = s(e), o.forEach(function (t, i) {
            !r["a"].isUndefined(t) && null !== t && n.append(!0 === p ? c([e], i, f) : null === p ? e : e + '[]', v(t));
          }), !1;
          return !!a(t) || (n.append(c(i, e, f), v(t)), !1);
        }
        var b = [],
          y = Object.assign(l, {
            defaultVisitor: m,
            convertValue: v,
            isVisitable: a
          });
        if (!r["a"].isObject(e)) throw new TypeError('data must be an object');
        return function t(e, i) {
          if (!r["a"].isUndefined(e)) {
            if (-1 !== b.indexOf(e)) throw Error('Circular reference detected in ' + i.join('.'));
            b.push(e), r["a"].forEach(e, function (e, o) {
              !0 === (!(r["a"].isUndefined(e) || null === e) && h.call(n, e, r["a"].isString(o) ? o.trim() : o, i, y)) && t(e, i ? i.concat(o) : [o]);
            }), b.pop();
          }
        }(e), n;
      };
    }).call(this, n(10).Buffer);
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      n.d(e, "b", function () {
        return a;
      }), n.d(e, "a", function () {
        return s;
      });
      var r = n(6);
      var i = t.env.REACT_APP_BUILDER_ENGINE ? t.env.REACT_APP_BUILDER_ENGINE : "https://builder-api.mydrapcode.com/api/";
      function o(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "pages",
          n = /pages\/(.*?)\/content/;
        switch (e) {
          case "pages":
            n = /pages\/(.*?)\/content/;
            break;
          default:
            n = /snippet-templates\/(.*?)\/content/;
        }
        var r = t.match(n);
        return r ? r[1] : null;
      }
      var a = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(t, e) {
            var n, o;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(t, e) {
                      var n, o;
                      return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            n = "".concat(i, "collections/").concat(t, "/project/").concat(e, "/name"), o = {
                              headers: {
                                "Content-Type": "application/json",
                                "x-project-id": t
                              }
                            };
                            return _context.abrupt("return", r["a"].get(n, o));
                          case 2:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee);
                    }));
                    return function (_x3, _x4) {
                      return _ref6.apply(this, arguments);
                    };
                  }()(t, e);
                case 2:
                  n = _context2.sent;
                  o = [];
                  return _context2.abrupt("return", (n.data && (o = n.data.fields.map(function (t, e) {
                    return {
                      id: t.fieldName,
                      name: t.fieldTitle.en
                    };
                  })), o));
                case 5:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function a(_x, _x2) {
            return _ref5.apply(this, arguments);
          };
        }(),
        s = /*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(t, e, n, a, _s) {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return function () {
                    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(t, e, n, a, s) {
                      var c, _t3, _r3, l, u;
                      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while (1) switch (_context3.prev = _context3.next) {
                          case 0:
                            console.log("🚀 ~ file: utils.js:52 ~ apiCallUpdateCssJsContent uri:", n);
                            c = "".concat(i, "v").concat(e || 1, "/projects/").concat(t, "/");
                            if (console.log("🚀 ~ file: utils.js:74 ~ apiCallUpdateCssJsContent isPrivate:", a), a) if (n && n.includes("/pages/")) {
                              _t3 = o(n);
                              c = "".concat(i, "v").concat(e || 1, "/pages/").concat(_t3, "/");
                            } else if (n && n.includes("/snippet-templates/")) {
                              _r3 = o(n, "snippet");
                              c = "".concat(i, "v").concat(e || 1, "/projects/").concat(t, "/snippet-templates/").concat(_r3, "/");
                            }
                            l = "".concat(c, "update-ux-content"), u = {
                              headers: {
                                "Content-Type": "application/json",
                                "x-project-id": t
                              }
                            };
                            return _context3.abrupt("return", r["a"].put(l, s, u).then(function (t) {
                              console.log("🚀 ~ file: utils.js:65 ~ apiCallUpdateCssJsContent response:", t);
                            }).catch(function (t) {
                              console.log("🚀 ~ file: utils.js:68 ~ apiCallUpdateCssJsContent err:", t);
                            }));
                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }, _callee3);
                    }));
                    return function (_x10, _x11, _x12, _x13, _x14) {
                      return _ref8.apply(this, arguments);
                    };
                  }()(t, e, n, a, _s);
                case 2:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          return function s(_x5, _x6, _x7, _x8, _x9) {
            return _ref7.apply(this, arguments);
          };
        }();
    }).call(this, n(9));
  }, function (t, e, n) {
    "use strict";

    function r(t, e) {
      return function () {
        return t.apply(e, arguments);
      };
    }
    n.d(e, "a", function () {
      return r;
    });
  }, function (t, e, n) {
    "use strict";

    e["a"] = null;
  }, function (t, e, n) {
    "use strict";

    var r = {};
    n.r(r), n.d(r, "hasBrowserEnv", function () {
      return m;
    }), n.d(r, "hasStandardBrowserWebWorkerEnv", function () {
      return w;
    }), n.d(r, "hasStandardBrowserEnv", function () {
      return b;
    });
    var i = n(0),
      o = n(4),
      a = n(2);
    function s(t) {
      var e = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\0'
      };
      return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function (t) {
        return e[t];
      });
    }
    function c(t, e) {
      this._pairs = [], t && Object(a["a"])(t, this, e);
    }
    var l = c.prototype;
    l.append = function (t, e) {
      this._pairs.push([t, e]);
    }, l.toString = function (t) {
      var e = t ? function (e) {
        return t.call(this, e, s);
      } : s;
      return this._pairs.map(function (t) {
        return e(t[0]) + '=' + e(t[1]);
      }, '').join('&');
    };
    var u = c;
    function d(t) {
      return encodeURIComponent(t).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    }
    function h(t, e, n) {
      if (!e) return t;
      var r = n && n.encode || d,
        o = n && n.serialize;
      var a;
      if (a = o ? o(e, n) : i["a"].isURLSearchParams(e) ? e.toString() : new u(e, n).toString(r), a) {
        var _e3 = t.indexOf("#");
        -1 !== _e3 && (t = t.slice(0, _e3)), t += (-1 === t.indexOf('?') ? '?' : '&') + a;
      }
      return t;
    }
    var f = /*#__PURE__*/function () {
        function f() {
          _classCallCheck(this, f);
          this.handlers = [];
        }
        _createClass(f, [{
          key: "use",
          value: function use(t, e, n) {
            return this.handlers.push({
              fulfilled: t,
              rejected: e,
              synchronous: !!n && n.synchronous,
              runWhen: n ? n.runWhen : null
            }), this.handlers.length - 1;
          }
        }, {
          key: "eject",
          value: function eject(t) {
            this.handlers[t] && (this.handlers[t] = null);
          }
        }, {
          key: "clear",
          value: function clear() {
            this.handlers && (this.handlers = []);
          }
        }, {
          key: "forEach",
          value: function forEach(t) {
            i["a"].forEach(this.handlers, function (e) {
              null !== e && t(e);
            });
          }
        }]);
        return f;
      }(),
      p = n(1),
      g = {
        silentJSONParsing: !0,
        forcedJSONParsing: !0,
        clarifyTimeoutError: !1
      },
      v = {
        isBrowser: !0,
        classes: {
          URLSearchParams: 'undefined' != typeof URLSearchParams ? URLSearchParams : u,
          FormData: 'undefined' != typeof FormData ? FormData : null,
          Blob: 'undefined' != typeof Blob ? Blob : null
        },
        protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
      };
    var m = 'undefined' != typeof window && 'undefined' != typeof document,
      b = (y = 'undefined' != typeof navigator && navigator.product, m && ['ReactNative', 'NativeScript', 'NS'].indexOf(y) < 0);
    var y;
    var w = 'undefined' != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && 'function' == typeof self.importScripts;
    var x = _objectSpread({}, r, v);
    var O = function O(t) {
      function e(t, n, r, o) {
        var a = t[o++];
        if ('__proto__' === a) return !0;
        var s = Number.isFinite(+a),
          c = o >= t.length;
        if (a = !a && i["a"].isArray(r) ? r.length : a, c) return i["a"].hasOwnProp(r, a) ? r[a] = [r[a], n] : r[a] = n, !s;
        r[a] && i["a"].isObject(r[a]) || (r[a] = []);
        return e(t, n, r[a], o) && i["a"].isArray(r[a]) && (r[a] = function (t) {
          var e = {},
            n = Object.keys(t);
          var r;
          var i = n.length;
          var o;
          for (r = 0; r < i; r++) o = n[r], e[o] = t[o];
          return e;
        }(r[a])), !s;
      }
      if (i["a"].isFormData(t) && i["a"].isFunction(t.entries)) {
        var _n4 = {};
        return i["a"].forEachEntry(t, function (t, r) {
          e(function (t) {
            return i["a"].matchAll(/\w+|\[(\w*)]/g, t).map(function (t) {
              return '[]' === t[0] ? '' : t[1] || t[0];
            });
          }(t), r, _n4, 0);
        }), _n4;
      }
      return null;
    };
    var C = {
      transitional: g,
      adapter: ['xhr', 'http'],
      transformRequest: [function (t, e) {
        var n = e.getContentType() || '',
          r = n.indexOf('application/json') > -1,
          o = i["a"].isObject(t);
        o && i["a"].isHTMLForm(t) && (t = new FormData(t));
        if (i["a"].isFormData(t)) return r ? JSON.stringify(O(t)) : t;
        if (i["a"].isArrayBuffer(t) || i["a"].isBuffer(t) || i["a"].isStream(t) || i["a"].isFile(t) || i["a"].isBlob(t)) return t;
        if (i["a"].isArrayBufferView(t)) return t.buffer;
        if (i["a"].isURLSearchParams(t)) return e.setContentType('application/x-www-form-urlencoded;charset=utf-8', !1), t.toString();
        var s;
        if (o) {
          if (n.indexOf('application/x-www-form-urlencoded') > -1) return function (t, e) {
            return Object(a["a"])(t, new x.classes.URLSearchParams(), Object.assign({
              visitor: function visitor(t, e, n, r) {
                return x.isNode && i["a"].isBuffer(t) ? (this.append(e, t.toString('base64')), !1) : r.defaultVisitor.apply(this, arguments);
              }
            }, e));
          }(t, this.formSerializer).toString();
          if ((s = i["a"].isFileList(t)) || n.indexOf('multipart/form-data') > -1) {
            var _e4 = this.env && this.env.FormData;
            return Object(a["a"])(s ? {
              'files[]': t
            } : t, _e4 && new _e4(), this.formSerializer);
          }
        }
        return o || r ? (e.setContentType('application/json', !1), function (t, e, n) {
          if (i["a"].isString(t)) try {
            return (e || JSON.parse)(t), i["a"].trim(t);
          } catch (t) {
            if ('SyntaxError' !== t.name) throw t;
          }
          return (n || JSON.stringify)(t);
        }(t)) : t;
      }],
      transformResponse: [function (t) {
        var e = this.transitional || C.transitional,
          n = e && e.forcedJSONParsing,
          r = 'json' === this.responseType;
        if (t && i["a"].isString(t) && (n && !this.responseType || r)) {
          var _n5 = !(e && e.silentJSONParsing) && r;
          try {
            return JSON.parse(t);
          } catch (t) {
            if (_n5) {
              if ('SyntaxError' === t.name) throw p["a"].from(t, p["a"].ERR_BAD_RESPONSE, this, null, this.response);
              throw t;
            }
          }
        }
        return t;
      }],
      timeout: 0,
      xsrfCookieName: 'XSRF-TOKEN',
      xsrfHeaderName: 'X-XSRF-TOKEN',
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {
        FormData: x.classes.FormData,
        Blob: x.classes.Blob
      },
      validateStatus: function validateStatus(t) {
        return t >= 200 && t < 300;
      },
      headers: {
        common: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': void 0
        }
      }
    };
    i["a"].forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], function (t) {
      C.headers[t] = {};
    });
    var S = C;
    var k = i["a"].toObjectSet(['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent']);
    var T = Symbol('internals');
    function j(t) {
      return t && String(t).trim().toLowerCase();
    }
    function E(t) {
      return !1 === t || null == t ? t : i["a"].isArray(t) ? t.map(E) : String(t);
    }
    function P(t, e, n, r, o) {
      return i["a"].isFunction(r) ? r.call(this, e, n) : (o && (e = n), i["a"].isString(e) ? i["a"].isString(r) ? -1 !== e.indexOf(r) : i["a"].isRegExp(r) ? r.test(e) : void 0 : void 0);
    }
    var A = /*#__PURE__*/function () {
      function A(t) {
        _classCallCheck(this, A);
        t && this.set(t);
      }
      _createClass(A, [{
        key: "set",
        value: function set(t, e, n) {
          var r = this;
          function o(t, e, n) {
            var o = j(e);
            if (!o) throw new Error('header name must be a non-empty string');
            var a = i["a"].findKey(r, o);
            (!a || void 0 === r[a] || !0 === n || void 0 === n && !1 !== r[a]) && (r[a || e] = E(t));
          }
          var a = function a(t, e) {
            return i["a"].forEach(t, function (t, n) {
              return o(t, n, e);
            });
          };
          return i["a"].isPlainObject(t) || t instanceof this.constructor ? a(t, e) : i["a"].isString(t) && (t = t.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim()) ? a(function (t) {
            var e = {};
            var n, r, i;
            return t && t.split('\n').forEach(function (t) {
              i = t.indexOf(':'), n = t.substring(0, i).trim().toLowerCase(), r = t.substring(i + 1).trim(), !n || e[n] && k[n] || ('set-cookie' === n ? e[n] ? e[n].push(r) : e[n] = [r] : e[n] = e[n] ? e[n] + ', ' + r : r);
            }), e;
          }(t), e) : null != t && o(e, t, n), this;
        }
      }, {
        key: "get",
        value: function get(t, e) {
          if (t = j(t)) {
            var _n6 = i["a"].findKey(this, t);
            if (_n6) {
              var _t4 = this[_n6];
              if (!e) return _t4;
              if (!0 === e) return function (t) {
                var e = Object.create(null),
                  n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
                var r;
                for (; r = n.exec(t);) e[r[1]] = r[2];
                return e;
              }(_t4);
              if (i["a"].isFunction(e)) return e.call(this, _t4, _n6);
              if (i["a"].isRegExp(e)) return e.exec(_t4);
              throw new TypeError('parser must be boolean|regexp|function');
            }
          }
        }
      }, {
        key: "has",
        value: function has(t, e) {
          if (t = j(t)) {
            var _n7 = i["a"].findKey(this, t);
            return !(!_n7 || void 0 === this[_n7] || e && !P(0, this[_n7], _n7, e));
          }
          return !1;
        }
      }, {
        key: "delete",
        value: function _delete(t, e) {
          var n = this;
          var r = !1;
          function o(t) {
            if (t = j(t)) {
              var _o3 = i["a"].findKey(n, t);
              !_o3 || e && !P(0, n[_o3], _o3, e) || (delete n[_o3], r = !0);
            }
          }
          return i["a"].isArray(t) ? t.forEach(o) : o(t), r;
        }
      }, {
        key: "clear",
        value: function clear(t) {
          var e = Object.keys(this);
          var n = e.length,
            r = !1;
          for (; n--;) {
            var _i4 = e[n];
            t && !P(0, this[_i4], _i4, t, !0) || (delete this[_i4], r = !0);
          }
          return r;
        }
      }, {
        key: "normalize",
        value: function normalize(t) {
          var e = this,
            n = {};
          return i["a"].forEach(this, function (r, o) {
            var a = i["a"].findKey(n, o);
            if (a) return e[a] = E(r), void delete e[o];
            var s = t ? function (t) {
              return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function (t, e, n) {
                return e.toUpperCase() + n;
              });
            }(o) : String(o).trim();
            s !== o && delete e[o], e[s] = E(r), n[s] = !0;
          }), this;
        }
      }, {
        key: "concat",
        value: function concat() {
          var _this$constructor;
          for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
            t[_key] = arguments[_key];
          }
          return (_this$constructor = this.constructor).concat.apply(_this$constructor, [this].concat(t));
        }
      }, {
        key: "toJSON",
        value: function toJSON(t) {
          var e = Object.create(null);
          return i["a"].forEach(this, function (n, r) {
            null != n && !1 !== n && (e[r] = t && i["a"].isArray(n) ? n.join(', ') : n);
          }), e;
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return Object.entries(this.toJSON())[Symbol.iterator]();
        }
      }, {
        key: "toString",
        value: function toString() {
          return Object.entries(this.toJSON()).map(function (_ref9) {
            var _ref10 = _slicedToArray(_ref9, 2),
              t = _ref10[0],
              e = _ref10[1];
            return t + ': ' + e;
          }).join('\n');
        }
      }, {
        key: Symbol.toStringTag,
        get: function get() {
          return 'AxiosHeaders';
        }
      }], [{
        key: "from",
        value: function from(t) {
          return t instanceof this ? t : new this(t);
        }
      }, {
        key: "concat",
        value: function concat(t) {
          var n = new this(t);
          for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            e[_key2 - 1] = arguments[_key2];
          }
          return e.forEach(function (t) {
            return n.set(t);
          }), n;
        }
      }, {
        key: "accessor",
        value: function accessor(t) {
          var e = (this[T] = this[T] = {
              accessors: {}
            }).accessors,
            n = this.prototype;
          function r(t) {
            var r = j(t);
            e[r] || (!function (t, e) {
              var n = i["a"].toCamelCase(' ' + e);
              ['get', 'set', 'has'].forEach(function (r) {
                Object.defineProperty(t, r + n, {
                  value: function value(t, n, i) {
                    return this[r].call(this, e, t, n, i);
                  },
                  configurable: !0
                });
              });
            }(n, t), e[r] = !0);
          }
          return i["a"].isArray(t) ? t.forEach(r) : r(t), this;
        }
      }]);
      return A;
    }();
    A.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']), i["a"].reduceDescriptors(A.prototype, function (_ref11, e) {
      var t = _ref11.value;
      var n = e[0].toUpperCase() + e.slice(1);
      return {
        get: function get() {
          return t;
        },
        set: function set(t) {
          this[n] = t;
        }
      };
    }), i["a"].freezeMethods(A);
    var M = A;
    function D(t, e) {
      var n = this || S,
        r = e || n,
        o = M.from(r.headers);
      var a = r.data;
      return i["a"].forEach(t, function (t) {
        a = t.call(n, a, o.normalize(), e ? e.status : void 0);
      }), o.normalize(), a;
    }
    function L(t) {
      return !(!t || !t.__CANCEL__);
    }
    function _(t, e, n) {
      p["a"].call(this, null == t ? 'canceled' : t, p["a"].ERR_CANCELED, e, n), this.name = 'CanceledError';
    }
    i["a"].inherits(_, p["a"], {
      __CANCEL__: !0
    });
    var N = _,
      I = n(5);
    var R = x.hasStandardBrowserEnv ? {
      write: function write(t, e, n, r, o, a) {
        var s = [t + '=' + encodeURIComponent(e)];
        i["a"].isNumber(n) && s.push('expires=' + new Date(n).toGMTString()), i["a"].isString(r) && s.push('path=' + r), i["a"].isString(o) && s.push('domain=' + o), !0 === a && s.push('secure'), document.cookie = s.join('; ');
      },
      read: function read(t) {
        var e = document.cookie.match(new RegExp('(^|;\\s*)(' + t + ')=([^;]*)'));
        return e ? decodeURIComponent(e[3]) : null;
      },
      remove: function remove(t) {
        this.write(t, '', Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
    function F(t, e) {
      return t && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e) ? function (t, e) {
        return e ? t.replace(/\/?\/$/, '') + '/' + e.replace(/^\/+/, '') : t;
      }(t, e) : e;
    }
    var V = x.hasStandardBrowserEnv ? function () {
      var t = /(msie|trident)/i.test(navigator.userAgent),
        e = document.createElement('a');
      var n;
      function r(n) {
        var r = n;
        return t && (e.setAttribute('href', r), r = e.href), e.setAttribute('href', r), {
          href: e.href,
          protocol: e.protocol ? e.protocol.replace(/:$/, '') : '',
          host: e.host,
          search: e.search ? e.search.replace(/^\?/, '') : '',
          hash: e.hash ? e.hash.replace(/^#/, '') : '',
          hostname: e.hostname,
          port: e.port,
          pathname: '/' === e.pathname.charAt(0) ? e.pathname : '/' + e.pathname
        };
      }
      return n = r(window.location.href), function (t) {
        var e = i["a"].isString(t) ? r(t) : t;
        return e.protocol === n.protocol && e.host === n.host;
      };
    }() : function () {
      return !0;
    };
    var z = function z(t, e) {
      t = t || 10;
      var n = new Array(t),
        r = new Array(t);
      var i,
        o = 0,
        a = 0;
      return e = void 0 !== e ? e : 1e3, function (s) {
        var c = Date.now(),
          l = r[a];
        i || (i = c), n[o] = s, r[o] = c;
        var u = a,
          d = 0;
        for (; u !== o;) d += n[u++], u %= t;
        if (o = (o + 1) % t, o === a && (a = (a + 1) % t), c - i < e) return;
        var h = l && c - l;
        return h ? Math.round(1e3 * d / h) : void 0;
      };
    };
    function H(t, e) {
      var n = 0;
      var r = z(50, 250);
      return function (i) {
        var o = i.loaded,
          a = i.lengthComputable ? i.total : void 0,
          s = o - n,
          c = r(s);
        n = o;
        var l = {
          loaded: o,
          total: a,
          progress: a ? o / a : void 0,
          bytes: s,
          rate: c || void 0,
          estimated: c && a && o <= a ? (a - o) / c : void 0,
          event: i
        };
        l[e ? 'download' : 'upload'] = !0, t(l);
      };
    }
    var B = 'undefined' != typeof XMLHttpRequest && function (t) {
      return new Promise(function (e, n) {
        var r = t.data;
        var o = M.from(t.headers).normalize();
        var a,
          s,
          c = t.responseType,
          l = t.withXSRFToken;
        function u() {
          t.cancelToken && t.cancelToken.unsubscribe(a), t.signal && t.signal.removeEventListener('abort', a);
        }
        if (i["a"].isFormData(r)) if (x.hasStandardBrowserEnv || x.hasStandardBrowserWebWorkerEnv) o.setContentType(!1);else if (!1 !== (s = o.getContentType())) {
          var _ref12 = s ? s.split(';').map(function (t) {
              return t.trim();
            }).filter(Boolean) : [],
            _ref13 = _toArray(_ref12),
            _t5 = _ref13[0],
            _e5 = _ref13.slice(1);
          o.setContentType([_t5 || 'multipart/form-data'].concat(_toConsumableArray(_e5)).join('; '));
        }
        var d = new XMLHttpRequest();
        if (t.auth) {
          var _e6 = t.auth.username || '',
            _n8 = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : '';
          o.set('Authorization', 'Basic ' + btoa(_e6 + ':' + _n8));
        }
        var f = F(t.baseURL, t.url);
        function v() {
          if (!d) return;
          var r = M.from('getAllResponseHeaders' in d && d.getAllResponseHeaders());
          !function (t, e, n) {
            var r = n.config.validateStatus;
            n.status && r && !r(n.status) ? e(new p["a"]('Request failed with status code ' + n.status, [p["a"].ERR_BAD_REQUEST, p["a"].ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
          }(function (t) {
            e(t), u();
          }, function (t) {
            n(t), u();
          }, {
            data: c && 'text' !== c && 'json' !== c ? d.response : d.responseText,
            status: d.status,
            statusText: d.statusText,
            headers: r,
            config: t,
            request: d
          }), d = null;
        }
        if (d.open(t.method.toUpperCase(), h(f, t.params, t.paramsSerializer), !0), d.timeout = t.timeout, 'onloadend' in d ? d.onloadend = v : d.onreadystatechange = function () {
          d && 4 === d.readyState && (0 !== d.status || d.responseURL && 0 === d.responseURL.indexOf('file:')) && setTimeout(v);
        }, d.onabort = function () {
          d && (n(new p["a"]('Request aborted', p["a"].ECONNABORTED, t, d)), d = null);
        }, d.onerror = function () {
          n(new p["a"]('Network Error', p["a"].ERR_NETWORK, t, d)), d = null;
        }, d.ontimeout = function () {
          var e = t.timeout ? 'timeout of ' + t.timeout + 'ms exceeded' : 'timeout exceeded';
          var r = t.transitional || g;
          t.timeoutErrorMessage && (e = t.timeoutErrorMessage), n(new p["a"](e, r.clarifyTimeoutError ? p["a"].ETIMEDOUT : p["a"].ECONNABORTED, t, d)), d = null;
        }, x.hasStandardBrowserEnv && (l && i["a"].isFunction(l) && (l = l(t)), l || !1 !== l && V(f))) {
          var _e7 = t.xsrfHeaderName && t.xsrfCookieName && R.read(t.xsrfCookieName);
          _e7 && o.set(t.xsrfHeaderName, _e7);
        }
        void 0 === r && o.setContentType(null), 'setRequestHeader' in d && i["a"].forEach(o.toJSON(), function (t, e) {
          d.setRequestHeader(e, t);
        }), i["a"].isUndefined(t.withCredentials) || (d.withCredentials = !!t.withCredentials), c && 'json' !== c && (d.responseType = t.responseType), 'function' == typeof t.onDownloadProgress && d.addEventListener('progress', H(t.onDownloadProgress, !0)), 'function' == typeof t.onUploadProgress && d.upload && d.upload.addEventListener('progress', H(t.onUploadProgress)), (t.cancelToken || t.signal) && (a = function a(e) {
          d && (n(!e || e.type ? new N(null, t, d) : e), d.abort(), d = null);
        }, t.cancelToken && t.cancelToken.subscribe(a), t.signal && (t.signal.aborted ? a() : t.signal.addEventListener('abort', a)));
        var m = function (t) {
          var e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
          return e && e[1] || '';
        }(f);
        m && -1 === x.protocols.indexOf(m) ? n(new p["a"]('Unsupported protocol ' + m + ':', p["a"].ERR_BAD_REQUEST, t)) : d.send(r || null);
      });
    };
    var U = {
      http: I["a"],
      xhr: B
    };
    i["a"].forEach(U, function (t, e) {
      if (t) {
        try {
          Object.defineProperty(t, 'name', {
            value: e
          });
        } catch (t) {}
        Object.defineProperty(t, 'adapterName', {
          value: e
        });
      }
    });
    var $ = function $(t) {
        return "- ".concat(t);
      },
      W = function W(t) {
        return i["a"].isFunction(t) || null === t || !1 === t;
      };
    var q = function q(t) {
      t = i["a"].isArray(t) ? t : [t];
      var _t6 = t,
        e = _t6.length;
      var n, r;
      var o = {};
      for (var _i5 = 0; _i5 < e; _i5++) {
        var _e8 = void 0;
        if (n = t[_i5], r = n, !W(n) && (r = U[(_e8 = String(n)).toLowerCase()], void 0 === r)) throw new p["a"]("Unknown adapter '".concat(_e8, "'"));
        if (r) break;
        o[_e8 || '#' + _i5] = r;
      }
      if (!r) {
        var _t7 = Object.entries(o).map(function (_ref14) {
          var _ref15 = _slicedToArray(_ref14, 2),
            t = _ref15[0],
            e = _ref15[1];
          return "adapter ".concat(t, " ") + (!1 === e ? 'is not supported by the environment' : 'is not available in the build');
        });
        var _n9 = e ? _t7.length > 1 ? 'since :\n' + _t7.map($).join('\n') : ' ' + $(_t7[0]) : 'as no adapter specified';
        throw new p["a"]("There is no suitable adapter to dispatch the request " + _n9, 'ERR_NOT_SUPPORT');
      }
      return r;
    };
    function G(t) {
      if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new N(null, t);
    }
    function Y(t) {
      G(t), t.headers = M.from(t.headers), t.data = D.call(t, t.transformRequest), -1 !== ['post', 'put', 'patch'].indexOf(t.method) && t.headers.setContentType('application/x-www-form-urlencoded', !1);
      return q(t.adapter || S.adapter)(t).then(function (e) {
        return G(t), e.data = D.call(t, t.transformResponse, e), e.headers = M.from(e.headers), e;
      }, function (e) {
        return L(e) || (G(t), e && e.response && (e.response.data = D.call(t, t.transformResponse, e.response), e.response.headers = M.from(e.response.headers))), Promise.reject(e);
      });
    }
    var K = function K(t) {
      return t instanceof M ? t.toJSON() : t;
    };
    function X(t, e) {
      e = e || {};
      var n = {};
      function r(t, e, n) {
        return i["a"].isPlainObject(t) && i["a"].isPlainObject(e) ? i["a"].merge.call({
          caseless: n
        }, t, e) : i["a"].isPlainObject(e) ? i["a"].merge({}, e) : i["a"].isArray(e) ? e.slice() : e;
      }
      function o(t, e, n) {
        return i["a"].isUndefined(e) ? i["a"].isUndefined(t) ? void 0 : r(void 0, t, n) : r(t, e, n);
      }
      function a(t, e) {
        if (!i["a"].isUndefined(e)) return r(void 0, e);
      }
      function s(t, e) {
        return i["a"].isUndefined(e) ? i["a"].isUndefined(t) ? void 0 : r(void 0, t) : r(void 0, e);
      }
      function c(n, i, o) {
        return o in e ? r(n, i) : o in t ? r(void 0, n) : void 0;
      }
      var l = {
        url: a,
        method: a,
        data: a,
        baseURL: s,
        transformRequest: s,
        transformResponse: s,
        paramsSerializer: s,
        timeout: s,
        timeoutMessage: s,
        withCredentials: s,
        withXSRFToken: s,
        adapter: s,
        responseType: s,
        xsrfCookieName: s,
        xsrfHeaderName: s,
        onUploadProgress: s,
        onDownloadProgress: s,
        decompress: s,
        maxContentLength: s,
        maxBodyLength: s,
        beforeRedirect: s,
        transport: s,
        httpAgent: s,
        httpsAgent: s,
        cancelToken: s,
        socketPath: s,
        responseEncoding: s,
        validateStatus: c,
        headers: function headers(t, e) {
          return o(K(t), K(e), !0);
        }
      };
      return i["a"].forEach(Object.keys(Object.assign({}, t, e)), function (r) {
        var a = l[r] || o,
          s = a(t[r], e[r], r);
        i["a"].isUndefined(s) && a !== c || (n[r] = s);
      }), n;
    }
    var J = "1.6.7",
      Z = {};
    ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (t, e) {
      Z[t] = function (n) {
        return typeof n === t || 'a' + (e < 1 ? 'n ' : ' ') + t;
      };
    });
    var Q = {};
    Z.transitional = function (t, e, n) {
      function r(t, e) {
        return '[Axios v' + J + '] Transitional option \'' + t + '\'' + e + (n ? '. ' + n : '');
      }
      return function (n, i, o) {
        if (!1 === t) throw new p["a"](r(i, ' has been removed' + (e ? ' in ' + e : '')), p["a"].ERR_DEPRECATED);
        return e && !Q[i] && (Q[i] = !0, console.warn(r(i, ' has been deprecated since v' + e + ' and will be removed in the near future'))), !t || t(n, i, o);
      };
    };
    var tt = {
      assertOptions: function assertOptions(t, e, n) {
        if ('object' != typeof t) throw new p["a"]('options must be an object', p["a"].ERR_BAD_OPTION_VALUE);
        var r = Object.keys(t);
        var i = r.length;
        for (; i-- > 0;) {
          var _o4 = r[i],
            _a3 = e[_o4];
          if (_a3) {
            var _e9 = t[_o4],
              _n10 = void 0 === _e9 || _a3(_e9, _o4, t);
            if (!0 !== _n10) throw new p["a"]('option ' + _o4 + ' must be ' + _n10, p["a"].ERR_BAD_OPTION_VALUE);
          } else if (!0 !== n) throw new p["a"]('Unknown option ' + _o4, p["a"].ERR_BAD_OPTION);
        }
      },
      validators: Z
    };
    var et = tt.validators;
    var nt = /*#__PURE__*/function () {
      function nt(t) {
        _classCallCheck(this, nt);
        this.defaults = t, this.interceptors = {
          request: new f(),
          response: new f()
        };
      }
      _createClass(nt, [{
        key: "request",
        value: function () {
          var _request2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(t, e) {
            var _e10, _n11;
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;
                  _context5.next = 3;
                  return this._request(t, e);
                case 3:
                  return _context5.abrupt("return", _context5.sent);
                case 6:
                  _context5.prev = 6;
                  _context5.t0 = _context5["catch"](0);
                  if (_context5.t0 instanceof Error) {
                    Error.captureStackTrace ? Error.captureStackTrace(_e10 = {}) : _e10 = new Error();
                    _n11 = _e10.stack ? _e10.stack.replace(/^.+\n/, '') : '';
                    _context5.t0.stack ? _n11 && !String(_context5.t0.stack).endsWith(_n11.replace(/^.+\n.+\n/, '')) && (_context5.t0.stack += '\n' + _n11) : _context5.t0.stack = _n11;
                  }
                  throw _context5.t0;
                case 10:
                case "end":
                  return _context5.stop();
              }
            }, _callee5, this, [[0, 6]]);
          }));
          function request(_x15, _x16) {
            return _request2.apply(this, arguments);
          }
          return request;
        }()
      }, {
        key: "_request",
        value: function _request(t, e) {
          'string' == typeof t ? (e = e || {}).url = t : e = t || {}, e = X(this.defaults, e);
          var _e11 = e,
            n = _e11.transitional,
            r = _e11.paramsSerializer,
            o = _e11.headers;
          void 0 !== n && tt.assertOptions(n, {
            silentJSONParsing: et.transitional(et.boolean),
            forcedJSONParsing: et.transitional(et.boolean),
            clarifyTimeoutError: et.transitional(et.boolean)
          }, !1), null != r && (i["a"].isFunction(r) ? e.paramsSerializer = {
            serialize: r
          } : tt.assertOptions(r, {
            encode: et.function,
            serialize: et.function
          }, !0)), e.method = (e.method || this.defaults.method || 'get').toLowerCase();
          var a = o && i["a"].merge(o.common, o[e.method]);
          o && i["a"].forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function (t) {
            delete o[t];
          }), e.headers = M.concat(a, o);
          var s = [];
          var c = !0;
          this.interceptors.request.forEach(function (t) {
            'function' == typeof t.runWhen && !1 === t.runWhen(e) || (c = c && t.synchronous, s.unshift(t.fulfilled, t.rejected));
          });
          var l = [];
          var u;
          this.interceptors.response.forEach(function (t) {
            l.push(t.fulfilled, t.rejected);
          });
          var d,
            h = 0;
          if (!c) {
            var _t8 = [Y.bind(this), void 0];
            for (_t8.unshift.apply(_t8, s), _t8.push.apply(_t8, l), d = _t8.length, u = Promise.resolve(e); h < d;) u = u.then(_t8[h++], _t8[h++]);
            return u;
          }
          d = s.length;
          var f = e;
          for (h = 0; h < d;) {
            var _t9 = s[h++],
              _e12 = s[h++];
            try {
              f = _t9(f);
            } catch (t) {
              _e12.call(this, t);
              break;
            }
          }
          try {
            u = Y.call(this, f);
          } catch (t) {
            return Promise.reject(t);
          }
          for (h = 0, d = l.length; h < d;) u = u.then(l[h++], l[h++]);
          return u;
        }
      }, {
        key: "getUri",
        value: function getUri(t) {
          return h(F((t = X(this.defaults, t)).baseURL, t.url), t.params, t.paramsSerializer);
        }
      }]);
      return nt;
    }();
    i["a"].forEach(['delete', 'get', 'head', 'options'], function (t) {
      nt.prototype[t] = function (e, n) {
        return this.request(X(n || {}, {
          method: t,
          url: e,
          data: (n || {}).data
        }));
      };
    }), i["a"].forEach(['post', 'put', 'patch'], function (t) {
      function e(e) {
        return function (n, r, i) {
          return this.request(X(i || {}, {
            method: t,
            headers: e ? {
              'Content-Type': 'multipart/form-data'
            } : {},
            url: n,
            data: r
          }));
        };
      }
      nt.prototype[t] = e(), nt.prototype[t + 'Form'] = e(!0);
    });
    var rt = nt;
    var it = /*#__PURE__*/function () {
      function it(t) {
        _classCallCheck(this, it);
        if ('function' != typeof t) throw new TypeError('executor must be a function.');
        var e;
        this.promise = new Promise(function (t) {
          e = t;
        });
        var n = this;
        this.promise.then(function (t) {
          if (!n._listeners) return;
          var e = n._listeners.length;
          for (; e-- > 0;) n._listeners[e](t);
          n._listeners = null;
        }), this.promise.then = function (t) {
          var e;
          var r = new Promise(function (t) {
            n.subscribe(t), e = t;
          }).then(t);
          return r.cancel = function () {
            n.unsubscribe(e);
          }, r;
        }, t(function (t, r, i) {
          n.reason || (n.reason = new N(t, r, i), e(n.reason));
        });
      }
      _createClass(it, [{
        key: "throwIfRequested",
        value: function throwIfRequested() {
          if (this.reason) throw this.reason;
        }
      }, {
        key: "subscribe",
        value: function subscribe(t) {
          this.reason ? t(this.reason) : this._listeners ? this._listeners.push(t) : this._listeners = [t];
        }
      }, {
        key: "unsubscribe",
        value: function unsubscribe(t) {
          if (!this._listeners) return;
          var e = this._listeners.indexOf(t);
          -1 !== e && this._listeners.splice(e, 1);
        }
      }], [{
        key: "source",
        value: function source() {
          var t;
          return {
            token: new it(function (e) {
              t = e;
            }),
            cancel: t
          };
        }
      }]);
      return it;
    }();
    var ot = it;
    var at = {
      Continue: 100,
      SwitchingProtocols: 101,
      Processing: 102,
      EarlyHints: 103,
      Ok: 200,
      Created: 201,
      Accepted: 202,
      NonAuthoritativeInformation: 203,
      NoContent: 204,
      ResetContent: 205,
      PartialContent: 206,
      MultiStatus: 207,
      AlreadyReported: 208,
      ImUsed: 226,
      MultipleChoices: 300,
      MovedPermanently: 301,
      Found: 302,
      SeeOther: 303,
      NotModified: 304,
      UseProxy: 305,
      Unused: 306,
      TemporaryRedirect: 307,
      PermanentRedirect: 308,
      BadRequest: 400,
      Unauthorized: 401,
      PaymentRequired: 402,
      Forbidden: 403,
      NotFound: 404,
      MethodNotAllowed: 405,
      NotAcceptable: 406,
      ProxyAuthenticationRequired: 407,
      RequestTimeout: 408,
      Conflict: 409,
      Gone: 410,
      LengthRequired: 411,
      PreconditionFailed: 412,
      PayloadTooLarge: 413,
      UriTooLong: 414,
      UnsupportedMediaType: 415,
      RangeNotSatisfiable: 416,
      ExpectationFailed: 417,
      ImATeapot: 418,
      MisdirectedRequest: 421,
      UnprocessableEntity: 422,
      Locked: 423,
      FailedDependency: 424,
      TooEarly: 425,
      UpgradeRequired: 426,
      PreconditionRequired: 428,
      TooManyRequests: 429,
      RequestHeaderFieldsTooLarge: 431,
      UnavailableForLegalReasons: 451,
      InternalServerError: 500,
      NotImplemented: 501,
      BadGateway: 502,
      ServiceUnavailable: 503,
      GatewayTimeout: 504,
      HttpVersionNotSupported: 505,
      VariantAlsoNegotiates: 506,
      InsufficientStorage: 507,
      LoopDetected: 508,
      NotExtended: 510,
      NetworkAuthenticationRequired: 511
    };
    Object.entries(at).forEach(function (_ref16) {
      var _ref17 = _slicedToArray(_ref16, 2),
        t = _ref17[0],
        e = _ref17[1];
      at[e] = t;
    });
    var st = at;
    var ct = function t(e) {
      var n = new rt(e),
        r = Object(o["a"])(rt.prototype.request, n);
      return i["a"].extend(r, rt.prototype, n, {
        allOwnKeys: !0
      }), i["a"].extend(r, n, null, {
        allOwnKeys: !0
      }), r.create = function (n) {
        return t(X(e, n));
      }, r;
    }(S);
    ct.Axios = rt, ct.CanceledError = N, ct.CancelToken = ot, ct.isCancel = L, ct.VERSION = J, ct.toFormData = a["a"], ct.AxiosError = p["a"], ct.Cancel = ct.CanceledError, ct.all = function (t) {
      return Promise.all(t);
    }, ct.spread = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    }, ct.isAxiosError = function (t) {
      return i["a"].isObject(t) && !0 === t.isAxiosError;
    }, ct.mergeConfig = X, ct.AxiosHeaders = M, ct.formToJSON = function (t) {
      return O(i["a"].isHTMLForm(t) ? new FormData(t) : t);
    }, ct.getAdapter = q, ct.HttpStatusCode = st, ct.default = ct;
    e["a"] = ct;
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  }, function (t, e, n) {
    window, 1 && (t.exports = function (t) {
      var e = {};
      function n(r) {
        if (e[r]) return e[r].exports;
        var i = e[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }
      return n.m = t, n.c = e, n.d = function (t, e, r) {
        n.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, n.t = function (t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var i in t) n.d(r, i, function (e) {
          return t[e];
        }.bind(null, i));
        return r;
      }, n.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return n.d(e, "a", e), e;
      }, n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, n.p = "", n(n.s = 102);
    }([function (t, e, n) {
      "use strict";

      n.r(e), n.d(e, "default", function () {
        return xn;
      }), n.d(e, "VERSION", function () {
        return i.e;
      }), n.d(e, "restArguments", function () {
        return o;
      }), n.d(e, "isObject", function () {
        return a;
      }), n.d(e, "isNull", function () {
        return s;
      }), n.d(e, "isUndefined", function () {
        return c;
      }), n.d(e, "isBoolean", function () {
        return l;
      }), n.d(e, "isElement", function () {
        return u;
      }), n.d(e, "isString", function () {
        return h;
      }), n.d(e, "isNumber", function () {
        return f;
      }), n.d(e, "isDate", function () {
        return p;
      }), n.d(e, "isRegExp", function () {
        return g;
      }), n.d(e, "isError", function () {
        return v;
      }), n.d(e, "isSymbol", function () {
        return m;
      }), n.d(e, "isArrayBuffer", function () {
        return b;
      }), n.d(e, "isDataView", function () {
        return T;
      }), n.d(e, "isArray", function () {
        return j;
      }), n.d(e, "isFunction", function () {
        return x;
      }), n.d(e, "isArguments", function () {
        return A;
      }), n.d(e, "isFinite", function () {
        return M;
      }), n.d(e, "isNaN", function () {
        return D;
      }), n.d(e, "isTypedArray", function () {
        return V;
      }), n.d(e, "isEmpty", function () {
        return U;
      }), n.d(e, "isMatch", function () {
        return $;
      }), n.d(e, "isEqual", function () {
        return G;
      }), n.d(e, "isMap", function () {
        return nt;
      }), n.d(e, "isWeakMap", function () {
        return rt;
      }), n.d(e, "isSet", function () {
        return it;
      }), n.d(e, "isWeakSet", function () {
        return ot;
      }), n.d(e, "keys", function () {
        return B;
      }), n.d(e, "allKeys", function () {
        return Y;
      }), n.d(e, "values", function () {
        return at;
      }), n.d(e, "pairs", function () {
        return st;
      }), n.d(e, "invert", function () {
        return ct;
      }), n.d(e, "functions", function () {
        return lt;
      }), n.d(e, "methods", function () {
        return lt;
      }), n.d(e, "extend", function () {
        return dt;
      }), n.d(e, "extendOwn", function () {
        return ht;
      }), n.d(e, "assign", function () {
        return ht;
      }), n.d(e, "defaults", function () {
        return ft;
      }), n.d(e, "create", function () {
        return gt;
      }), n.d(e, "clone", function () {
        return vt;
      }), n.d(e, "tap", function () {
        return mt;
      }), n.d(e, "get", function () {
        return xt;
      }), n.d(e, "has", function () {
        return Ot;
      }), n.d(e, "mapObject", function () {
        return At;
      }), n.d(e, "identity", function () {
        return Ct;
      }), n.d(e, "constant", function () {
        return L;
      }), n.d(e, "noop", function () {
        return Mt;
      }), n.d(e, "toPath", function () {
        return bt;
      }), n.d(e, "property", function () {
        return kt;
      }), n.d(e, "propertyOf", function () {
        return Dt;
      }), n.d(e, "matcher", function () {
        return St;
      }), n.d(e, "matches", function () {
        return St;
      }), n.d(e, "times", function () {
        return Lt;
      }), n.d(e, "random", function () {
        return _t;
      }), n.d(e, "now", function () {
        return Nt;
      }), n.d(e, "escape", function () {
        return Ft;
      }), n.d(e, "unescape", function () {
        return Vt;
      }), n.d(e, "templateSettings", function () {
        return zt;
      }), n.d(e, "template", function () {
        return qt;
      }), n.d(e, "result", function () {
        return Gt;
      }), n.d(e, "uniqueId", function () {
        return Kt;
      }), n.d(e, "chain", function () {
        return Xt;
      }), n.d(e, "iteratee", function () {
        return Et;
      }), n.d(e, "partial", function () {
        return Qt;
      }), n.d(e, "bind", function () {
        return te;
      }), n.d(e, "bindAll", function () {
        return re;
      }), n.d(e, "memoize", function () {
        return ie;
      }), n.d(e, "delay", function () {
        return oe;
      }), n.d(e, "defer", function () {
        return ae;
      }), n.d(e, "throttle", function () {
        return se;
      }), n.d(e, "debounce", function () {
        return ce;
      }), n.d(e, "wrap", function () {
        return le;
      }), n.d(e, "negate", function () {
        return ue;
      }), n.d(e, "compose", function () {
        return de;
      }), n.d(e, "after", function () {
        return he;
      }), n.d(e, "before", function () {
        return fe;
      }), n.d(e, "once", function () {
        return pe;
      }), n.d(e, "findKey", function () {
        return ge;
      }), n.d(e, "findIndex", function () {
        return me;
      }), n.d(e, "findLastIndex", function () {
        return be;
      }), n.d(e, "sortedIndex", function () {
        return ye;
      }), n.d(e, "indexOf", function () {
        return xe;
      }), n.d(e, "lastIndexOf", function () {
        return Oe;
      }), n.d(e, "find", function () {
        return Ce;
      }), n.d(e, "detect", function () {
        return Ce;
      }), n.d(e, "findWhere", function () {
        return Se;
      }), n.d(e, "each", function () {
        return ke;
      }), n.d(e, "forEach", function () {
        return ke;
      }), n.d(e, "map", function () {
        return Te;
      }), n.d(e, "collect", function () {
        return Te;
      }), n.d(e, "reduce", function () {
        return Ee;
      }), n.d(e, "foldl", function () {
        return Ee;
      }), n.d(e, "inject", function () {
        return Ee;
      }), n.d(e, "reduceRight", function () {
        return Pe;
      }), n.d(e, "foldr", function () {
        return Pe;
      }), n.d(e, "filter", function () {
        return Ae;
      }), n.d(e, "select", function () {
        return Ae;
      }), n.d(e, "reject", function () {
        return Me;
      }), n.d(e, "every", function () {
        return De;
      }), n.d(e, "all", function () {
        return De;
      }), n.d(e, "some", function () {
        return Le;
      }), n.d(e, "any", function () {
        return Le;
      }), n.d(e, "contains", function () {
        return _e;
      }), n.d(e, "includes", function () {
        return _e;
      }), n.d(e, "include", function () {
        return _e;
      }), n.d(e, "invoke", function () {
        return Ne;
      }), n.d(e, "pluck", function () {
        return Ie;
      }), n.d(e, "where", function () {
        return Re;
      }), n.d(e, "max", function () {
        return Fe;
      }), n.d(e, "min", function () {
        return Ve;
      }), n.d(e, "shuffle", function () {
        return Ue;
      }), n.d(e, "sample", function () {
        return Be;
      }), n.d(e, "sortBy", function () {
        return $e;
      }), n.d(e, "groupBy", function () {
        return qe;
      }), n.d(e, "indexBy", function () {
        return Ge;
      }), n.d(e, "countBy", function () {
        return Ye;
      }), n.d(e, "partition", function () {
        return Ke;
      }), n.d(e, "toArray", function () {
        return He;
      }), n.d(e, "size", function () {
        return Xe;
      }), n.d(e, "pick", function () {
        return Ze;
      }), n.d(e, "omit", function () {
        return Qe;
      }), n.d(e, "first", function () {
        return en;
      }), n.d(e, "head", function () {
        return en;
      }), n.d(e, "take", function () {
        return en;
      }), n.d(e, "initial", function () {
        return tn;
      }), n.d(e, "last", function () {
        return rn;
      }), n.d(e, "rest", function () {
        return nn;
      }), n.d(e, "tail", function () {
        return nn;
      }), n.d(e, "drop", function () {
        return nn;
      }), n.d(e, "compact", function () {
        return on;
      }), n.d(e, "flatten", function () {
        return an;
      }), n.d(e, "without", function () {
        return cn;
      }), n.d(e, "uniq", function () {
        return ln;
      }), n.d(e, "unique", function () {
        return ln;
      }), n.d(e, "union", function () {
        return un;
      }), n.d(e, "intersection", function () {
        return dn;
      }), n.d(e, "difference", function () {
        return sn;
      }), n.d(e, "unzip", function () {
        return hn;
      }), n.d(e, "transpose", function () {
        return hn;
      }), n.d(e, "zip", function () {
        return fn;
      }), n.d(e, "object", function () {
        return pn;
      }), n.d(e, "range", function () {
        return gn;
      }), n.d(e, "chunk", function () {
        return vn;
      }), n.d(e, "mixin", function () {
        return bn;
      });
      var r = {};
      n.r(r), n.d(r, "VERSION", function () {
        return i.e;
      }), n.d(r, "restArguments", function () {
        return o;
      }), n.d(r, "isObject", function () {
        return a;
      }), n.d(r, "isNull", function () {
        return s;
      }), n.d(r, "isUndefined", function () {
        return c;
      }), n.d(r, "isBoolean", function () {
        return l;
      }), n.d(r, "isElement", function () {
        return u;
      }), n.d(r, "isString", function () {
        return h;
      }), n.d(r, "isNumber", function () {
        return f;
      }), n.d(r, "isDate", function () {
        return p;
      }), n.d(r, "isRegExp", function () {
        return g;
      }), n.d(r, "isError", function () {
        return v;
      }), n.d(r, "isSymbol", function () {
        return m;
      }), n.d(r, "isArrayBuffer", function () {
        return b;
      }), n.d(r, "isDataView", function () {
        return T;
      }), n.d(r, "isArray", function () {
        return j;
      }), n.d(r, "isFunction", function () {
        return x;
      }), n.d(r, "isArguments", function () {
        return A;
      }), n.d(r, "isFinite", function () {
        return M;
      }), n.d(r, "isNaN", function () {
        return D;
      }), n.d(r, "isTypedArray", function () {
        return V;
      }), n.d(r, "isEmpty", function () {
        return U;
      }), n.d(r, "isMatch", function () {
        return $;
      }), n.d(r, "isEqual", function () {
        return G;
      }), n.d(r, "isMap", function () {
        return nt;
      }), n.d(r, "isWeakMap", function () {
        return rt;
      }), n.d(r, "isSet", function () {
        return it;
      }), n.d(r, "isWeakSet", function () {
        return ot;
      }), n.d(r, "keys", function () {
        return B;
      }), n.d(r, "allKeys", function () {
        return Y;
      }), n.d(r, "values", function () {
        return at;
      }), n.d(r, "pairs", function () {
        return st;
      }), n.d(r, "invert", function () {
        return ct;
      }), n.d(r, "functions", function () {
        return lt;
      }), n.d(r, "methods", function () {
        return lt;
      }), n.d(r, "extend", function () {
        return dt;
      }), n.d(r, "extendOwn", function () {
        return ht;
      }), n.d(r, "assign", function () {
        return ht;
      }), n.d(r, "defaults", function () {
        return ft;
      }), n.d(r, "create", function () {
        return gt;
      }), n.d(r, "clone", function () {
        return vt;
      }), n.d(r, "tap", function () {
        return mt;
      }), n.d(r, "get", function () {
        return xt;
      }), n.d(r, "has", function () {
        return Ot;
      }), n.d(r, "mapObject", function () {
        return At;
      }), n.d(r, "identity", function () {
        return Ct;
      }), n.d(r, "constant", function () {
        return L;
      }), n.d(r, "noop", function () {
        return Mt;
      }), n.d(r, "toPath", function () {
        return bt;
      }), n.d(r, "property", function () {
        return kt;
      }), n.d(r, "propertyOf", function () {
        return Dt;
      }), n.d(r, "matcher", function () {
        return St;
      }), n.d(r, "matches", function () {
        return St;
      }), n.d(r, "times", function () {
        return Lt;
      }), n.d(r, "random", function () {
        return _t;
      }), n.d(r, "now", function () {
        return Nt;
      }), n.d(r, "escape", function () {
        return Ft;
      }), n.d(r, "unescape", function () {
        return Vt;
      }), n.d(r, "templateSettings", function () {
        return zt;
      }), n.d(r, "template", function () {
        return qt;
      }), n.d(r, "result", function () {
        return Gt;
      }), n.d(r, "uniqueId", function () {
        return Kt;
      }), n.d(r, "chain", function () {
        return Xt;
      }), n.d(r, "iteratee", function () {
        return Et;
      }), n.d(r, "partial", function () {
        return Qt;
      }), n.d(r, "bind", function () {
        return te;
      }), n.d(r, "bindAll", function () {
        return re;
      }), n.d(r, "memoize", function () {
        return ie;
      }), n.d(r, "delay", function () {
        return oe;
      }), n.d(r, "defer", function () {
        return ae;
      }), n.d(r, "throttle", function () {
        return se;
      }), n.d(r, "debounce", function () {
        return ce;
      }), n.d(r, "wrap", function () {
        return le;
      }), n.d(r, "negate", function () {
        return ue;
      }), n.d(r, "compose", function () {
        return de;
      }), n.d(r, "after", function () {
        return he;
      }), n.d(r, "before", function () {
        return fe;
      }), n.d(r, "once", function () {
        return pe;
      }), n.d(r, "findKey", function () {
        return ge;
      }), n.d(r, "findIndex", function () {
        return me;
      }), n.d(r, "findLastIndex", function () {
        return be;
      }), n.d(r, "sortedIndex", function () {
        return ye;
      }), n.d(r, "indexOf", function () {
        return xe;
      }), n.d(r, "lastIndexOf", function () {
        return Oe;
      }), n.d(r, "find", function () {
        return Ce;
      }), n.d(r, "detect", function () {
        return Ce;
      }), n.d(r, "findWhere", function () {
        return Se;
      }), n.d(r, "each", function () {
        return ke;
      }), n.d(r, "forEach", function () {
        return ke;
      }), n.d(r, "map", function () {
        return Te;
      }), n.d(r, "collect", function () {
        return Te;
      }), n.d(r, "reduce", function () {
        return Ee;
      }), n.d(r, "foldl", function () {
        return Ee;
      }), n.d(r, "inject", function () {
        return Ee;
      }), n.d(r, "reduceRight", function () {
        return Pe;
      }), n.d(r, "foldr", function () {
        return Pe;
      }), n.d(r, "filter", function () {
        return Ae;
      }), n.d(r, "select", function () {
        return Ae;
      }), n.d(r, "reject", function () {
        return Me;
      }), n.d(r, "every", function () {
        return De;
      }), n.d(r, "all", function () {
        return De;
      }), n.d(r, "some", function () {
        return Le;
      }), n.d(r, "any", function () {
        return Le;
      }), n.d(r, "contains", function () {
        return _e;
      }), n.d(r, "includes", function () {
        return _e;
      }), n.d(r, "include", function () {
        return _e;
      }), n.d(r, "invoke", function () {
        return Ne;
      }), n.d(r, "pluck", function () {
        return Ie;
      }), n.d(r, "where", function () {
        return Re;
      }), n.d(r, "max", function () {
        return Fe;
      }), n.d(r, "min", function () {
        return Ve;
      }), n.d(r, "shuffle", function () {
        return Ue;
      }), n.d(r, "sample", function () {
        return Be;
      }), n.d(r, "sortBy", function () {
        return $e;
      }), n.d(r, "groupBy", function () {
        return qe;
      }), n.d(r, "indexBy", function () {
        return Ge;
      }), n.d(r, "countBy", function () {
        return Ye;
      }), n.d(r, "partition", function () {
        return Ke;
      }), n.d(r, "toArray", function () {
        return He;
      }), n.d(r, "size", function () {
        return Xe;
      }), n.d(r, "pick", function () {
        return Ze;
      }), n.d(r, "omit", function () {
        return Qe;
      }), n.d(r, "first", function () {
        return en;
      }), n.d(r, "head", function () {
        return en;
      }), n.d(r, "take", function () {
        return en;
      }), n.d(r, "initial", function () {
        return tn;
      }), n.d(r, "last", function () {
        return rn;
      }), n.d(r, "rest", function () {
        return nn;
      }), n.d(r, "tail", function () {
        return nn;
      }), n.d(r, "drop", function () {
        return nn;
      }), n.d(r, "compact", function () {
        return on;
      }), n.d(r, "flatten", function () {
        return an;
      }), n.d(r, "without", function () {
        return cn;
      }), n.d(r, "uniq", function () {
        return ln;
      }), n.d(r, "unique", function () {
        return ln;
      }), n.d(r, "union", function () {
        return un;
      }), n.d(r, "intersection", function () {
        return dn;
      }), n.d(r, "difference", function () {
        return sn;
      }), n.d(r, "unzip", function () {
        return hn;
      }), n.d(r, "transpose", function () {
        return hn;
      }), n.d(r, "zip", function () {
        return fn;
      }), n.d(r, "object", function () {
        return pn;
      }), n.d(r, "range", function () {
        return gn;
      }), n.d(r, "chunk", function () {
        return vn;
      }), n.d(r, "mixin", function () {
        return bn;
      }), n.d(r, "default", function () {
        return yn;
      });
      var i = n(4);
      function o(t, e) {
        return e = null == e ? t.length - 1 : +e, function () {
          for (var n = Math.max(arguments.length - e, 0), r = Array(n), i = 0; i < n; i++) r[i] = arguments[i + e];
          switch (e) {
            case 0:
              return t.call(this, r);
            case 1:
              return t.call(this, arguments[0], r);
            case 2:
              return t.call(this, arguments[0], arguments[1], r);
          }
          var o = Array(e + 1);
          for (i = 0; i < e; i++) o[i] = arguments[i];
          return o[e] = r, t.apply(this, o);
        };
      }
      function a(t) {
        var e = typeof t;
        return "function" === e || "object" === e && !!t;
      }
      function s(t) {
        return null === t;
      }
      function c(t) {
        return void 0 === t;
      }
      function l(t) {
        return !0 === t || !1 === t || "[object Boolean]" === i.t.call(t);
      }
      function u(t) {
        return !(!t || 1 !== t.nodeType);
      }
      function d(t) {
        var e = "[object " + t + "]";
        return function (t) {
          return i.t.call(t) === e;
        };
      }
      var h = d("String"),
        f = d("Number"),
        p = d("Date"),
        g = d("RegExp"),
        v = d("Error"),
        m = d("Symbol"),
        b = d("ArrayBuffer"),
        y = d("Function"),
        w = i.p.document && i.p.document.childNodes;
      "object" != typeof Int8Array && "function" != typeof w && (y = function y(t) {
        return "function" == typeof t || !1;
      });
      var x = y,
        O = d("Object"),
        C = i.s && O(new DataView(new ArrayBuffer(8))),
        S = "undefined" != typeof Map && O(new Map()),
        k = d("DataView"),
        T = C ? function (t) {
          return null != t && x(t.getInt8) && b(t.buffer);
        } : k,
        j = i.k || d("Array");
      function E(t, e) {
        return null != t && i.i.call(t, e);
      }
      var P = d("Arguments");
      !function () {
        P(arguments) || (P = function P(t) {
          return E(t, "callee");
        });
      }();
      var A = P;
      function M(t) {
        return !m(t) && Object(i.f)(t) && !isNaN(parseFloat(t));
      }
      function D(t) {
        return f(t) && Object(i.g)(t);
      }
      function L(t) {
        return function () {
          return t;
        };
      }
      function _(t) {
        return function (e) {
          var n = t(e);
          return "number" == typeof n && n >= 0 && n <= i.b;
        };
      }
      function N(t) {
        return function (e) {
          return null == e ? void 0 : e[t];
        };
      }
      var I = N("byteLength"),
        R = _(I),
        F = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/,
        V = i.r ? function (t) {
          return i.l ? Object(i.l)(t) && !T(t) : R(t) && F.test(i.t.call(t));
        } : L(!1),
        z = N("length");
      function H(t, e) {
        e = function (t) {
          for (var e = {}, n = t.length, r = 0; r < n; ++r) e[t[r]] = !0;
          return {
            contains: function contains(t) {
              return !0 === e[t];
            },
            push: function push(n) {
              return e[n] = !0, t.push(n);
            }
          };
        }(e);
        var n = i.n.length,
          r = t.constructor,
          o = x(r) && r.prototype || i.c,
          a = "constructor";
        for (E(t, a) && !e.contains(a) && e.push(a); n--;) (a = i.n[n]) in t && t[a] !== o[a] && !e.contains(a) && e.push(a);
      }
      function B(t) {
        if (!a(t)) return [];
        if (i.m) return Object(i.m)(t);
        var e = [];
        for (var n in t) E(t, n) && e.push(n);
        return i.h && H(t, e), e;
      }
      function U(t) {
        if (null == t) return !0;
        var e = z(t);
        return "number" == typeof e && (j(t) || h(t) || A(t)) ? 0 === e : 0 === z(B(t));
      }
      function $(t, e) {
        var n = B(e),
          r = n.length;
        if (null == t) return !r;
        for (var i = Object(t), o = 0; o < r; o++) {
          var a = n[o];
          if (e[a] !== i[a] || !(a in i)) return !1;
        }
        return !0;
      }
      function W(t) {
        return t instanceof W ? t : this instanceof W ? void (this._wrapped = t) : new W(t);
      }
      function q(t) {
        return new Uint8Array(t.buffer || t, t.byteOffset || 0, I(t));
      }
      function G(t, e) {
        return function t(e, n, r, o) {
          if (e === n) return 0 !== e || 1 / e == 1 / n;
          if (null == e || null == n) return !1;
          if (e != e) return n != n;
          var a = typeof e;
          return ("function" === a || "object" === a || "object" == typeof n) && function e(n, r, o, a) {
            n instanceof W && (n = n._wrapped), r instanceof W && (r = r._wrapped);
            var s = i.t.call(n);
            if (s !== i.t.call(r)) return !1;
            if (C && "[object Object]" == s && T(n)) {
              if (!T(r)) return !1;
              s = "[object DataView]";
            }
            switch (s) {
              case "[object RegExp]":
              case "[object String]":
                return "" + n == "" + r;
              case "[object Number]":
                return +n != +n ? +r != +r : 0 == +n ? 1 / +n == 1 / r : +n == +r;
              case "[object Date]":
              case "[object Boolean]":
                return +n == +r;
              case "[object Symbol]":
                return i.d.valueOf.call(n) === i.d.valueOf.call(r);
              case "[object ArrayBuffer]":
              case "[object DataView]":
                return e(q(n), q(r), o, a);
            }
            var c = "[object Array]" === s;
            if (!c && V(n)) {
              if (I(n) !== I(r)) return !1;
              if (n.buffer === r.buffer && n.byteOffset === r.byteOffset) return !0;
              c = !0;
            }
            if (!c) {
              if ("object" != typeof n || "object" != typeof r) return !1;
              var l = n.constructor,
                u = r.constructor;
              if (l !== u && !(x(l) && l instanceof l && x(u) && u instanceof u) && "constructor" in n && "constructor" in r) return !1;
            }
            a = a || [];
            for (var d = (o = o || []).length; d--;) if (o[d] === n) return a[d] === r;
            if (o.push(n), a.push(r), c) {
              if ((d = n.length) !== r.length) return !1;
              for (; d--;) if (!t(n[d], r[d], o, a)) return !1;
            } else {
              var h,
                f = B(n);
              if (d = f.length, B(r).length !== d) return !1;
              for (; d--;) if (!E(r, h = f[d]) || !t(n[h], r[h], o, a)) return !1;
            }
            return o.pop(), a.pop(), !0;
          }(e, n, r, o);
        }(t, e);
      }
      function Y(t) {
        if (!a(t)) return [];
        var e = [];
        for (var n in t) e.push(n);
        return i.h && H(t, e), e;
      }
      function K(t) {
        var e = z(t);
        return function (n) {
          if (null == n) return !1;
          var r = Y(n);
          if (z(r)) return !1;
          for (var i = 0; i < e; i++) if (!x(n[t[i]])) return !1;
          return t !== tt || !x(n[X]);
        };
      }
      W.VERSION = i.e, W.prototype.value = function () {
        return this._wrapped;
      }, W.prototype.valueOf = W.prototype.toJSON = W.prototype.value, W.prototype.toString = function () {
        return String(this._wrapped);
      };
      var X = "forEach",
        J = ["clear", "delete"],
        Z = ["get", "has", "set"],
        Q = J.concat(X, Z),
        tt = J.concat(Z),
        et = ["add"].concat(J, X, "has"),
        nt = S ? K(Q) : d("Map"),
        rt = S ? K(tt) : d("WeakMap"),
        it = S ? K(et) : d("Set"),
        ot = d("WeakSet");
      function at(t) {
        for (var e = B(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = t[e[i]];
        return r;
      }
      function st(t) {
        for (var e = B(t), n = e.length, r = Array(n), i = 0; i < n; i++) r[i] = [e[i], t[e[i]]];
        return r;
      }
      function ct(t) {
        for (var e = {}, n = B(t), r = 0, i = n.length; r < i; r++) e[t[n[r]]] = n[r];
        return e;
      }
      function lt(t) {
        var e = [];
        for (var n in t) x(t[n]) && e.push(n);
        return e.sort();
      }
      function ut(t, e) {
        return function (n) {
          var r = arguments.length;
          if (e && (n = Object(n)), r < 2 || null == n) return n;
          for (var i = 1; i < r; i++) for (var o = arguments[i], a = t(o), s = a.length, c = 0; c < s; c++) {
            var l = a[c];
            e && void 0 !== n[l] || (n[l] = o[l]);
          }
          return n;
        };
      }
      var dt = ut(Y),
        ht = ut(B),
        ft = ut(Y, !0);
      function pt(t) {
        if (!a(t)) return {};
        if (i.j) return Object(i.j)(t);
        var e = function e() {};
        e.prototype = t;
        var n = new e();
        return e.prototype = null, n;
      }
      function gt(t, e) {
        var n = pt(t);
        return e && ht(n, e), n;
      }
      function vt(t) {
        return a(t) ? j(t) ? t.slice() : dt({}, t) : t;
      }
      function mt(t, e) {
        return e(t), t;
      }
      function bt(t) {
        return j(t) ? t : [t];
      }
      function yt(t) {
        return W.toPath(t);
      }
      function wt(t, e) {
        for (var n = e.length, r = 0; r < n; r++) {
          if (null == t) return;
          t = t[e[r]];
        }
        return n ? t : void 0;
      }
      function xt(t, e, n) {
        var r = wt(t, yt(e));
        return c(r) ? n : r;
      }
      function Ot(t, e) {
        for (var n = (e = yt(e)).length, r = 0; r < n; r++) {
          var i = e[r];
          if (!E(t, i)) return !1;
          t = t[i];
        }
        return !!n;
      }
      function Ct(t) {
        return t;
      }
      function St(t) {
        return t = ht({}, t), function (e) {
          return $(e, t);
        };
      }
      function kt(t) {
        return t = yt(t), function (e) {
          return wt(e, t);
        };
      }
      function Tt(t, e, n) {
        if (void 0 === e) return t;
        switch (null == n ? 3 : n) {
          case 1:
            return function (n) {
              return t.call(e, n);
            };
          case 3:
            return function (n, r, i) {
              return t.call(e, n, r, i);
            };
          case 4:
            return function (n, r, i, o) {
              return t.call(e, n, r, i, o);
            };
        }
        return function () {
          return t.apply(e, arguments);
        };
      }
      function jt(t, e, n) {
        return null == t ? Ct : x(t) ? Tt(t, e, n) : a(t) && !j(t) ? St(t) : kt(t);
      }
      function Et(t, e) {
        return jt(t, e, 1 / 0);
      }
      function Pt(t, e, n) {
        return W.iteratee !== Et ? W.iteratee(t, e) : jt(t, e, n);
      }
      function At(t, e, n) {
        e = Pt(e, n);
        for (var r = B(t), i = r.length, o = {}, a = 0; a < i; a++) {
          var s = r[a];
          o[s] = e(t[s], s, t);
        }
        return o;
      }
      function Mt() {}
      function Dt(t) {
        return null == t ? Mt : function (e) {
          return xt(t, e);
        };
      }
      function Lt(t, e, n) {
        var r = Array(Math.max(0, t));
        e = Tt(e, n, 1);
        for (var i = 0; i < t; i++) r[i] = e(i);
        return r;
      }
      function _t(t, e) {
        return null == e && (e = t, t = 0), t + Math.floor(Math.random() * (e - t + 1));
      }
      W.toPath = bt, W.iteratee = Et;
      var Nt = Date.now || function () {
        return new Date().getTime();
      };
      function It(t) {
        var e = function (_e13) {
            function e(_x17) {
              return _e13.apply(this, arguments);
            }
            e.toString = function () {
              return _e13.toString();
            };
            return e;
          }(function (e) {
            return t[e];
          }),
          n = "(?:" + B(t).join("|") + ")",
          r = RegExp(n),
          i = RegExp(n, "g");
        return function (t) {
          return t = null == t ? "" : "" + t, r.test(t) ? t.replace(i, e) : t;
        };
      }
      var Rt = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;"
        },
        Ft = It(Rt),
        Vt = It(ct(Rt)),
        zt = W.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g
        },
        Ht = /(.)^/,
        Bt = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
        Ut = /\\|'|\r|\n|\u2028|\u2029/g;
      function $t(t) {
        return "\\" + Bt[t];
      }
      var Wt = /^\s*(\w|\$)+\s*$/;
      function qt(t, e, n) {
        !e && n && (e = n), e = ft({}, e, W.templateSettings);
        var r = RegExp([(e.escape || Ht).source, (e.interpolate || Ht).source, (e.evaluate || Ht).source].join("|") + "|$", "g"),
          i = 0,
          o = "__p+='";
        t.replace(r, function (e, n, r, a, s) {
          return o += t.slice(i, s).replace(Ut, $t), i = s + e.length, n ? o += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'" : r ? o += "'+\n((__t=(" + r + "))==null?'':__t)+\n'" : a && (o += "';\n" + a + "\n__p+='"), e;
        }), o += "';\n";
        var a,
          s = e.variable;
        if (s) {
          if (!Wt.test(s)) throw new Error("variable is not a bare identifier: " + s);
        } else o = "with(obj||{}){\n" + o + "}\n", s = "obj";
        o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
        try {
          a = new Function(s, "_", o);
        } catch (t) {
          throw t.source = o, t;
        }
        var c = function c(t) {
          return a.call(this, t, W);
        };
        return c.source = "function(" + s + "){\n" + o + "}", c;
      }
      function Gt(t, e, n) {
        var r = (e = yt(e)).length;
        if (!r) return x(n) ? n.call(t) : n;
        for (var i = 0; i < r; i++) {
          var o = null == t ? void 0 : t[e[i]];
          void 0 === o && (o = n, i = r), t = x(o) ? o.call(t) : o;
        }
        return t;
      }
      var Yt = 0;
      function Kt(t) {
        var e = ++Yt + "";
        return t ? t + e : e;
      }
      function Xt(t) {
        var e = W(t);
        return e._chain = !0, e;
      }
      function Jt(t, e, n, r, i) {
        if (!(r instanceof e)) return t.apply(n, i);
        var o = pt(t.prototype),
          s = t.apply(o, i);
        return a(s) ? s : o;
      }
      var Zt = o(function (t, e) {
        var n = Zt.placeholder,
          _r4 = function r() {
            for (var i = 0, o = e.length, a = Array(o), s = 0; s < o; s++) a[s] = e[s] === n ? arguments[i++] : e[s];
            for (; i < arguments.length;) a.push(arguments[i++]);
            return Jt(t, _r4, this, this, a);
          };
        return _r4;
      });
      Zt.placeholder = W;
      var Qt = Zt,
        te = o(function (t, e, n) {
          if (!x(t)) throw new TypeError("Bind must be called on a function");
          var r = o(function (i) {
            return Jt(t, r, e, this, n.concat(i));
          });
          return r;
        }),
        ee = _(z);
      function ne(t, e, n, r) {
        if (r = r || [], e || 0 === e) {
          if (e <= 0) return r.concat(t);
        } else e = 1 / 0;
        for (var i = r.length, o = 0, a = z(t); o < a; o++) {
          var s = t[o];
          if (ee(s) && (j(s) || A(s))) {
            if (e > 1) ne(s, e - 1, n, r), i = r.length;else for (var c = 0, l = s.length; c < l;) r[i++] = s[c++];
          } else n || (r[i++] = s);
        }
        return r;
      }
      var re = o(function (t, e) {
        var n = (e = ne(e, !1, !1)).length;
        if (n < 1) throw new Error("bindAll must be passed function names");
        for (; n--;) {
          var r = e[n];
          t[r] = te(t[r], t);
        }
        return t;
      });
      function ie(t, e) {
        var _n12 = function n(r) {
          var i = _n12.cache,
            o = "" + (e ? e.apply(this, arguments) : r);
          return E(i, o) || (i[o] = t.apply(this, arguments)), i[o];
        };
        return _n12.cache = {}, _n12;
      }
      var oe = o(function (t, e, n) {
          return setTimeout(function () {
            return t.apply(null, n);
          }, e);
        }),
        ae = Qt(oe, W, 1);
      function se(t, e, n) {
        var r,
          i,
          o,
          a,
          s = 0;
        n || (n = {});
        var c = function c() {
            s = !1 === n.leading ? 0 : Nt(), r = null, a = t.apply(i, o), r || (i = o = null);
          },
          l = function l() {
            var l = Nt();
            s || !1 !== n.leading || (s = l);
            var u = e - (l - s);
            return i = this, o = arguments, u <= 0 || u > e ? (r && (clearTimeout(r), r = null), s = l, a = t.apply(i, o), r || (i = o = null)) : r || !1 === n.trailing || (r = setTimeout(c, u)), a;
          };
        return l.cancel = function () {
          clearTimeout(r), s = 0, r = i = o = null;
        }, l;
      }
      function ce(t, e, n) {
        var r,
          i,
          a,
          s,
          c,
          _l = function l() {
            var o = Nt() - i;
            e > o ? r = setTimeout(_l, e - o) : (r = null, n || (s = t.apply(c, a)), r || (a = c = null));
          },
          u = o(function (o) {
            return c = this, a = o, i = Nt(), r || (r = setTimeout(_l, e), n && (s = t.apply(c, a))), s;
          });
        return u.cancel = function () {
          clearTimeout(r), r = a = c = null;
        }, u;
      }
      function le(t, e) {
        return Qt(e, t);
      }
      function ue(t) {
        return function () {
          return !t.apply(this, arguments);
        };
      }
      function de() {
        var t = arguments,
          e = t.length - 1;
        return function () {
          for (var n = e, r = t[e].apply(this, arguments); n--;) r = t[n].call(this, r);
          return r;
        };
      }
      function he(t, e) {
        return function () {
          if (--t < 1) return e.apply(this, arguments);
        };
      }
      function fe(t, e) {
        var n;
        return function () {
          return --t > 0 && (n = e.apply(this, arguments)), t <= 1 && (e = null), n;
        };
      }
      var pe = Qt(fe, 2);
      function ge(t, e, n) {
        e = Pt(e, n);
        for (var r, i = B(t), o = 0, a = i.length; o < a; o++) if (e(t[r = i[o]], r, t)) return r;
      }
      function ve(t) {
        return function (e, n, r) {
          n = Pt(n, r);
          for (var i = z(e), o = t > 0 ? 0 : i - 1; o >= 0 && o < i; o += t) if (n(e[o], o, e)) return o;
          return -1;
        };
      }
      var me = ve(1),
        be = ve(-1);
      function ye(t, e, n, r) {
        for (var i = (n = Pt(n, r, 1))(e), o = 0, a = z(t); o < a;) {
          var s = Math.floor((o + a) / 2);
          n(t[s]) < i ? o = s + 1 : a = s;
        }
        return o;
      }
      function we(t, e, n) {
        return function (r, o, a) {
          var s = 0,
            c = z(r);
          if ("number" == typeof a) t > 0 ? s = a >= 0 ? a : Math.max(a + c, s) : c = a >= 0 ? Math.min(a + 1, c) : a + c + 1;else if (n && a && c) return r[a = n(r, o)] === o ? a : -1;
          if (o != o) return (a = e(i.q.call(r, s, c), D)) >= 0 ? a + s : -1;
          for (a = t > 0 ? s : c - 1; a >= 0 && a < c; a += t) if (r[a] === o) return a;
          return -1;
        };
      }
      var xe = we(1, me, ye),
        Oe = we(-1, be);
      function Ce(t, e, n) {
        var r = (ee(t) ? me : ge)(t, e, n);
        if (void 0 !== r && -1 !== r) return t[r];
      }
      function Se(t, e) {
        return Ce(t, St(e));
      }
      function ke(t, e, n) {
        var r, i;
        if (e = Tt(e, n), ee(t)) for (r = 0, i = t.length; r < i; r++) e(t[r], r, t);else {
          var o = B(t);
          for (r = 0, i = o.length; r < i; r++) e(t[o[r]], o[r], t);
        }
        return t;
      }
      function Te(t, e, n) {
        e = Pt(e, n);
        for (var r = !ee(t) && B(t), i = (r || t).length, o = Array(i), a = 0; a < i; a++) {
          var s = r ? r[a] : a;
          o[a] = e(t[s], s, t);
        }
        return o;
      }
      function je(t) {
        var e = function (_e14) {
          function e(_x18, _x19, _x20, _x21) {
            return _e14.apply(this, arguments);
          }
          e.toString = function () {
            return _e14.toString();
          };
          return e;
        }(function (e, n, r, i) {
          var o = !ee(e) && B(e),
            a = (o || e).length,
            s = t > 0 ? 0 : a - 1;
          for (i || (r = e[o ? o[s] : s], s += t); s >= 0 && s < a; s += t) {
            var c = o ? o[s] : s;
            r = n(r, e[c], c, e);
          }
          return r;
        });
        return function (t, n, r, i) {
          var o = arguments.length >= 3;
          return e(t, Tt(n, i, 4), r, o);
        };
      }
      var Ee = je(1),
        Pe = je(-1);
      function Ae(t, e, n) {
        var r = [];
        return e = Pt(e, n), ke(t, function (t, n, i) {
          e(t, n, i) && r.push(t);
        }), r;
      }
      function Me(t, e, n) {
        return Ae(t, ue(Pt(e)), n);
      }
      function De(t, e, n) {
        e = Pt(e, n);
        for (var r = !ee(t) && B(t), i = (r || t).length, o = 0; o < i; o++) {
          var a = r ? r[o] : o;
          if (!e(t[a], a, t)) return !1;
        }
        return !0;
      }
      function Le(t, e, n) {
        e = Pt(e, n);
        for (var r = !ee(t) && B(t), i = (r || t).length, o = 0; o < i; o++) {
          var a = r ? r[o] : o;
          if (e(t[a], a, t)) return !0;
        }
        return !1;
      }
      function _e(t, e, n, r) {
        return ee(t) || (t = at(t)), ("number" != typeof n || r) && (n = 0), xe(t, e, n) >= 0;
      }
      var Ne = o(function (t, e, n) {
        var r, i;
        return x(e) ? i = e : (e = yt(e), r = e.slice(0, -1), e = e[e.length - 1]), Te(t, function (t) {
          var o = i;
          if (!o) {
            if (r && r.length && (t = wt(t, r)), null == t) return;
            o = t[e];
          }
          return null == o ? o : o.apply(t, n);
        });
      });
      function Ie(t, e) {
        return Te(t, kt(e));
      }
      function Re(t, e) {
        return Ae(t, St(e));
      }
      function Fe(t, e, n) {
        var r,
          i,
          o = -1 / 0,
          a = -1 / 0;
        if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for (var s = 0, c = (t = ee(t) ? t : at(t)).length; s < c; s++) null != (r = t[s]) && r > o && (o = r);else e = Pt(e, n), ke(t, function (t, n, r) {
          ((i = e(t, n, r)) > a || i === -1 / 0 && o === -1 / 0) && (o = t, a = i);
        });
        return o;
      }
      function Ve(t, e, n) {
        var r,
          i,
          o = 1 / 0,
          a = 1 / 0;
        if (null == e || "number" == typeof e && "object" != typeof t[0] && null != t) for (var s = 0, c = (t = ee(t) ? t : at(t)).length; s < c; s++) null != (r = t[s]) && r < o && (o = r);else e = Pt(e, n), ke(t, function (t, n, r) {
          ((i = e(t, n, r)) < a || i === 1 / 0 && o === 1 / 0) && (o = t, a = i);
        });
        return o;
      }
      var ze = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
      function He(t) {
        return t ? j(t) ? i.q.call(t) : h(t) ? t.match(ze) : ee(t) ? Te(t, Ct) : at(t) : [];
      }
      function Be(t, e, n) {
        if (null == e || n) return ee(t) || (t = at(t)), t[_t(t.length - 1)];
        var r = He(t),
          i = z(r);
        e = Math.max(Math.min(e, i), 0);
        for (var o = i - 1, a = 0; a < e; a++) {
          var s = _t(a, o),
            c = r[a];
          r[a] = r[s], r[s] = c;
        }
        return r.slice(0, e);
      }
      function Ue(t) {
        return Be(t, 1 / 0);
      }
      function $e(t, e, n) {
        var r = 0;
        return e = Pt(e, n), Ie(Te(t, function (t, n, i) {
          return {
            value: t,
            index: r++,
            criteria: e(t, n, i)
          };
        }).sort(function (t, e) {
          var n = t.criteria,
            r = e.criteria;
          if (n !== r) {
            if (n > r || void 0 === n) return 1;
            if (n < r || void 0 === r) return -1;
          }
          return t.index - e.index;
        }), "value");
      }
      function We(t, e) {
        return function (n, r, i) {
          var o = e ? [[], []] : {};
          return r = Pt(r, i), ke(n, function (e, i) {
            var a = r(e, i, n);
            t(o, e, a);
          }), o;
        };
      }
      var qe = We(function (t, e, n) {
          E(t, n) ? t[n].push(e) : t[n] = [e];
        }),
        Ge = We(function (t, e, n) {
          t[n] = e;
        }),
        Ye = We(function (t, e, n) {
          E(t, n) ? t[n]++ : t[n] = 1;
        }),
        Ke = We(function (t, e, n) {
          t[n ? 0 : 1].push(e);
        }, !0);
      function Xe(t) {
        return null == t ? 0 : ee(t) ? t.length : B(t).length;
      }
      function Je(t, e, n) {
        return e in n;
      }
      var Ze = o(function (t, e) {
          var n = {},
            r = e[0];
          if (null == t) return n;
          x(r) ? (e.length > 1 && (r = Tt(r, e[1])), e = Y(t)) : (r = Je, e = ne(e, !1, !1), t = Object(t));
          for (var i = 0, o = e.length; i < o; i++) {
            var a = e[i],
              s = t[a];
            r(s, a, t) && (n[a] = s);
          }
          return n;
        }),
        Qe = o(function (t, e) {
          var n,
            r = e[0];
          return x(r) ? (r = ue(r), e.length > 1 && (n = e[1])) : (e = Te(ne(e, !1, !1), String), r = function r(t, n) {
            return !_e(e, n);
          }), Ze(t, r, n);
        });
      function tn(t, e, n) {
        return i.q.call(t, 0, Math.max(0, t.length - (null == e || n ? 1 : e)));
      }
      function en(t, e, n) {
        return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[0] : tn(t, t.length - e);
      }
      function nn(t, e, n) {
        return i.q.call(t, null == e || n ? 1 : e);
      }
      function rn(t, e, n) {
        return null == t || t.length < 1 ? null == e || n ? void 0 : [] : null == e || n ? t[t.length - 1] : nn(t, Math.max(0, t.length - e));
      }
      function on(t) {
        return Ae(t, Boolean);
      }
      function an(t, e) {
        return ne(t, e, !1);
      }
      var sn = o(function (t, e) {
          return e = ne(e, !0, !0), Ae(t, function (t) {
            return !_e(e, t);
          });
        }),
        cn = o(function (t, e) {
          return sn(t, e);
        });
      function ln(t, e, n, r) {
        l(e) || (r = n, n = e, e = !1), null != n && (n = Pt(n, r));
        for (var i = [], o = [], a = 0, s = z(t); a < s; a++) {
          var c = t[a],
            u = n ? n(c, a, t) : c;
          e && !n ? (a && o === u || i.push(c), o = u) : n ? _e(o, u) || (o.push(u), i.push(c)) : _e(i, c) || i.push(c);
        }
        return i;
      }
      var un = o(function (t) {
        return ln(ne(t, !0, !0));
      });
      function dn(t) {
        for (var e = [], n = arguments.length, r = 0, i = z(t); r < i; r++) {
          var o = t[r];
          if (!_e(e, o)) {
            var a;
            for (a = 1; a < n && _e(arguments[a], o); a++);
            a === n && e.push(o);
          }
        }
        return e;
      }
      function hn(t) {
        for (var e = t && Fe(t, z).length || 0, n = Array(e), r = 0; r < e; r++) n[r] = Ie(t, r);
        return n;
      }
      var fn = o(hn);
      function pn(t, e) {
        for (var n = {}, r = 0, i = z(t); r < i; r++) e ? n[t[r]] = e[r] : n[t[r][0]] = t[r][1];
        return n;
      }
      function gn(t, e, n) {
        null == e && (e = t || 0, t = 0), n || (n = e < t ? -1 : 1);
        for (var r = Math.max(Math.ceil((e - t) / n), 0), i = Array(r), o = 0; o < r; o++, t += n) i[o] = t;
        return i;
      }
      function vn(t, e) {
        if (null == e || e < 1) return [];
        for (var n = [], r = 0, o = t.length; r < o;) n.push(i.q.call(t, r, r += e));
        return n;
      }
      function mn(t, e) {
        return t._chain ? W(e).chain() : e;
      }
      function bn(t) {
        return ke(lt(t), function (e) {
          var n = W[e] = t[e];
          W.prototype[e] = function () {
            var t = [this._wrapped];
            return i.o.apply(t, arguments), mn(this, n.apply(W, t));
          };
        }), W;
      }
      ke(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (t) {
        var e = i.a[t];
        W.prototype[t] = function () {
          var n = this._wrapped;
          return null != n && (e.apply(n, arguments), "shift" !== t && "splice" !== t || 0 !== n.length || delete n[0]), mn(this, n);
        };
      }), ke(["concat", "join", "slice"], function (t) {
        var e = i.a[t];
        W.prototype[t] = function () {
          var t = this._wrapped;
          return null != t && (t = e.apply(t, arguments)), mn(this, t);
        };
      });
      var yn = W,
        wn = bn(r);
      wn._ = wn;
      var xn = wn;
    }, function (t, e, n) {
      (function (r) {
        var i, o, a;
        a = "object" == typeof self && self.self === self && self || "object" == typeof r && r.global === r && r, i = [n(0), n(11), e], void 0 === (o = function (t, e, n) {
          a.Backbone = function (t, e, n, r) {
            var i = t.Backbone,
              o = Array.prototype.slice;
            e.VERSION = "1.3.3", e.$ = r, e.noConflict = function () {
              return t.Backbone = i, this;
            }, e.emulateHTTP = !1, e.emulateJSON = !1;
            var a = function a(t, e, r) {
                n.each(e, function (e, i) {
                  n[i] && (t.prototype[i] = function (t, e, r) {
                    switch (t) {
                      case 1:
                        return function () {
                          return n[e](this[r]);
                        };
                      case 2:
                        return function (t) {
                          return n[e](this[r], t);
                        };
                      case 3:
                        return function (t, i) {
                          return n[e](this[r], s(t, this), i);
                        };
                      case 4:
                        return function (t, i, o) {
                          return n[e](this[r], s(t, this), i, o);
                        };
                      default:
                        return function () {
                          var t = o.call(arguments);
                          return t.unshift(this[r]), n[e].apply(n, t);
                        };
                    }
                  }(e, i, r));
                });
              },
              s = function s(t, e) {
                return n.isFunction(t) ? t : n.isObject(t) && !e._isModel(t) ? c(t) : n.isString(t) ? function (e) {
                  return e.get(t);
                } : t;
              },
              c = function c(t) {
                var e = n.matches(t);
                return function (t) {
                  return e(t.attributes);
                };
              },
              l = e.Events = {},
              u = /\s+/,
              _d = function d(t, e, r, i, o) {
                var a,
                  s = 0;
                if (r && "object" == typeof r) {
                  void 0 !== i && "context" in o && void 0 === o.context && (o.context = i);
                  for (a = n.keys(r); s < a.length; s++) e = _d(t, e, a[s], r[a[s]], o);
                } else if (r && u.test(r)) for (a = r.split(u); s < a.length; s++) e = t(e, a[s], i, o);else e = t(e, r, i, o);
                return e;
              };
            l.on = function (t, e, n) {
              return h(this, t, e, n);
            };
            var h = function h(t, e, n, r, i) {
              return t._events = _d(f, t._events || {}, e, n, {
                context: r,
                ctx: t,
                listening: i
              }), i && ((t._listeners || (t._listeners = {}))[i.id] = i), t;
            };
            l.listenTo = function (t, e, r) {
              if (!t) return this;
              var i = t._listenId || (t._listenId = n.uniqueId("l")),
                o = this._listeningTo || (this._listeningTo = {}),
                a = o[i];
              if (!a) {
                var s = this._listenId || (this._listenId = n.uniqueId("l"));
                a = o[i] = {
                  obj: t,
                  objId: i,
                  id: s,
                  listeningTo: o,
                  count: 0
                };
              }
              return h(t, e, r, this, a), this;
            };
            var f = function f(t, e, n, r) {
              if (n) {
                var i = t[e] || (t[e] = []),
                  o = r.context,
                  a = r.ctx,
                  s = r.listening;
                s && s.count++, i.push({
                  callback: n,
                  context: o,
                  ctx: o || a,
                  listening: s
                });
              }
              return t;
            };
            l.off = function (t, e, n) {
              return this._events ? (this._events = _d(p, this._events, t, e, {
                context: n,
                listeners: this._listeners
              }), this) : this;
            }, l.stopListening = function (t, e, r) {
              var i = this._listeningTo;
              if (!i) return this;
              for (var o = t ? [t._listenId] : n.keys(i), a = 0; a < o.length; a++) {
                var s = i[o[a]];
                if (!s) break;
                s.obj.off(e, r, this);
              }
              return this;
            };
            var p = function p(t, e, r, i) {
              if (t) {
                var o,
                  a = 0,
                  s = i.context,
                  c = i.listeners;
                if (e || r || s) {
                  for (var l = e ? [e] : n.keys(t); a < l.length; a++) {
                    var u = t[e = l[a]];
                    if (!u) break;
                    for (var d = [], h = 0; h < u.length; h++) {
                      var f = u[h];
                      r && r !== f.callback && r !== f.callback._callback || s && s !== f.context ? d.push(f) : (o = f.listening) && 0 == --o.count && (delete c[o.id], delete o.listeningTo[o.objId]);
                    }
                    d.length ? t[e] = d : delete t[e];
                  }
                  return t;
                }
                for (var p = n.keys(c); a < p.length; a++) delete c[(o = c[p[a]]).id], delete o.listeningTo[o.objId];
              }
            };
            l.once = function (t, e, r) {
              var i = _d(g, {}, t, e, n.bind(this.off, this));
              return "string" == typeof t && null == r && (e = void 0), this.on(i, e, r);
            }, l.listenToOnce = function (t, e, r) {
              var i = _d(g, {}, e, r, n.bind(this.stopListening, this, t));
              return this.listenTo(t, i);
            };
            var g = function g(t, e, r, i) {
              if (r) {
                var o = t[e] = n.once(function () {
                  i(e, o), r.apply(this, arguments);
                });
                o._callback = r;
              }
              return t;
            };
            l.trigger = function (t) {
              if (!this._events) return this;
              for (var e = Math.max(0, arguments.length - 1), n = Array(e), r = 0; r < e; r++) n[r] = arguments[r + 1];
              return _d(v, this._events, t, void 0, n), this;
            };
            var v = function v(t, e, n, r) {
                if (t) {
                  var i = t[e],
                    o = t.all;
                  i && o && (o = o.slice()), i && m(i, r), o && m(o, [e].concat(r));
                }
                return t;
              },
              m = function m(t, e) {
                var n,
                  r = -1,
                  i = t.length,
                  o = e[0],
                  a = e[1],
                  s = e[2];
                switch (e.length) {
                  case 0:
                    for (; ++r < i;) (n = t[r]).callback.call(n.ctx);
                    return;
                  case 1:
                    for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o);
                    return;
                  case 2:
                    for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o, a);
                    return;
                  case 3:
                    for (; ++r < i;) (n = t[r]).callback.call(n.ctx, o, a, s);
                    return;
                  default:
                    for (; ++r < i;) (n = t[r]).callback.apply(n.ctx, e);
                    return;
                }
              };
            l.bind = l.on, l.unbind = l.off, n.extend(e, l);
            var b = e.Model = function (t, e) {
              var r = t || {};
              e || (e = {}), this.cid = n.uniqueId(this.cidPrefix), this.attributes = {}, e.collection && (this.collection = e.collection), e.parse && (r = this.parse(r, e) || {});
              var i = n.result(this, "defaults");
              r = n.defaults(n.extend({}, i, r), i), this.set(r, e), this.changed = {}, this.initialize.apply(this, arguments);
            };
            n.extend(b.prototype, l, {
              changed: null,
              validationError: null,
              idAttribute: "id",
              cidPrefix: "c",
              initialize: function initialize() {},
              toJSON: function toJSON(t) {
                return n.clone(this.attributes);
              },
              sync: function sync() {
                return e.sync.apply(this, arguments);
              },
              get: function get(t) {
                return this.attributes[t];
              },
              escape: function escape(t) {
                return n.escape(this.get(t));
              },
              has: function has(t) {
                return null != this.get(t);
              },
              matches: function matches(t) {
                return !!n.iteratee(t, this)(this.attributes);
              },
              set: function set(t, e, r) {
                if (null == t) return this;
                var i;
                if ("object" == typeof t ? (i = t, r = e) : (i = {})[t] = e, r || (r = {}), !this._validate(i, r)) return !1;
                var o = r.unset,
                  a = r.silent,
                  s = [],
                  c = this._changing;
                this._changing = !0, c || (this._previousAttributes = n.clone(this.attributes), this.changed = {});
                var l = this.attributes,
                  u = this.changed,
                  d = this._previousAttributes;
                for (var h in i) e = i[h], n.isEqual(l[h], e) || s.push(h), n.isEqual(d[h], e) ? delete u[h] : u[h] = e, o ? delete l[h] : l[h] = e;
                if (this.idAttribute in i && (this.id = this.get(this.idAttribute)), !a) {
                  s.length && (this._pending = r);
                  for (var f = 0; f < s.length; f++) this.trigger("change:" + s[f], this, l[s[f]], r);
                }
                if (c) return this;
                if (!a) for (; this._pending;) r = this._pending, this._pending = !1, this.trigger("change", this, r);
                return this._pending = !1, this._changing = !1, this;
              },
              unset: function unset(t, e) {
                return this.set(t, void 0, n.extend({}, e, {
                  unset: !0
                }));
              },
              clear: function clear(t) {
                var e = {};
                for (var r in this.attributes) e[r] = void 0;
                return this.set(e, n.extend({}, t, {
                  unset: !0
                }));
              },
              hasChanged: function hasChanged(t) {
                return null == t ? !n.isEmpty(this.changed) : n.has(this.changed, t);
              },
              changedAttributes: function changedAttributes(t) {
                if (!t) return !!this.hasChanged() && n.clone(this.changed);
                var e = this._changing ? this._previousAttributes : this.attributes,
                  r = {};
                for (var i in t) {
                  var o = t[i];
                  n.isEqual(e[i], o) || (r[i] = o);
                }
                return !!n.size(r) && r;
              },
              previous: function previous(t) {
                return null != t && this._previousAttributes ? this._previousAttributes[t] : null;
              },
              previousAttributes: function previousAttributes() {
                return n.clone(this._previousAttributes);
              },
              fetch: function fetch(t) {
                t = n.extend({
                  parse: !0
                }, t);
                var e = this,
                  r = t.success;
                return t.success = function (n) {
                  var i = t.parse ? e.parse(n, t) : n;
                  if (!e.set(i, t)) return !1;
                  r && r.call(t.context, e, n, t), e.trigger("sync", e, n, t);
                }, R(this, t), this.sync("read", this, t);
              },
              save: function save(t, e, r) {
                var i;
                null == t || "object" == typeof t ? (i = t, r = e) : (i = {})[t] = e;
                var o = (r = n.extend({
                  validate: !0,
                  parse: !0
                }, r)).wait;
                if (i && !o) {
                  if (!this.set(i, r)) return !1;
                } else if (!this._validate(i, r)) return !1;
                var a = this,
                  s = r.success,
                  c = this.attributes;
                r.success = function (t) {
                  a.attributes = c;
                  var e = r.parse ? a.parse(t, r) : t;
                  if (o && (e = n.extend({}, i, e)), e && !a.set(e, r)) return !1;
                  s && s.call(r.context, a, t, r), a.trigger("sync", a, t, r);
                }, R(this, r), i && o && (this.attributes = n.extend({}, c, i));
                var l = this.isNew() ? "create" : r.patch ? "patch" : "update";
                "patch" !== l || r.attrs || (r.attrs = i);
                var u = this.sync(l, this, r);
                return this.attributes = c, u;
              },
              destroy: function destroy(t) {
                t = t ? n.clone(t) : {};
                var e = this,
                  r = t.success,
                  i = t.wait,
                  o = function o() {
                    e.stopListening(), e.trigger("destroy", e, e.collection, t);
                  };
                t.success = function (n) {
                  i && o(), r && r.call(t.context, e, n, t), e.isNew() || e.trigger("sync", e, n, t);
                };
                var a = !1;
                return this.isNew() ? n.defer(t.success) : (R(this, t), a = this.sync("delete", this, t)), i || o(), a;
              },
              url: function url() {
                var t = n.result(this, "urlRoot") || n.result(this.collection, "url") || I();
                if (this.isNew()) return t;
                var e = this.get(this.idAttribute);
                return t.replace(/[^\/]$/, "$&/") + encodeURIComponent(e);
              },
              parse: function parse(t, e) {
                return t;
              },
              clone: function clone() {
                return new this.constructor(this.attributes);
              },
              isNew: function isNew() {
                return !this.has(this.idAttribute);
              },
              isValid: function isValid(t) {
                return this._validate({}, n.extend({}, t, {
                  validate: !0
                }));
              },
              _validate: function _validate(t, e) {
                if (!e.validate || !this.validate) return !0;
                t = n.extend({}, this.attributes, t);
                var r = this.validationError = this.validate(t, e) || null;
                return !r || (this.trigger("invalid", this, r, n.extend(e, {
                  validationError: r
                })), !1);
              }
            }), a(b, {
              keys: 1,
              values: 1,
              pairs: 1,
              invert: 1,
              pick: 0,
              omit: 0,
              chain: 1,
              isEmpty: 1
            }, "attributes");
            var y = e.Collection = function (t, e) {
                e || (e = {}), e.model && (this.model = e.model), void 0 !== e.comparator && (this.comparator = e.comparator), this._reset(), this.initialize.apply(this, arguments), t && this.reset(t, n.extend({
                  silent: !0
                }, e));
              },
              w = {
                add: !0,
                remove: !0,
                merge: !0
              },
              x = {
                add: !0,
                remove: !1
              },
              O = function O(t, e, n) {
                n = Math.min(Math.max(n, 0), t.length);
                var r,
                  i = Array(t.length - n),
                  o = e.length;
                for (r = 0; r < i.length; r++) i[r] = t[r + n];
                for (r = 0; r < o; r++) t[r + n] = e[r];
                for (r = 0; r < i.length; r++) t[r + o + n] = i[r];
              };
            n.extend(y.prototype, l, {
              model: b,
              initialize: function initialize() {},
              toJSON: function toJSON(t) {
                return this.map(function (e) {
                  return e.toJSON(t);
                });
              },
              sync: function sync() {
                return e.sync.apply(this, arguments);
              },
              add: function add(t, e) {
                return this.set(t, n.extend({
                  merge: !1
                }, e, x));
              },
              remove: function remove(t, e) {
                e = n.extend({}, e);
                var r = !n.isArray(t);
                t = r ? [t] : t.slice();
                var i = this._removeModels(t, e);
                return !e.silent && i.length && (e.changes = {
                  added: [],
                  merged: [],
                  removed: i
                }, this.trigger("update", this, e)), r ? i[0] : i;
              },
              set: function set(t, e) {
                if (null != t) {
                  (e = n.extend({}, w, e)).parse && !this._isModel(t) && (t = this.parse(t, e) || []);
                  var r = !n.isArray(t);
                  t = r ? [t] : t.slice();
                  var i = e.at;
                  null != i && (i = +i), i > this.length && (i = this.length), i < 0 && (i += this.length + 1);
                  var o,
                    a,
                    s = [],
                    c = [],
                    l = [],
                    u = [],
                    d = {},
                    h = e.add,
                    f = e.merge,
                    p = e.remove,
                    g = !1,
                    v = this.comparator && null == i && !1 !== e.sort,
                    m = n.isString(this.comparator) ? this.comparator : null;
                  for (a = 0; a < t.length; a++) {
                    o = t[a];
                    var b = this.get(o);
                    if (b) {
                      if (f && o !== b) {
                        var y = this._isModel(o) ? o.attributes : o;
                        e.parse && (y = b.parse(y, e)), b.set(y, e), l.push(b), v && !g && (g = b.hasChanged(m));
                      }
                      d[b.cid] || (d[b.cid] = !0, s.push(b)), t[a] = b;
                    } else h && (o = t[a] = this._prepareModel(o, e)) && (c.push(o), this._addReference(o, e), d[o.cid] = !0, s.push(o));
                  }
                  if (p) {
                    for (a = 0; a < this.length; a++) d[(o = this.models[a]).cid] || u.push(o);
                    u.length && this._removeModels(u, e);
                  }
                  var x = !1,
                    C = !v && h && p;
                  if (s.length && C ? (x = this.length !== s.length || n.some(this.models, function (t, e) {
                    return t !== s[e];
                  }), this.models.length = 0, O(this.models, s, 0), this.length = this.models.length) : c.length && (v && (g = !0), O(this.models, c, null == i ? this.length : i), this.length = this.models.length), g && this.sort({
                    silent: !0
                  }), !e.silent) {
                    for (a = 0; a < c.length; a++) null != i && (e.index = i + a), (o = c[a]).trigger("add", o, this, e);
                    (g || x) && this.trigger("sort", this, e), (c.length || u.length || l.length) && (e.changes = {
                      added: c,
                      removed: u,
                      merged: l
                    }, this.trigger("update", this, e));
                  }
                  return r ? t[0] : t;
                }
              },
              reset: function reset(t, e) {
                e = e ? n.clone(e) : {};
                for (var r = 0; r < this.models.length; r++) this._removeReference(this.models[r], e);
                return e.previousModels = this.models, this._reset(), t = this.add(t, n.extend({
                  silent: !0
                }, e)), e.silent || this.trigger("reset", this, e), t;
              },
              push: function push(t, e) {
                return this.add(t, n.extend({
                  at: this.length
                }, e));
              },
              pop: function pop(t) {
                var e = this.at(this.length - 1);
                return this.remove(e, t);
              },
              unshift: function unshift(t, e) {
                return this.add(t, n.extend({
                  at: 0
                }, e));
              },
              shift: function shift(t) {
                var e = this.at(0);
                return this.remove(e, t);
              },
              slice: function slice() {
                return o.apply(this.models, arguments);
              },
              get: function get(t) {
                if (null != t) return this._byId[t] || this._byId[this.modelId(t.attributes || t)] || t.cid && this._byId[t.cid];
              },
              has: function has(t) {
                return null != this.get(t);
              },
              at: function at(t) {
                return t < 0 && (t += this.length), this.models[t];
              },
              where: function where(t, e) {
                return this[e ? "find" : "filter"](t);
              },
              findWhere: function findWhere(t) {
                return this.where(t, !0);
              },
              sort: function sort(t) {
                var e = this.comparator;
                if (!e) throw new Error("Cannot sort a set without a comparator");
                t || (t = {});
                var r = e.length;
                return n.isFunction(e) && (e = n.bind(e, this)), 1 === r || n.isString(e) ? this.models = this.sortBy(e) : this.models.sort(e), t.silent || this.trigger("sort", this, t), this;
              },
              pluck: function pluck(t) {
                return this.map(t + "");
              },
              fetch: function fetch(t) {
                var e = (t = n.extend({
                    parse: !0
                  }, t)).success,
                  r = this;
                return t.success = function (n) {
                  var i = t.reset ? "reset" : "set";
                  r[i](n, t), e && e.call(t.context, r, n, t), r.trigger("sync", r, n, t);
                }, R(this, t), this.sync("read", this, t);
              },
              create: function create(t, e) {
                var r = (e = e ? n.clone(e) : {}).wait;
                if (!(t = this._prepareModel(t, e))) return !1;
                r || this.add(t, e);
                var i = this,
                  o = e.success;
                return e.success = function (t, e, n) {
                  r && i.add(t, n), o && o.call(n.context, t, e, n);
                }, t.save(null, e), t;
              },
              parse: function parse(t, e) {
                return t;
              },
              clone: function clone() {
                return new this.constructor(this.models, {
                  model: this.model,
                  comparator: this.comparator
                });
              },
              modelId: function modelId(t) {
                return t[this.model.prototype.idAttribute || "id"];
              },
              _reset: function _reset() {
                this.length = 0, this.models = [], this._byId = {};
              },
              _prepareModel: function _prepareModel(t, e) {
                if (this._isModel(t)) return t.collection || (t.collection = this), t;
                (e = e ? n.clone(e) : {}).collection = this;
                var r = new this.model(t, e);
                return r.validationError ? (this.trigger("invalid", this, r.validationError, e), !1) : r;
              },
              _removeModels: function _removeModels(t, e) {
                for (var n = [], r = 0; r < t.length; r++) {
                  var i = this.get(t[r]);
                  if (i) {
                    var o = this.indexOf(i);
                    this.models.splice(o, 1), this.length--, delete this._byId[i.cid];
                    var a = this.modelId(i.attributes);
                    null != a && delete this._byId[a], e.silent || (e.index = o, i.trigger("remove", i, this, e)), n.push(i), this._removeReference(i, e);
                  }
                }
                return n;
              },
              _isModel: function _isModel(t) {
                return t instanceof b;
              },
              _addReference: function _addReference(t, e) {
                this._byId[t.cid] = t;
                var n = this.modelId(t.attributes);
                null != n && (this._byId[n] = t), t.on("all", this._onModelEvent, this);
              },
              _removeReference: function _removeReference(t, e) {
                delete this._byId[t.cid];
                var n = this.modelId(t.attributes);
                null != n && delete this._byId[n], this === t.collection && delete t.collection, t.off("all", this._onModelEvent, this);
              },
              _onModelEvent: function _onModelEvent(t, e, n, r) {
                if (e) {
                  if (("add" === t || "remove" === t) && n !== this) return;
                  if ("destroy" === t && this.remove(e, r), "change" === t) {
                    var i = this.modelId(e.previousAttributes()),
                      o = this.modelId(e.attributes);
                    i !== o && (null != i && delete this._byId[i], null != o && (this._byId[o] = e));
                  }
                }
                this.trigger.apply(this, arguments);
              }
            }), a(y, {
              forEach: 3,
              each: 3,
              map: 3,
              collect: 3,
              reduce: 0,
              foldl: 0,
              inject: 0,
              reduceRight: 0,
              foldr: 0,
              find: 3,
              detect: 3,
              filter: 3,
              select: 3,
              reject: 3,
              every: 3,
              all: 3,
              some: 3,
              any: 3,
              include: 3,
              includes: 3,
              contains: 3,
              invoke: 0,
              max: 3,
              min: 3,
              toArray: 1,
              size: 1,
              first: 3,
              head: 3,
              take: 3,
              initial: 3,
              rest: 3,
              tail: 3,
              drop: 3,
              last: 3,
              without: 0,
              difference: 0,
              indexOf: 3,
              shuffle: 1,
              lastIndexOf: 3,
              isEmpty: 1,
              chain: 1,
              sample: 3,
              partition: 3,
              groupBy: 3,
              countBy: 3,
              sortBy: 3,
              indexBy: 3,
              findIndex: 3,
              findLastIndex: 3
            }, "models");
            var C = e.View = function (t) {
                this.cid = n.uniqueId("view"), n.extend(this, n.pick(t, k)), this._ensureElement(), this.initialize.apply(this, arguments);
              },
              S = /^(\S+)\s*(.*)$/,
              k = ["model", "collection", "el", "id", "attributes", "className", "tagName", "events"];
            n.extend(C.prototype, l, {
              tagName: "div",
              $: function $(t) {
                return this.$el.find(t);
              },
              initialize: function initialize() {},
              render: function render() {
                return this;
              },
              remove: function remove() {
                return this._removeElement(), this.stopListening(), this;
              },
              _removeElement: function _removeElement() {
                this.$el.remove();
              },
              setElement: function setElement(t) {
                return this.undelegateEvents(), this._setElement(t), this.delegateEvents(), this;
              },
              _setElement: function _setElement(t) {
                this.$el = t instanceof e.$ ? t : e.$(t), this.el = this.$el[0];
              },
              delegateEvents: function delegateEvents(t) {
                if (t || (t = n.result(this, "events")), !t) return this;
                for (var e in this.undelegateEvents(), t) {
                  var r = t[e];
                  if (n.isFunction(r) || (r = this[r]), r) {
                    var i = e.match(S);
                    this.delegate(i[1], i[2], n.bind(r, this));
                  }
                }
                return this;
              },
              delegate: function delegate(t, e, n) {
                return this.$el.on(t + ".delegateEvents" + this.cid, e, n), this;
              },
              undelegateEvents: function undelegateEvents() {
                return this.$el && this.$el.off(".delegateEvents" + this.cid), this;
              },
              undelegate: function undelegate(t, e, n) {
                return this.$el.off(t + ".delegateEvents" + this.cid, e, n), this;
              },
              _createElement: function _createElement(t) {
                return document.createElement(t);
              },
              _ensureElement: function _ensureElement() {
                if (this.el) this.setElement(n.result(this, "el"));else {
                  var t = n.extend({}, n.result(this, "attributes"));
                  this.id && (t.id = n.result(this, "id")), this.className && (t.class = n.result(this, "className")), this.setElement(this._createElement(n.result(this, "tagName"))), this._setAttributes(t);
                }
              },
              _setAttributes: function _setAttributes(t) {
                this.$el.attr(t);
              }
            }), e.sync = function (t, r, i) {
              var o = T[t];
              n.defaults(i || (i = {}), {
                emulateHTTP: e.emulateHTTP,
                emulateJSON: e.emulateJSON
              });
              var a = {
                type: o,
                dataType: "json"
              };
              if (i.url || (a.url = n.result(r, "url") || I()), null != i.data || !r || "create" !== t && "update" !== t && "patch" !== t || (a.contentType = "application/json", a.data = JSON.stringify(i.attrs || r.toJSON(i))), i.emulateJSON && (a.contentType = "application/x-www-form-urlencoded", a.data = a.data ? {
                model: a.data
              } : {}), i.emulateHTTP && ("PUT" === o || "DELETE" === o || "PATCH" === o)) {
                a.type = "POST", i.emulateJSON && (a.data._method = o);
                var s = i.beforeSend;
                i.beforeSend = function (t) {
                  if (t.setRequestHeader("X-HTTP-Method-Override", o), s) return s.apply(this, arguments);
                };
              }
              "GET" === a.type || i.emulateJSON || (a.processData = !1);
              var c = i.error;
              i.error = function (t, e, n) {
                i.textStatus = e, i.errorThrown = n, c && c.call(i.context, t, e, n);
              };
              var l = i.xhr = e.ajax(n.extend(a, i));
              return r.trigger("request", r, l, i), l;
            };
            var T = {
              create: "POST",
              update: "PUT",
              patch: "PATCH",
              delete: "DELETE",
              read: "GET"
            };
            e.ajax = function () {
              return e.$.ajax.apply(e.$, arguments);
            };
            var j = e.Router = function (t) {
                t || (t = {}), t.routes && (this.routes = t.routes), this._bindRoutes(), this.initialize.apply(this, arguments);
              },
              E = /\((.*?)\)/g,
              P = /(\(\?)?:\w+/g,
              A = /\*\w+/g,
              M = /[\-{}\[\]+?.,\\\^$|#\s]/g;
            n.extend(j.prototype, l, {
              initialize: function initialize() {},
              route: function route(t, r, i) {
                n.isRegExp(t) || (t = this._routeToRegExp(t)), n.isFunction(r) && (i = r, r = ""), i || (i = this[r]);
                var o = this;
                return e.history.route(t, function (n) {
                  var a = o._extractParameters(t, n);
                  !1 !== o.execute(i, a, r) && (o.trigger.apply(o, ["route:" + r].concat(a)), o.trigger("route", r, a), e.history.trigger("route", o, r, a));
                }), this;
              },
              execute: function execute(t, e, n) {
                t && t.apply(this, e);
              },
              navigate: function navigate(t, n) {
                return e.history.navigate(t, n), this;
              },
              _bindRoutes: function _bindRoutes() {
                if (this.routes) {
                  this.routes = n.result(this, "routes");
                  for (var t, e = n.keys(this.routes); null != (t = e.pop());) this.route(t, this.routes[t]);
                }
              },
              _routeToRegExp: function _routeToRegExp(t) {
                return t = t.replace(M, "\\$&").replace(E, "(?:$1)?").replace(P, function (t, e) {
                  return e ? t : "([^/?]+)";
                }).replace(A, "([^?]*?)"), new RegExp("^" + t + "(?:\\?([\\s\\S]*))?$");
              },
              _extractParameters: function _extractParameters(t, e) {
                var r = t.exec(e).slice(1);
                return n.map(r, function (t, e) {
                  return e === r.length - 1 ? t || null : t ? decodeURIComponent(t) : null;
                });
              }
            });
            var D = e.History = function () {
                this.handlers = [], this.checkUrl = n.bind(this.checkUrl, this), "undefined" != typeof window && (this.location = window.location, this.history = window.history);
              },
              L = /^[#\/]|\s+$/g,
              _ = /^\/+|\/+$/g,
              N = /#.*$/;
            D.started = !1, n.extend(D.prototype, l, {
              interval: 50,
              atRoot: function atRoot() {
                return this.location.pathname.replace(/[^\/]$/, "$&/") === this.root && !this.getSearch();
              },
              matchRoot: function matchRoot() {
                return this.decodeFragment(this.location.pathname).slice(0, this.root.length - 1) + "/" === this.root;
              },
              decodeFragment: function decodeFragment(t) {
                return decodeURI(t.replace(/%25/g, "%2525"));
              },
              getSearch: function getSearch() {
                var t = this.location.href.replace(/#.*/, "").match(/\?.+/);
                return t ? t[0] : "";
              },
              getHash: function getHash(t) {
                var e = (t || this).location.href.match(/#(.*)$/);
                return e ? e[1] : "";
              },
              getPath: function getPath() {
                var t = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
                return "/" === t.charAt(0) ? t.slice(1) : t;
              },
              getFragment: function getFragment(t) {
                return null == t && (t = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash()), t.replace(L, "");
              },
              start: function start(t) {
                if (D.started) throw new Error("Backbone.history has already been started");
                if (D.started = !0, this.options = n.extend({
                  root: "/"
                }, this.options, t), this.root = this.options.root, this._wantsHashChange = !1 !== this.options.hashChange, this._hasHashChange = "onhashchange" in window && (void 0 === document.documentMode || document.documentMode > 7), this._useHashChange = this._wantsHashChange && this._hasHashChange, this._wantsPushState = !!this.options.pushState, this._hasPushState = !(!this.history || !this.history.pushState), this._usePushState = this._wantsPushState && this._hasPushState, this.fragment = this.getFragment(), this.root = ("/" + this.root + "/").replace(_, "/"), this._wantsHashChange && this._wantsPushState) {
                  if (!this._hasPushState && !this.atRoot()) {
                    var e = this.root.slice(0, -1) || "/";
                    return this.location.replace(e + "#" + this.getPath()), !0;
                  }
                  this._hasPushState && this.atRoot() && this.navigate(this.getHash(), {
                    replace: !0
                  });
                }
                if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
                  this.iframe = document.createElement("iframe"), this.iframe.src = "javascript:0", this.iframe.style.display = "none", this.iframe.tabIndex = -1;
                  var r = document.body,
                    i = r.insertBefore(this.iframe, r.firstChild).contentWindow;
                  i.document.open(), i.document.close(), i.location.hash = "#" + this.fragment;
                }
                var o = window.addEventListener || function (t, e) {
                  return attachEvent("on" + t, e);
                };
                if (this._usePushState ? o("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe ? o("hashchange", this.checkUrl, !1) : this._wantsHashChange && (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)), !this.options.silent) return this.loadUrl();
              },
              stop: function stop() {
                var t = window.removeEventListener || function (t, e) {
                  return detachEvent("on" + t, e);
                };
                this._usePushState ? t("popstate", this.checkUrl, !1) : this._useHashChange && !this.iframe && t("hashchange", this.checkUrl, !1), this.iframe && (document.body.removeChild(this.iframe), this.iframe = null), this._checkUrlInterval && clearInterval(this._checkUrlInterval), D.started = !1;
              },
              route: function route(t, e) {
                this.handlers.unshift({
                  route: t,
                  callback: e
                });
              },
              checkUrl: function checkUrl(t) {
                var e = this.getFragment();
                if (e === this.fragment && this.iframe && (e = this.getHash(this.iframe.contentWindow)), e === this.fragment) return !1;
                this.iframe && this.navigate(e), this.loadUrl();
              },
              loadUrl: function loadUrl(t) {
                return !!this.matchRoot() && (t = this.fragment = this.getFragment(t), n.some(this.handlers, function (e) {
                  if (e.route.test(t)) return e.callback(t), !0;
                }));
              },
              navigate: function navigate(t, e) {
                if (!D.started) return !1;
                e && !0 !== e || (e = {
                  trigger: !!e
                }), t = this.getFragment(t || "");
                var n = this.root;
                "" !== t && "?" !== t.charAt(0) || (n = n.slice(0, -1) || "/");
                var r = n + t;
                if (t = this.decodeFragment(t.replace(N, "")), this.fragment !== t) {
                  if (this.fragment = t, this._usePushState) this.history[e.replace ? "replaceState" : "pushState"]({}, document.title, r);else {
                    if (!this._wantsHashChange) return this.location.assign(r);
                    if (this._updateHash(this.location, t, e.replace), this.iframe && t !== this.getHash(this.iframe.contentWindow)) {
                      var i = this.iframe.contentWindow;
                      e.replace || (i.document.open(), i.document.close()), this._updateHash(i.location, t, e.replace);
                    }
                  }
                  return e.trigger ? this.loadUrl(t) : void 0;
                }
              },
              _updateHash: function _updateHash(t, e, n) {
                if (n) {
                  var r = t.href.replace(/(javascript:|#).*$/, "");
                  t.replace(r + "#" + e);
                } else t.hash = "#" + e;
              }
            }), e.history = new D(), b.extend = y.extend = j.extend = C.extend = D.extend = function (t, e) {
              var r,
                i = this;
              return r = t && n.has(t, "constructor") ? t.constructor : function () {
                return i.apply(this, arguments);
              }, n.extend(r, i, e), r.prototype = n.create(i.prototype, t), r.prototype.constructor = r, r.__super__ = i.prototype, r;
            };
            var I = function I() {
                throw new Error('A "url" property or function must be specified');
              },
              R = function R(t, e) {
                var n = e.error;
                e.error = function (r) {
                  n && n.call(e.context, t, r, e), t.trigger("error", t, r, e);
                };
              };
            return e;
          }(a, n, t, e);
        }.apply(e, i)) || (t.exports = o);
      }).call(this, n(26));
    }, function (t, e, n) {
      var r = n(42);
      t.exports = function (t, e, n) {
        return (e = r(e)) in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.d(e, "p", function () {
        return x;
      }), n.d(e, "u", function () {
        return h;
      }), n.d(e, "t", function () {
        return f;
      }), n.d(e, "k", function () {
        return b;
      }), n.d(e, "r", function () {
        return l;
      }), n.d(e, "g", function () {
        return O;
      }), n.d(e, "d", function () {
        return C;
      }), n.d(e, "b", function () {
        return v;
      }), n.d(e, "q", function () {
        return w;
      }), n.d(e, "f", function () {
        return T;
      }), n.d(e, "m", function () {
        return j;
      }), n.d(e, "e", function () {
        return y;
      }), n.d(e, "w", function () {
        return d;
      }), n.d(e, "s", function () {
        return m;
      }), n.d(e, "h", function () {
        return S;
      }), n.d(e, "i", function () {
        return p;
      }), n.d(e, "c", function () {
        return P;
      }), n.d(e, "j", function () {
        return D;
      }), n.d(e, "v", function () {
        return L;
      }), n.d(e, "a", function () {
        return u;
      }), n.d(e, "n", function () {
        return E;
      }), n.d(e, "l", function () {
        return A;
      }), n.d(e, "o", function () {
        return M;
      });
      var r = n(8),
        i = n.n(r),
        o = n(9),
        a = n.n(o),
        s = n(0),
        c = window.Element.prototype,
        l = c.matches || c.webkitMatchesSelector || c.mozMatchesSelector || c.msMatchesSelector,
        u = function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = Object(s.isArray)(e) ? a()(e) : [e];
          if (r.length) {
            var i = r.shift();
            if (i && (!n.unique || !document.querySelector('link[href="'.concat(i, '"]')))) {
              var o = document,
                c = o.head,
                l = document.createElement("link");
              l.href = i, l.rel = "stylesheet", n.prepand ? c.insertBefore(l, c.firstChild) : c.appendChild(l);
            }
            t(r);
          }
        },
        d = function d(t, e) {
          var n = {},
            r = Object(s.keys)(e);
          for (var i in t) if (t.hasOwnProperty(i)) {
            var o = t[i],
              a = e[i];
            r.indexOf(i) >= 0 ? o !== a && (n[i] = a) : n[i] = null;
          }
          for (var c in e) e.hasOwnProperty(c) && Object(s.isUndefined)(t[c]) && (n[c] = e[c]);
          return n;
        },
        h = function h(t, e, n) {
          e = e.split(/\s+/), t = t instanceof Array ? t : [t];
          for (var r = function r(_r5) {
              t.forEach(function (t) {
                return t.addEventListener(e[_r5], n);
              });
            }, i = 0; i < e.length; ++i) r(i);
        },
        f = function f(t, e, n) {
          e = e.split(/\s+/), t = t instanceof Array ? t : [t];
          for (var r = function r(_r6) {
              t.forEach(function (t) {
                return t.removeEventListener(e[_r6], n);
              });
            }, i = 0; i < e.length; ++i) r(i);
        },
        p = function p(t) {
          return t.replace(parseFloat(t), "");
        },
        g = function g(t) {
          return t[0].toUpperCase() + t.toLowerCase().slice(1);
        },
        v = function v(t) {
          var e = t.split("-").filter(String);
          return e[0].toLowerCase() + e.slice(1).map(g);
        },
        m = function m(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            r = 0;
          if (isNaN(t)) return n;
          if (t = parseFloat(t), Math.floor(t) !== t) {
            var i = e.toString().split(".")[1];
            r = i ? i.length : 0;
          }
          return r ? parseFloat(t.toFixed(r)) : t;
        },
        b = function b(t) {
          return "draggable" in document.createElement("i") && (t ? t.get("Config").nativeDnD : 1);
        },
        y = function y(t) {
          return Object(s.isElement)(t) || w(t) ? t : t && t.getEl ? t.getEl() : void 0;
        },
        w = function w(t) {
          return t && 3 === t.nodeType;
        },
        x = function x(t) {
          return t && !w(t) && !function (t) {
            return t && 8 === t.nodeType;
          }(t);
        },
        O = function O(t, e) {
          var n = t;
          return Object(s.isElement)(t) && (n = e(t).data("model")), n;
        },
        C = function C(t) {
          var e,
            n = {
              top: 0,
              left: 0,
              width: 0,
              height: 0
            };
          if (!t) return n;
          if (w(t)) {
            var r = document.createRange();
            r.selectNode(t), e = r.getBoundingClientRect(), r.detach();
          }
          return e || (t.getBoundingClientRect ? t.getBoundingClientRect() : n);
        },
        S = function S(t) {
          return t.touches && t.touches[0] ? t.touches[0] : t;
        },
        k = function k(t) {
          return t.which || t.keyCode;
        },
        T = function T(t) {
          return String.fromCharCode(k(t));
        },
        j = function j(t) {
          return 27 === k(t);
        },
        E = function E(t) {
          return null !== t && !Array.isArray(t) && "object" === i()(t);
        },
        P = function P(t) {
          return t && t.charAt(0).toUpperCase() + t.substring(1);
        },
        A = function A(t) {
          return t && t.toHTML;
        },
        M = function M(t) {
          return t && t.toCSS;
        },
        D = function D(t) {
          return t.__gjsv;
        },
        L = function L(t, e) {
          t.__gjsv = e;
        };
    }, function (t, e, n) {
      "use strict";

      (function (t) {
        n.d(e, "e", function () {
          return r;
        }), n.d(e, "p", function () {
          return i;
        }), n.d(e, "a", function () {
          return o;
        }), n.d(e, "c", function () {
          return a;
        }), n.d(e, "d", function () {
          return s;
        }), n.d(e, "o", function () {
          return c;
        }), n.d(e, "q", function () {
          return l;
        }), n.d(e, "t", function () {
          return u;
        }), n.d(e, "i", function () {
          return d;
        }), n.d(e, "r", function () {
          return h;
        }), n.d(e, "s", function () {
          return f;
        }), n.d(e, "k", function () {
          return p;
        }), n.d(e, "m", function () {
          return g;
        }), n.d(e, "j", function () {
          return v;
        }), n.d(e, "l", function () {
          return m;
        }), n.d(e, "g", function () {
          return b;
        }), n.d(e, "f", function () {
          return y;
        }), n.d(e, "h", function () {
          return w;
        }), n.d(e, "n", function () {
          return x;
        }), n.d(e, "b", function () {
          return O;
        });
        var r = "1.13.6",
          i = "object" == typeof self && self.self === self && self || "object" == typeof t && t.global === t && t || Function("return this")() || {},
          o = Array.prototype,
          a = Object.prototype,
          s = "undefined" != typeof Symbol ? Symbol.prototype : null,
          c = o.push,
          l = o.slice,
          u = a.toString,
          d = a.hasOwnProperty,
          h = "undefined" != typeof ArrayBuffer,
          f = "undefined" != typeof DataView,
          p = Array.isArray,
          g = Object.keys,
          v = Object.create,
          m = h && ArrayBuffer.isView,
          b = isNaN,
          y = isFinite,
          w = !{
            toString: null
          }.propertyIsEnumerable("toString"),
          x = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
          O = Math.pow(2, 53) - 1;
      }).call(this, n(26));
    }, function (t, e, n) {
      "use strict";

      n.r(e), n.d(e, "eventDrag", function () {
        return O;
      });
      var r = n(8),
        i = n.n(r),
        o = n(2),
        a = n.n(o),
        s = n(0),
        c = n(3),
        l = n(23),
        u = n(1),
        d = n.n(u),
        h = n(21),
        f = n(10),
        p = n(12);
      function g(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function v(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? g(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var m = d.a.Model.extend({
          defaults: {
            type: "text",
            label: "",
            name: "",
            min: "",
            max: "",
            unit: "",
            step: 1,
            value: "",
            target: "",
            default: "",
            placeholder: "",
            changeProp: 0,
            options: [],
            title: "",
            info: "",
            infoStyle: ""
          },
          initialize: function initialize() {
            var t = this.get("target"),
              e = this.get("name"),
              n = this.get("changeProp");
            if (t) {
              this.target = t, this.unset("target");
              var r = n ? "change:".concat(e) : "change:attributes:".concat(e);
              this.listenTo(t, r, this.targetUpdated);
            }
          },
          props: function props() {
            return this.attributes;
          },
          targetUpdated: function targetUpdated() {
            var t = this.getTargetValue();
            this.set({
              value: t
            }, {
              fromTarget: 1
            });
          },
          getTargetValue: function getTargetValue() {
            var t,
              e = this.get("name"),
              n = this.target;
            return t = this.get("changeProp") ? n.get(e) : n.getAttributes()[e], Object(s.isUndefined)(t) ? "" : t;
          },
          setTargetValue: function setTargetValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.target,
              r = this.get("name");
            if (!Object(s.isUndefined)(t)) {
              var i = t;
              if ("false" === t ? i = !1 : "true" === t && (i = !0), this.get("changeProp")) n.set(r, i, e);else {
                var o = v({}, n.get("attributes"));
                o[r] = i, n.set("attributes", o, e);
              }
            }
          },
          setValueFromInput: function setValueFromInput(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = {
                value: t
              };
            this.set(r, v(v({}, n), {}, {
              avoidStore: 1
            })), e && (this.set("value", "", n), this.set(r, n));
          },
          getInitValue: function getInitValue() {
            var t,
              e = this.target,
              n = this.get("name");
            if (e) {
              var r = e.get("attributes");
              t = this.get("changeProp") ? e.get(n) : r[n];
            }
            return t || this.get("value") || this.get("default");
          }
        }),
        b = d.a.Collection.extend({
          model: m,
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.em = e.em || "", this.listenTo(this, "add", this.handleAdd), this.listenTo(this, "reset", this.handleReset);
          },
          handleReset: function handleReset(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.previousModels,
              r = void 0 === n ? [] : n;
            r.forEach(function (t) {
              return t.trigger("remove");
            });
          },
          handleAdd: function handleAdd(t) {
            var e = this.target;
            e && (t.target = e);
          },
          setTarget: function setTarget(t) {
            this.target = t;
          },
          add: function add(t, e) {
            var n = this.em;
            if (Object(s.isString)(t) || Object(s.isArray)(t)) {
              var r = n && n.get && n.get("TraitManager"),
                i = function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  return {
                    build: function build(e) {
                      var n = [];
                      "string" == typeof e && (e = [e]);
                      for (var r = 0; r < e.length; r++) {
                        var i = {},
                          o = e[r];
                        switch (i.name = o, o) {
                          case "target":
                            i.type = "select", i.default = !1, i.options = t.optionsTarget;
                        }
                        n.push(i);
                      }
                      return n;
                    }
                  };
                }(r && r.getConfig());
              Object(s.isString)(t) && (t = [t]);
              for (var o = 0, a = t.length; o < a; o++) {
                var c = t[o],
                  l = Object(s.isString)(c) ? i.build(c)[0] : c;
                l.target = this.target, t[o] = l;
              }
            }
            return d.a.Collection.prototype.add.apply(this, [t, e]);
          }
        });
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x = function x(t) {
          return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
        },
        O = "component:drag",
        C = d.a.Model.extend(l.a).extend({
          defaults: {
            tagName: "div",
            type: "",
            name: "",
            removable: !0,
            draggable: !0,
            droppable: !0,
            badgable: !0,
            stylable: !0,
            "stylable-require": "",
            "style-signature": "",
            unstylable: "",
            highlightable: !0,
            copyable: !0,
            resizable: !1,
            editable: !1,
            layerable: !0,
            selectable: !0,
            hoverable: !0,
            void: !1,
            state: "",
            status: "",
            content: "",
            icon: "",
            style: "",
            classes: "",
            script: "",
            "script-export": "",
            attributes: "",
            traits: ["id", "title"],
            propagate: "",
            dmode: "",
            toolbar: null
          },
          init: function init() {},
          updated: function updated(t, e, n) {},
          removed: function removed() {},
          initialize: function initialize() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.em,
              i = this.parent(),
              o = i && i.attributes;
            if (o && o.propagate) {
              var a = {},
                c = o.propagate;
              c.forEach(function (t) {
                return a[t] = i.get(t);
              }), a.propagate = c, a = w(w({}, a), e), this.set(a);
            }
            var l = this.get("propagate");
            l && this.set("propagate", Object(s.isArray)(l) ? l : [l]), n && n.config && n.config.voidElements.indexOf(this.get("tagName")) >= 0 && this.set("void", !0), n.em = r, this.opt = n, this.em = r, this.frame = n.frame, this.config = n.config || {}, this.set("attributes", w(w({}, this.defaults.attributes || {}), this.get("attributes") || {})), this.ccid = C.createId(this), this.initClasses(), this.initTraits(), this.initComponents(), this.initToolbar(), this.listenTo(this, "change:script", this.scriptUpdated), this.listenTo(this, "change:tagName", this.tagUpdated), this.listenTo(this, "change:attributes", this.attrUpdated), this.listenTo(this, "change:attributes:id", this._idUpdated), this.set("status", ""), this.views = [], ["classes", "traits", "components"].forEach(function (e) {
              var n = "add remove ".concat("components" !== e ? "change" : "");
              t.listenTo(t.get(e), n.trim(), function () {
                for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
                return t.emitUpdate.apply(t, [e].concat(r));
              });
            }), n.temporary || (this.init(), r && r.trigger("component:create", this));
          },
          is: function is(t) {
            return !(this.get("type") != t);
          },
          props: function props() {
            return this.attributes;
          },
          index: function index() {
            var t = this.collection;
            return t && t.indexOf(this);
          },
          setDragMode: function setDragMode(t) {
            return this.set("dmode", t);
          },
          find: function find(t) {
            var e = [],
              n = this.view.$el.find(t);
            return n.each(function (t) {
              var r = n.eq(t).data("model");
              r && e.push(r);
            }), e;
          },
          findType: function findType(t) {
            var e = [];
            return function n(r) {
              return r.forEach(function (r) {
                r.is(t) && e.push(r), n(r.components());
              });
            }(this.components()), e;
          },
          closest: function closest(t) {
            var e = this.view.$el.closest(t);
            return e.length && e.data("model");
          },
          closestType: function closestType(t) {
            for (var e = this.parent(); e && !e.is(t);) e = e.parent();
            return e;
          },
          tagUpdated: function tagUpdated() {
            var t = this.collection,
              e = t.indexOf(this);
            t.remove(this), t.add(this, {
              at: e
            });
          },
          replaceWith: function replaceWith(t) {
            var e = this.collection,
              n = e.indexOf(this);
            return e.remove(this), e.add(t, {
              at: n
            });
          },
          attrUpdated: function attrUpdated(t, e) {
            var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = this.get("attributes"),
              o = i.class;
            o && this.setClass(o), delete i.class;
            var a = i.style;
            a && this.setStyle(a), delete i.style;
            var l = w({}, this.previous("attributes")),
              u = Object(c.w)(l, this.get("attributes"));
            Object(s.keys)(u).forEach(function (t) {
              return n.trigger("change:attributes:".concat(t), n, u[t], r);
            });
          },
          setAttributes: function setAttributes(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.set("attributes", w({}, t), e), this;
          },
          addAttributes: function addAttributes(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = w(w({}, this.getAttributes()), t);
            return this.setAttributes(n, e), this;
          },
          getStyle: function getStyle() {
            var t = this.em;
            if (t && t.getConfig("avoidInlineStyle")) {
              var e = t.get("state"),
                n = t.get("CssComposer").getIdRule(this.getId(), {
                  state: e
                });
              if (this.rule = n, n) return n.getStyle();
            }
            return l.a.getStyle.call(this);
          },
          setStyle: function setStyle() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.em,
              i = this.opt;
            if (r && r.getConfig("avoidInlineStyle") && !i.temporary) {
              var o = this.get("style") || {};
              e = w(w({}, e = Object(s.isString)(e) ? this.parseStyle(e) : e), o);
              var a = r.get("state"),
                u = r.get("CssComposer"),
                d = this.getStyle();
              this.rule = u.setIdRule(this.getId(), e, w(w({}, n), {}, {
                state: a
              }));
              var h = Object(c.w)(d, e);
              this.set("style", {}, {
                silent: 1
              }), Object(s.keys)(h).forEach(function (e) {
                return t.trigger("change:style:".concat(e));
              });
            } else e = l.a.setStyle.apply(this, arguments);
            return e;
          },
          getAttributes: function getAttributes() {
            var t,
              e = this.em,
              n = [],
              r = w({}, this.get("attributes")),
              i = e && e.get("SelectorManager"),
              o = this.getId();
            return this.get("classes").forEach(function (t) {
              return n.push(Object(s.isString)(t) ? t : t.get("name"));
            }), n.length && (r.class = n.join(" ")), Object(s.has)(r, "id") || (function (t) {
              return t && t.getConfig("avoidInlineStyle");
            }(e) ? t = i && i.get(o, i.Selector.TYPE_ID) : Object(s.isEmpty)(this.getStyle()) || (t = 1), t && (r.id = this.getId())), r;
          },
          addClass: function addClass(t) {
            var e = this.em.get("SelectorManager").addClass(t);
            return this.get("classes").add(e);
          },
          setClass: function setClass(t) {
            return this.get("classes").reset(), this.addClass(t);
          },
          removeClass: function removeClass(t) {
            var e = [];
            t = Object(s.isArray)(t) ? t : [t];
            var n = this.get("classes"),
              r = f.a.TYPE_CLASS;
            return t.forEach(function (t) {
              t.split(" ").forEach(function (t) {
                var i = n.where({
                  name: t,
                  type: r
                })[0];
                i && e.push(n.remove(i));
              });
            }), e;
          },
          getClasses: function getClasses() {
            var t = this.getAttributes().class;
            return t ? t.split(" ") : [];
          },
          initClasses: function initClasses() {
            var t = this.get("attributes").class || [],
              e = [this, "change:classes", this.initClasses],
              n = this.get("classes") || t,
              r = Object(s.isString)(n) ? n.split(" ") : n;
            this.stopListening.apply(this, e);
            var i = this.normalizeClasses(r),
              o = new p.a([]);
            return this.set("classes", o), o.add(i), this.listenTo.apply(this, e), this;
          },
          initComponents: function initComponents() {
            var t = [this, "change:components", this.initComponents];
            this.stopListening.apply(this, t);
            var e = new h.a(null, this.opt);
            e.parent = this;
            var n = this.get("components"),
              r = !this.opt.avoidChildren;
            return this.set("components", e), r && e.add(Object(s.isFunction)(n) ? n(this) : n), this.listenTo.apply(this, t), this;
          },
          initTraits: function initTraits(t) {
            var e = this.em,
              n = [this, "change:traits", this.initTraits];
            this.stopListening.apply(this, n), this.loadTraits();
            var r = w({}, this.get("attributes")),
              i = this.get("traits");
            return i.each(function (t) {
              if (!t.get("changeProp")) {
                var e = t.get("name"),
                  n = t.getInitValue();
                e && n && (r[e] = n);
              }
            }), i.length && this.set("attributes", r), this.listenTo.apply(this, n), t && e && e.trigger("component:toggled"), this;
          },
          append: function append(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.components().add(t, e);
            return Object(s.isArray)(n) ? n : [n];
          },
          components: function components(t) {
            var e = this.get("components");
            return Object(s.isUndefined)(t) ? e : (e.reset(), t && this.append(t));
          },
          empty: function empty() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.components().reset(null, t), this;
          },
          parent: function parent() {
            var t = this.collection;
            return t && t.parent;
          },
          scriptUpdated: function scriptUpdated() {
            this.set("scriptUpdated", 1);
          },
          initToolbar: function initToolbar() {
            var t = this.em,
              e = t && t.getConfig("stylePrefix") || "";
            if (!this.get("toolbar")) {
              var n = [];
              this.collection && n.push({
                attributes: {
                  class: "fa fa-arrow-up"
                },
                command: function command(t) {
                  return t.runCommand("core:component-exit", {
                    force: 1
                  });
                }
              }), this.get("draggable") && n.push({
                attributes: {
                  class: "fa fa-arrows ".concat(e, "no-touch-actions"),
                  draggable: !0
                },
                command: "tlb-move"
              }), this.get("copyable") && n.push({
                attributes: {
                  class: "fa fa-clone"
                },
                command: "tlb-clone"
              }), this.get("removable") && n.push({
                attributes: {
                  class: "fa fa-trash-o"
                },
                command: "tlb-delete"
              }), this.get("traits").length > 0 && n.push({
                attributes: {
                  class: "fa fa-cog"
                },
                command: "tlb-trait-setting"
              }), this.set("toolbar", n);
            }
          },
          loadTraits: function loadTraits(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (t = t || this.get("traits"), !((t = Object(s.isFunction)(t) ? t(this) : t) instanceof b)) {
              var n = new b([], this.opt);
              n.setTarget(this), t.length && (t.forEach(function (t) {
                return t.attributes && delete t.attributes.value;
              }), n.add(t)), this.set("traits", n, e);
            }
            return this;
          },
          getTrait: function getTrait(t) {
            return this.get("traits").filter(function (e) {
              return e.get("id") === t || e.get("name") === t;
            })[0];
          },
          updateTrait: function updateTrait(t, e) {
            var n = this.em,
              r = this.getTrait(t);
            return r && r.set(e), n && n.trigger("component:toggled"), this;
          },
          getTraitIndex: function getTraitIndex(t) {
            var e = this.getTrait(t);
            return e ? this.get("traits").indexOf(e) : e;
          },
          removeTrait: function removeTrait(t) {
            var e = this,
              n = this.em,
              r = (Object(s.isArray)(t) ? t : [t]).map(function (t) {
                return e.getTrait(t);
              }),
              i = this.get("traits").remove(r);
            return n && n.trigger("component:toggled"), i;
          },
          addTrait: function addTrait(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.em,
              r = this.get("traits").add(t, e);
            return n && n.trigger("component:toggled"), r;
          },
          normalizeClasses: function normalizeClasses(t) {
            var e = [],
              n = this.em;
            if (n) {
              var r = n.get("SelectorManager");
              if (r) return t.forEach(function (t) {
                var n;
                n = "string" == typeof t ? t : t.name;
                var i = r.add(n);
                e.push(i);
              }), e;
            }
          },
          clone: function clone() {
            var t = this.em,
              e = this.getStyle(),
              n = w({}, this.attributes),
              r = w({}, this.opt);
            n.attributes = w({}, n.attributes), delete n.attributes.id, n.components = [], n.classes = [], n.traits = [], this.get("components").each(function (t, e) {
              n.components[e] = t.clone();
            }), this.get("traits").each(function (t, e) {
              n.traits[e] = t.clone();
            }), this.get("classes").each(function (t, e) {
              n.classes[e] = t.get("name");
            }), n.status = "", n.view = "", r.collection = null, t && t.getConfig("avoidInlineStyle") && !Object(s.isEmpty)(e) && (n.style = e);
            var i = new this.constructor(n, r);
            return t && t.trigger("component:clone", i), this.trigger("component:clone", i), i;
          },
          getName: function getName() {
            var t = this.em,
              e = this.attributes,
              n = e.type,
              r = e.tagName,
              i = this.get("name"),
              o = "div" == r,
              a = n || (o ? "box" : r),
              s = !n && r && !o && r,
              l = "domComponents.names.",
              u = i && t && t.t("".concat(l).concat(i)),
              d = s && t && t.t("".concat(l).concat(s)),
              h = t && (t.t("".concat(l).concat(n)) || t.t("".concat(l).concat(r)));
            return this.get("custom-name") || u || i || d || Object(c.c)(s) || h || Object(c.c)(a);
          },
          getIcon: function getIcon() {
            var t = this.get("icon");
            return t ? t + " " : "";
          },
          toHTML: function toHTML() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this,
              n = [],
              r = t.tag,
              i = r || e.get("tagName"),
              o = e.get("void"),
              a = t.attributes,
              c = this.getAttrToHTML();
            for (var l in delete t.tag, a && (Object(s.isFunction)(a) ? c = a(e, c) || {} : Object(s.isObject)(a) && (c = a)), c) {
              var u = c[l],
                d = Object(s.isString)(u) ? u.replace(/"/g, "&quot;") : u;
              Object(s.isUndefined)(d) || (Object(s.isBoolean)(d) ? d && n.push(l) : n.push("".concat(l, '="').concat(d, '"')));
            }
            var h = n.length ? " ".concat(n.join(" ")) : "",
              f = "<".concat(i).concat(h).concat(o ? "/" : "", ">").concat(e.get("content"));
            return e.get("components").each(function (e) {
              return f += e.toHTML(t);
            }), !o && (f += "</".concat(i, ">")), f;
          },
          getAttrToHTML: function getAttrToHTML() {
            var t = this.getAttributes();
            return delete t.style, t;
          },
          toJSON: function toJSON() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var r = d.a.Model.prototype.toJSON.apply(this, e);
            if (r.attributes = this.getAttributes(), delete r.attributes.class, delete r.toolbar, delete r.traits, this.em.getConfig("avoidDefaults")) {
              var i = Object(s.result)(this, "defaults");
              Object(s.forEach)(i, function (t, e) {
                -1 === ["type", "content"].indexOf(e) && r[e] === t && delete r[e];
              }), Object(s.isEmpty)(r.type) && delete r.type, Object(s.forEach)(["attributes", "style"], function (t) {
                Object(s.isEmpty)(i[t]) && Object(s.isEmpty)(r[t]) && delete r[t];
              }), Object(s.forEach)(["classes", "components"], function (t) {
                Object(s.isEmpty)(i[t]) && !r[t].length && delete r[t];
              });
            }
            return r;
          },
          getId: function getId() {
            return (this.get("attributes") || {}).id || this.ccid || this.cid;
          },
          setId: function setId(t, e) {
            var n = w({}, this.get("attributes"));
            return n.id = t, this.set("attributes", n, e), this;
          },
          getEl: function getEl(t) {
            var e = this.getView(t);
            return e && e.el;
          },
          getView: function getView(t) {
            var e = this.view,
              n = this.views;
            return t && (e = n.filter(function (e) {
              return e._getFrame() === t.view;
            })[0]), e;
          },
          getCurrentView: function getCurrentView() {
            var t = (this.em.get("currentFrame") || {}).model;
            return this.getView(t);
          },
          getScriptString: function getScriptString(t) {
            var e = this,
              n = t || this.get("script");
            if (!n) return n;
            if ("function" == typeof n) {
              var r = n.toString().trim();
              n = (r = r.replace(/^function[\s\w]*\(\)\s?\{/, "").replace(/\}$/, "")).trim();
            }
            var o = this.em.getConfig(),
              a = x(o.tagVarStart || "{[ "),
              c = x(o.tagVarEnd || " ]}"),
              l = new RegExp("".concat(a, "([\\w\\d-]*)").concat(c), "g");
            return n.replace(l, function (t, n) {
              e.scriptUpdated();
              var r = e.attributes[n] || "";
              return Object(s.isArray)(r) || "object" == i()(r) ? JSON.stringify(r) : r;
            });
          },
          emitUpdate: function emitUpdate(t) {
            for (var e = this.em, n = "component:update" + (t ? ":".concat(t) : ""), r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) i[o - 1] = arguments[o];
            t && this.updated.apply(this, [t, t && this.get(t), t && this.previous(t)].concat(i)), this.trigger.apply(this, [n].concat(i)), e && e.trigger.apply(e, [n, this].concat(i));
          },
          onAll: function onAll(t) {
            return Object(s.isFunction)(t) && (t(this), this.components().forEach(function (e) {
              return e.onAll(t);
            })), this;
          },
          remove: function remove() {
            var t = this.collection;
            return t && t.remove(this);
          },
          resetId: function resetId() {
            var t = this.em,
              e = this.getId();
            if (e) {
              var n = C.createId(this);
              this.setId(n);
              var r = t && t.get("CssComposer").getIdRule(e),
                i = r && r.get("selectors").at(0);
              return i && i.set("name", n), this;
            }
          },
          _getStyleRule: function _getStyleRule() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.id,
              n = this.em,
              r = e || this.getId();
            return n && n.get("CssComposer").getIdRule(r);
          },
          _getStyleSelector: function _getStyleSelector(t) {
            var e = this._getStyleRule(t);
            return e && e.get("selectors").at(0);
          },
          _idUpdated: function _idUpdated(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            if (!n.idUpdate) {
              var r = this.ccid,
                i = this.get("attributes") || {},
                o = i.id,
                a = (this.previous("attributes") || {}).id || r,
                s = C.getList(this);
              if (s[o]) return this.setId(a, {
                idUpdate: 1
              });
              delete s[a], s[o] = this, this.ccid = o;
              var c = this._getStyleSelector({
                id: a
              });
              c && c.set({
                name: o,
                label: o
              });
            }
          }
        }, {
          isComponent: function isComponent(t) {
            return {
              tagName: t.tagName ? t.tagName.toLowerCase() : ""
            };
          },
          ensureInList: function ensureInList(t) {
            var e = C.getList(t),
              n = t.getId(),
              r = e[n];
            if (r) {
              if (r !== t) {
                var i = C.getIncrementId(n, e);
                t.setId(i), e[i] = t;
              }
            } else e[n] = t;
            t.components().forEach(function (t) {
              return C.ensureInList(t);
            });
          },
          createId: function createId(t) {
            var e,
              n = C.getList(t),
              r = t.get("attributes").id;
            return r ? (e = C.getIncrementId(r, n), t.setId(e)) : e = C.getNewId(n), n[e] = t, e;
          },
          getNewId: function getNewId(t) {
            for (var e = Object.keys(t).length.toString().length + 2, n = (Math.random() + 1.1).toString(36).slice(-e), r = "i".concat(n); t[r];) r = C.getNewId(t);
            return r;
          },
          getIncrementId: function getIncrementId(t, e) {
            for (var n = 1, r = t; e[r];) n++, r = "".concat(t, "-").concat(n);
            return r;
          },
          getList: function getList(t) {
            var e = t.opt && t.opt.domc;
            return e ? e.componentsById : {};
          },
          checkId: function checkId(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = Object(s.isArray)(t) ? t : [t];
            r.forEach(function (t) {
              var r = t.attributes,
                i = void 0 === r ? {} : r,
                o = t.components,
                a = i.id;
              if (a && n[a]) {
                var c = C.getIncrementId(a, n);
                i.id = c, Object(s.isArray)(e) && e.forEach(function (t) {
                  var e = t.selectors;
                  e.forEach(function (t, n) {
                    t === "#".concat(a) && (e[n] = "#".concat(c));
                  });
                });
              }
              o && C.checkId(o, e, n);
            });
          }
        });
      e.default = C;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(1),
        a = n.n(o),
        s = n(0),
        c = n(21),
        l = n(35),
        u = n(12),
        d = n(7),
        h = n(3);
      function f(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function p(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? f(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = a.a.View.extend({
        className: function className() {
          return this.getClasses();
        },
        tagName: function tagName() {
          return this.model.get("tagName");
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = t.config || {},
            r = n.em,
            i = e.opt || {},
            o = this.$el,
            a = this.el,
            s = n.draggableComponents;
          this.opts = t, this.modelOpt = i, this.config = n, this.em = r || "", this.pfx = n.stylePrefix || "", this.ppfx = n.pStylePrefix || "", this.attr = e.get("attributes"), this.classe = this.attr.class || [], this.listenTo(e, "change:style", this.updateStyle), this.listenTo(e, "change:attributes change:_innertext", this.renderAttributes), this.listenTo(e, "change:highlightable", this.updateHighlight), this.listenTo(e, "change:status", this.updateStatus), this.listenTo(e, "change:script", this.reset), this.listenTo(e, "change:content", this.updateContent), this.listenTo(e, "change", this.handleChange), this.listenTo(e, "active", this.onActive), this.listenTo(e, "disable", this.onDisable), o.data("model", e), Object(h.v)(a, this), e.view = this, this._getFrame() && e.views.push(this), this.initClasses(), this.initComponents({
            avoidRender: 1
          }), this.events = p(p({}, this.events), s && {
            dragstart: "handleDragStart"
          }), this.delegateEvents(), !i.temporary && this.init(this._clbObj());
        },
        _clbObj: function _clbObj() {
          var t = this.em,
            e = this.model,
            n = this.el;
          return {
            editor: t && t.getEditor(),
            model: e,
            el: n
          };
        },
        init: function init() {},
        removed: function removed() {},
        onActive: function onActive() {},
        onDisable: function onDisable() {},
        remove: function remove() {
          var t = this;
          a.a.View.prototype.remove.apply(t, arguments);
          var e = t.model,
            n = t._getFrame() || {},
            r = n.model;
          e.components().forEach(function (t) {
            var e = t.getView(r);
            e && e.remove();
          });
          var i = e.views;
          return i.splice(i.indexOf(t), 1), t.removed(t._clbObj()), t.$el.data({
            model: "",
            collection: "",
            view: ""
          }), delete t.model, delete t.$el, delete t.el.__gjsv, delete t.childrenView, delete t.opts, t;
        },
        handleDragStart: function handleDragStart(t) {
          t.preventDefault(), t.stopPropagation(), this.em.get("Commands").run("tlb-move", {
            target: this.model,
            event: t
          });
        },
        initClasses: function initClasses() {
          var t = this.model,
            e = t.get("classes");
          e instanceof u.a && (this.stopListening(t, "change:classes", this.initClasses), this.listenTo(t, "change:classes", this.initClasses), this.listenTo(e, "add remove change", this.updateClasses), e.length && this.importClasses());
        },
        initComponents: function initComponents() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.model,
            n = this.$el,
            r = this.childrenView,
            i = "change:components",
            o = e.get("components"),
            a = [e, i, this.initComponents];
          o instanceof c.a && (n.data("collection", o), r && r.remove(), this.stopListening.apply(this, a), !t.avoidRender && this.renderChildren(), this.listenTo.apply(this, a));
        },
        handleChange: function handleChange() {
          var t = this.model,
            e = Object(s.keys)(t.changed);
          if (1 !== e.length || "status" !== e[0]) for (var n in t.emitUpdate(), t.changed) t.emitUpdate(n);
        },
        importClasses: function importClasses() {
          var t = this.config.em.get("SelectorManager");
          t && this.model.get("classes").each(function (e) {
            t.add(e.get("name"));
          });
        },
        updateStatus: function updateStatus() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = (this.em, this.el),
            n = this.model.get("status"),
            r = (this.pfx, this.ppfx),
            i = "".concat(r, "selected"),
            o = "".concat(i, "-parent"),
            a = "".concat(r, "freezed"),
            s = "".concat(r, "hovered"),
            c = [i, o, a, s];
          this.$el.removeClass(c.join(" "));
          var l = e.getAttribute("class") || "",
            u = "";
          switch (n) {
            case "selected":
              u = "".concat(l, " ").concat(i);
              break;
            case "selected-parent":
              u = "".concat(l, " ").concat(o);
              break;
            case "freezed":
              u = "".concat(l, " ").concat(a);
              break;
            case "freezed-selected":
              u = "".concat(l, " ").concat(a, " ").concat(i);
              break;
            case "hovered":
              u = t.avoidHover ? "" : "".concat(l, " ").concat(s);
          }
          (u = u.trim()) && e.setAttribute("class", u);
        },
        updateHighlight: function updateHighlight() {
          var t = this.model.get("highlightable");
          this.setAttribute("data-highlightable", t ? 1 : "");
        },
        updateStyle: function updateStyle() {
          var t = this.model,
            e = this.em,
            n = this.el;
          if (e && e.getConfig("avoidInlineStyle")) {
            t.get("_innertext") ? n.removeAttribute("id") : n.id = t.getId();
            var r = t.getStyle();
            !Object(s.isEmpty)(r) && t.setStyle(r);
          } else this.setAttribute("style", t.styleToString());
        },
        updateClasses: function updateClasses() {
          var t = this.model.get("classes").pluck("name").join(" ");
          this.setAttribute("class", t), this.updateStatus();
        },
        setAttribute: function setAttribute(t, e) {
          var n = this.$el;
          e ? n.attr(t, e) : n.removeAttr(t);
        },
        getClasses: function getClasses() {
          return this.model.getClasses().join(" ");
        },
        updateAttributes: function updateAttributes() {
          var t = [],
            e = this.model,
            n = this.$el,
            r = this.el,
            i = this.config,
            o = e.attributes,
            a = o.highlightable,
            c = o.textable,
            l = o.type,
            u = o._innertext,
            d = p(p(p({
              "data-gjs-type": l || "default"
            }, i.draggableComponents && !u ? {
              draggable: !0
            } : {}), a ? {
              "data-highlightable": 1
            } : {}), c ? {
              contenteditable: "false",
              "data-gjs-textable": "true"
            } : {});
          Object(s.each)(r.attributes, function (e) {
            return t.push(e.nodeName);
          }), t.forEach(function (t) {
            return n.removeAttr(t);
          });
          var h = p(p({}, d), e.getAttributes());
          Object(s.keys)(h).forEach(function (t) {
            return !1 === h[t] && delete h[t];
          }), n.attr(h), this.updateStyle();
        },
        updateContent: function updateContent() {
          this.getChildrenContainer().innerHTML = this.model.get("content");
        },
        prevDef: function prevDef(t) {
          t.preventDefault();
        },
        updateScript: function updateScript() {
          var t = this.model,
            e = this.em;
          t.get("script") && e && e.get("Canvas").getCanvasView().updateScript(this);
        },
        getChildrenContainer: function getChildrenContainer() {
          var t = this.el;
          return "function" == typeof this.getChildrenSelector ? t = this.el.querySelector(this.getChildrenSelector()) : this.getTemplate, t;
        },
        getOffsetRect: function getOffsetRect() {
          var t = {},
            e = this.el,
            n = 0,
            r = 0;
          return function i(o) {
            var a = o.offsetParent;
            a ? (n += a.offsetTop, r += a.offsetLeft, i(a)) : (t.top = e.offsetTop + n, t.left = e.offsetLeft + r, t.bottom = t.top + e.offsetHeight, t.right = t.left + e.offsetWidth);
          }(e), t;
        },
        isInViewport: function isInViewport() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.rect,
            n = this.el,
            r = n.ownerDocument,
            i = r.body,
            o = r.defaultView.frameElement,
            a = e || this.getOffsetRect(),
            s = a.top,
            c = a.left,
            l = this._getFrame().getOffsetRect();
          return s >= l.scrollTop && c >= l.scrollLeft && s <= l.scrollBottom && c <= o.offsetWidth + i.scrollLeft;
        },
        scrollIntoView: function scrollIntoView() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.getOffsetRect(),
            n = this.isInViewport({
              rect: e
            });
          if (!n || t.force) {
            var r = this.el;
            "smooth" !== t.behavior ? r.ownerDocument.defaultView.scrollTo(0, e.top) : r.scrollIntoView(p({
              behavior: "smooth",
              block: "nearest"
            }, t));
          }
        },
        reset: function reset() {
          var t = this.el;
          this.el = "", this._ensureElement(), this._setData(), Object(d.j)(t, this.el), this.render();
        },
        _setData: function _setData() {
          var t = this.model,
            e = t.components();
          this.$el.data({
            model: t,
            collection: e,
            view: this
          });
        },
        _getFrame: function _getFrame() {
          return this.config.frameView;
        },
        renderChildren: function renderChildren() {
          this.updateContent();
          var t = this.getChildrenContainer(),
            e = this.childrenView || new l.a({
              collection: this.model.get("components"),
              config: this.config,
              componentTypes: this.opts.componentTypes
            });
          e.render(t), this.childrenView = e;
          for (var n = Array.prototype.slice.call(e.el.childNodes), r = 0, i = n.length; r < i; r++) t.appendChild(n.shift());
        },
        renderAttributes: function renderAttributes() {
          this.updateAttributes(), this.updateClasses();
        },
        render: function render() {
          return this.renderAttributes(), this.modelOpt.temporary || (this.renderChildren(), this.updateScript(), Object(h.v)(this.el, this), this.postRender()), this;
        },
        postRender: function postRender() {
          var t = this.em,
            e = this.model;
          this.modelOpt.temporary || (this.onRender(this._clbObj()), t && t.trigger("component:mount", e));
        },
        onRender: function onRender() {}
      });
    }, function (t, e, n) {
      "use strict";

      n.d(e, "i", function () {
        return i;
      }), n.d(e, "g", function () {
        return o;
      }), n.d(e, "h", function () {
        return a;
      }), n.d(e, "f", function () {
        return s;
      }), n.d(e, "j", function () {
        return c;
      }), n.d(e, "b", function () {
        return l;
      }), n.d(e, "a", function () {
        return u;
      }), n.d(e, "e", function () {
        return d;
      }), n.d(e, "d", function () {
        return h;
      }), n.d(e, "c", function () {
        return f;
      });
      var r = n(0),
        i = "transitionend oTransitionEnd transitionend webkitTransitionEnd",
        o = function o(t) {
          return t && 9 === t.nodeType;
        },
        a = function a(t) {
          return t && !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
        },
        s = function s(t) {
          for (; t.firstChild;) t.removeChild(t.firstChild);
        },
        c = function c(t, e) {
          t.parentNode.replaceChild(e, t);
        },
        l = function l(t, e, n) {
          var i = t.childNodes,
            o = i.length,
            a = Object(r.isUndefined)(n) ? o : n;
          Object(r.isString)(e) && (t.insertAdjacentHTML("beforeEnd", e), e = t.lastChild, t.removeChild(e)), a >= o ? t.appendChild(e) : t.insertBefore(e, i[a]);
        },
        u = function u(t, e) {
          return l(t, e);
        },
        d = function d(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = arguments.length > 2 ? arguments[2] : void 0,
            i = document.createElement(t);
          return e && Object(r.each)(e, function (t, e) {
            return i.setAttribute(e, t);
          }), n && (Object(r.isString)(n) ? i.innerHTML = n : i.appendChild(n)), i;
        },
        h = function h(t, e) {
          var n;
          try {
            n = new window[e](t.type, t);
          } catch (t) {
            (n = document.createEvent(e)).initEvent(t.type, !0, !0);
          }
          return n.keyCodeVal = t.keyCode, n._parentEvent = t, ["keyCode", "which"].forEach(function (t) {
            Object.defineProperty(n, t, {
              get: function get() {
                return this.keyCodeVal;
              }
            });
          }), n;
        },
        f = function f(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = Array.isArray(e) ? e : [e];
          n.forEach(function (e) {
            var n = e.tag || "div",
              i = e.attributes || {},
              o = document.createElement(n);
            Object(r.each)(i, function (t, e) {
              o.setAttribute(e, t);
            }), t.appendChild(o);
          });
        };
    }, function (t, e) {
      function n(e) {
        return t.exports = n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, t.exports.__esModule = !0, t.exports.default = t.exports, n(e);
      }
      t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var r = n(82),
        i = n(83),
        o = n(44),
        a = n(84);
      t.exports = function (t) {
        return r(t) || i(t) || o(t) || a();
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      var r = n(1),
        i = n.n(r).a.Model.extend({
          idAttribute: "name",
          defaults: {
            name: "",
            label: "",
            type: 1,
            active: !0,
            private: !1,
            protected: !1
          },
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.config,
              r = void 0 === n ? {} : n,
              o = this.get("name"),
              a = this.get("label");
            o ? a || this.set("label", o) : this.set("name", a);
            var s = this.get("name"),
              c = r.escapeName,
              l = c ? c(s) : i.escapeName(s);
            this.set("name", l);
          },
          getFullName: function getFullName() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.escape,
              n = this.get("name"),
              r = "";
            switch (this.get("type")) {
              case 1:
                r = ".";
                break;
              case 2:
                r = "#";
            }
            return r + (e ? e(n) : n);
          }
        }, {
          TYPE_CLASS: 1,
          TYPE_ID: 2,
          escapeName: function escapeName(t) {
            return "".concat(t).trim().replace(/([^a-z0-9\w-\:]+)/gi, "-");
          }
        });
      e.a = i;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = document,
        i = window,
        o = Array.prototype,
        a = o.filter,
        s = o.indexOf,
        c = o.map,
        l = o.push,
        u = o.reverse,
        d = o.slice,
        h = o.splice,
        f = /^#[\w-]*$/,
        p = /^\.[\w-]*$/,
        g = /<.+>/,
        v = /^\w+$/;
      function m(t, e) {
        return void 0 === e && (e = r), p.test(t) ? e.getElementsByClassName(t.slice(1)) : v.test(t) ? e.getElementsByTagName(t) : e.querySelectorAll(t);
      }
      function b(t, e) {
        if (void 0 === e && (e = r), t) {
          if (t.__cash) return t;
          var n = t;
          if (E(t)) {
            if (e.__cash && (e = e[0]), !(n = f.test(t) ? e.getElementById(t.slice(1)) : g.test(t) ? lt(t) : m(t, e))) return;
          } else if (j(t)) return this.ready(t);
          (n.nodeType || n === i) && (n = [n]), this.length = n.length;
          for (var o = 0, a = this.length; o < a; o++) this[o] = n[o];
        }
      }
      function y(t, e) {
        return new b(t, e);
      }
      var w = y.fn = y.prototype = b.prototype = {
        constructor: y,
        __cash: !0,
        length: 0,
        splice: h
      };
      w.get = function (t) {
        return void 0 === t ? d.call(this) : this[t < 0 ? t + this.length : t];
      }, w.eq = function (t) {
        return y(this.get(t));
      }, w.first = function () {
        return this.eq(0);
      }, w.last = function () {
        return this.eq(-1);
      }, w.map = function (t) {
        return y(c.call(this, function (e, n) {
          return t.call(e, n, e);
        }));
      }, w.slice = function () {
        return y(d.apply(this, arguments));
      };
      var x = /(?:^\w|[A-Z]|\b\w)/g,
        O = /[\s-_]+/g;
      function C(t) {
        return t.replace(x, function (t, e) {
          return t[e ? "toUpperCase" : "toLowerCase"]();
        }).replace(O, "");
      }
      function S(t, e) {
        for (var n = 0, r = t.length; n < r && !1 !== e.call(t[n], t[n], n, t); n++);
      }
      y.camelCase = C, y.each = S, w.each = function (t) {
        return S(this, function (e, n) {
          return t.call(e, n, e);
        }), this;
      }, w.removeProp = function (t) {
        return this.each(function (e, n) {
          delete n[t];
        });
      }, y.extend = w.extend = function (t) {
        void 0 === t && (t = this);
        for (var e = arguments, n = e.length, r = n < 2 ? 0 : 1; r < n; r++) for (var i in e[r]) t[i] = e[r][i];
        return t;
      };
      var k = 1;
      function T(t, e) {
        var n = t && (t.matches || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector);
        return !!n && n.call(t, e);
      }
      function j(t) {
        return "function" == typeof t;
      }
      function E(t) {
        return "string" == typeof t;
      }
      function P(t) {
        return !isNaN(parseFloat(t)) && isFinite(t);
      }
      y.guid = k, y.matches = T, y.isFunction = j, y.isString = E, y.isNumeric = P;
      var A = Array.isArray;
      function M(t) {
        return E(t) ? function (e, n) {
          return T(n, t);
        } : t.__cash ? function (e, n) {
          return t.is(n);
        } : function (t, e, n) {
          return e === n;
        };
      }
      y.isArray = A, w.prop = function (t, e) {
        if (t) {
          if (E(t)) return arguments.length < 2 ? this[0] && this[0][t] : this.each(function (n, r) {
            r[t] = e;
          });
          for (var n in t) this.prop(n, t[n]);
          return this;
        }
      }, w.filter = function (t) {
        if (!t) return y();
        var e = j(t) ? t : M(t);
        return y(a.call(this, function (n, r) {
          return e.call(n, r, n, t);
        }));
      };
      var D = /\S+/g;
      function L(t) {
        return E(t) && t.match(D) || [];
      }
      function _(t) {
        return t.filter(function (t, e, n) {
          return n.indexOf(t) === e;
        });
      }
      function N(t, e, n) {
        if (1 === t.nodeType) {
          var r = i.getComputedStyle(t, null);
          return e ? n ? r.getPropertyValue(e) : r[e] : r;
        }
      }
      function I(t, e) {
        return parseInt(N(t, e), 10) || 0;
      }
      w.hasClass = function (t) {
        var e = L(t),
          n = !1;
        return e.length && this.each(function (t, r) {
          return !(n = r.classList.contains(e[0]));
        }), n;
      }, w.removeAttr = function (t) {
        var e = L(t);
        return e.length ? this.each(function (t, n) {
          S(e, function (t) {
            n.removeAttribute(t);
          });
        }) : this;
      }, w.attr = function (t, e) {
        if (t) {
          if (E(t)) {
            if (arguments.length < 2) {
              if (!this[0]) return;
              var n = this[0].getAttribute(t);
              return null === n ? void 0 : n;
            }
            return null === e ? this.removeAttr(t) : this.each(function (n, r) {
              r.setAttribute(t, e);
            });
          }
          for (var r in t) this.attr(r, t[r]);
          return this;
        }
      }, w.toggleClass = function (t, e) {
        var n = L(t),
          r = void 0 !== e;
        return n.length ? this.each(function (t, i) {
          S(n, function (t) {
            r ? e ? i.classList.add(t) : i.classList.remove(t) : i.classList.toggle(t);
          });
        }) : this;
      }, w.addClass = function (t) {
        return this.toggleClass(t, !0);
      }, w.removeClass = function (t) {
        return arguments.length ? this.toggleClass(t, !1) : this.attr("class", "");
      }, y.unique = _, w.add = function (t, e) {
        return y(_(this.get().concat(y(t, e).get())));
      };
      var R = /^--/;
      function F(t) {
        return R.test(t);
      }
      var V = {},
        z = r.createElement("div").style,
        H = ["webkit", "moz", "ms", "o"];
      function B(t, e) {
        if (void 0 === e && (e = F(t)), e) return t;
        if (!V[t]) {
          var n = C(t),
            r = "" + n.charAt(0).toUpperCase() + n.slice(1);
          S((n + " " + H.join(r + " ") + r).split(" "), function (e) {
            if (e in z) return V[t] = e, !1;
          });
        }
        return V[t];
      }
      y.prefixedProp = B;
      var U = {
        animationIterationCount: !0,
        columnCount: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0
      };
      function $(t, e, n) {
        return void 0 === n && (n = F(t)), n || U[t] || !P(e) ? e : e + "px";
      }
      w.css = function (t, e) {
        if (E(t)) {
          var n = F(t);
          return t = B(t, n), arguments.length < 2 ? this[0] && N(this[0], t, n) : t ? (e = $(t, e, n), this.each(function (r, i) {
            1 === i.nodeType && (n ? i.style.setProperty(t, e) : i.style[t] = e);
          })) : this;
        }
        for (var r in t) this.css(r, t[r]);
        return this;
      };
      var W = /^data-(.*)/;
      function q(t) {
        return t.__cashData = t.__cashData || {};
      }
      function G(t, e) {
        var n = q(t);
        if (e) {
          if (!(e in n)) {
            var r = t.dataset ? t.dataset[e] || t.dataset[C(e)] : y(t).attr("data-" + e);
            if (void 0 !== r) {
              try {
                r = JSON.parse(r);
              } catch (t) {}
              n[e] = r;
            }
          }
          return n[e];
        }
        return n;
      }
      function Y(t, e) {
        return I(t, "border" + (e ? "Left" : "Top") + "Width") + I(t, "padding" + (e ? "Left" : "Top")) + I(t, "padding" + (e ? "Right" : "Bottom")) + I(t, "border" + (e ? "Right" : "Bottom") + "Width");
      }
      function K(t, e) {
        for (var n = 0, r = e.length; n < r; n++) if (t.indexOf(e[n]) < 0) return !1;
        return !0;
      }
      function X(t, e, n) {
        S(t[n], function (t) {
          t[0];
          var r = t[1];
          e.removeEventListener(n, r);
        }), delete t[n];
      }
      function J(t) {
        return t.__cashEvents = t.__cashEvents || {};
      }
      function Z(t) {
        var e = t.split(".");
        return [e[0], e.slice(1).sort()];
      }
      function Q(t, e, n, r) {
        var i = J(t);
        if (e) {
          var o = i[e];
          if (!o) return;
          r && (r.guid = r.guid || k++), i[e] = o.filter(function (i) {
            var o = i[0],
              a = i[1];
            if (r && a.guid !== r.guid || !K(o, n)) return !0;
            t.removeEventListener(e, a);
          });
        } else if (n && n.length) for (e in i) Q(t, e, n, r);else for (e in i) X(i, t, e);
      }
      y.hasData = function (t) {
        return "__cashData" in t;
      }, w.data = function (t, e) {
        var n = this;
        if (!t) {
          if (!this[0]) return;
          return S(this[0].attributes, function (t) {
            var e = t.name.match(W);
            e && n.data(e[1]);
          }), G(this[0]);
        }
        if (E(t)) return void 0 === e ? this[0] && G(this[0], t) : this.each(function (n, r) {
          return function (t, e, n) {
            q(t)[e] = n;
          }(r, t, e);
        });
        for (var r in t) this.data(r, t[r]);
        return this;
      }, w.removeData = function (t) {
        return this.each(function (e, n) {
          return function (t, e) {
            void 0 === e ? delete t.__cashData : delete q(t)[e];
          }(n, t);
        });
      }, S(["Width", "Height"], function (t) {
        w["inner" + t] = function () {
          if (this[0]) return this[0] === i ? i["inner" + t] : this[0]["client" + t];
        };
      }), S(["width", "height"], function (t, e) {
        w[t] = function (n) {
          return this[0] ? arguments.length ? (n = parseInt(n, 10), this.each(function (r, i) {
            if (1 === i.nodeType) {
              var o = N(i, "boxSizing");
              i.style[t] = $(t, n + ("border-box" === o ? Y(i, !e) : 0));
            }
          })) : this[0] === i ? this[0][C("outer-" + t)] : this[0].getBoundingClientRect()[t] - Y(this[0], !e) : void 0 === n ? void 0 : this;
        };
      }), S(["Width", "Height"], function (t, e) {
        w["outer" + t] = function (n) {
          if (this[0]) return this[0] === i ? i["outer" + t] : this[0]["offset" + t] + (n ? I(this[0], "margin" + (e ? "Top" : "Left")) + I(this[0], "margin" + (e ? "Bottom" : "Right")) : 0);
        };
      }), w.off = function (t, e) {
        var n = this;
        return void 0 === t ? this.each(function (t, e) {
          return Q(e);
        }) : S(L(t), function (t) {
          var r = Z(t),
            i = r[0],
            o = r[1];
          n.each(function (t, n) {
            return Q(n, i, o, e);
          });
        }), this;
      }, w.on = function (t, e, n, r) {
        var i = this;
        if (!E(t)) {
          for (var o in t) this.on(o, e, t[o]);
          return this;
        }
        return j(e) && (n = e, e = !1), S(L(t), function (t) {
          var o = Z(t),
            a = o[0],
            s = o[1];
          i.each(function (t, i) {
            var o = function t(o) {
              if (!o.namespace || K(s, o.namespace.split("."))) {
                var c = i;
                if (e) {
                  for (var l = o.target; !T(l, e);) {
                    if (l === i) return;
                    if (!(l = l.parentNode)) return;
                  }
                  c = l;
                }
                o.namespace = o.namespace || "";
                var u = n.call(c, o, o.data);
                r && Q(i, a, s, t), !1 === u && (o.preventDefault(), o.stopPropagation());
              }
            };
            o.guid = n.guid = n.guid || k++, function (t, e, n, r) {
              r.guid = r.guid || k++;
              var i = J(t);
              i[e] = i[e] || [], i[e].push([n, r]), t.addEventListener(e, r);
            }(i, a, s, o);
          });
        }), this;
      }, w.one = function (t, e, n) {
        return this.on(t, e, n, !0);
      }, w.ready = function (t) {
        var e = function e() {
          return t(y);
        };
        return "loading" !== r.readyState ? setTimeout(e) : r.addEventListener("DOMContentLoaded", e), this;
      }, w.trigger = function (t, e) {
        var n = t;
        if (E(t)) {
          var i = Z(t),
            o = i[0],
            a = i[1];
          (n = r.createEvent("HTMLEvents")).initEvent(o, !0, !0), n.namespace = a.join(".");
        }
        return n.data = e, this.each(function (t, e) {
          e.dispatchEvent(n);
        });
      };
      var tt = /select-one/i,
        et = /select-multiple/i;
      function nt(t) {
        var e = t.type;
        return tt.test(e) ? function (t) {
          return t.selectedIndex < 0 ? null : t.options[t.selectedIndex].value;
        }(t) : et.test(e) ? function (t) {
          var e = [];
          return S(t.options, function (t) {
            !t.selected || t.disabled || t.parentNode.disabled || e.push(t.value);
          }), e;
        }(t) : t.value;
      }
      var rt = /%20/g,
        it = /file|reset|submit|button|image/i,
        ot = /radio|checkbox/i;
      w.serialize = function () {
        var t = "";
        return this.each(function (e, n) {
          S(n.elements || [n], function (e) {
            if (!e.disabled && e.name && "FIELDSET" !== e.tagName && !it.test(e.type) && (!ot.test(e.type) || e.checked)) {
              var n = nt(e);
              void 0 !== n && S(A(n) ? n : [n], function (n) {
                t += function (t, e) {
                  return "&" + encodeURIComponent(t) + "=" + encodeURIComponent(e).replace(rt, "+");
                }(e.name, n);
              });
            }
          });
        }), t.substr(1);
      }, w.val = function (t) {
        return void 0 === t ? this[0] && nt(this[0]) : this.each(function (e, n) {
          var r = et.test(n.type),
            i = null === t ? r ? [] : "" : t;
          r && A(i) ? S(n.options, function (t) {
            t.selected = i.indexOf(t.value) >= 0;
          }) : n.value = i;
        });
      }, w.clone = function () {
        return this.map(function (t, e) {
          return e.cloneNode(!0);
        });
      }, w.detach = function () {
        return this.each(function (t, e) {
          e.parentNode && e.parentNode.removeChild(e);
        });
      };
      var at,
        st = /^\s*<(\w+)[^>]*>/,
        ct = /^\s*<(\w+)\s*\/?>(?:<\/\1>)?\s*$/;
      function lt(t) {
        if (function () {
          if (!at) {
            var t = r.createElement("table"),
              e = r.createElement("tr");
            at = {
              "*": r.createElement("div"),
              tr: r.createElement("tbody"),
              td: e,
              th: e,
              thead: t,
              tbody: t,
              tfoot: t
            };
          }
        }(), !E(t)) return [];
        if (ct.test(t)) return [r.createElement(RegExp.$1)];
        var e = st.test(t) && RegExp.$1,
          n = at[e] || at["*"];
        return n.innerHTML = t, y(n.childNodes).detach().get();
      }
      function ut(t, e, n) {
        if (void 0 !== e) {
          var r = E(e);
          !r && e.length ? S(e, function (e) {
            return ut(t, e, n);
          }) : S(t, r ? function (t) {
            t.insertAdjacentHTML(n ? "afterbegin" : "beforeend", e);
          } : function (t, r) {
            return function (t, e, n) {
              n ? t.insertBefore(e, t.childNodes[0]) : t.appendChild(e);
            }(t, r ? e.cloneNode(!0) : e, n);
          });
        }
      }
      y.parseHTML = lt, w.empty = function () {
        var t = this[0];
        if (t) for (; t.firstChild;) t.removeChild(t.firstChild);
        return this;
      }, w.append = function () {
        var t = this;
        return S(arguments, function (e) {
          ut(t, e);
        }), this;
      }, w.appendTo = function (t) {
        return ut(y(t), this), this;
      }, w.html = function (t) {
        if (void 0 === t) return this[0] && this[0].innerHTML;
        var e = t.nodeType ? t[0].outerHTML : t;
        return this.each(function (t, n) {
          n.innerHTML = e;
        });
      }, w.insertAfter = function (t) {
        var e = this;
        return y(t).each(function (t, n) {
          var r = n.parentNode;
          e.each(function (e, i) {
            r.insertBefore(t ? i.cloneNode(!0) : i, n.nextSibling);
          });
        }), this;
      }, w.after = function () {
        var t = this;
        return S(u.apply(arguments), function (e) {
          u.apply(y(e).slice()).insertAfter(t);
        }), this;
      }, w.insertBefore = function (t) {
        var e = this;
        return y(t).each(function (t, n) {
          var r = n.parentNode;
          e.each(function (e, i) {
            r.insertBefore(t ? i.cloneNode(!0) : i, n);
          });
        }), this;
      }, w.before = function () {
        var t = this;
        return S(arguments, function (e) {
          y(e).insertBefore(t);
        }), this;
      }, w.prepend = function () {
        var t = this;
        return S(arguments, function (e) {
          ut(t, e, !0);
        }), this;
      }, w.prependTo = function (t) {
        return ut(y(t), u.apply(this.slice()), !0), this;
      }, w.remove = function () {
        return this.detach().off();
      }, w.replaceWith = function (t) {
        var e = this;
        return this.each(function (n, r) {
          var i = r.parentNode;
          if (i) {
            var o = n ? y(t).clone() : y(t);
            if (!o[0]) return e.remove(), !1;
            i.replaceChild(o[0], r), y(o[0]).after(o.slice(1));
          }
        });
      }, w.replaceAll = function (t) {
        return y(t).replaceWith(this), this;
      }, w.text = function (t) {
        return void 0 === t ? this[0] ? this[0].textContent : "" : this.each(function (e, n) {
          n.textContent = t;
        });
      };
      var dt = r.documentElement;
      w.offset = function () {
        var t = this[0];
        if (t) {
          var e = t.getBoundingClientRect();
          return {
            top: e.top + i.pageYOffset - dt.clientTop,
            left: e.left + i.pageXOffset - dt.clientLeft
          };
        }
      }, w.offsetParent = function () {
        return y(this[0] && this[0].offsetParent);
      }, w.position = function () {
        var t = this[0];
        if (t) return {
          left: t.offsetLeft,
          top: t.offsetTop
        };
      }, w.children = function (t) {
        var e = [];
        return this.each(function (t, n) {
          l.apply(e, n.children);
        }), e = y(_(e)), t ? e.filter(function (e, n) {
          return T(n, t);
        }) : e;
      }, w.contents = function () {
        var t = [];
        return this.each(function (e, n) {
          l.apply(t, "IFRAME" === n.tagName ? [n.contentDocument] : n.childNodes);
        }), y(t.length && _(t));
      }, w.find = function (t) {
        for (var e = [], n = 0, r = this.length; n < r; n++) {
          var i = m(t, this[n]);
          i.length && l.apply(e, i);
        }
        return y(e.length && _(e));
      }, w.has = function (t) {
        var e = E(t) ? function (e, n) {
          return !!m(t, n).length;
        } : function (e, n) {
          return n.contains(t);
        };
        return this.filter(e);
      }, w.is = function (t) {
        if (!t || !this[0]) return !1;
        var e = M(t),
          n = !1;
        return this.each(function (r, i) {
          return !(n = e(r, i, t));
        }), n;
      }, w.next = function () {
        return y(this[0] && this[0].nextElementSibling);
      }, w.not = function (t) {
        if (!t || !this[0]) return this;
        var e = M(t);
        return this.filter(function (n, r) {
          return !e(n, r, t);
        });
      }, w.parent = function () {
        var t = [];
        return this.each(function (e, n) {
          n && n.parentNode && t.push(n.parentNode);
        }), y(_(t));
      }, w.index = function (t) {
        var e = t ? y(t)[0] : this[0],
          n = t ? this : y(e).parent().children();
        return s.call(n, e);
      }, w.closest = function (t) {
        return t && this[0] ? this.is(t) ? this.filter(t) : this.parent().closest(t) : y();
      }, w.parents = function (t) {
        var e,
          n = [];
        return this.each(function (i, o) {
          for (e = o; e && e.parentNode && e !== r.body.parentNode;) e = e.parentNode, (!t || t && T(e, t)) && n.push(e);
        }), y(_(n));
      }, w.prev = function () {
        return y(this[0] && this[0].previousElementSibling);
      }, w.siblings = function () {
        var t = this[0];
        return this.parent().children().filter(function (e, n) {
          return n !== t;
        });
      }, e.default = y;
    }, function (t, e, n) {
      "use strict";

      var r = n(0),
        i = n(1),
        o = n.n(i),
        a = n(10);
      e.a = o.a.Collection.extend({
        model: a.a,
        modelId: function modelId(t) {
          return "".concat(t.name, "_").concat(t.type || a.a.TYPE_CLASS);
        },
        getStyleable: function getStyleable() {
          return Object(r.filter)(this.models, function (t) {
            return t.get("active") && !t.get("private");
          });
        },
        getValid: function getValid() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.noDisabled;
          return Object(r.filter)(this.models, function (t) {
            return !t.get("private");
          }).filter(function (t) {
            return e ? t.get("active") : 1;
          });
        },
        getFullString: function getFullString(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = [],
            r = t || this;
          return r.forEach(function (t) {
            return n.push(t.getFullName(e));
          }), n.join("").trim();
        }
      });
    }, function (t, e, n) {
      t.exports = function () {
        "use strict";

        var t = navigator.userAgent,
          e = navigator.platform,
          n = /gecko\/\d/i.test(t),
          r = /MSIE \d/.test(t),
          i = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(t),
          o = /Edge\/(\d+)/.exec(t),
          a = r || i || o,
          s = a && (r ? document.documentMode || 6 : +(o || i)[1]),
          c = !o && /WebKit\//.test(t),
          l = c && /Qt\/\d+\.\d+/.test(t),
          u = !o && /Chrome\/(\d+)/.exec(t),
          d = u && +u[1],
          h = /Opera\//.test(t),
          f = /Apple Computer/.test(navigator.vendor),
          p = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(t),
          g = /PhantomJS/.test(t),
          v = f && (/Mobile\/\w+/.test(t) || navigator.maxTouchPoints > 2),
          m = /Android/.test(t),
          b = v || m || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(t),
          y = v || /Mac/.test(e),
          w = /\bCrOS\b/.test(t),
          x = /win/i.test(e),
          O = h && t.match(/Version\/(\d*\.\d*)/);
        O && (O = Number(O[1])), O && O >= 15 && (h = !1, c = !0);
        var C = y && (l || h && (null == O || O < 12.11)),
          S = n || a && s >= 9;
        function k(t) {
          return new RegExp("(^|\\s)" + t + "(?:$|\\s)\\s*");
        }
        var T,
          j = function j(t, e) {
            var n = t.className,
              r = k(e).exec(n);
            if (r) {
              var i = n.slice(r.index + r[0].length);
              t.className = n.slice(0, r.index) + (i ? r[1] + i : "");
            }
          };
        function E(t) {
          for (var e = t.childNodes.length; e > 0; --e) t.removeChild(t.firstChild);
          return t;
        }
        function P(t, e) {
          return E(t).appendChild(e);
        }
        function A(t, e, n, r) {
          var i = document.createElement(t);
          if (n && (i.className = n), r && (i.style.cssText = r), "string" == typeof e) i.appendChild(document.createTextNode(e));else if (e) for (var o = 0; o < e.length; ++o) i.appendChild(e[o]);
          return i;
        }
        function M(t, e, n, r) {
          var i = A(t, e, n, r);
          return i.setAttribute("role", "presentation"), i;
        }
        function D(t, e) {
          if (3 == e.nodeType && (e = e.parentNode), t.contains) return t.contains(e);
          do {
            if (11 == e.nodeType && (e = e.host), e == t) return !0;
          } while (e = e.parentNode);
        }
        function L(t) {
          var e,
            n = t.ownerDocument || t;
          try {
            e = t.activeElement;
          } catch (t) {
            e = n.body || null;
          }
          for (; e && e.shadowRoot && e.shadowRoot.activeElement;) e = e.shadowRoot.activeElement;
          return e;
        }
        function _(t, e) {
          var n = t.className;
          k(e).test(n) || (t.className += (n ? " " : "") + e);
        }
        function N(t, e) {
          for (var n = t.split(" "), r = 0; r < n.length; r++) n[r] && !k(n[r]).test(e) && (e += " " + n[r]);
          return e;
        }
        T = document.createRange ? function (t, e, n, r) {
          var i = document.createRange();
          return i.setEnd(r || t, n), i.setStart(t, e), i;
        } : function (t, e, n) {
          var r = document.body.createTextRange();
          try {
            r.moveToElementText(t.parentNode);
          } catch (t) {
            return r;
          }
          return r.collapse(!0), r.moveEnd("character", n), r.moveStart("character", e), r;
        };
        var I = function I(t) {
          t.select();
        };
        function R(t) {
          return t.display.wrapper.ownerDocument;
        }
        function F(t) {
          return V(t.display.wrapper);
        }
        function V(t) {
          return t.getRootNode ? t.getRootNode() : t.ownerDocument;
        }
        function z(t) {
          return R(t).defaultView;
        }
        function H(t) {
          var e = Array.prototype.slice.call(arguments, 1);
          return function () {
            return t.apply(null, e);
          };
        }
        function B(t, e, n) {
          for (var r in e || (e = {}), t) !t.hasOwnProperty(r) || !1 === n && e.hasOwnProperty(r) || (e[r] = t[r]);
          return e;
        }
        function U(t, e, n, r, i) {
          null == e && -1 == (e = t.search(/[^\s\u00a0]/)) && (e = t.length);
          for (var o = r || 0, a = i || 0;;) {
            var s = t.indexOf("\t", o);
            if (s < 0 || s >= e) return a + (e - o);
            a += s - o, a += n - a % n, o = s + 1;
          }
        }
        v ? I = function I(t) {
          t.selectionStart = 0, t.selectionEnd = t.value.length;
        } : a && (I = function I(t) {
          try {
            t.select();
          } catch (t) {}
        });
        var $ = function $() {
          this.id = null, this.f = null, this.time = 0, this.handler = H(this.onTimeout, this);
        };
        function W(t, e) {
          for (var n = 0; n < t.length; ++n) if (t[n] == e) return n;
          return -1;
        }
        $.prototype.onTimeout = function (t) {
          t.id = 0, t.time <= +new Date() ? t.f() : setTimeout(t.handler, t.time - +new Date());
        }, $.prototype.set = function (t, e) {
          this.f = e;
          var n = +new Date() + t;
          (!this.id || n < this.time) && (clearTimeout(this.id), this.id = setTimeout(this.handler, t), this.time = n);
        };
        var q = {
            toString: function toString() {
              return "CodeMirror.Pass";
            }
          },
          G = {
            scroll: !1
          },
          Y = {
            origin: "*mouse"
          },
          K = {
            origin: "+move"
          };
        function X(t, e, n) {
          for (var r = 0, i = 0;;) {
            var o = t.indexOf("\t", r);
            -1 == o && (o = t.length);
            var a = o - r;
            if (o == t.length || i + a >= e) return r + Math.min(a, e - i);
            if (i += o - r, r = o + 1, (i += n - i % n) >= e) return r;
          }
        }
        var J = [""];
        function Z(t) {
          for (; J.length <= t;) J.push(Q(J) + " ");
          return J[t];
        }
        function Q(t) {
          return t[t.length - 1];
        }
        function tt(t, e) {
          for (var n = [], r = 0; r < t.length; r++) n[r] = e(t[r], r);
          return n;
        }
        function et() {}
        function nt(t, e) {
          var n;
          return Object.create ? n = Object.create(t) : (et.prototype = t, n = new et()), e && B(e, n), n;
        }
        var rt = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
        function it(t) {
          return /\w/.test(t) || t > "" && (t.toUpperCase() != t.toLowerCase() || rt.test(t));
        }
        function ot(t, e) {
          return e ? !!(e.source.indexOf("\\w") > -1 && it(t)) || e.test(t) : it(t);
        }
        function at(t) {
          for (var e in t) if (t.hasOwnProperty(e) && t[e]) return !1;
          return !0;
        }
        var st = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
        function ct(t) {
          return t.charCodeAt(0) >= 768 && st.test(t);
        }
        function lt(t, e, n) {
          for (; (n < 0 ? e > 0 : e < t.length) && ct(t.charAt(e));) e += n;
          return e;
        }
        function ut(t, e, n) {
          for (var r = e > n ? -1 : 1;;) {
            if (e == n) return e;
            var i = (e + n) / 2,
              o = r < 0 ? Math.ceil(i) : Math.floor(i);
            if (o == e) return t(o) ? e : n;
            t(o) ? n = o : e = o + r;
          }
        }
        var dt = null;
        function ht(t, e, n) {
          var r;
          dt = null;
          for (var i = 0; i < t.length; ++i) {
            var o = t[i];
            if (o.from < e && o.to > e) return i;
            o.to == e && (o.from != o.to && "before" == n ? r = i : dt = i), o.from == e && (o.from != o.to && "before" != n ? r = i : dt = i);
          }
          return null != r ? r : dt;
        }
        var ft = function () {
          var t = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/,
            e = /[stwN]/,
            n = /[LRr]/,
            r = /[Lb1n]/,
            i = /[1n]/;
          function o(t, e, n) {
            this.level = t, this.from = e, this.to = n;
          }
          return function (a, s) {
            var c = "ltr" == s ? "L" : "R";
            if (0 == a.length || "ltr" == s && !t.test(a)) return !1;
            for (var l, u = a.length, d = [], h = 0; h < u; ++h) d.push((l = a.charCodeAt(h)) <= 247 ? "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN".charAt(l) : 1424 <= l && l <= 1524 ? "R" : 1536 <= l && l <= 1785 ? "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111".charAt(l - 1536) : 1774 <= l && l <= 2220 ? "r" : 8192 <= l && l <= 8203 ? "w" : 8204 == l ? "b" : "L");
            for (var f = 0, p = c; f < u; ++f) {
              var g = d[f];
              "m" == g ? d[f] = p : p = g;
            }
            for (var v = 0, m = c; v < u; ++v) {
              var b = d[v];
              "1" == b && "r" == m ? d[v] = "n" : n.test(b) && (m = b, "r" == b && (d[v] = "R"));
            }
            for (var y = 1, w = d[0]; y < u - 1; ++y) {
              var x = d[y];
              "+" == x && "1" == w && "1" == d[y + 1] ? d[y] = "1" : "," != x || w != d[y + 1] || "1" != w && "n" != w || (d[y] = w), w = x;
            }
            for (var O = 0; O < u; ++O) {
              var C = d[O];
              if ("," == C) d[O] = "N";else if ("%" == C) {
                var S = void 0;
                for (S = O + 1; S < u && "%" == d[S]; ++S);
                for (var k = O && "!" == d[O - 1] || S < u && "1" == d[S] ? "1" : "N", T = O; T < S; ++T) d[T] = k;
                O = S - 1;
              }
            }
            for (var j = 0, E = c; j < u; ++j) {
              var P = d[j];
              "L" == E && "1" == P ? d[j] = "L" : n.test(P) && (E = P);
            }
            for (var A = 0; A < u; ++A) if (e.test(d[A])) {
              var M = void 0;
              for (M = A + 1; M < u && e.test(d[M]); ++M);
              for (var D = "L" == (A ? d[A - 1] : c), L = D == ("L" == (M < u ? d[M] : c)) ? D ? "L" : "R" : c, _ = A; _ < M; ++_) d[_] = L;
              A = M - 1;
            }
            for (var N, I = [], R = 0; R < u;) if (r.test(d[R])) {
              var F = R;
              for (++R; R < u && r.test(d[R]); ++R);
              I.push(new o(0, F, R));
            } else {
              var V = R,
                z = I.length,
                H = "rtl" == s ? 1 : 0;
              for (++R; R < u && "L" != d[R]; ++R);
              for (var B = V; B < R;) if (i.test(d[B])) {
                V < B && (I.splice(z, 0, new o(1, V, B)), z += H);
                var U = B;
                for (++B; B < R && i.test(d[B]); ++B);
                I.splice(z, 0, new o(2, U, B)), z += H, V = B;
              } else ++B;
              V < R && I.splice(z, 0, new o(1, V, R));
            }
            return "ltr" == s && (1 == I[0].level && (N = a.match(/^\s+/)) && (I[0].from = N[0].length, I.unshift(new o(0, 0, N[0].length))), 1 == Q(I).level && (N = a.match(/\s+$/)) && (Q(I).to -= N[0].length, I.push(new o(0, u - N[0].length, u)))), "rtl" == s ? I.reverse() : I;
          };
        }();
        function pt(t, e) {
          var n = t.order;
          return null == n && (n = t.order = ft(t.text, e)), n;
        }
        var gt = [],
          vt = function vt(t, e, n) {
            if (t.addEventListener) t.addEventListener(e, n, !1);else if (t.attachEvent) t.attachEvent("on" + e, n);else {
              var r = t._handlers || (t._handlers = {});
              r[e] = (r[e] || gt).concat(n);
            }
          };
        function mt(t, e) {
          return t._handlers && t._handlers[e] || gt;
        }
        function bt(t, e, n) {
          if (t.removeEventListener) t.removeEventListener(e, n, !1);else if (t.detachEvent) t.detachEvent("on" + e, n);else {
            var r = t._handlers,
              i = r && r[e];
            if (i) {
              var o = W(i, n);
              o > -1 && (r[e] = i.slice(0, o).concat(i.slice(o + 1)));
            }
          }
        }
        function yt(t, e) {
          var n = mt(t, e);
          if (n.length) for (var r = Array.prototype.slice.call(arguments, 2), i = 0; i < n.length; ++i) n[i].apply(null, r);
        }
        function wt(t, e, n) {
          return "string" == typeof e && (e = {
            type: e,
            preventDefault: function preventDefault() {
              this.defaultPrevented = !0;
            }
          }), yt(t, n || e.type, t, e), Tt(e) || e.codemirrorIgnore;
        }
        function xt(t) {
          var e = t._handlers && t._handlers.cursorActivity;
          if (e) for (var n = t.curOp.cursorActivityHandlers || (t.curOp.cursorActivityHandlers = []), r = 0; r < e.length; ++r) -1 == W(n, e[r]) && n.push(e[r]);
        }
        function Ot(t, e) {
          return mt(t, e).length > 0;
        }
        function Ct(t) {
          t.prototype.on = function (t, e) {
            vt(this, t, e);
          }, t.prototype.off = function (t, e) {
            bt(this, t, e);
          };
        }
        function St(t) {
          t.preventDefault ? t.preventDefault() : t.returnValue = !1;
        }
        function kt(t) {
          t.stopPropagation ? t.stopPropagation() : t.cancelBubble = !0;
        }
        function Tt(t) {
          return null != t.defaultPrevented ? t.defaultPrevented : 0 == t.returnValue;
        }
        function jt(t) {
          St(t), kt(t);
        }
        function Et(t) {
          return t.target || t.srcElement;
        }
        function Pt(t) {
          var e = t.which;
          return null == e && (1 & t.button ? e = 1 : 2 & t.button ? e = 3 : 4 & t.button && (e = 2)), y && t.ctrlKey && 1 == e && (e = 3), e;
        }
        var At,
          Mt,
          Dt = function () {
            if (a && s < 9) return !1;
            var t = A("div");
            return "draggable" in t || "dragDrop" in t;
          }();
        function Lt(t) {
          if (null == At) {
            var e = A("span", "​");
            P(t, A("span", [e, document.createTextNode("x")])), 0 != t.firstChild.offsetHeight && (At = e.offsetWidth <= 1 && e.offsetHeight > 2 && !(a && s < 8));
          }
          var n = At ? A("span", "​") : A("span", " ", null, "display: inline-block; width: 1px; margin-right: -1px");
          return n.setAttribute("cm-text", ""), n;
        }
        function _t(t) {
          if (null != Mt) return Mt;
          var e = P(t, document.createTextNode("AخA")),
            n = T(e, 0, 1).getBoundingClientRect(),
            r = T(e, 1, 2).getBoundingClientRect();
          return E(t), !(!n || n.left == n.right) && (Mt = r.right - n.right < 3);
        }
        var Nt,
          It = 3 != "\n\nb".split(/\n/).length ? function (t) {
            for (var e = 0, n = [], r = t.length; e <= r;) {
              var i = t.indexOf("\n", e);
              -1 == i && (i = t.length);
              var o = t.slice(e, "\r" == t.charAt(i - 1) ? i - 1 : i),
                a = o.indexOf("\r");
              -1 != a ? (n.push(o.slice(0, a)), e += a + 1) : (n.push(o), e = i + 1);
            }
            return n;
          } : function (t) {
            return t.split(/\r\n?|\n/);
          },
          Rt = window.getSelection ? function (t) {
            try {
              return t.selectionStart != t.selectionEnd;
            } catch (t) {
              return !1;
            }
          } : function (t) {
            var e;
            try {
              e = t.ownerDocument.selection.createRange();
            } catch (t) {}
            return !(!e || e.parentElement() != t) && 0 != e.compareEndPoints("StartToEnd", e);
          },
          Ft = "oncopy" in (Nt = A("div")) || (Nt.setAttribute("oncopy", "return;"), "function" == typeof Nt.oncopy),
          Vt = null,
          zt = {},
          Ht = {};
        function Bt(t, e) {
          arguments.length > 2 && (e.dependencies = Array.prototype.slice.call(arguments, 2)), zt[t] = e;
        }
        function Ut(t) {
          if ("string" == typeof t && Ht.hasOwnProperty(t)) t = Ht[t];else if (t && "string" == typeof t.name && Ht.hasOwnProperty(t.name)) {
            var e = Ht[t.name];
            "string" == typeof e && (e = {
              name: e
            }), (t = nt(e, t)).name = e.name;
          } else {
            if ("string" == typeof t && /^[\w\-]+\/[\w\-]+\+xml$/.test(t)) return Ut("application/xml");
            if ("string" == typeof t && /^[\w\-]+\/[\w\-]+\+json$/.test(t)) return Ut("application/json");
          }
          return "string" == typeof t ? {
            name: t
          } : t || {
            name: "null"
          };
        }
        function $t(t, e) {
          e = Ut(e);
          var n = zt[e.name];
          if (!n) return $t(t, "text/plain");
          var r = n(t, e);
          if (Wt.hasOwnProperty(e.name)) {
            var i = Wt[e.name];
            for (var o in i) i.hasOwnProperty(o) && (r.hasOwnProperty(o) && (r["_" + o] = r[o]), r[o] = i[o]);
          }
          if (r.name = e.name, e.helperType && (r.helperType = e.helperType), e.modeProps) for (var a in e.modeProps) r[a] = e.modeProps[a];
          return r;
        }
        var Wt = {};
        function qt(t, e) {
          B(e, Wt.hasOwnProperty(t) ? Wt[t] : Wt[t] = {});
        }
        function Gt(t, e) {
          if (!0 === e) return e;
          if (t.copyState) return t.copyState(e);
          var n = {};
          for (var r in e) {
            var i = e[r];
            i instanceof Array && (i = i.concat([])), n[r] = i;
          }
          return n;
        }
        function Yt(t, e) {
          for (var n; t.innerMode && (n = t.innerMode(e)) && n.mode != t;) e = n.state, t = n.mode;
          return n || {
            mode: t,
            state: e
          };
        }
        function Kt(t, e, n) {
          return !t.startState || t.startState(e, n);
        }
        var Xt = function Xt(t, e, n) {
          this.pos = this.start = 0, this.string = t, this.tabSize = e || 8, this.lastColumnPos = this.lastColumnValue = 0, this.lineStart = 0, this.lineOracle = n;
        };
        function Jt(t, e) {
          if ((e -= t.first) < 0 || e >= t.size) throw new Error("There is no line " + (e + t.first) + " in the document.");
          for (var n = t; !n.lines;) for (var r = 0;; ++r) {
            var i = n.children[r],
              o = i.chunkSize();
            if (e < o) {
              n = i;
              break;
            }
            e -= o;
          }
          return n.lines[e];
        }
        function Zt(t, e, n) {
          var r = [],
            i = e.line;
          return t.iter(e.line, n.line + 1, function (t) {
            var o = t.text;
            i == n.line && (o = o.slice(0, n.ch)), i == e.line && (o = o.slice(e.ch)), r.push(o), ++i;
          }), r;
        }
        function Qt(t, e, n) {
          var r = [];
          return t.iter(e, n, function (t) {
            r.push(t.text);
          }), r;
        }
        function te(t, e) {
          var n = e - t.height;
          if (n) for (var r = t; r; r = r.parent) r.height += n;
        }
        function ee(t) {
          if (null == t.parent) return null;
          for (var e = t.parent, n = W(e.lines, t), r = e.parent; r; e = r, r = r.parent) for (var i = 0; r.children[i] != e; ++i) n += r.children[i].chunkSize();
          return n + e.first;
        }
        function ne(t, e) {
          var n = t.first;
          t: do {
            for (var r = 0; r < t.children.length; ++r) {
              var i = t.children[r],
                o = i.height;
              if (e < o) {
                t = i;
                continue t;
              }
              e -= o, n += i.chunkSize();
            }
            return n;
          } while (!t.lines);
          for (var a = 0; a < t.lines.length; ++a) {
            var s = t.lines[a].height;
            if (e < s) break;
            e -= s;
          }
          return n + a;
        }
        function re(t, e) {
          return e >= t.first && e < t.first + t.size;
        }
        function ie(t, e) {
          return String(t.lineNumberFormatter(e + t.firstLineNumber));
        }
        function oe(t, e, n) {
          if (void 0 === n && (n = null), !(this instanceof oe)) return new oe(t, e, n);
          this.line = t, this.ch = e, this.sticky = n;
        }
        function ae(t, e) {
          return t.line - e.line || t.ch - e.ch;
        }
        function se(t, e) {
          return t.sticky == e.sticky && 0 == ae(t, e);
        }
        function ce(t) {
          return oe(t.line, t.ch);
        }
        function le(t, e) {
          return ae(t, e) < 0 ? e : t;
        }
        function ue(t, e) {
          return ae(t, e) < 0 ? t : e;
        }
        function de(t, e) {
          return Math.max(t.first, Math.min(e, t.first + t.size - 1));
        }
        function he(t, e) {
          if (e.line < t.first) return oe(t.first, 0);
          var n = t.first + t.size - 1;
          return e.line > n ? oe(n, Jt(t, n).text.length) : function (t, e) {
            var n = t.ch;
            return null == n || n > e ? oe(t.line, e) : n < 0 ? oe(t.line, 0) : t;
          }(e, Jt(t, e.line).text.length);
        }
        function fe(t, e) {
          for (var n = [], r = 0; r < e.length; r++) n[r] = he(t, e[r]);
          return n;
        }
        Xt.prototype.eol = function () {
          return this.pos >= this.string.length;
        }, Xt.prototype.sol = function () {
          return this.pos == this.lineStart;
        }, Xt.prototype.peek = function () {
          return this.string.charAt(this.pos) || void 0;
        }, Xt.prototype.next = function () {
          if (this.pos < this.string.length) return this.string.charAt(this.pos++);
        }, Xt.prototype.eat = function (t) {
          var e = this.string.charAt(this.pos);
          if ("string" == typeof t ? e == t : e && (t.test ? t.test(e) : t(e))) return ++this.pos, e;
        }, Xt.prototype.eatWhile = function (t) {
          for (var e = this.pos; this.eat(t););
          return this.pos > e;
        }, Xt.prototype.eatSpace = function () {
          for (var t = this.pos; /[\s\u00a0]/.test(this.string.charAt(this.pos));) ++this.pos;
          return this.pos > t;
        }, Xt.prototype.skipToEnd = function () {
          this.pos = this.string.length;
        }, Xt.prototype.skipTo = function (t) {
          var e = this.string.indexOf(t, this.pos);
          if (e > -1) return this.pos = e, !0;
        }, Xt.prototype.backUp = function (t) {
          this.pos -= t;
        }, Xt.prototype.column = function () {
          return this.lastColumnPos < this.start && (this.lastColumnValue = U(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue - (this.lineStart ? U(this.string, this.lineStart, this.tabSize) : 0);
        }, Xt.prototype.indentation = function () {
          return U(this.string, null, this.tabSize) - (this.lineStart ? U(this.string, this.lineStart, this.tabSize) : 0);
        }, Xt.prototype.match = function (t, e, n) {
          if ("string" != typeof t) {
            var r = this.string.slice(this.pos).match(t);
            return r && r.index > 0 ? null : (r && !1 !== e && (this.pos += r[0].length), r);
          }
          var i = function i(t) {
            return n ? t.toLowerCase() : t;
          };
          if (i(this.string.substr(this.pos, t.length)) == i(t)) return !1 !== e && (this.pos += t.length), !0;
        }, Xt.prototype.current = function () {
          return this.string.slice(this.start, this.pos);
        }, Xt.prototype.hideFirstChars = function (t, e) {
          this.lineStart += t;
          try {
            return e();
          } finally {
            this.lineStart -= t;
          }
        }, Xt.prototype.lookAhead = function (t) {
          var e = this.lineOracle;
          return e && e.lookAhead(t);
        }, Xt.prototype.baseToken = function () {
          var t = this.lineOracle;
          return t && t.baseToken(this.pos);
        };
        var pe = function pe(t, e) {
            this.state = t, this.lookAhead = e;
          },
          ge = function ge(t, e, n, r) {
            this.state = e, this.doc = t, this.line = n, this.maxLookAhead = r || 0, this.baseTokens = null, this.baseTokenPos = 1;
          };
        function ve(t, e, n, r) {
          var i = [t.state.modeGen],
            o = {};
          ke(t, e.text, t.doc.mode, n, function (t, e) {
            return i.push(t, e);
          }, o, r);
          for (var a = n.state, s = function s(r) {
              n.baseTokens = i;
              var s = t.state.overlays[r],
                c = 1,
                l = 0;
              n.state = !0, ke(t, e.text, s.mode, n, function (t, e) {
                for (var n = c; l < t;) {
                  var r = i[c];
                  r > t && i.splice(c, 1, t, i[c + 1], r), c += 2, l = Math.min(t, r);
                }
                if (e) if (s.opaque) i.splice(n, c - n, t, "overlay " + e), c = n + 2;else for (; n < c; n += 2) {
                  var o = i[n + 1];
                  i[n + 1] = (o ? o + " " : "") + "overlay " + e;
                }
              }, o), n.state = a, n.baseTokens = null, n.baseTokenPos = 1;
            }, c = 0; c < t.state.overlays.length; ++c) s(c);
          return {
            styles: i,
            classes: o.bgClass || o.textClass ? o : null
          };
        }
        function me(t, e, n) {
          if (!e.styles || e.styles[0] != t.state.modeGen) {
            var r = be(t, ee(e)),
              i = e.text.length > t.options.maxHighlightLength && Gt(t.doc.mode, r.state),
              o = ve(t, e, r);
            i && (r.state = i), e.stateAfter = r.save(!i), e.styles = o.styles, o.classes ? e.styleClasses = o.classes : e.styleClasses && (e.styleClasses = null), n === t.doc.highlightFrontier && (t.doc.modeFrontier = Math.max(t.doc.modeFrontier, ++t.doc.highlightFrontier));
          }
          return e.styles;
        }
        function be(t, e, n) {
          var r = t.doc,
            i = t.display;
          if (!r.mode.startState) return new ge(r, !0, e);
          var o = function (t, e, n) {
              for (var r, i, o = t.doc, a = n ? -1 : e - (t.doc.mode.innerMode ? 1e3 : 100), s = e; s > a; --s) {
                if (s <= o.first) return o.first;
                var c = Jt(o, s - 1),
                  l = c.stateAfter;
                if (l && (!n || s + (l instanceof pe ? l.lookAhead : 0) <= o.modeFrontier)) return s;
                var u = U(c.text, null, t.options.tabSize);
                (null == i || r > u) && (i = s - 1, r = u);
              }
              return i;
            }(t, e, n),
            a = o > r.first && Jt(r, o - 1).stateAfter,
            s = a ? ge.fromSaved(r, a, o) : new ge(r, Kt(r.mode), o);
          return r.iter(o, e, function (n) {
            ye(t, n.text, s);
            var r = s.line;
            n.stateAfter = r == e - 1 || r % 5 == 0 || r >= i.viewFrom && r < i.viewTo ? s.save() : null, s.nextLine();
          }), n && (r.modeFrontier = s.line), s;
        }
        function ye(t, e, n, r) {
          var i = t.doc.mode,
            o = new Xt(e, t.options.tabSize, n);
          for (o.start = o.pos = r || 0, "" == e && we(i, n.state); !o.eol();) xe(i, o, n.state), o.start = o.pos;
        }
        function we(t, e) {
          if (t.blankLine) return t.blankLine(e);
          if (t.innerMode) {
            var n = Yt(t, e);
            return n.mode.blankLine ? n.mode.blankLine(n.state) : void 0;
          }
        }
        function xe(t, e, n, r) {
          for (var i = 0; i < 10; i++) {
            r && (r[0] = Yt(t, n).mode);
            var o = t.token(e, n);
            if (e.pos > e.start) return o;
          }
          throw new Error("Mode " + t.name + " failed to advance stream.");
        }
        ge.prototype.lookAhead = function (t) {
          var e = this.doc.getLine(this.line + t);
          return null != e && t > this.maxLookAhead && (this.maxLookAhead = t), e;
        }, ge.prototype.baseToken = function (t) {
          if (!this.baseTokens) return null;
          for (; this.baseTokens[this.baseTokenPos] <= t;) this.baseTokenPos += 2;
          var e = this.baseTokens[this.baseTokenPos + 1];
          return {
            type: e && e.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - t
          };
        }, ge.prototype.nextLine = function () {
          this.line++, this.maxLookAhead > 0 && this.maxLookAhead--;
        }, ge.fromSaved = function (t, e, n) {
          return e instanceof pe ? new ge(t, Gt(t.mode, e.state), n, e.lookAhead) : new ge(t, Gt(t.mode, e), n);
        }, ge.prototype.save = function (t) {
          var e = !1 !== t ? Gt(this.doc.mode, this.state) : this.state;
          return this.maxLookAhead > 0 ? new pe(e, this.maxLookAhead) : e;
        };
        var Oe = function Oe(t, e, n) {
          this.start = t.start, this.end = t.pos, this.string = t.current(), this.type = e || null, this.state = n;
        };
        function Ce(t, e, n, r) {
          var i,
            o,
            a = t.doc,
            s = a.mode,
            c = Jt(a, (e = he(a, e)).line),
            l = be(t, e.line, n),
            u = new Xt(c.text, t.options.tabSize, l);
          for (r && (o = []); (r || u.pos < e.ch) && !u.eol();) u.start = u.pos, i = xe(s, u, l.state), r && o.push(new Oe(u, i, Gt(a.mode, l.state)));
          return r ? o : new Oe(u, i, l.state);
        }
        function Se(t, e) {
          if (t) for (;;) {
            var n = t.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!n) break;
            t = t.slice(0, n.index) + t.slice(n.index + n[0].length);
            var r = n[1] ? "bgClass" : "textClass";
            null == e[r] ? e[r] = n[2] : new RegExp("(?:^|\\s)" + n[2] + "(?:$|\\s)").test(e[r]) || (e[r] += " " + n[2]);
          }
          return t;
        }
        function ke(t, e, n, r, i, o, a) {
          var s = n.flattenSpans;
          null == s && (s = t.options.flattenSpans);
          var c,
            l = 0,
            u = null,
            d = new Xt(e, t.options.tabSize, r),
            h = t.options.addModeClass && [null];
          for ("" == e && Se(we(n, r.state), o); !d.eol();) {
            if (d.pos > t.options.maxHighlightLength ? (s = !1, a && ye(t, e, r, d.pos), d.pos = e.length, c = null) : c = Se(xe(n, d, r.state, h), o), h) {
              var f = h[0].name;
              f && (c = "m-" + (c ? f + " " + c : f));
            }
            if (!s || u != c) {
              for (; l < d.start;) i(l = Math.min(d.start, l + 5e3), u);
              u = c;
            }
            d.start = d.pos;
          }
          for (; l < d.pos;) {
            var p = Math.min(d.pos, l + 5e3);
            i(p, u), l = p;
          }
        }
        var Te = !1,
          je = !1;
        function Ee(t, e, n) {
          this.marker = t, this.from = e, this.to = n;
        }
        function Pe(t, e) {
          if (t) for (var n = 0; n < t.length; ++n) {
            var r = t[n];
            if (r.marker == e) return r;
          }
        }
        function Ae(t, e) {
          for (var n, r = 0; r < t.length; ++r) t[r] != e && (n || (n = [])).push(t[r]);
          return n;
        }
        function Me(t, e) {
          if (e.full) return null;
          var n = re(t, e.from.line) && Jt(t, e.from.line).markedSpans,
            r = re(t, e.to.line) && Jt(t, e.to.line).markedSpans;
          if (!n && !r) return null;
          var i = e.from.ch,
            o = e.to.ch,
            a = 0 == ae(e.from, e.to),
            s = function (t, e, n) {
              var r;
              if (t) for (var i = 0; i < t.length; ++i) {
                var o = t[i],
                  a = o.marker;
                if (null == o.from || (a.inclusiveLeft ? o.from <= e : o.from < e) || o.from == e && "bookmark" == a.type && (!n || !o.marker.insertLeft)) {
                  var s = null == o.to || (a.inclusiveRight ? o.to >= e : o.to > e);
                  (r || (r = [])).push(new Ee(a, o.from, s ? null : o.to));
                }
              }
              return r;
            }(n, i, a),
            c = function (t, e, n) {
              var r;
              if (t) for (var i = 0; i < t.length; ++i) {
                var o = t[i],
                  a = o.marker;
                if (null == o.to || (a.inclusiveRight ? o.to >= e : o.to > e) || o.from == e && "bookmark" == a.type && (!n || o.marker.insertLeft)) {
                  var s = null == o.from || (a.inclusiveLeft ? o.from <= e : o.from < e);
                  (r || (r = [])).push(new Ee(a, s ? null : o.from - e, null == o.to ? null : o.to - e));
                }
              }
              return r;
            }(r, o, a),
            l = 1 == e.text.length,
            u = Q(e.text).length + (l ? i : 0);
          if (s) for (var d = 0; d < s.length; ++d) {
            var h = s[d];
            if (null == h.to) {
              var f = Pe(c, h.marker);
              f ? l && (h.to = null == f.to ? null : f.to + u) : h.to = i;
            }
          }
          if (c) for (var p = 0; p < c.length; ++p) {
            var g = c[p];
            null != g.to && (g.to += u), null == g.from ? Pe(s, g.marker) || (g.from = u, l && (s || (s = [])).push(g)) : (g.from += u, l && (s || (s = [])).push(g));
          }
          s && (s = De(s)), c && c != s && (c = De(c));
          var v = [s];
          if (!l) {
            var m,
              b = e.text.length - 2;
            if (b > 0 && s) for (var y = 0; y < s.length; ++y) null == s[y].to && (m || (m = [])).push(new Ee(s[y].marker, null, null));
            for (var w = 0; w < b; ++w) v.push(m);
            v.push(c);
          }
          return v;
        }
        function De(t) {
          for (var e = 0; e < t.length; ++e) {
            var n = t[e];
            null != n.from && n.from == n.to && !1 !== n.marker.clearWhenEmpty && t.splice(e--, 1);
          }
          return t.length ? t : null;
        }
        function Le(t) {
          var e = t.markedSpans;
          if (e) {
            for (var n = 0; n < e.length; ++n) e[n].marker.detachLine(t);
            t.markedSpans = null;
          }
        }
        function _e(t, e) {
          if (e) {
            for (var n = 0; n < e.length; ++n) e[n].marker.attachLine(t);
            t.markedSpans = e;
          }
        }
        function Ne(t) {
          return t.inclusiveLeft ? -1 : 0;
        }
        function Ie(t) {
          return t.inclusiveRight ? 1 : 0;
        }
        function Re(t, e) {
          var n = t.lines.length - e.lines.length;
          if (0 != n) return n;
          var r = t.find(),
            i = e.find(),
            o = ae(r.from, i.from) || Ne(t) - Ne(e);
          return o ? -o : ae(r.to, i.to) || Ie(t) - Ie(e) || e.id - t.id;
        }
        function Fe(t, e) {
          var n,
            r = je && t.markedSpans;
          if (r) for (var i = void 0, o = 0; o < r.length; ++o) (i = r[o]).marker.collapsed && null == (e ? i.from : i.to) && (!n || Re(n, i.marker) < 0) && (n = i.marker);
          return n;
        }
        function Ve(t) {
          return Fe(t, !0);
        }
        function ze(t) {
          return Fe(t, !1);
        }
        function He(t, e) {
          var n,
            r = je && t.markedSpans;
          if (r) for (var i = 0; i < r.length; ++i) {
            var o = r[i];
            o.marker.collapsed && (null == o.from || o.from < e) && (null == o.to || o.to > e) && (!n || Re(n, o.marker) < 0) && (n = o.marker);
          }
          return n;
        }
        function Be(t, e, n, r, i) {
          var o = Jt(t, e),
            a = je && o.markedSpans;
          if (a) for (var s = 0; s < a.length; ++s) {
            var c = a[s];
            if (c.marker.collapsed) {
              var l = c.marker.find(0),
                u = ae(l.from, n) || Ne(c.marker) - Ne(i),
                d = ae(l.to, r) || Ie(c.marker) - Ie(i);
              if (!(u >= 0 && d <= 0 || u <= 0 && d >= 0) && (u <= 0 && (c.marker.inclusiveRight && i.inclusiveLeft ? ae(l.to, n) >= 0 : ae(l.to, n) > 0) || u >= 0 && (c.marker.inclusiveRight && i.inclusiveLeft ? ae(l.from, r) <= 0 : ae(l.from, r) < 0))) return !0;
            }
          }
        }
        function Ue(t) {
          for (var e; e = Ve(t);) t = e.find(-1, !0).line;
          return t;
        }
        function $e(t, e) {
          var n = Jt(t, e),
            r = Ue(n);
          return n == r ? e : ee(r);
        }
        function We(t, e) {
          if (e > t.lastLine()) return e;
          var n,
            r = Jt(t, e);
          if (!qe(t, r)) return e;
          for (; n = ze(r);) r = n.find(1, !0).line;
          return ee(r) + 1;
        }
        function qe(t, e) {
          var n = je && e.markedSpans;
          if (n) for (var r = void 0, i = 0; i < n.length; ++i) if ((r = n[i]).marker.collapsed) {
            if (null == r.from) return !0;
            if (!r.marker.widgetNode && 0 == r.from && r.marker.inclusiveLeft && Ge(t, e, r)) return !0;
          }
        }
        function Ge(t, e, n) {
          if (null == n.to) {
            var r = n.marker.find(1, !0);
            return Ge(t, r.line, Pe(r.line.markedSpans, n.marker));
          }
          if (n.marker.inclusiveRight && n.to == e.text.length) return !0;
          for (var i = void 0, o = 0; o < e.markedSpans.length; ++o) if ((i = e.markedSpans[o]).marker.collapsed && !i.marker.widgetNode && i.from == n.to && (null == i.to || i.to != n.from) && (i.marker.inclusiveLeft || n.marker.inclusiveRight) && Ge(t, e, i)) return !0;
        }
        function Ye(t) {
          for (var e = 0, n = (t = Ue(t)).parent, r = 0; r < n.lines.length; ++r) {
            var i = n.lines[r];
            if (i == t) break;
            e += i.height;
          }
          for (var o = n.parent; o; o = (n = o).parent) for (var a = 0; a < o.children.length; ++a) {
            var s = o.children[a];
            if (s == n) break;
            e += s.height;
          }
          return e;
        }
        function Ke(t) {
          if (0 == t.height) return 0;
          for (var e, n = t.text.length, r = t; e = Ve(r);) {
            var i = e.find(0, !0);
            r = i.from.line, n += i.from.ch - i.to.ch;
          }
          for (r = t; e = ze(r);) {
            var o = e.find(0, !0);
            n -= r.text.length - o.from.ch, n += (r = o.to.line).text.length - o.to.ch;
          }
          return n;
        }
        function Xe(t) {
          var e = t.display,
            n = t.doc;
          e.maxLine = Jt(n, n.first), e.maxLineLength = Ke(e.maxLine), e.maxLineChanged = !0, n.iter(function (t) {
            var n = Ke(t);
            n > e.maxLineLength && (e.maxLineLength = n, e.maxLine = t);
          });
        }
        var Je = function Je(t, e, n) {
          this.text = t, _e(this, e), this.height = n ? n(this) : 1;
        };
        function Ze(t) {
          t.parent = null, Le(t);
        }
        Je.prototype.lineNo = function () {
          return ee(this);
        }, Ct(Je);
        var Qe = {},
          tn = {};
        function en(t, e) {
          if (!t || /^\s*$/.test(t)) return null;
          var n = e.addModeClass ? tn : Qe;
          return n[t] || (n[t] = t.replace(/\S+/g, "cm-$&"));
        }
        function nn(t, e) {
          var n = M("span", null, null, c ? "padding-right: .1px" : null),
            r = {
              pre: M("pre", [n], "CodeMirror-line"),
              content: n,
              col: 0,
              pos: 0,
              cm: t,
              trailingSpace: !1,
              splitSpaces: t.getOption("lineWrapping")
            };
          e.measure = {};
          for (var i = 0; i <= (e.rest ? e.rest.length : 0); i++) {
            var o = i ? e.rest[i - 1] : e.line,
              a = void 0;
            r.pos = 0, r.addToken = on, _t(t.display.measure) && (a = pt(o, t.doc.direction)) && (r.addToken = an(r.addToken, a)), r.map = [], cn(o, r, me(t, o, e != t.display.externalMeasured && ee(o))), o.styleClasses && (o.styleClasses.bgClass && (r.bgClass = N(o.styleClasses.bgClass, r.bgClass || "")), o.styleClasses.textClass && (r.textClass = N(o.styleClasses.textClass, r.textClass || ""))), 0 == r.map.length && r.map.push(0, 0, r.content.appendChild(Lt(t.display.measure))), 0 == i ? (e.measure.map = r.map, e.measure.cache = {}) : ((e.measure.maps || (e.measure.maps = [])).push(r.map), (e.measure.caches || (e.measure.caches = [])).push({}));
          }
          if (c) {
            var s = r.content.lastChild;
            (/\bcm-tab\b/.test(s.className) || s.querySelector && s.querySelector(".cm-tab")) && (r.content.className = "cm-tab-wrap-hack");
          }
          return yt(t, "renderLine", t, e.line, r.pre), r.pre.className && (r.textClass = N(r.pre.className, r.textClass || "")), r;
        }
        function rn(t) {
          var e = A("span", "•", "cm-invalidchar");
          return e.title = "\\u" + t.charCodeAt(0).toString(16), e.setAttribute("aria-label", e.title), e;
        }
        function on(t, e, n, r, i, o, c) {
          if (e) {
            var l,
              u = t.splitSpaces ? function (t, e) {
                if (t.length > 1 && !/  /.test(t)) return t;
                for (var n = e, r = "", i = 0; i < t.length; i++) {
                  var o = t.charAt(i);
                  " " != o || !n || i != t.length - 1 && 32 != t.charCodeAt(i + 1) || (o = " "), r += o, n = " " == o;
                }
                return r;
              }(e, t.trailingSpace) : e,
              d = t.cm.state.specialChars,
              h = !1;
            if (d.test(e)) {
              l = document.createDocumentFragment();
              for (var f = 0;;) {
                d.lastIndex = f;
                var p = d.exec(e),
                  g = p ? p.index - f : e.length - f;
                if (g) {
                  var v = document.createTextNode(u.slice(f, f + g));
                  a && s < 9 ? l.appendChild(A("span", [v])) : l.appendChild(v), t.map.push(t.pos, t.pos + g, v), t.col += g, t.pos += g;
                }
                if (!p) break;
                f += g + 1;
                var m = void 0;
                if ("\t" == p[0]) {
                  var b = t.cm.options.tabSize,
                    y = b - t.col % b;
                  (m = l.appendChild(A("span", Z(y), "cm-tab"))).setAttribute("role", "presentation"), m.setAttribute("cm-text", "\t"), t.col += y;
                } else "\r" == p[0] || "\n" == p[0] ? ((m = l.appendChild(A("span", "\r" == p[0] ? "␍" : "␤", "cm-invalidchar"))).setAttribute("cm-text", p[0]), t.col += 1) : ((m = t.cm.options.specialCharPlaceholder(p[0])).setAttribute("cm-text", p[0]), a && s < 9 ? l.appendChild(A("span", [m])) : l.appendChild(m), t.col += 1);
                t.map.push(t.pos, t.pos + 1, m), t.pos++;
              }
            } else t.col += e.length, l = document.createTextNode(u), t.map.push(t.pos, t.pos + e.length, l), a && s < 9 && (h = !0), t.pos += e.length;
            if (t.trailingSpace = 32 == u.charCodeAt(e.length - 1), n || r || i || h || o || c) {
              var w = n || "";
              r && (w += r), i && (w += i);
              var x = A("span", [l], w, o);
              if (c) for (var O in c) c.hasOwnProperty(O) && "style" != O && "class" != O && x.setAttribute(O, c[O]);
              return t.content.appendChild(x);
            }
            t.content.appendChild(l);
          }
        }
        function an(t, e) {
          return function (n, r, i, o, a, s, c) {
            i = i ? i + " cm-force-border" : "cm-force-border";
            for (var l = n.pos, u = l + r.length;;) {
              for (var d = void 0, h = 0; h < e.length && !((d = e[h]).to > l && d.from <= l); h++);
              if (d.to >= u) return t(n, r, i, o, a, s, c);
              t(n, r.slice(0, d.to - l), i, o, null, s, c), o = null, r = r.slice(d.to - l), l = d.to;
            }
          };
        }
        function sn(t, e, n, r) {
          var i = !r && n.widgetNode;
          i && t.map.push(t.pos, t.pos + e, i), !r && t.cm.display.input.needsContentAttribute && (i || (i = t.content.appendChild(document.createElement("span"))), i.setAttribute("cm-marker", n.id)), i && (t.cm.display.input.setUneditable(i), t.content.appendChild(i)), t.pos += e, t.trailingSpace = !1;
        }
        function cn(t, e, n) {
          var r = t.markedSpans,
            i = t.text,
            o = 0;
          if (r) for (var a, s, c, l, u, d, h, f = i.length, p = 0, g = 1, v = "", m = 0;;) {
            if (m == p) {
              c = l = u = s = "", h = null, d = null, m = 1 / 0;
              for (var b = [], y = void 0, w = 0; w < r.length; ++w) {
                var x = r[w],
                  O = x.marker;
                if ("bookmark" == O.type && x.from == p && O.widgetNode) b.push(O);else if (x.from <= p && (null == x.to || x.to > p || O.collapsed && x.to == p && x.from == p)) {
                  if (null != x.to && x.to != p && m > x.to && (m = x.to, l = ""), O.className && (c += " " + O.className), O.css && (s = (s ? s + ";" : "") + O.css), O.startStyle && x.from == p && (u += " " + O.startStyle), O.endStyle && x.to == m && (y || (y = [])).push(O.endStyle, x.to), O.title && ((h || (h = {})).title = O.title), O.attributes) for (var C in O.attributes) (h || (h = {}))[C] = O.attributes[C];
                  O.collapsed && (!d || Re(d.marker, O) < 0) && (d = x);
                } else x.from > p && m > x.from && (m = x.from);
              }
              if (y) for (var S = 0; S < y.length; S += 2) y[S + 1] == m && (l += " " + y[S]);
              if (!d || d.from == p) for (var k = 0; k < b.length; ++k) sn(e, 0, b[k]);
              if (d && (d.from || 0) == p) {
                if (sn(e, (null == d.to ? f + 1 : d.to) - p, d.marker, null == d.from), null == d.to) return;
                d.to == p && (d = !1);
              }
            }
            if (p >= f) break;
            for (var T = Math.min(f, m);;) {
              if (v) {
                var j = p + v.length;
                if (!d) {
                  var E = j > T ? v.slice(0, T - p) : v;
                  e.addToken(e, E, a ? a + c : c, u, p + E.length == m ? l : "", s, h);
                }
                if (j >= T) {
                  v = v.slice(T - p), p = T;
                  break;
                }
                p = j, u = "";
              }
              v = i.slice(o, o = n[g++]), a = en(n[g++], e.cm.options);
            }
          } else for (var P = 1; P < n.length; P += 2) e.addToken(e, i.slice(o, o = n[P]), en(n[P + 1], e.cm.options));
        }
        function ln(t, e, n) {
          this.line = e, this.rest = function (t) {
            for (var e, n; e = ze(t);) t = e.find(1, !0).line, (n || (n = [])).push(t);
            return n;
          }(e), this.size = this.rest ? ee(Q(this.rest)) - n + 1 : 1, this.node = this.text = null, this.hidden = qe(t, e);
        }
        function un(t, e, n) {
          for (var r, i = [], o = e; o < n; o = r) {
            var a = new ln(t.doc, Jt(t.doc, o), o);
            r = o + a.size, i.push(a);
          }
          return i;
        }
        var dn = null,
          hn = null;
        function fn(t, e) {
          var n = mt(t, e);
          if (n.length) {
            var r,
              i = Array.prototype.slice.call(arguments, 2);
            dn ? r = dn.delayedCallbacks : hn ? r = hn : (r = hn = [], setTimeout(pn, 0));
            for (var o = function o(t) {
                r.push(function () {
                  return n[t].apply(null, i);
                });
              }, a = 0; a < n.length; ++a) o(a);
          }
        }
        function pn() {
          var t = hn;
          hn = null;
          for (var e = 0; e < t.length; ++e) t[e]();
        }
        function gn(t, e, n, r) {
          for (var i = 0; i < e.changes.length; i++) {
            var o = e.changes[i];
            "text" == o ? bn(t, e) : "gutter" == o ? wn(t, e, n, r) : "class" == o ? yn(t, e) : "widget" == o && xn(t, e, r);
          }
          e.changes = null;
        }
        function vn(t) {
          return t.node == t.text && (t.node = A("div", null, null, "position: relative"), t.text.parentNode && t.text.parentNode.replaceChild(t.node, t.text), t.node.appendChild(t.text), a && s < 8 && (t.node.style.zIndex = 2)), t.node;
        }
        function mn(t, e) {
          var n = t.display.externalMeasured;
          return n && n.line == e.line ? (t.display.externalMeasured = null, e.measure = n.measure, n.built) : nn(t, e);
        }
        function bn(t, e) {
          var n = e.text.className,
            r = mn(t, e);
          e.text == e.node && (e.node = r.pre), e.text.parentNode.replaceChild(r.pre, e.text), e.text = r.pre, r.bgClass != e.bgClass || r.textClass != e.textClass ? (e.bgClass = r.bgClass, e.textClass = r.textClass, yn(t, e)) : n && (e.text.className = n);
        }
        function yn(t, e) {
          !function (t, e) {
            var n = e.bgClass ? e.bgClass + " " + (e.line.bgClass || "") : e.line.bgClass;
            if (n && (n += " CodeMirror-linebackground"), e.background) n ? e.background.className = n : (e.background.parentNode.removeChild(e.background), e.background = null);else if (n) {
              var r = vn(e);
              e.background = r.insertBefore(A("div", null, n), r.firstChild), t.display.input.setUneditable(e.background);
            }
          }(t, e), e.line.wrapClass ? vn(e).className = e.line.wrapClass : e.node != e.text && (e.node.className = "");
          var n = e.textClass ? e.textClass + " " + (e.line.textClass || "") : e.line.textClass;
          e.text.className = n || "";
        }
        function wn(t, e, n, r) {
          if (e.gutter && (e.node.removeChild(e.gutter), e.gutter = null), e.gutterBackground && (e.node.removeChild(e.gutterBackground), e.gutterBackground = null), e.line.gutterClass) {
            var i = vn(e);
            e.gutterBackground = A("div", null, "CodeMirror-gutter-background " + e.line.gutterClass, "left: " + (t.options.fixedGutter ? r.fixedPos : -r.gutterTotalWidth) + "px; width: " + r.gutterTotalWidth + "px"), t.display.input.setUneditable(e.gutterBackground), i.insertBefore(e.gutterBackground, e.text);
          }
          var o = e.line.gutterMarkers;
          if (t.options.lineNumbers || o) {
            var a = vn(e),
              s = e.gutter = A("div", null, "CodeMirror-gutter-wrapper", "left: " + (t.options.fixedGutter ? r.fixedPos : -r.gutterTotalWidth) + "px");
            if (s.setAttribute("aria-hidden", "true"), t.display.input.setUneditable(s), a.insertBefore(s, e.text), e.line.gutterClass && (s.className += " " + e.line.gutterClass), !t.options.lineNumbers || o && o["CodeMirror-linenumbers"] || (e.lineNumber = s.appendChild(A("div", ie(t.options, n), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + r.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + t.display.lineNumInnerWidth + "px"))), o) for (var c = 0; c < t.display.gutterSpecs.length; ++c) {
              var l = t.display.gutterSpecs[c].className,
                u = o.hasOwnProperty(l) && o[l];
              u && s.appendChild(A("div", [u], "CodeMirror-gutter-elt", "left: " + r.gutterLeft[l] + "px; width: " + r.gutterWidth[l] + "px"));
            }
          }
        }
        function xn(t, e, n) {
          e.alignable && (e.alignable = null);
          for (var r = k("CodeMirror-linewidget"), i = e.node.firstChild, o = void 0; i; i = o) o = i.nextSibling, r.test(i.className) && e.node.removeChild(i);
          Cn(t, e, n);
        }
        function On(t, e, n, r) {
          var i = mn(t, e);
          return e.text = e.node = i.pre, i.bgClass && (e.bgClass = i.bgClass), i.textClass && (e.textClass = i.textClass), yn(t, e), wn(t, e, n, r), Cn(t, e, r), e.node;
        }
        function Cn(t, e, n) {
          if (Sn(t, e.line, e, n, !0), e.rest) for (var r = 0; r < e.rest.length; r++) Sn(t, e.rest[r], e, n, !1);
        }
        function Sn(t, e, n, r, i) {
          if (e.widgets) for (var o = vn(n), a = 0, s = e.widgets; a < s.length; ++a) {
            var c = s[a],
              l = A("div", [c.node], "CodeMirror-linewidget" + (c.className ? " " + c.className : ""));
            c.handleMouseEvents || l.setAttribute("cm-ignore-events", "true"), kn(c, l, n, r), t.display.input.setUneditable(l), i && c.above ? o.insertBefore(l, n.gutter || n.text) : o.appendChild(l), fn(c, "redraw");
          }
        }
        function kn(t, e, n, r) {
          if (t.noHScroll) {
            (n.alignable || (n.alignable = [])).push(e);
            var i = r.wrapperWidth;
            e.style.left = r.fixedPos + "px", t.coverGutter || (i -= r.gutterTotalWidth, e.style.paddingLeft = r.gutterTotalWidth + "px"), e.style.width = i + "px";
          }
          t.coverGutter && (e.style.zIndex = 5, e.style.position = "relative", t.noHScroll || (e.style.marginLeft = -r.gutterTotalWidth + "px"));
        }
        function Tn(t) {
          if (null != t.height) return t.height;
          var e = t.doc.cm;
          if (!e) return 0;
          if (!D(document.body, t.node)) {
            var n = "position: relative;";
            t.coverGutter && (n += "margin-left: -" + e.display.gutters.offsetWidth + "px;"), t.noHScroll && (n += "width: " + e.display.wrapper.clientWidth + "px;"), P(e.display.measure, A("div", [t.node], null, n));
          }
          return t.height = t.node.parentNode.offsetHeight;
        }
        function jn(t, e) {
          for (var n = Et(e); n != t.wrapper; n = n.parentNode) if (!n || 1 == n.nodeType && "true" == n.getAttribute("cm-ignore-events") || n.parentNode == t.sizer && n != t.mover) return !0;
        }
        function En(t) {
          return t.lineSpace.offsetTop;
        }
        function Pn(t) {
          return t.mover.offsetHeight - t.lineSpace.offsetHeight;
        }
        function An(t) {
          if (t.cachedPaddingH) return t.cachedPaddingH;
          var e = P(t.measure, A("pre", "x", "CodeMirror-line-like")),
            n = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle,
            r = {
              left: parseInt(n.paddingLeft),
              right: parseInt(n.paddingRight)
            };
          return isNaN(r.left) || isNaN(r.right) || (t.cachedPaddingH = r), r;
        }
        function Mn(t) {
          return 50 - t.display.nativeBarWidth;
        }
        function Dn(t) {
          return t.display.scroller.clientWidth - Mn(t) - t.display.barWidth;
        }
        function Ln(t) {
          return t.display.scroller.clientHeight - Mn(t) - t.display.barHeight;
        }
        function _n(t, e, n) {
          if (t.line == e) return {
            map: t.measure.map,
            cache: t.measure.cache
          };
          if (t.rest) {
            for (var r = 0; r < t.rest.length; r++) if (t.rest[r] == e) return {
              map: t.measure.maps[r],
              cache: t.measure.caches[r]
            };
            for (var i = 0; i < t.rest.length; i++) if (ee(t.rest[i]) > n) return {
              map: t.measure.maps[i],
              cache: t.measure.caches[i],
              before: !0
            };
          }
        }
        function Nn(t, e, n, r) {
          return Fn(t, Rn(t, e), n, r);
        }
        function In(t, e) {
          if (e >= t.display.viewFrom && e < t.display.viewTo) return t.display.view[gr(t, e)];
          var n = t.display.externalMeasured;
          return n && e >= n.lineN && e < n.lineN + n.size ? n : void 0;
        }
        function Rn(t, e) {
          var n = ee(e),
            r = In(t, n);
          r && !r.text ? r = null : r && r.changes && (gn(t, r, n, ur(t)), t.curOp.forceUpdate = !0), r || (r = function (t, e) {
            var n = ee(e = Ue(e)),
              r = t.display.externalMeasured = new ln(t.doc, e, n);
            r.lineN = n;
            var i = r.built = nn(t, r);
            return r.text = i.pre, P(t.display.lineMeasure, i.pre), r;
          }(t, e));
          var i = _n(r, e, n);
          return {
            line: e,
            view: r,
            rect: null,
            map: i.map,
            cache: i.cache,
            before: i.before,
            hasHeights: !1
          };
        }
        function Fn(t, e, n, r, i) {
          e.before && (n = -1);
          var o,
            c = n + (r || "");
          return e.cache.hasOwnProperty(c) ? o = e.cache[c] : (e.rect || (e.rect = e.view.text.getBoundingClientRect()), e.hasHeights || (function (t, e, n) {
            var r = t.options.lineWrapping,
              i = r && Dn(t);
            if (!e.measure.heights || r && e.measure.width != i) {
              var o = e.measure.heights = [];
              if (r) {
                e.measure.width = i;
                for (var a = e.text.firstChild.getClientRects(), s = 0; s < a.length - 1; s++) {
                  var c = a[s],
                    l = a[s + 1];
                  Math.abs(c.bottom - l.bottom) > 2 && o.push((c.bottom + l.top) / 2 - n.top);
                }
              }
              o.push(n.bottom - n.top);
            }
          }(t, e.view, e.rect), e.hasHeights = !0), (o = function (t, e, n, r) {
            var i,
              o = Hn(e.map, n, r),
              c = o.node,
              l = o.start,
              u = o.end,
              d = o.collapse;
            if (3 == c.nodeType) {
              for (var h = 0; h < 4; h++) {
                for (; l && ct(e.line.text.charAt(o.coverStart + l));) --l;
                for (; o.coverStart + u < o.coverEnd && ct(e.line.text.charAt(o.coverStart + u));) ++u;
                if ((i = a && s < 9 && 0 == l && u == o.coverEnd - o.coverStart ? c.parentNode.getBoundingClientRect() : Bn(T(c, l, u).getClientRects(), r)).left || i.right || 0 == l) break;
                u = l, l -= 1, d = "right";
              }
              a && s < 11 && (i = function (t, e) {
                if (!window.screen || null == screen.logicalXDPI || screen.logicalXDPI == screen.deviceXDPI || !function (t) {
                  if (null != Vt) return Vt;
                  var e = P(t, A("span", "x")),
                    n = e.getBoundingClientRect(),
                    r = T(e, 0, 1).getBoundingClientRect();
                  return Vt = Math.abs(n.left - r.left) > 1;
                }(t)) return e;
                var n = screen.logicalXDPI / screen.deviceXDPI,
                  r = screen.logicalYDPI / screen.deviceYDPI;
                return {
                  left: e.left * n,
                  right: e.right * n,
                  top: e.top * r,
                  bottom: e.bottom * r
                };
              }(t.display.measure, i));
            } else {
              var f;
              l > 0 && (d = r = "right"), i = t.options.lineWrapping && (f = c.getClientRects()).length > 1 ? f["right" == r ? f.length - 1 : 0] : c.getBoundingClientRect();
            }
            if (a && s < 9 && !l && (!i || !i.left && !i.right)) {
              var p = c.parentNode.getClientRects()[0];
              i = p ? {
                left: p.left,
                right: p.left + lr(t.display),
                top: p.top,
                bottom: p.bottom
              } : zn;
            }
            for (var g = i.top - e.rect.top, v = i.bottom - e.rect.top, m = (g + v) / 2, b = e.view.measure.heights, y = 0; y < b.length - 1 && !(m < b[y]); y++);
            var w = y ? b[y - 1] : 0,
              x = b[y],
              O = {
                left: ("right" == d ? i.right : i.left) - e.rect.left,
                right: ("left" == d ? i.left : i.right) - e.rect.left,
                top: w,
                bottom: x
              };
            return i.left || i.right || (O.bogus = !0), t.options.singleCursorHeightPerLine || (O.rtop = g, O.rbottom = v), O;
          }(t, e, n, r)).bogus || (e.cache[c] = o)), {
            left: o.left,
            right: o.right,
            top: i ? o.rtop : o.top,
            bottom: i ? o.rbottom : o.bottom
          };
        }
        var Vn,
          zn = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          };
        function Hn(t, e, n) {
          for (var r, i, o, a, s, c, l = 0; l < t.length; l += 3) if (s = t[l], c = t[l + 1], e < s ? (i = 0, o = 1, a = "left") : e < c ? o = 1 + (i = e - s) : (l == t.length - 3 || e == c && t[l + 3] > e) && (i = (o = c - s) - 1, e >= c && (a = "right")), null != i) {
            if (r = t[l + 2], s == c && n == (r.insertLeft ? "left" : "right") && (a = n), "left" == n && 0 == i) for (; l && t[l - 2] == t[l - 3] && t[l - 1].insertLeft;) r = t[2 + (l -= 3)], a = "left";
            if ("right" == n && i == c - s) for (; l < t.length - 3 && t[l + 3] == t[l + 4] && !t[l + 5].insertLeft;) r = t[(l += 3) + 2], a = "right";
            break;
          }
          return {
            node: r,
            start: i,
            end: o,
            collapse: a,
            coverStart: s,
            coverEnd: c
          };
        }
        function Bn(t, e) {
          var n = zn;
          if ("left" == e) for (var r = 0; r < t.length && (n = t[r]).left == n.right; r++);else for (var i = t.length - 1; i >= 0 && (n = t[i]).left == n.right; i--);
          return n;
        }
        function Un(t) {
          if (t.measure && (t.measure.cache = {}, t.measure.heights = null, t.rest)) for (var e = 0; e < t.rest.length; e++) t.measure.caches[e] = {};
        }
        function $n(t) {
          t.display.externalMeasure = null, E(t.display.lineMeasure);
          for (var e = 0; e < t.display.view.length; e++) Un(t.display.view[e]);
        }
        function Wn(t) {
          $n(t), t.display.cachedCharWidth = t.display.cachedTextHeight = t.display.cachedPaddingH = null, t.options.lineWrapping || (t.display.maxLineChanged = !0), t.display.lineNumChars = null;
        }
        function qn(t) {
          return u && m ? -(t.body.getBoundingClientRect().left - parseInt(getComputedStyle(t.body).marginLeft)) : t.defaultView.pageXOffset || (t.documentElement || t.body).scrollLeft;
        }
        function Gn(t) {
          return u && m ? -(t.body.getBoundingClientRect().top - parseInt(getComputedStyle(t.body).marginTop)) : t.defaultView.pageYOffset || (t.documentElement || t.body).scrollTop;
        }
        function Yn(t) {
          var e = Ue(t).widgets,
            n = 0;
          if (e) for (var r = 0; r < e.length; ++r) e[r].above && (n += Tn(e[r]));
          return n;
        }
        function Kn(t, e, n, r, i) {
          if (!i) {
            var o = Yn(e);
            n.top += o, n.bottom += o;
          }
          if ("line" == r) return n;
          r || (r = "local");
          var a = Ye(e);
          if ("local" == r ? a += En(t.display) : a -= t.display.viewOffset, "page" == r || "window" == r) {
            var s = t.display.lineSpace.getBoundingClientRect();
            a += s.top + ("window" == r ? 0 : Gn(R(t)));
            var c = s.left + ("window" == r ? 0 : qn(R(t)));
            n.left += c, n.right += c;
          }
          return n.top += a, n.bottom += a, n;
        }
        function Xn(t, e, n) {
          if ("div" == n) return e;
          var r = e.left,
            i = e.top;
          if ("page" == n) r -= qn(R(t)), i -= Gn(R(t));else if ("local" == n || !n) {
            var o = t.display.sizer.getBoundingClientRect();
            r += o.left, i += o.top;
          }
          var a = t.display.lineSpace.getBoundingClientRect();
          return {
            left: r - a.left,
            top: i - a.top
          };
        }
        function Jn(t, e, n, r, i) {
          return r || (r = Jt(t.doc, e.line)), Kn(t, r, Nn(t, r, e.ch, i), n);
        }
        function Zn(t, e, n, r, i, o) {
          function a(e, a) {
            var s = Fn(t, i, e, a ? "right" : "left", o);
            return a ? s.left = s.right : s.right = s.left, Kn(t, r, s, n);
          }
          r = r || Jt(t.doc, e.line), i || (i = Rn(t, r));
          var s = pt(r, t.doc.direction),
            c = e.ch,
            l = e.sticky;
          if (c >= r.text.length ? (c = r.text.length, l = "before") : c <= 0 && (c = 0, l = "after"), !s) return a("before" == l ? c - 1 : c, "before" == l);
          function u(t, e, n) {
            return a(n ? t - 1 : t, 1 == s[e].level != n);
          }
          var d = ht(s, c, l),
            h = dt,
            f = u(c, d, "before" == l);
          return null != h && (f.other = u(c, h, "before" != l)), f;
        }
        function Qn(t, e) {
          var n = 0;
          e = he(t.doc, e), t.options.lineWrapping || (n = lr(t.display) * e.ch);
          var r = Jt(t.doc, e.line),
            i = Ye(r) + En(t.display);
          return {
            left: n,
            right: n,
            top: i,
            bottom: i + r.height
          };
        }
        function tr(t, e, n, r, i) {
          var o = oe(t, e, n);
          return o.xRel = i, r && (o.outside = r), o;
        }
        function er(t, e, n) {
          var r = t.doc;
          if ((n += t.display.viewOffset) < 0) return tr(r.first, 0, null, -1, -1);
          var i = ne(r, n),
            o = r.first + r.size - 1;
          if (i > o) return tr(r.first + r.size - 1, Jt(r, o).text.length, null, 1, 1);
          e < 0 && (e = 0);
          for (var a = Jt(r, i);;) {
            var s = or(t, a, i, e, n),
              c = He(a, s.ch + (s.xRel > 0 || s.outside > 0 ? 1 : 0));
            if (!c) return s;
            var l = c.find(1);
            if (l.line == i) return l;
            a = Jt(r, i = l.line);
          }
        }
        function nr(t, e, n, r) {
          r -= Yn(e);
          var i = e.text.length,
            o = ut(function (e) {
              return Fn(t, n, e - 1).bottom <= r;
            }, i, 0);
          return {
            begin: o,
            end: i = ut(function (e) {
              return Fn(t, n, e).top > r;
            }, o, i)
          };
        }
        function rr(t, e, n, r) {
          return n || (n = Rn(t, e)), nr(t, e, n, Kn(t, e, Fn(t, n, r), "line").top);
        }
        function ir(t, e, n, r) {
          return !(t.bottom <= n) && (t.top > n || (r ? t.left : t.right) > e);
        }
        function or(t, e, n, r, i) {
          i -= Ye(e);
          var o = Rn(t, e),
            a = Yn(e),
            s = 0,
            c = e.text.length,
            l = !0,
            u = pt(e, t.doc.direction);
          if (u) {
            var d = (t.options.lineWrapping ? sr : ar)(t, e, n, o, u, r, i);
            s = (l = 1 != d.level) ? d.from : d.to - 1, c = l ? d.to : d.from - 1;
          }
          var h,
            f,
            p = null,
            g = null,
            v = ut(function (e) {
              var n = Fn(t, o, e);
              return n.top += a, n.bottom += a, !!ir(n, r, i, !1) && (n.top <= i && n.left <= r && (p = e, g = n), !0);
            }, s, c),
            m = !1;
          if (g) {
            var b = r - g.left < g.right - r,
              y = b == l;
            v = p + (y ? 0 : 1), f = y ? "after" : "before", h = b ? g.left : g.right;
          } else {
            l || v != c && v != s || v++, f = 0 == v ? "after" : v == e.text.length ? "before" : Fn(t, o, v - (l ? 1 : 0)).bottom + a <= i == l ? "after" : "before";
            var w = Zn(t, oe(n, v, f), "line", e, o);
            h = w.left, m = i < w.top ? -1 : i >= w.bottom ? 1 : 0;
          }
          return tr(n, v = lt(e.text, v, 1), f, m, r - h);
        }
        function ar(t, e, n, r, i, o, a) {
          var s = ut(function (s) {
              var c = i[s],
                l = 1 != c.level;
              return ir(Zn(t, oe(n, l ? c.to : c.from, l ? "before" : "after"), "line", e, r), o, a, !0);
            }, 0, i.length - 1),
            c = i[s];
          if (s > 0) {
            var l = 1 != c.level,
              u = Zn(t, oe(n, l ? c.from : c.to, l ? "after" : "before"), "line", e, r);
            ir(u, o, a, !0) && u.top > a && (c = i[s - 1]);
          }
          return c;
        }
        function sr(t, e, n, r, i, o, a) {
          var s = nr(t, e, r, a),
            c = s.begin,
            l = s.end;
          /\s/.test(e.text.charAt(l - 1)) && l--;
          for (var u = null, d = null, h = 0; h < i.length; h++) {
            var f = i[h];
            if (!(f.from >= l || f.to <= c)) {
              var p = Fn(t, r, 1 != f.level ? Math.min(l, f.to) - 1 : Math.max(c, f.from)).right,
                g = p < o ? o - p + 1e9 : p - o;
              (!u || d > g) && (u = f, d = g);
            }
          }
          return u || (u = i[i.length - 1]), u.from < c && (u = {
            from: c,
            to: u.to,
            level: u.level
          }), u.to > l && (u = {
            from: u.from,
            to: l,
            level: u.level
          }), u;
        }
        function cr(t) {
          if (null != t.cachedTextHeight) return t.cachedTextHeight;
          if (null == Vn) {
            Vn = A("pre", null, "CodeMirror-line-like");
            for (var e = 0; e < 49; ++e) Vn.appendChild(document.createTextNode("x")), Vn.appendChild(A("br"));
            Vn.appendChild(document.createTextNode("x"));
          }
          P(t.measure, Vn);
          var n = Vn.offsetHeight / 50;
          return n > 3 && (t.cachedTextHeight = n), E(t.measure), n || 1;
        }
        function lr(t) {
          if (null != t.cachedCharWidth) return t.cachedCharWidth;
          var e = A("span", "xxxxxxxxxx"),
            n = A("pre", [e], "CodeMirror-line-like");
          P(t.measure, n);
          var r = e.getBoundingClientRect(),
            i = (r.right - r.left) / 10;
          return i > 2 && (t.cachedCharWidth = i), i || 10;
        }
        function ur(t) {
          for (var e = t.display, n = {}, r = {}, i = e.gutters.clientLeft, o = e.gutters.firstChild, a = 0; o; o = o.nextSibling, ++a) {
            var s = t.display.gutterSpecs[a].className;
            n[s] = o.offsetLeft + o.clientLeft + i, r[s] = o.clientWidth;
          }
          return {
            fixedPos: dr(e),
            gutterTotalWidth: e.gutters.offsetWidth,
            gutterLeft: n,
            gutterWidth: r,
            wrapperWidth: e.wrapper.clientWidth
          };
        }
        function dr(t) {
          return t.scroller.getBoundingClientRect().left - t.sizer.getBoundingClientRect().left;
        }
        function hr(t) {
          var e = cr(t.display),
            n = t.options.lineWrapping,
            r = n && Math.max(5, t.display.scroller.clientWidth / lr(t.display) - 3);
          return function (i) {
            if (qe(t.doc, i)) return 0;
            var o = 0;
            if (i.widgets) for (var a = 0; a < i.widgets.length; a++) i.widgets[a].height && (o += i.widgets[a].height);
            return n ? o + (Math.ceil(i.text.length / r) || 1) * e : o + e;
          };
        }
        function fr(t) {
          var e = t.doc,
            n = hr(t);
          e.iter(function (t) {
            var e = n(t);
            e != t.height && te(t, e);
          });
        }
        function pr(t, e, n, r) {
          var i = t.display;
          if (!n && "true" == Et(e).getAttribute("cm-not-content")) return null;
          var o,
            a,
            s = i.lineSpace.getBoundingClientRect();
          try {
            o = e.clientX - s.left, a = e.clientY - s.top;
          } catch (t) {
            return null;
          }
          var c,
            l = er(t, o, a);
          if (r && l.xRel > 0 && (c = Jt(t.doc, l.line).text).length == l.ch) {
            var u = U(c, c.length, t.options.tabSize) - c.length;
            l = oe(l.line, Math.max(0, Math.round((o - An(t.display).left) / lr(t.display)) - u));
          }
          return l;
        }
        function gr(t, e) {
          if (e >= t.display.viewTo) return null;
          if ((e -= t.display.viewFrom) < 0) return null;
          for (var n = t.display.view, r = 0; r < n.length; r++) if ((e -= n[r].size) < 0) return r;
        }
        function vr(t, e, n, r) {
          null == e && (e = t.doc.first), null == n && (n = t.doc.first + t.doc.size), r || (r = 0);
          var i = t.display;
          if (r && n < i.viewTo && (null == i.updateLineNumbers || i.updateLineNumbers > e) && (i.updateLineNumbers = e), t.curOp.viewChanged = !0, e >= i.viewTo) je && $e(t.doc, e) < i.viewTo && br(t);else if (n <= i.viewFrom) je && We(t.doc, n + r) > i.viewFrom ? br(t) : (i.viewFrom += r, i.viewTo += r);else if (e <= i.viewFrom && n >= i.viewTo) br(t);else if (e <= i.viewFrom) {
            var o = yr(t, n, n + r, 1);
            o ? (i.view = i.view.slice(o.index), i.viewFrom = o.lineN, i.viewTo += r) : br(t);
          } else if (n >= i.viewTo) {
            var a = yr(t, e, e, -1);
            a ? (i.view = i.view.slice(0, a.index), i.viewTo = a.lineN) : br(t);
          } else {
            var s = yr(t, e, e, -1),
              c = yr(t, n, n + r, 1);
            s && c ? (i.view = i.view.slice(0, s.index).concat(un(t, s.lineN, c.lineN)).concat(i.view.slice(c.index)), i.viewTo += r) : br(t);
          }
          var l = i.externalMeasured;
          l && (n < l.lineN ? l.lineN += r : e < l.lineN + l.size && (i.externalMeasured = null));
        }
        function mr(t, e, n) {
          t.curOp.viewChanged = !0;
          var r = t.display,
            i = t.display.externalMeasured;
          if (i && e >= i.lineN && e < i.lineN + i.size && (r.externalMeasured = null), !(e < r.viewFrom || e >= r.viewTo)) {
            var o = r.view[gr(t, e)];
            if (null != o.node) {
              var a = o.changes || (o.changes = []);
              -1 == W(a, n) && a.push(n);
            }
          }
        }
        function br(t) {
          t.display.viewFrom = t.display.viewTo = t.doc.first, t.display.view = [], t.display.viewOffset = 0;
        }
        function yr(t, e, n, r) {
          var i,
            o = gr(t, e),
            a = t.display.view;
          if (!je || n == t.doc.first + t.doc.size) return {
            index: o,
            lineN: n
          };
          for (var s = t.display.viewFrom, c = 0; c < o; c++) s += a[c].size;
          if (s != e) {
            if (r > 0) {
              if (o == a.length - 1) return null;
              i = s + a[o].size - e, o++;
            } else i = s - e;
            e += i, n += i;
          }
          for (; $e(t.doc, n) != n;) {
            if (o == (r < 0 ? 0 : a.length - 1)) return null;
            n += r * a[o - (r < 0 ? 1 : 0)].size, o += r;
          }
          return {
            index: o,
            lineN: n
          };
        }
        function wr(t) {
          for (var e = t.display.view, n = 0, r = 0; r < e.length; r++) {
            var i = e[r];
            i.hidden || i.node && !i.changes || ++n;
          }
          return n;
        }
        function xr(t) {
          t.display.input.showSelection(t.display.input.prepareSelection());
        }
        function Or(t, e) {
          void 0 === e && (e = !0);
          var n = t.doc,
            r = {},
            i = r.cursors = document.createDocumentFragment(),
            o = r.selection = document.createDocumentFragment(),
            a = t.options.$customCursor;
          a && (e = !0);
          for (var s = 0; s < n.sel.ranges.length; s++) if (e || s != n.sel.primIndex) {
            var c = n.sel.ranges[s];
            if (!(c.from().line >= t.display.viewTo || c.to().line < t.display.viewFrom)) {
              var l = c.empty();
              if (a) {
                var u = a(t, c);
                u && Cr(t, u, i);
              } else (l || t.options.showCursorWhenSelecting) && Cr(t, c.head, i);
              l || kr(t, c, o);
            }
          }
          return r;
        }
        function Cr(t, e, n) {
          var r = Zn(t, e, "div", null, null, !t.options.singleCursorHeightPerLine),
            i = n.appendChild(A("div", " ", "CodeMirror-cursor"));
          if (i.style.left = r.left + "px", i.style.top = r.top + "px", i.style.height = Math.max(0, r.bottom - r.top) * t.options.cursorHeight + "px", /\bcm-fat-cursor\b/.test(t.getWrapperElement().className)) {
            var o = Jn(t, e, "div", null, null),
              a = o.right - o.left;
            i.style.width = (a > 0 ? a : t.defaultCharWidth()) + "px";
          }
          if (r.other) {
            var s = n.appendChild(A("div", " ", "CodeMirror-cursor CodeMirror-secondarycursor"));
            s.style.display = "", s.style.left = r.other.left + "px", s.style.top = r.other.top + "px", s.style.height = .85 * (r.other.bottom - r.other.top) + "px";
          }
        }
        function Sr(t, e) {
          return t.top - e.top || t.left - e.left;
        }
        function kr(t, e, n) {
          var r = t.display,
            i = t.doc,
            o = document.createDocumentFragment(),
            a = An(t.display),
            s = a.left,
            c = Math.max(r.sizerWidth, Dn(t) - r.sizer.offsetLeft) - a.right,
            l = "ltr" == i.direction;
          function u(t, e, n, r) {
            e < 0 && (e = 0), e = Math.round(e), r = Math.round(r), o.appendChild(A("div", null, "CodeMirror-selected", "position: absolute; left: " + t + "px;\n                             top: " + e + "px; width: " + (null == n ? c - t : n) + "px;\n                             height: " + (r - e) + "px"));
          }
          function d(e, n, r) {
            var o,
              a,
              d = Jt(i, e),
              h = d.text.length;
            function f(n, r) {
              return Jn(t, oe(e, n), "div", d, r);
            }
            function p(e, n, r) {
              var i = rr(t, d, null, e),
                o = "ltr" == n == ("after" == r) ? "left" : "right";
              return f("after" == r ? i.begin : i.end - (/\s/.test(d.text.charAt(i.end - 1)) ? 2 : 1), o)[o];
            }
            var g = pt(d, i.direction);
            return function (t, e, n, r) {
              if (!t) return r(e, n, "ltr", 0);
              for (var i = !1, o = 0; o < t.length; ++o) {
                var a = t[o];
                (a.from < n && a.to > e || e == n && a.to == e) && (r(Math.max(a.from, e), Math.min(a.to, n), 1 == a.level ? "rtl" : "ltr", o), i = !0);
              }
              i || r(e, n, "ltr");
            }(g, n || 0, null == r ? h : r, function (t, e, i, d) {
              var v = "ltr" == i,
                m = f(t, v ? "left" : "right"),
                b = f(e - 1, v ? "right" : "left"),
                y = null == n && 0 == t,
                w = null == r && e == h,
                x = 0 == d,
                O = !g || d == g.length - 1;
              if (b.top - m.top <= 3) {
                var C = (l ? w : y) && O,
                  S = (l ? y : w) && x ? s : (v ? m : b).left,
                  k = C ? c : (v ? b : m).right;
                u(S, m.top, k - S, m.bottom);
              } else {
                var T, j, E, P;
                v ? (T = l && y && x ? s : m.left, j = l ? c : p(t, i, "before"), E = l ? s : p(e, i, "after"), P = l && w && O ? c : b.right) : (T = l ? p(t, i, "before") : s, j = !l && y && x ? c : m.right, E = !l && w && O ? s : b.left, P = l ? p(e, i, "after") : c), u(T, m.top, j - T, m.bottom), m.bottom < b.top && u(s, m.bottom, null, b.top), u(E, b.top, P - E, b.bottom);
              }
              (!o || Sr(m, o) < 0) && (o = m), Sr(b, o) < 0 && (o = b), (!a || Sr(m, a) < 0) && (a = m), Sr(b, a) < 0 && (a = b);
            }), {
              start: o,
              end: a
            };
          }
          var h = e.from(),
            f = e.to();
          if (h.line == f.line) d(h.line, h.ch, f.ch);else {
            var p = Jt(i, h.line),
              g = Jt(i, f.line),
              v = Ue(p) == Ue(g),
              m = d(h.line, h.ch, v ? p.text.length + 1 : null).end,
              b = d(f.line, v ? 0 : null, f.ch).start;
            v && (m.top < b.top - 2 ? (u(m.right, m.top, null, m.bottom), u(s, b.top, b.left, b.bottom)) : u(m.right, m.top, b.left - m.right, m.bottom)), m.bottom < b.top && u(s, m.bottom, null, b.top);
          }
          n.appendChild(o);
        }
        function Tr(t) {
          if (t.state.focused) {
            var e = t.display;
            clearInterval(e.blinker);
            var n = !0;
            e.cursorDiv.style.visibility = "", t.options.cursorBlinkRate > 0 ? e.blinker = setInterval(function () {
              t.hasFocus() || Ar(t), e.cursorDiv.style.visibility = (n = !n) ? "" : "hidden";
            }, t.options.cursorBlinkRate) : t.options.cursorBlinkRate < 0 && (e.cursorDiv.style.visibility = "hidden");
          }
        }
        function jr(t) {
          t.hasFocus() || (t.display.input.focus(), t.state.focused || Pr(t));
        }
        function Er(t) {
          t.state.delayingBlurEvent = !0, setTimeout(function () {
            t.state.delayingBlurEvent && (t.state.delayingBlurEvent = !1, t.state.focused && Ar(t));
          }, 100);
        }
        function Pr(t, e) {
          t.state.delayingBlurEvent && !t.state.draggingText && (t.state.delayingBlurEvent = !1), "nocursor" != t.options.readOnly && (t.state.focused || (yt(t, "focus", t, e), t.state.focused = !0, _(t.display.wrapper, "CodeMirror-focused"), t.curOp || t.display.selForContextMenu == t.doc.sel || (t.display.input.reset(), c && setTimeout(function () {
            return t.display.input.reset(!0);
          }, 20)), t.display.input.receivedFocus()), Tr(t));
        }
        function Ar(t, e) {
          t.state.delayingBlurEvent || (t.state.focused && (yt(t, "blur", t, e), t.state.focused = !1, j(t.display.wrapper, "CodeMirror-focused")), clearInterval(t.display.blinker), setTimeout(function () {
            t.state.focused || (t.display.shift = !1);
          }, 150));
        }
        function Mr(t) {
          for (var e = t.display, n = e.lineDiv.offsetTop, r = Math.max(0, e.scroller.getBoundingClientRect().top), i = e.lineDiv.getBoundingClientRect().top, o = 0, c = 0; c < e.view.length; c++) {
            var l = e.view[c],
              u = t.options.lineWrapping,
              d = void 0,
              h = 0;
            if (!l.hidden) {
              if (i += l.line.height, a && s < 8) {
                var f = l.node.offsetTop + l.node.offsetHeight;
                d = f - n, n = f;
              } else {
                var p = l.node.getBoundingClientRect();
                d = p.bottom - p.top, !u && l.text.firstChild && (h = l.text.firstChild.getBoundingClientRect().right - p.left - 1);
              }
              var g = l.line.height - d;
              if ((g > .005 || g < -.005) && (i < r && (o -= g), te(l.line, d), Dr(l.line), l.rest)) for (var v = 0; v < l.rest.length; v++) Dr(l.rest[v]);
              if (h > t.display.sizerWidth) {
                var m = Math.ceil(h / lr(t.display));
                m > t.display.maxLineLength && (t.display.maxLineLength = m, t.display.maxLine = l.line, t.display.maxLineChanged = !0);
              }
            }
          }
          Math.abs(o) > 2 && (e.scroller.scrollTop += o);
        }
        function Dr(t) {
          if (t.widgets) for (var e = 0; e < t.widgets.length; ++e) {
            var n = t.widgets[e],
              r = n.node.parentNode;
            r && (n.height = r.offsetHeight);
          }
        }
        function Lr(t, e, n) {
          var r = n && null != n.top ? Math.max(0, n.top) : t.scroller.scrollTop;
          r = Math.floor(r - En(t));
          var i = n && null != n.bottom ? n.bottom : r + t.wrapper.clientHeight,
            o = ne(e, r),
            a = ne(e, i);
          if (n && n.ensure) {
            var s = n.ensure.from.line,
              c = n.ensure.to.line;
            s < o ? (o = s, a = ne(e, Ye(Jt(e, s)) + t.wrapper.clientHeight)) : Math.min(c, e.lastLine()) >= a && (o = ne(e, Ye(Jt(e, c)) - t.wrapper.clientHeight), a = c);
          }
          return {
            from: o,
            to: Math.max(a, o + 1)
          };
        }
        function _r(t, e) {
          var n = t.display,
            r = cr(t.display);
          e.top < 0 && (e.top = 0);
          var i = t.curOp && null != t.curOp.scrollTop ? t.curOp.scrollTop : n.scroller.scrollTop,
            o = Ln(t),
            a = {};
          e.bottom - e.top > o && (e.bottom = e.top + o);
          var s = t.doc.height + Pn(n),
            c = e.top < r,
            l = e.bottom > s - r;
          if (e.top < i) a.scrollTop = c ? 0 : e.top;else if (e.bottom > i + o) {
            var u = Math.min(e.top, (l ? s : e.bottom) - o);
            u != i && (a.scrollTop = u);
          }
          var d = t.options.fixedGutter ? 0 : n.gutters.offsetWidth,
            h = t.curOp && null != t.curOp.scrollLeft ? t.curOp.scrollLeft : n.scroller.scrollLeft - d,
            f = Dn(t) - n.gutters.offsetWidth,
            p = e.right - e.left > f;
          return p && (e.right = e.left + f), e.left < 10 ? a.scrollLeft = 0 : e.left < h ? a.scrollLeft = Math.max(0, e.left + d - (p ? 0 : 10)) : e.right > f + h - 3 && (a.scrollLeft = e.right + (p ? 0 : 10) - f), a;
        }
        function Nr(t, e) {
          null != e && (Fr(t), t.curOp.scrollTop = (null == t.curOp.scrollTop ? t.doc.scrollTop : t.curOp.scrollTop) + e);
        }
        function Ir(t) {
          Fr(t);
          var e = t.getCursor();
          t.curOp.scrollToPos = {
            from: e,
            to: e,
            margin: t.options.cursorScrollMargin
          };
        }
        function Rr(t, e, n) {
          null == e && null == n || Fr(t), null != e && (t.curOp.scrollLeft = e), null != n && (t.curOp.scrollTop = n);
        }
        function Fr(t) {
          var e = t.curOp.scrollToPos;
          e && (t.curOp.scrollToPos = null, Vr(t, Qn(t, e.from), Qn(t, e.to), e.margin));
        }
        function Vr(t, e, n, r) {
          var i = _r(t, {
            left: Math.min(e.left, n.left),
            top: Math.min(e.top, n.top) - r,
            right: Math.max(e.right, n.right),
            bottom: Math.max(e.bottom, n.bottom) + r
          });
          Rr(t, i.scrollLeft, i.scrollTop);
        }
        function zr(t, e) {
          Math.abs(t.doc.scrollTop - e) < 2 || (n || fi(t, {
            top: e
          }), Hr(t, e, !0), n && fi(t), ci(t, 100));
        }
        function Hr(t, e, n) {
          e = Math.max(0, Math.min(t.display.scroller.scrollHeight - t.display.scroller.clientHeight, e)), (t.display.scroller.scrollTop != e || n) && (t.doc.scrollTop = e, t.display.scrollbars.setScrollTop(e), t.display.scroller.scrollTop != e && (t.display.scroller.scrollTop = e));
        }
        function Br(t, e, n, r) {
          e = Math.max(0, Math.min(e, t.display.scroller.scrollWidth - t.display.scroller.clientWidth)), (n ? e == t.doc.scrollLeft : Math.abs(t.doc.scrollLeft - e) < 2) && !r || (t.doc.scrollLeft = e, vi(t), t.display.scroller.scrollLeft != e && (t.display.scroller.scrollLeft = e), t.display.scrollbars.setScrollLeft(e));
        }
        function Ur(t) {
          var e = t.display,
            n = e.gutters.offsetWidth,
            r = Math.round(t.doc.height + Pn(t.display));
          return {
            clientHeight: e.scroller.clientHeight,
            viewHeight: e.wrapper.clientHeight,
            scrollWidth: e.scroller.scrollWidth,
            clientWidth: e.scroller.clientWidth,
            viewWidth: e.wrapper.clientWidth,
            barLeft: t.options.fixedGutter ? n : 0,
            docHeight: r,
            scrollHeight: r + Mn(t) + e.barHeight,
            nativeBarWidth: e.nativeBarWidth,
            gutterWidth: n
          };
        }
        var $r = function $r(t, e, n) {
          this.cm = n;
          var r = this.vert = A("div", [A("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar"),
            i = this.horiz = A("div", [A("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
          r.tabIndex = i.tabIndex = -1, t(r), t(i), vt(r, "scroll", function () {
            r.clientHeight && e(r.scrollTop, "vertical");
          }), vt(i, "scroll", function () {
            i.clientWidth && e(i.scrollLeft, "horizontal");
          }), this.checkedZeroWidth = !1, a && s < 8 && (this.horiz.style.minHeight = this.vert.style.minWidth = "18px");
        };
        $r.prototype.update = function (t) {
          var e = t.scrollWidth > t.clientWidth + 1,
            n = t.scrollHeight > t.clientHeight + 1,
            r = t.nativeBarWidth;
          if (n) {
            this.vert.style.display = "block", this.vert.style.bottom = e ? r + "px" : "0";
            var i = t.viewHeight - (e ? r : 0);
            this.vert.firstChild.style.height = Math.max(0, t.scrollHeight - t.clientHeight + i) + "px";
          } else this.vert.scrollTop = 0, this.vert.style.display = "", this.vert.firstChild.style.height = "0";
          if (e) {
            this.horiz.style.display = "block", this.horiz.style.right = n ? r + "px" : "0", this.horiz.style.left = t.barLeft + "px";
            var o = t.viewWidth - t.barLeft - (n ? r : 0);
            this.horiz.firstChild.style.width = Math.max(0, t.scrollWidth - t.clientWidth + o) + "px";
          } else this.horiz.style.display = "", this.horiz.firstChild.style.width = "0";
          return !this.checkedZeroWidth && t.clientHeight > 0 && (0 == r && this.zeroWidthHack(), this.checkedZeroWidth = !0), {
            right: n ? r : 0,
            bottom: e ? r : 0
          };
        }, $r.prototype.setScrollLeft = function (t) {
          this.horiz.scrollLeft != t && (this.horiz.scrollLeft = t), this.disableHoriz && this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
        }, $r.prototype.setScrollTop = function (t) {
          this.vert.scrollTop != t && (this.vert.scrollTop = t), this.disableVert && this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
        }, $r.prototype.zeroWidthHack = function () {
          var t = y && !p ? "12px" : "18px";
          this.horiz.style.height = this.vert.style.width = t, this.horiz.style.visibility = this.vert.style.visibility = "hidden", this.disableHoriz = new $(), this.disableVert = new $();
        }, $r.prototype.enableZeroWidthBar = function (t, e, n) {
          t.style.visibility = "", e.set(1e3, function r() {
            var i = t.getBoundingClientRect();
            ("vert" == n ? document.elementFromPoint(i.right - 1, (i.top + i.bottom) / 2) : document.elementFromPoint((i.right + i.left) / 2, i.bottom - 1)) != t ? t.style.visibility = "hidden" : e.set(1e3, r);
          });
        }, $r.prototype.clear = function () {
          var t = this.horiz.parentNode;
          t.removeChild(this.horiz), t.removeChild(this.vert);
        };
        var Wr = function Wr() {};
        function qr(t, e) {
          e || (e = Ur(t));
          var n = t.display.barWidth,
            r = t.display.barHeight;
          Gr(t, e);
          for (var i = 0; i < 4 && n != t.display.barWidth || r != t.display.barHeight; i++) n != t.display.barWidth && t.options.lineWrapping && Mr(t), Gr(t, Ur(t)), n = t.display.barWidth, r = t.display.barHeight;
        }
        function Gr(t, e) {
          var n = t.display,
            r = n.scrollbars.update(e);
          n.sizer.style.paddingRight = (n.barWidth = r.right) + "px", n.sizer.style.paddingBottom = (n.barHeight = r.bottom) + "px", n.heightForcer.style.borderBottom = r.bottom + "px solid transparent", r.right && r.bottom ? (n.scrollbarFiller.style.display = "block", n.scrollbarFiller.style.height = r.bottom + "px", n.scrollbarFiller.style.width = r.right + "px") : n.scrollbarFiller.style.display = "", r.bottom && t.options.coverGutterNextToScrollbar && t.options.fixedGutter ? (n.gutterFiller.style.display = "block", n.gutterFiller.style.height = r.bottom + "px", n.gutterFiller.style.width = e.gutterWidth + "px") : n.gutterFiller.style.display = "";
        }
        Wr.prototype.update = function () {
          return {
            bottom: 0,
            right: 0
          };
        }, Wr.prototype.setScrollLeft = function () {}, Wr.prototype.setScrollTop = function () {}, Wr.prototype.clear = function () {};
        var Yr = {
          native: $r,
          null: Wr
        };
        function Kr(t) {
          t.display.scrollbars && (t.display.scrollbars.clear(), t.display.scrollbars.addClass && j(t.display.wrapper, t.display.scrollbars.addClass)), t.display.scrollbars = new Yr[t.options.scrollbarStyle](function (e) {
            t.display.wrapper.insertBefore(e, t.display.scrollbarFiller), vt(e, "mousedown", function () {
              t.state.focused && setTimeout(function () {
                return t.display.input.focus();
              }, 0);
            }), e.setAttribute("cm-not-content", "true");
          }, function (e, n) {
            "horizontal" == n ? Br(t, e) : zr(t, e);
          }, t), t.display.scrollbars.addClass && _(t.display.wrapper, t.display.scrollbars.addClass);
        }
        var Xr = 0;
        function Jr(t) {
          var e;
          t.curOp = {
            cm: t,
            viewChanged: !1,
            startHeight: t.doc.height,
            forceUpdate: !1,
            updateInput: 0,
            typing: !1,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: !1,
            updateMaxLine: !1,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: !1,
            id: ++Xr,
            markArrays: null
          }, e = t.curOp, dn ? dn.ops.push(e) : e.ownsGroup = dn = {
            ops: [e],
            delayedCallbacks: []
          };
        }
        function Zr(t) {
          var e = t.curOp;
          e && function (t, e) {
            var n = t.ownsGroup;
            if (n) try {
              !function (t) {
                var e = t.delayedCallbacks,
                  n = 0;
                do {
                  for (; n < e.length; n++) e[n].call(null);
                  for (var r = 0; r < t.ops.length; r++) {
                    var i = t.ops[r];
                    if (i.cursorActivityHandlers) for (; i.cursorActivityCalled < i.cursorActivityHandlers.length;) i.cursorActivityHandlers[i.cursorActivityCalled++].call(null, i.cm);
                  }
                } while (n < e.length);
              }(n);
            } finally {
              dn = null, function (t) {
                for (var e = 0; e < t.ops.length; e++) t.ops[e].cm.curOp = null;
                !function (t) {
                  for (var e = t.ops, n = 0; n < e.length; n++) Qr(e[n]);
                  for (var r = 0; r < e.length; r++) ti(e[r]);
                  for (var i = 0; i < e.length; i++) ei(e[i]);
                  for (var o = 0; o < e.length; o++) ni(e[o]);
                  for (var a = 0; a < e.length; a++) ri(e[a]);
                }(t);
              }(n);
            }
          }(e);
        }
        function Qr(t) {
          var e = t.cm,
            n = e.display;
          !function (t) {
            var e = t.display;
            !e.scrollbarsClipped && e.scroller.offsetWidth && (e.nativeBarWidth = e.scroller.offsetWidth - e.scroller.clientWidth, e.heightForcer.style.height = Mn(t) + "px", e.sizer.style.marginBottom = -e.nativeBarWidth + "px", e.sizer.style.borderRightWidth = Mn(t) + "px", e.scrollbarsClipped = !0);
          }(e), t.updateMaxLine && Xe(e), t.mustUpdate = t.viewChanged || t.forceUpdate || null != t.scrollTop || t.scrollToPos && (t.scrollToPos.from.line < n.viewFrom || t.scrollToPos.to.line >= n.viewTo) || n.maxLineChanged && e.options.lineWrapping, t.update = t.mustUpdate && new ui(e, t.mustUpdate && {
            top: t.scrollTop,
            ensure: t.scrollToPos
          }, t.forceUpdate);
        }
        function ti(t) {
          t.updatedDisplay = t.mustUpdate && di(t.cm, t.update);
        }
        function ei(t) {
          var e = t.cm,
            n = e.display;
          t.updatedDisplay && Mr(e), t.barMeasure = Ur(e), n.maxLineChanged && !e.options.lineWrapping && (t.adjustWidthTo = Nn(e, n.maxLine, n.maxLine.text.length).left + 3, e.display.sizerWidth = t.adjustWidthTo, t.barMeasure.scrollWidth = Math.max(n.scroller.clientWidth, n.sizer.offsetLeft + t.adjustWidthTo + Mn(e) + e.display.barWidth), t.maxScrollLeft = Math.max(0, n.sizer.offsetLeft + t.adjustWidthTo - Dn(e))), (t.updatedDisplay || t.selectionChanged) && (t.preparedSelection = n.input.prepareSelection());
        }
        function ni(t) {
          var e = t.cm;
          null != t.adjustWidthTo && (e.display.sizer.style.minWidth = t.adjustWidthTo + "px", t.maxScrollLeft < e.doc.scrollLeft && Br(e, Math.min(e.display.scroller.scrollLeft, t.maxScrollLeft), !0), e.display.maxLineChanged = !1);
          var n = t.focus && t.focus == L(F(e));
          t.preparedSelection && e.display.input.showSelection(t.preparedSelection, n), (t.updatedDisplay || t.startHeight != e.doc.height) && qr(e, t.barMeasure), t.updatedDisplay && gi(e, t.barMeasure), t.selectionChanged && Tr(e), e.state.focused && t.updateInput && e.display.input.reset(t.typing), n && jr(t.cm);
        }
        function ri(t) {
          var e = t.cm,
            n = e.display,
            r = e.doc;
          t.updatedDisplay && hi(e, t.update), null == n.wheelStartX || null == t.scrollTop && null == t.scrollLeft && !t.scrollToPos || (n.wheelStartX = n.wheelStartY = null), null != t.scrollTop && Hr(e, t.scrollTop, t.forceScroll), null != t.scrollLeft && Br(e, t.scrollLeft, !0, !0), t.scrollToPos && function (t, e) {
            if (!wt(t, "scrollCursorIntoView")) {
              var n = t.display,
                r = n.sizer.getBoundingClientRect(),
                i = null,
                o = n.wrapper.ownerDocument;
              if (e.top + r.top < 0 ? i = !0 : e.bottom + r.top > (o.defaultView.innerHeight || o.documentElement.clientHeight) && (i = !1), null != i && !g) {
                var a = A("div", "​", null, "position: absolute;\n                         top: " + (e.top - n.viewOffset - En(t.display)) + "px;\n                         height: " + (e.bottom - e.top + Mn(t) + n.barHeight) + "px;\n                         left: " + e.left + "px; width: " + Math.max(2, e.right - e.left) + "px;");
                t.display.lineSpace.appendChild(a), a.scrollIntoView(i), t.display.lineSpace.removeChild(a);
              }
            }
          }(e, function (t, e, n, r) {
            var i;
            null == r && (r = 0), t.options.lineWrapping || e != n || (n = "before" == e.sticky ? oe(e.line, e.ch + 1, "before") : e, e = e.ch ? oe(e.line, "before" == e.sticky ? e.ch - 1 : e.ch, "after") : e);
            for (var o = 0; o < 5; o++) {
              var a = !1,
                s = Zn(t, e),
                c = n && n != e ? Zn(t, n) : s,
                l = _r(t, i = {
                  left: Math.min(s.left, c.left),
                  top: Math.min(s.top, c.top) - r,
                  right: Math.max(s.left, c.left),
                  bottom: Math.max(s.bottom, c.bottom) + r
                }),
                u = t.doc.scrollTop,
                d = t.doc.scrollLeft;
              if (null != l.scrollTop && (zr(t, l.scrollTop), Math.abs(t.doc.scrollTop - u) > 1 && (a = !0)), null != l.scrollLeft && (Br(t, l.scrollLeft), Math.abs(t.doc.scrollLeft - d) > 1 && (a = !0)), !a) break;
            }
            return i;
          }(e, he(r, t.scrollToPos.from), he(r, t.scrollToPos.to), t.scrollToPos.margin));
          var i = t.maybeHiddenMarkers,
            o = t.maybeUnhiddenMarkers;
          if (i) for (var a = 0; a < i.length; ++a) i[a].lines.length || yt(i[a], "hide");
          if (o) for (var s = 0; s < o.length; ++s) o[s].lines.length && yt(o[s], "unhide");
          n.wrapper.offsetHeight && (r.scrollTop = e.display.scroller.scrollTop), t.changeObjs && yt(e, "changes", e, t.changeObjs), t.update && t.update.finish();
        }
        function ii(t, e) {
          if (t.curOp) return e();
          Jr(t);
          try {
            return e();
          } finally {
            Zr(t);
          }
        }
        function oi(t, e) {
          return function () {
            if (t.curOp) return e.apply(t, arguments);
            Jr(t);
            try {
              return e.apply(t, arguments);
            } finally {
              Zr(t);
            }
          };
        }
        function ai(t) {
          return function () {
            if (this.curOp) return t.apply(this, arguments);
            Jr(this);
            try {
              return t.apply(this, arguments);
            } finally {
              Zr(this);
            }
          };
        }
        function si(t) {
          return function () {
            var e = this.cm;
            if (!e || e.curOp) return t.apply(this, arguments);
            Jr(e);
            try {
              return t.apply(this, arguments);
            } finally {
              Zr(e);
            }
          };
        }
        function ci(t, e) {
          t.doc.highlightFrontier < t.display.viewTo && t.state.highlight.set(e, H(li, t));
        }
        function li(t) {
          var e = t.doc;
          if (!(e.highlightFrontier >= t.display.viewTo)) {
            var n = +new Date() + t.options.workTime,
              r = be(t, e.highlightFrontier),
              i = [];
            e.iter(r.line, Math.min(e.first + e.size, t.display.viewTo + 500), function (o) {
              if (r.line >= t.display.viewFrom) {
                var a = o.styles,
                  s = o.text.length > t.options.maxHighlightLength ? Gt(e.mode, r.state) : null,
                  c = ve(t, o, r, !0);
                s && (r.state = s), o.styles = c.styles;
                var l = o.styleClasses,
                  u = c.classes;
                u ? o.styleClasses = u : l && (o.styleClasses = null);
                for (var d = !a || a.length != o.styles.length || l != u && (!l || !u || l.bgClass != u.bgClass || l.textClass != u.textClass), h = 0; !d && h < a.length; ++h) d = a[h] != o.styles[h];
                d && i.push(r.line), o.stateAfter = r.save(), r.nextLine();
              } else o.text.length <= t.options.maxHighlightLength && ye(t, o.text, r), o.stateAfter = r.line % 5 == 0 ? r.save() : null, r.nextLine();
              if (+new Date() > n) return ci(t, t.options.workDelay), !0;
            }), e.highlightFrontier = r.line, e.modeFrontier = Math.max(e.modeFrontier, r.line), i.length && ii(t, function () {
              for (var e = 0; e < i.length; e++) mr(t, i[e], "text");
            });
          }
        }
        var ui = function ui(t, e, n) {
          var r = t.display;
          this.viewport = e, this.visible = Lr(r, t.doc, e), this.editorIsHidden = !r.wrapper.offsetWidth, this.wrapperHeight = r.wrapper.clientHeight, this.wrapperWidth = r.wrapper.clientWidth, this.oldDisplayWidth = Dn(t), this.force = n, this.dims = ur(t), this.events = [];
        };
        function di(t, e) {
          var n = t.display,
            r = t.doc;
          if (e.editorIsHidden) return br(t), !1;
          if (!e.force && e.visible.from >= n.viewFrom && e.visible.to <= n.viewTo && (null == n.updateLineNumbers || n.updateLineNumbers >= n.viewTo) && n.renderedView == n.view && 0 == wr(t)) return !1;
          mi(t) && (br(t), e.dims = ur(t));
          var i = r.first + r.size,
            o = Math.max(e.visible.from - t.options.viewportMargin, r.first),
            a = Math.min(i, e.visible.to + t.options.viewportMargin);
          n.viewFrom < o && o - n.viewFrom < 20 && (o = Math.max(r.first, n.viewFrom)), n.viewTo > a && n.viewTo - a < 20 && (a = Math.min(i, n.viewTo)), je && (o = $e(t.doc, o), a = We(t.doc, a));
          var s = o != n.viewFrom || a != n.viewTo || n.lastWrapHeight != e.wrapperHeight || n.lastWrapWidth != e.wrapperWidth;
          !function (t, e, n) {
            var r = t.display;
            0 == r.view.length || e >= r.viewTo || n <= r.viewFrom ? (r.view = un(t, e, n), r.viewFrom = e) : (r.viewFrom > e ? r.view = un(t, e, r.viewFrom).concat(r.view) : r.viewFrom < e && (r.view = r.view.slice(gr(t, e))), r.viewFrom = e, r.viewTo < n ? r.view = r.view.concat(un(t, r.viewTo, n)) : r.viewTo > n && (r.view = r.view.slice(0, gr(t, n)))), r.viewTo = n;
          }(t, o, a), n.viewOffset = Ye(Jt(t.doc, n.viewFrom)), t.display.mover.style.top = n.viewOffset + "px";
          var l = wr(t);
          if (!s && 0 == l && !e.force && n.renderedView == n.view && (null == n.updateLineNumbers || n.updateLineNumbers >= n.viewTo)) return !1;
          var u = function (t) {
            if (t.hasFocus()) return null;
            var e = L(F(t));
            if (!e || !D(t.display.lineDiv, e)) return null;
            var n = {
              activeElt: e
            };
            if (window.getSelection) {
              var r = z(t).getSelection();
              r.anchorNode && r.extend && D(t.display.lineDiv, r.anchorNode) && (n.anchorNode = r.anchorNode, n.anchorOffset = r.anchorOffset, n.focusNode = r.focusNode, n.focusOffset = r.focusOffset);
            }
            return n;
          }(t);
          return l > 4 && (n.lineDiv.style.display = "none"), function (t, e, n) {
            var r = t.display,
              i = t.options.lineNumbers,
              o = r.lineDiv,
              a = o.firstChild;
            function s(e) {
              var n = e.nextSibling;
              return c && y && t.display.currentWheelTarget == e ? e.style.display = "none" : e.parentNode.removeChild(e), n;
            }
            for (var l = r.view, u = r.viewFrom, d = 0; d < l.length; d++) {
              var h = l[d];
              if (h.hidden) ;else if (h.node && h.node.parentNode == o) {
                for (; a != h.node;) a = s(a);
                var f = i && null != e && e <= u && h.lineNumber;
                h.changes && (W(h.changes, "gutter") > -1 && (f = !1), gn(t, h, u, n)), f && (E(h.lineNumber), h.lineNumber.appendChild(document.createTextNode(ie(t.options, u)))), a = h.node.nextSibling;
              } else {
                var p = On(t, h, u, n);
                o.insertBefore(p, a);
              }
              u += h.size;
            }
            for (; a;) a = s(a);
          }(t, n.updateLineNumbers, e.dims), l > 4 && (n.lineDiv.style.display = ""), n.renderedView = n.view, function (t) {
            if (t && t.activeElt && t.activeElt != L(V(t.activeElt)) && (t.activeElt.focus(), !/^(INPUT|TEXTAREA)$/.test(t.activeElt.nodeName) && t.anchorNode && D(document.body, t.anchorNode) && D(document.body, t.focusNode))) {
              var e = t.activeElt.ownerDocument,
                n = e.defaultView.getSelection(),
                r = e.createRange();
              r.setEnd(t.anchorNode, t.anchorOffset), r.collapse(!1), n.removeAllRanges(), n.addRange(r), n.extend(t.focusNode, t.focusOffset);
            }
          }(u), E(n.cursorDiv), E(n.selectionDiv), n.gutters.style.height = n.sizer.style.minHeight = 0, s && (n.lastWrapHeight = e.wrapperHeight, n.lastWrapWidth = e.wrapperWidth, ci(t, 400)), n.updateLineNumbers = null, !0;
        }
        function hi(t, e) {
          for (var n = e.viewport, r = !0;; r = !1) {
            if (r && t.options.lineWrapping && e.oldDisplayWidth != Dn(t)) r && (e.visible = Lr(t.display, t.doc, n));else if (n && null != n.top && (n = {
              top: Math.min(t.doc.height + Pn(t.display) - Ln(t), n.top)
            }), e.visible = Lr(t.display, t.doc, n), e.visible.from >= t.display.viewFrom && e.visible.to <= t.display.viewTo) break;
            if (!di(t, e)) break;
            Mr(t);
            var i = Ur(t);
            xr(t), qr(t, i), gi(t, i), e.force = !1;
          }
          e.signal(t, "update", t), t.display.viewFrom == t.display.reportedViewFrom && t.display.viewTo == t.display.reportedViewTo || (e.signal(t, "viewportChange", t, t.display.viewFrom, t.display.viewTo), t.display.reportedViewFrom = t.display.viewFrom, t.display.reportedViewTo = t.display.viewTo);
        }
        function fi(t, e) {
          var n = new ui(t, e);
          if (di(t, n)) {
            Mr(t), hi(t, n);
            var r = Ur(t);
            xr(t), qr(t, r), gi(t, r), n.finish();
          }
        }
        function pi(t) {
          var e = t.gutters.offsetWidth;
          t.sizer.style.marginLeft = e + "px", fn(t, "gutterChanged", t);
        }
        function gi(t, e) {
          t.display.sizer.style.minHeight = e.docHeight + "px", t.display.heightForcer.style.top = e.docHeight + "px", t.display.gutters.style.height = e.docHeight + t.display.barHeight + Mn(t) + "px";
        }
        function vi(t) {
          var e = t.display,
            n = e.view;
          if (e.alignWidgets || e.gutters.firstChild && t.options.fixedGutter) {
            for (var r = dr(e) - e.scroller.scrollLeft + t.doc.scrollLeft, i = e.gutters.offsetWidth, o = r + "px", a = 0; a < n.length; a++) if (!n[a].hidden) {
              t.options.fixedGutter && (n[a].gutter && (n[a].gutter.style.left = o), n[a].gutterBackground && (n[a].gutterBackground.style.left = o));
              var s = n[a].alignable;
              if (s) for (var c = 0; c < s.length; c++) s[c].style.left = o;
            }
            t.options.fixedGutter && (e.gutters.style.left = r + i + "px");
          }
        }
        function mi(t) {
          if (!t.options.lineNumbers) return !1;
          var e = t.doc,
            n = ie(t.options, e.first + e.size - 1),
            r = t.display;
          if (n.length != r.lineNumChars) {
            var i = r.measure.appendChild(A("div", [A("div", n)], "CodeMirror-linenumber CodeMirror-gutter-elt")),
              o = i.firstChild.offsetWidth,
              a = i.offsetWidth - o;
            return r.lineGutter.style.width = "", r.lineNumInnerWidth = Math.max(o, r.lineGutter.offsetWidth - a) + 1, r.lineNumWidth = r.lineNumInnerWidth + a, r.lineNumChars = r.lineNumInnerWidth ? n.length : -1, r.lineGutter.style.width = r.lineNumWidth + "px", pi(t.display), !0;
          }
          return !1;
        }
        function bi(t, e) {
          for (var n = [], r = !1, i = 0; i < t.length; i++) {
            var o = t[i],
              a = null;
            if ("string" != typeof o && (a = o.style, o = o.className), "CodeMirror-linenumbers" == o) {
              if (!e) continue;
              r = !0;
            }
            n.push({
              className: o,
              style: a
            });
          }
          return e && !r && n.push({
            className: "CodeMirror-linenumbers",
            style: null
          }), n;
        }
        function yi(t) {
          var e = t.gutters,
            n = t.gutterSpecs;
          E(e), t.lineGutter = null;
          for (var r = 0; r < n.length; ++r) {
            var i = n[r],
              o = i.className,
              a = i.style,
              s = e.appendChild(A("div", null, "CodeMirror-gutter " + o));
            a && (s.style.cssText = a), "CodeMirror-linenumbers" == o && (t.lineGutter = s, s.style.width = (t.lineNumWidth || 1) + "px");
          }
          e.style.display = n.length ? "" : "none", pi(t);
        }
        function wi(t) {
          yi(t.display), vr(t), vi(t);
        }
        function xi(t, e, r, i) {
          var o = this;
          this.input = r, o.scrollbarFiller = A("div", null, "CodeMirror-scrollbar-filler"), o.scrollbarFiller.setAttribute("cm-not-content", "true"), o.gutterFiller = A("div", null, "CodeMirror-gutter-filler"), o.gutterFiller.setAttribute("cm-not-content", "true"), o.lineDiv = M("div", null, "CodeMirror-code"), o.selectionDiv = A("div", null, null, "position: relative; z-index: 1"), o.cursorDiv = A("div", null, "CodeMirror-cursors"), o.measure = A("div", null, "CodeMirror-measure"), o.lineMeasure = A("div", null, "CodeMirror-measure"), o.lineSpace = M("div", [o.measure, o.lineMeasure, o.selectionDiv, o.cursorDiv, o.lineDiv], null, "position: relative; outline: none");
          var l = M("div", [o.lineSpace], "CodeMirror-lines");
          o.mover = A("div", [l], null, "position: relative"), o.sizer = A("div", [o.mover], "CodeMirror-sizer"), o.sizerWidth = null, o.heightForcer = A("div", null, null, "position: absolute; height: 50px; width: 1px;"), o.gutters = A("div", null, "CodeMirror-gutters"), o.lineGutter = null, o.scroller = A("div", [o.sizer, o.heightForcer, o.gutters], "CodeMirror-scroll"), o.scroller.setAttribute("tabIndex", "-1"), o.wrapper = A("div", [o.scrollbarFiller, o.gutterFiller, o.scroller], "CodeMirror"), u && d >= 105 && (o.wrapper.style.clipPath = "inset(0px)"), o.wrapper.setAttribute("translate", "no"), a && s < 8 && (o.gutters.style.zIndex = -1, o.scroller.style.paddingRight = 0), c || n && b || (o.scroller.draggable = !0), t && (t.appendChild ? t.appendChild(o.wrapper) : t(o.wrapper)), o.viewFrom = o.viewTo = e.first, o.reportedViewFrom = o.reportedViewTo = e.first, o.view = [], o.renderedView = null, o.externalMeasured = null, o.viewOffset = 0, o.lastWrapHeight = o.lastWrapWidth = 0, o.updateLineNumbers = null, o.nativeBarWidth = o.barHeight = o.barWidth = 0, o.scrollbarsClipped = !1, o.lineNumWidth = o.lineNumInnerWidth = o.lineNumChars = null, o.alignWidgets = !1, o.cachedCharWidth = o.cachedTextHeight = o.cachedPaddingH = null, o.maxLine = null, o.maxLineLength = 0, o.maxLineChanged = !1, o.wheelDX = o.wheelDY = o.wheelStartX = o.wheelStartY = null, o.shift = !1, o.selForContextMenu = null, o.activeTouch = null, o.gutterSpecs = bi(i.gutters, i.lineNumbers), yi(o), r.init(o);
        }
        ui.prototype.signal = function (t, e) {
          Ot(t, e) && this.events.push(arguments);
        }, ui.prototype.finish = function () {
          for (var t = 0; t < this.events.length; t++) yt.apply(null, this.events[t]);
        };
        var Oi = 0,
          Ci = null;
        function Si(t) {
          var e = t.wheelDeltaX,
            n = t.wheelDeltaY;
          return null == e && t.detail && t.axis == t.HORIZONTAL_AXIS && (e = t.detail), null == n && t.detail && t.axis == t.VERTICAL_AXIS ? n = t.detail : null == n && (n = t.wheelDelta), {
            x: e,
            y: n
          };
        }
        function ki(t) {
          var e = Si(t);
          return e.x *= Ci, e.y *= Ci, e;
        }
        function Ti(t, e) {
          u && 102 == d && (null == t.display.chromeScrollHack ? t.display.sizer.style.pointerEvents = "none" : clearTimeout(t.display.chromeScrollHack), t.display.chromeScrollHack = setTimeout(function () {
            t.display.chromeScrollHack = null, t.display.sizer.style.pointerEvents = "";
          }, 100));
          var r = Si(e),
            i = r.x,
            o = r.y,
            a = Ci;
          0 === e.deltaMode && (i = e.deltaX, o = e.deltaY, a = 1);
          var s = t.display,
            l = s.scroller,
            f = l.scrollWidth > l.clientWidth,
            p = l.scrollHeight > l.clientHeight;
          if (i && f || o && p) {
            if (o && y && c) t: for (var g = e.target, v = s.view; g != l; g = g.parentNode) for (var m = 0; m < v.length; m++) if (v[m].node == g) {
              t.display.currentWheelTarget = g;
              break t;
            }
            if (i && !n && !h && null != a) return o && p && zr(t, Math.max(0, l.scrollTop + o * a)), Br(t, Math.max(0, l.scrollLeft + i * a)), (!o || o && p) && St(e), void (s.wheelStartX = null);
            if (o && null != a) {
              var b = o * a,
                w = t.doc.scrollTop,
                x = w + s.wrapper.clientHeight;
              b < 0 ? w = Math.max(0, w + b - 50) : x = Math.min(t.doc.height, x + b + 50), fi(t, {
                top: w,
                bottom: x
              });
            }
            Oi < 20 && 0 !== e.deltaMode && (null == s.wheelStartX ? (s.wheelStartX = l.scrollLeft, s.wheelStartY = l.scrollTop, s.wheelDX = i, s.wheelDY = o, setTimeout(function () {
              if (null != s.wheelStartX) {
                var t = l.scrollLeft - s.wheelStartX,
                  e = l.scrollTop - s.wheelStartY,
                  n = e && s.wheelDY && e / s.wheelDY || t && s.wheelDX && t / s.wheelDX;
                s.wheelStartX = s.wheelStartY = null, n && (Ci = (Ci * Oi + n) / (Oi + 1), ++Oi);
              }
            }, 200)) : (s.wheelDX += i, s.wheelDY += o));
          }
        }
        a ? Ci = -.53 : n ? Ci = 15 : u ? Ci = -.7 : f && (Ci = -1 / 3);
        var ji = function ji(t, e) {
          this.ranges = t, this.primIndex = e;
        };
        ji.prototype.primary = function () {
          return this.ranges[this.primIndex];
        }, ji.prototype.equals = function (t) {
          if (t == this) return !0;
          if (t.primIndex != this.primIndex || t.ranges.length != this.ranges.length) return !1;
          for (var e = 0; e < this.ranges.length; e++) {
            var n = this.ranges[e],
              r = t.ranges[e];
            if (!se(n.anchor, r.anchor) || !se(n.head, r.head)) return !1;
          }
          return !0;
        }, ji.prototype.deepCopy = function () {
          for (var t = [], e = 0; e < this.ranges.length; e++) t[e] = new Ei(ce(this.ranges[e].anchor), ce(this.ranges[e].head));
          return new ji(t, this.primIndex);
        }, ji.prototype.somethingSelected = function () {
          for (var t = 0; t < this.ranges.length; t++) if (!this.ranges[t].empty()) return !0;
          return !1;
        }, ji.prototype.contains = function (t, e) {
          e || (e = t);
          for (var n = 0; n < this.ranges.length; n++) {
            var r = this.ranges[n];
            if (ae(e, r.from()) >= 0 && ae(t, r.to()) <= 0) return n;
          }
          return -1;
        };
        var Ei = function Ei(t, e) {
          this.anchor = t, this.head = e;
        };
        function Pi(t, e, n) {
          var r = t && t.options.selectionsMayTouch,
            i = e[n];
          e.sort(function (t, e) {
            return ae(t.from(), e.from());
          }), n = W(e, i);
          for (var o = 1; o < e.length; o++) {
            var a = e[o],
              s = e[o - 1],
              c = ae(s.to(), a.from());
            if (r && !a.empty() ? c > 0 : c >= 0) {
              var l = ue(s.from(), a.from()),
                u = le(s.to(), a.to()),
                d = s.empty() ? a.from() == a.head : s.from() == s.head;
              o <= n && --n, e.splice(--o, 2, new Ei(d ? u : l, d ? l : u));
            }
          }
          return new ji(e, n);
        }
        function Ai(t, e) {
          return new ji([new Ei(t, e || t)], 0);
        }
        function Mi(t) {
          return t.text ? oe(t.from.line + t.text.length - 1, Q(t.text).length + (1 == t.text.length ? t.from.ch : 0)) : t.to;
        }
        function Di(t, e) {
          if (ae(t, e.from) < 0) return t;
          if (ae(t, e.to) <= 0) return Mi(e);
          var n = t.line + e.text.length - (e.to.line - e.from.line) - 1,
            r = t.ch;
          return t.line == e.to.line && (r += Mi(e).ch - e.to.ch), oe(n, r);
        }
        function Li(t, e) {
          for (var n = [], r = 0; r < t.sel.ranges.length; r++) {
            var i = t.sel.ranges[r];
            n.push(new Ei(Di(i.anchor, e), Di(i.head, e)));
          }
          return Pi(t.cm, n, t.sel.primIndex);
        }
        function _i(t, e, n) {
          return t.line == e.line ? oe(n.line, t.ch - e.ch + n.ch) : oe(n.line + (t.line - e.line), t.ch);
        }
        function Ni(t) {
          t.doc.mode = $t(t.options, t.doc.modeOption), Ii(t);
        }
        function Ii(t) {
          t.doc.iter(function (t) {
            t.stateAfter && (t.stateAfter = null), t.styles && (t.styles = null);
          }), t.doc.modeFrontier = t.doc.highlightFrontier = t.doc.first, ci(t, 100), t.state.modeGen++, t.curOp && vr(t);
        }
        function Ri(t, e) {
          return 0 == e.from.ch && 0 == e.to.ch && "" == Q(e.text) && (!t.cm || t.cm.options.wholeLineUpdateBefore);
        }
        function Fi(t, e, n, r) {
          function i(t) {
            return n ? n[t] : null;
          }
          function o(t, n, i) {
            !function (t, e, n, r) {
              t.text = e, t.stateAfter && (t.stateAfter = null), t.styles && (t.styles = null), null != t.order && (t.order = null), Le(t), _e(t, n);
              var i = r ? r(t) : 1;
              i != t.height && te(t, i);
            }(t, n, i, r), fn(t, "change", t, e);
          }
          function a(t, e) {
            for (var n = [], o = t; o < e; ++o) n.push(new Je(l[o], i(o), r));
            return n;
          }
          var s = e.from,
            c = e.to,
            l = e.text,
            u = Jt(t, s.line),
            d = Jt(t, c.line),
            h = Q(l),
            f = i(l.length - 1),
            p = c.line - s.line;
          if (e.full) t.insert(0, a(0, l.length)), t.remove(l.length, t.size - l.length);else if (Ri(t, e)) {
            var g = a(0, l.length - 1);
            o(d, d.text, f), p && t.remove(s.line, p), g.length && t.insert(s.line, g);
          } else if (u == d) {
            if (1 == l.length) o(u, u.text.slice(0, s.ch) + h + u.text.slice(c.ch), f);else {
              var v = a(1, l.length - 1);
              v.push(new Je(h + u.text.slice(c.ch), f, r)), o(u, u.text.slice(0, s.ch) + l[0], i(0)), t.insert(s.line + 1, v);
            }
          } else if (1 == l.length) o(u, u.text.slice(0, s.ch) + l[0] + d.text.slice(c.ch), i(0)), t.remove(s.line + 1, p);else {
            o(u, u.text.slice(0, s.ch) + l[0], i(0)), o(d, h + d.text.slice(c.ch), f);
            var m = a(1, l.length - 1);
            p > 1 && t.remove(s.line + 1, p - 1), t.insert(s.line + 1, m);
          }
          fn(t, "change", t, e);
        }
        function Vi(t, e, n) {
          !function t(r, i, o) {
            if (r.linked) for (var a = 0; a < r.linked.length; ++a) {
              var s = r.linked[a];
              if (s.doc != i) {
                var c = o && s.sharedHist;
                n && !c || (e(s.doc, c), t(s.doc, r, c));
              }
            }
          }(t, null, !0);
        }
        function zi(t, e) {
          if (e.cm) throw new Error("This document is already in use.");
          t.doc = e, e.cm = t, fr(t), Ni(t), Hi(t), t.options.direction = e.direction, t.options.lineWrapping || Xe(t), t.options.mode = e.modeOption, vr(t);
        }
        function Hi(t) {
          ("rtl" == t.doc.direction ? _ : j)(t.display.lineDiv, "CodeMirror-rtl");
        }
        function Bi(t) {
          this.done = [], this.undone = [], this.undoDepth = t ? t.undoDepth : 1 / 0, this.lastModTime = this.lastSelTime = 0, this.lastOp = this.lastSelOp = null, this.lastOrigin = this.lastSelOrigin = null, this.generation = this.maxGeneration = t ? t.maxGeneration : 1;
        }
        function Ui(t, e) {
          var n = {
            from: ce(e.from),
            to: Mi(e),
            text: Zt(t, e.from, e.to)
          };
          return Gi(t, n, e.from.line, e.to.line + 1), Vi(t, function (t) {
            return Gi(t, n, e.from.line, e.to.line + 1);
          }, !0), n;
        }
        function $i(t) {
          for (; t.length && Q(t).ranges;) t.pop();
        }
        function Wi(t, e, n, r) {
          var i = t.history;
          i.undone.length = 0;
          var o,
            a,
            s = +new Date();
          if ((i.lastOp == r || i.lastOrigin == e.origin && e.origin && ("+" == e.origin.charAt(0) && i.lastModTime > s - (t.cm ? t.cm.options.historyEventDelay : 500) || "*" == e.origin.charAt(0))) && (o = function (t, e) {
            return e ? ($i(t.done), Q(t.done)) : t.done.length && !Q(t.done).ranges ? Q(t.done) : t.done.length > 1 && !t.done[t.done.length - 2].ranges ? (t.done.pop(), Q(t.done)) : void 0;
          }(i, i.lastOp == r))) a = Q(o.changes), 0 == ae(e.from, e.to) && 0 == ae(e.from, a.to) ? a.to = Mi(e) : o.changes.push(Ui(t, e));else {
            var c = Q(i.done);
            for (c && c.ranges || qi(t.sel, i.done), o = {
              changes: [Ui(t, e)],
              generation: i.generation
            }, i.done.push(o); i.done.length > i.undoDepth;) i.done.shift(), i.done[0].ranges || i.done.shift();
          }
          i.done.push(n), i.generation = ++i.maxGeneration, i.lastModTime = i.lastSelTime = s, i.lastOp = i.lastSelOp = r, i.lastOrigin = i.lastSelOrigin = e.origin, a || yt(t, "historyAdded");
        }
        function qi(t, e) {
          var n = Q(e);
          n && n.ranges && n.equals(t) || e.push(t);
        }
        function Gi(t, e, n, r) {
          var i = e["spans_" + t.id],
            o = 0;
          t.iter(Math.max(t.first, n), Math.min(t.first + t.size, r), function (n) {
            n.markedSpans && ((i || (i = e["spans_" + t.id] = {}))[o] = n.markedSpans), ++o;
          });
        }
        function Yi(t) {
          if (!t) return null;
          for (var e, n = 0; n < t.length; ++n) t[n].marker.explicitlyCleared ? e || (e = t.slice(0, n)) : e && e.push(t[n]);
          return e ? e.length ? e : null : t;
        }
        function Ki(t, e) {
          var n = function (t, e) {
              var n = e["spans_" + t.id];
              if (!n) return null;
              for (var r = [], i = 0; i < e.text.length; ++i) r.push(Yi(n[i]));
              return r;
            }(t, e),
            r = Me(t, e);
          if (!n) return r;
          if (!r) return n;
          for (var i = 0; i < n.length; ++i) {
            var o = n[i],
              a = r[i];
            if (o && a) t: for (var s = 0; s < a.length; ++s) {
              for (var c = a[s], l = 0; l < o.length; ++l) if (o[l].marker == c.marker) continue t;
              o.push(c);
            } else a && (n[i] = a);
          }
          return n;
        }
        function Xi(t, e, n) {
          for (var r = [], i = 0; i < t.length; ++i) {
            var o = t[i];
            if (o.ranges) r.push(n ? ji.prototype.deepCopy.call(o) : o);else {
              var a = o.changes,
                s = [];
              r.push({
                changes: s
              });
              for (var c = 0; c < a.length; ++c) {
                var l = a[c],
                  u = void 0;
                if (s.push({
                  from: l.from,
                  to: l.to,
                  text: l.text
                }), e) for (var d in l) (u = d.match(/^spans_(\d+)$/)) && W(e, Number(u[1])) > -1 && (Q(s)[d] = l[d], delete l[d]);
              }
            }
          }
          return r;
        }
        function Ji(t, e, n, r) {
          if (r) {
            var i = t.anchor;
            if (n) {
              var o = ae(e, i) < 0;
              o != ae(n, i) < 0 ? (i = e, e = n) : o != ae(e, n) < 0 && (e = n);
            }
            return new Ei(i, e);
          }
          return new Ei(n || e, e);
        }
        function Zi(t, e, n, r, i) {
          null == i && (i = t.cm && (t.cm.display.shift || t.extend)), ro(t, new ji([Ji(t.sel.primary(), e, n, i)], 0), r);
        }
        function Qi(t, e, n) {
          for (var r = [], i = t.cm && (t.cm.display.shift || t.extend), o = 0; o < t.sel.ranges.length; o++) r[o] = Ji(t.sel.ranges[o], e[o], null, i);
          ro(t, Pi(t.cm, r, t.sel.primIndex), n);
        }
        function to(t, e, n, r) {
          var i = t.sel.ranges.slice(0);
          i[e] = n, ro(t, Pi(t.cm, i, t.sel.primIndex), r);
        }
        function eo(t, e, n, r) {
          ro(t, Ai(e, n), r);
        }
        function no(t, e, n) {
          var r = t.history.done,
            i = Q(r);
          i && i.ranges ? (r[r.length - 1] = e, io(t, e, n)) : ro(t, e, n);
        }
        function ro(t, e, n) {
          io(t, e, n), function (t, e, n, r) {
            var i = t.history,
              o = r && r.origin;
            n == i.lastSelOp || o && i.lastSelOrigin == o && (i.lastModTime == i.lastSelTime && i.lastOrigin == o || function (t, e, n, r) {
              var i = e.charAt(0);
              return "*" == i || "+" == i && n.ranges.length == r.ranges.length && n.somethingSelected() == r.somethingSelected() && new Date() - t.history.lastSelTime <= (t.cm ? t.cm.options.historyEventDelay : 500);
            }(t, o, Q(i.done), e)) ? i.done[i.done.length - 1] = e : qi(e, i.done), i.lastSelTime = +new Date(), i.lastSelOrigin = o, i.lastSelOp = n, r && !1 !== r.clearRedo && $i(i.undone);
          }(t, t.sel, t.cm ? t.cm.curOp.id : NaN, n);
        }
        function io(t, e, n) {
          (Ot(t, "beforeSelectionChange") || t.cm && Ot(t.cm, "beforeSelectionChange")) && (e = function (t, e, n) {
            var r = {
              ranges: e.ranges,
              update: function update(e) {
                this.ranges = [];
                for (var n = 0; n < e.length; n++) this.ranges[n] = new Ei(he(t, e[n].anchor), he(t, e[n].head));
              },
              origin: n && n.origin
            };
            return yt(t, "beforeSelectionChange", t, r), t.cm && yt(t.cm, "beforeSelectionChange", t.cm, r), r.ranges != e.ranges ? Pi(t.cm, r.ranges, r.ranges.length - 1) : e;
          }(t, e, n));
          var r = n && n.bias || (ae(e.primary().head, t.sel.primary().head) < 0 ? -1 : 1);
          oo(t, so(t, e, r, !0)), n && !1 === n.scroll || !t.cm || "nocursor" == t.cm.getOption("readOnly") || Ir(t.cm);
        }
        function oo(t, e) {
          e.equals(t.sel) || (t.sel = e, t.cm && (t.cm.curOp.updateInput = 1, t.cm.curOp.selectionChanged = !0, xt(t.cm)), fn(t, "cursorActivity", t));
        }
        function ao(t) {
          oo(t, so(t, t.sel, null, !1));
        }
        function so(t, e, n, r) {
          for (var i, o = 0; o < e.ranges.length; o++) {
            var a = e.ranges[o],
              s = e.ranges.length == t.sel.ranges.length && t.sel.ranges[o],
              c = lo(t, a.anchor, s && s.anchor, n, r),
              l = a.head == a.anchor ? c : lo(t, a.head, s && s.head, n, r);
            (i || c != a.anchor || l != a.head) && (i || (i = e.ranges.slice(0, o)), i[o] = new Ei(c, l));
          }
          return i ? Pi(t.cm, i, e.primIndex) : e;
        }
        function co(t, e, n, r, i) {
          var o = Jt(t, e.line);
          if (o.markedSpans) for (var a = 0; a < o.markedSpans.length; ++a) {
            var s = o.markedSpans[a],
              c = s.marker,
              l = "selectLeft" in c ? !c.selectLeft : c.inclusiveLeft,
              u = "selectRight" in c ? !c.selectRight : c.inclusiveRight;
            if ((null == s.from || (l ? s.from <= e.ch : s.from < e.ch)) && (null == s.to || (u ? s.to >= e.ch : s.to > e.ch))) {
              if (i && (yt(c, "beforeCursorEnter"), c.explicitlyCleared)) {
                if (o.markedSpans) {
                  --a;
                  continue;
                }
                break;
              }
              if (!c.atomic) continue;
              if (n) {
                var d = c.find(r < 0 ? 1 : -1),
                  h = void 0;
                if ((r < 0 ? u : l) && (d = uo(t, d, -r, d && d.line == e.line ? o : null)), d && d.line == e.line && (h = ae(d, n)) && (r < 0 ? h < 0 : h > 0)) return co(t, d, e, r, i);
              }
              var f = c.find(r < 0 ? -1 : 1);
              return (r < 0 ? l : u) && (f = uo(t, f, r, f.line == e.line ? o : null)), f ? co(t, f, e, r, i) : null;
            }
          }
          return e;
        }
        function lo(t, e, n, r, i) {
          var o = r || 1;
          return co(t, e, n, o, i) || !i && co(t, e, n, o, !0) || co(t, e, n, -o, i) || !i && co(t, e, n, -o, !0) || (t.cantEdit = !0, oe(t.first, 0));
        }
        function uo(t, e, n, r) {
          return n < 0 && 0 == e.ch ? e.line > t.first ? he(t, oe(e.line - 1)) : null : n > 0 && e.ch == (r || Jt(t, e.line)).text.length ? e.line < t.first + t.size - 1 ? oe(e.line + 1, 0) : null : new oe(e.line, e.ch + n);
        }
        function ho(t) {
          t.setSelection(oe(t.firstLine(), 0), oe(t.lastLine()), G);
        }
        function fo(t, e, n) {
          var r = {
            canceled: !1,
            from: e.from,
            to: e.to,
            text: e.text,
            origin: e.origin,
            cancel: function cancel() {
              return r.canceled = !0;
            }
          };
          return n && (r.update = function (e, n, i, o) {
            e && (r.from = he(t, e)), n && (r.to = he(t, n)), i && (r.text = i), void 0 !== o && (r.origin = o);
          }), yt(t, "beforeChange", t, r), t.cm && yt(t.cm, "beforeChange", t.cm, r), r.canceled ? (t.cm && (t.cm.curOp.updateInput = 2), null) : {
            from: r.from,
            to: r.to,
            text: r.text,
            origin: r.origin
          };
        }
        function po(t, e, n) {
          if (t.cm) {
            if (!t.cm.curOp) return oi(t.cm, po)(t, e, n);
            if (t.cm.state.suppressEdits) return;
          }
          if (!(Ot(t, "beforeChange") || t.cm && Ot(t.cm, "beforeChange")) || (e = fo(t, e, !0))) {
            var r = Te && !n && function (t, e, n) {
              var r = null;
              if (t.iter(e.line, n.line + 1, function (t) {
                if (t.markedSpans) for (var e = 0; e < t.markedSpans.length; ++e) {
                  var n = t.markedSpans[e].marker;
                  !n.readOnly || r && -1 != W(r, n) || (r || (r = [])).push(n);
                }
              }), !r) return null;
              for (var i = [{
                  from: e,
                  to: n
                }], o = 0; o < r.length; ++o) for (var a = r[o], s = a.find(0), c = 0; c < i.length; ++c) {
                var l = i[c];
                if (!(ae(l.to, s.from) < 0 || ae(l.from, s.to) > 0)) {
                  var u = [c, 1],
                    d = ae(l.from, s.from),
                    h = ae(l.to, s.to);
                  (d < 0 || !a.inclusiveLeft && !d) && u.push({
                    from: l.from,
                    to: s.from
                  }), (h > 0 || !a.inclusiveRight && !h) && u.push({
                    from: s.to,
                    to: l.to
                  }), i.splice.apply(i, u), c += u.length - 3;
                }
              }
              return i;
            }(t, e.from, e.to);
            if (r) for (var i = r.length - 1; i >= 0; --i) go(t, {
              from: r[i].from,
              to: r[i].to,
              text: i ? [""] : e.text,
              origin: e.origin
            });else go(t, e);
          }
        }
        function go(t, e) {
          if (1 != e.text.length || "" != e.text[0] || 0 != ae(e.from, e.to)) {
            var n = Li(t, e);
            Wi(t, e, n, t.cm ? t.cm.curOp.id : NaN), bo(t, e, n, Me(t, e));
            var r = [];
            Vi(t, function (t, n) {
              n || -1 != W(r, t.history) || (Oo(t.history, e), r.push(t.history)), bo(t, e, null, Me(t, e));
            });
          }
        }
        function vo(t, e, n) {
          var r = t.cm && t.cm.state.suppressEdits;
          if (!r || n) {
            for (var i, o = t.history, a = t.sel, s = "undo" == e ? o.done : o.undone, c = "undo" == e ? o.undone : o.done, l = 0; l < s.length && (i = s[l], n ? !i.ranges || i.equals(t.sel) : i.ranges); l++);
            if (l != s.length) {
              for (o.lastOrigin = o.lastSelOrigin = null;;) {
                if (!(i = s.pop()).ranges) {
                  if (r) return void s.push(i);
                  break;
                }
                if (qi(i, c), n && !i.equals(t.sel)) return void ro(t, i, {
                  clearRedo: !1
                });
                a = i;
              }
              var u = [];
              qi(a, c), c.push({
                changes: u,
                generation: o.generation
              }), o.generation = i.generation || ++o.maxGeneration;
              for (var d = Ot(t, "beforeChange") || t.cm && Ot(t.cm, "beforeChange"), h = function h(n) {
                  var r = i.changes[n];
                  if (r.origin = e, d && !fo(t, r, !1)) return s.length = 0, {};
                  u.push(Ui(t, r));
                  var o = n ? Li(t, r) : Q(s);
                  bo(t, r, o, Ki(t, r)), !n && t.cm && t.cm.scrollIntoView({
                    from: r.from,
                    to: Mi(r)
                  });
                  var a = [];
                  Vi(t, function (t, e) {
                    e || -1 != W(a, t.history) || (Oo(t.history, r), a.push(t.history)), bo(t, r, null, Ki(t, r));
                  });
                }, f = i.changes.length - 1; f >= 0; --f) {
                var p = h(f);
                if (p) return p.v;
              }
            }
          }
        }
        function mo(t, e) {
          if (0 != e && (t.first += e, t.sel = new ji(tt(t.sel.ranges, function (t) {
            return new Ei(oe(t.anchor.line + e, t.anchor.ch), oe(t.head.line + e, t.head.ch));
          }), t.sel.primIndex), t.cm)) {
            vr(t.cm, t.first, t.first - e, e);
            for (var n = t.cm.display, r = n.viewFrom; r < n.viewTo; r++) mr(t.cm, r, "gutter");
          }
        }
        function bo(t, e, n, r) {
          if (t.cm && !t.cm.curOp) return oi(t.cm, bo)(t, e, n, r);
          if (e.to.line < t.first) mo(t, e.text.length - 1 - (e.to.line - e.from.line));else if (!(e.from.line > t.lastLine())) {
            if (e.from.line < t.first) {
              var i = e.text.length - 1 - (t.first - e.from.line);
              mo(t, i), e = {
                from: oe(t.first, 0),
                to: oe(e.to.line + i, e.to.ch),
                text: [Q(e.text)],
                origin: e.origin
              };
            }
            var o = t.lastLine();
            e.to.line > o && (e = {
              from: e.from,
              to: oe(o, Jt(t, o).text.length),
              text: [e.text[0]],
              origin: e.origin
            }), e.removed = Zt(t, e.from, e.to), n || (n = Li(t, e)), t.cm ? function (t, e, n) {
              var r = t.doc,
                i = t.display,
                o = e.from,
                a = e.to,
                s = !1,
                c = o.line;
              t.options.lineWrapping || (c = ee(Ue(Jt(r, o.line))), r.iter(c, a.line + 1, function (t) {
                if (t == i.maxLine) return s = !0, !0;
              })), r.sel.contains(e.from, e.to) > -1 && xt(t), Fi(r, e, n, hr(t)), t.options.lineWrapping || (r.iter(c, o.line + e.text.length, function (t) {
                var e = Ke(t);
                e > i.maxLineLength && (i.maxLine = t, i.maxLineLength = e, i.maxLineChanged = !0, s = !1);
              }), s && (t.curOp.updateMaxLine = !0)), function (t, e) {
                if (t.modeFrontier = Math.min(t.modeFrontier, e), !(t.highlightFrontier < e - 10)) {
                  for (var n = t.first, r = e - 1; r > n; r--) {
                    var i = Jt(t, r).stateAfter;
                    if (i && (!(i instanceof pe) || r + i.lookAhead < e)) {
                      n = r + 1;
                      break;
                    }
                  }
                  t.highlightFrontier = Math.min(t.highlightFrontier, n);
                }
              }(r, o.line), ci(t, 400);
              var l = e.text.length - (a.line - o.line) - 1;
              e.full ? vr(t) : o.line != a.line || 1 != e.text.length || Ri(t.doc, e) ? vr(t, o.line, a.line + 1, l) : mr(t, o.line, "text");
              var u = Ot(t, "changes"),
                d = Ot(t, "change");
              if (d || u) {
                var h = {
                  from: o,
                  to: a,
                  text: e.text,
                  removed: e.removed,
                  origin: e.origin
                };
                d && fn(t, "change", t, h), u && (t.curOp.changeObjs || (t.curOp.changeObjs = [])).push(h);
              }
              t.display.selForContextMenu = null;
            }(t.cm, e, r) : Fi(t, e, r), io(t, n, G), t.cantEdit && lo(t, oe(t.firstLine(), 0)) && (t.cantEdit = !1);
          }
        }
        function yo(t, e, n, r, i) {
          var o;
          r || (r = n), ae(r, n) < 0 && (n = (o = [r, n])[0], r = o[1]), "string" == typeof e && (e = t.splitLines(e)), po(t, {
            from: n,
            to: r,
            text: e,
            origin: i
          });
        }
        function wo(t, e, n, r) {
          n < t.line ? t.line += r : e < t.line && (t.line = e, t.ch = 0);
        }
        function xo(t, e, n, r) {
          for (var i = 0; i < t.length; ++i) {
            var o = t[i],
              a = !0;
            if (o.ranges) {
              o.copied || ((o = t[i] = o.deepCopy()).copied = !0);
              for (var s = 0; s < o.ranges.length; s++) wo(o.ranges[s].anchor, e, n, r), wo(o.ranges[s].head, e, n, r);
            } else {
              for (var c = 0; c < o.changes.length; ++c) {
                var l = o.changes[c];
                if (n < l.from.line) l.from = oe(l.from.line + r, l.from.ch), l.to = oe(l.to.line + r, l.to.ch);else if (e <= l.to.line) {
                  a = !1;
                  break;
                }
              }
              a || (t.splice(0, i + 1), i = 0);
            }
          }
        }
        function Oo(t, e) {
          var n = e.from.line,
            r = e.to.line,
            i = e.text.length - (r - n) - 1;
          xo(t.done, n, r, i), xo(t.undone, n, r, i);
        }
        function Co(t, e, n, r) {
          var i = e,
            o = e;
          return "number" == typeof e ? o = Jt(t, de(t, e)) : i = ee(e), null == i ? null : (r(o, i) && t.cm && mr(t.cm, i, n), o);
        }
        function So(t) {
          this.lines = t, this.parent = null;
          for (var e = 0, n = 0; n < t.length; ++n) t[n].parent = this, e += t[n].height;
          this.height = e;
        }
        function ko(t) {
          this.children = t;
          for (var e = 0, n = 0, r = 0; r < t.length; ++r) {
            var i = t[r];
            e += i.chunkSize(), n += i.height, i.parent = this;
          }
          this.size = e, this.height = n, this.parent = null;
        }
        Ei.prototype.from = function () {
          return ue(this.anchor, this.head);
        }, Ei.prototype.to = function () {
          return le(this.anchor, this.head);
        }, Ei.prototype.empty = function () {
          return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
        }, So.prototype = {
          chunkSize: function chunkSize() {
            return this.lines.length;
          },
          removeInner: function removeInner(t, e) {
            for (var n = t, r = t + e; n < r; ++n) {
              var i = this.lines[n];
              this.height -= i.height, Ze(i), fn(i, "delete");
            }
            this.lines.splice(t, e);
          },
          collapse: function collapse(t) {
            t.push.apply(t, this.lines);
          },
          insertInner: function insertInner(t, e, n) {
            this.height += n, this.lines = this.lines.slice(0, t).concat(e).concat(this.lines.slice(t));
            for (var r = 0; r < e.length; ++r) e[r].parent = this;
          },
          iterN: function iterN(t, e, n) {
            for (var r = t + e; t < r; ++t) if (n(this.lines[t])) return !0;
          }
        }, ko.prototype = {
          chunkSize: function chunkSize() {
            return this.size;
          },
          removeInner: function removeInner(t, e) {
            this.size -= e;
            for (var n = 0; n < this.children.length; ++n) {
              var r = this.children[n],
                i = r.chunkSize();
              if (t < i) {
                var o = Math.min(e, i - t),
                  a = r.height;
                if (r.removeInner(t, o), this.height -= a - r.height, i == o && (this.children.splice(n--, 1), r.parent = null), 0 == (e -= o)) break;
                t = 0;
              } else t -= i;
            }
            if (this.size - e < 25 && (this.children.length > 1 || !(this.children[0] instanceof So))) {
              var s = [];
              this.collapse(s), this.children = [new So(s)], this.children[0].parent = this;
            }
          },
          collapse: function collapse(t) {
            for (var e = 0; e < this.children.length; ++e) this.children[e].collapse(t);
          },
          insertInner: function insertInner(t, e, n) {
            this.size += e.length, this.height += n;
            for (var r = 0; r < this.children.length; ++r) {
              var i = this.children[r],
                o = i.chunkSize();
              if (t <= o) {
                if (i.insertInner(t, e, n), i.lines && i.lines.length > 50) {
                  for (var a = i.lines.length % 25 + 25, s = a; s < i.lines.length;) {
                    var c = new So(i.lines.slice(s, s += 25));
                    i.height -= c.height, this.children.splice(++r, 0, c), c.parent = this;
                  }
                  i.lines = i.lines.slice(0, a), this.maybeSpill();
                }
                break;
              }
              t -= o;
            }
          },
          maybeSpill: function maybeSpill() {
            if (!(this.children.length <= 10)) {
              var t = this;
              do {
                var e = new ko(t.children.splice(t.children.length - 5, 5));
                if (t.parent) {
                  t.size -= e.size, t.height -= e.height;
                  var n = W(t.parent.children, t);
                  t.parent.children.splice(n + 1, 0, e);
                } else {
                  var r = new ko(t.children);
                  r.parent = t, t.children = [r, e], t = r;
                }
                e.parent = t.parent;
              } while (t.children.length > 10);
              t.parent.maybeSpill();
            }
          },
          iterN: function iterN(t, e, n) {
            for (var r = 0; r < this.children.length; ++r) {
              var i = this.children[r],
                o = i.chunkSize();
              if (t < o) {
                var a = Math.min(e, o - t);
                if (i.iterN(t, a, n)) return !0;
                if (0 == (e -= a)) break;
                t = 0;
              } else t -= o;
            }
          }
        };
        var To = function To(t, e, n) {
          if (n) for (var r in n) n.hasOwnProperty(r) && (this[r] = n[r]);
          this.doc = t, this.node = e;
        };
        function jo(t, e, n) {
          Ye(e) < (t.curOp && t.curOp.scrollTop || t.doc.scrollTop) && Nr(t, n);
        }
        To.prototype.clear = function () {
          var t = this.doc.cm,
            e = this.line.widgets,
            n = this.line,
            r = ee(n);
          if (null != r && e) {
            for (var i = 0; i < e.length; ++i) e[i] == this && e.splice(i--, 1);
            e.length || (n.widgets = null);
            var o = Tn(this);
            te(n, Math.max(0, n.height - o)), t && (ii(t, function () {
              jo(t, n, -o), mr(t, r, "widget");
            }), fn(t, "lineWidgetCleared", t, this, r));
          }
        }, To.prototype.changed = function () {
          var t = this,
            e = this.height,
            n = this.doc.cm,
            r = this.line;
          this.height = null;
          var i = Tn(this) - e;
          i && (qe(this.doc, r) || te(r, r.height + i), n && ii(n, function () {
            n.curOp.forceUpdate = !0, jo(n, r, i), fn(n, "lineWidgetChanged", n, t, ee(r));
          }));
        }, Ct(To);
        var Eo = 0,
          Po = function Po(t, e) {
            this.lines = [], this.type = e, this.doc = t, this.id = ++Eo;
          };
        function Ao(t, e, n, r, i) {
          if (r && r.shared) return function (t, e, n, r, i) {
            (r = B(r)).shared = !1;
            var o = [Ao(t, e, n, r, i)],
              a = o[0],
              s = r.widgetNode;
            return Vi(t, function (t) {
              s && (r.widgetNode = s.cloneNode(!0)), o.push(Ao(t, he(t, e), he(t, n), r, i));
              for (var c = 0; c < t.linked.length; ++c) if (t.linked[c].isParent) return;
              a = Q(o);
            }), new Mo(o, a);
          }(t, e, n, r, i);
          if (t.cm && !t.cm.curOp) return oi(t.cm, Ao)(t, e, n, r, i);
          var o = new Po(t, i),
            a = ae(e, n);
          if (r && B(r, o, !1), a > 0 || 0 == a && !1 !== o.clearWhenEmpty) return o;
          if (o.replacedWith && (o.collapsed = !0, o.widgetNode = M("span", [o.replacedWith], "CodeMirror-widget"), r.handleMouseEvents || o.widgetNode.setAttribute("cm-ignore-events", "true"), r.insertLeft && (o.widgetNode.insertLeft = !0)), o.collapsed) {
            if (Be(t, e.line, e, n, o) || e.line != n.line && Be(t, n.line, e, n, o)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
            je = !0;
          }
          o.addToHistory && Wi(t, {
            from: e,
            to: n,
            origin: "markText"
          }, t.sel, NaN);
          var s,
            c = e.line,
            l = t.cm;
          if (t.iter(c, n.line + 1, function (r) {
            l && o.collapsed && !l.options.lineWrapping && Ue(r) == l.display.maxLine && (s = !0), o.collapsed && c != e.line && te(r, 0), function (t, e, n) {
              var r = n && window.WeakSet && (n.markedSpans || (n.markedSpans = new WeakSet()));
              r && t.markedSpans && r.has(t.markedSpans) ? t.markedSpans.push(e) : (t.markedSpans = t.markedSpans ? t.markedSpans.concat([e]) : [e], r && r.add(t.markedSpans)), e.marker.attachLine(t);
            }(r, new Ee(o, c == e.line ? e.ch : null, c == n.line ? n.ch : null), t.cm && t.cm.curOp), ++c;
          }), o.collapsed && t.iter(e.line, n.line + 1, function (e) {
            qe(t, e) && te(e, 0);
          }), o.clearOnEnter && vt(o, "beforeCursorEnter", function () {
            return o.clear();
          }), o.readOnly && (Te = !0, (t.history.done.length || t.history.undone.length) && t.clearHistory()), o.collapsed && (o.id = ++Eo, o.atomic = !0), l) {
            if (s && (l.curOp.updateMaxLine = !0), o.collapsed) vr(l, e.line, n.line + 1);else if (o.className || o.startStyle || o.endStyle || o.css || o.attributes || o.title) for (var u = e.line; u <= n.line; u++) mr(l, u, "text");
            o.atomic && ao(l.doc), fn(l, "markerAdded", l, o);
          }
          return o;
        }
        Po.prototype.clear = function () {
          if (!this.explicitlyCleared) {
            var t = this.doc.cm,
              e = t && !t.curOp;
            if (e && Jr(t), Ot(this, "clear")) {
              var n = this.find();
              n && fn(this, "clear", n.from, n.to);
            }
            for (var r = null, i = null, o = 0; o < this.lines.length; ++o) {
              var a = this.lines[o],
                s = Pe(a.markedSpans, this);
              t && !this.collapsed ? mr(t, ee(a), "text") : t && (null != s.to && (i = ee(a)), null != s.from && (r = ee(a))), a.markedSpans = Ae(a.markedSpans, s), null == s.from && this.collapsed && !qe(this.doc, a) && t && te(a, cr(t.display));
            }
            if (t && this.collapsed && !t.options.lineWrapping) for (var c = 0; c < this.lines.length; ++c) {
              var l = Ue(this.lines[c]),
                u = Ke(l);
              u > t.display.maxLineLength && (t.display.maxLine = l, t.display.maxLineLength = u, t.display.maxLineChanged = !0);
            }
            null != r && t && this.collapsed && vr(t, r, i + 1), this.lines.length = 0, this.explicitlyCleared = !0, this.atomic && this.doc.cantEdit && (this.doc.cantEdit = !1, t && ao(t.doc)), t && fn(t, "markerCleared", t, this, r, i), e && Zr(t), this.parent && this.parent.clear();
          }
        }, Po.prototype.find = function (t, e) {
          var n, r;
          null == t && "bookmark" == this.type && (t = 1);
          for (var i = 0; i < this.lines.length; ++i) {
            var o = this.lines[i],
              a = Pe(o.markedSpans, this);
            if (null != a.from && (n = oe(e ? o : ee(o), a.from), -1 == t)) return n;
            if (null != a.to && (r = oe(e ? o : ee(o), a.to), 1 == t)) return r;
          }
          return n && {
            from: n,
            to: r
          };
        }, Po.prototype.changed = function () {
          var t = this,
            e = this.find(-1, !0),
            n = this,
            r = this.doc.cm;
          e && r && ii(r, function () {
            var i = e.line,
              o = ee(e.line),
              a = In(r, o);
            if (a && (Un(a), r.curOp.selectionChanged = r.curOp.forceUpdate = !0), r.curOp.updateMaxLine = !0, !qe(n.doc, i) && null != n.height) {
              var s = n.height;
              n.height = null;
              var c = Tn(n) - s;
              c && te(i, i.height + c);
            }
            fn(r, "markerChanged", r, t);
          });
        }, Po.prototype.attachLine = function (t) {
          if (!this.lines.length && this.doc.cm) {
            var e = this.doc.cm.curOp;
            e.maybeHiddenMarkers && -1 != W(e.maybeHiddenMarkers, this) || (e.maybeUnhiddenMarkers || (e.maybeUnhiddenMarkers = [])).push(this);
          }
          this.lines.push(t);
        }, Po.prototype.detachLine = function (t) {
          if (this.lines.splice(W(this.lines, t), 1), !this.lines.length && this.doc.cm) {
            var e = this.doc.cm.curOp;
            (e.maybeHiddenMarkers || (e.maybeHiddenMarkers = [])).push(this);
          }
        }, Ct(Po);
        var Mo = function Mo(t, e) {
          this.markers = t, this.primary = e;
          for (var n = 0; n < t.length; ++n) t[n].parent = this;
        };
        function Do(t) {
          return t.findMarks(oe(t.first, 0), t.clipPos(oe(t.lastLine())), function (t) {
            return t.parent;
          });
        }
        function Lo(t) {
          for (var e = function (_e15) {
              function e(_x22) {
                return _e15.apply(this, arguments);
              }
              e.toString = function () {
                return _e15.toString();
              };
              return e;
            }(function (e) {
              var n = t[e],
                r = [n.primary.doc];
              Vi(n.primary.doc, function (t) {
                return r.push(t);
              });
              for (var i = 0; i < n.markers.length; i++) {
                var o = n.markers[i];
                -1 == W(r, o.doc) && (o.parent = null, n.markers.splice(i--, 1));
              }
            }), n = 0; n < t.length; n++) e(n);
        }
        Mo.prototype.clear = function () {
          if (!this.explicitlyCleared) {
            this.explicitlyCleared = !0;
            for (var t = 0; t < this.markers.length; ++t) this.markers[t].clear();
            fn(this, "clear");
          }
        }, Mo.prototype.find = function (t, e) {
          return this.primary.find(t, e);
        }, Ct(Mo);
        var _o = 0,
          _No = function No(t, e, n, r, i) {
            if (!(this instanceof _No)) return new _No(t, e, n, r, i);
            null == n && (n = 0), ko.call(this, [new So([new Je("", null)])]), this.first = n, this.scrollTop = this.scrollLeft = 0, this.cantEdit = !1, this.cleanGeneration = 1, this.modeFrontier = this.highlightFrontier = n;
            var o = oe(n, 0);
            this.sel = Ai(o), this.history = new Bi(null), this.id = ++_o, this.modeOption = e, this.lineSep = r, this.direction = "rtl" == i ? "rtl" : "ltr", this.extend = !1, "string" == typeof t && (t = this.splitLines(t)), Fi(this, {
              from: o,
              to: o,
              text: t
            }), ro(this, Ai(o), G);
          };
        _No.prototype = nt(ko.prototype, {
          constructor: _No,
          iter: function iter(t, e, n) {
            n ? this.iterN(t - this.first, e - t, n) : this.iterN(this.first, this.first + this.size, t);
          },
          insert: function insert(t, e) {
            for (var n = 0, r = 0; r < e.length; ++r) n += e[r].height;
            this.insertInner(t - this.first, e, n);
          },
          remove: function remove(t, e) {
            this.removeInner(t - this.first, e);
          },
          getValue: function getValue(t) {
            var e = Qt(this, this.first, this.first + this.size);
            return !1 === t ? e : e.join(t || this.lineSeparator());
          },
          setValue: si(function (t) {
            var e = oe(this.first, 0),
              n = this.first + this.size - 1;
            po(this, {
              from: e,
              to: oe(n, Jt(this, n).text.length),
              text: this.splitLines(t),
              origin: "setValue",
              full: !0
            }, !0), this.cm && Rr(this.cm, 0, 0), ro(this, Ai(e), G);
          }),
          replaceRange: function replaceRange(t, e, n, r) {
            yo(this, t, e = he(this, e), n = n ? he(this, n) : e, r);
          },
          getRange: function getRange(t, e, n) {
            var r = Zt(this, he(this, t), he(this, e));
            return !1 === n ? r : "" === n ? r.join("") : r.join(n || this.lineSeparator());
          },
          getLine: function getLine(t) {
            var e = this.getLineHandle(t);
            return e && e.text;
          },
          getLineHandle: function getLineHandle(t) {
            if (re(this, t)) return Jt(this, t);
          },
          getLineNumber: function getLineNumber(t) {
            return ee(t);
          },
          getLineHandleVisualStart: function getLineHandleVisualStart(t) {
            return "number" == typeof t && (t = Jt(this, t)), Ue(t);
          },
          lineCount: function lineCount() {
            return this.size;
          },
          firstLine: function firstLine() {
            return this.first;
          },
          lastLine: function lastLine() {
            return this.first + this.size - 1;
          },
          clipPos: function clipPos(t) {
            return he(this, t);
          },
          getCursor: function getCursor(t) {
            var e = this.sel.primary();
            return null == t || "head" == t ? e.head : "anchor" == t ? e.anchor : "end" == t || "to" == t || !1 === t ? e.to() : e.from();
          },
          listSelections: function listSelections() {
            return this.sel.ranges;
          },
          somethingSelected: function somethingSelected() {
            return this.sel.somethingSelected();
          },
          setCursor: si(function (t, e, n) {
            eo(this, he(this, "number" == typeof t ? oe(t, e || 0) : t), null, n);
          }),
          setSelection: si(function (t, e, n) {
            eo(this, he(this, t), he(this, e || t), n);
          }),
          extendSelection: si(function (t, e, n) {
            Zi(this, he(this, t), e && he(this, e), n);
          }),
          extendSelections: si(function (t, e) {
            Qi(this, fe(this, t), e);
          }),
          extendSelectionsBy: si(function (t, e) {
            Qi(this, fe(this, tt(this.sel.ranges, t)), e);
          }),
          setSelections: si(function (t, e, n) {
            if (t.length) {
              for (var r = [], i = 0; i < t.length; i++) r[i] = new Ei(he(this, t[i].anchor), he(this, t[i].head || t[i].anchor));
              null == e && (e = Math.min(t.length - 1, this.sel.primIndex)), ro(this, Pi(this.cm, r, e), n);
            }
          }),
          addSelection: si(function (t, e, n) {
            var r = this.sel.ranges.slice(0);
            r.push(new Ei(he(this, t), he(this, e || t))), ro(this, Pi(this.cm, r, r.length - 1), n);
          }),
          getSelection: function getSelection(t) {
            for (var e, n = this.sel.ranges, r = 0; r < n.length; r++) {
              var i = Zt(this, n[r].from(), n[r].to());
              e = e ? e.concat(i) : i;
            }
            return !1 === t ? e : e.join(t || this.lineSeparator());
          },
          getSelections: function getSelections(t) {
            for (var e = [], n = this.sel.ranges, r = 0; r < n.length; r++) {
              var i = Zt(this, n[r].from(), n[r].to());
              !1 !== t && (i = i.join(t || this.lineSeparator())), e[r] = i;
            }
            return e;
          },
          replaceSelection: function replaceSelection(t, e, n) {
            for (var r = [], i = 0; i < this.sel.ranges.length; i++) r[i] = t;
            this.replaceSelections(r, e, n || "+input");
          },
          replaceSelections: si(function (t, e, n) {
            for (var r = [], i = this.sel, o = 0; o < i.ranges.length; o++) {
              var a = i.ranges[o];
              r[o] = {
                from: a.from(),
                to: a.to(),
                text: this.splitLines(t[o]),
                origin: n
              };
            }
            for (var s = e && "end" != e && function (t, e, n) {
                for (var r = [], i = oe(t.first, 0), o = i, a = 0; a < e.length; a++) {
                  var s = e[a],
                    c = _i(s.from, i, o),
                    l = _i(Mi(s), i, o);
                  if (i = s.to, o = l, "around" == n) {
                    var u = t.sel.ranges[a],
                      d = ae(u.head, u.anchor) < 0;
                    r[a] = new Ei(d ? l : c, d ? c : l);
                  } else r[a] = new Ei(c, c);
                }
                return new ji(r, t.sel.primIndex);
              }(this, r, e), c = r.length - 1; c >= 0; c--) po(this, r[c]);
            s ? no(this, s) : this.cm && Ir(this.cm);
          }),
          undo: si(function () {
            vo(this, "undo");
          }),
          redo: si(function () {
            vo(this, "redo");
          }),
          undoSelection: si(function () {
            vo(this, "undo", !0);
          }),
          redoSelection: si(function () {
            vo(this, "redo", !0);
          }),
          setExtending: function setExtending(t) {
            this.extend = t;
          },
          getExtending: function getExtending() {
            return this.extend;
          },
          historySize: function historySize() {
            for (var t = this.history, e = 0, n = 0, r = 0; r < t.done.length; r++) t.done[r].ranges || ++e;
            for (var i = 0; i < t.undone.length; i++) t.undone[i].ranges || ++n;
            return {
              undo: e,
              redo: n
            };
          },
          clearHistory: function clearHistory() {
            var t = this;
            this.history = new Bi(this.history), Vi(this, function (e) {
              return e.history = t.history;
            }, !0);
          },
          markClean: function markClean() {
            this.cleanGeneration = this.changeGeneration(!0);
          },
          changeGeneration: function changeGeneration(t) {
            return t && (this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null), this.history.generation;
          },
          isClean: function isClean(t) {
            return this.history.generation == (t || this.cleanGeneration);
          },
          getHistory: function getHistory() {
            return {
              done: Xi(this.history.done),
              undone: Xi(this.history.undone)
            };
          },
          setHistory: function setHistory(t) {
            var e = this.history = new Bi(this.history);
            e.done = Xi(t.done.slice(0), null, !0), e.undone = Xi(t.undone.slice(0), null, !0);
          },
          setGutterMarker: si(function (t, e, n) {
            return Co(this, t, "gutter", function (t) {
              var r = t.gutterMarkers || (t.gutterMarkers = {});
              return r[e] = n, !n && at(r) && (t.gutterMarkers = null), !0;
            });
          }),
          clearGutter: si(function (t) {
            var e = this;
            this.iter(function (n) {
              n.gutterMarkers && n.gutterMarkers[t] && Co(e, n, "gutter", function () {
                return n.gutterMarkers[t] = null, at(n.gutterMarkers) && (n.gutterMarkers = null), !0;
              });
            });
          }),
          lineInfo: function lineInfo(t) {
            var e;
            if ("number" == typeof t) {
              if (!re(this, t)) return null;
              if (e = t, !(t = Jt(this, t))) return null;
            } else if (null == (e = ee(t))) return null;
            return {
              line: e,
              handle: t,
              text: t.text,
              gutterMarkers: t.gutterMarkers,
              textClass: t.textClass,
              bgClass: t.bgClass,
              wrapClass: t.wrapClass,
              widgets: t.widgets
            };
          },
          addLineClass: si(function (t, e, n) {
            return Co(this, t, "gutter" == e ? "gutter" : "class", function (t) {
              var r = "text" == e ? "textClass" : "background" == e ? "bgClass" : "gutter" == e ? "gutterClass" : "wrapClass";
              if (t[r]) {
                if (k(n).test(t[r])) return !1;
                t[r] += " " + n;
              } else t[r] = n;
              return !0;
            });
          }),
          removeLineClass: si(function (t, e, n) {
            return Co(this, t, "gutter" == e ? "gutter" : "class", function (t) {
              var r = "text" == e ? "textClass" : "background" == e ? "bgClass" : "gutter" == e ? "gutterClass" : "wrapClass",
                i = t[r];
              if (!i) return !1;
              if (null == n) t[r] = null;else {
                var o = i.match(k(n));
                if (!o) return !1;
                var a = o.index + o[0].length;
                t[r] = i.slice(0, o.index) + (o.index && a != i.length ? " " : "") + i.slice(a) || null;
              }
              return !0;
            });
          }),
          addLineWidget: si(function (t, e, n) {
            return function (t, e, n, r) {
              var i = new To(t, n, r),
                o = t.cm;
              return o && i.noHScroll && (o.display.alignWidgets = !0), Co(t, e, "widget", function (e) {
                var n = e.widgets || (e.widgets = []);
                if (null == i.insertAt ? n.push(i) : n.splice(Math.min(n.length, Math.max(0, i.insertAt)), 0, i), i.line = e, o && !qe(t, e)) {
                  var r = Ye(e) < t.scrollTop;
                  te(e, e.height + Tn(i)), r && Nr(o, i.height), o.curOp.forceUpdate = !0;
                }
                return !0;
              }), o && fn(o, "lineWidgetAdded", o, i, "number" == typeof e ? e : ee(e)), i;
            }(this, t, e, n);
          }),
          removeLineWidget: function removeLineWidget(t) {
            t.clear();
          },
          markText: function markText(t, e, n) {
            return Ao(this, he(this, t), he(this, e), n, n && n.type || "range");
          },
          setBookmark: function setBookmark(t, e) {
            var n = {
              replacedWith: e && (null == e.nodeType ? e.widget : e),
              insertLeft: e && e.insertLeft,
              clearWhenEmpty: !1,
              shared: e && e.shared,
              handleMouseEvents: e && e.handleMouseEvents
            };
            return Ao(this, t = he(this, t), t, n, "bookmark");
          },
          findMarksAt: function findMarksAt(t) {
            var e = [],
              n = Jt(this, (t = he(this, t)).line).markedSpans;
            if (n) for (var r = 0; r < n.length; ++r) {
              var i = n[r];
              (null == i.from || i.from <= t.ch) && (null == i.to || i.to >= t.ch) && e.push(i.marker.parent || i.marker);
            }
            return e;
          },
          findMarks: function findMarks(t, e, n) {
            t = he(this, t), e = he(this, e);
            var r = [],
              i = t.line;
            return this.iter(t.line, e.line + 1, function (o) {
              var a = o.markedSpans;
              if (a) for (var s = 0; s < a.length; s++) {
                var c = a[s];
                null != c.to && i == t.line && t.ch >= c.to || null == c.from && i != t.line || null != c.from && i == e.line && c.from >= e.ch || n && !n(c.marker) || r.push(c.marker.parent || c.marker);
              }
              ++i;
            }), r;
          },
          getAllMarks: function getAllMarks() {
            var t = [];
            return this.iter(function (e) {
              var n = e.markedSpans;
              if (n) for (var r = 0; r < n.length; ++r) null != n[r].from && t.push(n[r].marker);
            }), t;
          },
          posFromIndex: function posFromIndex(t) {
            var e,
              n = this.first,
              r = this.lineSeparator().length;
            return this.iter(function (i) {
              var o = i.text.length + r;
              if (o > t) return e = t, !0;
              t -= o, ++n;
            }), he(this, oe(n, e));
          },
          indexFromPos: function indexFromPos(t) {
            var e = (t = he(this, t)).ch;
            if (t.line < this.first || t.ch < 0) return 0;
            var n = this.lineSeparator().length;
            return this.iter(this.first, t.line, function (t) {
              e += t.text.length + n;
            }), e;
          },
          copy: function copy(t) {
            var e = new _No(Qt(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            return e.scrollTop = this.scrollTop, e.scrollLeft = this.scrollLeft, e.sel = this.sel, e.extend = !1, t && (e.history.undoDepth = this.history.undoDepth, e.setHistory(this.getHistory())), e;
          },
          linkedDoc: function linkedDoc(t) {
            t || (t = {});
            var e = this.first,
              n = this.first + this.size;
            null != t.from && t.from > e && (e = t.from), null != t.to && t.to < n && (n = t.to);
            var r = new _No(Qt(this, e, n), t.mode || this.modeOption, e, this.lineSep, this.direction);
            return t.sharedHist && (r.history = this.history), (this.linked || (this.linked = [])).push({
              doc: r,
              sharedHist: t.sharedHist
            }), r.linked = [{
              doc: this,
              isParent: !0,
              sharedHist: t.sharedHist
            }], function (t, e) {
              for (var n = 0; n < e.length; n++) {
                var r = e[n],
                  i = r.find(),
                  o = t.clipPos(i.from),
                  a = t.clipPos(i.to);
                if (ae(o, a)) {
                  var s = Ao(t, o, a, r.primary, r.primary.type);
                  r.markers.push(s), s.parent = r;
                }
              }
            }(r, Do(this)), r;
          },
          unlinkDoc: function unlinkDoc(t) {
            if (t instanceof Aa && (t = t.doc), this.linked) for (var e = 0; e < this.linked.length; ++e) if (this.linked[e].doc == t) {
              this.linked.splice(e, 1), t.unlinkDoc(this), Lo(Do(this));
              break;
            }
            if (t.history == this.history) {
              var n = [t.id];
              Vi(t, function (t) {
                return n.push(t.id);
              }, !0), t.history = new Bi(null), t.history.done = Xi(this.history.done, n), t.history.undone = Xi(this.history.undone, n);
            }
          },
          iterLinkedDocs: function iterLinkedDocs(t) {
            Vi(this, t);
          },
          getMode: function getMode() {
            return this.mode;
          },
          getEditor: function getEditor() {
            return this.cm;
          },
          splitLines: function splitLines(t) {
            return this.lineSep ? t.split(this.lineSep) : It(t);
          },
          lineSeparator: function lineSeparator() {
            return this.lineSep || "\n";
          },
          setDirection: si(function (t) {
            var e;
            "rtl" != t && (t = "ltr"), t != this.direction && (this.direction = t, this.iter(function (t) {
              return t.order = null;
            }), this.cm && ii(e = this.cm, function () {
              Hi(e), vr(e);
            }));
          })
        }), _No.prototype.eachLine = _No.prototype.iter;
        var Io = 0;
        function Ro(t) {
          var e = this;
          if (Fo(e), !wt(e, t) && !jn(e.display, t)) {
            St(t), a && (Io = +new Date());
            var n = pr(e, t, !0),
              r = t.dataTransfer.files;
            if (n && !e.isReadOnly()) if (r && r.length && window.FileReader && window.File) for (var i = r.length, o = Array(i), s = 0, c = function c() {
                ++s == i && oi(e, function () {
                  var t = {
                    from: n = he(e.doc, n),
                    to: n,
                    text: e.doc.splitLines(o.filter(function (t) {
                      return null != t;
                    }).join(e.doc.lineSeparator())),
                    origin: "paste"
                  };
                  po(e.doc, t), no(e.doc, Ai(he(e.doc, n), he(e.doc, Mi(t))));
                })();
              }, l = function l(t, n) {
                if (e.options.allowDropFileTypes && -1 == W(e.options.allowDropFileTypes, t.type)) c();else {
                  var r = new FileReader();
                  r.onerror = function () {
                    return c();
                  }, r.onload = function () {
                    var t = r.result;
                    /[\x00-\x08\x0e-\x1f]{2}/.test(t) || (o[n] = t), c();
                  }, r.readAsText(t);
                }
              }, u = 0; u < r.length; u++) l(r[u], u);else {
              if (e.state.draggingText && e.doc.sel.contains(n) > -1) return e.state.draggingText(t), void setTimeout(function () {
                return e.display.input.focus();
              }, 20);
              try {
                var d = t.dataTransfer.getData("Text");
                if (d) {
                  var h;
                  if (e.state.draggingText && !e.state.draggingText.copy && (h = e.listSelections()), io(e.doc, Ai(n, n)), h) for (var f = 0; f < h.length; ++f) yo(e.doc, "", h[f].anchor, h[f].head, "drag");
                  e.replaceSelection(d, "around", "paste"), e.display.input.focus();
                }
              } catch (t) {}
            }
          }
        }
        function Fo(t) {
          t.display.dragCursor && (t.display.lineSpace.removeChild(t.display.dragCursor), t.display.dragCursor = null);
        }
        function Vo(t) {
          if (document.getElementsByClassName) {
            for (var e = document.getElementsByClassName("CodeMirror"), n = [], r = 0; r < e.length; r++) {
              var i = e[r].CodeMirror;
              i && n.push(i);
            }
            n.length && n[0].operation(function () {
              for (var e = 0; e < n.length; e++) t(n[e]);
            });
          }
        }
        var zo = !1;
        function Ho(t) {
          var e = t.display;
          e.cachedCharWidth = e.cachedTextHeight = e.cachedPaddingH = null, e.scrollbarsClipped = !1, t.setSize();
        }
        for (var Bo = {
            3: "Pause",
            8: "Backspace",
            9: "Tab",
            13: "Enter",
            16: "Shift",
            17: "Ctrl",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Esc",
            32: "Space",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "Left",
            38: "Up",
            39: "Right",
            40: "Down",
            44: "PrintScrn",
            45: "Insert",
            46: "Delete",
            59: ";",
            61: "=",
            91: "Mod",
            92: "Mod",
            93: "Mod",
            106: "*",
            107: "=",
            109: "-",
            110: ".",
            111: "/",
            145: "ScrollLock",
            173: "-",
            186: ";",
            187: "=",
            188: ",",
            189: "-",
            190: ".",
            191: "/",
            192: "`",
            219: "[",
            220: "\\",
            221: "]",
            222: "'",
            224: "Mod",
            63232: "Up",
            63233: "Down",
            63234: "Left",
            63235: "Right",
            63272: "Delete",
            63273: "Home",
            63275: "End",
            63276: "PageUp",
            63277: "PageDown",
            63302: "Insert"
          }, Uo = 0; Uo < 10; Uo++) Bo[Uo + 48] = Bo[Uo + 96] = String(Uo);
        for (var $o = 65; $o <= 90; $o++) Bo[$o] = String.fromCharCode($o);
        for (var Wo = 1; Wo <= 12; Wo++) Bo[Wo + 111] = Bo[Wo + 63235] = "F" + Wo;
        var qo = {};
        function Go(t) {
          var e,
            n,
            r,
            i,
            o = t.split(/-(?!$)/);
          t = o[o.length - 1];
          for (var a = 0; a < o.length - 1; a++) {
            var s = o[a];
            if (/^(cmd|meta|m)$/i.test(s)) i = !0;else if (/^a(lt)?$/i.test(s)) e = !0;else if (/^(c|ctrl|control)$/i.test(s)) n = !0;else {
              if (!/^s(hift)?$/i.test(s)) throw new Error("Unrecognized modifier name: " + s);
              r = !0;
            }
          }
          return e && (t = "Alt-" + t), n && (t = "Ctrl-" + t), i && (t = "Cmd-" + t), r && (t = "Shift-" + t), t;
        }
        function Yo(t) {
          var e = {};
          for (var n in t) if (t.hasOwnProperty(n)) {
            var r = t[n];
            if (/^(name|fallthrough|(de|at)tach)$/.test(n)) continue;
            if ("..." == r) {
              delete t[n];
              continue;
            }
            for (var i = tt(n.split(" "), Go), o = 0; o < i.length; o++) {
              var a = void 0,
                s = void 0;
              o == i.length - 1 ? (s = i.join(" "), a = r) : (s = i.slice(0, o + 1).join(" "), a = "...");
              var c = e[s];
              if (c) {
                if (c != a) throw new Error("Inconsistent bindings for " + s);
              } else e[s] = a;
            }
            delete t[n];
          }
          for (var l in e) t[l] = e[l];
          return t;
        }
        function Ko(t, e, n, r) {
          var i = (e = Qo(e)).call ? e.call(t, r) : e[t];
          if (!1 === i) return "nothing";
          if ("..." === i) return "multi";
          if (null != i && n(i)) return "handled";
          if (e.fallthrough) {
            if ("[object Array]" != Object.prototype.toString.call(e.fallthrough)) return Ko(t, e.fallthrough, n, r);
            for (var o = 0; o < e.fallthrough.length; o++) {
              var a = Ko(t, e.fallthrough[o], n, r);
              if (a) return a;
            }
          }
        }
        function Xo(t) {
          var e = "string" == typeof t ? t : Bo[t.keyCode];
          return "Ctrl" == e || "Alt" == e || "Shift" == e || "Mod" == e;
        }
        function Jo(t, e, n) {
          var r = t;
          return e.altKey && "Alt" != r && (t = "Alt-" + t), (C ? e.metaKey : e.ctrlKey) && "Ctrl" != r && (t = "Ctrl-" + t), (C ? e.ctrlKey : e.metaKey) && "Mod" != r && (t = "Cmd-" + t), !n && e.shiftKey && "Shift" != r && (t = "Shift-" + t), t;
        }
        function Zo(t, e) {
          if (h && 34 == t.keyCode && t.char) return !1;
          var n = Bo[t.keyCode];
          return null != n && !t.altGraphKey && (3 == t.keyCode && t.code && (n = t.code), Jo(n, t, e));
        }
        function Qo(t) {
          return "string" == typeof t ? qo[t] : t;
        }
        function ta(t, e) {
          for (var n = t.doc.sel.ranges, r = [], i = 0; i < n.length; i++) {
            for (var o = e(n[i]); r.length && ae(o.from, Q(r).to) <= 0;) {
              var a = r.pop();
              if (ae(a.from, o.from) < 0) {
                o.from = a.from;
                break;
              }
            }
            r.push(o);
          }
          ii(t, function () {
            for (var e = r.length - 1; e >= 0; e--) yo(t.doc, "", r[e].from, r[e].to, "+delete");
            Ir(t);
          });
        }
        function ea(t, e, n) {
          var r = lt(t.text, e + n, n);
          return r < 0 || r > t.text.length ? null : r;
        }
        function na(t, e, n) {
          var r = ea(t, e.ch, n);
          return null == r ? null : new oe(e.line, r, n < 0 ? "after" : "before");
        }
        function ra(t, e, n, r, i) {
          if (t) {
            "rtl" == e.doc.direction && (i = -i);
            var o = pt(n, e.doc.direction);
            if (o) {
              var a,
                s = i < 0 ? Q(o) : o[0],
                c = i < 0 == (1 == s.level) ? "after" : "before";
              if (s.level > 0 || "rtl" == e.doc.direction) {
                var l = Rn(e, n);
                a = i < 0 ? n.text.length - 1 : 0;
                var u = Fn(e, l, a).top;
                a = ut(function (t) {
                  return Fn(e, l, t).top == u;
                }, i < 0 == (1 == s.level) ? s.from : s.to - 1, a), "before" == c && (a = ea(n, a, 1));
              } else a = i < 0 ? s.to : s.from;
              return new oe(r, a, c);
            }
          }
          return new oe(r, i < 0 ? n.text.length : 0, i < 0 ? "before" : "after");
        }
        qo.basic = {
          Left: "goCharLeft",
          Right: "goCharRight",
          Up: "goLineUp",
          Down: "goLineDown",
          End: "goLineEnd",
          Home: "goLineStartSmart",
          PageUp: "goPageUp",
          PageDown: "goPageDown",
          Delete: "delCharAfter",
          Backspace: "delCharBefore",
          "Shift-Backspace": "delCharBefore",
          Tab: "defaultTab",
          "Shift-Tab": "indentAuto",
          Enter: "newlineAndIndent",
          Insert: "toggleOverwrite",
          Esc: "singleSelection"
        }, qo.pcDefault = {
          "Ctrl-A": "selectAll",
          "Ctrl-D": "deleteLine",
          "Ctrl-Z": "undo",
          "Shift-Ctrl-Z": "redo",
          "Ctrl-Y": "redo",
          "Ctrl-Home": "goDocStart",
          "Ctrl-End": "goDocEnd",
          "Ctrl-Up": "goLineUp",
          "Ctrl-Down": "goLineDown",
          "Ctrl-Left": "goGroupLeft",
          "Ctrl-Right": "goGroupRight",
          "Alt-Left": "goLineStart",
          "Alt-Right": "goLineEnd",
          "Ctrl-Backspace": "delGroupBefore",
          "Ctrl-Delete": "delGroupAfter",
          "Ctrl-S": "save",
          "Ctrl-F": "find",
          "Ctrl-G": "findNext",
          "Shift-Ctrl-G": "findPrev",
          "Shift-Ctrl-F": "replace",
          "Shift-Ctrl-R": "replaceAll",
          "Ctrl-[": "indentLess",
          "Ctrl-]": "indentMore",
          "Ctrl-U": "undoSelection",
          "Shift-Ctrl-U": "redoSelection",
          "Alt-U": "redoSelection",
          fallthrough: "basic"
        }, qo.emacsy = {
          "Ctrl-F": "goCharRight",
          "Ctrl-B": "goCharLeft",
          "Ctrl-P": "goLineUp",
          "Ctrl-N": "goLineDown",
          "Ctrl-A": "goLineStart",
          "Ctrl-E": "goLineEnd",
          "Ctrl-V": "goPageDown",
          "Shift-Ctrl-V": "goPageUp",
          "Ctrl-D": "delCharAfter",
          "Ctrl-H": "delCharBefore",
          "Alt-Backspace": "delWordBefore",
          "Ctrl-K": "killLine",
          "Ctrl-T": "transposeChars",
          "Ctrl-O": "openLine"
        }, qo.macDefault = {
          "Cmd-A": "selectAll",
          "Cmd-D": "deleteLine",
          "Cmd-Z": "undo",
          "Shift-Cmd-Z": "redo",
          "Cmd-Y": "redo",
          "Cmd-Home": "goDocStart",
          "Cmd-Up": "goDocStart",
          "Cmd-End": "goDocEnd",
          "Cmd-Down": "goDocEnd",
          "Alt-Left": "goGroupLeft",
          "Alt-Right": "goGroupRight",
          "Cmd-Left": "goLineLeft",
          "Cmd-Right": "goLineRight",
          "Alt-Backspace": "delGroupBefore",
          "Ctrl-Alt-Backspace": "delGroupAfter",
          "Alt-Delete": "delGroupAfter",
          "Cmd-S": "save",
          "Cmd-F": "find",
          "Cmd-G": "findNext",
          "Shift-Cmd-G": "findPrev",
          "Cmd-Alt-F": "replace",
          "Shift-Cmd-Alt-F": "replaceAll",
          "Cmd-[": "indentLess",
          "Cmd-]": "indentMore",
          "Cmd-Backspace": "delWrappedLineLeft",
          "Cmd-Delete": "delWrappedLineRight",
          "Cmd-U": "undoSelection",
          "Shift-Cmd-U": "redoSelection",
          "Ctrl-Up": "goDocStart",
          "Ctrl-Down": "goDocEnd",
          fallthrough: ["basic", "emacsy"]
        }, qo.default = y ? qo.macDefault : qo.pcDefault;
        var ia = {
          selectAll: ho,
          singleSelection: function singleSelection(t) {
            return t.setSelection(t.getCursor("anchor"), t.getCursor("head"), G);
          },
          killLine: function killLine(t) {
            return ta(t, function (e) {
              if (e.empty()) {
                var n = Jt(t.doc, e.head.line).text.length;
                return e.head.ch == n && e.head.line < t.lastLine() ? {
                  from: e.head,
                  to: oe(e.head.line + 1, 0)
                } : {
                  from: e.head,
                  to: oe(e.head.line, n)
                };
              }
              return {
                from: e.from(),
                to: e.to()
              };
            });
          },
          deleteLine: function deleteLine(t) {
            return ta(t, function (e) {
              return {
                from: oe(e.from().line, 0),
                to: he(t.doc, oe(e.to().line + 1, 0))
              };
            });
          },
          delLineLeft: function delLineLeft(t) {
            return ta(t, function (t) {
              return {
                from: oe(t.from().line, 0),
                to: t.from()
              };
            });
          },
          delWrappedLineLeft: function delWrappedLineLeft(t) {
            return ta(t, function (e) {
              var n = t.charCoords(e.head, "div").top + 5;
              return {
                from: t.coordsChar({
                  left: 0,
                  top: n
                }, "div"),
                to: e.from()
              };
            });
          },
          delWrappedLineRight: function delWrappedLineRight(t) {
            return ta(t, function (e) {
              var n = t.charCoords(e.head, "div").top + 5,
                r = t.coordsChar({
                  left: t.display.lineDiv.offsetWidth + 100,
                  top: n
                }, "div");
              return {
                from: e.from(),
                to: r
              };
            });
          },
          undo: function undo(t) {
            return t.undo();
          },
          redo: function redo(t) {
            return t.redo();
          },
          undoSelection: function undoSelection(t) {
            return t.undoSelection();
          },
          redoSelection: function redoSelection(t) {
            return t.redoSelection();
          },
          goDocStart: function goDocStart(t) {
            return t.extendSelection(oe(t.firstLine(), 0));
          },
          goDocEnd: function goDocEnd(t) {
            return t.extendSelection(oe(t.lastLine()));
          },
          goLineStart: function goLineStart(t) {
            return t.extendSelectionsBy(function (e) {
              return oa(t, e.head.line);
            }, {
              origin: "+move",
              bias: 1
            });
          },
          goLineStartSmart: function goLineStartSmart(t) {
            return t.extendSelectionsBy(function (e) {
              return aa(t, e.head);
            }, {
              origin: "+move",
              bias: 1
            });
          },
          goLineEnd: function goLineEnd(t) {
            return t.extendSelectionsBy(function (e) {
              return function (t, e) {
                var n = Jt(t.doc, e),
                  r = function (t) {
                    for (var e; e = ze(t);) t = e.find(1, !0).line;
                    return t;
                  }(n);
                return r != n && (e = ee(r)), ra(!0, t, n, e, -1);
              }(t, e.head.line);
            }, {
              origin: "+move",
              bias: -1
            });
          },
          goLineRight: function goLineRight(t) {
            return t.extendSelectionsBy(function (e) {
              var n = t.cursorCoords(e.head, "div").top + 5;
              return t.coordsChar({
                left: t.display.lineDiv.offsetWidth + 100,
                top: n
              }, "div");
            }, K);
          },
          goLineLeft: function goLineLeft(t) {
            return t.extendSelectionsBy(function (e) {
              var n = t.cursorCoords(e.head, "div").top + 5;
              return t.coordsChar({
                left: 0,
                top: n
              }, "div");
            }, K);
          },
          goLineLeftSmart: function goLineLeftSmart(t) {
            return t.extendSelectionsBy(function (e) {
              var n = t.cursorCoords(e.head, "div").top + 5,
                r = t.coordsChar({
                  left: 0,
                  top: n
                }, "div");
              return r.ch < t.getLine(r.line).search(/\S/) ? aa(t, e.head) : r;
            }, K);
          },
          goLineUp: function goLineUp(t) {
            return t.moveV(-1, "line");
          },
          goLineDown: function goLineDown(t) {
            return t.moveV(1, "line");
          },
          goPageUp: function goPageUp(t) {
            return t.moveV(-1, "page");
          },
          goPageDown: function goPageDown(t) {
            return t.moveV(1, "page");
          },
          goCharLeft: function goCharLeft(t) {
            return t.moveH(-1, "char");
          },
          goCharRight: function goCharRight(t) {
            return t.moveH(1, "char");
          },
          goColumnLeft: function goColumnLeft(t) {
            return t.moveH(-1, "column");
          },
          goColumnRight: function goColumnRight(t) {
            return t.moveH(1, "column");
          },
          goWordLeft: function goWordLeft(t) {
            return t.moveH(-1, "word");
          },
          goGroupRight: function goGroupRight(t) {
            return t.moveH(1, "group");
          },
          goGroupLeft: function goGroupLeft(t) {
            return t.moveH(-1, "group");
          },
          goWordRight: function goWordRight(t) {
            return t.moveH(1, "word");
          },
          delCharBefore: function delCharBefore(t) {
            return t.deleteH(-1, "codepoint");
          },
          delCharAfter: function delCharAfter(t) {
            return t.deleteH(1, "char");
          },
          delWordBefore: function delWordBefore(t) {
            return t.deleteH(-1, "word");
          },
          delWordAfter: function delWordAfter(t) {
            return t.deleteH(1, "word");
          },
          delGroupBefore: function delGroupBefore(t) {
            return t.deleteH(-1, "group");
          },
          delGroupAfter: function delGroupAfter(t) {
            return t.deleteH(1, "group");
          },
          indentAuto: function indentAuto(t) {
            return t.indentSelection("smart");
          },
          indentMore: function indentMore(t) {
            return t.indentSelection("add");
          },
          indentLess: function indentLess(t) {
            return t.indentSelection("subtract");
          },
          insertTab: function insertTab(t) {
            return t.replaceSelection("\t");
          },
          insertSoftTab: function insertSoftTab(t) {
            for (var e = [], n = t.listSelections(), r = t.options.tabSize, i = 0; i < n.length; i++) {
              var o = n[i].from(),
                a = U(t.getLine(o.line), o.ch, r);
              e.push(Z(r - a % r));
            }
            t.replaceSelections(e);
          },
          defaultTab: function defaultTab(t) {
            t.somethingSelected() ? t.indentSelection("add") : t.execCommand("insertTab");
          },
          transposeChars: function transposeChars(t) {
            return ii(t, function () {
              for (var e = t.listSelections(), n = [], r = 0; r < e.length; r++) if (e[r].empty()) {
                var i = e[r].head,
                  o = Jt(t.doc, i.line).text;
                if (o) if (i.ch == o.length && (i = new oe(i.line, i.ch - 1)), i.ch > 0) i = new oe(i.line, i.ch + 1), t.replaceRange(o.charAt(i.ch - 1) + o.charAt(i.ch - 2), oe(i.line, i.ch - 2), i, "+transpose");else if (i.line > t.doc.first) {
                  var a = Jt(t.doc, i.line - 1).text;
                  a && (i = new oe(i.line, 1), t.replaceRange(o.charAt(0) + t.doc.lineSeparator() + a.charAt(a.length - 1), oe(i.line - 1, a.length - 1), i, "+transpose"));
                }
                n.push(new Ei(i, i));
              }
              t.setSelections(n);
            });
          },
          newlineAndIndent: function newlineAndIndent(t) {
            return ii(t, function () {
              for (var e = t.listSelections(), n = e.length - 1; n >= 0; n--) t.replaceRange(t.doc.lineSeparator(), e[n].anchor, e[n].head, "+input");
              e = t.listSelections();
              for (var r = 0; r < e.length; r++) t.indentLine(e[r].from().line, null, !0);
              Ir(t);
            });
          },
          openLine: function openLine(t) {
            return t.replaceSelection("\n", "start");
          },
          toggleOverwrite: function toggleOverwrite(t) {
            return t.toggleOverwrite();
          }
        };
        function oa(t, e) {
          var n = Jt(t.doc, e),
            r = Ue(n);
          return r != n && (e = ee(r)), ra(!0, t, r, e, 1);
        }
        function aa(t, e) {
          var n = oa(t, e.line),
            r = Jt(t.doc, n.line),
            i = pt(r, t.doc.direction);
          if (!i || 0 == i[0].level) {
            var o = Math.max(n.ch, r.text.search(/\S/)),
              a = e.line == n.line && e.ch <= o && e.ch;
            return oe(n.line, a ? 0 : o, n.sticky);
          }
          return n;
        }
        function sa(t, e, n) {
          if ("string" == typeof e && !(e = ia[e])) return !1;
          t.display.input.ensurePolled();
          var r = t.display.shift,
            i = !1;
          try {
            t.isReadOnly() && (t.state.suppressEdits = !0), n && (t.display.shift = !1), i = e(t) != q;
          } finally {
            t.display.shift = r, t.state.suppressEdits = !1;
          }
          return i;
        }
        var ca = new $();
        function la(t, e, n, r) {
          var i = t.state.keySeq;
          if (i) {
            if (Xo(e)) return "handled";
            if (/\'$/.test(e) ? t.state.keySeq = null : ca.set(50, function () {
              t.state.keySeq == i && (t.state.keySeq = null, t.display.input.reset());
            }), ua(t, i + " " + e, n, r)) return !0;
          }
          return ua(t, e, n, r);
        }
        function ua(t, e, n, r) {
          var i = function (t, e, n) {
            for (var r = 0; r < t.state.keyMaps.length; r++) {
              var i = Ko(e, t.state.keyMaps[r], n, t);
              if (i) return i;
            }
            return t.options.extraKeys && Ko(e, t.options.extraKeys, n, t) || Ko(e, t.options.keyMap, n, t);
          }(t, e, r);
          return "multi" == i && (t.state.keySeq = e), "handled" == i && fn(t, "keyHandled", t, e, n), "handled" != i && "multi" != i || (St(n), Tr(t)), !!i;
        }
        function da(t, e) {
          var n = Zo(e, !0);
          return !!n && (e.shiftKey && !t.state.keySeq ? la(t, "Shift-" + n, e, function (e) {
            return sa(t, e, !0);
          }) || la(t, n, e, function (e) {
            if ("string" == typeof e ? /^go[A-Z]/.test(e) : e.motion) return sa(t, e);
          }) : la(t, n, e, function (e) {
            return sa(t, e);
          }));
        }
        var ha = null;
        function fa(t) {
          var e = this;
          if (!(t.target && t.target != e.display.input.getField() || (e.curOp.focus = L(F(e)), wt(e, t)))) {
            a && s < 11 && 27 == t.keyCode && (t.returnValue = !1);
            var r = t.keyCode;
            e.display.shift = 16 == r || t.shiftKey;
            var i = da(e, t);
            h && (ha = i ? r : null, i || 88 != r || Ft || !(y ? t.metaKey : t.ctrlKey) || e.replaceSelection("", null, "cut")), n && !y && !i && 46 == r && t.shiftKey && !t.ctrlKey && document.execCommand && document.execCommand("cut"), 18 != r || /\bCodeMirror-crosshair\b/.test(e.display.lineDiv.className) || function (t) {
              var e = t.display.lineDiv;
              function n(t) {
                18 != t.keyCode && t.altKey || (j(e, "CodeMirror-crosshair"), bt(document, "keyup", n), bt(document, "mouseover", n));
              }
              _(e, "CodeMirror-crosshair"), vt(document, "keyup", n), vt(document, "mouseover", n);
            }(e);
          }
        }
        function pa(t) {
          16 == t.keyCode && (this.doc.sel.shift = !1), wt(this, t);
        }
        function ga(t) {
          var e = this;
          if (!(t.target && t.target != e.display.input.getField() || jn(e.display, t) || wt(e, t) || t.ctrlKey && !t.altKey || y && t.metaKey)) {
            var n = t.keyCode,
              r = t.charCode;
            if (h && n == ha) return ha = null, void St(t);
            if (!h || t.which && !(t.which < 10) || !da(e, t)) {
              var i = String.fromCharCode(null == r ? n : r);
              "\b" != i && (function (t, e, n) {
                return la(t, "'" + n + "'", e, function (e) {
                  return sa(t, e, !0);
                });
              }(e, t, i) || e.display.input.onKeyPress(t));
            }
          }
        }
        var va,
          ma,
          ba = function ba(t, e, n) {
            this.time = t, this.pos = e, this.button = n;
          };
        function ya(t) {
          var e = this,
            n = e.display;
          if (!(wt(e, t) || n.activeTouch && n.input.supportsTouch())) if (n.input.ensurePolled(), n.shift = t.shiftKey, jn(n, t)) c || (n.scroller.draggable = !1, setTimeout(function () {
            return n.scroller.draggable = !0;
          }, 100));else if (!Oa(e, t)) {
            var r = pr(e, t),
              i = Pt(t),
              o = r ? function (t, e) {
                var n = +new Date();
                return ma && ma.compare(n, t, e) ? (va = ma = null, "triple") : va && va.compare(n, t, e) ? (ma = new ba(n, t, e), va = null, "double") : (va = new ba(n, t, e), ma = null, "single");
              }(r, i) : "single";
            z(e).focus(), 1 == i && e.state.selectingText && e.state.selectingText(t), r && function (t, e, n, r, i) {
              var o = "Click";
              return "double" == r ? o = "Double" + o : "triple" == r && (o = "Triple" + o), la(t, Jo(o = (1 == e ? "Left" : 2 == e ? "Middle" : "Right") + o, i), i, function (e) {
                if ("string" == typeof e && (e = ia[e]), !e) return !1;
                var r = !1;
                try {
                  t.isReadOnly() && (t.state.suppressEdits = !0), r = e(t, n) != q;
                } finally {
                  t.state.suppressEdits = !1;
                }
                return r;
              });
            }(e, i, r, o, t) || (1 == i ? r ? function (t, e, n, r) {
              a ? setTimeout(H(jr, t), 0) : t.curOp.focus = L(F(t));
              var i,
                o = function (t, e, n) {
                  var r = t.getOption("configureMouse"),
                    i = r ? r(t, e, n) : {};
                  if (null == i.unit) {
                    var o = w ? n.shiftKey && n.metaKey : n.altKey;
                    i.unit = o ? "rectangle" : "single" == e ? "char" : "double" == e ? "word" : "line";
                  }
                  return (null == i.extend || t.doc.extend) && (i.extend = t.doc.extend || n.shiftKey), null == i.addNew && (i.addNew = y ? n.metaKey : n.ctrlKey), null == i.moveOnDrag && (i.moveOnDrag = !(y ? n.altKey : n.ctrlKey)), i;
                }(t, n, r),
                l = t.doc.sel;
              t.options.dragDrop && Dt && !t.isReadOnly() && "single" == n && (i = l.contains(e)) > -1 && (ae((i = l.ranges[i]).from(), e) < 0 || e.xRel > 0) && (ae(i.to(), e) > 0 || e.xRel < 0) ? function (t, e, n, r) {
                var i = t.display,
                  o = !1,
                  l = oi(t, function (e) {
                    c && (i.scroller.draggable = !1), t.state.draggingText = !1, t.state.delayingBlurEvent && (t.hasFocus() ? t.state.delayingBlurEvent = !1 : Er(t)), bt(i.wrapper.ownerDocument, "mouseup", l), bt(i.wrapper.ownerDocument, "mousemove", u), bt(i.scroller, "dragstart", d), bt(i.scroller, "drop", l), o || (St(e), r.addNew || Zi(t.doc, n, null, null, r.extend), c && !f || a && 9 == s ? setTimeout(function () {
                      i.wrapper.ownerDocument.body.focus({
                        preventScroll: !0
                      }), i.input.focus();
                    }, 20) : i.input.focus());
                  }),
                  u = function u(t) {
                    o = o || Math.abs(e.clientX - t.clientX) + Math.abs(e.clientY - t.clientY) >= 10;
                  },
                  d = function d() {
                    return o = !0;
                  };
                c && (i.scroller.draggable = !0), t.state.draggingText = l, l.copy = !r.moveOnDrag, vt(i.wrapper.ownerDocument, "mouseup", l), vt(i.wrapper.ownerDocument, "mousemove", u), vt(i.scroller, "dragstart", d), vt(i.scroller, "drop", l), t.state.delayingBlurEvent = !0, setTimeout(function () {
                  return i.input.focus();
                }, 20), i.scroller.dragDrop && i.scroller.dragDrop();
              }(t, r, e, o) : function (t, e, n, r) {
                a && Er(t);
                var i = t.display,
                  o = t.doc;
                St(e);
                var s,
                  c,
                  l = o.sel,
                  u = l.ranges;
                if (r.addNew && !r.extend ? (c = o.sel.contains(n), s = c > -1 ? u[c] : new Ei(n, n)) : (s = o.sel.primary(), c = o.sel.primIndex), "rectangle" == r.unit) r.addNew || (s = new Ei(n, n)), n = pr(t, e, !0, !0), c = -1;else {
                  var d = wa(t, n, r.unit);
                  s = r.extend ? Ji(s, d.anchor, d.head, r.extend) : d;
                }
                r.addNew ? -1 == c ? (c = u.length, ro(o, Pi(t, u.concat([s]), c), {
                  scroll: !1,
                  origin: "*mouse"
                })) : u.length > 1 && u[c].empty() && "char" == r.unit && !r.extend ? (ro(o, Pi(t, u.slice(0, c).concat(u.slice(c + 1)), 0), {
                  scroll: !1,
                  origin: "*mouse"
                }), l = o.sel) : to(o, c, s, Y) : (c = 0, ro(o, new ji([s], 0), Y), l = o.sel);
                var h = n;
                function f(e) {
                  if (0 != ae(h, e)) if (h = e, "rectangle" == r.unit) {
                    for (var i = [], a = t.options.tabSize, u = U(Jt(o, n.line).text, n.ch, a), d = U(Jt(o, e.line).text, e.ch, a), f = Math.min(u, d), p = Math.max(u, d), g = Math.min(n.line, e.line), v = Math.min(t.lastLine(), Math.max(n.line, e.line)); g <= v; g++) {
                      var m = Jt(o, g).text,
                        b = X(m, f, a);
                      f == p ? i.push(new Ei(oe(g, b), oe(g, b))) : m.length > b && i.push(new Ei(oe(g, b), oe(g, X(m, p, a))));
                    }
                    i.length || i.push(new Ei(n, n)), ro(o, Pi(t, l.ranges.slice(0, c).concat(i), c), {
                      origin: "*mouse",
                      scroll: !1
                    }), t.scrollIntoView(e);
                  } else {
                    var y,
                      w = s,
                      x = wa(t, e, r.unit),
                      O = w.anchor;
                    ae(x.anchor, O) > 0 ? (y = x.head, O = ue(w.from(), x.anchor)) : (y = x.anchor, O = le(w.to(), x.head));
                    var C = l.ranges.slice(0);
                    C[c] = function (t, e) {
                      var n = e.anchor,
                        r = e.head,
                        i = Jt(t.doc, n.line);
                      if (0 == ae(n, r) && n.sticky == r.sticky) return e;
                      var o = pt(i);
                      if (!o) return e;
                      var a = ht(o, n.ch, n.sticky),
                        s = o[a];
                      if (s.from != n.ch && s.to != n.ch) return e;
                      var c,
                        l = a + (s.from == n.ch == (1 != s.level) ? 0 : 1);
                      if (0 == l || l == o.length) return e;
                      if (r.line != n.line) c = (r.line - n.line) * ("ltr" == t.doc.direction ? 1 : -1) > 0;else {
                        var u = ht(o, r.ch, r.sticky),
                          d = u - a || (r.ch - n.ch) * (1 == s.level ? -1 : 1);
                        c = u == l - 1 || u == l ? d < 0 : d > 0;
                      }
                      var h = o[l + (c ? -1 : 0)],
                        f = c == (1 == h.level),
                        p = f ? h.from : h.to,
                        g = f ? "after" : "before";
                      return n.ch == p && n.sticky == g ? e : new Ei(new oe(n.line, p, g), r);
                    }(t, new Ei(he(o, O), y)), ro(o, Pi(t, C, c), Y);
                  }
                }
                var p = i.wrapper.getBoundingClientRect(),
                  g = 0;
                function v(e) {
                  t.state.selectingText = !1, g = 1 / 0, e && (St(e), i.input.focus()), bt(i.wrapper.ownerDocument, "mousemove", m), bt(i.wrapper.ownerDocument, "mouseup", b), o.history.lastSelOrigin = null;
                }
                var m = oi(t, function (e) {
                    0 !== e.buttons && Pt(e) ? function e(n) {
                      var a = ++g,
                        s = pr(t, n, !0, "rectangle" == r.unit);
                      if (s) if (0 != ae(s, h)) {
                        t.curOp.focus = L(F(t)), f(s);
                        var c = Lr(i, o);
                        (s.line >= c.to || s.line < c.from) && setTimeout(oi(t, function () {
                          g == a && e(n);
                        }), 150);
                      } else {
                        var l = n.clientY < p.top ? -20 : n.clientY > p.bottom ? 20 : 0;
                        l && setTimeout(oi(t, function () {
                          g == a && (i.scroller.scrollTop += l, e(n));
                        }), 50);
                      }
                    }(e) : v(e);
                  }),
                  b = oi(t, v);
                t.state.selectingText = b, vt(i.wrapper.ownerDocument, "mousemove", m), vt(i.wrapper.ownerDocument, "mouseup", b);
              }(t, r, e, o);
            }(e, r, o, t) : Et(t) == n.scroller && St(t) : 2 == i ? (r && Zi(e.doc, r), setTimeout(function () {
              return n.input.focus();
            }, 20)) : 3 == i && (S ? e.display.input.onContextMenu(t) : Er(e)));
          }
        }
        function wa(t, e, n) {
          if ("char" == n) return new Ei(e, e);
          if ("word" == n) return t.findWordAt(e);
          if ("line" == n) return new Ei(oe(e.line, 0), he(t.doc, oe(e.line + 1, 0)));
          var r = n(t, e);
          return new Ei(r.from, r.to);
        }
        function xa(t, e, n, r) {
          var i, o;
          if (e.touches) i = e.touches[0].clientX, o = e.touches[0].clientY;else try {
            i = e.clientX, o = e.clientY;
          } catch (t) {
            return !1;
          }
          if (i >= Math.floor(t.display.gutters.getBoundingClientRect().right)) return !1;
          r && St(e);
          var a = t.display,
            s = a.lineDiv.getBoundingClientRect();
          if (o > s.bottom || !Ot(t, n)) return Tt(e);
          o -= s.top - a.viewOffset;
          for (var c = 0; c < t.display.gutterSpecs.length; ++c) {
            var l = a.gutters.childNodes[c];
            if (l && l.getBoundingClientRect().right >= i) return yt(t, n, t, ne(t.doc, o), t.display.gutterSpecs[c].className, e), Tt(e);
          }
        }
        function Oa(t, e) {
          return xa(t, e, "gutterClick", !0);
        }
        function Ca(t, e) {
          jn(t.display, e) || function (t, e) {
            return !!Ot(t, "gutterContextMenu") && xa(t, e, "gutterContextMenu", !1);
          }(t, e) || wt(t, e, "contextmenu") || S || t.display.input.onContextMenu(e);
        }
        function Sa(t) {
          t.display.wrapper.className = t.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + t.options.theme.replace(/(^|\s)\s*/g, " cm-s-"), Wn(t);
        }
        ba.prototype.compare = function (t, e, n) {
          return this.time + 400 > t && 0 == ae(e, this.pos) && n == this.button;
        };
        var ka = {
            toString: function toString() {
              return "CodeMirror.Init";
            }
          },
          Ta = {},
          ja = {};
        function Ea(t, e, n) {
          if (!e != !(n && n != ka)) {
            var r = t.display.dragFunctions,
              i = e ? vt : bt;
            i(t.display.scroller, "dragstart", r.start), i(t.display.scroller, "dragenter", r.enter), i(t.display.scroller, "dragover", r.over), i(t.display.scroller, "dragleave", r.leave), i(t.display.scroller, "drop", r.drop);
          }
        }
        function Pa(t) {
          t.options.lineWrapping ? (_(t.display.wrapper, "CodeMirror-wrap"), t.display.sizer.style.minWidth = "", t.display.sizerWidth = null) : (j(t.display.wrapper, "CodeMirror-wrap"), Xe(t)), fr(t), vr(t), Wn(t), setTimeout(function () {
            return qr(t);
          }, 100);
        }
        function Aa(t, e) {
          var n = this;
          if (!(this instanceof Aa)) return new Aa(t, e);
          this.options = e = e ? B(e) : {}, B(Ta, e, !1);
          var r = e.value;
          "string" == typeof r ? r = new _No(r, e.mode, null, e.lineSeparator, e.direction) : e.mode && (r.modeOption = e.mode), this.doc = r;
          var i = new Aa.inputStyles[e.inputStyle](this),
            o = this.display = new xi(t, r, i, e);
          for (var l in o.wrapper.CodeMirror = this, Sa(this), e.lineWrapping && (this.display.wrapper.className += " CodeMirror-wrap"), Kr(this), this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: !1,
            delayingBlurEvent: !1,
            focused: !1,
            suppressEdits: !1,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: !1,
            draggingText: !1,
            highlight: new $(),
            keySeq: null,
            specialChars: null
          }, e.autofocus && !b && o.input.focus(), a && s < 11 && setTimeout(function () {
            return n.display.input.reset(!0);
          }, 20), function (t) {
            var e = t.display;
            vt(e.scroller, "mousedown", oi(t, ya)), vt(e.scroller, "dblclick", a && s < 11 ? oi(t, function (e) {
              if (!wt(t, e)) {
                var n = pr(t, e);
                if (n && !Oa(t, e) && !jn(t.display, e)) {
                  St(e);
                  var r = t.findWordAt(n);
                  Zi(t.doc, r.anchor, r.head);
                }
              }
            }) : function (e) {
              return wt(t, e) || St(e);
            }), vt(e.scroller, "contextmenu", function (e) {
              return Ca(t, e);
            }), vt(e.input.getField(), "contextmenu", function (n) {
              e.scroller.contains(n.target) || Ca(t, n);
            });
            var n,
              r = {
                end: 0
              };
            function i() {
              e.activeTouch && (n = setTimeout(function () {
                return e.activeTouch = null;
              }, 1e3), (r = e.activeTouch).end = +new Date());
            }
            function o(t, e) {
              if (null == e.left) return !0;
              var n = e.left - t.left,
                r = e.top - t.top;
              return n * n + r * r > 400;
            }
            vt(e.scroller, "touchstart", function (i) {
              if (!wt(t, i) && !function (t) {
                if (1 != t.touches.length) return !1;
                var e = t.touches[0];
                return e.radiusX <= 1 && e.radiusY <= 1;
              }(i) && !Oa(t, i)) {
                e.input.ensurePolled(), clearTimeout(n);
                var o = +new Date();
                e.activeTouch = {
                  start: o,
                  moved: !1,
                  prev: o - r.end <= 300 ? r : null
                }, 1 == i.touches.length && (e.activeTouch.left = i.touches[0].pageX, e.activeTouch.top = i.touches[0].pageY);
              }
            }), vt(e.scroller, "touchmove", function () {
              e.activeTouch && (e.activeTouch.moved = !0);
            }), vt(e.scroller, "touchend", function (n) {
              var r = e.activeTouch;
              if (r && !jn(e, n) && null != r.left && !r.moved && new Date() - r.start < 300) {
                var a,
                  s = t.coordsChar(e.activeTouch, "page");
                a = !r.prev || o(r, r.prev) ? new Ei(s, s) : !r.prev.prev || o(r, r.prev.prev) ? t.findWordAt(s) : new Ei(oe(s.line, 0), he(t.doc, oe(s.line + 1, 0))), t.setSelection(a.anchor, a.head), t.focus(), St(n);
              }
              i();
            }), vt(e.scroller, "touchcancel", i), vt(e.scroller, "scroll", function () {
              e.scroller.clientHeight && (zr(t, e.scroller.scrollTop), Br(t, e.scroller.scrollLeft, !0), yt(t, "scroll", t));
            }), vt(e.scroller, "mousewheel", function (e) {
              return Ti(t, e);
            }), vt(e.scroller, "DOMMouseScroll", function (e) {
              return Ti(t, e);
            }), vt(e.wrapper, "scroll", function () {
              return e.wrapper.scrollTop = e.wrapper.scrollLeft = 0;
            }), e.dragFunctions = {
              enter: function enter(e) {
                wt(t, e) || jt(e);
              },
              over: function over(e) {
                wt(t, e) || (function (t, e) {
                  var n = pr(t, e);
                  if (n) {
                    var r = document.createDocumentFragment();
                    Cr(t, n, r), t.display.dragCursor || (t.display.dragCursor = A("div", null, "CodeMirror-cursors CodeMirror-dragcursors"), t.display.lineSpace.insertBefore(t.display.dragCursor, t.display.cursorDiv)), P(t.display.dragCursor, r);
                  }
                }(t, e), jt(e));
              },
              start: function start(e) {
                return function (t, e) {
                  if (a && (!t.state.draggingText || +new Date() - Io < 100)) jt(e);else if (!wt(t, e) && !jn(t.display, e) && (e.dataTransfer.setData("Text", t.getSelection()), e.dataTransfer.effectAllowed = "copyMove", e.dataTransfer.setDragImage && !f)) {
                    var n = A("img", null, null, "position: fixed; left: 0; top: 0;");
                    n.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", h && (n.width = n.height = 1, t.display.wrapper.appendChild(n), n._top = n.offsetTop), e.dataTransfer.setDragImage(n, 0, 0), h && n.parentNode.removeChild(n);
                  }
                }(t, e);
              },
              drop: oi(t, Ro),
              leave: function leave(e) {
                wt(t, e) || Fo(t);
              }
            };
            var c = e.input.getField();
            vt(c, "keyup", function (e) {
              return pa.call(t, e);
            }), vt(c, "keydown", oi(t, fa)), vt(c, "keypress", oi(t, ga)), vt(c, "focus", function (e) {
              return Pr(t, e);
            }), vt(c, "blur", function (e) {
              return Ar(t, e);
            });
          }(this), function () {
            var t;
            zo || (vt(window, "resize", function () {
              null == t && (t = setTimeout(function () {
                t = null, Vo(Ho);
              }, 100));
            }), vt(window, "blur", function () {
              return Vo(Ar);
            }), zo = !0);
          }(), Jr(this), this.curOp.forceUpdate = !0, zi(this, r), e.autofocus && !b || this.hasFocus() ? setTimeout(function () {
            n.hasFocus() && !n.state.focused && Pr(n);
          }, 20) : Ar(this), ja) ja.hasOwnProperty(l) && ja[l](this, e[l], ka);
          mi(this), e.finishInit && e.finishInit(this);
          for (var u = 0; u < Ma.length; ++u) Ma[u](this);
          Zr(this), c && e.lineWrapping && "optimizelegibility" == getComputedStyle(o.lineDiv).textRendering && (o.lineDiv.style.textRendering = "auto");
        }
        Aa.defaults = Ta, Aa.optionHandlers = ja;
        var Ma = [];
        function Da(t, e, n, r) {
          var i,
            o = t.doc;
          null == n && (n = "add"), "smart" == n && (o.mode.indent ? i = be(t, e).state : n = "prev");
          var a = t.options.tabSize,
            s = Jt(o, e),
            c = U(s.text, null, a);
          s.stateAfter && (s.stateAfter = null);
          var l,
            u = s.text.match(/^\s*/)[0];
          if (r || /\S/.test(s.text)) {
            if ("smart" == n && ((l = o.mode.indent(i, s.text.slice(u.length), s.text)) == q || l > 150)) {
              if (!r) return;
              n = "prev";
            }
          } else l = 0, n = "not";
          "prev" == n ? l = e > o.first ? U(Jt(o, e - 1).text, null, a) : 0 : "add" == n ? l = c + t.options.indentUnit : "subtract" == n ? l = c - t.options.indentUnit : "number" == typeof n && (l = c + n), l = Math.max(0, l);
          var d = "",
            h = 0;
          if (t.options.indentWithTabs) for (var f = Math.floor(l / a); f; --f) h += a, d += "\t";
          if (h < l && (d += Z(l - h)), d != u) return yo(o, d, oe(e, 0), oe(e, u.length), "+input"), s.stateAfter = null, !0;
          for (var p = 0; p < o.sel.ranges.length; p++) {
            var g = o.sel.ranges[p];
            if (g.head.line == e && g.head.ch < u.length) {
              var v = oe(e, u.length);
              to(o, p, new Ei(v, v));
              break;
            }
          }
        }
        Aa.defineInitHook = function (t) {
          return Ma.push(t);
        };
        var La = null;
        function _a(t) {
          La = t;
        }
        function Na(t, e, n, r, i) {
          var o = t.doc;
          t.display.shift = !1, r || (r = o.sel);
          var a = +new Date() - 200,
            s = "paste" == i || t.state.pasteIncoming > a,
            c = It(e),
            l = null;
          if (s && r.ranges.length > 1) if (La && La.text.join("\n") == e) {
            if (r.ranges.length % La.text.length == 0) {
              l = [];
              for (var u = 0; u < La.text.length; u++) l.push(o.splitLines(La.text[u]));
            }
          } else c.length == r.ranges.length && t.options.pasteLinesPerSelection && (l = tt(c, function (t) {
            return [t];
          }));
          for (var d = t.curOp.updateInput, h = r.ranges.length - 1; h >= 0; h--) {
            var f = r.ranges[h],
              p = f.from(),
              g = f.to();
            f.empty() && (n && n > 0 ? p = oe(p.line, p.ch - n) : t.state.overwrite && !s ? g = oe(g.line, Math.min(Jt(o, g.line).text.length, g.ch + Q(c).length)) : s && La && La.lineWise && La.text.join("\n") == c.join("\n") && (p = g = oe(p.line, 0)));
            var v = {
              from: p,
              to: g,
              text: l ? l[h % l.length] : c,
              origin: i || (s ? "paste" : t.state.cutIncoming > a ? "cut" : "+input")
            };
            po(t.doc, v), fn(t, "inputRead", t, v);
          }
          e && !s && Ra(t, e), Ir(t), t.curOp.updateInput < 2 && (t.curOp.updateInput = d), t.curOp.typing = !0, t.state.pasteIncoming = t.state.cutIncoming = -1;
        }
        function Ia(t, e) {
          var n = t.clipboardData && t.clipboardData.getData("Text");
          if (n) return t.preventDefault(), e.isReadOnly() || e.options.disableInput || !e.hasFocus() || ii(e, function () {
            return Na(e, n, 0, null, "paste");
          }), !0;
        }
        function Ra(t, e) {
          if (t.options.electricChars && t.options.smartIndent) for (var n = t.doc.sel, r = n.ranges.length - 1; r >= 0; r--) {
            var i = n.ranges[r];
            if (!(i.head.ch > 100 || r && n.ranges[r - 1].head.line == i.head.line)) {
              var o = t.getModeAt(i.head),
                a = !1;
              if (o.electricChars) {
                for (var s = 0; s < o.electricChars.length; s++) if (e.indexOf(o.electricChars.charAt(s)) > -1) {
                  a = Da(t, i.head.line, "smart");
                  break;
                }
              } else o.electricInput && o.electricInput.test(Jt(t.doc, i.head.line).text.slice(0, i.head.ch)) && (a = Da(t, i.head.line, "smart"));
              a && fn(t, "electricInput", t, i.head.line);
            }
          }
        }
        function Fa(t) {
          for (var e = [], n = [], r = 0; r < t.doc.sel.ranges.length; r++) {
            var i = t.doc.sel.ranges[r].head.line,
              o = {
                anchor: oe(i, 0),
                head: oe(i + 1, 0)
              };
            n.push(o), e.push(t.getRange(o.anchor, o.head));
          }
          return {
            text: e,
            ranges: n
          };
        }
        function Va(t, e, n, r) {
          t.setAttribute("autocorrect", n ? "on" : "off"), t.setAttribute("autocapitalize", r ? "on" : "off"), t.setAttribute("spellcheck", !!e);
        }
        function za() {
          var t = A("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none"),
            e = A("div", [t], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
          return c ? t.style.width = "1000px" : t.setAttribute("wrap", "off"), v && (t.style.border = "1px solid black"), e;
        }
        function Ha(t, e, n, r, i) {
          var o = e,
            a = n,
            s = Jt(t, e.line),
            c = i && "rtl" == t.direction ? -n : n;
          function l(o) {
            var a, l;
            if ("codepoint" == r) {
              var u = s.text.charCodeAt(e.ch + (n > 0 ? 0 : -1));
              if (isNaN(u)) a = null;else {
                var d = n > 0 ? u >= 55296 && u < 56320 : u >= 56320 && u < 57343;
                a = new oe(e.line, Math.max(0, Math.min(s.text.length, e.ch + n * (d ? 2 : 1))), -n);
              }
            } else a = i ? function (t, e, n, r) {
              var i = pt(e, t.doc.direction);
              if (!i) return na(e, n, r);
              n.ch >= e.text.length ? (n.ch = e.text.length, n.sticky = "before") : n.ch <= 0 && (n.ch = 0, n.sticky = "after");
              var o = ht(i, n.ch, n.sticky),
                a = i[o];
              if ("ltr" == t.doc.direction && a.level % 2 == 0 && (r > 0 ? a.to > n.ch : a.from < n.ch)) return na(e, n, r);
              var s,
                c = function c(t, n) {
                  return ea(e, t instanceof oe ? t.ch : t, n);
                },
                l = function l(n) {
                  return t.options.lineWrapping ? (s = s || Rn(t, e), rr(t, e, s, n)) : {
                    begin: 0,
                    end: e.text.length
                  };
                },
                u = l("before" == n.sticky ? c(n, -1) : n.ch);
              if ("rtl" == t.doc.direction || 1 == a.level) {
                var d = 1 == a.level == r < 0,
                  h = c(n, d ? 1 : -1);
                if (null != h && (d ? h <= a.to && h <= u.end : h >= a.from && h >= u.begin)) {
                  var f = d ? "before" : "after";
                  return new oe(n.line, h, f);
                }
              }
              var p = function p(t, e, r) {
                  for (var o = function o(t, e) {
                    return e ? new oe(n.line, c(t, 1), "before") : new oe(n.line, t, "after");
                  }; t >= 0 && t < i.length; t += e) {
                    var a = i[t],
                      s = e > 0 == (1 != a.level),
                      l = s ? r.begin : c(r.end, -1);
                    if (a.from <= l && l < a.to) return o(l, s);
                    if (l = s ? a.from : c(a.to, -1), r.begin <= l && l < r.end) return o(l, s);
                  }
                },
                g = p(o + r, r, u);
              if (g) return g;
              var v = r > 0 ? u.end : c(u.begin, -1);
              return null == v || r > 0 && v == e.text.length || !(g = p(r > 0 ? 0 : i.length - 1, r, l(v))) ? null : g;
            }(t.cm, s, e, n) : na(s, e, n);
            if (null == a) {
              if (o || (l = e.line + c) < t.first || l >= t.first + t.size || (e = new oe(l, e.ch, e.sticky), !(s = Jt(t, l)))) return !1;
              e = ra(i, t.cm, s, e.line, c);
            } else e = a;
            return !0;
          }
          if ("char" == r || "codepoint" == r) l();else if ("column" == r) l(!0);else if ("word" == r || "group" == r) for (var u = null, d = "group" == r, h = t.cm && t.cm.getHelper(e, "wordChars"), f = !0; !(n < 0) || l(!f); f = !1) {
            var p = s.text.charAt(e.ch) || "\n",
              g = ot(p, h) ? "w" : d && "\n" == p ? "n" : !d || /\s/.test(p) ? null : "p";
            if (!d || f || g || (g = "s"), u && u != g) {
              n < 0 && (n = 1, l(), e.sticky = "after");
              break;
            }
            if (g && (u = g), n > 0 && !l(!f)) break;
          }
          var v = lo(t, e, o, a, !0);
          return se(o, v) && (v.hitSide = !0), v;
        }
        function Ba(t, e, n, r) {
          var i,
            o,
            a = t.doc,
            s = e.left;
          if ("page" == r) {
            var c = Math.min(t.display.wrapper.clientHeight, z(t).innerHeight || a(t).documentElement.clientHeight),
              l = Math.max(c - .5 * cr(t.display), 3);
            i = (n > 0 ? e.bottom : e.top) + n * l;
          } else "line" == r && (i = n > 0 ? e.bottom + 3 : e.top - 3);
          for (; (o = er(t, s, i)).outside;) {
            if (n < 0 ? i <= 0 : i >= a.height) {
              o.hitSide = !0;
              break;
            }
            i += 5 * n;
          }
          return o;
        }
        var Ua = function Ua(t) {
          this.cm = t, this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null, this.polling = new $(), this.composing = null, this.gracePeriod = !1, this.readDOMTimeout = null;
        };
        function $a(t, e) {
          var n = In(t, e.line);
          if (!n || n.hidden) return null;
          var r = Jt(t.doc, e.line),
            i = _n(n, r, e.line),
            o = pt(r, t.doc.direction),
            a = "left";
          o && (a = ht(o, e.ch) % 2 ? "right" : "left");
          var s = Hn(i.map, e.ch, a);
          return s.offset = "right" == s.collapse ? s.end : s.start, s;
        }
        function Wa(t, e) {
          return e && (t.bad = !0), t;
        }
        function qa(t, e, n) {
          var r;
          if (e == t.display.lineDiv) {
            if (!(r = t.display.lineDiv.childNodes[n])) return Wa(t.clipPos(oe(t.display.viewTo - 1)), !0);
            e = null, n = 0;
          } else for (r = e;; r = r.parentNode) {
            if (!r || r == t.display.lineDiv) return null;
            if (r.parentNode && r.parentNode == t.display.lineDiv) break;
          }
          for (var i = 0; i < t.display.view.length; i++) {
            var o = t.display.view[i];
            if (o.node == r) return Ga(o, e, n);
          }
        }
        function Ga(t, e, n) {
          var r = t.text.firstChild,
            i = !1;
          if (!e || !D(r, e)) return Wa(oe(ee(t.line), 0), !0);
          if (e == r && (i = !0, e = r.childNodes[n], n = 0, !e)) {
            var o = t.rest ? Q(t.rest) : t.line;
            return Wa(oe(ee(o), o.text.length), i);
          }
          var a = 3 == e.nodeType ? e : null,
            s = e;
          for (a || 1 != e.childNodes.length || 3 != e.firstChild.nodeType || (a = e.firstChild, n && (n = a.nodeValue.length)); s.parentNode != r;) s = s.parentNode;
          var c = t.measure,
            l = c.maps;
          function u(e, n, r) {
            for (var i = -1; i < (l ? l.length : 0); i++) for (var o = i < 0 ? c.map : l[i], a = 0; a < o.length; a += 3) {
              var s = o[a + 2];
              if (s == e || s == n) {
                var u = ee(i < 0 ? t.line : t.rest[i]),
                  d = o[a] + r;
                return (r < 0 || s != e) && (d = o[a + (r ? 1 : 0)]), oe(u, d);
              }
            }
          }
          var d = u(a, s, n);
          if (d) return Wa(d, i);
          for (var h = s.nextSibling, f = a ? a.nodeValue.length - n : 0; h; h = h.nextSibling) {
            if (d = u(h, h.firstChild, 0)) return Wa(oe(d.line, d.ch - f), i);
            f += h.textContent.length;
          }
          for (var p = s.previousSibling, g = n; p; p = p.previousSibling) {
            if (d = u(p, p.firstChild, -1)) return Wa(oe(d.line, d.ch + g), i);
            g += p.textContent.length;
          }
        }
        Ua.prototype.init = function (t) {
          var e = this,
            n = this,
            r = n.cm,
            i = n.div = t.lineDiv;
          function o(t) {
            for (var e = t.target; e; e = e.parentNode) {
              if (e == i) return !0;
              if (/\bCodeMirror-(?:line)?widget\b/.test(e.className)) break;
            }
            return !1;
          }
          function a(t) {
            if (o(t) && !wt(r, t)) {
              if (r.somethingSelected()) _a({
                lineWise: !1,
                text: r.getSelections()
              }), "cut" == t.type && r.replaceSelection("", null, "cut");else {
                if (!r.options.lineWiseCopyCut) return;
                var e = Fa(r);
                _a({
                  lineWise: !0,
                  text: e.text
                }), "cut" == t.type && r.operation(function () {
                  r.setSelections(e.ranges, 0, G), r.replaceSelection("", null, "cut");
                });
              }
              if (t.clipboardData) {
                t.clipboardData.clearData();
                var a = La.text.join("\n");
                if (t.clipboardData.setData("Text", a), t.clipboardData.getData("Text") == a) return void t.preventDefault();
              }
              var s = za(),
                c = s.firstChild;
              Va(c), r.display.lineSpace.insertBefore(s, r.display.lineSpace.firstChild), c.value = La.text.join("\n");
              var l = L(V(i));
              I(c), setTimeout(function () {
                r.display.lineSpace.removeChild(s), l.focus(), l == i && n.showPrimarySelection();
              }, 50);
            }
          }
          i.contentEditable = !0, Va(i, r.options.spellcheck, r.options.autocorrect, r.options.autocapitalize), vt(i, "paste", function (t) {
            !o(t) || wt(r, t) || Ia(t, r) || s <= 11 && setTimeout(oi(r, function () {
              return e.updateFromDOM();
            }), 20);
          }), vt(i, "compositionstart", function (t) {
            e.composing = {
              data: t.data,
              done: !1
            };
          }), vt(i, "compositionupdate", function (t) {
            e.composing || (e.composing = {
              data: t.data,
              done: !1
            });
          }), vt(i, "compositionend", function (t) {
            e.composing && (t.data != e.composing.data && e.readFromDOMSoon(), e.composing.done = !0);
          }), vt(i, "touchstart", function () {
            return n.forceCompositionEnd();
          }), vt(i, "input", function () {
            e.composing || e.readFromDOMSoon();
          }), vt(i, "copy", a), vt(i, "cut", a);
        }, Ua.prototype.screenReaderLabelChanged = function (t) {
          t ? this.div.setAttribute("aria-label", t) : this.div.removeAttribute("aria-label");
        }, Ua.prototype.prepareSelection = function () {
          var t = Or(this.cm, !1);
          return t.focus = L(V(this.div)) == this.div, t;
        }, Ua.prototype.showSelection = function (t, e) {
          t && this.cm.display.view.length && ((t.focus || e) && this.showPrimarySelection(), this.showMultipleSelections(t));
        }, Ua.prototype.getSelection = function () {
          return this.cm.display.wrapper.ownerDocument.getSelection();
        }, Ua.prototype.showPrimarySelection = function () {
          var t = this.getSelection(),
            e = this.cm,
            r = e.doc.sel.primary(),
            i = r.from(),
            o = r.to();
          if (e.display.viewTo == e.display.viewFrom || i.line >= e.display.viewTo || o.line < e.display.viewFrom) t.removeAllRanges();else {
            var a = qa(e, t.anchorNode, t.anchorOffset),
              s = qa(e, t.focusNode, t.focusOffset);
            if (!a || a.bad || !s || s.bad || 0 != ae(ue(a, s), i) || 0 != ae(le(a, s), o)) {
              var c = e.display.view,
                l = i.line >= e.display.viewFrom && $a(e, i) || {
                  node: c[0].measure.map[2],
                  offset: 0
                },
                u = o.line < e.display.viewTo && $a(e, o);
              if (!u) {
                var d = c[c.length - 1].measure,
                  h = d.maps ? d.maps[d.maps.length - 1] : d.map;
                u = {
                  node: h[h.length - 1],
                  offset: h[h.length - 2] - h[h.length - 3]
                };
              }
              if (l && u) {
                var f,
                  p = t.rangeCount && t.getRangeAt(0);
                try {
                  f = T(l.node, l.offset, u.offset, u.node);
                } catch (t) {}
                f && (!n && e.state.focused ? (t.collapse(l.node, l.offset), f.collapsed || (t.removeAllRanges(), t.addRange(f))) : (t.removeAllRanges(), t.addRange(f)), p && null == t.anchorNode ? t.addRange(p) : n && this.startGracePeriod()), this.rememberSelection();
              } else t.removeAllRanges();
            }
          }
        }, Ua.prototype.startGracePeriod = function () {
          var t = this;
          clearTimeout(this.gracePeriod), this.gracePeriod = setTimeout(function () {
            t.gracePeriod = !1, t.selectionChanged() && t.cm.operation(function () {
              return t.cm.curOp.selectionChanged = !0;
            });
          }, 20);
        }, Ua.prototype.showMultipleSelections = function (t) {
          P(this.cm.display.cursorDiv, t.cursors), P(this.cm.display.selectionDiv, t.selection);
        }, Ua.prototype.rememberSelection = function () {
          var t = this.getSelection();
          this.lastAnchorNode = t.anchorNode, this.lastAnchorOffset = t.anchorOffset, this.lastFocusNode = t.focusNode, this.lastFocusOffset = t.focusOffset;
        }, Ua.prototype.selectionInEditor = function () {
          var t = this.getSelection();
          if (!t.rangeCount) return !1;
          var e = t.getRangeAt(0).commonAncestorContainer;
          return D(this.div, e);
        }, Ua.prototype.focus = function () {
          "nocursor" != this.cm.options.readOnly && (this.selectionInEditor() && L(V(this.div)) == this.div || this.showSelection(this.prepareSelection(), !0), this.div.focus());
        }, Ua.prototype.blur = function () {
          this.div.blur();
        }, Ua.prototype.getField = function () {
          return this.div;
        }, Ua.prototype.supportsTouch = function () {
          return !0;
        }, Ua.prototype.receivedFocus = function () {
          var t = this,
            e = this;
          this.selectionInEditor() ? setTimeout(function () {
            return t.pollSelection();
          }, 20) : ii(this.cm, function () {
            return e.cm.curOp.selectionChanged = !0;
          }), this.polling.set(this.cm.options.pollInterval, function t() {
            e.cm.state.focused && (e.pollSelection(), e.polling.set(e.cm.options.pollInterval, t));
          });
        }, Ua.prototype.selectionChanged = function () {
          var t = this.getSelection();
          return t.anchorNode != this.lastAnchorNode || t.anchorOffset != this.lastAnchorOffset || t.focusNode != this.lastFocusNode || t.focusOffset != this.lastFocusOffset;
        }, Ua.prototype.pollSelection = function () {
          if (null == this.readDOMTimeout && !this.gracePeriod && this.selectionChanged()) {
            var t = this.getSelection(),
              e = this.cm;
            if (m && u && this.cm.display.gutterSpecs.length && function (t) {
              for (var e = t; e; e = e.parentNode) if (/CodeMirror-gutter-wrapper/.test(e.className)) return !0;
              return !1;
            }(t.anchorNode)) return this.cm.triggerOnKeyDown({
              type: "keydown",
              keyCode: 8,
              preventDefault: Math.abs
            }), this.blur(), void this.focus();
            if (!this.composing) {
              this.rememberSelection();
              var n = qa(e, t.anchorNode, t.anchorOffset),
                r = qa(e, t.focusNode, t.focusOffset);
              n && r && ii(e, function () {
                ro(e.doc, Ai(n, r), G), (n.bad || r.bad) && (e.curOp.selectionChanged = !0);
              });
            }
          }
        }, Ua.prototype.pollContent = function () {
          null != this.readDOMTimeout && (clearTimeout(this.readDOMTimeout), this.readDOMTimeout = null);
          var t,
            e,
            n,
            r = this.cm,
            i = r.display,
            o = r.doc.sel.primary(),
            a = o.from(),
            s = o.to();
          if (0 == a.ch && a.line > r.firstLine() && (a = oe(a.line - 1, Jt(r.doc, a.line - 1).length)), s.ch == Jt(r.doc, s.line).text.length && s.line < r.lastLine() && (s = oe(s.line + 1, 0)), a.line < i.viewFrom || s.line > i.viewTo - 1) return !1;
          a.line == i.viewFrom || 0 == (t = gr(r, a.line)) ? (e = ee(i.view[0].line), n = i.view[0].node) : (e = ee(i.view[t].line), n = i.view[t - 1].node.nextSibling);
          var c,
            l,
            u = gr(r, s.line);
          if (u == i.view.length - 1 ? (c = i.viewTo - 1, l = i.lineDiv.lastChild) : (c = ee(i.view[u + 1].line) - 1, l = i.view[u + 1].node.previousSibling), !n) return !1;
          for (var d = r.doc.splitLines(function (t, e, n, r, i) {
              var o = "",
                a = !1,
                s = t.doc.lineSeparator(),
                c = !1;
              function l() {
                a && (o += s, c && (o += s), a = c = !1);
              }
              function u(t) {
                t && (l(), o += t);
              }
              function d(e) {
                if (1 == e.nodeType) {
                  var n = e.getAttribute("cm-text");
                  if (n) return void u(n);
                  var o,
                    h = e.getAttribute("cm-marker");
                  if (h) {
                    var f = t.findMarks(oe(r, 0), oe(i + 1, 0), (v = +h, function (t) {
                      return t.id == v;
                    }));
                    return void (f.length && (o = f[0].find(0)) && u(Zt(t.doc, o.from, o.to).join(s)));
                  }
                  if ("false" == e.getAttribute("contenteditable")) return;
                  var p = /^(pre|div|p|li|table|br)$/i.test(e.nodeName);
                  if (!/^br$/i.test(e.nodeName) && 0 == e.textContent.length) return;
                  p && l();
                  for (var g = 0; g < e.childNodes.length; g++) d(e.childNodes[g]);
                  /^(pre|p)$/i.test(e.nodeName) && (c = !0), p && (a = !0);
                } else 3 == e.nodeType && u(e.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
                var v;
              }
              for (; d(e), e != n;) e = e.nextSibling, c = !1;
              return o;
            }(r, n, l, e, c)), h = Zt(r.doc, oe(e, 0), oe(c, Jt(r.doc, c).text.length)); d.length > 1 && h.length > 1;) if (Q(d) == Q(h)) d.pop(), h.pop(), c--;else {
            if (d[0] != h[0]) break;
            d.shift(), h.shift(), e++;
          }
          for (var f = 0, p = 0, g = d[0], v = h[0], m = Math.min(g.length, v.length); f < m && g.charCodeAt(f) == v.charCodeAt(f);) ++f;
          for (var b = Q(d), y = Q(h), w = Math.min(b.length - (1 == d.length ? f : 0), y.length - (1 == h.length ? f : 0)); p < w && b.charCodeAt(b.length - p - 1) == y.charCodeAt(y.length - p - 1);) ++p;
          if (1 == d.length && 1 == h.length && e == a.line) for (; f && f > a.ch && b.charCodeAt(b.length - p - 1) == y.charCodeAt(y.length - p - 1);) f--, p++;
          d[d.length - 1] = b.slice(0, b.length - p).replace(/^\u200b+/, ""), d[0] = d[0].slice(f).replace(/\u200b+$/, "");
          var x = oe(e, f),
            O = oe(c, h.length ? Q(h).length - p : 0);
          return d.length > 1 || d[0] || ae(x, O) ? (yo(r.doc, d, x, O, "+input"), !0) : void 0;
        }, Ua.prototype.ensurePolled = function () {
          this.forceCompositionEnd();
        }, Ua.prototype.reset = function () {
          this.forceCompositionEnd();
        }, Ua.prototype.forceCompositionEnd = function () {
          this.composing && (clearTimeout(this.readDOMTimeout), this.composing = null, this.updateFromDOM(), this.div.blur(), this.div.focus());
        }, Ua.prototype.readFromDOMSoon = function () {
          var t = this;
          null == this.readDOMTimeout && (this.readDOMTimeout = setTimeout(function () {
            if (t.readDOMTimeout = null, t.composing) {
              if (!t.composing.done) return;
              t.composing = null;
            }
            t.updateFromDOM();
          }, 80));
        }, Ua.prototype.updateFromDOM = function () {
          var t = this;
          !this.cm.isReadOnly() && this.pollContent() || ii(this.cm, function () {
            return vr(t.cm);
          });
        }, Ua.prototype.setUneditable = function (t) {
          t.contentEditable = "false";
        }, Ua.prototype.onKeyPress = function (t) {
          0 == t.charCode || this.composing || (t.preventDefault(), this.cm.isReadOnly() || oi(this.cm, Na)(this.cm, String.fromCharCode(null == t.charCode ? t.keyCode : t.charCode), 0));
        }, Ua.prototype.readOnlyChanged = function (t) {
          this.div.contentEditable = String("nocursor" != t);
        }, Ua.prototype.onContextMenu = function () {}, Ua.prototype.resetPosition = function () {}, Ua.prototype.needsContentAttribute = !0;
        var Ya = function Ya(t) {
          this.cm = t, this.prevInput = "", this.pollingFast = !1, this.polling = new $(), this.hasSelection = !1, this.composing = null, this.resetting = !1;
        };
        Ya.prototype.init = function (t) {
          var e = this,
            n = this,
            r = this.cm;
          this.createField(t);
          var i = this.textarea;
          function o(t) {
            if (!wt(r, t)) {
              if (r.somethingSelected()) _a({
                lineWise: !1,
                text: r.getSelections()
              });else {
                if (!r.options.lineWiseCopyCut) return;
                var e = Fa(r);
                _a({
                  lineWise: !0,
                  text: e.text
                }), "cut" == t.type ? r.setSelections(e.ranges, null, G) : (n.prevInput = "", i.value = e.text.join("\n"), I(i));
              }
              "cut" == t.type && (r.state.cutIncoming = +new Date());
            }
          }
          t.wrapper.insertBefore(this.wrapper, t.wrapper.firstChild), v && (i.style.width = "0px"), vt(i, "input", function () {
            a && s >= 9 && e.hasSelection && (e.hasSelection = null), n.poll();
          }), vt(i, "paste", function (t) {
            wt(r, t) || Ia(t, r) || (r.state.pasteIncoming = +new Date(), n.fastPoll());
          }), vt(i, "cut", o), vt(i, "copy", o), vt(t.scroller, "paste", function (e) {
            if (!jn(t, e) && !wt(r, e)) {
              if (!i.dispatchEvent) return r.state.pasteIncoming = +new Date(), void n.focus();
              var o = new Event("paste");
              o.clipboardData = e.clipboardData, i.dispatchEvent(o);
            }
          }), vt(t.lineSpace, "selectstart", function (e) {
            jn(t, e) || St(e);
          }), vt(i, "compositionstart", function () {
            var t = r.getCursor("from");
            n.composing && n.composing.range.clear(), n.composing = {
              start: t,
              range: r.markText(t, r.getCursor("to"), {
                className: "CodeMirror-composing"
              })
            };
          }), vt(i, "compositionend", function () {
            n.composing && (n.poll(), n.composing.range.clear(), n.composing = null);
          });
        }, Ya.prototype.createField = function (t) {
          this.wrapper = za(), this.textarea = this.wrapper.firstChild;
          var e = this.cm.options;
          Va(this.textarea, e.spellcheck, e.autocorrect, e.autocapitalize);
        }, Ya.prototype.screenReaderLabelChanged = function (t) {
          t ? this.textarea.setAttribute("aria-label", t) : this.textarea.removeAttribute("aria-label");
        }, Ya.prototype.prepareSelection = function () {
          var t = this.cm,
            e = t.display,
            n = t.doc,
            r = Or(t);
          if (t.options.moveInputWithCursor) {
            var i = Zn(t, n.sel.primary().head, "div"),
              o = e.wrapper.getBoundingClientRect(),
              a = e.lineDiv.getBoundingClientRect();
            r.teTop = Math.max(0, Math.min(e.wrapper.clientHeight - 10, i.top + a.top - o.top)), r.teLeft = Math.max(0, Math.min(e.wrapper.clientWidth - 10, i.left + a.left - o.left));
          }
          return r;
        }, Ya.prototype.showSelection = function (t) {
          var e = this.cm.display;
          P(e.cursorDiv, t.cursors), P(e.selectionDiv, t.selection), null != t.teTop && (this.wrapper.style.top = t.teTop + "px", this.wrapper.style.left = t.teLeft + "px");
        }, Ya.prototype.reset = function (t) {
          if (!(this.contextMenuPending || this.composing && t)) {
            var e = this.cm;
            if (this.resetting = !0, e.somethingSelected()) {
              this.prevInput = "";
              var n = e.getSelection();
              this.textarea.value = n, e.state.focused && I(this.textarea), a && s >= 9 && (this.hasSelection = n);
            } else t || (this.prevInput = this.textarea.value = "", a && s >= 9 && (this.hasSelection = null));
            this.resetting = !1;
          }
        }, Ya.prototype.getField = function () {
          return this.textarea;
        }, Ya.prototype.supportsTouch = function () {
          return !1;
        }, Ya.prototype.focus = function () {
          if ("nocursor" != this.cm.options.readOnly && (!b || L(V(this.textarea)) != this.textarea)) try {
            this.textarea.focus();
          } catch (t) {}
        }, Ya.prototype.blur = function () {
          this.textarea.blur();
        }, Ya.prototype.resetPosition = function () {
          this.wrapper.style.top = this.wrapper.style.left = 0;
        }, Ya.prototype.receivedFocus = function () {
          this.slowPoll();
        }, Ya.prototype.slowPoll = function () {
          var t = this;
          this.pollingFast || this.polling.set(this.cm.options.pollInterval, function () {
            t.poll(), t.cm.state.focused && t.slowPoll();
          });
        }, Ya.prototype.fastPoll = function () {
          var t = !1,
            e = this;
          e.pollingFast = !0, e.polling.set(20, function n() {
            e.poll() || t ? (e.pollingFast = !1, e.slowPoll()) : (t = !0, e.polling.set(60, n));
          });
        }, Ya.prototype.poll = function () {
          var t = this,
            e = this.cm,
            n = this.textarea,
            r = this.prevInput;
          if (this.contextMenuPending || this.resetting || !e.state.focused || Rt(n) && !r && !this.composing || e.isReadOnly() || e.options.disableInput || e.state.keySeq) return !1;
          var i = n.value;
          if (i == r && !e.somethingSelected()) return !1;
          if (a && s >= 9 && this.hasSelection === i || y && /[\uf700-\uf7ff]/.test(i)) return e.display.input.reset(), !1;
          if (e.doc.sel == e.display.selForContextMenu) {
            var o = i.charCodeAt(0);
            if (8203 != o || r || (r = "​"), 8666 == o) return this.reset(), this.cm.execCommand("undo");
          }
          for (var c = 0, l = Math.min(r.length, i.length); c < l && r.charCodeAt(c) == i.charCodeAt(c);) ++c;
          return ii(e, function () {
            Na(e, i.slice(c), r.length - c, null, t.composing ? "*compose" : null), i.length > 1e3 || i.indexOf("\n") > -1 ? n.value = t.prevInput = "" : t.prevInput = i, t.composing && (t.composing.range.clear(), t.composing.range = e.markText(t.composing.start, e.getCursor("to"), {
              className: "CodeMirror-composing"
            }));
          }), !0;
        }, Ya.prototype.ensurePolled = function () {
          this.pollingFast && this.poll() && (this.pollingFast = !1);
        }, Ya.prototype.onKeyPress = function () {
          a && s >= 9 && (this.hasSelection = null), this.fastPoll();
        }, Ya.prototype.onContextMenu = function (t) {
          var e = this,
            n = e.cm,
            r = n.display,
            i = e.textarea;
          e.contextMenuPending && e.contextMenuPending();
          var o = pr(n, t),
            l = r.scroller.scrollTop;
          if (o && !h) {
            n.options.resetSelectionOnContextMenu && -1 == n.doc.sel.contains(o) && oi(n, ro)(n.doc, Ai(o), G);
            var u,
              d = i.style.cssText,
              f = e.wrapper.style.cssText,
              p = e.wrapper.offsetParent.getBoundingClientRect();
            if (e.wrapper.style.cssText = "position: static", i.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (t.clientY - p.top - 5) + "px; left: " + (t.clientX - p.left - 5) + "px;\n      z-index: 1000; background: " + (a ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);", c && (u = i.ownerDocument.defaultView.scrollY), r.input.focus(), c && i.ownerDocument.defaultView.scrollTo(null, u), r.input.reset(), n.somethingSelected() || (i.value = e.prevInput = " "), e.contextMenuPending = m, r.selForContextMenu = n.doc.sel, clearTimeout(r.detectingSelectAll), a && s >= 9 && v(), S) {
              jt(t);
              var _g = function g() {
                bt(window, "mouseup", _g), setTimeout(m, 20);
              };
              vt(window, "mouseup", _g);
            } else setTimeout(m, 50);
          }
          function v() {
            if (null != i.selectionStart) {
              var t = n.somethingSelected(),
                o = "​" + (t ? i.value : "");
              i.value = "⇚", i.value = o, e.prevInput = t ? "" : "​", i.selectionStart = 1, i.selectionEnd = o.length, r.selForContextMenu = n.doc.sel;
            }
          }
          function m() {
            if (e.contextMenuPending == m && (e.contextMenuPending = !1, e.wrapper.style.cssText = f, i.style.cssText = d, a && s < 9 && r.scrollbars.setScrollTop(r.scroller.scrollTop = l), null != i.selectionStart)) {
              (!a || a && s < 9) && v();
              var t = 0,
                _o5 = function o() {
                  r.selForContextMenu == n.doc.sel && 0 == i.selectionStart && i.selectionEnd > 0 && "​" == e.prevInput ? oi(n, ho)(n) : t++ < 10 ? r.detectingSelectAll = setTimeout(_o5, 500) : (r.selForContextMenu = null, r.input.reset());
                };
              r.detectingSelectAll = setTimeout(_o5, 200);
            }
          }
        }, Ya.prototype.readOnlyChanged = function (t) {
          t || this.reset(), this.textarea.disabled = "nocursor" == t, this.textarea.readOnly = !!t;
        }, Ya.prototype.setUneditable = function () {}, Ya.prototype.needsContentAttribute = !1, function (t) {
          var e = t.optionHandlers;
          function n(n, r, i, o) {
            t.defaults[n] = r, i && (e[n] = o ? function (t, e, n) {
              n != ka && i(t, e, n);
            } : i);
          }
          t.defineOption = n, t.Init = ka, n("value", "", function (t, e) {
            return t.setValue(e);
          }, !0), n("mode", null, function (t, e) {
            t.doc.modeOption = e, Ni(t);
          }, !0), n("indentUnit", 2, Ni, !0), n("indentWithTabs", !1), n("smartIndent", !0), n("tabSize", 4, function (t) {
            Ii(t), Wn(t), vr(t);
          }, !0), n("lineSeparator", null, function (t, e) {
            if (t.doc.lineSep = e, e) {
              var n = [],
                r = t.doc.first;
              t.doc.iter(function (t) {
                for (var i = 0;;) {
                  var o = t.text.indexOf(e, i);
                  if (-1 == o) break;
                  i = o + e.length, n.push(oe(r, o));
                }
                r++;
              });
              for (var i = n.length - 1; i >= 0; i--) yo(t.doc, e, n[i], oe(n[i].line, n[i].ch + e.length));
            }
          }), n("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function (t, e, n) {
            t.state.specialChars = new RegExp(e.source + (e.test("\t") ? "" : "|\t"), "g"), n != ka && t.refresh();
          }), n("specialCharPlaceholder", rn, function (t) {
            return t.refresh();
          }, !0), n("electricChars", !0), n("inputStyle", b ? "contenteditable" : "textarea", function () {
            throw new Error("inputStyle can not (yet) be changed in a running editor");
          }, !0), n("spellcheck", !1, function (t, e) {
            return t.getInputField().spellcheck = e;
          }, !0), n("autocorrect", !1, function (t, e) {
            return t.getInputField().autocorrect = e;
          }, !0), n("autocapitalize", !1, function (t, e) {
            return t.getInputField().autocapitalize = e;
          }, !0), n("rtlMoveVisually", !x), n("wholeLineUpdateBefore", !0), n("theme", "default", function (t) {
            Sa(t), wi(t);
          }, !0), n("keyMap", "default", function (t, e, n) {
            var r = Qo(e),
              i = n != ka && Qo(n);
            i && i.detach && i.detach(t, r), r.attach && r.attach(t, i || null);
          }), n("extraKeys", null), n("configureMouse", null), n("lineWrapping", !1, Pa, !0), n("gutters", [], function (t, e) {
            t.display.gutterSpecs = bi(e, t.options.lineNumbers), wi(t);
          }, !0), n("fixedGutter", !0, function (t, e) {
            t.display.gutters.style.left = e ? dr(t.display) + "px" : "0", t.refresh();
          }, !0), n("coverGutterNextToScrollbar", !1, function (t) {
            return qr(t);
          }, !0), n("scrollbarStyle", "native", function (t) {
            Kr(t), qr(t), t.display.scrollbars.setScrollTop(t.doc.scrollTop), t.display.scrollbars.setScrollLeft(t.doc.scrollLeft);
          }, !0), n("lineNumbers", !1, function (t, e) {
            t.display.gutterSpecs = bi(t.options.gutters, e), wi(t);
          }, !0), n("firstLineNumber", 1, wi, !0), n("lineNumberFormatter", function (t) {
            return t;
          }, wi, !0), n("showCursorWhenSelecting", !1, xr, !0), n("resetSelectionOnContextMenu", !0), n("lineWiseCopyCut", !0), n("pasteLinesPerSelection", !0), n("selectionsMayTouch", !1), n("readOnly", !1, function (t, e) {
            "nocursor" == e && (Ar(t), t.display.input.blur()), t.display.input.readOnlyChanged(e);
          }), n("screenReaderLabel", null, function (t, e) {
            e = "" === e ? null : e, t.display.input.screenReaderLabelChanged(e);
          }), n("disableInput", !1, function (t, e) {
            e || t.display.input.reset();
          }, !0), n("dragDrop", !0, Ea), n("allowDropFileTypes", null), n("cursorBlinkRate", 530), n("cursorScrollMargin", 0), n("cursorHeight", 1, xr, !0), n("singleCursorHeightPerLine", !0, xr, !0), n("workTime", 100), n("workDelay", 100), n("flattenSpans", !0, Ii, !0), n("addModeClass", !1, Ii, !0), n("pollInterval", 100), n("undoDepth", 200, function (t, e) {
            return t.doc.history.undoDepth = e;
          }), n("historyEventDelay", 1250), n("viewportMargin", 10, function (t) {
            return t.refresh();
          }, !0), n("maxHighlightLength", 1e4, Ii, !0), n("moveInputWithCursor", !0, function (t, e) {
            e || t.display.input.resetPosition();
          }), n("tabindex", null, function (t, e) {
            return t.display.input.getField().tabIndex = e || "";
          }), n("autofocus", null), n("direction", "ltr", function (t, e) {
            return t.doc.setDirection(e);
          }, !0), n("phrases", null);
        }(Aa), function (t) {
          var e = t.optionHandlers,
            n = t.helpers = {};
          t.prototype = {
            constructor: t,
            focus: function focus() {
              z(this).focus(), this.display.input.focus();
            },
            setOption: function setOption(t, n) {
              var r = this.options,
                i = r[t];
              r[t] == n && "mode" != t || (r[t] = n, e.hasOwnProperty(t) && oi(this, e[t])(this, n, i), yt(this, "optionChange", this, t));
            },
            getOption: function getOption(t) {
              return this.options[t];
            },
            getDoc: function getDoc() {
              return this.doc;
            },
            addKeyMap: function addKeyMap(t, e) {
              this.state.keyMaps[e ? "push" : "unshift"](Qo(t));
            },
            removeKeyMap: function removeKeyMap(t) {
              for (var e = this.state.keyMaps, n = 0; n < e.length; ++n) if (e[n] == t || e[n].name == t) return e.splice(n, 1), !0;
            },
            addOverlay: ai(function (e, n) {
              var r = e.token ? e : t.getMode(this.options, e);
              if (r.startState) throw new Error("Overlays may not be stateful.");
              !function (t, e, n) {
                for (var r = 0, i = n(e); r < t.length && n(t[r]) <= i;) r++;
                t.splice(r, 0, e);
              }(this.state.overlays, {
                mode: r,
                modeSpec: e,
                opaque: n && n.opaque,
                priority: n && n.priority || 0
              }, function (t) {
                return t.priority;
              }), this.state.modeGen++, vr(this);
            }),
            removeOverlay: ai(function (t) {
              for (var e = this.state.overlays, n = 0; n < e.length; ++n) {
                var r = e[n].modeSpec;
                if (r == t || "string" == typeof t && r.name == t) return e.splice(n, 1), this.state.modeGen++, void vr(this);
              }
            }),
            indentLine: ai(function (t, e, n) {
              "string" != typeof e && "number" != typeof e && (e = null == e ? this.options.smartIndent ? "smart" : "prev" : e ? "add" : "subtract"), re(this.doc, t) && Da(this, t, e, n);
            }),
            indentSelection: ai(function (t) {
              for (var e = this.doc.sel.ranges, n = -1, r = 0; r < e.length; r++) {
                var i = e[r];
                if (i.empty()) i.head.line > n && (Da(this, i.head.line, t, !0), n = i.head.line, r == this.doc.sel.primIndex && Ir(this));else {
                  var o = i.from(),
                    a = i.to(),
                    s = Math.max(n, o.line);
                  n = Math.min(this.lastLine(), a.line - (a.ch ? 0 : 1)) + 1;
                  for (var c = s; c < n; ++c) Da(this, c, t);
                  var l = this.doc.sel.ranges;
                  0 == o.ch && e.length == l.length && l[r].from().ch > 0 && to(this.doc, r, new Ei(o, l[r].to()), G);
                }
              }
            }),
            getTokenAt: function getTokenAt(t, e) {
              return Ce(this, t, e);
            },
            getLineTokens: function getLineTokens(t, e) {
              return Ce(this, oe(t), e, !0);
            },
            getTokenTypeAt: function getTokenTypeAt(t) {
              t = he(this.doc, t);
              var e,
                n = me(this, Jt(this.doc, t.line)),
                r = 0,
                i = (n.length - 1) / 2,
                o = t.ch;
              if (0 == o) e = n[2];else for (;;) {
                var a = r + i >> 1;
                if ((a ? n[2 * a - 1] : 0) >= o) i = a;else {
                  if (!(n[2 * a + 1] < o)) {
                    e = n[2 * a + 2];
                    break;
                  }
                  r = a + 1;
                }
              }
              var s = e ? e.indexOf("overlay ") : -1;
              return s < 0 ? e : 0 == s ? null : e.slice(0, s - 1);
            },
            getModeAt: function getModeAt(e) {
              var n = this.doc.mode;
              return n.innerMode ? t.innerMode(n, this.getTokenAt(e).state).mode : n;
            },
            getHelper: function getHelper(t, e) {
              return this.getHelpers(t, e)[0];
            },
            getHelpers: function getHelpers(t, e) {
              var r = [];
              if (!n.hasOwnProperty(e)) return r;
              var i = n[e],
                o = this.getModeAt(t);
              if ("string" == typeof o[e]) i[o[e]] && r.push(i[o[e]]);else if (o[e]) for (var a = 0; a < o[e].length; a++) {
                var s = i[o[e][a]];
                s && r.push(s);
              } else o.helperType && i[o.helperType] ? r.push(i[o.helperType]) : i[o.name] && r.push(i[o.name]);
              for (var c = 0; c < i._global.length; c++) {
                var l = i._global[c];
                l.pred(o, this) && -1 == W(r, l.val) && r.push(l.val);
              }
              return r;
            },
            getStateAfter: function getStateAfter(t, e) {
              var n = this.doc;
              return be(this, (t = de(n, null == t ? n.first + n.size - 1 : t)) + 1, e).state;
            },
            cursorCoords: function cursorCoords(t, e) {
              var n = this.doc.sel.primary();
              return Zn(this, null == t ? n.head : "object" == typeof t ? he(this.doc, t) : t ? n.from() : n.to(), e || "page");
            },
            charCoords: function charCoords(t, e) {
              return Jn(this, he(this.doc, t), e || "page");
            },
            coordsChar: function coordsChar(t, e) {
              return er(this, (t = Xn(this, t, e || "page")).left, t.top);
            },
            lineAtHeight: function lineAtHeight(t, e) {
              return t = Xn(this, {
                top: t,
                left: 0
              }, e || "page").top, ne(this.doc, t + this.display.viewOffset);
            },
            heightAtLine: function heightAtLine(t, e, n) {
              var r,
                i = !1;
              if ("number" == typeof t) {
                var o = this.doc.first + this.doc.size - 1;
                t < this.doc.first ? t = this.doc.first : t > o && (t = o, i = !0), r = Jt(this.doc, t);
              } else r = t;
              return Kn(this, r, {
                top: 0,
                left: 0
              }, e || "page", n || i).top + (i ? this.doc.height - Ye(r) : 0);
            },
            defaultTextHeight: function defaultTextHeight() {
              return cr(this.display);
            },
            defaultCharWidth: function defaultCharWidth() {
              return lr(this.display);
            },
            getViewport: function getViewport() {
              return {
                from: this.display.viewFrom,
                to: this.display.viewTo
              };
            },
            addWidget: function addWidget(t, e, n, r, i) {
              var o,
                a,
                s = this.display,
                c = (t = Zn(this, he(this.doc, t))).bottom,
                l = t.left;
              if (e.style.position = "absolute", e.setAttribute("cm-ignore-events", "true"), this.display.input.setUneditable(e), s.sizer.appendChild(e), "over" == r) c = t.top;else if ("above" == r || "near" == r) {
                var u = Math.max(s.wrapper.clientHeight, this.doc.height),
                  d = Math.max(s.sizer.clientWidth, s.lineSpace.clientWidth);
                ("above" == r || t.bottom + e.offsetHeight > u) && t.top > e.offsetHeight ? c = t.top - e.offsetHeight : t.bottom + e.offsetHeight <= u && (c = t.bottom), l + e.offsetWidth > d && (l = d - e.offsetWidth);
              }
              e.style.top = c + "px", e.style.left = e.style.right = "", "right" == i ? (l = s.sizer.clientWidth - e.offsetWidth, e.style.right = "0px") : ("left" == i ? l = 0 : "middle" == i && (l = (s.sizer.clientWidth - e.offsetWidth) / 2), e.style.left = l + "px"), n && (null != (a = _r(o = this, {
                left: l,
                top: c,
                right: l + e.offsetWidth,
                bottom: c + e.offsetHeight
              })).scrollTop && zr(o, a.scrollTop), null != a.scrollLeft && Br(o, a.scrollLeft));
            },
            triggerOnKeyDown: ai(fa),
            triggerOnKeyPress: ai(ga),
            triggerOnKeyUp: pa,
            triggerOnMouseDown: ai(ya),
            execCommand: function execCommand(t) {
              if (ia.hasOwnProperty(t)) return ia[t].call(null, this);
            },
            triggerElectric: ai(function (t) {
              Ra(this, t);
            }),
            findPosH: function findPosH(t, e, n, r) {
              var i = 1;
              e < 0 && (i = -1, e = -e);
              for (var o = he(this.doc, t), a = 0; a < e && !(o = Ha(this.doc, o, i, n, r)).hitSide; ++a);
              return o;
            },
            moveH: ai(function (t, e) {
              var n = this;
              this.extendSelectionsBy(function (r) {
                return n.display.shift || n.doc.extend || r.empty() ? Ha(n.doc, r.head, t, e, n.options.rtlMoveVisually) : t < 0 ? r.from() : r.to();
              }, K);
            }),
            deleteH: ai(function (t, e) {
              var n = this.doc.sel,
                r = this.doc;
              n.somethingSelected() ? r.replaceSelection("", null, "+delete") : ta(this, function (n) {
                var i = Ha(r, n.head, t, e, !1);
                return t < 0 ? {
                  from: i,
                  to: n.head
                } : {
                  from: n.head,
                  to: i
                };
              });
            }),
            findPosV: function findPosV(t, e, n, r) {
              var i = 1,
                o = r;
              e < 0 && (i = -1, e = -e);
              for (var a = he(this.doc, t), s = 0; s < e; ++s) {
                var c = Zn(this, a, "div");
                if (null == o ? o = c.left : c.left = o, (a = Ba(this, c, i, n)).hitSide) break;
              }
              return a;
            },
            moveV: ai(function (t, e) {
              var n = this,
                r = this.doc,
                i = [],
                o = !this.display.shift && !r.extend && r.sel.somethingSelected();
              if (r.extendSelectionsBy(function (a) {
                if (o) return t < 0 ? a.from() : a.to();
                var s = Zn(n, a.head, "div");
                null != a.goalColumn && (s.left = a.goalColumn), i.push(s.left);
                var c = Ba(n, s, t, e);
                return "page" == e && a == r.sel.primary() && Nr(n, Jn(n, c, "div").top - s.top), c;
              }, K), i.length) for (var a = 0; a < r.sel.ranges.length; a++) r.sel.ranges[a].goalColumn = i[a];
            }),
            findWordAt: function findWordAt(t) {
              var e = Jt(this.doc, t.line).text,
                n = t.ch,
                r = t.ch;
              if (e) {
                var i = this.getHelper(t, "wordChars");
                "before" != t.sticky && r != e.length || !n ? ++r : --n;
                for (var o = e.charAt(n), a = ot(o, i) ? function (t) {
                    return ot(t, i);
                  } : /\s/.test(o) ? function (t) {
                    return /\s/.test(t);
                  } : function (t) {
                    return !/\s/.test(t) && !ot(t);
                  }; n > 0 && a(e.charAt(n - 1));) --n;
                for (; r < e.length && a(e.charAt(r));) ++r;
              }
              return new Ei(oe(t.line, n), oe(t.line, r));
            },
            toggleOverwrite: function toggleOverwrite(t) {
              null != t && t == this.state.overwrite || ((this.state.overwrite = !this.state.overwrite) ? _(this.display.cursorDiv, "CodeMirror-overwrite") : j(this.display.cursorDiv, "CodeMirror-overwrite"), yt(this, "overwriteToggle", this, this.state.overwrite));
            },
            hasFocus: function hasFocus() {
              return this.display.input.getField() == L(F(this));
            },
            isReadOnly: function isReadOnly() {
              return !(!this.options.readOnly && !this.doc.cantEdit);
            },
            scrollTo: ai(function (t, e) {
              Rr(this, t, e);
            }),
            getScrollInfo: function getScrollInfo() {
              var t = this.display.scroller;
              return {
                left: t.scrollLeft,
                top: t.scrollTop,
                height: t.scrollHeight - Mn(this) - this.display.barHeight,
                width: t.scrollWidth - Mn(this) - this.display.barWidth,
                clientHeight: Ln(this),
                clientWidth: Dn(this)
              };
            },
            scrollIntoView: ai(function (t, e) {
              null == t ? (t = {
                from: this.doc.sel.primary().head,
                to: null
              }, null == e && (e = this.options.cursorScrollMargin)) : "number" == typeof t ? t = {
                from: oe(t, 0),
                to: null
              } : null == t.from && (t = {
                from: t,
                to: null
              }), t.to || (t.to = t.from), t.margin = e || 0, null != t.from.line ? function (t, e) {
                Fr(t), t.curOp.scrollToPos = e;
              }(this, t) : Vr(this, t.from, t.to, t.margin);
            }),
            setSize: ai(function (t, e) {
              var n = this,
                r = function r(t) {
                  return "number" == typeof t || /^\d+$/.test(String(t)) ? t + "px" : t;
                };
              null != t && (this.display.wrapper.style.width = r(t)), null != e && (this.display.wrapper.style.height = r(e)), this.options.lineWrapping && $n(this);
              var i = this.display.viewFrom;
              this.doc.iter(i, this.display.viewTo, function (t) {
                if (t.widgets) for (var e = 0; e < t.widgets.length; e++) if (t.widgets[e].noHScroll) {
                  mr(n, i, "widget");
                  break;
                }
                ++i;
              }), this.curOp.forceUpdate = !0, yt(this, "refresh", this);
            }),
            operation: function operation(t) {
              return ii(this, t);
            },
            startOperation: function startOperation() {
              return Jr(this);
            },
            endOperation: function endOperation() {
              return Zr(this);
            },
            refresh: ai(function () {
              var t = this.display.cachedTextHeight;
              vr(this), this.curOp.forceUpdate = !0, Wn(this), Rr(this, this.doc.scrollLeft, this.doc.scrollTop), pi(this.display), (null == t || Math.abs(t - cr(this.display)) > .5 || this.options.lineWrapping) && fr(this), yt(this, "refresh", this);
            }),
            swapDoc: ai(function (t) {
              var e = this.doc;
              return e.cm = null, this.state.selectingText && this.state.selectingText(), zi(this, t), Wn(this), this.display.input.reset(), Rr(this, t.scrollLeft, t.scrollTop), this.curOp.forceScroll = !0, fn(this, "swapDoc", this, e), e;
            }),
            phrase: function phrase(t) {
              var e = this.options.phrases;
              return e && Object.prototype.hasOwnProperty.call(e, t) ? e[t] : t;
            },
            getInputField: function getInputField() {
              return this.display.input.getField();
            },
            getWrapperElement: function getWrapperElement() {
              return this.display.wrapper;
            },
            getScrollerElement: function getScrollerElement() {
              return this.display.scroller;
            },
            getGutterElement: function getGutterElement() {
              return this.display.gutters;
            }
          }, Ct(t), t.registerHelper = function (e, r, i) {
            n.hasOwnProperty(e) || (n[e] = t[e] = {
              _global: []
            }), n[e][r] = i;
          }, t.registerGlobalHelper = function (e, r, i, o) {
            t.registerHelper(e, r, o), n[e]._global.push({
              pred: i,
              val: o
            });
          };
        }(Aa);
        var Ka = "iter insert remove copy getEditor constructor".split(" ");
        for (var Xa in _No.prototype) _No.prototype.hasOwnProperty(Xa) && W(Ka, Xa) < 0 && (Aa.prototype[Xa] = function (t) {
          return function () {
            return t.apply(this.doc, arguments);
          };
        }(_No.prototype[Xa]));
        return Ct(_No), Aa.inputStyles = {
          textarea: Ya,
          contenteditable: Ua
        }, Aa.defineMode = function (t) {
          Aa.defaults.mode || "null" == t || (Aa.defaults.mode = t), Bt.apply(this, arguments);
        }, Aa.defineMIME = function (t, e) {
          Ht[t] = e;
        }, Aa.defineMode("null", function () {
          return {
            token: function token(t) {
              return t.skipToEnd();
            }
          };
        }), Aa.defineMIME("text/plain", "null"), Aa.defineExtension = function (t, e) {
          Aa.prototype[t] = e;
        }, Aa.defineDocExtension = function (t, e) {
          _No.prototype[t] = e;
        }, Aa.fromTextArea = function (t, e) {
          if ((e = e ? B(e) : {}).value = t.value, !e.tabindex && t.tabIndex && (e.tabindex = t.tabIndex), !e.placeholder && t.placeholder && (e.placeholder = t.placeholder), null == e.autofocus) {
            var n = L(V(t));
            e.autofocus = n == t || null != t.getAttribute("autofocus") && n == document.body;
          }
          function r() {
            t.value = s.getValue();
          }
          var i;
          if (t.form && (vt(t.form, "submit", r), !e.leaveSubmitMethodAlone)) {
            var o = t.form;
            i = o.submit;
            try {
              var a = o.submit = function () {
                r(), o.submit = i, o.submit(), o.submit = a;
              };
            } catch (t) {}
          }
          e.finishInit = function (n) {
            n.save = r, n.getTextArea = function () {
              return t;
            }, n.toTextArea = function () {
              n.toTextArea = isNaN, r(), t.parentNode.removeChild(n.getWrapperElement()), t.style.display = "", t.form && (bt(t.form, "submit", r), e.leaveSubmitMethodAlone || "function" != typeof t.form.submit || (t.form.submit = i));
            };
          }, t.style.display = "none";
          var s = Aa(function (e) {
            return t.parentNode.insertBefore(e, t.nextSibling);
          }, e);
          return s;
        }, function (t) {
          t.off = bt, t.on = vt, t.wheelEventPixels = ki, t.Doc = _No, t.splitLines = It, t.countColumn = U, t.findColumn = X, t.isWordChar = it, t.Pass = q, t.signal = yt, t.Line = Je, t.changeEnd = Mi, t.scrollbarModel = Yr, t.Pos = oe, t.cmpPos = ae, t.modes = zt, t.mimeModes = Ht, t.resolveMode = Ut, t.getMode = $t, t.modeExtensions = Wt, t.extendMode = qt, t.copyState = Gt, t.startState = Kt, t.innerMode = Yt, t.commands = ia, t.keyMap = qo, t.keyName = Zo, t.isModifierKey = Xo, t.lookupKey = Ko, t.normalizeKeyMap = Yo, t.StringStream = Xt, t.SharedTextMarker = Mo, t.TextMarker = Po, t.LineWidget = To, t.e_preventDefault = St, t.e_stopPropagation = kt, t.e_stop = jt, t.addClass = _, t.contains = D, t.rmClass = j, t.keyNames = Bo;
        }(Aa), Aa.version = "5.65.16", Aa;
      }();
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(8),
        i = n.n(r),
        o = n(2),
        a = n.n(o),
        s = n(1),
        c = n.n(s),
        l = n(0),
        u = n(3),
        d = n(7),
        h = n(20);
      function f(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function p(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? f(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var g = c.a.View.extend({
          events: function events() {
            return this.model.get("events") || {
              mousedown: "handleClick"
            };
          },
          attributes: function attributes() {
            return this.model.get("attributes");
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.config,
              n = void 0 === e ? {} : e;
            this.em = n.em, this.editor = n.editor;
          },
          handleClick: function handleClick(t) {
            t.preventDefault(), t.stopPropagation();
            var e = this.editor,
              n = this.em,
              r = e.Canvas.getFrameEl().getBoundingClientRect(),
              i = r.left,
              o = r.top,
              a = p(p({}, t), {}, {
                clientX: t.clientX - i,
                clientY: t.clientY - o
              });
            n.trigger("toolbar:run:before"), this.execCommand(a);
          },
          execCommand: function execCommand(t) {
            var e = {
                event: t
              },
              n = this.model.get("command"),
              r = this.editor;
            "function" == typeof n && n(r, null, e), "string" == typeof n && r.runCommand(n, e);
          },
          render: function render() {
            var t = this.editor,
              e = this.$el,
              n = this.model,
              r = n.get("id"),
              i = n.get("label"),
              o = t.getConfig("stylePrefix");
            return e.addClass("".concat(o, "toolbar-item")), r && e.addClass("".concat(o, "toolbar-item__").concat(r)), i && e.append(i), this;
          }
        }),
        v = h.a.extend({
          itemView: g,
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = {
              editor: t.editor || "",
              em: t.em
            }, this.listenTo(this.collection, "reset", this.render);
          }
        }),
        m = c.a.Model.extend({
          defaults: {
            command: "",
            attributes: {}
          }
        }),
        b = c.a.Collection.extend({
          model: m
        });
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x,
        O = c.a.$;
      e.default = {
        init: function init(t) {
          Object(l.bindAll)(this, "onHover", "onOut", "onClick", "onFrameScroll", "onFrameUpdated", "onContainerChange");
        },
        enable: function enable() {
          this.frameOff = this.canvasOff = this.adjScroll = null, this.startSelectComponent(), x = 1;
        },
        startSelectComponent: function startSelectComponent() {
          this.toggleSelectComponent(1), this.em.getSelected() && this.onSelect();
        },
        stopSelectComponent: function stopSelectComponent() {
          this.toggleSelectComponent();
        },
        toggleSelectComponent: function toggleSelectComponent(t) {
          var e = this,
            n = this.em,
            r = n.getConfig("listenToEl"),
            i = n.getContainer().parentNode,
            o = t ? "on" : "off",
            a = {
              on: u.u,
              off: u.t
            };
          !r.length && i && r.push(i), a[o](window, "resize", this.onFrameUpdated), a[o](r, "scroll", this.onContainerChange), n[o]("component:toggled", this.onSelect, this), n[o]("change:componentHovered", this.onHovered, this), n[o]("component:resize component:styleUpdate component:input", this.updateGlobalPos, this), n[o]("change:canvasOffset", this.updateAttached, this), n[o]("frame:updated", this.onFrameUpdated, this), n.get("Canvas").getFrames().forEach(function (t) {
            var n,
              r,
              i = t.view;
            i && (n = i.getWindow(), r = i.getBody(), a[o](r, "mouseover", e.onHover), a[o](r, "mouseleave", e.onOut), a[o](r, "click touchend", e.onClick), a[o](n, "scroll", e.onFrameScroll));
          });
        },
        onHover: function onHover(t) {
          t.stopPropagation();
          var e = t.target,
            n = Object(u.j)(e),
            r = n && n._getFrame(),
            i = O(e),
            o = i.data("model");
          if (!o) for (var a = i.parent(); !o && a.length && !Object(d.g)(a[0]);) o = a.data("model"), a = a.parent();
          if (o && !o.get("hoverable")) {
            for (var s = o && o.parent(); s && !s.get("hoverable");) s = s.parent();
            o = s;
          }
          this.currentDoc = e.ownerDocument, this.em.setHovered(o), r && this.em.set("currentFrame", r);
        },
        onFrameUpdated: function onFrameUpdated() {
          this.updateLocalPos(), this.updateGlobalPos();
        },
        onHovered: function onHovered(t, e) {
          var n = this,
            r = {};
          e && e.views.forEach(function (t) {
            var i = t.el,
              o = n.getElementPos(i);
            r = {
              el: i,
              pos: o,
              component: e,
              view: Object(u.j)(i)
            }, n.updateToolsLocal(r), i.ownerDocument === n.currentDoc && (n.elHovered = r);
          });
        },
        onSelect: Object(l.debounce)(function () {
          var t = this.em,
            e = t.getSelected(),
            n = t.get("currentFrame") || {},
            r = e && e.getView(n.model),
            i = r && r.el,
            o = {};
          i && Object(d.h)(i) && (o = {
            el: i,
            pos: this.getElementPos(i),
            component: e,
            view: Object(u.j)(i)
          }), this.elSelected = o, this.updateToolsGlobal(), this.updateToolsLocal(o), this.initResize(e);
        }),
        updateGlobalPos: function updateGlobalPos() {
          var t = this.getElSelected();
          t.el && (t.pos = this.getElementPos(t.el), this.updateToolsGlobal());
        },
        updateLocalPos: function updateLocalPos() {
          var t = this.getElHovered();
          t.el && (t.pos = this.getElementPos(t.el), this.updateToolsLocal());
        },
        getElHovered: function getElHovered() {
          return this.elHovered || {};
        },
        getElSelected: function getElSelected() {
          return this.elSelected || {};
        },
        onOut: function onOut() {
          var t = this;
          this.currentDoc = null, this.em.setHovered(0), this.elHovered = 0, this.updateToolsLocal(), this.canvas.getFrames().forEach(function (e) {
            var n = e.view,
              r = n && n.getToolsEl();
            r && t.toggleToolsEl(0, 0, {
              el: r
            });
          });
        },
        toggleToolsEl: function toggleToolsEl(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = n.el || this.canvas.getToolsEl(e);
          return r && (r.style.opacity = t ? 1 : 0), r || {};
        },
        showElementOffset: function showElementOffset(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          x && this.editor.runCommand("show-offset", {
            el: t,
            elPos: e,
            view: n.view,
            force: 1,
            top: 0,
            left: 0
          });
        },
        hideElementOffset: function hideElementOffset(t) {
          this.editor.stopCommand("show-offset", {
            view: t
          });
        },
        showFixedElementOffset: function showFixedElementOffset(t, e) {
          this.editor.runCommand("show-offset", {
            el: t,
            elPos: e,
            state: "Fixed"
          });
        },
        hideFixedElementOffset: function hideFixedElementOffset(t, e) {
          this.editor && this.editor.stopCommand("show-offset", {
            state: "Fixed"
          });
        },
        hideHighlighter: function hideHighlighter(t) {
          this.canvas.getHighlighter(t).style.opacity = 0;
        },
        onClick: function onClick(t) {
          t.stopPropagation(), t.preventDefault();
          var e = this.em;
          if (e.get("_cmpDrag")) return e.set("_cmpDrag");
          var n = O(t.target),
            r = n.data("model");
          if (!r) for (var i = n.parent(); !r && i.length && !Object(d.g)(i[0]);) r = i.data("model"), i = i.parent();
          if (r) if (r.get("selectable")) this.select(r, t);else {
            for (var o = r.parent(); o && !o.get("selectable");) o = o.parent();
            this.select(o, t);
          }
        },
        select: function select(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (t) {
            var n = e.ctrlKey || e.metaKey,
              r = e.shiftKey,
              i = this.editor,
              o = this.em,
              a = i.getConfig("multipleSelection");
            if (n && a) i.selectToggle(t);else if (r && a) {
              o.clearSelection(i.Canvas.getWindow());
              var s,
                c,
                u = t.collection,
                d = u.indexOf(t);
              if (i.getSelectedAll(), i.getSelectedAll().forEach(function (t) {
                var e = t.collection,
                  n = e.indexOf(t);
                e === u && (n < d ? s = Object(l.isUndefined)(s) ? n : Math.max(s, n) : n > d && (c = Object(l.isUndefined)(c) ? n : Math.min(c, n)));
              }), !Object(l.isUndefined)(s)) for (; s !== d;) i.selectAdd(u.at(s)), s++;
              if (!Object(l.isUndefined)(c)) for (; c !== d;) i.selectAdd(u.at(c)), c--;
              i.selectAdd(t);
            } else i.select(t, {
              scroll: {}
            });
            this.initResize(t);
          }
        },
        updateBadge: function updateBadge(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = O(t).data("model");
          if (r && r.get("badgable")) {
            var i = this.getBadge(n);
            if (!n.posOnly) {
              var o = this.canvas.getConfig(),
                a = r.getIcon(),
                s = o.pStylePrefix || "",
                c = "".concat(s, "badge"),
                l = o.customBadgeLabel,
                u = "".concat(a ? '<div class="'.concat(c, '__icon">').concat(a, "</div>") : "", '\n        <div class="').concat(c, '__name">').concat(r.getName(), "</div>");
              i.innerHTML = l ? l(r) : u;
            }
            var d = "px",
              h = i.style;
            h.display = "block";
            var f = i ? i.offsetHeight : 0,
              p = 0 - f,
              g = n.topOff - f < 0 ? -n.topOff : p,
              v = n.leftOff < 0 ? -n.leftOff : 0;
            h.top = g + d, h.left = v + d;
          }
        },
        showHighlighter: function showHighlighter(t) {
          this.canvas.getHighlighter(t).style.opacity = "";
        },
        initResize: function initResize(t) {
          var e,
            n = this.em,
            r = this.canvas,
            o = n ? n.get("Editor") : "",
            a = (n ? n.get("Config") : "").stylePrefix || "",
            s = "".concat(a, "resizing"),
            c = !Object(l.isElement)(t) && Object(u.p)(t) ? t : n.getSelected(),
            d = c && c.get("resizable"),
            h = {},
            f = function f(t, e, n) {
              var r = n.docs;
              r && r.forEach(function (e) {
                var n = e.body,
                  r = n.className || "";
                n.className = ("add" == t ? "".concat(r, " ").concat(s) : r.replace(s, "")).trim();
              });
            };
          if (o && d) {
            var p = Object(l.isElement)(t) ? t : c.getEl();
            h = {
              onStart: function onStart(t) {
                var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  o = i.el,
                  a = i.config,
                  s = i.resizer,
                  l = a.keyHeight,
                  d = a.keyWidth,
                  h = a.currentUnit,
                  p = a.keepAutoHeight,
                  g = a.keepAutoWidth;
                f("add", 0, i), e = n.get("StyleManager").getModelToStyle(c), r.toggleFramesEvents();
                var v = getComputedStyle(o),
                  m = e.getStyle(),
                  b = m[d];
                a.autoWidth = g && "auto" === b, isNaN(parseFloat(b)) && (b = v[d]);
                var y = m[l];
                a.autoHeight = p && "auto" === y, isNaN(parseFloat(y)) && (y = v[l]), s.startDim.w = parseFloat(b), s.startDim.h = parseFloat(y), x = 0, h && (a.unitHeight = Object(u.i)(y), a.unitWidth = Object(u.i)(b));
              },
              onMove: function onMove() {
                o.trigger("component:resize");
              },
              onEnd: function onEnd(t, e) {
                f("remove", 0, e), o.trigger("component:resize"), r.toggleFramesEvents(1), x = 1;
              },
              updateTarget: function updateTarget(t, i) {
                var o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (e) {
                  var a = o.store,
                    s = o.selectedHandler,
                    c = o.config,
                    l = c.keyHeight,
                    u = c.keyWidth,
                    d = c.autoHeight,
                    h = c.autoWidth,
                    f = c.unitWidth,
                    p = c.unitHeight,
                    g = ["tc", "bc"].indexOf(s) >= 0,
                    v = ["cl", "cr"].indexOf(s) >= 0,
                    m = {},
                    b = a ? "" : 1;
                  if (!g) {
                    var y = r.getBody().offsetWidth,
                      x = i.w < y ? i.w : y;
                    m[u] = h ? "auto" : "".concat(x).concat(f);
                  }
                  v || (m[l] = d ? "auto" : "".concat(i.h).concat(p)), e.addStyle(w(w({}, m), {}, {
                    en: b
                  }), {
                    avoidStore: !a
                  });
                  var O = "update:component:style",
                    C = "".concat(O, ":").concat(l, " ").concat(O, ":").concat(u);
                  n && n.trigger(C, null, null, {
                    noEmit: 1
                  });
                }
              }
            }, "object" == i()(d) && (h = w(w({}, h), d)), this.resizer = o.runCommand("resize", {
              el: p,
              options: h,
              force: 1
            });
          } else o.stopCommand("resize"), this.resizer = null;
        },
        updateToolbar: function updateToolbar(t) {
          var e = this.config.em,
            n = t == e ? e.getSelected() : t,
            r = this.canvas.getToolbarEl(),
            i = r.style;
          if (n) {
            var o = n.get("toolbar");
            if (e.get("Config").showToolbar && o && o.length) {
              if (i.opacity = "", i.display = "", !this.toolbar) {
                r.innerHTML = "", this.toolbar = new b(o);
                var a = new v({
                  collection: this.toolbar,
                  editor: this.editor,
                  em: e
                });
                r.appendChild(a.render().el);
              }
              this.toolbar.reset(o), i.top = "-100px", i.left = 0;
            } else i.display = "none";
          } else i.opacity = 0;
        },
        updateToolbarPos: function updateToolbarPos(t) {
          var e = this.canvas.getToolbarEl().style;
          e.top = "".concat(t.top).concat("px"), e.left = "".concat(t.left).concat("px"), e.opacity = "";
        },
        getCanvasPosition: function getCanvasPosition() {
          return this.canvas.getCanvasView().getPosition();
        },
        getBadge: function getBadge() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.canvas.getBadgeEl(t.view);
        },
        onFrameScroll: function onFrameScroll() {
          this.updateTools();
        },
        updateTools: function updateTools() {
          this.updateToolsLocal(), this.updateGlobalPos();
        },
        isCompSelected: function isCompSelected(t) {
          return t && "selected" === t.get("status");
        },
        updateToolsLocal: function updateToolsLocal(t) {
          var e = t || this.getElHovered(),
            n = e.el,
            r = e.pos,
            i = e.view,
            o = e.component;
          if (n) {
            var a = o.get("hoverable"),
              s = this.lastHovered !== n,
              c = s ? {} : {
                posOnly: 1
              };
            s && a && (this.lastHovered = n, this.showHighlighter(i), this.showElementOffset(n, r, {
              view: i
            })), this.isCompSelected(o) && (this.hideHighlighter(i), this.hideElementOffset(i));
            var l = this.toggleToolsEl(1, i).style,
              u = this.canvas.canvasRectOffset(n, r),
              d = u.top,
              h = u.left;
            this.updateBadge(n, r, w(w({}, c), {}, {
              view: i,
              topOff: d,
              leftOff: h
            })), l.top = d + "px", l.left = h + "px", l.width = r.width + "px", l.height = r.height + "px";
          } else this.lastHovered = 0;
        },
        updateToolsGlobal: function updateToolsGlobal() {
          var t = this.getElSelected(),
            e = t.el,
            n = t.pos,
            r = t.component;
          if (!e) return this.toggleToolsEl(), void (this.lastSelected = 0);
          var i = this.canvas;
          this.lastSelected !== e && (this.lastSelected = e, this.updateToolbar(r));
          var o = this.toggleToolsEl(1).style,
            a = i.getTargetToElementFixed(e, i.getToolbarEl(), {
              pos: n
            }),
            s = a.canvasOffsetTop,
            c = a.canvasOffsetLeft;
          o.top = s + "px", o.left = c + "px", o.width = n.width + "px", o.height = n.height + "px", this.updateToolbarPos({
            top: a.top,
            left: a.left
          });
        },
        updateAttached: Object(l.debounce)(function () {
          this.updateGlobalPos();
        }),
        onContainerChange: Object(l.debounce)(function () {
          this.em.refreshCanvas();
        }, 150),
        getElementPos: function getElementPos(t) {
          return this.canvas.getCanvasView().getElementPos(t);
        },
        hideBadge: function hideBadge() {
          this.getBadge().style.display = "none";
        },
        cleanPrevious: function cleanPrevious(t) {
          t && t.set({
            status: "",
            state: ""
          });
        },
        getContentWindow: function getContentWindow() {
          return this.canvas.getWindow();
        },
        run: function run(t) {
          this.editor = t && t.get("Editor"), this.enable();
        },
        stop: function stop(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.em,
            i = this.editor;
          this.stopSelectComponent(), !n.preserveSelected && r.setSelected(null), this.onOut(), this.toggleToolsEl(), i && i.stopCommand("resize");
        }
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var r = n(42);
      function i(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, r(i.key), i);
        }
      }
      t.exports = function (t, e, n) {
        return e && i(t.prototype, e), n && i(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), t;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.d(e, "a", function () {
        return f;
      });
      var r = n(2),
        i = n.n(r),
        o = n(15),
        a = n.n(o),
        s = n(16),
        c = n.n(s),
        l = n(0),
        u = n(3);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var f = function () {
        function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return a()(this, t), this.opts = {
            container: null,
            onStart: null,
            onDrag: null,
            onEnd: null,
            setPosition: null,
            getPosition: null,
            guidesStatic: null,
            guidesTarget: null,
            snapOffset: 5,
            doc: 0,
            scale: 1
          }, Object(l.bindAll)(this, "drag", "stop", "keyHandle", "handleScroll"), this.setOptions(e), this.delta = {
            x: 0,
            y: 0
          }, this;
        }
        return c()(t, [{
          key: "setOptions",
          value: function value() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.opts = h(h({}, this.opts), t);
          }
        }, {
          key: "toggleDrag",
          value: function value(t) {
            var e = this.getDocumentEl(),
              n = this.getContainerEl(),
              r = this.getWindowEl(),
              i = t ? "on" : "off",
              o = {
                on: u.u,
                off: u.t
              };
            o[i](n, "mousemove dragover", this.drag), o[i](e, "mouseup dragend touchend", this.stop), o[i](e, "keydown", this.keyHandle), o[i](r, "scroll", this.handleScroll);
          }
        }, {
          key: "handleScroll",
          value: function value() {
            var t = this.lastScroll,
              e = this.delta,
              n = this.getScrollInfo(),
              r = {
                x: n.x - t.x,
                y: n.y - t.y
              };
            this.move(e.x + r.x, e.y + r.y), this.lastScrollDiff = r;
          }
        }, {
          key: "start",
          value: function value(t) {
            var e = this.opts,
              n = e.onStart;
            this.toggleDrag(1), this.startPointer = this.getPointerPos(t), this.guidesStatic = Object(l.result)(e, "guidesStatic") || [], this.guidesTarget = Object(l.result)(e, "guidesTarget") || [], Object(l.isFunction)(n) && n(t, this), this.startPosition = this.getStartPosition(), this.lastScrollDiff = {
              x: 0,
              y: 0
            }, this.globScrollDiff = {
              x: 0,
              y: 0
            }, this.drag(t);
          }
        }, {
          key: "drag",
          value: function value(t) {
            var e = this,
              n = this.opts,
              r = this.lastScrollDiff,
              i = this.globScrollDiff,
              o = n.onDrag,
              a = this.startPointer,
              s = this.getPointerPos(t),
              c = {
                x: i.x + r.x,
                y: i.y + r.y
              };
            this.globScrollDiff = c;
            var u = {
              x: s.x - a.x + c.x,
              y: s.y - a.y + c.y
            };
            this.lastScrollDiff = {
              x: 0,
              y: 0
            };
            var d = this.lockedAxis;
            "x" === (d = t.shiftKey ? !d && this.detectAxisLock(u.x, u.y) : null) ? u.x = a.x : "y" === d && (u.y = a.y);
            var f = function f(r) {
                ["x", "y"].forEach(function (t) {
                  return r[t] = r[t] * Object(l.result)(n, "scale");
                }), e.delta = r, e.move(r.x, r.y), Object(l.isFunction)(o) && o(t, e);
              },
              p = h({}, u);
            if (this.currentPointer = s, this.lockedAxis = d, this.lastScroll = this.getScrollInfo(), f(u), this.guidesTarget.length) {
              var g = this.snapGuides(p),
                v = g.newDelta,
                m = g.trgX,
                b = g.trgY;
              (m || b) && f(v);
            }
            0 === t.which && this.stop(t);
          }
        }, {
          key: "snapGuides",
          value: function value(t) {
            var e = this,
              n = t,
              r = this.trgX,
              i = this.trgY;
            return this.guidesTarget.forEach(function (n) {
              n.x && e.trgX || n.y && e.trgY || (n.active = 0, e.guidesStatic.forEach(function (o) {
                if (!(n.y && o.x || n.x && o.y)) {
                  var a = n.y && o.y,
                    s = a ? "y" : "x",
                    c = n[s],
                    u = o[s],
                    d = t[s],
                    h = a ? i : r;
                  if (e.isPointIn(c, u) && Object(l.isUndefined)(h)) {
                    var f = d - (c - u);
                    e.setGuideLock(n, f);
                  }
                }
              }));
            }), r = this.trgX, i = this.trgY, ["x", "y"].forEach(function (r) {
              var i = r.toUpperCase(),
                o = e["trg".concat(i)];
              o && !e.isPointIn(t[r], o.lock) && (e.setGuideLock(o, null), o = null), o && !Object(l.isUndefined)(o.lock) && (n[r] = o.lock);
            }), {
              newDelta: n,
              trgX: this.trgX,
              trgY: this.trgY
            };
          }
        }, {
          key: "isPointIn",
          value: function value(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = n.offset,
              i = r || this.opts.snapOffset;
            return t >= e && t <= e + i || t <= e && t >= e - i;
          }
        }, {
          key: "setGuideLock",
          value: function value(t, e) {
            var n = Object(l.isUndefined)(t.x) ? "Y" : "X",
              r = "trg".concat(n);
            return null !== e ? (t.active = 1, t.lock = e, this[r] = t) : (delete t.active, delete t.lock, delete this[r]), t;
          }
        }, {
          key: "stop",
          value: function value(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.delta,
              r = e.cancel,
              i = r ? 0 : n.x,
              o = r ? 0 : n.y;
            this.toggleDrag(), this.lockedAxis = null, this.move(i, o, 1);
            var a = this.opts.onEnd;
            Object(l.isFunction)(a) && a(t, this, {
              cancelled: r
            });
          }
        }, {
          key: "keyHandle",
          value: function value(t) {
            Object(u.m)(t) && this.stop(t, {
              cancel: 1
            });
          }
        }, {
          key: "move",
          value: function value(t, e, n) {
            var r = this.el,
              i = this.opts,
              o = this.startPosition;
            if (o) {
              var a = i.setPosition,
                s = o.x + t,
                c = o.y + e;
              this.position = {
                x: s,
                y: c,
                end: n
              }, Object(l.isFunction)(a) && a(this.position), r && (r.style.left = "".concat(s, "px"), r.style.top = "".concat(c, "px"));
            }
          }
        }, {
          key: "getContainerEl",
          value: function value() {
            var t = this.opts.container;
            return t ? [t] : this.getDocumentEl();
          }
        }, {
          key: "getWindowEl",
          value: function value() {
            return this.getContainerEl().map(function (t) {
              var e = t.ownerDocument || t;
              return e.defaultView || e.parentWindow;
            });
          }
        }, {
          key: "getDocumentEl",
          value: function value(t) {
            var e = this.opts.doc;
            if (t = t || this.el, !this.docs) {
              var n = [document];
              t && n.push(t.ownerDocument), e && n.push(e), this.docs = n;
            }
            return this.docs;
          }
        }, {
          key: "getPointerPos",
          value: function value(t) {
            var e = this.opts.getPointerPosition,
              n = Object(u.h)(t);
            return e ? e(t) : {
              x: n.clientX,
              y: n.clientY
            };
          }
        }, {
          key: "getStartPosition",
          value: function value() {
            var t = this.el,
              e = this.opts.getPosition,
              n = {
                x: 0,
                y: 0
              };
            return Object(l.isFunction)(e) ? n = e() : t && (n = {
              x: parseFloat(t.style.left),
              y: parseFloat(t.style.top)
            }), n;
          }
        }, {
          key: "getScrollInfo",
          value: function value() {
            var t = this.opts.doc,
              e = t && t.body;
            return {
              y: e ? e.scrollTop : 0,
              x: e ? e.scrollLeft : 0
            };
          }
        }, {
          key: "detectAxisLock",
          value: function value(t, e) {
            var n = t,
              r = e,
              i = Math.abs(n),
              o = Math.abs(r);
            return r >= i || r <= -i ? "x" : n > o || n < -o ? "y" : void 0;
          }
        }]), t;
      }();
    }, function (t, e, n) {
      "use strict";

      var r = n(1),
        i = n.n(r),
        o = i.a.$;
      e.a = i.a.View.extend({
        events: {
          change: "handleChange"
        },
        template: function template() {
          return '<span class="'.concat(this.holderClass(), '"></span>');
        },
        inputClass: function inputClass() {
          return "".concat(this.ppfx, "field");
        },
        holderClass: function holderClass() {
          return "".concat(this.ppfx, "input-holder");
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.ppfx || "";
          this.opts = t, this.ppfx = e, this.em = t.target || {}, this.listenTo(this.model, "change:value", this.handleModelChange);
        },
        elementUpdated: function elementUpdated() {
          this.model.trigger("el:change");
        },
        setValue: function setValue(t) {
          var e = this.model,
            n = t || e.get("defaults"),
            r = this.getInputEl();
          r && (r.value = n);
        },
        handleModelChange: function handleModelChange(t, e, n) {
          this.setValue(e, n);
        },
        handleChange: function handleChange(t) {
          t.stopPropagation();
          var e = this.getInputEl().value;
          this.model.set({
            value: e
          }, {
            fromInput: 1
          }), this.elementUpdated();
        },
        getInputEl: function getInputEl() {
          if (!this.inputEl) {
            var t = this.model,
              e = t.get("placeholder") || t.get("defaults") || "";
            this.inputEl = o('<input type="text" placeholder="'.concat(e, '">'));
          }
          return this.inputEl.get(0);
        },
        render: function render() {
          this.inputEl = null;
          var t = this.$el;
          return t.addClass(this.inputClass()), t.html(this.template()), t.find(".".concat(this.holderClass())).append(this.getInputEl()), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r),
        o = n(7);
      e.default = i.a.View.extend({
        initialize: function initialize(t) {
          this.config = t.config || {}, this.pfx = this.config.stylePrefix || "", this.target = t.target || {}, this.propTarget = t.propTarget || {}, this.onChange = t.onChange, this.onInputRender = t.onInputRender || {}, this.customValue = t.customValue || {}, this.properties = [];
          var e = this.collection;
          this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.render);
        },
        addTo: function addTo(t, e, n) {
          this.add(t, null, n);
        },
        add: function add(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = e || this.el,
            i = new t.typeView({
              model: t,
              name: t.get("name"),
              id: this.pfx + t.get("property"),
              target: this.target,
              propTarget: this.propTarget,
              onChange: this.onChange,
              onInputRender: this.onInputRender,
              config: this.config
            });
          "composite" != t.get("type") && (i.customValue = this.customValue), i.render();
          var a = i.el;
          this.properties.push(i), i.updateVisibility(), Object(o.b)(r, a, n.at);
        },
        render: function render() {
          var t = this,
            e = this.$el;
          this.clearItems();
          var n = document.createDocumentFragment();
          return this.collection.each(function (e) {
            return t.add(e, n);
          }), e.empty(), e.append(n), e.attr("class", "".concat(this.pfx, "properties")), this;
        },
        remove: function remove() {
          i.a.View.prototype.remove.apply(this, arguments), this.clearItems();
        },
        clearItems: function clearItems() {
          this.properties.forEach(function (t) {
            return t.remove();
          }), this.properties = [];
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(0),
        i = n(1),
        o = n.n(i);
      e.a = o.a.View.extend({
        itemView: "",
        itemsView: "",
        itemType: "type",
        autoAdd: 0,
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 ? arguments[1] : void 0;
          this.config = e || t.config || {}, this.autoAdd && this.listenTo(this.collection, "add", this.addTo), this.items = [], this.init();
        },
        init: function init() {},
        addTo: function addTo(t) {
          this.add(t);
        },
        itemViewNotFound: function itemViewNotFound(t) {
          var e = this.config,
            n = this.ns,
            r = e.em,
            i = "".concat(n ? "[".concat(n, "]: ") : "", "'").concat(t, "' type not found");
          r && r.logWarning(i);
        },
        add: function add(t, e) {
          var n,
            i = this.config,
            o = this.reuseView,
            a = this.items,
            s = this.itemsView,
            c = void 0 === s ? {} : s,
            l = e || null,
            u = this.itemView,
            d = t.get(this.itemType);
          c[d] ? u = c[d] : !d || c[d] || Object(r.includes)(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"], d) || this.itemViewNotFound(d), n = t.view && o ? t.view : new u({
            model: t,
            config: i
          }, i), a && a.push(n);
          var h = n.render().el;
          l ? l.appendChild(h) : this.$el.append(h);
        },
        render: function render() {
          var t = document.createDocumentFragment();
          return this.clearItems(), this.$el.empty(), this.collection.length && this.collection.each(function (e) {
            this.add(e, t);
          }, this), this.$el.append(t), this.onRender(), this;
        },
        onRender: function onRender() {},
        remove: function remove() {
          this.clearItems(), o.a.View.prototype.remove.apply(this, arguments);
        },
        clearItems: function clearItems() {
          this.items;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r,
        i = n(8),
        o = n.n(i),
        a = n(2),
        s = n.n(a),
        c = n(1),
        l = n.n(c),
        u = n(0);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            s()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.a = l.a.Collection.extend({
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.opt = e, this.listenTo(this, "add", this.onAdd), this.listenTo(this, "remove", this.removeChildren), this.listenTo(this, "reset", this.resetChildren), this.config = e.config, this.em = e.em, this.domc = e.domc;
        },
        resetChildren: function resetChildren(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = this,
            i = n.previousModels,
            o = void 0 === i ? [] : i;
          o.forEach(function (t) {
            return e.removeChildren(t, r, n);
          }), t.each(function (t) {
            return e.onAdd(t);
          });
        },
        removeChildren: function removeChildren(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.domc,
            o = this.em,
            a = i ? i.allById() : {};
          if (!r.temporary) {
            var s = t.getId(),
              c = o.get("SelectorManager").getAll(),
              l = o.get("CssComposer").getAll();
            delete a[s];
            var u = l.remove(l.filter(function (t) {
              return t.getSelectors().getFullString() === "#".concat(s);
            }));
            if (c.remove(u.map(function (t) {
              return t.getSelectors().at(0);
            })), !t.opt.temporary) {
              var d = o.get("Commands"),
                h = t.get("style-signature"),
                f = {
                  target: t
                };
              h && d.run("core:component-style-clear", f), t.removed(), o.trigger("component:remove", t);
            }
            var p = t.components();
            p.forEach(function (t) {
              return n.removeChildren(t, e, r);
            });
          }
          var g = t.components(),
            v = o.get("UndoManager");
          o.stopListening(g), o.stopListening(t), o.stopListening(t.get("classes")), v.remove(t), v.remove(g);
        },
        model: function model(t, e) {
          var n,
            r = e.collection.opt,
            i = r.em,
            o = i.get("DomComponents").componentTypes;
          e.em = i, e.config = r.config, e.componentTypes = o, e.domc = r.domc;
          for (var a = 0; a < o.length; a++) if (o[a].id == t.type) {
            n = o[a].model;
            break;
          }
          return n || (n = o[o.length - 1].model, i && t.type && i.logWarning("Component type '".concat(t.type, "' not found"), {
            attrs: t,
            options: e
          })), new n(t, e);
        },
        parseString: function parseString(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = this.em,
            o = this.opt.domc,
            a = i.get("CssComposer"),
            s = i.get("Parser").parseHtml(t);
          return r || (r = n(5).default), r.checkId(s.html, s.css, o.componentsById), s.css && a && !e.temporary && a.addCollection(s.css, h(h({}, e), {}, {
            extend: 1
          })), s.html;
        },
        add: function add(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          Object(u.isString)(t) ? t = this.parseString(t, n) : Object(u.isArray)(t) && t.forEach(function (r, i) {
            if (Object(u.isString)(r)) {
              var o = e.parseString(r, n);
              t[i] = Object(u.isArray)(o) && !o.length ? null : o;
            }
          });
          var r = Object(u.isArray)(t);
          return t = (r ? t : [t]).filter(function (t) {
            return t;
          }).map(function (t) {
            return e.processDef(t);
          }), t = r ? t : t[0], l.a.Collection.prototype.add.apply(this, [t, n]);
        },
        processDef: function processDef(t) {
          if (t.cid && t.ccid) return t;
          var e = this.em,
            n = this.config,
            r = (void 0 === n ? {} : n).processor,
            i = t;
          if (r) {
            var a = r(i = h({}, i));
            a && (Object(u.each)(i, function (t, e) {
              return delete i[e];
            }), Object(u.extend)(i, a));
          }
          if (i.$$typeof && "object" == o()(i.props)) {
            (i = h({}, i)).props = h({}, i.props);
            var s = e.get("DomComponents"),
              c = e.get("Parser").parserHtml;
            Object(u.each)(i, function (t, e) {
              Object(u.includes)(["props", "type"], e) || delete i[e];
            });
            var l = i.props,
              d = l.children;
            delete l.children, delete i.props;
            var f = c.splitPropsFromAttr(l);
            i.attributes = f.attrs, d && (i.components = d), i.type ? s.getType(i.type) || (i.tagName = i.type, delete i.type) : i.type = "textnode", Object(u.extend)(i, f.props);
          }
          return i;
        },
        onAdd: function onAdd(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.domc,
            i = this.em,
            o = t.getStyle(),
            a = i && i.getConfig("avoidInlineStyle");
          if (r && r.Component.ensureInList(t), !Object(u.isEmpty)(o) && !a && i && i.get && i.getConfig("forceClass") && !n.temporary) {
            var s = t.cid;
            i.get("CssComposer").setClassRule(s, o), t.setStyle({}), t.addClass(s);
          }
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r);
      i.a.$, e.default = i.a.View.extend({
        initialize: function initialize(t) {
          this.config = t || {}, this.editorModel = this.em = this.config.em || {}, this.pfx = this.config.stylePrefix, this.ppfx = this.config.pStylePrefix, this.hoverClass = this.pfx + "hover", this.badgeClass = this.pfx + "badge", this.plhClass = this.pfx + "placeholder", this.freezClass = this.ppfx + "freezed", this.canvas = this.em.get && this.em.get("Canvas"), this.em.get && this.setElement(this.getCanvas()), this.canvas && (this.$canvas = this.$el, this.canvasTool = this.getCanvasTools()), this.init(this.config);
        },
        onFrameScroll: function onFrameScroll(t) {},
        getCanvas: function getCanvas() {
          return this.canvas ? this.canvas.getElement() : null;
        },
        getCanvasBody: function getCanvasBody() {
          return this.canvas.getBody();
        },
        getCanvasWrapper: function getCanvasWrapper() {
          return this.canvas.getWrapperEl();
        },
        getCanvasTools: function getCanvasTools() {
          return this.canvas.getToolsEl();
        },
        offset: function offset(t) {
          var e = t.getBoundingClientRect();
          return {
            top: e.top + t.ownerDocument.body.scrollTop,
            left: e.left + t.ownerDocument.body.scrollLeft
          };
        },
        init: function init(t) {},
        callRun: function callRun(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.id;
          if (t.trigger("run:".concat(n, ":before"), e), !e || !e.abort) {
            var r = e.sender || t,
              i = this.run(t, r, e);
            return t.trigger("run:".concat(n), i, e), t.trigger("run", n, i, e), i;
          }
          t.trigger("abort:".concat(n), e);
        },
        callStop: function callStop(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.id,
            r = e.sender || t;
          t.trigger("stop:".concat(n, ":before"), e);
          var i = this.stop(t, r, e);
          return t.trigger("stop:".concat(n), i, e), t.trigger("stop", n, i, e), i;
        },
        stopCommand: function stopCommand() {
          this.em.get("Commands").stop(this.id);
        },
        run: function run(t, e) {},
        stop: function stop(t, e) {}
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(2),
        i = n.n(r),
        o = n(0),
        a = n(3),
        s = n(29);
      function c(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function l(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var u = Object(s.a)().parseStyle;
      e.a = {
        parseStyle: u,
        extendStyle: function extendStyle(t) {
          return l(l({}, this.getStyle()), t);
        },
        getStyle: function getStyle() {
          return l({}, this.get("style") || {});
        },
        setStyle: function setStyle() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          Object(o.isString)(e) && (e = u(e));
          var r = this.getStyle(),
            i = l({}, e);
          this.set("style", i, n);
          var s = Object(a.w)(r, i);
          return Object(o.keys)(s).forEach(function (e) {
            var n = t.em;
            t.trigger("change:style:".concat(e)), n && (n.trigger("styleable:change", t, e), n.trigger("styleable:change:".concat(e), t, e));
          }), i;
        },
        addStyle: function addStyle(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          "string" == typeof t ? t = {
            prop: e
          } : n = e || {}, t = this.extendStyle(t), this.setStyle(t, n);
        },
        removeStyle: function removeStyle(t) {
          var e = this.getStyle();
          delete e[t], this.setStyle(e);
        },
        styleToString: function styleToString() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = [],
            n = this.getStyle();
          for (var r in n) {
            var i = t.important,
              a = Object(o.isArray)(i) ? i.indexOf(r) >= 0 : i,
              s = "".concat(n[r]).concat(a ? " !important" : ""),
              c = "__" == r.substr(0, 2);
            s && !c && e.push("".concat(r, ":").concat(s, ";"));
          }
          return e.join("");
        },
        getSelectors: function getSelectors() {
          return this.get("selectors") || this.get("classes");
        },
        getSelectorsString: function getSelectorsString() {
          return this.selectorsToString ? this.selectorsToString() : this.getSelectors().getFullString();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(1),
        a = n.n(o),
        s = n(30),
        c = n(0),
        l = n(3);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var h = a.a.Model.extend({
          defaults: {
            name: "",
            property: "",
            type: "",
            defaults: "",
            info: "",
            value: "",
            icon: "",
            functionName: "",
            status: "",
            visible: !0,
            fixedValues: ["initial", "inherit"],
            full: 0,
            important: 0,
            toRequire: 0,
            requires: null,
            requiresParent: null
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.get("id") || "",
              r = this.get("name") || "";
            !this.get("property") && this.set("property", (r || n).replace(/ /g, "-"));
            var i = this.get("property");
            !this.get("id") && this.set("id", i), !r && this.set("name", Object(l.c)(i).replace(/-/g, " ")), h.callInit(this, t, e);
          },
          init: function init() {},
          clearValue: function clearValue() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.set({
              value: void 0,
              status: ""
            }, t), this;
          },
          setValue: function setValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = this.parseValue(t),
              i = !e;
            !i && this.set({
              value: void 0
            }, {
              avoidStore: i,
              silent: !0
            }), this.set(r, d({
              avoidStore: i
            }, n));
          },
          setValueFromInput: function setValueFromInput(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            this.setValue(t, e, d(d({}, n), {}, {
              fromInput: 1
            }));
          },
          parseValue: function parseValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = {
                value: t
              },
              r = "!important";
            if (Object(c.isString)(t) && -1 !== t.indexOf(r) && (n.value = t.replace(r, "").trim(), n.important = 1), !this.get("functionName") && !e.complete) return n;
            var i = [],
              o = "".concat(n.value),
              a = o.indexOf("(") + 1,
              s = o.lastIndexOf(")"),
              l = o.substring(0, a - 1);
            if (l && (n.functionName = l), i.push(a), s >= 0 && i.push(s), n.value = String.prototype.substring.apply(o, i), e.numeric) {
              var u = parseFloat(n.value);
              n.unit = n.value.replace(u, ""), n.value = u;
            }
            return n;
          },
          splitValues: function splitValues(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ",",
              n = [],
              r = "(",
              i = ")",
              o = "",
              a = 0;
            return (t || "").split("").forEach(function (t) {
              t == r ? (a++, o += r) : t == i && a > 0 ? (a--, o += i) : t === e && 0 == a ? (n.push(o), o = "") : o += t;
            }), "" !== o && n.push(o), n.map(function (t) {
              return t.trim();
            });
          },
          getDefaultValue: function getDefaultValue() {
            return this.get("defaults");
          },
          getFullValue: function getFullValue(t) {
            var e = this.get("functionName"),
              n = this.getDefaultValue(),
              r = Object(c.isUndefined)(t) ? this.get("value") : t,
              i = !Object(c.isUndefined)(r) && "" !== r;
            if (r && n && r === n) return n;
            if (e && i) {
              var o = "url" === e ? "'".concat(r.replace(/'/g, ""), "'") : r;
              r = "".concat(e, "(").concat(o, ")");
            }
            return i && this.get("important") && (r = "".concat(r, " !important")), r || "";
          }
        }, {
          callParentInit: function callParentInit(t, e, n) {
            var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            t.prototype.initialize.apply(e, [n, d(d({}, r), {}, {
              skipInit: 1
            })]);
          },
          callInit: function callInit(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            !n.skipInit && t.init(e, n);
          }
        }),
        f = h;
      function p(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function g(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? p(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var v = f.extend({
          defaults: g(g({}, f.prototype.defaults), {}, {
            detached: 0,
            properties: [],
            separator: " "
          }),
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            f.callParentInit(f, this, t, e);
            var r = this.get("properties") || [],
              i = n(24).default;
            this.set("properties", new i(r)), this.listenTo(this, "change:value", this.updateValues), f.callInit(this, t, e);
          },
          clearValue: function clearValue() {
            return this.get("properties").each(function (t) {
              return t.clearValue();
            }), f.prototype.clearValue.apply(this, arguments);
          },
          updateValues: function updateValues() {
            var t = this.getFullValue().split(this.getSplitSeparator());
            this.get("properties").each(function (e, n) {
              var r = t.length;
              t[n] || t[n % r + (1 != r && r % 2 ? 1 : 0)];
            });
          },
          getSplitSeparator: function getSplitSeparator() {
            return new RegExp("".concat(this.get("separator"), "(?![^\\(]*\\))"));
          },
          getDefaultValue: function getDefaultValue(t) {
            var e = this.get("defaults");
            return e && !t ? e : (e = "", this.get("properties").each(function (t, n) {
              return e += "".concat(t.getDefaultValue(), " ");
            }), e.trim());
          },
          getFullValue: function getFullValue() {
            return this.get("detached") ? "" : this.get("properties").getFullValue();
          },
          getPropertyAt: function getPropertyAt(t) {
            return this.get("properties").at(t);
          }
        }),
        m = a.a.Model.extend({
          defaults: {
            index: "",
            value: "",
            values: {},
            active: !1,
            preview: !1,
            properties: []
          },
          initialize: function initialize() {
            var t = this.get("properties"),
              e = this.get("value");
            this.set("properties", t instanceof yt ? t : new yt(t));
            var n = this.get("properties");
            if (n.forEach(this.onPropAdd, this), this.listenTo(n, "add", this.onPropAdd), !e) {
              var r = "",
                i = this.get("values");
              for (var o in i) r += " " + i[o];
              this.set("value", r.trim());
            }
          },
          onPropAdd: function onPropAdd(t) {
            var e = this.collection;
            t.parent = e && e.property;
          },
          getPropertyAt: function getPropertyAt(t) {
            return this.get("properties").at(t);
          },
          getPropertyValue: function getPropertyValue(t) {
            var e = "";
            return this.get("properties").each(function (n) {
              n.get("property") == t && (e = n.getFullValue());
            }), e;
          },
          getFullValue: function getFullValue() {
            var t = [];
            return this.get("properties").each(function (e) {
              return t.push(e.getFullValue());
            }), t.join(" ").trim();
          }
        });
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function y(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? b(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var w = a.a.Collection.extend({
        model: m,
        initialize: function initialize() {
          this.idx = 1, this.on("add", this.onAdd), this.on("reset", this.onReset);
        },
        onAdd: function onAdd(t, e, n) {
          n.noIncrement || t.set("index", this.idx++), n.active && this.active(this.indexOf(t));
        },
        onReset: function onReset() {
          this.idx = 1;
        },
        getSeparator: function getSeparator() {
          var t = this.property;
          return t ? t.get("layerSeparator") : ", ";
        },
        getLayersFromValue: function getLayersFromValue(t) {
          var e = this,
            n = [];
          return t.replace(/\(([\w\s,.]*)\)/g, function (e) {
            var n = e.replace(/,\s*/g, ",");
            t = t.replace(e, n);
          }), (t ? t.split(this.getSeparator()) : []).forEach(function (t) {
            n.push({
              properties: e.properties.parseValue(t)
            });
          }), n;
        },
        getLayersFromStyle: function getLayersFromStyle(t) {
          var e = [],
            n = this.properties;
          return n.each(function (n) {
            var r = t[n.get("property")];
            (r ? r.split(", ") : []).forEach(function (t, r) {
              t = n.parseValue(t.trim()).value;
              var i = e[r],
                o = y(y({}, n.attributes), {
                  value: t
                });
              i ? i.properties.push(o) : e[r] = {
                properties: [o]
              };
            });
          }), e.forEach(function (t) {
            var e = t.properties.map(function (t) {
              return t.property;
            });
            n.each(function (n) {
              var r = n.get("property");
              e.indexOf(r) < 0 && t.properties.push(y({}, n.attributes));
            });
          }), e;
        },
        active: function active(t) {
          this.each(function (t) {
            return t.set("active", 0);
          });
          var e = this.at(t);
          e && e.set("active", 1);
        },
        getFullValue: function getFullValue() {
          var t = [];
          return this.each(function (e) {
            return t.push(e.getFullValue());
          }), t.join(this.getSeparator());
        },
        getPropertyValues: function getPropertyValues(t, e) {
          var n = [];
          return this.each(function (r) {
            var i = r.getPropertyValue(t);
            i ? n.push(i) : !Object(c.isUndefined)(e) && n.push(e);
          }), n.join(", ");
        }
      });
      function x(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function O(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? x(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var C = v.extend({
          defaults: O(O({}, v.prototype.defaults), {}, {
            layers: [],
            layerSeparator: ", ",
            prepend: 0,
            preview: 0
          }),
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            v.callParentInit(v, this, t, e);
            var n = this.get("layers"),
              r = new w(n);
            r.property = this, r.properties = this.get("properties"), this.set("layers", r), v.callInit(this, t, e);
          },
          getLayers: function getLayers() {
            return this.get("layers");
          },
          getCurrentLayer: function getCurrentLayer() {
            return this.getLayers().filter(function (t) {
              return t.get("active");
            })[0];
          },
          getFullValue: function getFullValue() {
            return this.get("detached") ? "" : this.get("layers").getFullValue();
          },
          getValueFromStyle: function getValueFromStyle() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.getLayers().getLayersFromStyle(t);
            return new w(e).getFullValue();
          },
          clearValue: function clearValue() {
            return this.getLayers().reset(), v.prototype.clearValue.apply(this, arguments);
          },
          getValueFromTarget: function getValueFromTarget(t) {
            var e = this.attributes,
              n = e.detached,
              r = e.property,
              i = e.properties,
              o = t.getStyle(),
              a = {};
            return i.forEach(function (t) {
              var e = t.get("property"),
                n = o[e];
              n && (a[e] = n);
            }), n ? Object(c.keys)(a).length ? a : "" : o[r];
          },
          getLayersFromTarget: function getLayersFromTarget(t) {}
        }),
        S = n(25),
        k = n.n(S),
        T = ["status", "value"],
        j = ["complete"];
      function E(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function P(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? E(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : E(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var A = a.a.View.extend({
        template: function template() {
          var t = this.pfx,
            e = this.ppfx;
          return '\n      <div class="'.concat(t, 'label" data-sm-label></div>\n      <div class="').concat(e, 'fields" data-sm-fields></div>\n    ');
        },
        templateLabel: function templateLabel(t) {
          var e = this.pfx,
            n = this.em,
            r = t.parent,
            i = t.attributes,
            o = i.icon,
            a = void 0 === o ? "" : o,
            s = i.info,
            c = void 0 === s ? "" : s,
            l = i.id,
            u = i.name,
            d = n && n.t("styleManager.properties.".concat(l)) || u;
          return '\n      <span class="'.concat(e, "icon ").concat(a, '" title="').concat(c, '">\n        ').concat(d, "\n      </span>\n      ").concat(r ? "" : '<b class="'.concat(e, 'clear" ').concat("data-clear-style", ">&Cross;</b>"), "\n    ");
        },
        templateInput: function templateInput(t) {
          return '\n      <div class="'.concat(this.ppfx, 'field">\n        <input placeholder="').concat(t.getDefaultValue(), '"/>\n      </div>\n    ');
        },
        events: i()({
          change: "inputValueChanged"
        }, "click [".concat("data-clear-style", "]"), "clear"),
        initialize: function initialize() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          Object(c.bindAll)(this, "targetUpdated", "__change", "__updateStyle"), this.config = e.config || {};
          var n = this.config.em;
          this.em = n, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.target = e.target || {}, this.propTarget = e.propTarget || {}, this.onChange = e.onChange, this.onInputRender = e.onInputRender || {}, this.customValue = e.customValue || {};
          var r = this.model;
          this.property = r.get("property"), this.input = null;
          var i = this.pfx;
          this.inputHolderId = "#" + i + "input-holder", this.sector = r.collection && r.collection.sector, this.__destroyFn = this.destroy ? this.destroy.bind(this) : function () {}, r.view = this, r.get("value") || r.set("value", r.getDefaultValue()), n && n.on("update:component:style:".concat(this.property), this.targetUpdated);
          var o = r.get("requires");
          o && Object.keys(o).forEach(function (e) {
            n && n.on("component:styleUpdate:".concat(e), t.targetUpdated);
          }), this.listenTo(this.propTarget, "update styleManager:update", this.targetUpdated), this.listenTo(r, "destroy remove", this.remove), this.listenTo(r, "change:value", this.modelValueChanged), this.listenTo(r, "targetUpdated", this.targetUpdated), this.listenTo(r, "change:visible", this.updateVisibility), this.listenTo(r, "change:status", this.updateStatus), this.listenTo(r, "change:name change:className change:full", this.render);
          var a = this.init && this.init.bind(this);
          a && a();
        },
        remove: function remove() {
          a.a.View.prototype.remove.apply(this, arguments), this.__destroyFn(this._getClbOpts());
        },
        updateStatus: function updateStatus() {
          var t = this.model,
            e = t.get("status"),
            n = t.parent,
            r = this.pfx,
            i = this.ppfx,
            o = this.config,
            a = "".concat(i, "four-color"),
            s = "".concat(i, "color-warn"),
            c = this.$el.children(".".concat(r, "label")),
            l = this.getClearEl(),
            u = l ? l.style : {};
          switch (c.removeClass("".concat(a, " ").concat(s)), u.display = "none", e) {
            case "updated":
              !n && c.addClass(a), o.clearProperties && (u.display = "inline");
              break;
            case "computed":
              c.addClass(s);
          }
        },
        clear: function clear(t) {
          var e = this;
          t && t.stopPropagation(), this.model.clearValue(), setTimeout(function () {
            return e.targetUpdated();
          });
        },
        getClearEl: function getClearEl() {
          return this.clearEl || (this.clearEl = this.el.querySelector("[".concat("data-clear-style", "]"))), this.clearEl;
        },
        getTarget: function getTarget() {
          return this.getTargetModel();
        },
        getTargets: function getTargets() {
          return this.propTarget.targets || [this.getTarget()];
        },
        getTargetModel: function getTargetModel() {
          return this.propTarget && this.propTarget.model;
        },
        getHelperModel: function getHelperModel() {
          return this.propTarget && this.propTarget.helper;
        },
        inputValueChanged: function inputValueChanged(t) {
          t && t.stopPropagation(), this.emit || (this.model.setValueFromInput(this.getInputValue()), this.elementUpdated());
        },
        elementUpdated: function elementUpdated() {
          this.setStatus("updated");
        },
        setStatus: function setStatus(t) {
          this.model.set("status", t);
          var e = this.model.parent;
          e && "updated" == t && e.set("status", t);
        },
        emitUpdateTarget: Object(c.debounce)(function () {
          var t = this.config.em;
          t && t.trigger("styleManager:update:target", this.getTarget());
        }),
        _getTargetData: function _getTargetData() {
          var t = this.model,
            e = this.config,
            n = this.getTargetValue({
              ignoreDefault: 1
            }),
            r = t.getDefaultValue(),
            i = this.getComputedValue(),
            o = "",
            a = "";
          return n ? (o = n, e.highlightChanged && (a = "updated")) : i && e.showComputed && i != r ? (o = i, e.highlightComputed && (a = "computed")) : (o = r, a = ""), {
            value: o,
            status: a,
            targetValue: n,
            defaultValue: r,
            computedValue: i
          };
        },
        targetUpdated: function targetUpdated(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (!this.config.fromLayer && (this.emitUpdateTarget(), this.checkVisibility())) {
            var r = this.config,
              i = r.em,
              o = this.model,
              a = o.get("property"),
              s = this._getTargetData(),
              c = s.status,
              l = s.value,
              u = k()(s, T),
              d = P({
                status: c,
                value: l
              }, u);
            return this.setStatus(c), o.setValue(l, 0, P({
              fromTarget: 1
            }, n)), i && (i.trigger("styleManager:change", this, a, l, d), i.trigger("styleManager:change:".concat(a), this, l, d), this._emitUpdate(d)), d;
          }
        },
        _emitUpdate: function _emitUpdate() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = this.em,
            n = this.model;
          if (e) {
            var r = n.get("property"),
              i = P(P({}, this._getEventData()), t),
              o = i.id;
            e.trigger("style:update", i), e.trigger("style:update:".concat(r), i), r !== o && e.trigger("style:update:".concat(o), i);
          }
        },
        _getEventData: function _getEventData() {
          var t = this.model;
          return {
            propertyView: this,
            targets: this.getTargets(),
            value: t.getFullValue(),
            property: t,
            id: t.get("id"),
            name: t.get("property")
          };
        },
        checkVisibility: function checkVisibility() {
          var t = 1;
          return this.config.hideNotStylable && (this.isTargetStylable() && this.isComponentStylable() ? this.show() : (this.hide(), t = 0), this.sector && this.sector.trigger("updateVisibility")), t;
        },
        getTargetValue: function getTargetValue() {
          var t,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = this.model,
            r = this.getTargetModel(),
            i = this.customValue;
          if (!r) return t;
          if ((t = r.getStyle()[n.get("property")]) || e.ignoreDefault || (t = n.getDefaultValue()), "function" == typeof i && !e.ignoreCustomValue) {
            var o = n.collection.indexOf(n),
              a = i(this, o, t);
            a && (t = a);
          }
          return t;
        },
        getComputedValue: function getComputedValue() {
          var t = this.propTarget,
            e = t.computed || {},
            n = t.computedDefault || {},
            r = this.config.avoidComputed || [],
            i = this.model.get("property"),
            o = r.indexOf(i) < 0,
            a = e[i],
            s = n[Object(l.b)(i)];
          return e && o && s !== a && a || "";
        },
        getInputValue: function getInputValue() {
          var t = this.getInputEl();
          return t ? t.value : "";
        },
        modelValueChanged: function modelValueChanged(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = this.model,
            o = i.getFullValue();
          r.fromInput || this.setValue(o), r.fromTarget || this.getTargets().forEach(function (t) {
            return n.__updateTarget(t, r);
          });
        },
        __updateTarget: function __updateTarget(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.model,
            r = this.config.em,
            i = n.get("property"),
            o = n.getFullValue(),
            a = this.onChange;
          if (t && this.isTargetStylable(t) && this.isComponentStylable()) {
            e.fromTarget || (a && !e.fromParent ? a(t, this, e) : this.updateTargetStyle(o, null, P(P({}, e), {}, {
              target: t
            })));
            var s = r && r.getSelected();
            r && s && (!e.noEmit && r.trigger("component:update", s), r.trigger("component:styleUpdate", s, i), r.trigger("component:styleUpdate:".concat(i), s)), this._emitUpdate();
          }
        },
        updateTargetStyle: function updateTargetStyle(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = e || this.model.get("property"),
            i = n.target || this.getTarget(),
            o = i.getStyle();
          t ? o[r] = t : delete o[r], n.avoidStore ? o.__ = 1 : delete o.__, i.setStyle(o, n);
          var a = this.getHelperModel();
          a && a.setStyle(o, n);
        },
        isTargetStylable: function isTargetStylable(t) {
          var e = t || this.getTarget(),
            n = this.model,
            r = n.get("id"),
            i = n.get("property"),
            o = n.get("toRequire"),
            a = e.get("unstylable"),
            s = e.get("stylable-require"),
            l = n.get("requires"),
            u = n.get("requiresParent"),
            d = this.sector ? this.sector.collection : null,
            h = this.em ? this.em.getSelected() : null,
            f = e.get("stylable");
          if (Object(c.isArray)(f) && (f = f.indexOf(i) >= 0), Object(c.isArray)(a) && (f = a.indexOf(i) < 0), o && (f = !t || s && (s.indexOf(r) >= 0 || s.indexOf(i) >= 0)), d && l) {
            var p = Object.keys(l);
            d.each(function (t) {
              t.get("properties").each(function (t) {
                if (Object(c.includes)(p, t.id)) {
                  var e = l[t.id];
                  f = f && Object(c.includes)(e, t.get("value"));
                }
              });
            });
          }
          if (u) {
            var g = h && h.parent(),
              v = g && g.getEl();
            if (v) {
              var m = window.getComputedStyle(v);
              Object(c.each)(u, function (t, e) {
                f = f && m[e] && Object(c.includes)(t, m[e]);
              });
            } else f = !1;
          }
          return f;
        },
        isComponentStylable: function isComponentStylable() {
          var t = this.em,
            e = t && t.getSelected();
          return !e || this.isTargetStylable(e);
        },
        setRawValue: function setRawValue(t) {
          this.setValue(this.model.parseValue(t));
        },
        setValue: function setValue(t) {
          var e = this.model,
            n = Object(c.isUndefined)(t) ? e.getDefaultValue() : t;
          if (this.update) return this.__update(n);
          var r = this.getInputEl();
          r && (r.value = n);
        },
        getInputEl: function getInputEl() {
          return this.input || (this.input = this.el.querySelector("input")), this.input;
        },
        updateVisibility: function updateVisibility() {
          this.el.style.display = this.model.get("visible") ? "block" : "none";
        },
        show: function show() {
          this.model.set("visible", 1);
        },
        hide: function hide() {
          this.model.set("visible", 0);
        },
        cleanValue: function cleanValue() {
          this.setValue("");
        },
        clearCached: function clearCached() {
          this.clearEl = null, this.input = null, this.$input = null;
        },
        __update: function __update(t) {
          var e = this.update && this.update.bind(this);
          e && e(P(P({}, this._getClbOpts()), {}, {
            value: t
          }));
        },
        __change: function __change() {
          for (var t = this.emit && this.emit.bind(this), e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          t && t.apply(void 0, [this._getClbOpts()].concat(n));
        },
        __updateStyle: function __updateStyle(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = e.complete,
            r = k()(e, j),
            i = !1 !== n;
          Object(l.n)(t) ? this.getTargets().forEach(function (e) {
            return e.addStyle(t, {
              avoidStore: !i
            });
          }) : this.model.setValueFromInput(t, n, r), i && this.elementUpdated();
        },
        _getClbOpts: function _getClbOpts() {
          var t = this.model;
          return {
            el: this.el,
            props: t.attributes,
            setProps: function setProps() {
              return t.set.apply(t, arguments);
            },
            change: this.__change,
            updateStyle: this.__updateStyle,
            targets: this.getTargets()
          };
        },
        render: function render() {
          this.clearCached();
          var t = this.pfx,
            e = this.model,
            n = this.el,
            r = this.$el,
            i = e.get("property"),
            o = e.get("full"),
            a = e.get("className") || "",
            s = "".concat(t, "property");
          this.createdEl && this.__destroyFn(this._getClbOpts()), r.empty().append(this.template(e)), r.find("[data-sm-label]").append(this.templateLabel(e));
          var c = this.create && this.create.bind(this);
          this.createdEl = c && c(this._getClbOpts()), r.find("[data-sm-fields]").append(this.createdEl || this.templateInput(e)), n.className = "".concat(s, " ").concat(t).concat(e.get("type"), " ").concat(s, "__").concat(i, " ").concat(a).trim(), n.className += o ? " ".concat(s, "--full") : "", this.updateStatus();
          var l = this.onRender && this.onRender.bind(this);
          l && l(), this.setValue(e.get("value"), {
            fromTarget: 1
          });
        }
      });
      function M(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function D(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? M(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var L = a.a.$,
        _ = A.extend({
          templateInput: function templateInput() {
            var t = this.pfx;
            return '\n      <div class="'.concat(t, "field ").concat(t, 'composite">\n        <span id="').concat(t, 'input-holder"></span>\n      </div>\n    ');
          },
          inputValueChanged: function inputValueChanged() {
            if (!this.model.get("detached")) {
              for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
              A.prototype.inputValueChanged.apply(this, e);
            }
          },
          clear: function clear(t) {
            var e = this.properties;
            e && e.forEach(function (t) {
              return t.clear();
            }), A.prototype.clear.apply(this, arguments);
          },
          onRender: function onRender() {
            var t = this.model,
              e = t.get("properties") || [];
            if (this.properties = [], e.length && (this.$input || (this.$input = L('<input type="hidden" value="0">'), this.input = this.$input.get(0)), this.props || (this.props = t.get("properties")), !this.$props)) {
              this.props.each(function (e, n) {
                e && "composite" == e.get("type") && (this.props.remove(e), console.warn("Nested composite types not yet allowed.")), e.parent = t;
              }, this);
              var r = new (0, n(19).default)(this.getPropsConfig());
              this.$props = r.render().$el, this.properties = r.properties, this.$el.find("#".concat(this.pfx, "input-holder")).append(this.$props);
            }
          },
          getPropsConfig: function getPropsConfig(t) {
            var e = this,
              n = this.model,
              r = {
                config: D(D({}, this.config), {}, {
                  highlightComputed: 0
                }),
                collection: this.props,
                target: this.target,
                propTarget: this.propTarget,
                onChange: function onChange(t, e, r) {
                  n.set("value", n.getFullValue(), r);
                },
                customValue: function customValue(t, n) {
                  return e.valueOnIndex(n, t);
                }
              };
            return n.get("detached") && delete r.onChange, r;
          },
          valueOnIndex: function valueOnIndex(t, e) {
            var n = this.getTargetValue({
              ignoreDefault: 1
            });
            return n ? n.split(this.model.getSplitSeparator())[t] : e && e.getTargetValue({
              ignoreCustomValue: 1,
              ignoreDefault: 1
            });
          },
          clearCached: function clearCached() {
            A.prototype.clearCached.apply(this, arguments), this.$input = null, this.props = null, this.$props = null;
          }
        }),
        N = n(19);
      function I(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function R(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? I(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var F = a.a.View.extend({
          events: {
            click: "active",
            "click [data-close-layer]": "removeItem",
            "mousedown [data-move-layer]": "initSorter",
            "touchstart [data-move-layer]": "initSorter"
          },
          template: function template(t) {
            var e = this.pfx,
              n = this.ppfx,
              r = this.em,
              i = "".concat(r && r.t("styleManager.layer"), " ").concat(t.get("index"));
            return '\n      <div id="'.concat(e, 'move" class="').concat(n, 'no-touch-actions" data-move-layer>\n        <i class="fa fa-arrows"></i>\n      </div>\n      <div id="').concat(e, 'label">').concat(i, '</div>\n      <div id="').concat(e, 'preview-box">\n      \t<div id="').concat(e, 'preview" data-preview></div>\n      </div>\n      <div id="').concat(e, 'close-layer" class="').concat(e, 'btn-close" data-close-layer>\n        &Cross;\n      </div>\n      <div id="').concat(e, 'inputs" data-properties></div>\n      <div style="clear:both"></div>\n    ');
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model;
            this.stackModel = t.stackModel, this.config = t.config || {}, this.em = this.config.em, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.sorter = t.sorter || null, this.propsConfig = t.propsConfig || {}, this.customPreview = t.onPreview, this.listenTo(e, "destroy remove", this.remove), this.listenTo(e, "change:active", this.updateVisibility), this.listenTo(e.get("properties"), "change", this.updatePreview), e.view = this, e.set({
              droppable: 0,
              draggable: 1
            }), this.$el.data("model", e);
          },
          initSorter: function initSorter(t) {
            this.sorter && this.sorter.startSort(this.el);
          },
          removeItem: function removeItem(t) {
            t && t.stopPropagation(), this.remove();
          },
          remove: function remove() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = this.props,
              r = e.collection,
              i = this.stackModel;
            a.a.View.prototype.remove.apply(this, arguments), r && r.contains(e) && r.remove(e), i && i.set && (i.set({
              stackIndex: null
            }, {
              silent: !0
            }), !t.fromTarget && i.trigger("updateValue")), n && n.remove();
          },
          onPreview: function onPreview(t) {
            var e = this.stackModel,
              n = e && e.get("detached"),
              r = t.split(" "),
              i = [],
              o = {};
            return this.model.get("properties").each(function (t, e) {
              var a = t.get("property"),
                s = n ? t.getFullValue() : r[e] || "";
              if (s && "integer" == t.get("type")) {
                var c = parseInt(s, 10),
                  l = s.replace(c, "");
                s = (c = (c = (c = isNaN(c) ? 0 : c) > 3 ? 3 : c) < -3 ? -3 : c) + l;
              }
              i.push(s), o[a] = s;
            }), n ? o : i.join(" ");
          },
          updatePreview: function updatePreview() {
            var t = this.stackModel,
              e = this.customPreview,
              n = this.getPreviewEl(),
              r = this.model.getFullValue(),
              i = e ? e(r) : this.onPreview(r);
            if (i && t && n) {
              var o = n.style;
              if (Object(c.isString)(i)) o[t.get("property")] = i;else {
                var a = [];
                Object(c.each)(i, function (t, e) {
                  return a.push("".concat(e, ":").concat(t));
                }), n.setAttribute("style", a.join(";"));
              }
            }
          },
          getPropertiesWrapper: function getPropertiesWrapper() {
            return this.propsWrapEl || (this.propsWrapEl = this.el.querySelector("[data-properties]")), this.propsWrapEl;
          },
          getPreviewEl: function getPreviewEl() {
            return this.previewEl || (this.previewEl = this.el.querySelector("[data-preview]")), this.previewEl;
          },
          active: function active() {
            var t = this.model,
              e = t.collection;
            e.active(e.indexOf(t));
          },
          updateVisibility: function updateVisibility() {
            var t = this.pfx,
              e = this.getPropertiesWrapper(),
              n = this.model.get("active");
            e.style.display = n ? "" : "none", this.$el[n ? "addClass" : "removeClass"]("".concat(t, "active"));
          },
          render: function render() {
            var t = this.propsConfig,
              e = this.model,
              n = this.el,
              r = this.pfx,
              i = e.get("preview"),
              o = new N.default({
                collection: e.get("properties"),
                config: R(R({}, this.config), {}, {
                  fromLayer: 1
                }),
                target: t.target,
                customValue: t.customValue,
                propTarget: t.propTarget,
                onChange: t.onChange
              }),
              a = o.render().el;
            return n.innerHTML = this.template(e), n.className = "".concat(r, "layer").concat(i ? "" : " ".concat(r, "no-preview")), this.props = o, this.getPropertiesWrapper().appendChild(a), this.updateVisibility(), this.updatePreview(), this;
          }
        }),
        V = a.a.View.extend({
          initialize: function initialize(t) {
            this.config = t.config || {}, this.stackModel = t.stackModel, this.preview = t.preview, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.propsConfig = t.propsConfig;
            var e = this.pfx,
              n = this.ppfx,
              r = this.collection;
            this.className = "".concat(e, "layers ").concat(n, "field"), this.listenTo(r, "add", this.addTo), this.listenTo(r, "deselectAll", this.deselectAll), this.listenTo(r, "reset", this.reset), this.items = [];
            var i = this.config.em || "",
              o = i ? i.get("Utils") : "";
            this.sorter = o ? new o.Sorter({
              container: this.el,
              ignoreViewChildren: 1,
              containerSel: ".".concat(e, "layers"),
              itemSel: ".".concat(e, "layer"),
              pfx: this.config.pStylePrefix
            }) : "", r.view = this, this.$el.data("model", r), this.$el.data("collection", r);
          },
          addTo: function addTo(t) {
            var e = this.collection.indexOf(t);
            this.addToCollection(t, null, e);
          },
          addToCollection: function addToCollection(t, e, n) {
            var r = e || null,
              i = this.stackModel,
              o = this.config,
              a = this.sorter,
              s = this.propsConfig;
            void 0 !== this.preview && t.set("preview", this.preview);
            var c = new F({
                model: t,
                config: o,
                sorter: a,
                stackModel: i,
                propsConfig: s
              }),
              l = c.render().el;
            if (this.items.push(c), r) r.appendChild(l);else if (void 0 !== n) {
              var u = "before";
              this.$el.children().length == n && (n--, u = "after"), n < 0 ? this.$el.append(l) : this.$el.children().eq(n)[u](l);
            } else this.$el.append(l);
            return l;
          },
          deselectAll: function deselectAll() {
            this.$el.find("." + this.pfx + "layer").removeClass(this.pfx + "active");
          },
          reset: function reset(t, e) {
            this.clearItems(e), this.render();
          },
          render: function render() {
            var t = document.createDocumentFragment();
            return this.$el.empty(), this.collection.each(function (e) {
              this.addToCollection(e, t);
            }, this), this.$el.append(t), this.$el.attr("class", this.className), this.sorter && (this.sorter.plh = null), this;
          },
          remove: function remove() {
            this.clearItems(), a.a.View.prototype.remove.apply(this, arguments);
          },
          clearItems: function clearItems(t) {
            this.items.forEach(function (e) {
              return e.remove(t);
            }), this.items = [];
          }
        });
      function z(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      var H = new (n(31).a)(),
        B = _.extend({
          templateInput: function templateInput() {
            var t = this.pfx;
            return this.ppfx, '\n      <div class="'.concat(t, "field ").concat(t, 'stack">\n        <button type="button" id="').concat(t, 'add" data-add-layer>+</button>\n        <div data-layers-wrapper></div>\n      </div>\n    ');
          },
          init: function init() {
            var t = this.model;
            this.pfx, t.set("stackIndex", null), this.events["click [data-add-layer]"] = "addLayer", this.listenTo(t, "change:stackIndex", this.indexChanged), this.listenTo(t, "updateValue", this.inputValueChanged), this.delegateEvents();
            var e = this.getPropsConfig();
            this.layers = new V({
              collection: this.getLayers(),
              stackModel: t,
              preview: t.get("preview"),
              config: this.config,
              propsConfig: e
            });
            var r = n(19).default;
            this.propsView = new r({
              target: this.target,
              collection: t.get("properties"),
              stackModel: t,
              config: this.config,
              onChange: e.onChange,
              propTarget: e.propTarget
            });
          },
          targetUpdated: function targetUpdated() {
            var t,
              e = this;
            if (this.model.get("detached")) t = this._getTargetData(), this.setStatus(t.status), this.checkVisibility();else {
              for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) r[i] = arguments[i];
              t = _.prototype.targetUpdated.apply(this, r);
            }
            setTimeout(function () {
              return e.refreshLayers(t);
            });
          },
          getLayers: function getLayers() {
            return this.model.get("layers");
          },
          indexChanged: function indexChanged(t) {
            var e = this.model;
            this.getLayers().active(e.get("stackIndex"));
          },
          addLayer: function addLayer() {
            var t = this.model,
              e = this.getLayers(),
              n = t.get("prepend"),
              r = t.get("properties").deepClone();
            r.each(function (t) {
              return t.set("value", "");
            });
            var o = e.add({
              properties: r
            }, function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {};
                e % 2 ? z(Object(n), !0).forEach(function (e) {
                  i()(t, e, n[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : z(Object(n)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                });
              }
              return t;
            }({
              active: 1
            }, n && {
              at: 0
            }));
            this.inputValueChanged({
              up: 1
            }), t.set("stackIndex", e.indexOf(o));
          },
          inputValueChanged: function inputValueChanged() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model;
            t.up && this.elementUpdated(), e.get("detached") ? e.get("properties").each(function (t) {
              return t.trigger("change:value");
            }) : e.set("value", this.getLayerValues());
          },
          setValue: function setValue() {},
          getLayerValues: function getLayerValues() {
            return this.getLayers().getFullValue();
          },
          _getClassRule: function _getClassRule() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.em,
              n = t.skipAdd,
              r = void 0 === n ? 1 : n,
              i = e.getSelected(),
              o = e.get("StyleManager").getModelToStyle(i, {
                skipAdd: r,
                useClasses: 1
              });
            return o !== i && o;
          },
          _getParentTarget: function _getParentTarget(t) {
            for (var e, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = this.em, i = this.model, o = i.get("property"), a = n.isValid || function (t) {
                return t.getStyle()[o];
              }, s = r.get("CssComposer").getAll().filter(function (e) {
                return e.selectorsToString() === t.getSelectorsString();
              }), c = s.reduce(function (t, e) {
                return t[e.getAtRule()] = e, t;
              }, {}), l = H.sortMediaObject(c), u = l.map(function (t) {
                return t.value;
              }), d = u.indexOf(t), h = u.splice(0, d), f = h.length - 1; f > -1; f--) {
              var p = h[f];
              if (a(p)) {
                e = p;
                break;
              }
            }
            return e;
          },
          refreshLayers: function refreshLayers() {
            var t,
              e,
              n,
              r,
              i,
              o,
              a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              s = [],
              l = this.model,
              u = this.em,
              d = this.getLayers(),
              h = l.get("detached"),
              f = l.get("property"),
              p = this.getTarget(),
              g = this.getComputedValue(),
              v = u.getSelected(),
              m = {
                fromTarget: 1
              };
            if (h) {
              e = a.targetValue || {};
              var b = function b(t) {
                var e = l.get("properties").at(0).get("property");
                return t && !Object(c.isUndefined)(t.getStyle()[e]);
              };
              if (!Object(c.keys)(e).length && g && v) {
                var y = {
                  isValid: function isValid(t) {
                    return b(t);
                  }
                };
                (r = this._getParentTarget(p, y)) ? e = r.getStyle() : (n = this._getClassRule(), r = !(i = b(n) && n.getStyle()) && this._getParentTarget(this._getClassRule({
                  skipAdd: 0
                }), y), o = b(r) && r.getStyle(), e = i || o || {});
              }
              t = e, s = d.getLayersFromStyle(e);
            } else {
              var w = this.getTargetValue({
                  ignoreDefault: 1
                }),
                x = w;
              !x && g && ((r = this._getParentTarget(p)) ? x = r.getStyle()[f] : (o = (r = !(i = (n = this._getClassRule()) && n.getStyle()[f]) && this._getParentTarget(this._getClassRule({
                skipAdd: 0
              }))) && r.getStyle()[f], x = i || o || g)), t = x = x == l.getDefaultValue() ? "" : x, s = d.getLayersFromValue(x);
            }
            var O = l.getLayersFromTarget(p, {
              resultValue: t,
              layersObj: s
            }) || s;
            d.reset(null, m), d.add(O, m), l.set({
              stackIndex: null
            }, {
              silent: !0
            });
          },
          getTargetValue: function getTargetValue() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = e.attributes.detached,
              r = this.getTarget(),
              i = _.prototype.getTargetValue.call(this, t);
            return Object(c.isUndefined)(i) && !n ? i = e.getValueFromStyle(r.getStyle()) : n && (i = e.getValueFromTarget(r)), i;
          },
          getPropsConfig: function getPropsConfig() {
            var t = this,
              e = t.model;
            return {
              target: t.target,
              propTarget: t.propTarget,
              onChange: function onChange(n, r, o) {
                var a = r.model,
                  s = e.get("status");
                if (e.get("detached")) {
                  var c = a.get("property"),
                    l = a.getDefaultValue(),
                    u = t.getLayers(),
                    d = u.getPropertyValues(c, l);
                  r.updateTargetStyle(d, null, o), "background-image" != c || o.avoidStore || "computed" != s || e.get("properties").filter(function (t) {
                    return "__" == t.get("property").substr(0, 2);
                  }).forEach(function (e) {
                    var n = e.get("property"),
                      r = u.getPropertyValues(n, e.getDefaultValue());
                    t.getTargets().forEach(function (t) {
                      return t.addStyle(i()({}, n, r), o);
                    });
                  });
                } else if ("updated" == s) {
                  var h = e.getFullValue();
                  e.set("value", h, o), !h && r.updateTargetStyle(h, null, o);
                }
              }
            };
          },
          onRender: function onRender() {
            var t = this.el,
              e = this.layers,
              n = this.propsView,
              r = t.querySelector("[data-layers-wrapper]");
            n.render(), r.appendChild(e.render().el);
          }
        }),
        U = a.a.$,
        $ = A.extend({
          templateInput: function templateInput() {
            var t = this.pfx,
              e = this.em;
            return '\n    <div class="'.concat(t, "field ").concat(t, "file\">\n      <div id='").concat(t, "input-holder'>\n        <div class=\"").concat(t, 'btn-c">\n          <button class="').concat(t, 'btn" id="').concat(t, 'images" type="button">\n            ').concat(e.t("styleManager.fileButton"), '\n          </button>\n        </div>\n        <div style="clear:both;"></div>\n      </div>\n      <div id="').concat(t, 'preview-box">\n        <div id="').concat(t, 'preview-file"></div>\n        <div id="').concat(t, 'close">&Cross;</div>\n      </div>\n    </div>\n    ');
          },
          init: function init() {
            var t = this.em;
            this.modal = t.get("Modal"), this.am = t.get("AssetManager"), this.events["click #" + this.pfx + "close"] = "removeFile", this.events["click #" + this.pfx + "images"] = "openAssetManager", this.delegateEvents();
          },
          onRender: function onRender() {
            if (!this.$input) {
              var t = this.model.getDefaultValue();
              this.$input = U('<input placeholder="'.concat(t, '">'));
            }
            this.$preview || (this.$preview = this.$el.find("#" + this.pfx + "preview-file")), this.$previewBox || (this.$previewBox = this.$el.find("#" + this.pfx + "preview-box")), this.setValue(this.componentValue, 0);
          },
          clearCached: function clearCached() {
            A.prototype.clearCached.apply(this, arguments), this.$preview = null, this.$previewBox = null;
          },
          setValue: function setValue(t, e) {
            A.prototype.setValue.apply(this, arguments), this.setPreviewView(t && t != this.model.getDefaultValue()), this.setPreview(t);
          },
          setPreviewView: function setPreviewView(t) {
            var e = this.$previewBox;
            e && e[t ? "addClass" : "removeClass"]("".concat(this.pfx, "show")), e && e.css({
              display: t ? "block" : "none"
            });
          },
          spreadUrl: function spreadUrl(t) {
            this.model.set("value", t), this.setPreviewView(1);
          },
          setPreview: function setPreview(t) {
            var e = this.$preview;
            t = t && t.indexOf("url(") < 0 ? "url(".concat(t, ")") : t, e && e.css("background-image", t);
          },
          cleanValue: function cleanValue() {
            this.setPreviewView(0), this.model.set({
              value: ""
            }, {
              silent: !0
            });
          },
          removeFile: function removeFile() {
            this.model.set("value", this.model.getDefaultValue());
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            A.prototype.cleanValue.apply(this, e), this.setPreviewView(0);
          },
          openAssetManager: function openAssetManager(t) {
            var e = this,
              n = this.em,
              r = this.modal,
              i = n ? n.get("Editor") : "";
            i && i.runCommand("open-assets", {
              types: ["image"],
              accept: "image/*",
              target: this.getTargetModel(),
              onClick: function onClick() {},
              onDblClick: function onDblClick() {},
              onSelect: function onSelect(t) {
                r.close();
                var n = Object(c.isString)(t) ? t : t.get("src");
                e.spreadUrl(n);
              }
            });
          }
        }),
        W = a.a.$,
        q = A.extend({
          templateInput: function templateInput() {
            return "";
          },
          init: function init() {
            var t = this.model;
            this.listenTo(t, "change:unit", this.modelValueChanged), this.listenTo(t, "el:change", this.elementUpdated), this.listenTo(t, "change:units", this.render);
          },
          setValue: function setValue(t) {
            var e = this.model.parseValue(t);
            t = "".concat(e.value).concat(e.unit), this.inputInst.setValue(t, {
              silent: 1
            });
          },
          onRender: function onRender() {
            var t = this.ppfx;
            if (!this.input) {
              var e = this.model.input;
              e.ppfx = t, e.render(), this.el.querySelector(".".concat(t, "fields")).appendChild(e.el), this.$input = e.inputEl, this.unit = e.unitEl, this.$unit = W(this.unit), this.input = this.$input.get(0), this.inputInst = e;
            }
          },
          clearCached: function clearCached() {
            A.prototype.clearCached.apply(this, arguments), this.unit = null, this.$unit = null;
          }
        }),
        G = n(38);
      function Y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function K(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Y(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var X = q.extend({
          setValue: function setValue(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            e = K(K({}, e), {}, {
              silent: 1
            }), this.inputInst.setValue(t, e);
          },
          onRender: function onRender() {
            if (!this.input) {
              var t = this.ppfx,
                e = new G.a({
                  target: this.target,
                  model: this.model,
                  ppfx: t
                }).render();
              this.el.querySelector(".".concat(t, "fields")).appendChild(e.el), this.$input = e.inputEl, this.$color = e.colorEl, this.input = this.$input.get(0), this.inputInst = e;
            }
          }
        }),
        J = n(9),
        Z = n.n(J);
      function Q(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function tt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Q(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Q(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var et = f.extend({
        defaults: function defaults() {
          return tt(tt({}, f.prototype.defaults), {}, {
            options: [],
            full: 1
          });
        },
        initialize: function initialize() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          f.prototype.initialize.apply(this, e), this.listenTo(this, "change:options", this.onOptionChange);
        },
        onOptionChange: function onOptionChange() {
          this.set("list", this.get("options"));
        },
        getOptions: function getOptions() {
          var t = this.attributes,
            e = t.options,
            n = t.list;
          return e && e.length ? e : n;
        },
        setOptions: function setOptions() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return this.set("options", t), this;
        },
        addOption: function addOption(t) {
          if (t) {
            var e = this.getOptions();
            this.setOptions([].concat(Z()(e), [t]));
          }
          return this;
        }
      });
      function nt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function rt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? nt(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : nt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var it = et.extend({
          defaults: function defaults() {
            return rt(rt({}, et.prototype.defaults()), {}, {
              full: 0
            });
          }
        }),
        ot = (a.a.$, A.extend({
          templateInput: function templateInput() {
            var t = this.pfx,
              e = this.ppfx;
            return '\n      <div class="'.concat(e, "field ").concat(e, 'select">\n        <span id="').concat(t, 'input-holder"></span>\n        <div class="').concat(e, 'sel-arrow">\n          <div class="').concat(e, 'd-s-arrow"></div>\n        </div>\n      </div>\n    ');
          },
          initialize: function initialize() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            A.prototype.initialize.apply(this, e), this.listenTo(this.model, "change:options", this.updateOptions);
          },
          updateOptions: function updateOptions() {
            this.input = null, this.onRender();
          },
          onRender: function onRender() {
            var t = this.pfx,
              e = this.model.getOptions();
            if (!this.input) {
              var n = "";
              e.forEach(function (t) {
                var e = t.name || t.value,
                  r = t.style ? t.style.replace(/"/g, "&quot;") : "",
                  i = r ? 'style="'.concat(r, '"') : "",
                  o = t.value.replace(/"/g, "&quot;");
                n += '<option value="'.concat(o, '" ').concat(i, ">").concat(e, "</option>");
              });
              var r = this.el.querySelector("#".concat(t, "input-holder"));
              r.innerHTML = "<select>".concat(n, "</select>"), this.input = r.firstChild;
            }
          }
        })),
        at = A.extend({
          templateInput: function templateInput() {
            this.pfx;
            var t = this.ppfx;
            return '\n      <div class="'.concat(t, "field ").concat(t, 'field-radio">\n      </div>\n    ');
          },
          onRender: function onRender() {
            var t = this.pfx,
              e = this.ppfx,
              n = "".concat(e, "radio-item-label"),
              r = this.model,
              i = r.get("property"),
              o = r.get("list") || r.get("options") || [],
              a = r.cid,
              s = "".concat(t, "radio ").concat(t, "radio-").concat(i);
            if (!this.input && o && o.length) {
              var c = "";
              o.forEach(function (r) {
                var o = r.className ? "".concat(r.className, " ").concat(t, "icon ").concat(n) : "",
                  l = "".concat(i, "-").concat(r.value, "-").concat(a),
                  u = r.name || r.value,
                  d = r.title ? 'title="'.concat(r.title, '"') : "";
                c += '\n            <div class="'.concat(e, 'radio-item">\n              <input type="radio" class="').concat(s, '" id="').concat(l, '" name="').concat(i, "-").concat(a, '" value="').concat(r.value, '"/>\n              <label class="').concat(o || n, '" ').concat(d, ' for="').concat(l, '">').concat(o ? "" : u, "</label>\n            </div>\n          ");
              });
              var l = this.el.querySelector(".".concat(e, "field"));
              l.innerHTML = '<div class="'.concat(e, 'radio-items">').concat(c, "</div>"), this.input = l.firstChild;
            }
          },
          getInputValue: function getInputValue() {
            var t = this.getCheckedEl();
            return t ? t.value : "";
          },
          getCheckedEl: function getCheckedEl() {
            var t = this.getInputEl();
            return t ? t.querySelector("input:checked") : "";
          },
          setValue: function setValue(t) {
            var e = this.model,
              n = t || e.get("value") || e.getDefaultValue(),
              r = this.getInputEl(),
              i = r ? r.querySelector('[value="'.concat(n, '"]')) : "";
            if (i) i.checked = !0;else {
              var o = this.getCheckedEl();
              o && (o.checked = !1);
            }
          }
        }),
        st = n(32);
      function ct(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function lt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? ct(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ct(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var ut = f.extend({
        defaults: lt(lt({}, f.prototype.defaults), {}, {
          units: [],
          unit: "",
          step: 1,
          min: "",
          max: ""
        }),
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          f.callParentInit(f, this, t, e);
          var n = this.get("unit"),
            r = this.get("units");
          this.input = new st.a({
            model: this
          }), r.length && !n && this.set("unit", r[0]), f.callInit(this, t, e);
        },
        clearValue: function clearValue() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.set({
            value: void 0,
            unit: void 0
          }, t), this;
        },
        parseValue: function parseValue(t) {
          var e = f.prototype.parseValue.apply(this, arguments),
            n = this.input.validateInputValue(e.value, {
              deepCheck: 1
            }),
            r = n.value,
            i = n.unit;
          return e.value = r, e.unit = i, e;
        },
        getFullValue: function getFullValue() {
          var t = this.get("value"),
            e = this.get("unit");
          return t = Object(c.isUndefined)(t) ? "" : t, e = !Object(c.isUndefined)(e) && t ? e : "", t = "".concat(t).concat(e), f.prototype.getFullValue.apply(this, [t]);
        }
      });
      function dt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function ht(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? dt(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : dt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var ft = ut.extend({
        defaults: ht(ht({}, ut.prototype.defaults), {}, {
          showInput: 1
        })
      });
      function pt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function gt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? pt(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : pt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var vt = q.extend({
        events: function events() {
          return gt(gt({}, q.prototype.events), {}, {
            "change [type=range]": "inputValueChanged",
            "input [type=range]": "inputValueChangedSoft",
            change: ""
          });
        },
        templateInput: function templateInput(t) {
          var e = this.ppfx;
          return '\n      <div class="'.concat(e, "field ").concat(e, 'field-range">\n        <input type="range"\n          min="').concat(t.get("min"), '"\n          max="').concat(t.get("max"), '"\n          step="').concat(t.get("step"), '"/>\n      </div>\n    ');
        },
        getSliderEl: function getSliderEl() {
          return this.slider || (this.slider = this.el.querySelector("input[type=range]")), this.slider;
        },
        inputValueChanged: function inputValueChanged() {
          var t = this.model,
            e = t.get("step");
          this.getInputEl().value = this.getSliderEl().value;
          var n = this.getInputValue() - e;
          t.set("value", n, {
            avoidStore: 1
          }).set("value", n + e), this.elementUpdated();
        },
        inputValueChangedSoft: function inputValueChangedSoft() {
          this.getInputEl().value = this.getSliderEl().value, this.model.set("value", this.getInputValue(), {
            avoidStore: 1
          }), this.elementUpdated();
        },
        setValue: function setValue(t) {
          var e = this.model.parseValue(t);
          this.getSliderEl().value = parseFloat(e.value), q.prototype.setValue.apply(this, arguments);
        },
        onRender: function onRender() {
          q.prototype.onRender.apply(this, arguments), this.model.get("showInput") || (this.inputInst.el.style.display = "none");
        },
        clearCached: function clearCached() {
          q.prototype.clearCached.apply(this, arguments), this.slider = null;
        }
      });
      function mt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function bt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? mt(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : mt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var yt = e.default = a.a.Collection.extend(s.a).extend({
        extendViewApi: 1,
        types: [{
          id: "stack",
          model: C,
          view: B,
          isType: function isType(t) {
            if (t && "stack" == t.type) return t;
          }
        }, {
          id: "composite",
          model: v,
          view: _,
          isType: function isType(t) {
            if (t && "composite" == t.type) return t;
          }
        }, {
          id: "file",
          model: f,
          view: $,
          isType: function isType(t) {
            if (t && "file" == t.type) return t;
          }
        }, {
          id: "color",
          model: f,
          view: X,
          isType: function isType(t) {
            if (t && "color" == t.type) return t;
          }
        }, {
          id: "select",
          model: it,
          view: ot,
          isType: function isType(t) {
            if (t && "select" == t.type) return t;
          }
        }, {
          id: "radio",
          model: et,
          view: at,
          isType: function isType(t) {
            if (t && "radio" == t.type) return t;
          }
        }, {
          id: "slider",
          model: ft,
          view: vt,
          isType: function isType(t) {
            if (t && "slider" == t.type) return t;
          }
        }, {
          id: "integer",
          model: ut,
          view: q,
          isType: function isType(t) {
            if (t && "integer" == t.type) return t;
          }
        }, {
          id: "base",
          model: f,
          view: A,
          isType: function isType(t) {
            return t.type = "base", t;
          }
        }],
        deepClone: function deepClone() {
          var t = this.clone();
          return t.reset(t.map(function (t) {
            var e = t.clone();
            return e.typeView = t.typeView, e;
          })), t;
        },
        parseValue: function parseValue(t) {
          var e = this,
            n = [];
          return t.split(" ").forEach(function (t, r) {
            var i = e.at(r);
            i && n.push(bt(bt({}, i.attributes), {
              value: t
            }));
          }), n;
        },
        getFullValue: function getFullValue() {
          var t = "";
          return this.each(function (e) {
            return t += "".concat(e.getFullValue(), " ");
          }), t.trim();
        }
      });
    }, function (t, e, n) {
      var r = n(90);
      t.exports = function (t, e) {
        if (null == t) return {};
        var n,
          i,
          o = r(t, e);
        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(t);
          for (i = 0; i < a.length; i++) n = a[i], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (o[n] = t[n]);
        }
        return o;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      var n;
      n = function () {
        return this;
      }();
      try {
        n = n || new Function("return this")();
      } catch (t) {
        "object" == typeof window && (n = window);
      }
      t.exports = n;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r).a.$;
      e.default = {
        startSelectPosition: function startSelectPosition(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.isPointed = !1;
          var i = this.editorModel.get("Utils"),
            o = t.ownerDocument.body;
          i && !this.sorter && (this.sorter = new i.Sorter({
            container: o,
            placer: this.canvas.getPlacerEl(),
            containerSel: "*",
            itemSel: "*",
            pfx: this.ppfx,
            direction: "a",
            document: e,
            wmargin: 1,
            nested: 1,
            em: this.editorModel,
            canvasRelative: 1,
            scale: function scale() {
              return n.em.getZoomDecimal();
            }
          })), r.onStart && (this.sorter.onStart = r.onStart), t && this.sorter.startSort(t, {
            container: o
          });
        },
        getOffsetDim: function getOffsetDim() {
          var t = this.offset(this.canvas.getFrameEl()),
            e = this.offset(this.canvas.getElement());
          return {
            top: t.top - e.top,
            left: t.left - e.left
          };
        },
        stopSelectPosition: function stopSelectPosition() {
          this.posTargetCollection = null, this.posIndex = "after" == this.posMethod && 0 !== this.cDim.length ? this.posIndex + 1 : this.posIndex, this.sorter && (this.sorter.moved = 0, this.sorter.endMove()), this.cDim && (this.posIsLastEl = 0 !== this.cDim.length && "after" == this.posMethod && this.posIndex == this.cDim.length, this.posTargetEl = 0 === this.cDim.length ? i(this.outsideElem) : !this.posIsLastEl && this.cDim[this.posIndex] ? i(this.cDim[this.posIndex][5]).parent() : i(this.outsideElem), this.posTargetModel = this.posTargetEl.data("model"), this.posTargetCollection = this.posTargetEl.data("model-comp"));
        },
        enable: function enable() {
          this.startSelectPosition();
        },
        nearFloat: function nearFloat(t, e, n) {
          var r = t || 0,
            i = e || "before",
            o = n.length,
            a = 0 !== o && "after" == i && r == o;
          return 0 !== o && (!a && !n[r][4] || n[r - 1] && !n[r - 1][4] || a && !n[r - 1][4]) ? 1 : 0;
        },
        run: function run() {
          this.enable();
        },
        stop: function stop() {
          this.stopSelectPosition(), this.$wrapper.css("cursor", ""), this.$wrapper.unbind();
        }
      };
    }, function (t, e, n) {
      "use strict";

      var r = n(40);
      window.Promise = window.Promise || r.a, e.a = "function" == typeof fetch ? fetch.bind() : function (t, e) {
        return new r.a(function (n, i) {
          var o = new XMLHttpRequest();
          for (var a in o.open(e.method || "get", t), o.withCredentials = "include" == e.credentials, e.headers || {}) o.setRequestHeader(a, e.headers[a]);
          o.onload = function (t) {
            return n({
              status: o.status,
              statusText: o.statusText,
              text: function text() {
                return r.a.resolve(o.responseText);
              }
            });
          }, o.onerror = i, o.upload && e.onProgress && (o.upload.onprogress = e.onProgress), e.body ? o.send(e.body) : o.send();
        });
      };
    }, function (t, e, n) {
      "use strict";

      var r = n(8),
        i = n.n(r),
        o = n(0);
      e.a = function (t) {
        var e = t;
        return {
          compTypes: "",
          modelAttrStart: "data-gjs-",
          splitPropsFromAttr: function splitPropsFromAttr() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = {},
              r = {};
            return Object(o.each)(e, function (e, i) {
              if (0 === i.indexOf(t.modelAttrStart)) {
                var a = i.replace("data-gjs-", ""),
                  s = e.length,
                  c = e && Object(o.isString)(e),
                  l = c && e.substr(0, 1),
                  u = c && e.substr(s - 1);
                e = "false" !== (e = "true" === e || e) && e;
                try {
                  e = "{" == l && "}" == u || "[" == l && "]" == u ? JSON.parse(e) : e;
                } catch (t) {}
                n[a] = e;
              } else r[i] = e;
            }), {
              props: n,
              attrs: r
            };
          },
          parseStyle: function parseStyle(t) {
            for (var e = {}, n = t.split(";"), r = 0, i = n.length; r < i; r++) {
              var o = n[r].trim();
              if (o) {
                var a = o.split(":");
                e[a[0].trim()] = a.slice(1).join(":").trim();
              }
            }
            return e;
          },
          parseClass: function parseClass(t) {
            for (var e = [], n = t.split(" "), r = 0, i = n.length; r < i; r++) {
              var o = n[r].trim();
              o && e.push(o);
            }
            return e;
          },
          parseNode: function parseNode(n) {
            for (var r = [], o = n.childNodes, a = 0, s = o.length; a < s; a++) {
              var c = o[a],
                l = c.attributes || [],
                u = l.length,
                d = r[r.length - 1],
                h = c.childNodes.length,
                f = this.compTypes,
                p = {};
              if (f) {
                var g = "",
                  v = c.getAttribute && c.getAttribute("".concat("data-gjs-", "type"));
                if (v) p = {
                  type: v
                };else {
                  for (var m = 0; m < f.length; m++) {
                    var b = f[m];
                    if (g = b.model.isComponent(c)) {
                      "object" !== i()(g) && (g = {
                        type: b.id
                      });
                      break;
                    }
                  }
                  p = g;
                }
              }
              p.tagName || (p.tagName = c.tagName ? c.tagName.toLowerCase() : ""), u && (p.attributes = {});
              for (var y = 0; y < u; y++) {
                var w = l[y].nodeName,
                  x = l[y].nodeValue;
                if ("style" == w) p.style = this.parseStyle(x);else if ("class" == w) p.classes = this.parseClass(x);else {
                  if ("contenteditable" == w) continue;
                  if (0 === w.indexOf("data-gjs-")) {
                    var O = w.replace("data-gjs-", ""),
                      C = x.length,
                      S = x && x.substr(0, 1),
                      k = x && x.substr(C - 1);
                    x = "false" !== (x = "true" === x || x) && x;
                    try {
                      x = "{" == S && "}" == k || "[" == S && "]" == k ? JSON.parse(x) : x;
                    } catch (t) {}
                    p[O] = x;
                  } else "" === x && !0 === c[w] && (x = !0), p.attributes[w] = x;
                }
              }
              if (h && !p.components) {
                var T = c.childNodes[0];
                1 === h && 3 === T.nodeType ? (!p.type && (p.type = "text"), p.content = T.nodeValue) : p.components = this.parseNode(c);
              }
              if ("textnode" == p.type) {
                if (d && "textnode" == d.type) {
                  d.content += p.content;
                  continue;
                }
                if (!t.keepEmptyTextNodes) {
                  var j = c.nodeValue;
                  if (" " != j && !j.trim()) continue;
                }
              }
              var E = p.components;
              if (!p.type && E) {
                for (var P = 1, A = 0, M = 0; M < E.length; M++) {
                  var D = E[M],
                    L = D.type;
                  if (["text", "textnode"].indexOf(L) < 0 && e.textTags.indexOf(D.tagName) < 0) {
                    P = 0;
                    break;
                  }
                  "textnode" == L && (A = 1);
                }
                P && A && (p.type = "text");
              }
              (p.tagName || "textnode" == p.type) && r.push(p);
            }
            return r;
          },
          parse: function parse(t, n) {
            var r = e.em && e.em.get("Config") || {},
              i = {
                html: "",
                css: ""
              },
              o = document.createElement("div");
            o.innerHTML = t;
            var a = o.querySelectorAll("script"),
              s = a.length;
            if (!r.allowScripts) for (; s--;) a[s].parentNode.removeChild(a[s]);
            if (n) {
              for (var c = "", l = o.querySelectorAll("style"), u = l.length; u--;) c = l[u].innerHTML + c, l[u].parentNode.removeChild(l[u]);
              c && (i.css = n.parse(c));
            }
            var d = this.parseNode(o);
            return 1 == d.length && (d = d[0]), i.html = d, i;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      var r = n(0),
        i = n(1),
        o = n.n(i),
        a = o.a.Model,
        s = o.a.View;
      e.a = {
        types: [],
        initialize: function initialize(t, e) {
          var n = this;
          this.model = function () {
            var t,
              e,
              r,
              i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (i && i.type) {
              var a = n.getBaseType();
              t = (r = n.getType(i.type)) ? r.model : a.model, e = r ? r.view : a.view;
            } else {
              var s = n.recognizeType(i);
              t = (r = s.type).model, e = r.view, i = s.attributes;
            }
            var c = new t(i, o);
            return c.typeView = e, c;
          };
          var r = this.init && this.init.bind(this);
          r && r();
        },
        recognizeType: function recognizeType(t) {
          for (var e = this.getTypes(), n = 0; n < e.length; n++) {
            var r = e[n],
              i = r.isType(t);
            if (i = "boolean" == typeof i && i ? {
              type: r.id
            } : i) return {
              type: r,
              attributes: i
            };
          }
          return {
            type: this.getBaseType(),
            attributes: t
          };
        },
        getBaseType: function getBaseType() {
          var t = this.getTypes();
          return t[t.length - 1];
        },
        getTypes: function getTypes() {
          return this.types;
        },
        getType: function getType(t) {
          for (var e = this.getTypes(), n = 0; n < e.length; n++) {
            var r = e[n];
            if (r.id === t) return r;
          }
        },
        addType: function addType(t, e) {
          var n = this.getType(t),
            i = this.getBaseType(),
            o = n ? n.model : i.model,
            c = n ? n.view : i.view,
            l = e.model,
            u = e.view,
            d = e.isType;
          l = l instanceof a || Object(r.isFunction)(l) ? l : o.extend(l || {}), u = u instanceof s || Object(r.isFunction)(u) ? u : c.extend(u || {}), !this.extendViewApi || e.model || e.view || (u = u.extend(e)), n ? (n.model = l, n.view = u, n.isType = d || n.isType) : (e.id = t, e.model = l, e.view = u, e.isType = d || function (e) {
            if (e && e.type == t) return !0;
          }, this.getTypes().unshift(e));
        }
      };
    }, function (t, e, n) {
      "use strict";

      var r = n(1),
        i = n.n(r),
        o = n(0),
        a = Number.MAX_VALUE;
      e.a = i.a.Model.extend({
        initialize: function initialize() {
          this.compCls = [], this.ids = [];
        },
        buildFromModel: function buildFromModel(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = "",
            i = this.em,
            o = i && i.getConfig("avoidInlineStyle"),
            a = t.styleToString(),
            s = t.get("classes"),
            c = n.wrapperIsBody,
            l = t.get("wrapper");
          if (this.ids.push("#".concat(t.getId())), s.each(function (t) {
            return e.compCls.push(t.getFullName());
          }), !o && a) {
            var u = "#".concat(t.getId());
            r = "".concat(u = c && l ? "body" : u, "{").concat(a, "}");
          }
          var d = t.components();
          return d.each(function (t) {
            return r += e.buildFromModel(t, n);
          }), r;
        },
        build: function build(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = n.cssc,
            i = n.em || "";
          this.em = i, this.compCls = [], this.ids = [];
          var a = this.buildFromModel(t, n),
            s = Object(o.isUndefined)(n.clearStyles) && i ? i.getConfig("clearStyles") : n.clearStyles;
          if (r) {
            var c = r.getAll(),
              l = {},
              u = [];
            c.each(function (t) {
              var r = t.getAtRule();
              if (r) {
                var i = l[r];
                i ? i.push(t) : l[r] = [t];
              } else a += e.buildFromRule(t, u, n);
            }), this.sortMediaObject(l).forEach(function (t) {
              var r = "",
                i = t.key;
              t.value.forEach(function (t) {
                var o = e.buildFromRule(t, u, n);
                t.get("singleAtRule") ? a += "".concat(i, "{").concat(o, "}") : r += o;
              }), r && (a += "".concat(i, "{").concat(r, "}"));
            }), i && s && c.remove(u);
          }
          return a;
        },
        buildFromRule: function buildFromRule(t, e) {
          var n,
            r = this,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = "",
            a = t.selectorsToString({
              skipAdd: 1
            }),
            s = t.get("selectorsAdd"),
            c = t.get("singleAtRule");
          if (t.get("selectors").each(function (t) {
            var e = t.getFullName();
            (r.compCls.indexOf(e) >= 0 || r.ids.indexOf(e) >= 0 || i.keepUnusedStyles) && (n = 1);
          }), a && n || s || c) {
            var l = t.getDeclaration();
            l && (o += l);
          } else e.push(t);
          return o;
        },
        getQueryLength: function getQueryLength(t) {
          var e = /(-?\d*\.?\d+)\w{0,}/.exec(t);
          return e ? parseFloat(e[1]) : a;
        },
        sortMediaObject: function sortMediaObject() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = [];
          return Object(o.each)(e, function (t, e) {
            return n.push({
              key: e,
              value: t
            });
          }), n.sort(function (e, n) {
            var r = [e.key, n.key].every(function (t) {
                return -1 !== t.indexOf("min-width");
              }),
              i = r ? e.key : n.key,
              o = r ? n.key : e.key;
            return t.getQueryLength(i) - t.getQueryLength(o);
          });
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(1),
        i = n.n(r),
        o = n(0),
        a = n(3),
        s = n(18);
      i.a.$, e.a = s.a.extend({
        events: {
          "change input": "handleChange",
          "change select": "handleUnitChange",
          "click [data-arrow-up]": "upArrowClick",
          "click [data-arrow-down]": "downArrowClick",
          "mousedown [data-arrows]": "downIncrement"
        },
        template: function template() {
          var t = this.ppfx;
          return '\n      <span class="'.concat(t, 'input-holder"></span>\n      <span class="').concat(t, 'field-units"></span>\n      <div class="').concat(t, 'field-arrows" data-arrows>\n        <div class="').concat(t, 'field-arrow-u" data-arrow-up></div>\n        <div class="').concat(t, 'field-arrow-d" data-arrow-down></div>\n      </div>\n    ');
        },
        inputClass: function inputClass() {
          var t = this.ppfx;
          return this.opts.contClass || "".concat(t, "field ").concat(t, "field-integer");
        },
        initialize: function initialize() {
          s.a.prototype.initialize.apply(this, arguments), Object(o.bindAll)(this, "moveIncrement", "upIncrement"), this.doc = document, this.listenTo(this.model, "change:unit", this.handleModelChange);
        },
        setValue: function setValue(t, e) {
          var n = e || {},
            r = this.validateInputValue(t, {
              deepCheck: 1
            }),
            i = {
              value: r.value
            };
          (r.unit || r.force) && (i.unit = r.unit), this.model.set(i, n), n.silent && this.handleModelChange();
        },
        handleChange: function handleChange(t) {
          t.stopPropagation(), this.setValue(this.getInputEl().value), this.elementUpdated();
        },
        handleUnitChange: function handleUnitChange(t) {
          t.stopPropagation();
          var e = this.getUnitEl().value;
          this.model.set("unit", e), this.elementUpdated();
        },
        elementUpdated: function elementUpdated() {
          this.model.trigger("el:change");
        },
        handleModelChange: function handleModelChange() {
          var t = this.model;
          this.getInputEl().value = t.get("value");
          var e = this.getUnitEl();
          e && (e.value = t.get("unit") || "");
        },
        getUnitEl: function getUnitEl() {
          if (!this.unitEl) {
            var t = this.model,
              e = t.get("units") || [];
            if (e.length) {
              var n = [];
              e.forEach(function (e) {
                var r = e == t.get("unit") ? "selected" : "";
                n.push("<option ".concat(r, ">").concat(e, "</option>"));
              });
              var r = document.createElement("div");
              r.innerHTML = '<select class="'.concat(this.ppfx, 'input-unit">').concat(n.join(""), "</select>"), this.unitEl = r.firstChild;
            }
          }
          return this.unitEl;
        },
        upArrowClick: function upArrowClick() {
          var t = this.model,
            e = t.get("step"),
            n = parseInt(t.get("value"), 10);
          n = this.normalizeValue(n + e);
          var r = this.validateInputValue(n);
          t.set("value", r.value), this.elementUpdated();
        },
        downArrowClick: function downArrowClick() {
          var t = this.model,
            e = t.get("step"),
            n = parseInt(t.get("value"), 10),
            r = this.normalizeValue(n - e),
            i = this.validateInputValue(r);
          t.set("value", i.value), this.elementUpdated();
        },
        downIncrement: function downIncrement(t) {
          t.preventDefault(), this.moved = 0;
          var e = this.model.get("value");
          e = this.normalizeValue(e), this.current = {
            y: t.pageY,
            val: e
          }, Object(a.u)(this.doc, "mousemove", this.moveIncrement), Object(a.u)(this.doc, "mouseup", this.upIncrement);
        },
        moveIncrement: function moveIncrement(t) {
          this.moved = 1;
          var e = this.model,
            n = e.get("step"),
            r = this.current,
            i = this.normalizeValue(r.val + (r.y - t.pageY) * n);
          return this.prValue = this.validateInputValue(i).value, e.set("value", this.prValue, {
            avoidStore: 1
          }), !1;
        },
        upIncrement: function upIncrement() {
          var t = this.model,
            e = t.get("step");
          if (Object(a.t)(this.doc, "mouseup", this.upIncrement), Object(a.t)(this.doc, "mousemove", this.moveIncrement), this.prValue && this.moved) {
            var n = this.prValue - e;
            t.set("value", n, {
              avoidStore: 1
            }).set("value", n + e), this.elementUpdated();
          }
        },
        normalizeValue: function normalizeValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = this.model,
            r = n.get("step"),
            i = 0;
          if (isNaN(t)) return e;
          if (t = parseFloat(t), Math.floor(t) !== t) {
            var o = r.toString().split(".")[1];
            i = o ? o.length : 0;
          }
          return i ? parseFloat(t.toFixed(i)) : t;
        },
        validateInputValue: function validateInputValue(t, e) {
          var n = 0,
            r = e || {},
            i = this.model,
            a = Object(o.isUndefined)(t) ? "" : t,
            s = i.get("units") || [],
            c = i.get("unit") || s.length && s[0] || "",
            l = i.get("max"),
            u = i.get("min");
          if (r.deepCheck) {
            var d = i.get("fixedValues") || [];
            if (a) {
              var h = new RegExp("^" + d.join("|"), "g");
              if (d.length && h.test(a)) a = a.match(h)[0], c = "", n = 1;else {
                var f = a + "";
                a += "", a = parseFloat(a.replace(",", ".")), a = isNaN(a) ? "" : a;
                var p = f.replace(a, "");
                Object(o.indexOf)(s, p) >= 0 && (c = p);
              }
            }
          }
          return Object(o.isUndefined)(l) || "" === l || (a = a > l ? l : a), Object(o.isUndefined)(u) || "" === u || (a = a < u ? u : a), {
            force: n,
            value: a,
            unit: c
          };
        },
        render: function render() {
          s.a.prototype.render.call(this), this.unitEl = null;
          var t = this.getUnitEl();
          return t && this.$el.find(".".concat(this.ppfx, "field-units")).get(0).appendChild(t), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(1),
        i = n.n(r),
        o = n(34);
      e.a = i.a.Collection.extend({
        model: o.a,
        initialize: function initialize(t, e) {
          var n = this;
          e && e.em && (this.editor = e.em), setTimeout(function () {
            n.on("remove", n.onRemove), n.on("add", n.onAdd);
          });
        },
        onAdd: function onAdd(t) {
          t.ensureSelectors();
        },
        onRemove: function onRemove(t) {
          var e = this.editor;
          e.stopListening(t), e.get("UndoManager").remove(t);
        },
        add: function add(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" == typeof t && (t = this.editor.get("Parser").parseCss(t)), e.em = this.editor, i.a.Collection.prototype.add.apply(this, [t, e]);
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(0),
        i = n(1),
        o = n.n(i),
        a = n(23),
        s = n(12),
        c = window.CSS;
      e.a = o.a.Model.extend(a.a).extend({
        defaults: {
          selectors: [],
          selectorsAdd: "",
          style: {},
          mediaText: "",
          state: "",
          stylable: !0,
          atRuleType: "",
          singleAtRule: 0,
          important: 0
        },
        initialize: function initialize(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.config = t || {}, this.em = e.em, this.ensureSelectors();
        },
        ensureSelectors: function ensureSelectors() {
          var t = this.em,
            e = [],
            n = t && t.get("SelectorManager"),
            r = this.getSelectors(),
            i = Array.isArray(r);
          r.forEach(function (t) {
            return e.push(n ? n.add(t) : t);
          }), i && this.set("selectors", new s.a(e));
        },
        getAtRule: function getAtRule() {
          var t = this.get("atRuleType"),
            e = this.get("mediaText"),
            n = t ? "@".concat(t) : e ? "@media" : "";
          return n + (e && n ? " ".concat(e) : "");
        },
        selectorsToString: function selectorsToString() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = [],
            n = this.em,
            r = this.get("state"),
            i = this.get("wrapper"),
            o = this.get("selectorsAdd"),
            a = i && n && n.getConfig("wrapperIsBody"),
            s = {
              escape: function escape(t) {
                return c && c.escape ? c.escape(t) : t;
              }
            },
            l = a ? "body" : this.get("selectors").getFullString(0, s),
            u = r && !t.skipState ? ":".concat(r) : "";
          return l && e.push("".concat(l).concat(u)), o && !t.skipAdd && e.push(o), e.join(", ");
        },
        getDeclaration: function getDeclaration() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = "",
            n = this.selectorsToString(),
            r = this.styleToString(t),
            i = this.get("singleAtRule");
          return (n || i) && r && (e = i ? r : "".concat(n, "{").concat(r, "}")), e;
        },
        toCSS: function toCSS() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = "",
            n = this.getAtRule(),
            r = this.getDeclaration(t);
          return r && (e = r), n && e && (e = "".concat(n, "{").concat(e, "}")), e;
        },
        toJSON: function toJSON() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          var i = o.a.Model.prototype.toJSON.apply(this, e);
          if (this.em.getConfig("avoidDefaults")) {
            var a = this.defaults;
            Object(r.forEach)(a, function (t, e) {
              i[e] === t && delete i[e];
            }), Object(r.isEmpty)(i.selectors) && delete i.selectors, Object(r.isEmpty)(i.style) && delete i.style;
          }
          return i;
        },
        compare: function compare(t, e, n) {
          var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            o = e || "",
            a = n || "",
            s = i.selectorsAdd || "",
            c = i.atRuleType || "";
          t instanceof Array || t.models || (t = [t]);
          var l = Object(r.map)(t.models || t, function (t) {
              return t.get("name");
            }),
            u = Object(r.map)(this.get("selectors").models, function (t) {
              return t.get("name");
            }),
            d = !1;
          if (l.length !== u.length) return d;
          for (var h = 0; h < l.length; h++) {
            for (var f = 0, p = 0; p < u.length; p++) l[h] === u[p] && (f = 1);
            if (0 === f) return d;
          }
          return this.get("state") === o && this.get("mediaText") === a && this.get("selectorsAdd") === s && this.get("atRuleType") === c || d;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(1),
        i = n.n(r),
        o = n(0);
      e.a = i.a.View.extend({
        initialize: function initialize(t) {
          this.opts = t || {}, this.config = t.config || {}, this.em = this.config.em;
          var e = this.collection;
          this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.resetChildren), this.listenTo(e, "remove", this.removeChildren);
        },
        removeChildren: function removeChildren(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t.views.forEach(function (t) {
            if (t) {
              var e = t.childrenView,
                n = t.scriptContainer;
              e && e.stopListening(), n && n.remove(), t.remove.apply(t);
            }
          });
          var i = t.components();
          i.forEach(function (t) {
            return n.removeChildren(t, e, r);
          });
        },
        addTo: function addTo(t) {
          var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = this.config.em,
            r = this.collection.indexOf(t);
          if (this.addToCollection(t, null, r), n && !e.temporary) {
            var i = function t(e) {
              n.trigger("component:add", e), e.components().forEach(function (e) {
                return t(e);
              });
            };
            i(t);
          }
        },
        addToCollection: function addToCollection(t, e, r) {
          this.compView || (this.compView = n(6).default);
          for (var i = this.config, a = this.opts, s = this.em, c = e || null, l = i.frameView, u = void 0 === l ? {} : l, d = u.model && t.getView(u.model), h = a.componentTypes || s && s.get("DomComponents").getTypes(), f = t.get("type"), p = this.compView, g = 0; g < h.length; g++) if (h[g].id == f) {
            p = h[g].view;
            break;
          }
          var v,
            m = d || new p({
              model: t,
              config: i,
              componentTypes: h
            });
          try {
            v = m.render().el;
          } catch (t) {
            v = document.createTextNode(""), s.logError(t);
          }
          if (c) c.appendChild(v);else {
            var b = this.parentEl,
              y = b.childNodes;
            if (Object(o.isUndefined)(r)) b.appendChild(v);else {
              var w = y.length == r;
              w && r--, w || !y.length ? b.appendChild(v) : b.insertBefore(v, y[r]);
            }
          }
          return v;
        },
        resetChildren: function resetChildren(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = n.previousModels,
            i = void 0 === r ? [] : r;
          this.parentEl.innerHTML = "", i.forEach(function (t) {
            return e.removeChildren(t, e.collection);
          }), t.each(function (t) {
            return e.addToCollection(t);
          });
        },
        render: function render(t) {
          var e = this,
            n = this.el,
            r = document.createDocumentFragment();
          return this.parentEl = t || this.el, this.collection.each(function (t) {
            return e.addToCollection(t, r);
          }), n.innerHTML = "", n.appendChild(r), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r,
        i = n(0),
        o = n(3),
        a = n(1),
        s = n.n(a),
        c = n(6),
        l = n(5),
        u = s.a.$;
      e.a = s.a.View.extend({
        events: {
          "mousedown [data-toggle-move]": "startSort",
          "touchstart [data-toggle-move]": "startSort",
          "click [data-toggle-visible]": "toggleVisibility",
          "click [data-toggle-select]": "handleSelect",
          "mouseover [data-toggle-select]": "handleHover",
          "click [data-toggle-open]": "toggleOpening",
          "dblclick [data-name]": "handleEdit",
          "focusout [data-name]": "handleEditEnd"
        },
        template: function template(t) {
          var e = this.pfx,
            n = this.ppfx,
            r = this.config,
            i = this.clsNoEdit,
            o = r.hidable,
            a = this.countChildren(t),
            s = a ? "" : this.clsNoChild,
            c = "".concat(this.clsTitle, " ").concat(s),
            l = "".concat(this.clsTitleC, " ").concat(n, "one-bg"),
            u = "".concat(this.clsCaret, " fa fa-chevron-right"),
            d = "".concat(this.inputNameCls, " ").concat(i, " ").concat(n, "no-app"),
            h = this.level + 1,
            f = "".concat(30 + 10 * h, "px"),
            p = t.getName(),
            g = t.getIcon();
          return "".concat(e, "layer"), "\n      ".concat(o ? '<i class="'.concat(e, "layer-vis fa fa-eye ").concat(this.isVisible() ? "" : "fa-eye-slash", '" data-toggle-visible></i>') : "", '\n      <div class="').concat(l, '">\n        <div class="').concat(c, '" title="').concat(p, '" style="padding-left: ').concat(f, '" data-toggle-select>\n          <div class="').concat(e, 'layer-title-inn">\n            <i class="').concat(u, '" data-toggle-open></i>\n            <span class="').concat(d, '" data-name> \n             ').concat(g ? "".concat(g) : "", " &nbsp;").concat(p, '\n            </span>\n          </div>\n        </div>\n      </div>\n      <div class="').concat(this.clsCount, '" data-count>').concat(a || "", '</div>\n      <div class="').concat(this.clsMove, '" data-toggle-move>\n        <i class="fa fa-arrows"></i>\n      </div>\n      <div class="').concat(this.clsChildren, '"></div>');
        },
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.opt = t, this.level = t.level, this.config = t.config, this.em = t.config.em, this.ppfx = this.em.get("Config").stylePrefix, this.sorter = t.sorter || "", this.pfx = this.config.stylePrefix, this.parentView = t.parentView;
          var e = this.pfx,
            n = this.ppfx,
            r = this.model,
            i = r.get("components"),
            o = r.get("type") || "default";
          r.set("open", !1), this.listenTo(i, "remove add reset", this.checkChildren), this.listenTo(r, "change:status", this.updateStatus), this.listenTo(r, "change:open", this.updateOpening), this.listenTo(r, "change:layerable", this.updateLayerable), this.listenTo(r, "change:style:display", this.updateVisibility), this.className = "".concat(e, "layer ").concat(e, "layer__t-").concat(o, " no-select ").concat(n, "two-color"), this.inputNameCls = "".concat(n, "layer-name"), this.clsTitleC = "".concat(e, "layer-title-c"), this.clsTitle = "".concat(e, "layer-title"), this.clsCaret = "".concat(e, "layer-caret"), this.clsCount = "".concat(e, "layer-count"), this.clsMove = "".concat(e, "layer-move"), this.clsChildren = "".concat(e, "layer-children"), this.clsNoChild = "".concat(e, "layer-no-chld"), this.clsEdit = "".concat(this.inputNameCls, "--edit"), this.clsNoEdit = "".concat(this.inputNameCls, "--no-edit"), this.$el.data("model", r), this.$el.data("collection", i), r.viewLayer = this;
        },
        getVisibilityEl: function getVisibilityEl() {
          return this.eyeEl || (this.eyeEl = this.$el.children(".".concat(this.pfx, "layer-vis"))), this.eyeEl;
        },
        updateVisibility: function updateVisibility() {
          var t = this.pfx,
            e = this.model,
            n = "".concat(t, "layer-hidden"),
            r = "none" === e.getStyle().display ? "addClass" : "removeClass";
          this.$el[r](n), this.getVisibilityEl()[r]("fa-eye-slash");
        },
        toggleVisibility: function toggleVisibility(t) {
          t && t.stopPropagation();
          var e = this.model,
            n = this.em,
            r = e.get("__prev-display"),
            i = e.getStyle(),
            o = i.display;
          "none" == o ? (delete i.display, r && (i.display = r, e.unset("__prev-display"))) : (o && e.set("__prev-display", o), i.display = "none"), e.setStyle(i), n && n.trigger("component:toggled");
        },
        handleEdit: function handleEdit(t) {
          t && t.stopPropagation();
          var e = this.em,
            n = this.$el,
            r = this.clsNoEdit,
            i = this.clsEdit,
            o = this.getInputName();
          o.contentEditable = !0, o.focus(), e && e.setEditing(1), n.find(".".concat(this.inputNameCls)).removeClass(r).addClass(i);
        },
        handleEditEnd: function handleEditEnd(t) {
          t && t.stopPropagation();
          var e = this.em,
            n = this.$el,
            r = this.clsNoEdit,
            i = this.clsEdit,
            o = this.getInputName(),
            a = o.textContent;
          o.scrollLeft = 0, o.contentEditable = !1, this.model.set({
            "custom-name": a
          }), e && e.setEditing(0), n.find(".".concat(this.inputNameCls)).addClass(r).removeClass(i);
        },
        getInputName: function getInputName() {
          return this.inputName || (this.inputName = this.el.querySelector(".".concat(this.inputNameCls))), this.inputName;
        },
        updateOpening: function updateOpening() {
          var t = this.opt.opened || {},
            e = this.model;
          e.get("open") ? (this.$el.addClass("open"), this.getCaret().addClass("fa-chevron-down"), t[e.cid] = e) : (this.$el.removeClass("open"), this.getCaret().removeClass("fa-chevron-down"), delete t[e.cid]);
        },
        toggleOpening: function toggleOpening(t) {
          t.stopPropagation(), this.model.get("components").length && this.model.set("open", !this.model.get("open"));
        },
        handleSelect: function handleSelect(t) {
          t.stopPropagation();
          var e = this.em,
            n = this.config;
          if (e) {
            var r = this.model;
            e.setSelected(r, {
              fromLayers: 1
            });
            var i = n.scrollCanvas;
            i && r.views.forEach(function (t) {
              return t.scrollIntoView(i);
            });
          }
        },
        handleHover: function handleHover(t) {
          t.stopPropagation();
          var e = this.em,
            n = this.config,
            r = this.model;
          e && n.showHover && e.setHovered(r, {
            fromLayers: 1
          });
        },
        startSort: function startSort(t) {
          t.stopPropagation();
          var e = this.em,
            n = this.sorter;
          t.button && 0 !== t.button || n && (n.onStart = function (t) {
            return e.trigger("".concat(l.eventDrag, ":start"), t);
          }, n.onMoveClb = function (t) {
            return e.trigger(l.eventDrag, t);
          }, n.startSort(t.target));
        },
        freeze: function freeze() {
          this.$el.addClass(this.pfx + "opac50"), this.model.set("open", 0);
        },
        unfreeze: function unfreeze() {
          this.$el.removeClass(this.pfx + "opac50");
        },
        updateStatus: function updateStatus(t) {
          c.default.prototype.updateStatus.apply(this, [{
            avoidHover: !this.config.highlightHover
          }]);
        },
        isVisible: function isVisible() {
          var t = this.model.getStyle().display;
          return !(t && "none" === t);
        },
        checkChildren: function checkChildren() {
          var t = this.model,
            e = this.clsNoChild,
            n = this.countChildren(t),
            r = this.$el.children(".".concat(this.clsTitleC)).children(".".concat(this.clsTitle)),
            i = this.cnt;
          i || (i = this.$el.children("[data-count]").get(0), this.cnt = i), r[n ? "removeClass" : "addClass"](e), i && (i.innerHTML = n || ""), !n && t.set("open", 0);
        },
        countChildren: function countChildren(t) {
          var e = 0;
          return t.get("components").each(function (t) {
            var n = this.opt.isCountable,
              r = this.config.hideTextnode;
            n && !n(t, r) || e++;
          }, this), e;
        },
        getCaret: function getCaret() {
          return this.caret && this.caret.length || (this.pfx, this.caret = this.$el.children(".".concat(this.clsTitleC)).find(".".concat(this.clsCaret))), this.caret;
        },
        setRoot: function setRoot(t) {
          t = Object(i.isString)(t) ? this.em.getWrapper().find(t)[0] : t;
          var e = Object(o.g)(t, u);
          e && (this.stopListening(), this.model = e, this.initialize(this.opt), this.render());
        },
        updateLayerable: function updateLayerable() {
          (this.parentView || this).render();
        },
        render: function render() {
          var t = this.model,
            e = this.config,
            o = this.pfx,
            a = this.ppfx,
            s = this.opt.isCountable,
            c = s && !s(t, e.hideTextnode),
            l = this.isVisible(),
            u = this.$el.empty(),
            d = this.level + 1;
          Object(i.isUndefined)(r) && (r = n(98).default);
          var h = new r({
            collection: t.get("components"),
            config: this.config,
            sorter: this.sorter,
            opened: this.opt.opened,
            parentView: this,
            parent: t,
            level: d
          }).render().$el;
          return this.config.showWrapper || 1 !== d ? (u.html(this.template(t)), u.find(".".concat(this.clsChildren)).append(h)) : u.append(h), t.get("draggable") && this.config.sortable || u.children(".".concat(this.clsMove)).remove(), !l && (this.className += " ".concat(o, "hide")), c && (this.className += " ".concat(a, "hidden")), u.attr("class", this.className), this.updateOpening(), this.updateStatus(), this.updateVisibility(), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(1),
        i = n.n(r),
        o = i.a.View.extend({
          tagName: "style",
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = t.config || {};
            var e = this.model,
              n = "change:style change:state change:mediaText";
            this.listenTo(e, n, this.render), this.listenTo(e, "destroy remove", this.remove), this.listenTo(e.get("selectors"), "change", this.render);
          },
          render: function render() {
            var t = this.model.get("important");
            return this.el.innerHTML = this.model.toCSS({
              important: t
            }), this;
          }
        }),
        a = o.extend({
          _createElement: function _createElement(t) {
            return document.createTextNode("");
          },
          render: function render() {
            var t = this.model,
              e = t.get("important");
            return this.el.textContent = t.getDeclaration({
              important: e
            }), this;
          }
        }),
        s = i.a.$,
        c = function c(t, e) {
          return "".concat(t).concat(e ? "-".concat(parseFloat(e)) : "");
        };
      e.a = i.a.View.extend({
        initialize: function initialize(t) {
          var e = t.config || {};
          this.atRules = {}, this.config = e, this.em = e.em, this.pfx = e.stylePrefix || "", this.className = this.pfx + "rules";
          var n = this.collection;
          this.listenTo(n, "add", this.addTo), this.listenTo(n, "reset", this.render);
        },
        addTo: function addTo(t) {
          this.addToCollection(t);
        },
        addToCollection: function addToCollection(t, e) {
          if (this.renderStarted) {
            var n,
              r,
              i = e || null,
              s = {
                model: t,
                config: this.config
              };
            if ("keyframes" === t.get("atRuleType")) {
              var l = t.getAtRule(),
                u = this.atRules[l];
              if (!u) {
                var d = document.createElement("style");
                u = document.createTextNode(""), d.appendChild(document.createTextNode("".concat(l, "{"))), d.appendChild(u), d.appendChild(document.createTextNode("}")), this.atRules[l] = u, n = d;
              }
              r = new a(s), u.appendData(r.render().el.textContent);
            } else n = (r = new o(s)).render().el;
            var h = this.className,
              f = t.get("mediaText"),
              p = c(h),
              g = p;
            if (f && (g = c(h, this.getMediaWidth(f))), n) {
              var v,
                m = i || this.el;
              try {
                v = m.querySelector("#".concat(g));
              } catch (t) {}
              v || (v = m.querySelector("#".concat(p))), v.appendChild(n);
            }
            return n;
          }
        },
        getMediaWidth: function getMediaWidth(t) {
          return t && t.replace("(".concat(this.em.getConfig("mediaCondition"), ": "), "").replace(")", "");
        },
        render: function render() {
          var t = this;
          this.renderStarted = 1, this.atRules = {};
          var e = this.em,
            n = this.$el,
            r = this.className,
            i = this.collection,
            o = document.createDocumentFragment();
          n.empty();
          var a = e.get("DeviceManager").getAll().pluck("priority");
          return a.every(function (t) {
            return t;
          }) && a.unshift(0), a.forEach(function (t) {
            return s('<div id="'.concat(c(r, t), '"></div>')).appendTo(o);
          }), i.each(function (e) {
            return t.addToCollection(e, o);
          }), n.append(o), n.attr("class", r), this;
        }
      });
    }, function (t, e, n) {
      "use strict";

      var r = n(2),
        i = n.n(r),
        o = n(1),
        a = n.n(o),
        s = n(0),
        c = n(8),
        l = n.n(c),
        u = n(18);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var f = a.a.$;
      !function (t, e) {
        var n = {
            beforeShow: d,
            move: d,
            change: d,
            show: d,
            hide: d,
            color: !1,
            flat: !1,
            showInput: !1,
            allowEmpty: !1,
            showButtons: !0,
            clickoutFiresChange: !0,
            showInitial: !1,
            showPalette: !1,
            showPaletteOnly: !1,
            hideAfterPaletteSelect: !1,
            togglePaletteOnly: !1,
            showSelectionPalette: !0,
            localStorageKey: !1,
            appendTo: "body",
            maxSelectionSize: 7,
            cancelText: "cancel",
            chooseText: "choose",
            togglePaletteMoreText: "more",
            togglePaletteLessText: "less",
            clearText: "Clear Color Selection",
            noColorSelectedText: "No Color Selected",
            preferredFormat: !1,
            className: "",
            containerClassName: "",
            replacerClassName: "",
            showAlpha: !1,
            theme: "sp-light",
            palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
            selectionPalette: [],
            disabled: !1,
            offset: null
          },
          r = [],
          i = !!/msie/i.exec(window.navigator.userAgent),
          o = function () {
            function t(t, e) {
              return !!~("" + t).indexOf(e);
            }
            var e = document.createElement("div").style;
            return e.cssText = "background-color:rgba(0,0,0,.5)", t(e.backgroundColor, "rgba") || t(e.backgroundColor, "hsla");
          }(),
          a = ["<div class='sp-replacer'>", "<div class='sp-preview'><div class='sp-preview-inner'></div></div>", "<div class='sp-dd'>&#9660;</div>", "</div>"].join(""),
          s = function () {
            var t = "";
            if (i) for (var e = 1; e <= 6; e++) t += "<div class='sp-" + e + "'></div>";
            return ["<div class='sp-container sp-hidden'>", "<div class='sp-palette-container'>", "<div class='sp-palette sp-thumb sp-cf'></div>", "<div class='sp-palette-button-container sp-cf'>", "<button type='button' class='sp-palette-toggle'></button>", "</div>", "</div>", "<div class='sp-picker-container'>", "<div class='sp-top sp-cf'>", "<div class='sp-fill'></div>", "<div class='sp-top-inner'>", "<div class='sp-color'>", "<div class='sp-sat'>", "<div class='sp-val'>", "<div class='sp-dragger'></div>", "</div>", "</div>", "</div>", "<div class='sp-clear sp-clear-display'>", "</div>", "<div class='sp-hue'>", "<div class='sp-slider'></div>", t, "</div>", "</div>", "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>", "</div>", "<div class='sp-input-container sp-cf'>", "<input class='sp-input' type='text' spellcheck='false'  />", "</div>", "<div class='sp-initial sp-thumb sp-cf'></div>", "<div class='sp-button-container sp-cf'>", "<a class='sp-cancel' href='#'></a>", "<button type='button' class='sp-choose'></button>", "</div>", "</div>", "</div>"].join("");
          }();
        function c(e, n, r, i) {
          for (var a = [], s = 0; s < e.length; s++) {
            var c = e[s];
            if (c) {
              var l = k(c),
                u = l.toHsl().l < .5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
              u += k.equals(n, c) ? " sp-thumb-active" : "";
              var d = l.toString(i.preferredFormat || "rgb"),
                h = o ? "background-color:" + l.toRgbString() : "filter:" + l.toFilter();
              a.push('<span title="' + d + '" data-color="' + l.toRgbString() + '" class="' + u + '"><span class="sp-thumb-inner" style="' + h + ';"></span></span>');
            } else a.push(t("<div />").append(t('<span data-color="" style="background-color:transparent;" class="sp-clear-display"></span>').attr("title", i.noColorSelectedText)).html());
          }
          return "<div class='sp-cf " + r + "'>" + a.join("") + "</div>";
        }
        function u(l, u) {
          var d,
            v,
            m,
            b,
            y = function (e, r) {
              var i = t.extend({}, n, e);
              return i.callbacks = {
                move: f(i.move, r),
                change: f(i.change, r),
                show: f(i.show, r),
                hide: f(i.hide, r),
                beforeShow: f(i.beforeShow, r)
              }, i;
            }(u, l),
            w = y.flat,
            x = y.showSelectionPalette,
            O = y.localStorageKey,
            C = y.theme,
            S = y.callbacks,
            T = (d = Ut, v = 10, function () {
              var t = this,
                e = arguments,
                n = function n() {
                  b = null, d.apply(t, e);
                };
              m && clearTimeout(b), !m && b || (b = setTimeout(n, v));
            }),
            j = !1,
            E = !1,
            P = 0,
            A = 0,
            M = 0,
            D = 0,
            L = 0,
            _ = 0,
            N = 0,
            I = 0,
            R = 0,
            F = 0,
            V = 1,
            z = [],
            H = [],
            B = {},
            U = y.selectionPalette.slice(0),
            $ = y.maxSelectionSize,
            W = null,
            q = l.ownerDocument,
            G = (q.body, t(l)),
            Y = !1,
            K = t(s, q).addClass(C),
            X = K.find(".sp-picker-container"),
            J = K.find(".sp-color"),
            Z = K.find(".sp-dragger"),
            Q = K.find(".sp-hue"),
            tt = K.find(".sp-slider"),
            et = K.find(".sp-alpha-inner"),
            nt = K.find(".sp-alpha"),
            rt = K.find(".sp-alpha-handle"),
            it = K.find(".sp-input"),
            ot = K.find(".sp-palette"),
            at = K.find(".sp-initial"),
            st = K.find(".sp-cancel"),
            ct = K.find(".sp-clear"),
            lt = K.find(".sp-choose"),
            ut = K.find(".sp-palette-toggle"),
            dt = G.is("input"),
            ht = dt && "color" === G.attr("type") && g(),
            ft = dt && !w,
            pt = ft ? t(a).addClass(C).addClass(y.className).addClass(y.replacerClassName) : t([]),
            gt = ft ? pt : G,
            vt = pt.find(".sp-preview-inner"),
            mt = y.color || dt && G.val(),
            bt = !1,
            yt = y.preferredFormat,
            wt = !y.showButtons || y.clickoutFiresChange,
            xt = !mt,
            Ot = y.allowEmpty && !ht;
          function Ct() {
            if (y.showPaletteOnly && (y.showPalette = !0), ut.text(y.showPaletteOnly ? y.togglePaletteMoreText : y.togglePaletteLessText), y.palette) {
              z = y.palette.slice(0), H = t.isArray(z[0]) ? z : [z], B = {};
              for (var e = 0; e < H.length; e++) for (var n = 0; n < H[e].length; n++) {
                var r = k(H[e][n]).toRgbString();
                B[r] = !0;
              }
            }
            K.toggleClass("sp-flat", w), K.toggleClass("sp-input-disabled", !y.showInput), K.toggleClass("sp-alpha-enabled", y.showAlpha), K.toggleClass("sp-clear-enabled", Ot), K.toggleClass("sp-buttons-disabled", !y.showButtons), K.toggleClass("sp-palette-buttons-disabled", !y.togglePaletteOnly), K.toggleClass("sp-palette-disabled", !y.showPalette), K.toggleClass("sp-palette-only", y.showPaletteOnly), K.toggleClass("sp-initial-disabled", !y.showInitial), K.addClass(y.className).addClass(y.containerClassName), Ut();
          }
          function St() {
            if (O && window.localStorage) {
              try {
                var e = window.localStorage[O].split(",#");
                e.length > 1 && (delete window.localStorage[O], t.each(e, function (t, e) {
                  kt(e);
                }));
              } catch (t) {}
              try {
                U = window.localStorage[O].split(";");
              } catch (t) {}
            }
          }
          function kt(e) {
            if (x) {
              var n = k(e).toRgbString();
              if (!B[n] && -1 === t.inArray(n, U)) for (U.push(n); U.length > $;) U.shift();
              if (O && window.localStorage) try {
                window.localStorage[O] = U.join(";");
              } catch (t) {}
            }
          }
          function Tt() {
            var e = Ft(),
              n = t.map(H, function (t, n) {
                return c(t, e, "sp-palette-row sp-palette-row-" + n, y);
              });
            St(), U && n.push(c(function () {
              var t = [];
              if (y.showPalette) for (var e = 0; e < U.length; e++) {
                var n = k(U[e]).toRgbString();
                B[n] || t.push(U[e]);
              }
              return t.reverse().slice(0, y.maxSelectionSize);
            }(), e, "sp-palette-row sp-palette-row-selection", y)), ot.html(n.join(""));
          }
          function jt() {
            if (y.showInitial) {
              var t = bt,
                e = Ft();
              at.html(c([t, e], e, "sp-palette-row-initial", y));
            }
          }
          function Et() {
            (A <= 0 || P <= 0 || D <= 0) && Ut(), E = !0, K.addClass("sp-dragging"), W = null, G.trigger("dragstart.spectrum", [Ft()]);
          }
          function Pt() {
            E = !1, K.removeClass("sp-dragging"), G.trigger("dragstop.spectrum", [Ft()]);
          }
          function At() {
            var t = it.val();
            if (null !== t && "" !== t || !Ot) {
              var e = k(t);
              e.isValid() ? (Rt(e), Bt(!0)) : it.addClass("sp-validation-error");
            } else Rt(null), Bt(!0);
          }
          function Mt() {
            j ? Nt() : Dt();
          }
          function Dt() {
            var e = t.Event("beforeShow.spectrum");
            if (j) Ut();else if (G.trigger("beforeShow.spectrum", [Ft()]), !1 !== S.beforeShow(Ft()) && !e.isDefaultPrevented()) {
              !function () {
                for (var t = 0; t < r.length; t++) r[t] && r[t].hide();
              }(), j = !0;
              var n = t(q);
              n.bind("keydown.spectrum", Lt), n.bind("click.spectrum", _t), t(window).bind("resize.spectrum", T), pt.addClass("sp-active"), K.removeClass("sp-hidden"), Ut(), zt(), bt = Ft(), jt(), S.show(bt), G.trigger("show.spectrum", [bt]);
            }
          }
          function Lt(t) {
            27 === t.keyCode && Nt();
          }
          function _t(t) {
            2 != t.button && (E || (wt ? Bt(!0) : It(), Nt()));
          }
          function Nt() {
            j && !w && (j = !1, t(q).unbind("keydown.spectrum", Lt), t(q).unbind("click.spectrum", _t), t(window).unbind("resize.spectrum", T), pt.removeClass("sp-active"), K.addClass("sp-hidden"), S.hide(Ft()), G.trigger("hide.spectrum", [Ft()]));
          }
          function It() {
            Rt(bt, !0);
          }
          function Rt(t, e) {
            var n, r;
            k.equals(t, Ft()) ? zt() : (!t && Ot ? xt = !0 : (xt = !1, r = (n = k(t)).toHsv(), I = r.h % 360 / 360, R = r.s, F = r.v, V = r.a), zt(), n && n.isValid() && !e && (yt = y.preferredFormat || n.getFormat()));
          }
          function Ft(t) {
            return t = t || {}, Ot && xt ? null : k.fromRatio({
              h: I,
              s: R,
              v: F,
              a: Math.round(100 * V) / 100
            }, {
              format: t.format || yt
            });
          }
          function Vt() {
            zt(), S.move(Ft()), G.trigger("move.spectrum", [Ft()]);
          }
          function zt() {
            it.removeClass("sp-validation-error"), Ht();
            var t = k.fromRatio({
              h: I,
              s: 1,
              v: 1
            });
            J.css("background-color", t.toHexString());
            var e = yt;
            V < 1 && (0 !== V || "name" !== e) && ("hex" !== e && "hex3" !== e && "hex6" !== e && "name" !== e || (e = "rgb"));
            var n = Ft({
                format: e
              }),
              r = "";
            if (vt.removeClass("sp-clear-display"), vt.css("background-color", "transparent"), !n && Ot) vt.addClass("sp-clear-display");else {
              var a = n.toHexString(),
                s = n.toRgbString();
              if (o || 1 === n.alpha ? vt.css("background-color", s) : (vt.css("background-color", "transparent"), vt.css("filter", n.toFilter())), y.showAlpha) {
                var c = n.toRgb();
                c.a = 0;
                var l = k(c).toRgbString(),
                  u = "linear-gradient(left, " + l + ", " + a + ")";
                i ? et.css("filter", k(l).toFilter({
                  gradientType: 1
                }, a)) : (et.css("background", "-webkit-" + u), et.css("background", "-moz-" + u), et.css("background", "-ms-" + u), et.css("background", "linear-gradient(to right, " + l + ", " + a + ")"));
              }
              r = n.toString(e);
            }
            y.showInput && it.val(r), y.showPalette && Tt(), jt();
          }
          function Ht() {
            var t = R,
              e = F;
            if (Ot && xt) rt.hide(), tt.hide(), Z.hide();else {
              rt.show(), tt.show(), Z.show();
              var n = t * P,
                r = A - e * A;
              n = Math.max(-M, Math.min(P - M, n - M)), r = Math.max(-M, Math.min(A - M, r - M)), Z.css({
                top: r + "px",
                left: n + "px"
              });
              var i = V * L;
              rt.css({
                left: i - _ / 2 + "px"
              });
              var o = I * D;
              tt.css({
                top: o - N + "px"
              });
            }
          }
          function Bt(t) {
            var e = Ft(),
              n = "",
              r = !k.equals(e, bt);
            e && (n = e.toString(yt), kt(e)), dt && G.val(n), t && r && (S.change(e), G.trigger("change", [e]));
          }
          function Ut() {
            j && (P = J.width(), A = J.height(), M = Z.height(), Q.width(), D = Q.height(), N = tt.height(), L = nt.width(), _ = rt.width(), w || (K.css("position", "absolute"), y.offset ? K.offset(y.offset) : K.offset(function (e, n) {
              var r = e.outerWidth(),
                i = e.outerHeight(),
                o = n.outerHeight(),
                a = e[0].ownerDocument,
                s = a.documentElement,
                c = s.clientWidth,
                l = s.clientHeight,
                u = c + t(a).scrollLeft(),
                d = l + t(a).scrollTop(),
                h = n.offset();
              return h.top += o, h.left -= Math.min(h.left, h.left + r > u && u > r ? Math.abs(h.left + r - u) : 0), h.top -= Math.min(h.top, h.top + i > d && d > i ? Math.abs(i + o - 0) : 0), h;
            }(K, gt))), Ht(), y.showPalette && Tt(), G.trigger("reflow.spectrum"));
          }
          function $t() {
            Nt(), Y = !0, G.attr("disabled", !0), gt.addClass("sp-disabled");
          }
          !function () {
            if (i && K.find("*:not(input)").attr("unselectable", "on"), Ct(), ft && G.after(pt).hide(), Ot || ct.hide(), w) G.after(K).hide();else {
              var e = "parent" === y.appendTo ? G.parent() : t(y.appendTo);
              1 !== e.length && (e = t("body")), e.append(K);
            }
            function n(e) {
              return e.data && e.data.ignore ? (Rt(t(e.target).closest(".sp-thumb-el").data("color")), Vt()) : (Rt(t(e.target).closest(".sp-thumb-el").data("color")), Vt(), Bt(!0), y.hideAfterPaletteSelect && Nt()), !1;
            }
            St(), gt.bind("click.spectrum touchstart.spectrum", function (e) {
              Y || Mt(), e.stopPropagation(), t(e.target).is("input") || e.preventDefault();
            }), (G.is(":disabled") || !0 === y.disabled) && $t(), K.click(h), it.change(At), it.bind("paste", function () {
              setTimeout(At, 1);
            }), it.keydown(function (t) {
              13 == t.keyCode && At();
            }), st.text(y.cancelText), st.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), It(), Nt();
            }), ct.attr("title", y.clearText), ct.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), xt = !0, Vt(), w && Bt(!0);
            }), lt.text(y.chooseText), lt.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), i && it.is(":focus") && it.trigger("change"), it.hasClass("sp-validation-error") || (Bt(!0), Nt());
            }), ut.text(y.showPaletteOnly ? y.togglePaletteMoreText : y.togglePaletteLessText), ut.bind("click.spectrum", function (t) {
              t.stopPropagation(), t.preventDefault(), y.showPaletteOnly = !y.showPaletteOnly, y.showPaletteOnly || w || K.css("left", "-=" + (X.outerWidth(!0) + 5)), Ct();
            }), p(nt, function (t, e, n) {
              V = t / L, xt = !1, n.shiftKey && (V = Math.round(10 * V) / 10), Vt();
            }, Et, Pt), p(Q, function (t, e) {
              I = parseFloat(e / D), xt = !1, y.showAlpha || (V = 1), Vt();
            }, Et, Pt), p(J, function (t, e, n) {
              if (n.shiftKey) {
                if (!W) {
                  var r = R * P,
                    i = A - F * A,
                    o = Math.abs(t - r) > Math.abs(e - i);
                  W = o ? "x" : "y";
                }
              } else W = null;
              var a = !W || "y" === W;
              (!W || "x" === W) && (R = parseFloat(t / P)), a && (F = parseFloat((A - e) / A)), xt = !1, y.showAlpha || (V = 1), Vt();
            }, Et, Pt), mt ? (Rt(mt), zt(), yt = y.preferredFormat || k(mt).format, kt(mt)) : zt(), w && Dt();
            var r = i ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
            ot.delegate(".sp-thumb-el", r, n), at.delegate(".sp-thumb-el:nth-child(1)", r, {
              ignore: !0
            }, n);
          }();
          var Wt = {
            show: Dt,
            hide: Nt,
            toggle: Mt,
            reflow: Ut,
            option: function option(n, r) {
              return n === e ? t.extend({}, y) : r === e ? y[n] : (y[n] = r, "preferredFormat" === n && (yt = y.preferredFormat), void Ct());
            },
            enable: function enable() {
              Y = !1, G.attr("disabled", !1), gt.removeClass("sp-disabled");
            },
            disable: $t,
            offset: function offset(t) {
              y.offset = t, Ut();
            },
            set: function set(t) {
              Rt(t), Bt();
            },
            get: Ft,
            destroy: function destroy() {
              G.show(), gt.unbind("click.spectrum touchstart.spectrum"), K.remove(), pt.remove(), r[Wt.id] = null;
            },
            container: K
          };
          return Wt.id = r.push(Wt) - 1, Wt;
        }
        function d() {}
        function h(t) {
          t.stopPropagation();
        }
        function f(t, e) {
          var n = Array.prototype.slice,
            r = n.call(arguments, 2);
          return function () {
            return t.apply(e, r.concat(n.call(arguments)));
          };
        }
        function p(e, n, r, o) {
          n = n || function () {}, r = r || function () {}, o = o || function () {};
          var a = document,
            s = !1,
            c = {},
            l = 0,
            u = 0,
            d = "ontouchstart" in window,
            h = {};
          function f(t) {
            t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault(), t.returnValue = !1;
          }
          function p(t) {
            if (s) {
              if (i && a.documentMode < 9 && !t.button) return g();
              var r = t && t.touches && t.touches[0],
                o = r && r.pageX || t.pageX,
                h = r && r.pageY || t.pageY,
                p = Math.max(0, Math.min(o - c.left, u)),
                v = Math.max(0, Math.min(h - c.top, l));
              d && f(t), n.apply(e, [p, v, t]);
            }
          }
          function g() {
            s && (t(a).unbind(h), t(a.body).removeClass("sp-dragging"), setTimeout(function () {
              o.apply(e, arguments);
            }, 0)), s = !1;
          }
          h.selectstart = f, h.dragstart = f, h["touchmove mousemove"] = p, h["touchend mouseup"] = g, t(e).bind("touchstart mousedown", function (n) {
            var i = n.which ? 3 == n.which : 2 == n.button;
            i || s || !1 !== r.apply(e, arguments) && (s = !0, l = t(e).height(), u = t(e).width(), c = t(e).offset(), t(a).bind(h), t(a.body).addClass("sp-dragging"), p(n), f(n));
          });
        }
        function g() {
          return t.fn.spectrum.inputTypeColorSupport();
        }
        var v = "spectrum.id";
        t.fn.spectrum = function (e, n) {
          if ("string" == typeof e) {
            var i = this,
              o = Array.prototype.slice.call(arguments, 1);
            return this.each(function () {
              var n = r[t(this).data(v)];
              if (n) {
                var a = n[e];
                if (!a) throw new Error("Spectrum: no such method: '" + e + "'");
                "get" == e ? i = n.get() : "container" == e ? i = n.container : "option" == e ? i = n.option.apply(n, o) : "destroy" == e ? (n.destroy(), t(this).removeData(v)) : a.apply(n, o);
              }
            }), i;
          }
          return this.spectrum("destroy").each(function () {
            var n = u(this, t.extend({}, e, t(this).data()));
            t(this).data(v, n.id);
          });
        }, t.fn.spectrum.load = !0, t.fn.spectrum.loadOpts = {}, t.fn.spectrum.draggable = p, t.fn.spectrum.defaults = n, t.fn.spectrum.inputTypeColorSupport = function e() {
          if (void 0 === e._cachedResult) {
            var n = t("<input type='color'/>")[0];
            e._cachedResult = "color" === n.type && "" !== n.value;
          }
          return e._cachedResult;
        }, t.spectrum = {}, t.spectrum.localization = {}, t.spectrum.palettes = {}, t.fn.spectrum.processNativeColorInputs = function () {
          var e = t("input[type=color]");
          e.length && !g() && e.spectrum({
            preferredFormat: "hex6"
          });
        };
        var m = /^[\s,#]+/,
          b = /\s+$/,
          y = 0,
          w = Math,
          x = w.round,
          O = w.min,
          C = w.max,
          S = w.random,
          k = function t(e, n) {
            if (n = n || {}, (e = e || "") instanceof t) return e;
            if (!(this instanceof t)) return new t(e, n);
            var r = function (t) {
              var e,
                n,
                r,
                i = {
                  r: 0,
                  g: 0,
                  b: 0
                },
                o = 1,
                a = !1,
                s = !1;
              return "string" == typeof t && (t = function (t) {
                t = t.replace(m, "").replace(b, "").toLowerCase();
                var e,
                  n,
                  r = !1;
                if (U[t]) t = U[t], r = !0;else if ("transparent" == t) return {
                  r: 0,
                  g: 0,
                  b: 0,
                  a: 0,
                  format: "name"
                };
                return (e = tt.rgb.exec(t)) ? {
                  r: e[1],
                  g: e[2],
                  b: e[3]
                } : (e = tt.rgba.exec(t)) ? {
                  r: e[1],
                  g: e[2],
                  b: e[3],
                  a: e[4]
                } : (e = tt.hsl.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  l: e[3]
                } : (e = tt.hsla.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  l: e[3],
                  a: e[4]
                } : (e = tt.hsv.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  v: e[3]
                } : (e = tt.hsva.exec(t)) ? {
                  h: e[1],
                  s: e[2],
                  v: e[3],
                  a: e[4]
                } : (e = tt.hex8.exec(t)) ? {
                  a: (n = e[1], Y(n) / 255),
                  r: Y(e[2]),
                  g: Y(e[3]),
                  b: Y(e[4]),
                  format: r ? "name" : "hex8"
                } : (e = tt.hex6.exec(t)) ? {
                  r: Y(e[1]),
                  g: Y(e[2]),
                  b: Y(e[3]),
                  format: r ? "name" : "hex"
                } : !!(e = tt.hex3.exec(t)) && {
                  r: Y(e[1] + "" + e[1]),
                  g: Y(e[2] + "" + e[2]),
                  b: Y(e[3] + "" + e[3]),
                  format: r ? "name" : "hex"
                };
              }(t)), "object" == l()(t) && (t.hasOwnProperty("r") && t.hasOwnProperty("g") && t.hasOwnProperty("b") ? (e = t.r, n = t.g, r = t.b, i = {
                r: 255 * q(e, 255),
                g: 255 * q(n, 255),
                b: 255 * q(r, 255)
              }, a = !0, s = "%" === String(t.r).substr(-1) ? "prgb" : "rgb") : t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("v") ? (t.s = X(t.s), t.v = X(t.v), i = function (t, e, n) {
                t = 6 * q(t, 360), e = q(e, 100), n = q(n, 100);
                var r = w.floor(t),
                  i = t - r,
                  o = n * (1 - e),
                  a = n * (1 - i * e),
                  s = n * (1 - (1 - i) * e),
                  c = r % 6;
                return {
                  r: 255 * [n, a, o, o, s, n][c],
                  g: 255 * [s, n, n, a, o, o][c],
                  b: 255 * [o, o, s, n, n, a][c]
                };
              }(t.h, t.s, t.v), a = !0, s = "hsv") : t.hasOwnProperty("h") && t.hasOwnProperty("s") && t.hasOwnProperty("l") && (t.s = X(t.s), t.l = X(t.l), i = function (t, e, n) {
                var r, i, o;
                function a(t, e, n) {
                  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + 6 * (e - t) * n : n < .5 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
                }
                if (t = q(t, 360), e = q(e, 100), n = q(n, 100), 0 === e) r = i = o = n;else {
                  var s = n < .5 ? n * (1 + e) : n + e - n * e,
                    c = 2 * n - s;
                  r = a(c, s, t + 1 / 3), i = a(c, s, t), o = a(c, s, t - 1 / 3);
                }
                return {
                  r: 255 * r,
                  g: 255 * i,
                  b: 255 * o
                };
              }(t.h, t.s, t.l), a = !0, s = "hsl"), t.hasOwnProperty("a") && (o = t.a)), o = W(o), {
                ok: a,
                format: t.format || s,
                r: O(255, C(i.r, 0)),
                g: O(255, C(i.g, 0)),
                b: O(255, C(i.b, 0)),
                a: o
              };
            }(e);
            this._originalInput = e, this._r = r.r, this._g = r.g, this._b = r.b, this._a = r.a, this._roundA = x(100 * this._a) / 100, this._format = n.format || r.format, this._gradientType = n.gradientType, this._r < 1 && (this._r = x(this._r)), this._g < 1 && (this._g = x(this._g)), this._b < 1 && (this._b = x(this._b)), this._ok = r.ok, this._tc_id = y++;
          };
        function T(t, e, n) {
          t = q(t, 255), e = q(e, 255), n = q(n, 255);
          var r,
            i,
            o = C(t, e, n),
            a = O(t, e, n),
            s = (o + a) / 2;
          if (o == a) r = i = 0;else {
            var c = o - a;
            switch (i = s > .5 ? c / (2 - o - a) : c / (o + a), o) {
              case t:
                r = (e - n) / c + (e < n ? 6 : 0);
                break;
              case e:
                r = (n - t) / c + 2;
                break;
              case n:
                r = (t - e) / c + 4;
            }
            r /= 6;
          }
          return {
            h: r,
            s: i,
            l: s
          };
        }
        function j(t, e, n) {
          t = q(t, 255), e = q(e, 255), n = q(n, 255);
          var r,
            i,
            o = C(t, e, n),
            a = O(t, e, n),
            s = o,
            c = o - a;
          if (i = 0 === o ? 0 : c / o, o == a) r = 0;else {
            switch (o) {
              case t:
                r = (e - n) / c + (e < n ? 6 : 0);
                break;
              case e:
                r = (n - t) / c + 2;
                break;
              case n:
                r = (t - e) / c + 4;
            }
            r /= 6;
          }
          return {
            h: r,
            s: i,
            v: s
          };
        }
        function E(t, e, n, r) {
          var i = [K(x(t).toString(16)), K(x(e).toString(16)), K(x(n).toString(16))];
          return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
        }
        function P(t, e, n, r) {
          var i;
          return [K((i = r, Math.round(255 * parseFloat(i)).toString(16))), K(x(t).toString(16)), K(x(e).toString(16)), K(x(n).toString(16))].join("");
        }
        function A(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.s -= e / 100, n.s = G(n.s), k(n);
        }
        function M(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.s += e / 100, n.s = G(n.s), k(n);
        }
        function D(t) {
          return k(t).desaturate(100);
        }
        function L(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.l += e / 100, n.l = G(n.l), k(n);
        }
        function _(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toRgb();
          return n.r = C(0, O(255, n.r - x(-e / 100 * 255))), n.g = C(0, O(255, n.g - x(-e / 100 * 255))), n.b = C(0, O(255, n.b - x(-e / 100 * 255))), k(n);
        }
        function N(t, e) {
          e = 0 === e ? 0 : e || 10;
          var n = k(t).toHsl();
          return n.l -= e / 100, n.l = G(n.l), k(n);
        }
        function I(t, e) {
          var n = k(t).toHsl(),
            r = (x(n.h) + e) % 360;
          return n.h = r < 0 ? 360 + r : r, k(n);
        }
        function R(t) {
          var e = k(t).toHsl();
          return e.h = (e.h + 180) % 360, k(e);
        }
        function F(t) {
          var e = k(t).toHsl(),
            n = e.h;
          return [k(t), k({
            h: (n + 120) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 240) % 360,
            s: e.s,
            l: e.l
          })];
        }
        function V(t) {
          var e = k(t).toHsl(),
            n = e.h;
          return [k(t), k({
            h: (n + 90) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 180) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 270) % 360,
            s: e.s,
            l: e.l
          })];
        }
        function z(t) {
          var e = k(t).toHsl(),
            n = e.h;
          return [k(t), k({
            h: (n + 72) % 360,
            s: e.s,
            l: e.l
          }), k({
            h: (n + 216) % 360,
            s: e.s,
            l: e.l
          })];
        }
        function H(t, e, n) {
          e = e || 6, n = n || 30;
          var r = k(t).toHsl(),
            i = 360 / n,
            o = [k(t)];
          for (r.h = (r.h - (i * e >> 1) + 720) % 360; --e;) r.h = (r.h + i) % 360, o.push(k(r));
          return o;
        }
        function B(t, e) {
          e = e || 6;
          for (var n = k(t).toHsv(), r = n.h, i = n.s, o = n.v, a = [], s = 1 / e; e--;) a.push(k({
            h: r,
            s: i,
            v: o
          })), o = (o + s) % 1;
          return a;
        }
        k.prototype = {
          isDark: function isDark() {
            return this.getBrightness() < 128;
          },
          isLight: function isLight() {
            return !this.isDark();
          },
          isValid: function isValid() {
            return this._ok;
          },
          getOriginalInput: function getOriginalInput() {
            return this._originalInput;
          },
          getFormat: function getFormat() {
            return this._format;
          },
          getAlpha: function getAlpha() {
            return this._a;
          },
          getBrightness: function getBrightness() {
            var t = this.toRgb();
            return (299 * t.r + 587 * t.g + 114 * t.b) / 1e3;
          },
          setAlpha: function setAlpha(t) {
            return this._a = W(t), this._roundA = x(100 * this._a) / 100, this;
          },
          toHsv: function toHsv() {
            var t = j(this._r, this._g, this._b);
            return {
              h: 360 * t.h,
              s: t.s,
              v: t.v,
              a: this._a
            };
          },
          toHsvString: function toHsvString() {
            var t = j(this._r, this._g, this._b),
              e = x(360 * t.h),
              n = x(100 * t.s),
              r = x(100 * t.v);
            return 1 == this._a ? "hsv(" + e + ", " + n + "%, " + r + "%)" : "hsva(" + e + ", " + n + "%, " + r + "%, " + this._roundA + ")";
          },
          toHsl: function toHsl() {
            var t = T(this._r, this._g, this._b);
            return {
              h: 360 * t.h,
              s: t.s,
              l: t.l,
              a: this._a
            };
          },
          toHslString: function toHslString() {
            var t = T(this._r, this._g, this._b),
              e = x(360 * t.h),
              n = x(100 * t.s),
              r = x(100 * t.l);
            return 1 == this._a ? "hsl(" + e + ", " + n + "%, " + r + "%)" : "hsla(" + e + ", " + n + "%, " + r + "%, " + this._roundA + ")";
          },
          toHex: function toHex(t) {
            return E(this._r, this._g, this._b, t);
          },
          toHexString: function toHexString(t) {
            return "#" + this.toHex(t);
          },
          toHex8: function toHex8() {
            return P(this._r, this._g, this._b, this._a);
          },
          toHex8String: function toHex8String() {
            return "#" + this.toHex8();
          },
          toRgb: function toRgb() {
            return {
              r: x(this._r),
              g: x(this._g),
              b: x(this._b),
              a: this._a
            };
          },
          toRgbString: function toRgbString() {
            return 1 == this._a ? "rgb(" + x(this._r) + ", " + x(this._g) + ", " + x(this._b) + ")" : "rgba(" + x(this._r) + ", " + x(this._g) + ", " + x(this._b) + ", " + this._roundA + ")";
          },
          toPercentageRgb: function toPercentageRgb() {
            return {
              r: x(100 * q(this._r, 255)) + "%",
              g: x(100 * q(this._g, 255)) + "%",
              b: x(100 * q(this._b, 255)) + "%",
              a: this._a
            };
          },
          toPercentageRgbString: function toPercentageRgbString() {
            return 1 == this._a ? "rgb(" + x(100 * q(this._r, 255)) + "%, " + x(100 * q(this._g, 255)) + "%, " + x(100 * q(this._b, 255)) + "%)" : "rgba(" + x(100 * q(this._r, 255)) + "%, " + x(100 * q(this._g, 255)) + "%, " + x(100 * q(this._b, 255)) + "%, " + this._roundA + ")";
          },
          toName: function toName() {
            return 0 === this._a ? "transparent" : !(this._a < 1) && ($[E(this._r, this._g, this._b, !0)] || !1);
          },
          toFilter: function toFilter(t) {
            var e = "#" + P(this._r, this._g, this._b, this._a),
              n = e,
              r = this._gradientType ? "GradientType = 1, " : "";
            return t && (n = k(t).toHex8String()), "progid:DXImageTransform.Microsoft.gradient(" + r + "startColorstr=" + e + ",endColorstr=" + n + ")";
          },
          toString: function toString(t) {
            var e = !!t;
            t = t || this._format;
            var n = !1,
              r = this._a < 1 && this._a >= 0;
            return e || !r || "hex" !== t && "hex6" !== t && "hex3" !== t && "name" !== t ? ("rgb" === t && (n = this.toRgbString()), "prgb" === t && (n = this.toPercentageRgbString()), "hex" !== t && "hex6" !== t || (n = this.toHexString()), "hex3" === t && (n = this.toHexString(!0)), "hex8" === t && (n = this.toHex8String()), "name" === t && (n = this.toName()), "hsl" === t && (n = this.toHslString()), "hsv" === t && (n = this.toHsvString()), n || this.toHexString()) : "name" === t && 0 === this._a ? this.toName() : this.toRgbString();
          },
          _applyModification: function _applyModification(t, e) {
            var n = t.apply(null, [this].concat([].slice.call(e)));
            return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
          },
          lighten: function lighten() {
            return this._applyModification(L, arguments);
          },
          brighten: function brighten() {
            return this._applyModification(_, arguments);
          },
          darken: function darken() {
            return this._applyModification(N, arguments);
          },
          desaturate: function desaturate() {
            return this._applyModification(A, arguments);
          },
          saturate: function saturate() {
            return this._applyModification(M, arguments);
          },
          greyscale: function greyscale() {
            return this._applyModification(D, arguments);
          },
          spin: function spin() {
            return this._applyModification(I, arguments);
          },
          _applyCombination: function _applyCombination(t, e) {
            return t.apply(null, [this].concat([].slice.call(e)));
          },
          analogous: function analogous() {
            return this._applyCombination(H, arguments);
          },
          complement: function complement() {
            return this._applyCombination(R, arguments);
          },
          monochromatic: function monochromatic() {
            return this._applyCombination(B, arguments);
          },
          splitcomplement: function splitcomplement() {
            return this._applyCombination(z, arguments);
          },
          triad: function triad() {
            return this._applyCombination(F, arguments);
          },
          tetrad: function tetrad() {
            return this._applyCombination(V, arguments);
          }
        }, k.fromRatio = function (t, e) {
          if ("object" == l()(t)) {
            var n = {};
            for (var r in t) t.hasOwnProperty(r) && (n[r] = "a" === r ? t[r] : X(t[r]));
            t = n;
          }
          return k(t, e);
        }, k.equals = function (t, e) {
          return !(!t || !e) && k(t).toRgbString() == k(e).toRgbString();
        }, k.random = function () {
          return k.fromRatio({
            r: S(),
            g: S(),
            b: S()
          });
        }, k.mix = function (t, e, n) {
          n = 0 === n ? 0 : n || 50;
          var r,
            i = k(t).toRgb(),
            o = k(e).toRgb(),
            a = n / 100,
            s = 2 * a - 1,
            c = o.a - i.a,
            l = 1 - (r = ((r = s * c == -1 ? s : (s + c) / (1 + s * c)) + 1) / 2),
            u = {
              r: o.r * r + i.r * l,
              g: o.g * r + i.g * l,
              b: o.b * r + i.b * l,
              a: o.a * a + i.a * (1 - a)
            };
          return k(u);
        }, k.readability = function (t, e) {
          var n = k(t),
            r = k(e),
            i = n.toRgb(),
            o = r.toRgb(),
            a = n.getBrightness(),
            s = r.getBrightness(),
            c = Math.max(i.r, o.r) - Math.min(i.r, o.r) + Math.max(i.g, o.g) - Math.min(i.g, o.g) + Math.max(i.b, o.b) - Math.min(i.b, o.b);
          return {
            brightness: Math.abs(a - s),
            color: c
          };
        }, k.isReadable = function (t, e) {
          var n = k.readability(t, e);
          return n.brightness > 125 && n.color > 500;
        }, k.mostReadable = function (t, e) {
          for (var n = null, r = 0, i = !1, o = 0; o < e.length; o++) {
            var a = k.readability(t, e[o]),
              s = a.brightness > 125 && a.color > 500,
              c = a.brightness / 125 * 3 + a.color / 500;
            (s && !i || s && i && c > r || !s && !i && c > r) && (i = s, r = c, n = k(e[o]));
          }
          return n;
        };
        var U = k.names = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "0ff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000",
            blanchedalmond: "ffebcd",
            blue: "00f",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            burntsienna: "ea7e5d",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "0ff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkgrey: "a9a9a9",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkslategrey: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dimgrey: "696969",
            dodgerblue: "1e90ff",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "f0f",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            grey: "808080",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgray: "d3d3d3",
            lightgreen: "90ee90",
            lightgrey: "d3d3d3",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslategray: "789",
            lightslategrey: "789",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "0f0",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "f0f",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370db",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "db7093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            rebeccapurple: "663399",
            red: "f00",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            slategrey: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            wheat: "f5deb3",
            white: "fff",
            whitesmoke: "f5f5f5",
            yellow: "ff0",
            yellowgreen: "9acd32"
          },
          $ = k.hexNames = function (t) {
            var e = {};
            for (var n in t) t.hasOwnProperty(n) && (e[t[n]] = n);
            return e;
          }(U);
        function W(t) {
          return t = parseFloat(t), (isNaN(t) || t < 0 || t > 1) && (t = 1), t;
        }
        function q(t, e) {
          (function (t) {
            return "string" == typeof t && -1 != t.indexOf(".") && 1 === parseFloat(t);
          })(t) && (t = "100%");
          var n = function (t) {
            return "string" == typeof t && -1 != t.indexOf("%");
          }(t);
          return t = O(e, C(0, parseFloat(t))), n && (t = parseInt(t * e, 10) / 100), w.abs(t - e) < 1e-6 ? 1 : t % e / parseFloat(e);
        }
        function G(t) {
          return O(1, C(0, t));
        }
        function Y(t) {
          return parseInt(t, 16);
        }
        function K(t) {
          return 1 == t.length ? "0" + t : "" + t;
        }
        function X(t) {
          return t <= 1 && (t = 100 * t + "%"), t;
        }
        var J,
          Z,
          Q,
          tt = (Z = "[\\s|\\(]+(" + (J = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)") + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")\\s*\\)?", Q = "[\\s|\\(]+(" + J + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")[,|\\s]+(" + J + ")\\s*\\)?", {
            rgb: new RegExp("rgb" + Z),
            rgba: new RegExp("rgba" + Q),
            hsl: new RegExp("hsl" + Z),
            hsla: new RegExp("hsla" + Q),
            hsv: new RegExp("hsv" + Z),
            hsva: new RegExp("hsva" + Q),
            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
          });
        window.tinycolor = k, t(function () {
          t.fn.spectrum.load && t.fn.spectrum.processNativeColorInputs();
        });
      }(f), e.a = u.a.extend({
        template: function template() {
          var t = this.ppfx;
          return '\n      <div class="'.concat(this.holderClass(), '"></div>\n      <div class="').concat(t, 'field-colorp">\n        <div class="').concat(t, 'field-colorp-c" data-colorp-c>\n          <div class="').concat(t, 'checker-bg"></div>\n        </div>\n      </div>\n    ');
        },
        inputClass: function inputClass() {
          var t = this.ppfx;
          return "".concat(t, "field ").concat(t, "field-color");
        },
        holderClass: function holderClass() {
          return "".concat(this.ppfx, "input-holder");
        },
        setValue: function setValue(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.model,
            r = n.get("defaults"),
            i = Object(s.isUndefined)(t) ? Object(s.isUndefined)(r) ? "" : r : t,
            o = this.getInputEl(),
            a = this.getColorEl(),
            c = "none" != i ? i : "";
          o.value = i, a.get(0).style.backgroundColor = c, (e.fromTarget || e.fromInput && !e.avoidStore) && (a.spectrum("set", c), this.noneColor = "none" == i);
        },
        getColorEl: function getColorEl() {
          if (!this.colorEl) {
            var t,
              e = this.em,
              n = this,
              r = this.ppfx,
              i = this.model,
              o = f('<div class="'.concat(this.ppfx, 'field-color-picker"></div>')),
              a = o.get(0).style,
              s = e && e.config ? e.config.el : "",
              c = e && e.getConfig && e.getConfig("colorPicker") || {},
              l = function l(t) {
                return (1 == t.getAlpha() ? t.toHexString() : t.toRgbString()).replace(/ /g, "");
              },
              u = 0;
            this.$el.find("[data-colorp-c]").append(o), o.spectrum(h(h(h({
              containerClassName: "".concat(r, "one-bg ").concat(r, "two-color"),
              appendTo: s || "body",
              maxSelectionSize: 8,
              showPalette: !0,
              showAlpha: !0,
              chooseText: "Ok",
              cancelText: "⨯",
              palette: []
            }, c), i.get("colorPicker") || {}), {}, {
              move: function move(t) {
                var e = l(t);
                a.backgroundColor = e, i.setValueFromInput(e, 0);
              },
              change: function change(t) {
                u = 1;
                var e = l(t);
                a.backgroundColor = e, i.setValueFromInput(0, 0), i.setValueFromInput(e), n.noneColor = 0;
              },
              show: function show(e) {
                u = 0, t = l(e);
              },
              hide: function hide(e) {
                !u && t && (n.noneColor && (t = ""), a.backgroundColor = t, o.spectrum("set", t), i.setValueFromInput(t, 0));
              }
            })), e && e.on && e.on("component:selected", function () {
              u = 1, o.spectrum("hide");
            }), this.colorEl = o;
          }
          return this.colorEl;
        },
        render: function render() {
          return u.a.prototype.render.call(this), this.getColorEl(), this;
        }
      });
    }, function (t, e, n) {
      !function (e) {
        var n,
          r = {},
          i = {
            16: !1,
            18: !1,
            17: !1,
            91: !1
          },
          o = "all",
          a = {
            "⇧": 16,
            shift: 16,
            "⌥": 18,
            alt: 18,
            option: 18,
            "⌃": 17,
            ctrl: 17,
            control: 17,
            "⌘": 91,
            command: 91
          },
          s = {
            backspace: 8,
            tab: 9,
            clear: 12,
            enter: 13,
            return: 13,
            esc: 27,
            escape: 27,
            space: 32,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            del: 46,
            delete: 46,
            home: 36,
            end: 35,
            pageup: 33,
            pagedown: 34,
            ",": 188,
            ".": 190,
            "/": 191,
            "`": 192,
            "-": 189,
            "=": 187,
            ";": 186,
            "'": 222,
            "[": 219,
            "]": 221,
            "\\": 220
          },
          c = function c(t) {
            return s[t] || t.toUpperCase().charCodeAt(0);
          },
          l = [];
        for (n = 1; n < 20; n++) s["f" + n] = 111 + n;
        function u(t, e) {
          for (var n = t.length; n--;) if (t[n] === e) return n;
          return -1;
        }
        function d(t, e) {
          if (t.length != e.length) return !1;
          for (var n = 0; n < t.length; n++) if (t[n] !== e[n]) return !1;
          return !0;
        }
        var h = {
          16: "shiftKey",
          18: "altKey",
          17: "ctrlKey",
          91: "metaKey"
        };
        function f(t) {
          for (n in i) i[n] = t[h[n]];
        }
        function p(t, e, n) {
          var i, o;
          i = v(t), void 0 === n && (n = e, e = "all");
          for (var a = 0; a < i.length; a++) o = [], (t = i[a].split("+")).length > 1 && (o = m(t), t = [t[t.length - 1]]), t = t[0], (t = c(t)) in r || (r[t] = []), r[t].push({
            shortcut: i[a],
            scope: e,
            method: n,
            key: i[a],
            mods: o
          });
        }
        for (n in a) p[n] = !1;
        function g() {
          return o || "all";
        }
        function v(t) {
          var e;
          return "" == (e = (t = t.replace(/\s/g, "")).split(","))[e.length - 1] && (e[e.length - 2] += ","), e;
        }
        function m(t) {
          for (var e = t.slice(0, t.length - 1), n = 0; n < e.length; n++) e[n] = a[e[n]];
          return e;
        }
        function b(t, e, n) {
          t.addEventListener ? t.addEventListener(e, n, !1) : t.attachEvent && t.attachEvent("on" + e, function () {
            n(window.event);
          });
        }
        b(document, "keydown", function (t) {
          !function (t) {
            var e, n, o, s, c, d;
            if (e = t.keyCode, -1 == u(l, e) && l.push(e), 93 != e && 224 != e || (e = 91), e in i) for (o in i[e] = !0, a) a[o] == e && (p[o] = !0);else if (f(t), p.filter.call(this, t) && e in r) for (d = g(), s = 0; s < r[e].length; s++) if ((n = r[e][s]).scope == d || "all" == n.scope) {
              for (o in c = n.mods.length > 0, i) (!i[o] && u(n.mods, +o) > -1 || i[o] && -1 == u(n.mods, +o)) && (c = !1);
              (0 != n.mods.length || i[16] || i[18] || i[17] || i[91]) && !c || !1 === n.method(t, n) && (t.preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation && t.stopPropagation(), t.cancelBubble && (t.cancelBubble = !0));
            }
          }(t);
        }), b(document, "keyup", function (t) {
          var e,
            n = t.keyCode,
            r = u(l, n);
          if (r >= 0 && l.splice(r, 1), 93 != n && 224 != n || (n = 91), n in i) for (e in i[n] = !1, a) a[e] == n && (p[e] = !1);
        }), b(window, "focus", function () {
          for (n in i) i[n] = !1;
          for (n in a) p[n] = !1;
        });
        var y = e.key;
        e.key = p, e.key.setScope = function (t) {
          o = t || "all";
        }, e.key.getScope = g, e.key.deleteScope = function (t) {
          var e, n, i;
          for (e in r) for (n = r[e], i = 0; i < n.length;) n[i].scope === t ? n.splice(i, 1) : i++;
        }, e.key.filter = function (t) {
          var e = (t.target || t.srcElement).tagName;
          return !("INPUT" == e || "SELECT" == e || "TEXTAREA" == e);
        }, e.key.isPressed = function (t) {
          return "string" == typeof t && (t = c(t)), -1 != u(l, t);
        }, e.key.getPressedKeyCodes = function () {
          return l.slice(0);
        }, e.key.noConflict = function () {
          var t = e.key;
          return e.key = y, t;
        }, e.key.unbind = function (t, e) {
          var n,
            i,
            o,
            a,
            s,
            l = [];
          for (n = v(t), a = 0; a < n.length; a++) {
            if ((i = n[a].split("+")).length > 1 && (l = m(i), t = i[i.length - 1]), t = c(t), void 0 === e && (e = g()), !r[t]) return;
            for (o = 0; o < r[t].length; o++) (s = r[t][o]).scope === e && d(s.mods, l) && (r[t][o] = {});
          }
        }, t.exports = p;
      }(this);
    }, function (t, e, n) {
      "use strict";

      (function (t) {
        var r = n(77),
          i = n(78),
          o = n(79),
          a = setTimeout;
        function s(t) {
          return Boolean(t && void 0 !== t.length);
        }
        function c() {}
        function l(t) {
          if (!(this instanceof l)) throw new TypeError("Promises must be constructed via new");
          if ("function" != typeof t) throw new TypeError("not a function");
          this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], g(t, this);
        }
        function u(t, e) {
          for (; 3 === t._state;) t = t._value;
          0 !== t._state ? (t._handled = !0, l._immediateFn(function () {
            var n = 1 === t._state ? e.onFulfilled : e.onRejected;
            if (null !== n) {
              var r;
              try {
                r = n(t._value);
              } catch (t) {
                return void h(e.promise, t);
              }
              d(e.promise, r);
            } else (1 === t._state ? d : h)(e.promise, t._value);
          })) : t._deferreds.push(e);
        }
        function d(t, e) {
          try {
            if (e === t) throw new TypeError("A promise cannot be resolved with itself.");
            if (e && ("object" == typeof e || "function" == typeof e)) {
              var n = e.then;
              if (e instanceof l) return t._state = 3, t._value = e, void f(t);
              if ("function" == typeof n) return void g((r = n, i = e, function () {
                r.apply(i, arguments);
              }), t);
            }
            t._state = 1, t._value = e, f(t);
          } catch (e) {
            h(t, e);
          }
          var r, i;
        }
        function h(t, e) {
          t._state = 2, t._value = e, f(t);
        }
        function f(t) {
          2 === t._state && 0 === t._deferreds.length && l._immediateFn(function () {
            t._handled || l._unhandledRejectionFn(t._value);
          });
          for (var e = 0, n = t._deferreds.length; e < n; e++) u(t, t._deferreds[e]);
          t._deferreds = null;
        }
        function p(t, e, n) {
          this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.promise = n;
        }
        function g(t, e) {
          var n = !1;
          try {
            t(function (t) {
              n || (n = !0, d(e, t));
            }, function (t) {
              n || (n = !0, h(e, t));
            });
          } catch (t) {
            if (n) return;
            n = !0, h(e, t);
          }
        }
        l.prototype.catch = function (t) {
          return this.then(null, t);
        }, l.prototype.then = function (t, e) {
          var n = new this.constructor(c);
          return u(this, new p(t, e, n)), n;
        }, l.prototype.finally = r.a, l.all = function (t) {
          return new l(function (e, n) {
            if (!s(t)) return n(new TypeError("Promise.all accepts an array"));
            var r = Array.prototype.slice.call(t);
            if (0 === r.length) return e([]);
            var i = r.length;
            function o(t, a) {
              try {
                if (a && ("object" == typeof a || "function" == typeof a)) {
                  var s = a.then;
                  if ("function" == typeof s) return void s.call(a, function (e) {
                    o(t, e);
                  }, n);
                }
                r[t] = a, 0 == --i && e(r);
              } catch (t) {
                n(t);
              }
            }
            for (var a = 0; a < r.length; a++) o(a, r[a]);
          });
        }, l.any = o.a, l.allSettled = i.a, l.resolve = function (t) {
          return t && "object" == typeof t && t.constructor === l ? t : new l(function (e) {
            e(t);
          });
        }, l.reject = function (t) {
          return new l(function (e, n) {
            n(t);
          });
        }, l.race = function (t) {
          return new l(function (e, n) {
            if (!s(t)) return n(new TypeError("Promise.race accepts an array"));
            for (var r = 0, i = t.length; r < i; r++) l.resolve(t[r]).then(e, n);
          });
        }, l._immediateFn = "function" == typeof t && function (e) {
          t(e);
        } || function (t) {
          a(t, 0);
        }, l._unhandledRejectionFn = function (t) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", t);
        }, e.a = l;
      }).call(this, n(87).setImmediate);
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r),
        o = i.a.Model.extend({
          defaults: {
            id: "",
            label: "",
            tagName: "span",
            className: "",
            command: "",
            context: "",
            buttons: [],
            attributes: {},
            options: {},
            active: !1,
            dragDrop: !1,
            togglable: !0,
            runDefaultCommand: !0,
            stopDefaultCommand: !1,
            disable: !1
          },
          initialize: function initialize(t) {
            if (this.get("buttons").length) {
              var e = n(41).default;
              this.set("buttons", new e(this.get("buttons")));
            }
          }
        });
      e.default = i.a.Collection.extend({
        model: o,
        deactivateAllExceptOne: function deactivateAllExceptOne(t, e) {
          this.forEach(function (n, r) {
            n !== t && (n.set("active", !1), e && n.get("buttons").length && n.get("buttons").deactivateAllExceptOne(t, e));
          });
        },
        deactivateAll: function deactivateAll(t, e) {
          var n = t || "";
          this.forEach(function (t) {
            t.get("context") == n && t !== e && (t.set("active", !1, {
              silent: 1
            }), t.trigger("updateActive", {
              fromCollection: 1
            }));
          });
        },
        disableAllButtons: function disableAllButtons(t) {
          var e = t || "";
          this.forEach(function (t, n) {
            t.get("context") == e && t.set("disable", !0);
          });
        },
        disableAllButtonsExceptOne: function disableAllButtonsExceptOne(t, e) {
          this.forEach(function (n, r) {
            n !== t && (n.set("disable", !0), e && n.get("buttons").length && n.get("buttons").disableAllButtonsExceptOne(t, e));
          });
        }
      });
    }, function (t, e, n) {
      var r = n(8).default,
        i = n(81);
      t.exports = function (t) {
        var e = i(t, "string");
        return "symbol" == r(e) ? e : String(e);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function (t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var r = n(43);
      t.exports = function (t, e) {
        if (t) {
          if ("string" == typeof t) return r(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0;
        }
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        function e(t) {
          for (var e = {}, n = 0; n < t.length; ++n) e[t[n].toLowerCase()] = !0;
          return e;
        }
        t.defineMode("css", function (e, n) {
          var r = n.inline;
          n.propertyKeywords || (n = t.resolveMode("text/css"));
          var i,
            o,
            a = e.indentUnit,
            s = n.tokenHooks,
            c = n.documentTypes || {},
            l = n.mediaTypes || {},
            u = n.mediaFeatures || {},
            d = n.mediaValueKeywords || {},
            h = n.propertyKeywords || {},
            f = n.nonStandardPropertyKeywords || {},
            p = n.fontProperties || {},
            g = n.counterDescriptors || {},
            v = n.colorKeywords || {},
            m = n.valueKeywords || {},
            b = n.allowNested,
            y = n.lineComment,
            w = !0 === n.supportsAtComponent,
            x = !1 !== e.highlightNonStandardPropertyKeywords;
          function O(t, e) {
            return i = e, t;
          }
          function C(t, e) {
            var n = t.next();
            if (s[n]) {
              var r = s[n](t, e);
              if (!1 !== r) return r;
            }
            return "@" == n ? (t.eatWhile(/[\w\\\-]/), O("def", t.current())) : "=" == n || ("~" == n || "|" == n) && t.eat("=") ? O(null, "compare") : '"' == n || "'" == n ? (e.tokenize = S(n), e.tokenize(t, e)) : "#" == n ? (t.eatWhile(/[\w\\\-]/), O("atom", "hash")) : "!" == n ? (t.match(/^\s*\w*/), O("keyword", "important")) : /\d/.test(n) || "." == n && t.eat(/\d/) ? (t.eatWhile(/[\w.%]/), O("number", "unit")) : "-" !== n ? /[,+>*\/]/.test(n) ? O(null, "select-op") : "." == n && t.match(/^-?[_a-z][_a-z0-9-]*/i) ? O("qualifier", "qualifier") : /[:;{}\[\]\(\)]/.test(n) ? O(null, n) : t.match(/^[\w-.]+(?=\()/) ? (/^(url(-prefix)?|domain|regexp)$/i.test(t.current()) && (e.tokenize = k), O("variable callee", "variable")) : /[\w\\\-]/.test(n) ? (t.eatWhile(/[\w\\\-]/), O("property", "word")) : O(null, null) : /[\d.]/.test(t.peek()) ? (t.eatWhile(/[\w.%]/), O("number", "unit")) : t.match(/^-[\w\\\-]*/) ? (t.eatWhile(/[\w\\\-]/), t.match(/^\s*:/, !1) ? O("variable-2", "variable-definition") : O("variable-2", "variable")) : t.match(/^\w+-/) ? O("meta", "meta") : void 0;
          }
          function S(t) {
            return function (e, n) {
              for (var r, i = !1; null != (r = e.next());) {
                if (r == t && !i) {
                  ")" == t && e.backUp(1);
                  break;
                }
                i = !i && "\\" == r;
              }
              return (r == t || !i && ")" != t) && (n.tokenize = null), O("string", "string");
            };
          }
          function k(t, e) {
            return t.next(), t.match(/^\s*[\"\')]/, !1) ? e.tokenize = null : e.tokenize = S(")"), O(null, "(");
          }
          function T(t, e, n) {
            this.type = t, this.indent = e, this.prev = n;
          }
          function j(t, e, n, r) {
            return t.context = new T(n, e.indentation() + (!1 === r ? 0 : a), t.context), n;
          }
          function E(t) {
            return t.context.prev && (t.context = t.context.prev), t.context.type;
          }
          function P(t, e, n) {
            return D[n.context.type](t, e, n);
          }
          function A(t, e, n, r) {
            for (var i = r || 1; i > 0; i--) n.context = n.context.prev;
            return P(t, e, n);
          }
          function M(t) {
            var e = t.current().toLowerCase();
            o = m.hasOwnProperty(e) ? "atom" : v.hasOwnProperty(e) ? "keyword" : "variable";
          }
          var D = {
            top: function top(t, e, n) {
              if ("{" == t) return j(n, e, "block");
              if ("}" == t && n.context.prev) return E(n);
              if (w && /@component/i.test(t)) return j(n, e, "atComponentBlock");
              if (/^@(-moz-)?document$/i.test(t)) return j(n, e, "documentTypes");
              if (/^@(media|supports|(-moz-)?document|import)$/i.test(t)) return j(n, e, "atBlock");
              if (/^@(font-face|counter-style)/i.test(t)) return n.stateArg = t, "restricted_atBlock_before";
              if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(t)) return "keyframes";
              if (t && "@" == t.charAt(0)) return j(n, e, "at");
              if ("hash" == t) o = "builtin";else if ("word" == t) o = "tag";else {
                if ("variable-definition" == t) return "maybeprop";
                if ("interpolation" == t) return j(n, e, "interpolation");
                if (":" == t) return "pseudo";
                if (b && "(" == t) return j(n, e, "parens");
              }
              return n.context.type;
            },
            block: function block(t, e, n) {
              if ("word" == t) {
                var r = e.current().toLowerCase();
                return h.hasOwnProperty(r) ? (o = "property", "maybeprop") : f.hasOwnProperty(r) ? (o = x ? "string-2" : "property", "maybeprop") : b ? (o = e.match(/^\s*:(?:\s|$)/, !1) ? "property" : "tag", "block") : (o += " error", "maybeprop");
              }
              return "meta" == t ? "block" : b || "hash" != t && "qualifier" != t ? D.top(t, e, n) : (o = "error", "block");
            },
            maybeprop: function maybeprop(t, e, n) {
              return ":" == t ? j(n, e, "prop") : P(t, e, n);
            },
            prop: function prop(t, e, n) {
              if (";" == t) return E(n);
              if ("{" == t && b) return j(n, e, "propBlock");
              if ("}" == t || "{" == t) return A(t, e, n);
              if ("(" == t) return j(n, e, "parens");
              if ("hash" != t || /^#([0-9a-fA-F]{3,4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(e.current())) {
                if ("word" == t) M(e);else if ("interpolation" == t) return j(n, e, "interpolation");
              } else o += " error";
              return "prop";
            },
            propBlock: function propBlock(t, e, n) {
              return "}" == t ? E(n) : "word" == t ? (o = "property", "maybeprop") : n.context.type;
            },
            parens: function parens(t, e, n) {
              return "{" == t || "}" == t ? A(t, e, n) : ")" == t ? E(n) : "(" == t ? j(n, e, "parens") : "interpolation" == t ? j(n, e, "interpolation") : ("word" == t && M(e), "parens");
            },
            pseudo: function pseudo(t, e, n) {
              return "meta" == t ? "pseudo" : "word" == t ? (o = "variable-3", n.context.type) : P(t, e, n);
            },
            documentTypes: function documentTypes(t, e, n) {
              return "word" == t && c.hasOwnProperty(e.current()) ? (o = "tag", n.context.type) : D.atBlock(t, e, n);
            },
            atBlock: function atBlock(t, e, n) {
              if ("(" == t) return j(n, e, "atBlock_parens");
              if ("}" == t || ";" == t) return A(t, e, n);
              if ("{" == t) return E(n) && j(n, e, b ? "block" : "top");
              if ("interpolation" == t) return j(n, e, "interpolation");
              if ("word" == t) {
                var r = e.current().toLowerCase();
                o = "only" == r || "not" == r || "and" == r || "or" == r ? "keyword" : l.hasOwnProperty(r) ? "attribute" : u.hasOwnProperty(r) ? "property" : d.hasOwnProperty(r) ? "keyword" : h.hasOwnProperty(r) ? "property" : f.hasOwnProperty(r) ? x ? "string-2" : "property" : m.hasOwnProperty(r) ? "atom" : v.hasOwnProperty(r) ? "keyword" : "error";
              }
              return n.context.type;
            },
            atComponentBlock: function atComponentBlock(t, e, n) {
              return "}" == t ? A(t, e, n) : "{" == t ? E(n) && j(n, e, b ? "block" : "top", !1) : ("word" == t && (o = "error"), n.context.type);
            },
            atBlock_parens: function atBlock_parens(t, e, n) {
              return ")" == t ? E(n) : "{" == t || "}" == t ? A(t, e, n, 2) : D.atBlock(t, e, n);
            },
            restricted_atBlock_before: function restricted_atBlock_before(t, e, n) {
              return "{" == t ? j(n, e, "restricted_atBlock") : "word" == t && "@counter-style" == n.stateArg ? (o = "variable", "restricted_atBlock_before") : P(t, e, n);
            },
            restricted_atBlock: function restricted_atBlock(t, e, n) {
              return "}" == t ? (n.stateArg = null, E(n)) : "word" == t ? (o = "@font-face" == n.stateArg && !p.hasOwnProperty(e.current().toLowerCase()) || "@counter-style" == n.stateArg && !g.hasOwnProperty(e.current().toLowerCase()) ? "error" : "property", "maybeprop") : "restricted_atBlock";
            },
            keyframes: function keyframes(t, e, n) {
              return "word" == t ? (o = "variable", "keyframes") : "{" == t ? j(n, e, "top") : P(t, e, n);
            },
            at: function at(t, e, n) {
              return ";" == t ? E(n) : "{" == t || "}" == t ? A(t, e, n) : ("word" == t ? o = "tag" : "hash" == t && (o = "builtin"), "at");
            },
            interpolation: function interpolation(t, e, n) {
              return "}" == t ? E(n) : "{" == t || ";" == t ? A(t, e, n) : ("word" == t ? o = "variable" : "variable" != t && "(" != t && ")" != t && (o = "error"), "interpolation");
            }
          };
          return {
            startState: function startState(t) {
              return {
                tokenize: null,
                state: r ? "block" : "top",
                stateArg: null,
                context: new T(r ? "block" : "top", t || 0, null)
              };
            },
            token: function token(t, e) {
              if (!e.tokenize && t.eatSpace()) return null;
              var n = (e.tokenize || C)(t, e);
              return n && "object" == typeof n && (i = n[1], n = n[0]), o = n, "comment" != i && (e.state = D[e.state](i, t, e)), o;
            },
            indent: function indent(t, e) {
              var n = t.context,
                r = e && e.charAt(0),
                i = n.indent;
              return "prop" != n.type || "}" != r && ")" != r || (n = n.prev), n.prev && ("}" != r || "block" != n.type && "top" != n.type && "interpolation" != n.type && "restricted_atBlock" != n.type ? (")" != r || "parens" != n.type && "atBlock_parens" != n.type) && ("{" != r || "at" != n.type && "atBlock" != n.type) || (i = Math.max(0, n.indent - a)) : i = (n = n.prev).indent), i;
            },
            electricChars: "}",
            blockCommentStart: "/*",
            blockCommentEnd: "*/",
            blockCommentContinue: " * ",
            lineComment: y,
            fold: "brace"
          };
        });
        var n = ["domain", "regexp", "url", "url-prefix"],
          r = e(n),
          i = ["all", "aural", "braille", "handheld", "print", "projection", "screen", "tty", "tv", "embossed"],
          o = e(i),
          a = ["width", "min-width", "max-width", "height", "min-height", "max-height", "device-width", "min-device-width", "max-device-width", "device-height", "min-device-height", "max-device-height", "aspect-ratio", "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio", "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color", "max-color", "color-index", "min-color-index", "max-color-index", "monochrome", "min-monochrome", "max-monochrome", "resolution", "min-resolution", "max-resolution", "scan", "grid", "orientation", "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio", "pointer", "any-pointer", "hover", "any-hover", "prefers-color-scheme", "dynamic-range", "video-dynamic-range"],
          s = e(a),
          c = ["landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover", "interlace", "progressive", "dark", "light", "standard", "high"],
          l = e(c),
          u = ["align-content", "align-items", "align-self", "alignment-adjust", "alignment-baseline", "all", "anchor-point", "animation", "animation-delay", "animation-direction", "animation-duration", "animation-fill-mode", "animation-iteration-count", "animation-name", "animation-play-state", "animation-timing-function", "appearance", "azimuth", "backdrop-filter", "backface-visibility", "background", "background-attachment", "background-blend-mode", "background-clip", "background-color", "background-image", "background-origin", "background-position", "background-position-x", "background-position-y", "background-repeat", "background-size", "baseline-shift", "binding", "bleed", "block-size", "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target", "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius", "border-bottom-right-radius", "border-bottom-style", "border-bottom-width", "border-collapse", "border-color", "border-image", "border-image-outset", "border-image-repeat", "border-image-slice", "border-image-source", "border-image-width", "border-left", "border-left-color", "border-left-style", "border-left-width", "border-radius", "border-right", "border-right-color", "border-right-style", "border-right-width", "border-spacing", "border-style", "border-top", "border-top-color", "border-top-left-radius", "border-top-right-radius", "border-top-style", "border-top-width", "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing", "break-after", "break-before", "break-inside", "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count", "column-fill", "column-gap", "column-rule", "column-rule-color", "column-rule-style", "column-rule-width", "column-span", "column-width", "columns", "contain", "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after", "cue-before", "cursor", "direction", "display", "dominant-baseline", "drop-initial-after-adjust", "drop-initial-after-align", "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size", "drop-initial-value", "elevation", "empty-cells", "fit", "fit-content", "fit-position", "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into", "font", "font-family", "font-feature-settings", "font-kerning", "font-language-override", "font-optical-sizing", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-synthesis", "font-variant", "font-variant-alternates", "font-variant-caps", "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric", "font-variant-position", "font-variation-settings", "font-weight", "gap", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns", "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon", "image-orientation", "image-rendering", "image-resolution", "inline-box-align", "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline", "inset-inline-end", "inset-inline-start", "isolation", "justify-content", "justify-items", "justify-self", "left", "letter-spacing", "line-break", "line-height", "line-height-step", "line-stacking", "line-stacking-ruby", "line-stacking-shift", "line-stacking-strategy", "list-style", "list-style-image", "list-style-position", "list-style-type", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "marks", "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed", "marquee-style", "mask-clip", "mask-composite", "mask-image", "mask-mode", "mask-origin", "mask-position", "mask-repeat", "mask-size", "mask-type", "max-block-size", "max-height", "max-inline-size", "max-width", "min-block-size", "min-height", "min-inline-size", "min-width", "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right", "nav-up", "object-fit", "object-position", "offset", "offset-anchor", "offset-distance", "offset-path", "offset-position", "offset-rotate", "opacity", "order", "orphans", "outline", "outline-color", "outline-offset", "outline-style", "outline-width", "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom", "padding-left", "padding-right", "padding-top", "page", "page-break-after", "page-break-before", "page-break-inside", "page-policy", "pause", "pause-after", "pause-before", "perspective", "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position", "presentation-level", "punctuation-trim", "quotes", "region-break-after", "region-break-before", "region-break-inside", "region-fragment", "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness", "right", "rotate", "rotation", "rotation-point", "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span", "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block", "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom", "scroll-margin-inline", "scroll-margin-inline-end", "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right", "scroll-margin-top", "scroll-padding", "scroll-padding-block", "scroll-padding-block-end", "scroll-padding-block-start", "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end", "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right", "scroll-padding-top", "scroll-snap-align", "scroll-snap-type", "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside", "size", "speak", "speak-as", "speak-header", "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size", "table-layout", "target", "target-name", "target-new", "target-position", "text-align", "text-align-last", "text-combine-upright", "text-decoration", "text-decoration-color", "text-decoration-line", "text-decoration-skip", "text-decoration-skip-ink", "text-decoration-style", "text-emphasis", "text-emphasis-color", "text-emphasis-position", "text-emphasis-style", "text-height", "text-indent", "text-justify", "text-orientation", "text-outline", "text-overflow", "text-rendering", "text-shadow", "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position", "text-wrap", "top", "touch-action", "transform", "transform-origin", "transform-style", "transition", "transition-delay", "transition-duration", "transition-property", "transition-timing-function", "translate", "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress", "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index", "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color", "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events", "color-interpolation", "color-interpolation-filters", "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering", "marker", "marker-end", "marker-mid", "marker-start", "paint-order", "shape-rendering", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering", "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal", "glyph-orientation-vertical", "text-anchor", "writing-mode"],
          d = e(u),
          h = ["accent-color", "aspect-ratio", "border-block", "border-block-color", "border-block-end", "border-block-end-color", "border-block-end-style", "border-block-end-width", "border-block-start", "border-block-start-color", "border-block-start-style", "border-block-start-width", "border-block-style", "border-block-width", "border-inline", "border-inline-color", "border-inline-end", "border-inline-end-color", "border-inline-end-style", "border-inline-end-width", "border-inline-start", "border-inline-start-color", "border-inline-start-style", "border-inline-start-width", "border-inline-style", "border-inline-width", "content-visibility", "margin-block", "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end", "margin-inline-start", "overflow-anchor", "overscroll-behavior", "padding-block", "padding-block-end", "padding-block-start", "padding-inline", "padding-inline-end", "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color", "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color", "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color", "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"],
          f = e(h),
          p = e(["font-display", "font-family", "src", "unicode-range", "font-variant", "font-feature-settings", "font-stretch", "font-weight", "font-style"]),
          g = e(["additive-symbols", "fallback", "negative", "pad", "prefix", "range", "speak-as", "suffix", "symbols", "system"]),
          v = ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "slategrey", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
          m = e(v),
          b = ["above", "absolute", "activeborder", "additive", "activecaption", "afar", "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate", "always", "amharic", "amharic-abegede", "antialiased", "appworkspace", "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page", "avoid-region", "axis-pan", "background", "backwards", "baseline", "below", "bidi-override", "binary", "bengali", "blink", "block", "block-axis", "blur", "bold", "bolder", "border", "border-box", "both", "bottom", "break", "break-all", "break-word", "brightness", "bullets", "button", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian", "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret", "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch", "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote", "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse", "compact", "condensed", "conic-gradient", "contain", "content", "contents", "content-box", "context-menu", "continuous", "contrast", "copy", "counter", "counters", "cover", "crop", "cross", "crosshair", "cubic-bezier", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal", "decimal-leading-zero", "default", "default-button", "dense", "destination-atop", "destination-in", "destination-out", "destination-over", "devanagari", "difference", "disc", "discard", "disclosure-closed", "disclosure-open", "document", "dot-dash", "dot-dot-dash", "dotted", "double", "down", "drop-shadow", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out", "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede", "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er", "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er", "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et", "ethiopic-halehame-gez", "ethiopic-halehame-om-et", "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et", "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig", "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed", "extra-expanded", "fantasy", "fast", "fill", "fill-box", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes", "forwards", "from", "geometricPrecision", "georgian", "grayscale", "graytext", "grid", "groove", "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew", "help", "hidden", "hide", "higher", "highlight", "highlighttext", "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "hue-rotate", "icon", "ignore", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite", "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis", "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert", "italic", "japanese-formal", "japanese-informal", "justify", "kannada", "katakana", "katakana-iroha", "keep-all", "khmer", "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal", "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten", "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem", "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian", "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian", "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "manipulation", "match", "matrix", "matrix3d", "media-play-button", "media-slider", "media-sliderthumb", "media-volume-slider", "media-volume-sliderthumb", "medium", "menu", "menulist", "menulist-button", "menutext", "message-box", "middle", "min-intrinsic", "mix", "mongolian", "monospace", "move", "multiple", "multiple_mask_images", "multiply", "myanmar", "n-resize", "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop", "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap", "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote", "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset", "outside", "outside-shape", "overlay", "overline", "padding", "padding-box", "painted", "page", "paused", "persian", "perspective", "pinch-zoom", "plus-darker", "plus-lighter", "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d", "progress", "push-button", "radial-gradient", "radio", "read-only", "read-write", "read-write-plaintext-only", "rectangle", "region", "relative", "repeat", "repeating-linear-gradient", "repeating-radial-gradient", "repeating-conic-gradient", "repeat-x", "repeat-y", "reset", "reverse", "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY", "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running", "s-resize", "sans-serif", "saturate", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen", "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end", "semi-condensed", "semi-expanded", "separate", "sepia", "serif", "show", "sidama", "simp-chinese-formal", "simp-chinese-informal", "single", "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal", "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow", "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali", "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square", "square-button", "start", "static", "status-bar", "stretch", "stroke", "stroke-box", "sub", "subpixel-antialiased", "svg_masks", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row", "table-row-group", "tamil", "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai", "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er", "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top", "trad-chinese-formal", "trad-chinese-informal", "transform", "translate", "translate3d", "translateX", "translateY", "translateZ", "transparent", "ultra-condensed", "ultra-expanded", "underline", "unidirectional-pan", "unset", "up", "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal", "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url", "var", "vertical", "vertical-text", "view-box", "visible", "visibleFill", "visiblePainted", "visibleStroke", "visual", "w-resize", "wait", "wave", "wider", "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor", "xx-large", "xx-small"],
          y = e(b),
          w = n.concat(i).concat(a).concat(c).concat(u).concat(h).concat(v).concat(b);
        function x(t, e) {
          for (var n, r = !1; null != (n = t.next());) {
            if (r && "/" == n) {
              e.tokenize = null;
              break;
            }
            r = "*" == n;
          }
          return ["comment", "comment"];
        }
        t.registerHelper("hintWords", "css", w), t.defineMIME("text/css", {
          documentTypes: r,
          mediaTypes: o,
          mediaFeatures: s,
          mediaValueKeywords: l,
          propertyKeywords: d,
          nonStandardPropertyKeywords: f,
          fontProperties: p,
          counterDescriptors: g,
          colorKeywords: m,
          valueKeywords: y,
          tokenHooks: {
            "/": function _(t, e) {
              return !!t.eat("*") && (e.tokenize = x, x(t, e));
            }
          },
          name: "css"
        }), t.defineMIME("text/x-scss", {
          mediaTypes: o,
          mediaFeatures: s,
          mediaValueKeywords: l,
          propertyKeywords: d,
          nonStandardPropertyKeywords: f,
          colorKeywords: m,
          valueKeywords: y,
          fontProperties: p,
          allowNested: !0,
          lineComment: "//",
          tokenHooks: {
            "/": function _(t, e) {
              return t.eat("/") ? (t.skipToEnd(), ["comment", "comment"]) : t.eat("*") ? (e.tokenize = x, x(t, e)) : ["operator", "operator"];
            },
            ":": function _(t) {
              return !!t.match(/^\s*\{/, !1) && [null, null];
            },
            $: function $(t) {
              return t.match(/^[\w-]+/), t.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"];
            },
            "#": function _(t) {
              return !!t.eat("{") && [null, "interpolation"];
            }
          },
          name: "css",
          helperType: "scss"
        }), t.defineMIME("text/x-less", {
          mediaTypes: o,
          mediaFeatures: s,
          mediaValueKeywords: l,
          propertyKeywords: d,
          nonStandardPropertyKeywords: f,
          colorKeywords: m,
          valueKeywords: y,
          fontProperties: p,
          allowNested: !0,
          lineComment: "//",
          tokenHooks: {
            "/": function _(t, e) {
              return t.eat("/") ? (t.skipToEnd(), ["comment", "comment"]) : t.eat("*") ? (e.tokenize = x, x(t, e)) : ["operator", "operator"];
            },
            "@": function _(t) {
              return t.eat("{") ? [null, "interpolation"] : !t.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, !1) && (t.eatWhile(/[\w\\\-]/), t.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"]);
            },
            "&": function _() {
              return ["atom", "atom"];
            }
          },
          name: "css",
          helperType: "less"
        }), t.defineMIME("text/x-gss", {
          documentTypes: r,
          mediaTypes: o,
          mediaFeatures: s,
          propertyKeywords: d,
          nonStandardPropertyKeywords: f,
          fontProperties: p,
          counterDescriptors: g,
          colorKeywords: m,
          valueKeywords: y,
          supportsAtComponent: !0,
          tokenHooks: {
            "/": function _(t, e) {
              return !!t.eat("*") && (e.tokenize = x, x(t, e));
            }
          },
          name: "css",
          helperType: "gss"
        });
      }(n(13));
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          confirm("Are you sure to clean the canvas?") && (t.Storage.getCurrentStorage().attributes.isDeleteContent = !0, t.DomComponents.clear(), t.CssComposer.clear(), t.store());
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0),
        i = n(3),
        o = n(17);
      e.default = {
        run: function run(t) {
          Object(r.bindAll)(this, "onKeyUp", "enableDragger", "disableDragger"), this.editor = t, this.canvasModel = this.canvas.getCanvasView().model, this.toggleMove(1);
        },
        stop: function stop(t) {
          this.toggleMove(), this.disableDragger();
        },
        onKeyUp: function onKeyUp(t) {
          " " === Object(i.f)(t) && this.editor.stopCommand(this.id);
        },
        enableDragger: function enableDragger(t) {
          this.toggleDragger(1, t);
        },
        disableDragger: function disableDragger(t) {
          this.toggleDragger(0, t);
        },
        toggleDragger: function toggleDragger(t, e) {
          var n = this.canvasModel,
            r = this.em,
            i = this.dragger,
            a = t ? "add" : "remove";
          this.getCanvas().classList[a]("".concat(this.ppfx, "is__grabbing")), i || (i = new o.a({
            getPosition: function getPosition() {
              return {
                x: n.get("x"),
                y: n.get("y")
              };
            },
            setPosition: function setPosition(t) {
              var e = t.x,
                r = t.y;
              n.set({
                x: e,
                y: r
              });
            },
            onStart: function onStart(t, e) {
              r.trigger("canvas:move:start", e);
            },
            onDrag: function onDrag(t, e) {
              r.trigger("canvas:move", e);
            },
            onEnd: function onEnd(t, e) {
              r.trigger("canvas:move:end", e);
            }
          }), this.dragger = i), t ? i.start(e) : i.stop();
        },
        toggleMove: function toggleMove(t) {
          var e = this.ppfx,
            n = t ? "add" : "remove",
            r = t ? "on" : "off",
            o = {
              on: i.u,
              off: i.t
            },
            a = this.getCanvas(),
            s = ["".concat(e, "is__grab")];
          !t && s.push("".concat(e, "is__grabbing")), s.forEach(function (t) {
            return a.classList[n](t);
          }), o[r](document, "keyup", this.onKeyUp), o[r](a, "mousedown", this.enableDragger), o[r](document, "mouseup", this.disableDragger);
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(9),
        i = n.n(r),
        o = n(0);
      e.default = {
        run: function run(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            a = r.component || t.getSelectedAll();
          a = Object(o.isArray)(a) ? i()(a) : [a];
          var s = "",
            c = t.getComponents();
          if (c && 1 == c.length) {
            var l = t.getSelected();
            if ((s = l ? l.parent() : "") && !s.collection) return alert("Alert! The removal of the main component from a page is currently restricted.\n\nPlease click the Clear icon on the top bar if you like to Clear the page content."), this.em.logWarning("Alert! The removal of the main component from a page is currently restricted.\n\nPlease click the Clear icon on the top bar if you like to Clear the page content.", {
              component: l
            });
          }
          return t.select(null), a.forEach(function (t) {
            if (!t || !t.get("removable")) return n.em.logWarning("The element is not removable", {
              component: t
            });
            t.remove();
          }), a;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(0),
        a = n(17);
      function s(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function c(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? s(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = {
        run: function run(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          Object(o.bindAll)(this, "setPosition", "onStart", "onDrag", "onEnd", "getPosition", "getGuidesStatic", "renderGuide", "getGuidesTarget");
          var i = r.target,
            s = r.event,
            l = r.mode,
            u = r.dragger,
            d = void 0 === u ? {} : u,
            h = i.getEl(),
            f = c({
              doc: h.ownerDocument,
              onStart: this.onStart,
              onEnd: this.onEnd,
              onDrag: this.onDrag,
              getPosition: this.getPosition,
              setPosition: this.setPosition,
              guidesStatic: function guidesStatic() {
                return n.guidesStatic;
              },
              guidesTarget: function guidesTarget() {
                return n.guidesTarget;
              }
            }, d);
          this.setupGuides(), this.opts = r, this.editor = t, this.em = t.getModel(), this.target = i, this.isTran = "translate" == l, this.guidesContainer = this.getGuidesContainer(), this.guidesTarget = this.getGuidesTarget(), this.guidesStatic = this.getGuidesStatic();
          var p = this.dragger;
          return p ? p.setOptions(f) : (p = new a.a(f), this.dragger = p), s && p.start(s), this.toggleDrag(1), this.em.trigger("".concat("dmode", ":start"), this.getEventOpts()), p;
        },
        getEventOpts: function getEventOpts() {
          return {
            mode: this.opts.mode,
            target: this.target,
            guidesTarget: this.guidesTarget,
            guidesStatic: this.guidesStatic
          };
        },
        stop: function stop() {
          this.toggleDrag();
        },
        setupGuides: function setupGuides() {
          (this.guides || []).forEach(function (t) {
            var e = t.guide;
            e && e.parentNode.removeChild(e);
          }), this.guides = [];
        },
        getGuidesContainer: function getGuidesContainer() {
          var t = this,
            e = this.guidesEl;
          if (!e) {
            var n = this.editor,
              r = this.em,
              i = this.opts,
              a = n.getConfig("stylePrefix"),
              s = document.createElement("div"),
              c = document.createElement("div"),
              l = '<div class="'.concat(a, "guide-info__line ").concat(a, 'danger-bg">\n        <div class="').concat(a, "guide-info__content ").concat(a, 'danger-color"></div>\n      </div>');
            (e = document.createElement("div")).className = "".concat(a, "guides"), s.className = "".concat(a, "guide-info ").concat(a, "guide-info__x"), c.className = "".concat(a, "guide-info ").concat(a, "guide-info__y"), s.innerHTML = l, c.innerHTML = l, e.appendChild(s), e.appendChild(c), n.Canvas.getGlobalToolsEl().appendChild(e), this.guidesEl = e, this.elGuideInfoX = s, this.elGuideInfoY = c, this.elGuideInfoContentX = s.querySelector(".".concat(a, "guide-info__content")), this.elGuideInfoContentY = c.querySelector(".".concat(a, "guide-info__content")), r.on("canvas:update frame:scroll", Object(o.debounce)(function () {
              t.updateGuides(), i.debug && t.guides.forEach(function (e) {
                return t.renderGuide(e);
              });
            }, 200));
          }
          return e;
        },
        getGuidesStatic: function getGuidesStatic() {
          var t = this,
            e = [],
            n = this.target.getEl(),
            r = n.parentNode,
            i = void 0 === r ? {} : r;
          return Object(o.each)(i.children, function (r) {
            return e = e.concat(n !== r ? t.getElementGuides(r) : []);
          }), e.concat(this.getElementGuides(i));
        },
        getGuidesTarget: function getGuidesTarget() {
          return this.getElementGuides(this.target.getEl());
        },
        updateGuides: function updateGuides(t) {
          var e,
            n,
            r = this;
          (t || this.guides).forEach(function (t) {
            var i = t.origin,
              a = e === i ? n : r.getElementPos(i);
            e = i, n = a, Object(o.each)(r.getGuidePosUpdate(t, a), function (e, n) {
              return t[n] = e;
            }), t.originRect = a;
          });
        },
        getGuidePosUpdate: function getGuidePosUpdate(t, e) {
          var n = {},
            r = e.top,
            i = e.height,
            o = e.left,
            a = e.width;
          switch (t.type) {
            case "t":
              n.y = r;
              break;
            case "b":
              n.y = r + i;
              break;
            case "l":
              n.x = o;
              break;
            case "r":
              n.x = o + a;
              break;
            case "x":
              n.x = o + a / 2;
              break;
            case "y":
              n.y = r + i / 2;
          }
          return n;
        },
        renderGuide: function renderGuide() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.guide || document.createElement("div"),
            n = "px",
            r = t.active ? 2 : 1,
            i = e.children[0];
          return e.style = "position: absolute; background-color: ".concat(t.active ? "green" : "red", ";"), e.children.length || ((i = document.createElement("div")).style = "position: absolute; color: red; padding: 5px; top: 0; left: 0;", e.appendChild(i)), t.y ? (e.style.width = "100%", e.style.height = "".concat(r).concat(n), e.style.top = "".concat(t.y).concat(n), e.style.left = 0) : (e.style.width = "".concat(r).concat(n), e.style.height = "100%", e.style.left = "".concat(t.x).concat(n), e.style.top = "0".concat(n)), !t.guide && this.guidesContainer.appendChild(e), e;
        },
        getElementPos: function getElementPos(t) {
          return this.editor.Canvas.getElementPos(t, {
            noScroll: 1
          });
        },
        getElementGuides: function getElementGuides(t) {
          var e = this,
            n = this.opts,
            r = this.getElementPos(t),
            i = r.top,
            o = r.height,
            a = r.left,
            s = r.width,
            l = [{
              type: "t",
              y: i
            }, {
              type: "b",
              y: i + o
            }, {
              type: "l",
              x: a
            }, {
              type: "r",
              x: a + s
            }, {
              type: "x",
              x: a + s / 2
            }, {
              type: "y",
              y: i + o / 2
            }].map(function (i) {
              return c(c({}, i), {}, {
                origin: t,
                originRect: r,
                guide: n.debug && e.renderGuide(i)
              });
            });
          return l.forEach(function (t) {
            return e.guides.push(t);
          }), l;
        },
        getTranslate: function getTranslate(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x",
            n = 0;
          return (t || "").split(" ").forEach(function (t) {
            var r = t.trim(),
              i = "translate".concat(e.toUpperCase(), "(");
            0 === r.indexOf(i) && (n = parseFloat(r.replace(i, "")));
          }), n;
        },
        setTranslate: function setTranslate(t, e, n) {
          var r = "translate".concat(e.toUpperCase(), "("),
            i = "".concat(r).concat(n, ")"),
            o = (t || "").split(" ").map(function (t) {
              return 0 === t.trim().indexOf(r) && (t = i), t;
            }).join(" ");
          return o.indexOf(r) < 0 && (o += " ".concat(i)), o;
        },
        getPosition: function getPosition() {
          var t = this.target,
            e = this.isTran,
            n = t.getStyle(),
            r = n.left,
            i = n.top,
            o = n.transform,
            a = 0,
            s = 0;
          return e ? (a = this.getTranslate(o), s = this.getTranslate(o, "y")) : (a = parseFloat(r), s = parseFloat(i)), {
            x: a,
            y: s
          };
        },
        setPosition: function setPosition(t) {
          var e = t.x,
            n = t.y,
            r = t.end,
            i = t.position,
            a = t.width,
            s = t.height,
            c = this.target,
            l = this.isTran,
            u = r ? "" : 1,
            d = "".concat(e).concat("px"),
            h = "".concat(n).concat("px");
          if (l) {
            var f = c.getStyle().transform || "";
            return f = this.setTranslate(f, "x", d), f = this.setTranslate(f, "y", h), c.addStyle({
              transform: f,
              en: u
            }, {
              avoidStore: !r
            });
          }
          var p = {
              position: i,
              width: a,
              height: s
            },
            g = {
              left: d,
              top: h,
              en: u
            };
          Object(o.keys)(p).forEach(function (t) {
            var e = p[t];
            e && (g[t] = e);
          }), c.addStyle(g, {
            avoidStore: !r
          });
        },
        _getDragData: function _getDragData() {
          var t = this.target;
          return {
            target: t,
            parent: t.parent(),
            index: t.index()
          };
        },
        onStart: function onStart() {
          var t = this.target,
            e = this.editor,
            n = this.isTran,
            r = this.opts,
            i = r.center,
            o = r.onStart,
            a = e.Canvas,
            s = t.getStyle();
          if (o && o(this._getDragData()), !n && "absolute" !== s.position) {
            var c = a.offset(t.getEl()),
              l = c.left,
              u = c.top,
              d = c.width,
              h = c.height;
            if (i) {
              var f = a.getMouseRelativeCanvas(event);
              l = f.x, u = f.y;
            }
            this.setPosition({
              x: l,
              y: u,
              width: "".concat(d, "px"),
              height: "".concat(h, "px"),
              position: "absolute"
            });
          }
        },
        onDrag: function onDrag() {
          var t = this,
            e = this.guidesTarget,
            n = this.opts,
            r = n.onDrag;
          this.updateGuides(e), n.debug && e.forEach(function (e) {
            return t.renderGuide(e);
          }), n.guidesInfo && this.renderGuideInfo(e.filter(function (t) {
            return t.active;
          })), r && r(this._getDragData());
        },
        onEnd: function onEnd(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.editor,
            i = this.opts,
            o = this.id,
            a = i.onEnd;
          a && a(t, n, c(c({
            event: t
          }, n), this._getDragData())), r.stopCommand(o), this.hideGuidesInfo(), this.em.trigger("".concat("dmode", ":end"), this.getEventOpts());
        },
        hideGuidesInfo: function hideGuidesInfo() {
          var t = this;
          ["X", "Y"].forEach(function (e) {
            var n = t["elGuideInfo".concat(e)];
            n && (n.style.display = "none");
          });
        },
        renderGuideInfo: function renderGuideInfo() {
          var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            n = this.guidesStatic;
          this.hideGuidesInfo(), e.forEach(function (e) {
            var r = e.origin,
              i = e.x,
              a = t.getElementPos(r),
              s = Object(o.isUndefined)(i) ? "y" : "x",
              l = "y" === s,
              u = a[l ? "left" : "top"],
              d = a.rect[l ? "left" : "top"],
              h = l ? u + a.width : u + a.height,
              f = l ? d + a.rect.width : d + a.rect.height,
              p = t["elGuideInfo".concat(s.toUpperCase())],
              g = t["elGuideInfoContent".concat(s.toUpperCase())],
              v = p.style,
              m = n.filter(function (t) {
                return t.type === e.type;
              }).map(function (t) {
                var e = t.originRect,
                  n = e.left,
                  r = e.width,
                  i = e.top,
                  o = e.height,
                  a = l ? n + r : i + o;
                return {
                  gap: a < u ? u - a : (l ? n : i) - h,
                  guide: t
                };
              }).filter(function (t) {
                return t.gap > 0;
              }).sort(function (t, e) {
                return t.gap - e.gap;
              }).map(function (t) {
                return t.guide;
              })[0];
            if (m) {
              var b = m.originRect,
                y = b.left,
                w = b.width,
                x = b.top,
                O = b.height,
                C = b.rect,
                S = l ? y < a.left : x < a.top,
                k = l ? y : x,
                T = l ? C.left : C.top,
                j = l ? y + w : x + O,
                E = l ? C.left + C.width : C.top + C.height,
                P = l ? e.y : e.x,
                A = S ? j : h,
                M = "".concat(P, "px"),
                D = S ? u - j : k - h,
                L = S ? d - E : T - f;
              v.display = "", v[l ? "top" : "left"] = M, v[l ? "left" : "top"] = "".concat(A, "px"), v[l ? "width" : "height"] = "".concat(D, "px"), g.innerHTML = "".concat(Math.round(L), "px"), t.em.trigger("".concat("dmode", ":active"), c(c({}, t.getEventOpts()), {}, {
                guide: e,
                guidesStatic: n,
                matched: m,
                posFirst: P,
                posSecond: A,
                size: D,
                sizeRaw: L,
                elGuideInfo: p,
                elGuideInfoCnt: g
              }));
            }
          });
        },
        toggleDrag: function toggleDrag(t) {
          var e = this.ppfx,
            n = this.editor,
            r = t ? "add" : "remove",
            i = ["".concat(e, "is__grabbing")],
            o = n.Canvas,
            a = o.getBody();
          i.forEach(function (t) {
            return a.classList[r](t);
          }), o[t ? "startAutoscroll" : "stopAutoscroll"]();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          if (t.Canvas.hasFocus()) {
            var e = [];
            t.getSelectedAll().forEach(function (t) {
              var n = t.components(),
                r = n && n.at(0);
              r && e.push(r);
            }), e.length && t.select(e);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (t.Canvas.hasFocus() || n.force) {
            var r = [];
            t.getSelectedAll().forEach(function (t) {
              for (var e = t.parent(); e && !e.get("selectable");) e = e.parent();
              e && r.push(e);
            }), r.length && t.select(r);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          if (t.Canvas.hasFocus()) {
            var e = [];
            t.getSelectedAll().forEach(function (t) {
              var n = t.collection,
                r = n.indexOf(t),
                i = n.at(r + 1);
              e.push(i || t);
            }), e.length && t.select(e);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          if (t.Canvas.hasFocus()) {
            var e = [];
            t.getSelectedAll().forEach(function (t) {
              var n = t.collection,
                r = n.indexOf(t),
                i = n.at(r - 1);
              e.push(i && r - 1 >= 0 ? i : t);
            }), e.length && t.select(e);
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0);
      e.default = {
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = n.target,
            o = t.DomComponents,
            a = i.get("type"),
            s = o.getWrapper().findType(a).length,
            c = [];
          if (!s) {
            var l = t.CssComposer.getAll(),
              u = i.get("style-signature");
            u = Object(r.isArray)(u) ? u : [u], l.forEach(function (t) {
              var e = t.selectorsToString();
              u.forEach(function (n) {
                n && e.indexOf(n) >= 0 && c.push(t);
              });
            }), l.remove(c);
          }
          return c;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(9),
        i = n.n(r);
      e.default = {
        run: function run(t) {
          var e = t.getModel(),
            n = i()(t.getSelectedAll());
          n.length && e.set("clipboard", n);
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0),
        i = n(1),
        o = n.n(i),
        a = n(14),
        s = o.a.$;
      e.default = Object(r.extend)({}, a.default, {
        init: function init(t) {
          Object(r.bindAll)(this, "startDelete", "stopDelete", "onDelete"), this.hoverClass = this.pfx + "hover-delete", this.badgeClass = this.pfx + "badge-red";
        },
        enable: function enable() {
          this.$el.find("*").mouseover(this.startDelete).mouseout(this.stopDelete).click(this.onDelete);
        },
        startDelete: function startDelete(t) {
          t.stopPropagation();
          var e = s(t.target);
          e.data("model").get("removable") && (e.addClass(this.hoverClass), this.attachBadge(e.get(0)));
        },
        stopDelete: function stopDelete(t) {
          t.stopPropagation(), s(t.target).removeClass(this.hoverClass), this.badge && this.badge.css({
            left: -1e3,
            top: -1e3
          });
        },
        onDelete: function onDelete(t) {
          t.stopPropagation();
          var e = s(t.target);
          e.data("model").get("removable") && (e.data("model").destroy(), this.removeBadge(), this.clean());
        },
        updateBadgeLabel: function updateBadgeLabel(t) {
          this.badge.html("Remove " + t.getName());
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Desktop");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Mobile landscape");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Mobile portrait");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          t.setDevice("Tablet");
        },
        stop: function stop() {}
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r).a.$;
      e.default = {
        run: function run(t, e) {
          var n = this;
          e && e.set && e.set("active", 0);
          var r = t.getConfig(),
            o = t.Modal,
            a = r.stylePrefix;
          if (this.cm = t.CodeManager || null, !this.$editors) {
            var s = this.buildEditor("htmlmixed", "hopscotch", "HTML"),
              c = this.buildEditor("css", "hopscotch", "CSS");
            this.htmlEditor = s.el, this.cssEditor = c.el;
            var l = i('<div class="'.concat(a, 'export-dl"></div>'));
            l.append(s.$el).append(c.$el), this.$editors = l;
          }
          o.open({
            title: r.textViewCode,
            content: this.$editors
          }).getModel().once("change:open", function () {
            return t.stopCommand(n.id);
          }), this.htmlEditor.setContent(t.getHtml()), this.cssEditor.setContent(t.getCss());
        },
        stop: function stop(t) {
          var e = t.Modal;
          e && e.close();
        },
        buildEditor: function buildEditor(t, e, n) {
          var r = document.createElement("textarea");
          !this.codeMirror && (this.codeMirror = this.cm.getViewer("CodeMirror"));
          var i = this.codeMirror.clone().set({
              label: n,
              codeName: t,
              theme: e,
              input: r
            }),
            o = new this.cm.EditorView({
              model: i,
              config: this.cm.getConfig()
            }).render().$el;
          return i.init(r), {
            el: i,
            $el: o
          };
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0);
      e.default = {
        isEnabled: function isEnabled() {
          var t = document;
          return t.fullscreenElement || t.webkitFullscreenElement || t.mozFullScreenElement ? 1 : 0;
        },
        enable: function enable(t) {
          var e = "";
          return t.requestFullscreen ? t.requestFullscreen() : t.webkitRequestFullscreen ? (e = "webkit", t.webkitRequestFullscreen()) : t.mozRequestFullScreen ? (e = "moz", t.mozRequestFullScreen()) : t.msRequestFullscreen ? t.msRequestFullscreen() : console.warn("Fullscreen not supported"), e;
        },
        disable: function disable() {
          var t = document;
          this.isEnabled() && (t.exitFullscreen ? t.exitFullscreen() : t.webkitExitFullscreen ? t.webkitExitFullscreen() : t.mozCancelFullScreen ? t.mozCancelFullScreen() : t.msExitFullscreen && t.msExitFullscreen());
        },
        fsChanged: function fsChanged(t, e) {
          document;
          var n = (t || "") + "fullscreenchange";
          this.isEnabled() || (this.stop(null, this.sender), document.removeEventListener(n, this.fsChanged));
        },
        run: function run(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.sender = e;
          var i = n.target,
            o = Object(r.isElement)(i) ? i : document.querySelector(i),
            a = this.enable(o || t.getContainer());
          this.fsChanged = this.fsChanged.bind(this, a), document.addEventListener(a + "fullscreenchange", this.fsChanged), t.trigger("change:canvasOffset");
        },
        stop: function stop(t, e) {
          e && e.set && e.set("active", !1), this.disable(), t && t.trigger("change:canvasOffset");
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0),
        i = n(1),
        o = n.n(i),
        a = n(3),
        s = n(14),
        c = n(27),
        l = o.a.$;
      e.default = Object(r.extend)({}, c.default, s.default, {
        init: function init(t) {
          s.default.init.apply(this, arguments), Object(r.bindAll)(this, "initSorter", "rollback", "onEndMove"), this.opt = t, this.hoverClass = this.ppfx + "highlighter-warning", this.badgeClass = this.ppfx + "badge-warning", this.noSelClass = this.ppfx + "no-select";
        },
        enable: function enable() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          s.default.enable.apply(this, e), this.getBadgeEl().addClass(this.badgeClass), this.getHighlighterEl().addClass(this.hoverClass);
          var r = this.$wrapper;
          r.css("cursor", "move"), r.on("mousedown", this.initSorter), r.addClass(this.noSelClass);
        },
        toggleClipboard: function toggleClipboard() {},
        initSorter: function initSorter(t) {
          var e = l(t.target).data("model").get("draggable");
          e && (this.cacheEl = null, this.startSelectPosition(t.target, this.frameEl.contentDocument), this.sorter.draggable = e, this.sorter.onEndMove = this.onEndMove.bind(this), this.stopSelectComponent(), this.$wrapper.off("mousedown", this.initSorter), Object(a.u)(this.getContentWindow(), "keydown", this.rollback));
        },
        initSorterFromModel: function initSorterFromModel(t) {
          var e = t.get("draggable");
          if (e) {
            this.cacheEl = null;
            var n = t.view.el;
            this.startSelectPosition(n, this.frameEl.contentDocument), this.sorter.draggable = e, this.sorter.onEndMove = this.onEndMoveFromModel.bind(this), this.stopSelectComponent(), Object(a.u)(this.getContentWindow(), "keydown", this.rollback);
          }
        },
        initSorterFromModels: function initSorterFromModels(t) {
          this.cacheEl = null;
          var e = t[t.length - 1],
            n = (this.em.get("currentFrame") || {}).model,
            r = e.getEl(n),
            i = r.ownerDocument;
          this.startSelectPosition(r, i, {
            onStart: this.onStart
          }), this.sorter.draggable = e.get("draggable"), this.sorter.toMove = t, this.sorter.onMoveClb = this.onDrag, this.sorter.onEndMove = this.onEndMoveFromModel.bind(this), this.stopSelectComponent(), Object(a.u)(this.getContentWindow(), "keydown", this.rollback);
        },
        onEndMoveFromModel: function onEndMoveFromModel() {
          Object(a.t)(this.getContentWindow(), "keydown", this.rollback);
        },
        onEndMove: function onEndMove() {
          this.enable(), Object(a.t)(this.getContentWindow(), "keydown", this.rollback);
        },
        onSelect: function onSelect(t, e) {},
        rollback: function rollback(t, e) {
          (27 == (t.which || t.keyCode) || e) && (this.sorter.moved = !1, this.sorter.endMove());
        },
        getBadgeEl: function getBadgeEl() {
          return this.$badge || (this.$badge = l(this.getBadge())), this.$badge;
        },
        getHighlighterEl: function getHighlighterEl() {
          return this.$hl || (this.$hl = l(this.canvas.getHighlighter())), this.$hl;
        },
        stop: function stop() {
          for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
          s.default.stop.apply(this, e), this.getBadgeEl().removeClass(this.badgeClass), this.getHighlighterEl().removeClass(this.hoverClass);
          var r = this.$wrapper;
          r.css("cursor", "").unbind().removeClass(this.noSelClass);
        }
      });
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e) {
          var n = this,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            i = t.Modal,
            o = t.AssetManager,
            a = o.getConfig(),
            s = o.getContainer(),
            c = r.modalTitle || t.t("assetManager.modalTitle") || "",
            l = r.types,
            u = r.accept;
          if (o.setTarget(r.target), o.onClick(r.onClick), o.onDblClick(r.onDblClick), o.onSelect(r.onSelect), !this.rendered || l) {
            var d = o.getAll().filter(function (t) {
              return 1;
            });
            l && l.length && (d = d.filter(function (t) {
              return -1 !== l.indexOf(t.get("type"));
            })), o.render(d), this.rendered = 1;
          }
          if (u) {
            var h = s.querySelector("input#".concat(a.stylePrefix, "uploadFile"));
            h && h.setAttribute("accept", u);
          }
          return i.open({
            title: c,
            content: s
          }).getModel().once("change:open", function () {
            return t.stopCommand(n.id);
          }), this;
        },
        stop: function stop(t) {
          return t.Modal.close(), this;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e) {
          var n = t.BlockManager,
            r = t.Panels;
          if (!this.blocks) {
            n.render();
            var i = "views-container",
              o = document.createElement("div"),
              a = r.getPanel(i) || r.addPanel({
                id: i
              });
            o.appendChild(n.getContainer()), a.set("appendContent", o).trigger("change:appendContent"), this.blocks = o;
          }
          this.blocks.style.display = "block";
        },
        stop: function stop() {
          var t = this.blocks;
          t && (t.style.display = "none");
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1);
      n.n(r).a.$, e.default = {
        run: function run(t) {
          var e = t.LayerManager,
            n = t.Panels;
          if (!this.layers) {
            var r = "views-container",
              i = document.createElement("div"),
              o = n.getPanel(r) || n.addPanel({
                id: r
              });
            i.appendChild(e.render()), o.set("appendContent", i).trigger("change:appendContent"), this.layers = i;
          }
          this.layers.style.display = "block";
        },
        stop: function stop() {
          var t = this.layers;
          t && (t.style.display = "none");
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r).a.$;
      e.default = {
        run: function run(t, e) {
          if (this.sender = e, !this.$cn) {
            var n = t.getConfig(),
              r = t.Panels;
            this.$cn = i("<div></div>"), this.$cn2 = i("<div></div>"), this.$cn.append(this.$cn2);
            var o = t.DeviceManager;
            o && n.showDevices && r.addPanel({
              id: "devices-c"
            }).set("appendContent", o.render()).trigger("change:appendContent");
            var a = t.SelectorManager;
            a && this.$cn2.append(a.render([])), this.$cn2.append(t.StyleManager.render());
            var s = t.StyleManager.getConfig().stylePrefix;
            this.$header = i('<div class="'.concat(s, 'header">').concat(t.t("styleManager.empty"), "</div>")), this.$cn.append(this.$header), r.getPanel("views-container") ? this.panel = r.getPanel("views-container") : this.panel = r.addPanel({
              id: "views-container"
            }), this.panel.set("appendContent", this.$cn).trigger("change:appendContent"), this.target = t.editor, this.listenTo(this.target, "component:toggled", this.toggleSm);
          }
          this.toggleSm();
        },
        toggleSm: function toggleSm() {
          var t = this.target,
            e = this.sender;
          if (!e || !e.get || e.get("active")) {
            var n = t.get("SelectorManager").getConfig().componentFirst,
              r = t.getSelectedAll().length;
            1 === r || r > 1 && n ? (this.$cn2.show(), this.$header.hide()) : (this.$cn2.hide(), this.$header.show());
          }
        },
        stop: function stop() {
          this.$cn2 && this.$cn2.hide(), this.$header && this.$header.hide();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r).a.$;
      e.default = {
        run: function run(t, e) {
          this.sender = e;
          var n = t.getModel(),
            r = t.Config.stylePrefix,
            o = t.TraitManager;
          if (!this.$cn) {
            var a = o.getTraitsViewer(),
              s = o.getConfig();
            this.$cn = i("<div></div>"), this.$cn2 = i("<div></div>"), this.$cn.append(this.$cn2), this.$header = i("<div>").append('<div class="'.concat(s.stylePrefix, 'header">').concat(n.t("traitManager.empty"), "</div>")), this.$cn.append(this.$header), this.$cn2.append('<div class="'.concat(r, 'traits-label">').concat(n.t("traitManager.label"), "</div>")), this.$cn2.append(a.render().el);
            var c = t.Panels;
            (c.getPanel("views-container") ? c.getPanel("views-container") : c.addPanel({
              id: "views-container"
            })).set("appendContent", this.$cn.get(0)).trigger("change:appendContent"), this.target = t.getModel(), this.listenTo(this.target, "component:toggled", this.toggleTm);
          }
          this.toggleTm();
        },
        toggleTm: function toggleTm() {
          var t = this.sender;
          t && t.get && !t.get("active") || (1 === this.target.getSelectedAll().length ? (this.$cn2.show(), this.$header.hide()) : (this.$cn2.hide(), this.$header.show()));
        },
        stop: function stop() {
          this.$cn2 && this.$cn2.hide(), this.$header && this.$header.hide();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0);
      e.default = {
        run: function run(t) {
          var e = t.getModel().get("clipboard"),
            n = t.getSelected();
          e && n && (t.getSelectedAll().forEach(function (n) {
            if (n) {
              var i,
                o = n.collection,
                a = o.indexOf(n) + 1,
                s = e.filter(function (t) {
                  return t.get("copyable");
                });
              i = Object(r.contains)(e, n) && n.get("copyable") ? o.add(n.clone(), {
                at: a
              }) : o.add(s.map(function (t) {
                return t.clone();
              }), {
                at: a
              }), (i = Object(r.isArray)(i) ? i : [i]).forEach(function (e) {
                return t.trigger("component:paste", e);
              });
            }
          }), n.emitUpdate());
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0),
        i = "sw-visibility";
      e.default = {
        getPanels: function getPanels(t) {
          return this.panels || (this.panels = t.Panels.getPanels()), this.panels;
        },
        preventDrag: function preventDrag(t) {
          t.abort = 1;
        },
        tglPointers: function tglPointers(t, e) {
          var n = t.Canvas.getBody().querySelectorAll(".".concat(this.ppfx, "no-pointer"));
          Object(r.each)(n, function (t) {
            return t.style.pointerEvents = e ? "" : "all";
          });
        },
        tglEffects: function tglEffects(t) {
          var e = this.em;
          e && e[t ? "on" : "off"]("run:tlb-move:before", this.preventDrag);
        },
        run: function run(t, e) {
          var n = this;
          this.sender = e, this.shouldRunSwVisibility || (this.shouldRunSwVisibility = t.Commands.isActive(i)), this.shouldRunSwVisibility && t.stopCommand(i), t.getModel().stopDefault();
          var r = this.getPanels(t),
            o = t.Canvas.getElement(),
            a = t.getEl(),
            s = t.Config.stylePrefix;
          if (!this.helper) {
            var c = document.createElement("span");
            c.className = "".concat(s, "off-prv fa fa-eye-slash"), a.appendChild(c), c.onclick = function () {
              return n.stopCommand();
            }, this.helper = c;
          }
          this.helper.style.display = "inline-block", this.tglPointers(t), r.forEach(function (t) {
            return t.set("visible", !1);
          });
          var l = o.style;
          l.width = "100%", l.height = "100%", l.top = "0", l.left = "0", l.padding = "0", l.margin = "0", t.refresh(), this.tglEffects(1);
        },
        stop: function stop(t) {
          var e = this.sender,
            n = void 0 === e ? {} : e;
          n.set && n.set("active", 0);
          var r = this.getPanels(t);
          this.shouldRunSwVisibility && (t.runCommand(i), this.shouldRunSwVisibility = !1), t.getModel().runDefault(), r.forEach(function (t) {
            return t.set("visible", !0);
          }), t.Canvas.getElement().setAttribute("style", ""), this.helper && (this.helper.style.display = "none"), t.refresh(), this.tglPointers(t, 1), this.tglEffects();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t, e, n) {
          var r = n || {},
            i = r.el || "",
            o = t.Canvas,
            a = this.canvasResizer,
            s = r.options || {},
            c = o.getCanvasView();
          return s.appendTo = o.getResizerEl(), s.prefix = t.getConfig().stylePrefix, s.posFetcher = c.getElementPos.bind(c), s.mousePosFetcher = o.getMouseRelativePos, a && !r.forceNew || (this.canvasResizer = t.Utils.Resizer.init(s), a = this.canvasResizer), a.setOptions(s), a.blur(), a.focus(i), a;
        },
        stop: function stop() {
          var t = this.canvasResizer;
          t && t.blur();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          var e = t.Storage.getCurrentStorage();
          e.attributes.isDeleteContent && (e.attributes.isDeleteContent = !1), t.store();
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(1),
        a = n.n(o),
        s = n(0),
        c = n(3);
      function l(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      var u = a.a.$;
      e.default = {
        getOffsetMethod: function getOffsetMethod(t) {
          return "get" + (t || "") + "OffsetViewerEl";
        },
        run: function run(t, e, n) {
          var r = n || {},
            o = r.state || "",
            a = t.getConfig(),
            d = this.em.getZoomDecimal(),
            h = r.el || "";
          if (!a.showOffsets || Object(c.q)(h) || !a.showOffsetsSelected && "Fixed" == o) t.stopCommand(this.id, n);else {
            var f = t.Canvas,
              p = function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var n = null != arguments[e] ? arguments[e] : {};
                  e % 2 ? l(Object(n), !0).forEach(function (e) {
                    i()(t, e, n[e]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                  });
                }
                return t;
              }({}, r.elPos || f.getElementPos(h));
            Object(s.isUndefined)(r.top) || (p.top = r.top), Object(s.isUndefined)(r.left) || (p.left = r.left);
            var g = window.getComputedStyle(h),
              v = this.ppfx,
              m = o + "State",
              b = f[this.getOffsetMethod(o)](n.view);
            b.style.opacity = "";
            var y = this["marginT" + o],
              w = this["marginB" + o],
              x = this["marginL" + o],
              O = this["marginR" + o],
              C = this["padT" + o],
              S = this["padB" + o],
              k = this["padL" + o],
              T = this["padR" + o];
            if (b.childNodes.length && (this[m] = "1", y = b.querySelector("[data-offset-m-t]"), w = b.querySelector("[data-offset-m-b]"), x = b.querySelector("[data-offset-m-l]"), O = b.querySelector("[data-offset-m-r]"), C = b.querySelector("[data-offset-p-t]"), S = b.querySelector("[data-offset-p-b]"), k = b.querySelector("[data-offset-p-l]"), T = b.querySelector("[data-offset-p-r]")), !this[m]) {
              var j = o.toLowerCase(),
                E = j + "margin-v",
                P = j + "padding-v",
                A = u('<div class="'.concat(v, 'marginName">')).get(0),
                M = u('<div class="'.concat(v, 'paddingName">')).get(0),
                D = v + P + "-el",
                L = "".concat(v + E + "-el", " ").concat(v + E),
                _ = "".concat(D, " ").concat(v + P);
              y = u('<div class="'.concat(L, '-top"></div>')).get(0), w = u('<div class="'.concat(L, '-bottom"></div>')).get(0), x = u('<div class="'.concat(L, '-left"></div>')).get(0), O = u('<div class="'.concat(L, '-right"></div>')).get(0), C = u('<div class="'.concat(_, '-top"></div>')).get(0), S = u('<div class="'.concat(_, '-bottom"></div>')).get(0), k = u('<div class="'.concat(_, '-left"></div>')).get(0), T = u('<div class="'.concat(_, '-right"></div>')).get(0), this["marginT" + o] = y, this["marginB" + o] = w, this["marginL" + o] = x, this["marginR" + o] = O, this["padT" + o] = C, this["padB" + o] = S, this["padL" + o] = k, this["padR" + o] = T, A.appendChild(y), A.appendChild(w), A.appendChild(x), A.appendChild(O), M.appendChild(C), M.appendChild(S), M.appendChild(k), M.appendChild(T), b.appendChild(A), b.appendChild(M), this[m] = "1";
            }
            var N = parseFloat(g.marginLeft.replace("px", "")) * d,
              I = parseFloat(g.marginRight.replace("px", "")) * d,
              R = parseFloat(g.marginTop.replace("px", "")) * d,
              F = parseFloat(g.marginBottom.replace("px", "")) * d,
              V = y.style,
              z = w.style,
              H = x.style,
              B = O.style,
              U = C.style,
              $ = S.style,
              W = k.style,
              q = T.style,
              G = parseFloat(p.left),
              Y = parseFloat(g.width) * d + "px";
            V.height = R + "px", V.width = Y, V.top = p.top - R + "px", V.left = G + "px", z.height = F + "px", z.width = Y, z.top = p.top + p.height + "px", z.left = G + "px";
            var K = p.height + R + F + "px",
              X = p.top - R + "px";
            H.height = K, H.width = N + "px", H.top = X, H.left = G - N + "px", B.height = K, B.width = I + "px", B.top = X, B.left = G + p.width + "px";
            var J = parseFloat(g.paddingTop) * d;
            U.height = J + "px";
            var Z = parseFloat(g.paddingBottom) * d;
            $.height = Z + "px";
            var Q = p.height - Z - J + "px",
              tt = p.top + J + "px";
            W.height = Q, W.width = parseFloat(g.paddingLeft) * d + "px", W.top = tt;
            var et = parseFloat(g.paddingRight) * d;
            q.height = Q, q.width = et + "px", q.top = tt;
          }
        },
        stop: function stop(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = n || {},
            i = r.state || "",
            o = this.getOffsetMethod(i),
            a = t.Canvas,
            s = a[o](n.view);
          s.style.opacity = 0;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e), e.default = {
        run: function run(t) {
          this.toggleVis(t);
        },
        stop: function stop(t) {
          this.toggleVis(t, 0);
        },
        toggleVis: function toggleVis(t) {
          var e = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          if (!t.Commands.isActive("preview")) {
            var r = n ? "add" : "remove";
            t.Canvas.getFrames().forEach(function (t) {
              t.view.getBody().classList[r]("".concat(e.ppfx, "dashed"));
            });
          }
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = {
          stylePrefix: "",
          appendTo: "",
          sortable: 1,
          hidable: 1,
          hideTextnode: 1,
          root: "",
          showWrapper: 1,
          showHover: 1,
          scrollCanvas: {
            behavior: "smooth",
            block: "nearest"
          },
          scrollLayers: {
            behavior: "auto",
            block: "nearest"
          },
          highlightHover: 1
        },
        a = n(36),
        s = n(0);
      function c(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function l(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? c(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          name: "LayerManager",
          init: function init() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return (n = l(l({}, o), e)).stylePrefix = e.pStylePrefix, t = n.em, this;
          },
          getConfig: function getConfig() {
            return n;
          },
          onLoad: function onLoad() {
            e = new a.a({
              level: 0,
              config: n,
              opened: n.opened || {},
              model: t.get("DomComponents").getWrapper()
            }), t && t.on("component:selected", this.componentChanged), this.componentChanged();
          },
          postRender: function postRender() {
            var t = n.appendTo,
              e = n.root;
            e && this.setRoot(e), t && (Object(s.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
          },
          setRoot: function setRoot(t) {
            return e.setRoot(t), this;
          },
          getRoot: function getRoot() {
            return e.model;
          },
          getAll: function getAll() {
            return e;
          },
          componentChanged: function componentChanged(e) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!r.fromLayers) {
              var i = t.get("opened"),
                o = t.getSelected(),
                a = n.scrollLayers,
                s = o && o.collection ? o.collection.parent : null;
              for (var c in i) i[c].set("open", 0);
              for (; s;) s.set("open", 1), i[s.cid] = s, s = s.collection ? s.collection.parent : null;
              if (o && a) {
                var l = o.viewLayer && o.viewLayer.el;
                l && l.scrollIntoView(a);
              }
            }
          },
          render: function render() {
            return e.render().el;
          }
        };
      };
    }, function (t, e, n) {
      var r, i, o;
      i = [n(0), n(1)], void 0 === (o = "function" == typeof (r = function r(t, e) {
        var n = Array.prototype.slice;
        function r(t, e, n) {
          return n.length <= 4 ? t.call(e, n[0], n[1], n[2], n[3]) : t.apply(e, n);
        }
        function i(t, e) {
          return n.call(t, e);
        }
        function o(e, n) {
          return null != e && (t.isArray(n) || (n = i(arguments, 1)), t.all(n, function (t) {
            return t in e;
          }));
        }
        var a,
          s,
          c = (a = !1, s = -1, function () {
            return a || (s++, a = !0, t.defer(function () {
              a = !1;
            })), s;
          });
        function l() {
          this.registeredObjects = [], this.cidIndexes = [];
        }
        function u(e, n, r, i) {
          for (var o, a = 0, s = n.length; a < s; a++) if (o = n[a]) {
            if ("on" === e) {
              if (!i.objectRegistry.register(o)) continue;
            } else if (!i.objectRegistry.unregister(o)) continue;
            t.isFunction(o[e]) && o[e]("all", r, i);
          }
        }
        function d(e, n) {
          var r = n.type,
            i = n.undoTypes,
            o = !i[r] || i[r][e];
          t.isFunction(o) && o(n.object, n.before, n.after, n.options);
        }
        function h(e, r, i, o, a) {
          if (!(i.isCurrentlyUndoRedoing || "undo" === e && -1 === i.pointer || "redo" === e && i.pointer === i.length - 1)) {
            i.isCurrentlyUndoRedoing = !0;
            var s,
              c,
              l = "undo" === e;
            for (a ? c = l && i.pointer === i.length - 1 || !l && -1 === i.pointer ? t.clone(i.models) : n.apply(i.models, l ? [0, i.pointer] : [i.pointer, i.length - 1]) : (s = i.at(l ? i.pointer : i.pointer + 1), c = o ? i.where({
              magicFusionIndex: s.get("magicFusionIndex")
            }) : [s]), i.pointer += (l ? -1 : 1) * c.length; s = l ? c.pop() : c.shift();) s[e]();
            i.isCurrentlyUndoRedoing = !1, r.trigger(e, r);
          }
        }
        function f(t, e, n, i) {
          if (t.track && !t.isCurrentlyUndoRedoing && e in i && function (t, e) {
            var n = t.condition,
              i = typeof n;
            return "function" === i ? !!r(n, t, e) : "boolean" !== i || n;
          }(i[e], n)) {
            var a = r(i[e].on, i[e], n);
            if (o(a, "object", "before", "after")) {
              if (a.type = e, a.magicFusionIndex = c(), a.undoTypes = i, t.pointer < t.length - 1) for (var s = t.length - t.pointer - 1; s--;) t.pop();
              t.pointer = t.length, t.add(a), t.length > t.maximumStackLength && (t.shift(), t.pointer--);
            }
          }
        }
        l.prototype = {
          isRegistered: function isRegistered(e) {
            return e && e.cid ? this.registeredObjects[e.cid] : t.contains(this.registeredObjects, e);
          },
          register: function register(t) {
            return !this.isRegistered(t) && (t && t.cid ? (this.registeredObjects[t.cid] = t, this.cidIndexes.push(t.cid)) : this.registeredObjects.push(t), !0);
          },
          unregister: function unregister(e) {
            if (this.isRegistered(e)) {
              if (e && e.cid) delete this.registeredObjects[e.cid], this.cidIndexes.splice(t.indexOf(this.cidIndexes, e.cid), 1);else {
                var n = t.indexOf(this.registeredObjects, e);
                this.registeredObjects.splice(n, 1);
              }
              return !0;
            }
            return !1;
          },
          get: function get() {
            return t.map(this.cidIndexes, function (t) {
              return this.registeredObjects[t];
            }, this).concat(this.registeredObjects);
          }
        };
        var p = {
          add: {
            undo: function undo(t, e, n, r) {
              t.remove(n, r);
            },
            redo: function redo(t, e, n, r) {
              r.index && (r.at = r.index), t.add(n, r);
            },
            on: function on(e, n, r) {
              return {
                object: n,
                before: void 0,
                after: e,
                options: t.clone(r)
              };
            }
          },
          remove: {
            undo: function undo(t, e, n, r) {
              "index" in r && (r.at = r.index), t.add(e, r);
            },
            redo: function redo(t, e, n, r) {
              t.remove(e, r);
            },
            on: function on(e, n, r) {
              return {
                object: n,
                before: e,
                after: void 0,
                options: t.clone(r)
              };
            }
          },
          change: {
            undo: function undo(e, n, r, i) {
              t.isEmpty(n) ? t.each(t.keys(r), e.unset, e) : (e.set(n), i && i.unsetData && i.unsetData.before && i.unsetData.before.length && t.each(i.unsetData.before, e.unset, e));
            },
            redo: function redo(e, n, r, i) {
              t.isEmpty(r) ? t.each(t.keys(n), e.unset, e) : (e.set(r), i && i.unsetData && i.unsetData.after && i.unsetData.after.length && t.each(i.unsetData.after, e.unset, e));
            },
            on: function on(e, n) {
              var r = e.changedAttributes(),
                i = t.keys(r),
                o = t.pick(e.previousAttributes(), i),
                a = t.keys(o),
                s = (n || (n = {})).unsetData = {
                  after: [],
                  before: []
                };
              return i.length != a.length && (i.length > a.length ? t.each(i, function (t) {
                t in o || s.before.push(t);
              }, this) : t.each(a, function (t) {
                t in r || s.after.push(t);
              })), {
                object: e,
                before: o,
                after: r,
                options: t.clone(n)
              };
            }
          },
          reset: {
            undo: function undo(t, e, n) {
              t.reset(e);
            },
            redo: function redo(t, e, n) {
              t.reset(n);
            },
            on: function on(e, n) {
              return {
                object: e,
                before: n.previousModels,
                after: t.clone(e.models)
              };
            }
          }
        };
        function g() {}
        function v(e, n, r, i) {
          if ("object" == typeof n) return t.each(n, function (t, n) {
            2 === e ? v(e, t, r, i) : v(e, n, t, r);
          });
          switch (e) {
            case 0:
              o(r, "undo", "redo", "on") && t.all(t.pick(r, "undo", "redo", "on"), t.isFunction) && (i[n] = r);
              break;
            case 1:
              i[n] && t.isObject(r) && (i[n] = t.extend({}, i[n], r));
              break;
            case 2:
              delete i[n];
          }
          return this;
        }
        g.prototype = p;
        var m = e.Model.extend({
            defaults: {
              type: null,
              object: null,
              before: null,
              after: null,
              magicFusionIndex: null
            },
            undo: function undo(t) {
              d("undo", this.attributes);
            },
            redo: function redo(t) {
              d("redo", this.attributes);
            }
          }),
          b = e.Collection.extend({
            model: m,
            pointer: -1,
            track: !1,
            isCurrentlyUndoRedoing: !1,
            maximumStackLength: 1 / 0,
            setMaxLength: function setMaxLength(t) {
              this.maximumStackLength = t;
            }
          }),
          y = e.Model.extend({
            defaults: {
              maximumStackLength: 1 / 0,
              track: !1
            },
            initialize: function initialize(e) {
              this.stack = new b(), this.objectRegistry = new l(), this.undoTypes = new g(), this.stack.setMaxLength(this.get("maximumStackLength")), this.on("change:maximumStackLength", function (t, e) {
                this.stack.setMaxLength(e);
              }, this), e && e.track && this.startTracking(), e && e.register && (t.isArray(e.register) || t.isArguments(e.register) ? r(this.register, this, e.register) : this.register(e.register));
            },
            startTracking: function startTracking() {
              this.set("track", !0), this.stack.track = !0;
            },
            stopTracking: function stopTracking() {
              this.set("track", !1), this.stack.track = !1;
            },
            isTracking: function isTracking() {
              return this.get("track");
            },
            _addToStack: function _addToStack(t) {
              f(this.stack, t, i(arguments, 1), this.undoTypes);
            },
            register: function register() {
              u("on", arguments, this._addToStack, this);
            },
            unregister: function unregister() {
              u("off", arguments, this._addToStack, this);
            },
            unregisterAll: function unregisterAll() {
              r(this.unregister, this, this.objectRegistry.get());
            },
            undo: function undo(t) {
              h("undo", this, this.stack, t);
            },
            undoAll: function undoAll() {
              h("undo", this, this.stack, !1, !0);
            },
            redo: function redo(t) {
              h("redo", this, this.stack, t);
            },
            redoAll: function redoAll() {
              h("redo", this, this.stack, !1, !0);
            },
            isAvailable: function isAvailable(t) {
              var e = this.stack,
                n = e.length;
              switch (t) {
                case "undo":
                  return n > 0 && e.pointer > -1;
                case "redo":
                  return n > 0 && e.pointer < n - 1;
                default:
                  return !1;
              }
            },
            merge: function merge(e) {
              for (var n, r = t.isArray(e) ? e : i(arguments); n = r.pop();) n instanceof y && n.stack instanceof b && (n.stack = this.stack);
            },
            addUndoType: function addUndoType(t, e) {
              v(0, t, e, this.undoTypes);
            },
            changeUndoType: function changeUndoType(t, e) {
              v(1, t, e, this.undoTypes);
            },
            removeUndoType: function removeUndoType(t) {
              v(2, t, void 0, this.undoTypes);
            },
            clear: function clear() {
              this.stack.reset(), this.stack.pointer = -1;
            }
          });
        return t.extend(y, {
          defaults: function defaults(e) {
            t.extend(y.prototype.defaults, e);
          },
          addUndoType: function addUndoType(t, e) {
            v(0, t, e, p);
          },
          changeUndoType: function changeUndoType(t, e) {
            v(1, t, e, p);
          },
          removeUndoType: function removeUndoType(t) {
            v(2, t, void 0, p);
          }
        }), e.UndoManager = y;
      }) ? r.apply(e, i) : r) || (t.exports = o);
    }, function (t, e, n) {
      "use strict";

      e.a = function (t) {
        var e = this.constructor;
        return this.then(function (n) {
          return e.resolve(t()).then(function () {
            return n;
          });
        }, function (n) {
          return e.resolve(t()).then(function () {
            return e.reject(n);
          });
        });
      };
    }, function (t, e, n) {
      "use strict";

      e.a = function (t) {
        return new this(function (e, n) {
          if (!t || void 0 === t.length) return n(new TypeError(typeof t + " " + t + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
          var r = Array.prototype.slice.call(t);
          if (0 === r.length) return e([]);
          var i = r.length;
          function o(t, n) {
            if (n && ("object" == typeof n || "function" == typeof n)) {
              var a = n.then;
              if ("function" == typeof a) return void a.call(n, function (e) {
                o(t, e);
              }, function (n) {
                r[t] = {
                  status: "rejected",
                  reason: n
                }, 0 == --i && e(r);
              });
            }
            r[t] = {
              status: "fulfilled",
              value: n
            }, 0 == --i && e(r);
          }
          for (var a = 0; a < r.length; a++) o(a, r[a]);
        });
      };
    }, function (t, e, n) {
      "use strict";

      function r(t, e) {
        this.name = "AggregateError", this.errors = t, this.message = e || "";
      }
      r.prototype = Error.prototype, e.a = function (t) {
        var e = this;
        return new e(function (n, i) {
          if (!t || void 0 === t.length) return i(new TypeError("Promise.any accepts an array"));
          var o = Array.prototype.slice.call(t);
          if (0 === o.length) return i();
          for (var a = [], s = 0; s < o.length; s++) try {
            e.resolve(o[s]).then(n).catch(function (t) {
              a.push(t), a.length === o.length && i(new r(a, "All promises were rejected"));
            });
          } catch (t) {
            i(t);
          }
        });
      };
    }, function (t, e, n) {
      var r = n(95),
        i = n(96),
        o = n(44),
        a = n(97);
      t.exports = function (t, e) {
        return r(t) || i(t, e) || o(t, e) || a();
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var r = n(8).default;
      t.exports = function (t, e) {
        if ("object" != r(t) || !t) return t;
        var n = t[Symbol.toPrimitive];
        if (void 0 !== n) {
          var i = n.call(t, e || "default");
          if ("object" != r(i)) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === e ? String : Number)(t);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      var r = n(43);
      t.exports = function (t) {
        if (Array.isArray(t)) return r(t);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(8),
        i = n.n(r),
        o = n(2),
        a = n.n(o),
        s = n(0),
        c = n(39),
        l = n.n(c);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {},
          r = {
            defaults: {
              "core:undo": {
                keys: "⌘+z, ctrl+z",
                handler: "core:undo"
              },
              "core:redo": {
                keys: "⌘+shift+z, ctrl+shift+z",
                handler: "core:redo"
              },
              "core:copy": {
                keys: "⌘+c, ctrl+c",
                handler: "core:copy"
              },
              "core:paste": {
                keys: "⌘+v, ctrl+v",
                handler: "core:paste"
              },
              "core:component-next": {
                keys: "s",
                handler: "core:component-next"
              },
              "core:component-prev": {
                keys: "w",
                handler: "core:component-prev"
              },
              "core:component-enter": {
                keys: "d",
                handler: "core:component-enter"
              },
              "core:component-exit": {
                keys: "a",
                handler: "core:component-exit"
              },
              "core:component-delete": {
                keys: "backspace, delete",
                handler: "core:component-delete",
                opts: {
                  prevent: 1
                }
              }
            }
          };
        return {
          keymaster: l.a,
          name: "Keymaps",
          getConfig: function getConfig() {
            return e;
          },
          init: function init() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return e = d(d({}, r), n), t = e.em, this.em = t, this;
          },
          onLoad: function onLoad() {
            var t = e.defaults;
            for (var n in t) {
              var r = t[n];
              this.add(n, r.keys, r.handler, r.opts || {});
            }
          },
          add: function add(t, e, r) {
            var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              a = this.em,
              c = a.get("Commands"),
              u = a.getEditor(),
              d = a.get("Canvas"),
              h = {
                id: t,
                keys: e,
                handler: r
              },
              f = n[t];
            return f && this.remove(t), n[t] = h, l()(e, function (e, n) {
              var l = {
                event: e,
                h: n
              };
              if (r = Object(s.isString)(r) ? c.get(r) : r, !a.isEditing() && !u.Canvas.isInputFocused() || o.force) {
                o.prevent && d.getCanvasView().preventDefault(e), "object" == i()(r) ? c.runCommand(r, l) : r(u, 0, l);
                var h = [t, n.shortcut, e];
                a.trigger.apply(a, ["keymap:emit"].concat(h)), a.trigger.apply(a, ["keymap:emit:".concat(t)].concat(h));
              }
            }), a.trigger("keymap:add", h), h;
          },
          get: function get(t) {
            return n[t];
          },
          getAll: function getAll() {
            return n;
          },
          remove: function remove(t) {
            var e = this.em,
              r = this.get(t);
            if (r) return delete n[t], l.a.unbind(r.keys), e && e.trigger("keymap:remove", r), r;
          },
          removeAll: function removeAll() {
            var t = this;
            return Object.keys(n).forEach(function (e) {
              return t.remove(e);
            }), this;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(76),
        a = n.n(o);
      function s(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function c(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? s(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          r,
          i = {
            maximumStackLength: 500
          };
        return {
          name: "UndoManager",
          init: function init() {
            var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            n = c(c({}, o), i), t = n.em, this.em = t, (e = new a.a(c({
              track: !0,
              register: []
            }, n))).changeUndoType("change", {
              condition: !1
            }), e.changeUndoType("add", {
              on: function on(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!n.avoidStore) return {
                  object: e,
                  before: void 0,
                  after: t,
                  options: c({}, n)
                };
              }
            }), e.changeUndoType("remove", {
              on: function on(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!n.avoidStore) return {
                  object: e,
                  before: t,
                  after: void 0,
                  options: c({}, n)
                };
              }
            });
            var s = {
                on: function on(t, e) {
                  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                  if (!r && (r = t.previousAttributes()), !n.avoidStore) {
                    var i = {
                      object: t,
                      before: r,
                      after: t.toJSON()
                    };
                    return r = null, i;
                  }
                },
                undo: function undo(t, e, n, r) {
                  t.set(e);
                },
                redo: function redo(t, e, n, r) {
                  t.set(n);
                }
              },
              l = ["style", "attributes", "content", "src"];
            return l.forEach(function (t) {
              return e.addUndoType("change:".concat(t), s);
            }), e.on("undo redo", function () {
              return t.trigger("component:toggled change:canvasOffset");
            }), ["undo", "redo"].forEach(function (n) {
              return e.on(n, function () {
                return t.trigger(n);
              });
            }), this;
          },
          getConfig: function getConfig() {
            return n;
          },
          add: function add(t) {
            return e.register(t), this;
          },
          remove: function remove(t) {
            return e.unregister(t), this;
          },
          removeAll: function removeAll() {
            return e.unregisterAll(), this;
          },
          start: function start() {
            return e.startTracking(), this;
          },
          stop: function stop() {
            return e.stopTracking(), this;
          },
          undo: function undo() {
            var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return !t.isEditing() && e.undo(n), this;
          },
          undoAll: function undoAll() {
            return e.undoAll(), this;
          },
          redo: function redo() {
            var n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return !t.isEditing() && e.redo(n), this;
          },
          redoAll: function redoAll() {
            return e.redoAll(), this;
          },
          hasUndo: function hasUndo() {
            return e.isAvailable("undo");
          },
          hasRedo: function hasRedo() {
            return e.isAvailable("redo");
          },
          getStack: function getStack() {
            return e.stack;
          },
          getStackGroup: function getStackGroup() {
            var t = [],
              e = [];
            return this.getStack().forEach(function (n) {
              var r = n.get("magicFusionIndex");
              e.indexOf(r) < 0 && (e.push(r), t.push(n));
            }), t;
          },
          getPointer: function getPointer() {
            return this.getStack().pointer;
          },
          clear: function clear() {
            return e.clear(), this;
          },
          getInstance: function getInstance() {
            return e;
          }
        };
      };
    }, function (t, e, n) {
      (function (t) {
        var r = void 0 !== t && t || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;
        function o(t, e) {
          this._id = t, this._clearFn = e;
        }
        e.setTimeout = function () {
          return new o(i.call(setTimeout, r, arguments), clearTimeout);
        }, e.setInterval = function () {
          return new o(i.call(setInterval, r, arguments), clearInterval);
        }, e.clearTimeout = e.clearInterval = function (t) {
          t && t.close();
        }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
          this._clearFn.call(r, this._id);
        }, e.enroll = function (t, e) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
        }, e.unenroll = function (t) {
          clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
        }, e._unrefActive = e.active = function (t) {
          clearTimeout(t._idleTimeoutId);
          var e = t._idleTimeout;
          e >= 0 && (t._idleTimeoutId = setTimeout(function () {
            t._onTimeout && t._onTimeout();
          }, e));
        }, n(88), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
      }).call(this, n(26));
    }, function (t, e, n) {
      (function (t, e) {
        !function (t, n) {
          "use strict";

          if (!t.setImmediate) {
            var r,
              i,
              o,
              a,
              s,
              c = 1,
              l = {},
              u = !1,
              d = t.document,
              h = Object.getPrototypeOf && Object.getPrototypeOf(t);
            h = h && h.setTimeout ? h : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
              e.nextTick(function () {
                p(t);
              });
            } : function () {
              if (t.postMessage && !t.importScripts) {
                var e = !0,
                  n = t.onmessage;
                return t.onmessage = function () {
                  e = !1;
                }, t.postMessage("", "*"), t.onmessage = n, e;
              }
            }() ? (a = "setImmediate$" + Math.random() + "$", s = function s(e) {
              e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && p(+e.data.slice(a.length));
            }, t.addEventListener ? t.addEventListener("message", s, !1) : t.attachEvent("onmessage", s), r = function r(e) {
              t.postMessage(a + e, "*");
            }) : t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
              p(t.data);
            }, r = function r(t) {
              o.port2.postMessage(t);
            }) : d && "onreadystatechange" in d.createElement("script") ? (i = d.documentElement, r = function r(t) {
              var e = d.createElement("script");
              e.onreadystatechange = function () {
                p(t), e.onreadystatechange = null, i.removeChild(e), e = null;
              }, i.appendChild(e);
            }) : r = function r(t) {
              setTimeout(p, 0, t);
            }, h.setImmediate = function (t) {
              "function" != typeof t && (t = new Function("" + t));
              for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) e[n] = arguments[n + 1];
              var i = {
                callback: t,
                args: e
              };
              return l[c] = i, r(c), c++;
            }, h.clearImmediate = f;
          }
          function f(t) {
            delete l[t];
          }
          function p(t) {
            if (u) setTimeout(p, 0, t);else {
              var e = l[t];
              if (e) {
                u = !0;
                try {
                  !function (t) {
                    var e = t.callback,
                      n = t.args;
                    switch (n.length) {
                      case 0:
                        e();
                        break;
                      case 1:
                        e(n[0]);
                        break;
                      case 2:
                        e(n[0], n[1]);
                        break;
                      case 3:
                        e(n[0], n[1], n[2]);
                        break;
                      default:
                        e.apply(void 0, n);
                    }
                  }(e);
                } finally {
                  f(t), u = !1;
                }
              }
            }
          }
        }("undefined" == typeof self ? void 0 === t ? this : t : self);
      }).call(this, n(26), n(89));
    }, function (t, e) {
      var n,
        r,
        i = t.exports = {};
      function o() {
        throw new Error("setTimeout has not been defined");
      }
      function a() {
        throw new Error("clearTimeout has not been defined");
      }
      function s(t) {
        if (n === setTimeout) return setTimeout(t, 0);
        if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);
        try {
          return n(t, 0);
        } catch (e) {
          try {
            return n.call(null, t, 0);
          } catch (e) {
            return n.call(this, t, 0);
          }
        }
      }
      !function () {
        try {
          n = "function" == typeof setTimeout ? setTimeout : o;
        } catch (t) {
          n = o;
        }
        try {
          r = "function" == typeof clearTimeout ? clearTimeout : a;
        } catch (t) {
          r = a;
        }
      }();
      var c,
        l = [],
        u = !1,
        d = -1;
      function h() {
        u && c && (u = !1, c.length ? l = c.concat(l) : d = -1, l.length && f());
      }
      function f() {
        if (!u) {
          var t = s(h);
          u = !0;
          for (var e = l.length; e;) {
            for (c = l, l = []; ++d < e;) c && c[d].run();
            d = -1, e = l.length;
          }
          c = null, u = !1, function (t) {
            if (r === clearTimeout) return clearTimeout(t);
            if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);
            try {
              r(t);
            } catch (e) {
              try {
                return r.call(null, t);
              } catch (e) {
                return r.call(this, t);
              }
            }
          }(t);
        }
      }
      function p(t, e) {
        this.fun = t, this.array = e;
      }
      function g() {}
      i.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
        l.push(new p(t, e)), 1 !== l.length || u || s(f);
      }, p.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
        return [];
      }, i.binding = function (t) {
        throw new Error("process.binding is not supported");
      }, i.cwd = function () {
        return "/";
      }, i.chdir = function (t) {
        throw new Error("process.chdir is not supported");
      }, i.umask = function () {
        return 0;
      };
    }, function (t, e) {
      t.exports = function (t, e) {
        if (null == t) return {};
        var n,
          r,
          i = {},
          o = Object.keys(t);
        for (r = 0; r < o.length; r++) n = o[r], e.indexOf(n) >= 0 || (i[n] = t[n]);
        return i;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        var e = {
            script: [["lang", /(javascript|babel)/i, "javascript"], ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"], ["type", /./, "text/plain"], [null, null, "javascript"]],
            style: [["lang", /^css$/i, "css"], ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"], ["type", /./, "text/plain"], [null, null, "css"]]
          },
          n = {};
        function r(t, e) {
          var r = t.match(function (t) {
            return n[t] || (n[t] = new RegExp("\\s+" + t + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*"));
          }(e));
          return r ? /^\s*(.*?)\s*$/.exec(r[2])[1] : "";
        }
        function i(t, e) {
          return new RegExp((e ? "^" : "") + "</\\s*" + t + "\\s*>", "i");
        }
        function o(t, e) {
          for (var n in t) for (var r = e[n] || (e[n] = []), i = t[n], o = i.length - 1; o >= 0; o--) r.unshift(i[o]);
        }
        t.defineMode("htmlmixed", function (n, a) {
          var s = t.getMode(n, {
              name: "xml",
              htmlMode: !0,
              multilineTagIndentFactor: a.multilineTagIndentFactor,
              multilineTagIndentPastTag: a.multilineTagIndentPastTag,
              allowMissingTagName: a.allowMissingTagName
            }),
            c = {},
            l = a && a.tags,
            u = a && a.scriptTypes;
          if (o(e, c), l && o(l, c), u) for (var d = u.length - 1; d >= 0; d--) c.script.unshift(["type", u[d].matches, u[d].mode]);
          function h(e, o) {
            var a,
              l = s.token(e, o.htmlState),
              u = /\btag\b/.test(l);
            if (u && !/[<>\s\/]/.test(e.current()) && (a = o.htmlState.tagName && o.htmlState.tagName.toLowerCase()) && c.hasOwnProperty(a)) o.inTag = a + " ";else if (o.inTag && u && />$/.test(e.current())) {
              var d = /^([\S]+) (.*)/.exec(o.inTag);
              o.inTag = null;
              var f = ">" == e.current() && function (t, e) {
                  for (var n = 0; n < t.length; n++) {
                    var i = t[n];
                    if (!i[0] || i[1].test(r(e, i[0]))) return i[2];
                  }
                }(c[d[1]], d[2]),
                p = t.getMode(n, f),
                g = i(d[1], !0),
                v = i(d[1], !1);
              o.token = function (t, e) {
                return t.match(g, !1) ? (e.token = h, e.localState = e.localMode = null, null) : function (t, e, n) {
                  var r = t.current(),
                    i = r.search(e);
                  return i > -1 ? t.backUp(r.length - i) : r.match(/<\/?$/) && (t.backUp(r.length), t.match(e, !1) || t.match(r)), n;
                }(t, v, e.localMode.token(t, e.localState));
              }, o.localMode = p, o.localState = t.startState(p, s.indent(o.htmlState, "", ""));
            } else o.inTag && (o.inTag += e.current(), e.eol() && (o.inTag += " "));
            return l;
          }
          return {
            startState: function startState() {
              return {
                token: h,
                inTag: null,
                localMode: null,
                localState: null,
                htmlState: t.startState(s)
              };
            },
            copyState: function copyState(e) {
              var n;
              return e.localState && (n = t.copyState(e.localMode, e.localState)), {
                token: e.token,
                inTag: e.inTag,
                localMode: e.localMode,
                localState: n,
                htmlState: t.copyState(s, e.htmlState)
              };
            },
            token: function token(t, e) {
              return e.token(t, e);
            },
            indent: function indent(e, n, r) {
              return !e.localMode || /^\s*<\//.test(n) ? s.indent(e.htmlState, n, r) : e.localMode.indent ? e.localMode.indent(e.localState, n, r) : t.Pass;
            },
            innerMode: function innerMode(t) {
              return {
                state: t.localState || t.htmlState,
                mode: t.localMode || s
              };
            }
          };
        }, "xml", "javascript", "css"), t.defineMIME("text/html", "htmlmixed");
      }(n(13), n(92), n(93), n(45));
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        var e = {
            autoSelfClosers: {
              area: !0,
              base: !0,
              br: !0,
              col: !0,
              command: !0,
              embed: !0,
              frame: !0,
              hr: !0,
              img: !0,
              input: !0,
              keygen: !0,
              link: !0,
              meta: !0,
              param: !0,
              source: !0,
              track: !0,
              wbr: !0,
              menuitem: !0
            },
            implicitlyClosed: {
              dd: !0,
              li: !0,
              optgroup: !0,
              option: !0,
              p: !0,
              rp: !0,
              rt: !0,
              tbody: !0,
              td: !0,
              tfoot: !0,
              th: !0,
              tr: !0
            },
            contextGrabbers: {
              dd: {
                dd: !0,
                dt: !0
              },
              dt: {
                dd: !0,
                dt: !0
              },
              li: {
                li: !0
              },
              option: {
                option: !0,
                optgroup: !0
              },
              optgroup: {
                optgroup: !0
              },
              p: {
                address: !0,
                article: !0,
                aside: !0,
                blockquote: !0,
                dir: !0,
                div: !0,
                dl: !0,
                fieldset: !0,
                footer: !0,
                form: !0,
                h1: !0,
                h2: !0,
                h3: !0,
                h4: !0,
                h5: !0,
                h6: !0,
                header: !0,
                hgroup: !0,
                hr: !0,
                menu: !0,
                nav: !0,
                ol: !0,
                p: !0,
                pre: !0,
                section: !0,
                table: !0,
                ul: !0
              },
              rp: {
                rp: !0,
                rt: !0
              },
              rt: {
                rp: !0,
                rt: !0
              },
              tbody: {
                tbody: !0,
                tfoot: !0
              },
              td: {
                td: !0,
                th: !0
              },
              tfoot: {
                tbody: !0
              },
              th: {
                td: !0,
                th: !0
              },
              thead: {
                tbody: !0,
                tfoot: !0
              },
              tr: {
                tr: !0
              }
            },
            doNotIndent: {
              pre: !0
            },
            allowUnquoted: !0,
            allowMissing: !0,
            caseFold: !0
          },
          n = {
            autoSelfClosers: {},
            implicitlyClosed: {},
            contextGrabbers: {},
            doNotIndent: {},
            allowUnquoted: !1,
            allowMissing: !1,
            allowMissingTagName: !1,
            caseFold: !1
          };
        t.defineMode("xml", function (r, i) {
          var o,
            a,
            s = r.indentUnit,
            c = {},
            l = i.htmlMode ? e : n;
          for (var u in l) c[u] = l[u];
          for (var u in i) c[u] = i[u];
          function d(t, e) {
            function n(n) {
              return e.tokenize = n, n(t, e);
            }
            var r = t.next();
            return "<" == r ? t.eat("!") ? t.eat("[") ? t.match("CDATA[") ? n(f("atom", "]]>")) : null : t.match("--") ? n(f("comment", "--\x3e")) : t.match("DOCTYPE", !0, !0) ? (t.eatWhile(/[\w\._\-]/), n(function t(e) {
              return function (n, r) {
                for (var i; null != (i = n.next());) {
                  if ("<" == i) return r.tokenize = t(e + 1), r.tokenize(n, r);
                  if (">" == i) {
                    if (1 == e) {
                      r.tokenize = d;
                      break;
                    }
                    return r.tokenize = t(e - 1), r.tokenize(n, r);
                  }
                }
                return "meta";
              };
            }(1))) : null : t.eat("?") ? (t.eatWhile(/[\w\._\-]/), e.tokenize = f("meta", "?>"), "meta") : (o = t.eat("/") ? "closeTag" : "openTag", e.tokenize = h, "tag bracket") : "&" == r ? (t.eat("#") ? t.eat("x") ? t.eatWhile(/[a-fA-F\d]/) && t.eat(";") : t.eatWhile(/[\d]/) && t.eat(";") : t.eatWhile(/[\w\.\-:]/) && t.eat(";")) ? "atom" : "error" : (t.eatWhile(/[^&<]/), null);
          }
          function h(t, e) {
            var n,
              r,
              i = t.next();
            if (">" == i || "/" == i && t.eat(">")) return e.tokenize = d, o = ">" == i ? "endTag" : "selfcloseTag", "tag bracket";
            if ("=" == i) return o = "equals", null;
            if ("<" == i) {
              e.tokenize = d, e.state = b, e.tagName = e.tagStart = null;
              var a = e.tokenize(t, e);
              return a ? a + " tag error" : "tag error";
            }
            return /[\'\"]/.test(i) ? (e.tokenize = (n = i, (r = function r(t, e) {
              for (; !t.eol();) if (t.next() == n) {
                e.tokenize = h;
                break;
              }
              return "string";
            }).isInAttribute = !0, r), e.stringStartCol = t.column(), e.tokenize(t, e)) : (t.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/), "word");
          }
          function f(t, e) {
            return function (n, r) {
              for (; !n.eol();) {
                if (n.match(e)) {
                  r.tokenize = d;
                  break;
                }
                n.next();
              }
              return t;
            };
          }
          function p(t) {
            return t && t.toLowerCase();
          }
          function g(t, e, n) {
            this.prev = t.context, this.tagName = e || "", this.indent = t.indented, this.startOfLine = n, (c.doNotIndent.hasOwnProperty(e) || t.context && t.context.noIndent) && (this.noIndent = !0);
          }
          function v(t) {
            t.context && (t.context = t.context.prev);
          }
          function m(t, e) {
            for (var n;;) {
              if (!t.context) return;
              if (n = t.context.tagName, !c.contextGrabbers.hasOwnProperty(p(n)) || !c.contextGrabbers[p(n)].hasOwnProperty(p(e))) return;
              v(t);
            }
          }
          function b(t, e, n) {
            return "openTag" == t ? (n.tagStart = e.column(), y) : "closeTag" == t ? w : b;
          }
          function y(t, e, n) {
            return "word" == t ? (n.tagName = e.current(), a = "tag", C) : c.allowMissingTagName && "endTag" == t ? (a = "tag bracket", C(t, 0, n)) : (a = "error", y);
          }
          function w(t, e, n) {
            if ("word" == t) {
              var r = e.current();
              return n.context && n.context.tagName != r && c.implicitlyClosed.hasOwnProperty(p(n.context.tagName)) && v(n), n.context && n.context.tagName == r || !1 === c.matchClosing ? (a = "tag", x) : (a = "tag error", O);
            }
            return c.allowMissingTagName && "endTag" == t ? (a = "tag bracket", x(t, 0, n)) : (a = "error", O);
          }
          function x(t, e, n) {
            return "endTag" != t ? (a = "error", x) : (v(n), b);
          }
          function O(t, e, n) {
            return a = "error", x(t, 0, n);
          }
          function C(t, e, n) {
            if ("word" == t) return a = "attribute", S;
            if ("endTag" == t || "selfcloseTag" == t) {
              var r = n.tagName,
                i = n.tagStart;
              return n.tagName = n.tagStart = null, "selfcloseTag" == t || c.autoSelfClosers.hasOwnProperty(p(r)) ? m(n, r) : (m(n, r), n.context = new g(n, r, i == n.indented)), b;
            }
            return a = "error", C;
          }
          function S(t, e, n) {
            return "equals" == t ? k : (c.allowMissing || (a = "error"), C(t, 0, n));
          }
          function k(t, e, n) {
            return "string" == t ? T : "word" == t && c.allowUnquoted ? (a = "string", C) : (a = "error", C(t, 0, n));
          }
          function T(t, e, n) {
            return "string" == t ? T : C(t, 0, n);
          }
          return d.isInText = !0, {
            startState: function startState(t) {
              var e = {
                tokenize: d,
                state: b,
                indented: t || 0,
                tagName: null,
                tagStart: null,
                context: null
              };
              return null != t && (e.baseIndent = t), e;
            },
            token: function token(t, e) {
              if (!e.tagName && t.sol() && (e.indented = t.indentation()), t.eatSpace()) return null;
              o = null;
              var n = e.tokenize(t, e);
              return (n || o) && "comment" != n && (a = null, e.state = e.state(o || n, t, e), a && (n = "error" == a ? n + " error" : a)), n;
            },
            indent: function indent(e, n, r) {
              var i = e.context;
              if (e.tokenize.isInAttribute) return e.tagStart == e.indented ? e.stringStartCol + 1 : e.indented + s;
              if (i && i.noIndent) return t.Pass;
              if (e.tokenize != h && e.tokenize != d) return r ? r.match(/^(\s*)/)[0].length : 0;
              if (e.tagName) return !1 !== c.multilineTagIndentPastTag ? e.tagStart + e.tagName.length + 2 : e.tagStart + s * (c.multilineTagIndentFactor || 1);
              if (c.alignCDATA && /<!\[CDATA\[/.test(n)) return 0;
              var o = n && /^<(\/)?([\w_:\.-]*)/.exec(n);
              if (o && o[1]) for (; i;) {
                if (i.tagName == o[2]) {
                  i = i.prev;
                  break;
                }
                if (!c.implicitlyClosed.hasOwnProperty(p(i.tagName))) break;
                i = i.prev;
              } else if (o) for (; i;) {
                var a = c.contextGrabbers[p(i.tagName)];
                if (!a || !a.hasOwnProperty(p(o[2]))) break;
                i = i.prev;
              }
              for (; i && i.prev && !i.startOfLine;) i = i.prev;
              return i ? i.indent + s : e.baseIndent || 0;
            },
            electricInput: /<\/[\s\w:]+>$/,
            blockCommentStart: "\x3c!--",
            blockCommentEnd: "--\x3e",
            configuration: c.htmlMode ? "html" : "xml",
            helperType: c.htmlMode ? "html" : "xml",
            skipAttribute: function skipAttribute(t) {
              t.state == k && (t.state = C);
            },
            xmlCurrentTag: function xmlCurrentTag(t) {
              return t.tagName ? {
                name: t.tagName,
                close: "closeTag" == t.type
              } : null;
            },
            xmlCurrentContext: function xmlCurrentContext(t) {
              for (var e = [], n = t.context; n; n = n.prev) e.push(n.tagName);
              return e.reverse();
            }
          };
        }), t.defineMIME("text/xml", "xml"), t.defineMIME("application/xml", "xml"), t.mimeModes.hasOwnProperty("text/html") || t.defineMIME("text/html", {
          name: "xml",
          htmlMode: !0
        });
      }(n(13));
    }, function (t, e, n) {
      !function (t) {
        "use strict";

        t.defineMode("javascript", function (e, n) {
          var r,
            i,
            o = e.indentUnit,
            a = n.statementIndent,
            s = n.jsonld,
            c = n.json || s,
            l = !1 !== n.trackScope,
            u = n.typescript,
            d = n.wordCharacters || /[\w$\xa1-\uffff]/,
            h = function () {
              function t(t) {
                return {
                  type: t,
                  style: "keyword"
                };
              }
              var e = t("keyword a"),
                n = t("keyword b"),
                r = t("keyword c"),
                i = t("keyword d"),
                o = t("operator"),
                a = {
                  type: "atom",
                  style: "atom"
                };
              return {
                if: t("if"),
                while: e,
                with: e,
                else: n,
                do: n,
                try: n,
                finally: n,
                return: i,
                break: i,
                continue: i,
                new: t("new"),
                delete: r,
                void: r,
                throw: r,
                debugger: t("debugger"),
                var: t("var"),
                const: t("var"),
                let: t("var"),
                function: t("function"),
                catch: t("catch"),
                for: t("for"),
                switch: t("switch"),
                case: t("case"),
                default: t("default"),
                in: o,
                typeof: o,
                instanceof: o,
                true: a,
                false: a,
                null: a,
                undefined: a,
                NaN: a,
                Infinity: a,
                this: t("this"),
                class: t("class"),
                super: t("atom"),
                yield: r,
                export: t("export"),
                import: t("import"),
                extends: r,
                await: r
              };
            }(),
            f = /[+\-*&%=<>!?|~^@]/,
            p = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
          function g(t, e, n) {
            return r = t, i = n, e;
          }
          function v(t, e) {
            var n,
              r = t.next();
            if ('"' == r || "'" == r) return e.tokenize = (n = r, function (t, e) {
              var r,
                i = !1;
              if (s && "@" == t.peek() && t.match(p)) return e.tokenize = v, g("jsonld-keyword", "meta");
              for (; null != (r = t.next()) && (r != n || i);) i = !i && "\\" == r;
              return i || (e.tokenize = v), g("string", "string");
            }), e.tokenize(t, e);
            if ("." == r && t.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) return g("number", "number");
            if ("." == r && t.match("..")) return g("spread", "meta");
            if (/[\[\]{}\(\),;\:\.]/.test(r)) return g(r);
            if ("=" == r && t.eat(">")) return g("=>", "operator");
            if ("0" == r && t.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) return g("number", "number");
            if (/\d/.test(r)) return t.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/), g("number", "number");
            if ("/" == r) return t.eat("*") ? (e.tokenize = m, m(t, e)) : t.eat("/") ? (t.skipToEnd(), g("comment", "comment")) : Zt(t, e, 1) ? (function (t) {
              for (var e, n = !1, r = !1; null != (e = t.next());) {
                if (!n) {
                  if ("/" == e && !r) return;
                  "[" == e ? r = !0 : r && "]" == e && (r = !1);
                }
                n = !n && "\\" == e;
              }
            }(t), t.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/), g("regexp", "string-2")) : (t.eat("="), g("operator", "operator", t.current()));
            if ("`" == r) return e.tokenize = b, b(t, e);
            if ("#" == r && "!" == t.peek()) return t.skipToEnd(), g("meta", "meta");
            if ("#" == r && t.eatWhile(d)) return g("variable", "property");
            if ("<" == r && t.match("!--") || "-" == r && t.match("->") && !/\S/.test(t.string.slice(0, t.start))) return t.skipToEnd(), g("comment", "comment");
            if (f.test(r)) return ">" == r && e.lexical && ">" == e.lexical.type || (t.eat("=") ? "!" != r && "=" != r || t.eat("=") : /[<>*+\-|&?]/.test(r) && (t.eat(r), ">" == r && t.eat(r))), "?" == r && t.eat(".") ? g(".") : g("operator", "operator", t.current());
            if (d.test(r)) {
              t.eatWhile(d);
              var i = t.current();
              if ("." != e.lastType) {
                if (h.propertyIsEnumerable(i)) {
                  var o = h[i];
                  return g(o.type, o.style, i);
                }
                if ("async" == i && t.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, !1)) return g("async", "keyword", i);
              }
              return g("variable", "variable", i);
            }
          }
          function m(t, e) {
            for (var n, r = !1; n = t.next();) {
              if ("/" == n && r) {
                e.tokenize = v;
                break;
              }
              r = "*" == n;
            }
            return g("comment", "comment");
          }
          function b(t, e) {
            for (var n, r = !1; null != (n = t.next());) {
              if (!r && ("`" == n || "$" == n && t.eat("{"))) {
                e.tokenize = v;
                break;
              }
              r = !r && "\\" == n;
            }
            return g("quasi", "string-2", t.current());
          }
          function y(t, e) {
            e.fatArrowAt && (e.fatArrowAt = null);
            var n = t.string.indexOf("=>", t.start);
            if (!(n < 0)) {
              if (u) {
                var r = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(t.string.slice(t.start, n));
                r && (n = r.index);
              }
              for (var i = 0, o = !1, a = n - 1; a >= 0; --a) {
                var s = t.string.charAt(a),
                  c = "([{}])".indexOf(s);
                if (c >= 0 && c < 3) {
                  if (!i) {
                    ++a;
                    break;
                  }
                  if (0 == --i) {
                    "(" == s && (o = !0);
                    break;
                  }
                } else if (c >= 3 && c < 6) ++i;else if (d.test(s)) o = !0;else if (/["'\/`]/.test(s)) for (;; --a) {
                  if (0 == a) return;
                  if (t.string.charAt(a - 1) == s && "\\" != t.string.charAt(a - 2)) {
                    a--;
                    break;
                  }
                } else if (o && !i) {
                  ++a;
                  break;
                }
              }
              o && !i && (e.fatArrowAt = a);
            }
          }
          var w = {
            atom: !0,
            number: !0,
            variable: !0,
            string: !0,
            regexp: !0,
            this: !0,
            import: !0,
            "jsonld-keyword": !0
          };
          function x(t, e, n, r, i, o) {
            this.indented = t, this.column = e, this.type = n, this.prev = i, this.info = o, null != r && (this.align = r);
          }
          function O(t, e) {
            if (!l) return !1;
            for (var n = t.localVars; n; n = n.next) if (n.name == e) return !0;
            for (var r = t.context; r; r = r.prev) for (n = r.vars; n; n = n.next) if (n.name == e) return !0;
          }
          function C(t, e, n, r, i) {
            var o = t.cc;
            for (S.state = t, S.stream = i, S.marked = null, S.cc = o, S.style = e, t.lexical.hasOwnProperty("align") || (t.lexical.align = !0);;) if ((o.length ? o.pop() : c ? H : V)(n, r)) {
              for (; o.length && o[o.length - 1].lex;) o.pop()();
              return S.marked ? S.marked : "variable" == n && O(t, r) ? "variable-2" : e;
            }
          }
          var S = {
            state: null,
            column: null,
            marked: null,
            cc: null
          };
          function k() {
            for (var t = arguments.length - 1; t >= 0; t--) S.cc.push(arguments[t]);
          }
          function T() {
            return k.apply(null, arguments), !0;
          }
          function j(t, e) {
            for (var n = e; n; n = n.next) if (n.name == t) return !0;
            return !1;
          }
          function E(t) {
            var e = S.state;
            if (S.marked = "def", l) {
              if (e.context) if ("var" == e.lexical.info && e.context && e.context.block) {
                var r = function t(e, n) {
                  if (n) {
                    if (n.block) {
                      var r = t(e, n.prev);
                      return r ? r == n.prev ? n : new A(r, n.vars, !0) : null;
                    }
                    return j(e, n.vars) ? n : new A(n.prev, new M(e, n.vars), !1);
                  }
                  return null;
                }(t, e.context);
                if (null != r) return void (e.context = r);
              } else if (!j(t, e.localVars)) return void (e.localVars = new M(t, e.localVars));
              n.globalVars && !j(t, e.globalVars) && (e.globalVars = new M(t, e.globalVars));
            }
          }
          function P(t) {
            return "public" == t || "private" == t || "protected" == t || "abstract" == t || "readonly" == t;
          }
          function A(t, e, n) {
            this.prev = t, this.vars = e, this.block = n;
          }
          function M(t, e) {
            this.name = t, this.next = e;
          }
          var D = new M("this", new M("arguments", null));
          function L() {
            S.state.context = new A(S.state.context, S.state.localVars, !1), S.state.localVars = D;
          }
          function _() {
            S.state.context = new A(S.state.context, S.state.localVars, !0), S.state.localVars = null;
          }
          function N() {
            S.state.localVars = S.state.context.vars, S.state.context = S.state.context.prev;
          }
          function I(t, e) {
            var n = function n() {
              var n = S.state,
                r = n.indented;
              if ("stat" == n.lexical.type) r = n.lexical.indented;else for (var i = n.lexical; i && ")" == i.type && i.align; i = i.prev) r = i.indented;
              n.lexical = new x(r, S.stream.column(), t, null, n.lexical, e);
            };
            return n.lex = !0, n;
          }
          function R() {
            var t = S.state;
            t.lexical.prev && (")" == t.lexical.type && (t.indented = t.lexical.indented), t.lexical = t.lexical.prev);
          }
          function F(t) {
            return function e(n) {
              return n == t ? T() : ";" == t || "}" == n || ")" == n || "]" == n ? k() : T(e);
            };
          }
          function V(t, e) {
            return "var" == t ? T(I("vardef", e), Ct, F(";"), R) : "keyword a" == t ? T(I("form"), U, V, R) : "keyword b" == t ? T(I("form"), V, R) : "keyword d" == t ? S.stream.match(/^\s*$/, !1) ? T() : T(I("stat"), W, F(";"), R) : "debugger" == t ? T(F(";")) : "{" == t ? T(I("}"), _, st, R, N) : ";" == t ? T() : "if" == t ? ("else" == S.state.lexical.info && S.state.cc[S.state.cc.length - 1] == R && S.state.cc.pop()(), T(I("form"), U, V, R, Pt)) : "function" == t ? T(Lt) : "for" == t ? T(I("form"), _, At, V, N, R) : "class" == t || u && "interface" == e ? (S.marked = "keyword", T(I("form", "class" == t ? t : e), Ft, R)) : "variable" == t ? u && "declare" == e ? (S.marked = "keyword", T(V)) : u && ("module" == e || "enum" == e || "type" == e) && S.stream.match(/^\s*\w/, !1) ? (S.marked = "keyword", "enum" == e ? T(Xt) : "type" == e ? T(Nt, F("operator"), ht, F(";")) : T(I("form"), St, F("{"), I("}"), st, R, R)) : u && "namespace" == e ? (S.marked = "keyword", T(I("form"), H, V, R)) : u && "abstract" == e ? (S.marked = "keyword", T(V)) : T(I("stat"), tt) : "switch" == t ? T(I("form"), U, F("{"), I("}", "switch"), _, st, R, R, N) : "case" == t ? T(H, F(":")) : "default" == t ? T(F(":")) : "catch" == t ? T(I("form"), L, z, V, R, N) : "export" == t ? T(I("stat"), Bt, R) : "import" == t ? T(I("stat"), $t, R) : "async" == t ? T(V) : "@" == e ? T(H, V) : k(I("stat"), H, F(";"), R);
          }
          function z(t) {
            if ("(" == t) return T(It, F(")"));
          }
          function H(t, e) {
            return $(t, e, !1);
          }
          function B(t, e) {
            return $(t, e, !0);
          }
          function U(t) {
            return "(" != t ? k() : T(I(")"), W, F(")"), R);
          }
          function $(t, e, n) {
            if (S.state.fatArrowAt == S.stream.start) {
              var r = n ? J : X;
              if ("(" == t) return T(L, I(")"), ot(It, ")"), R, F("=>"), r, N);
              if ("variable" == t) return k(L, St, F("=>"), r, N);
            }
            var i = n ? G : q;
            return w.hasOwnProperty(t) ? T(i) : "function" == t ? T(Lt, i) : "class" == t || u && "interface" == e ? (S.marked = "keyword", T(I("form"), Rt, R)) : "keyword c" == t || "async" == t ? T(n ? B : H) : "(" == t ? T(I(")"), W, F(")"), R, i) : "operator" == t || "spread" == t ? T(n ? B : H) : "[" == t ? T(I("]"), Kt, R, i) : "{" == t ? at(nt, "}", null, i) : "quasi" == t ? k(Y, i) : "new" == t ? T(function (t) {
              return function (e) {
                return "." == e ? T(t ? Q : Z) : "variable" == e && u ? T(wt, t ? G : q) : k(t ? B : H);
              };
            }(n)) : T();
          }
          function W(t) {
            return t.match(/[;\}\)\],]/) ? k() : k(H);
          }
          function q(t, e) {
            return "," == t ? T(W) : G(t, e, !1);
          }
          function G(t, e, n) {
            var r = 0 == n ? q : G,
              i = 0 == n ? H : B;
            return "=>" == t ? T(L, n ? J : X, N) : "operator" == t ? /\+\+|--/.test(e) || u && "!" == e ? T(r) : u && "<" == e && S.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, !1) ? T(I(">"), ot(ht, ">"), R, r) : "?" == e ? T(H, F(":"), i) : T(i) : "quasi" == t ? k(Y, r) : ";" != t ? "(" == t ? at(B, ")", "call", r) : "." == t ? T(et, r) : "[" == t ? T(I("]"), W, F("]"), R, r) : u && "as" == e ? (S.marked = "keyword", T(ht, r)) : "regexp" == t ? (S.state.lastType = S.marked = "operator", S.stream.backUp(S.stream.pos - S.stream.start - 1), T(i)) : void 0 : void 0;
          }
          function Y(t, e) {
            return "quasi" != t ? k() : "${" != e.slice(e.length - 2) ? T(Y) : T(W, K);
          }
          function K(t) {
            if ("}" == t) return S.marked = "string-2", S.state.tokenize = b, T(Y);
          }
          function X(t) {
            return y(S.stream, S.state), k("{" == t ? V : H);
          }
          function J(t) {
            return y(S.stream, S.state), k("{" == t ? V : B);
          }
          function Z(t, e) {
            if ("target" == e) return S.marked = "keyword", T(q);
          }
          function Q(t, e) {
            if ("target" == e) return S.marked = "keyword", T(G);
          }
          function tt(t) {
            return ":" == t ? T(R, V) : k(q, F(";"), R);
          }
          function et(t) {
            if ("variable" == t) return S.marked = "property", T();
          }
          function nt(t, e) {
            return "async" == t ? (S.marked = "property", T(nt)) : "variable" == t || "keyword" == S.style ? (S.marked = "property", "get" == e || "set" == e ? T(rt) : (u && S.state.fatArrowAt == S.stream.start && (n = S.stream.match(/^\s*:\s*/, !1)) && (S.state.fatArrowAt = S.stream.pos + n[0].length), T(it))) : "number" == t || "string" == t ? (S.marked = s ? "property" : S.style + " property", T(it)) : "jsonld-keyword" == t ? T(it) : u && P(e) ? (S.marked = "keyword", T(nt)) : "[" == t ? T(H, ct, F("]"), it) : "spread" == t ? T(B, it) : "*" == e ? (S.marked = "keyword", T(nt)) : ":" == t ? k(it) : void 0;
            var n;
          }
          function rt(t) {
            return "variable" != t ? k(it) : (S.marked = "property", T(Lt));
          }
          function it(t) {
            return ":" == t ? T(B) : "(" == t ? k(Lt) : void 0;
          }
          function ot(t, e, n) {
            function r(i, o) {
              if (n ? n.indexOf(i) > -1 : "," == i) {
                var a = S.state.lexical;
                return "call" == a.info && (a.pos = (a.pos || 0) + 1), T(function (n, r) {
                  return n == e || r == e ? k() : k(t);
                }, r);
              }
              return i == e || o == e ? T() : n && n.indexOf(";") > -1 ? k(t) : T(F(e));
            }
            return function (n, i) {
              return n == e || i == e ? T() : k(t, r);
            };
          }
          function at(t, e, n) {
            for (var r = 3; r < arguments.length; r++) S.cc.push(arguments[r]);
            return T(I(e, n), ot(t, e), R);
          }
          function st(t) {
            return "}" == t ? T() : k(V, st);
          }
          function ct(t, e) {
            if (u) {
              if (":" == t) return T(ht);
              if ("?" == e) return T(ct);
            }
          }
          function lt(t, e) {
            if (u && (":" == t || "in" == e)) return T(ht);
          }
          function ut(t) {
            if (u && ":" == t) return S.stream.match(/^\s*\w+\s+is\b/, !1) ? T(H, dt, ht) : T(ht);
          }
          function dt(t, e) {
            if ("is" == e) return S.marked = "keyword", T();
          }
          function ht(t, e) {
            return "keyof" == e || "typeof" == e || "infer" == e || "readonly" == e ? (S.marked = "keyword", T("typeof" == e ? B : ht)) : "variable" == t || "void" == e ? (S.marked = "type", T(yt)) : "|" == e || "&" == e ? T(ht) : "string" == t || "number" == t || "atom" == t ? T(yt) : "[" == t ? T(I("]"), ot(ht, "]", ","), R, yt) : "{" == t ? T(I("}"), pt, R, yt) : "(" == t ? T(ot(bt, ")"), ft, yt) : "<" == t ? T(ot(ht, ">"), ht) : "quasi" == t ? k(vt, yt) : void 0;
          }
          function ft(t) {
            if ("=>" == t) return T(ht);
          }
          function pt(t) {
            return t.match(/[\}\)\]]/) ? T() : "," == t || ";" == t ? T(pt) : k(gt, pt);
          }
          function gt(t, e) {
            return "variable" == t || "keyword" == S.style ? (S.marked = "property", T(gt)) : "?" == e || "number" == t || "string" == t ? T(gt) : ":" == t ? T(ht) : "[" == t ? T(F("variable"), lt, F("]"), gt) : "(" == t ? k(_t, gt) : t.match(/[;\}\)\],]/) ? void 0 : T();
          }
          function vt(t, e) {
            return "quasi" != t ? k() : "${" != e.slice(e.length - 2) ? T(vt) : T(ht, mt);
          }
          function mt(t) {
            if ("}" == t) return S.marked = "string-2", S.state.tokenize = b, T(vt);
          }
          function bt(t, e) {
            return "variable" == t && S.stream.match(/^\s*[?:]/, !1) || "?" == e ? T(bt) : ":" == t ? T(ht) : "spread" == t ? T(bt) : k(ht);
          }
          function yt(t, e) {
            return "<" == e ? T(I(">"), ot(ht, ">"), R, yt) : "|" == e || "." == t || "&" == e ? T(ht) : "[" == t ? T(ht, F("]"), yt) : "extends" == e || "implements" == e ? (S.marked = "keyword", T(ht)) : "?" == e ? T(ht, F(":"), ht) : void 0;
          }
          function wt(t, e) {
            if ("<" == e) return T(I(">"), ot(ht, ">"), R, yt);
          }
          function xt() {
            return k(ht, Ot);
          }
          function Ot(t, e) {
            if ("=" == e) return T(ht);
          }
          function Ct(t, e) {
            return "enum" == e ? (S.marked = "keyword", T(Xt)) : k(St, ct, jt, Et);
          }
          function St(t, e) {
            return u && P(e) ? (S.marked = "keyword", T(St)) : "variable" == t ? (E(e), T()) : "spread" == t ? T(St) : "[" == t ? at(Tt, "]") : "{" == t ? at(kt, "}") : void 0;
          }
          function kt(t, e) {
            return "variable" != t || S.stream.match(/^\s*:/, !1) ? ("variable" == t && (S.marked = "property"), "spread" == t ? T(St) : "}" == t ? k() : "[" == t ? T(H, F("]"), F(":"), kt) : T(F(":"), St, jt)) : (E(e), T(jt));
          }
          function Tt() {
            return k(St, jt);
          }
          function jt(t, e) {
            if ("=" == e) return T(B);
          }
          function Et(t) {
            if ("," == t) return T(Ct);
          }
          function Pt(t, e) {
            if ("keyword b" == t && "else" == e) return T(I("form", "else"), V, R);
          }
          function At(t, e) {
            return "await" == e ? T(At) : "(" == t ? T(I(")"), Mt, R) : void 0;
          }
          function Mt(t) {
            return "var" == t ? T(Ct, Dt) : "variable" == t ? T(Dt) : k(Dt);
          }
          function Dt(t, e) {
            return ")" == t ? T() : ";" == t ? T(Dt) : "in" == e || "of" == e ? (S.marked = "keyword", T(H, Dt)) : k(H, Dt);
          }
          function Lt(t, e) {
            return "*" == e ? (S.marked = "keyword", T(Lt)) : "variable" == t ? (E(e), T(Lt)) : "(" == t ? T(L, I(")"), ot(It, ")"), R, ut, V, N) : u && "<" == e ? T(I(">"), ot(xt, ">"), R, Lt) : void 0;
          }
          function _t(t, e) {
            return "*" == e ? (S.marked = "keyword", T(_t)) : "variable" == t ? (E(e), T(_t)) : "(" == t ? T(L, I(")"), ot(It, ")"), R, ut, N) : u && "<" == e ? T(I(">"), ot(xt, ">"), R, _t) : void 0;
          }
          function Nt(t, e) {
            return "keyword" == t || "variable" == t ? (S.marked = "type", T(Nt)) : "<" == e ? T(I(">"), ot(xt, ">"), R) : void 0;
          }
          function It(t, e) {
            return "@" == e && T(H, It), "spread" == t ? T(It) : u && P(e) ? (S.marked = "keyword", T(It)) : u && "this" == t ? T(ct, jt) : k(St, ct, jt);
          }
          function Rt(t, e) {
            return "variable" == t ? Ft(t, e) : Vt(t, e);
          }
          function Ft(t, e) {
            if ("variable" == t) return E(e), T(Vt);
          }
          function Vt(t, e) {
            return "<" == e ? T(I(">"), ot(xt, ">"), R, Vt) : "extends" == e || "implements" == e || u && "," == t ? ("implements" == e && (S.marked = "keyword"), T(u ? ht : H, Vt)) : "{" == t ? T(I("}"), zt, R) : void 0;
          }
          function zt(t, e) {
            return "async" == t || "variable" == t && ("static" == e || "get" == e || "set" == e || u && P(e)) && S.stream.match(/^\s+#?[\w$\xa1-\uffff]/, !1) ? (S.marked = "keyword", T(zt)) : "variable" == t || "keyword" == S.style ? (S.marked = "property", T(Ht, zt)) : "number" == t || "string" == t ? T(Ht, zt) : "[" == t ? T(H, ct, F("]"), Ht, zt) : "*" == e ? (S.marked = "keyword", T(zt)) : u && "(" == t ? k(_t, zt) : ";" == t || "," == t ? T(zt) : "}" == t ? T() : "@" == e ? T(H, zt) : void 0;
          }
          function Ht(t, e) {
            if ("!" == e) return T(Ht);
            if ("?" == e) return T(Ht);
            if (":" == t) return T(ht, jt);
            if ("=" == e) return T(B);
            var n = S.state.lexical.prev;
            return k(n && "interface" == n.info ? _t : Lt);
          }
          function Bt(t, e) {
            return "*" == e ? (S.marked = "keyword", T(Yt, F(";"))) : "default" == e ? (S.marked = "keyword", T(H, F(";"))) : "{" == t ? T(ot(Ut, "}"), Yt, F(";")) : k(V);
          }
          function Ut(t, e) {
            return "as" == e ? (S.marked = "keyword", T(F("variable"))) : "variable" == t ? k(B, Ut) : void 0;
          }
          function $t(t) {
            return "string" == t ? T() : "(" == t ? k(H) : "." == t ? k(q) : k(Wt, qt, Yt);
          }
          function Wt(t, e) {
            return "{" == t ? at(Wt, "}") : ("variable" == t && E(e), "*" == e && (S.marked = "keyword"), T(Gt));
          }
          function qt(t) {
            if ("," == t) return T(Wt, qt);
          }
          function Gt(t, e) {
            if ("as" == e) return S.marked = "keyword", T(Wt);
          }
          function Yt(t, e) {
            if ("from" == e) return S.marked = "keyword", T(H);
          }
          function Kt(t) {
            return "]" == t ? T() : k(ot(B, "]"));
          }
          function Xt() {
            return k(I("form"), St, F("{"), I("}"), ot(Jt, "}"), R, R);
          }
          function Jt() {
            return k(St, jt);
          }
          function Zt(t, e, n) {
            return e.tokenize == v && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(e.lastType) || "quasi" == e.lastType && /\{\s*$/.test(t.string.slice(0, t.pos - (n || 0)));
          }
          return L.lex = _.lex = !0, N.lex = !0, R.lex = !0, {
            startState: function startState(t) {
              var e = {
                tokenize: v,
                lastType: "sof",
                cc: [],
                lexical: new x((t || 0) - o, 0, "block", !1),
                localVars: n.localVars,
                context: n.localVars && new A(null, null, !1),
                indented: t || 0
              };
              return n.globalVars && "object" == typeof n.globalVars && (e.globalVars = n.globalVars), e;
            },
            token: function token(t, e) {
              if (t.sol() && (e.lexical.hasOwnProperty("align") || (e.lexical.align = !1), e.indented = t.indentation(), y(t, e)), e.tokenize != m && t.eatSpace()) return null;
              var n = e.tokenize(t, e);
              return "comment" == r ? n : (e.lastType = "operator" != r || "++" != i && "--" != i ? r : "incdec", C(e, n, r, i, t));
            },
            indent: function indent(e, r) {
              if (e.tokenize == m || e.tokenize == b) return t.Pass;
              if (e.tokenize != v) return 0;
              var i,
                s = r && r.charAt(0),
                c = e.lexical;
              if (!/^\s*else\b/.test(r)) for (var l = e.cc.length - 1; l >= 0; --l) {
                var u = e.cc[l];
                if (u == R) c = c.prev;else if (u != Pt && u != N) break;
              }
              for (; ("stat" == c.type || "form" == c.type) && ("}" == s || (i = e.cc[e.cc.length - 1]) && (i == q || i == G) && !/^[,\.=+\-*:?[\(]/.test(r));) c = c.prev;
              a && ")" == c.type && "stat" == c.prev.type && (c = c.prev);
              var d = c.type,
                h = s == d;
              return "vardef" == d ? c.indented + ("operator" == e.lastType || "," == e.lastType ? c.info.length + 1 : 0) : "form" == d && "{" == s ? c.indented : "form" == d ? c.indented + o : "stat" == d ? c.indented + (function (t, e) {
                return "operator" == t.lastType || "," == t.lastType || f.test(e.charAt(0)) || /[,.]/.test(e.charAt(0));
              }(e, r) ? a || o : 0) : "switch" != c.info || h || 0 == n.doubleIndentSwitch ? c.align ? c.column + (h ? 0 : 1) : c.indented + (h ? 0 : o) : c.indented + (/^(?:case|default)\b/.test(r) ? o : 2 * o);
            },
            electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
            blockCommentStart: c ? null : "/*",
            blockCommentEnd: c ? null : "*/",
            blockCommentContinue: c ? null : " * ",
            lineComment: c ? null : "//",
            fold: "brace",
            closeBrackets: "()[]{}''\"\"``",
            helperType: c ? "json" : "javascript",
            jsonldMode: s,
            jsonMode: c,
            expressionAllowed: Zt,
            skipExpression: function skipExpression(e) {
              C(e, "atom", "atom", "true", new t.StringStream("", 2, null));
            }
          };
        }), t.registerHelper("wordChars", "javascript", /[\w$]/), t.defineMIME("text/javascript", "javascript"), t.defineMIME("text/ecmascript", "javascript"), t.defineMIME("application/javascript", "javascript"), t.defineMIME("application/x-javascript", "javascript"), t.defineMIME("application/ecmascript", "javascript"), t.defineMIME("application/json", {
          name: "javascript",
          json: !0
        }), t.defineMIME("application/x-json", {
          name: "javascript",
          json: !0
        }), t.defineMIME("application/manifest+json", {
          name: "javascript",
          json: !0
        }), t.defineMIME("application/ld+json", {
          name: "javascript",
          jsonld: !0
        }), t.defineMIME("text/typescript", {
          name: "javascript",
          typescript: !0
        }), t.defineMIME("application/typescript", {
          name: "javascript",
          typescript: !0
        });
      }(n(13));
    }, function (t, e, n) {
      !function (t) {
        t.extendMode("css", {
          commentStart: "/*",
          commentEnd: "*/",
          newlineAfterToken: function newlineAfterToken(t, e) {
            return /^[;{}]$/.test(e);
          }
        }), t.extendMode("javascript", {
          commentStart: "/*",
          commentEnd: "*/",
          newlineAfterToken: function newlineAfterToken(t, e, n, r) {
            return this.jsonMode ? /^[\[,{]$/.test(e) || /^}/.test(n) : (";" != e || !r.lexical || ")" != r.lexical.type) && /^[;{}]$/.test(e) && !/^;/.test(n);
          }
        });
        var e = /^(a|abbr|acronym|area|base|bdo|big|br|button|caption|cite|code|col|colgroup|dd|del|dfn|em|frame|hr|iframe|img|input|ins|kbd|label|legend|link|map|object|optgroup|option|param|q|samp|script|select|small|span|strong|sub|sup|textarea|tt|var)$/;
        t.extendMode("xml", {
          commentStart: "\x3c!--",
          commentEnd: "--\x3e",
          newlineAfterToken: function newlineAfterToken(t, n, r, i) {
            var o = !1;
            return "html" == this.configuration && (o = !!i.context && e.test(i.context.tagName)), !o && ("tag" == t && />$/.test(n) && i.context || /^</.test(r));
          }
        }), t.defineExtension("commentRange", function (e, n, r) {
          var i = this,
            o = t.innerMode(i.getMode(), i.getTokenAt(n).state).mode;
          i.operation(function () {
            if (e) i.replaceRange(o.commentEnd, r), i.replaceRange(o.commentStart, n), n.line == r.line && n.ch == r.ch && i.setCursor(n.line, n.ch + o.commentStart.length);else {
              var t = i.getRange(n, r),
                a = t.indexOf(o.commentStart),
                s = t.lastIndexOf(o.commentEnd);
              a > -1 && s > -1 && s > a && (t = t.substr(0, a) + t.substring(a + o.commentStart.length, s) + t.substr(s + o.commentEnd.length)), i.replaceRange(t, n, r);
            }
          });
        }), t.defineExtension("autoIndentRange", function (t, e) {
          var n = this;
          this.operation(function () {
            for (var r = t.line; r <= e.line; r++) n.indentLine(r, "smart");
          });
        }), t.defineExtension("autoFormatRange", function (e, n) {
          var r = this,
            i = r.getMode(),
            o = r.getRange(e, n).split("\n"),
            a = t.copyState(i, r.getTokenAt(e).state),
            s = r.getOption("tabSize"),
            c = "",
            l = 0,
            u = 0 === e.ch;
          function d() {
            c += "\n", u = !0, ++l;
          }
          for (var h = 0; h < o.length; ++h) {
            for (var f = new t.StringStream(o[h], s); !f.eol();) {
              var p = t.innerMode(i, a),
                g = i.token(f, a),
                v = f.current();
              f.start = f.pos, u && !/\S/.test(v) || (c += v, u = !1), !u && p.mode.newlineAfterToken && p.mode.newlineAfterToken(g, v, f.string.slice(f.pos) || o[h + 1] || "", p.state) && d();
            }
            !f.pos && i.blankLine && i.blankLine(a), !u && h < o.length - 1 && d();
          }
          r.operation(function () {
            r.replaceRange(c, e, n);
            for (var t = e.line + 1, i = e.line + l; t <= i; ++t) r.indentLine(t, "smart");
            r.setSelection(e, r.getCursor(!1));
          });
        });
      }(n(13));
    }, function (t, e) {
      t.exports = function (t) {
        if (Array.isArray(t)) return t;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function (t, e) {
        var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null != n) {
          var r,
            i,
            o,
            a,
            s = [],
            c = !0,
            l = !1;
          try {
            if (o = (n = n.call(t)).next, 0 === e) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = o.call(n)).done) && (s.push(r.value), s.length !== e); c = !0);
          } catch (t) {
            l = !0, i = t;
          } finally {
            try {
              if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw i;
            }
          }
          return s;
        }
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e) {
      t.exports = function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(1),
        i = n.n(r),
        o = n(36),
        a = n(5);
      e.default = i.a.View.extend({
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.opt = t;
          var e = t.config || {};
          this.level = t.level, this.config = e, this.preview = t.preview, this.ppfx = e.pStylePrefix || "", this.pfx = e.stylePrefix || "", this.parent = t.parent, this.parentView = t.parentView;
          var n = this.pfx,
            r = this.ppfx,
            i = this.parent,
            o = this.collection;
          this.listenTo(o, "add", this.addTo), this.listenTo(o, "reset resetNavigator", this.render), this.listenTo(o, "remove", this.removeChildren), this.className = "".concat(n, "layers");
          var s = e.em;
          if (e.sortable && !this.opt.sorter) {
            var c = s.get("Utils");
            this.opt.sorter = new c.Sorter({
              container: e.sortContainer || this.el,
              containerSel: ".".concat(this.className),
              itemSel: ".".concat(n, "layer"),
              ignoreViewChildren: 1,
              onEndMove: function onEndMove(t, e, n) {
                var r = e.getSourceModel();
                s.setSelected(r, {
                  forceChange: 1
                }), s.trigger("".concat(a.eventDrag, ":end"), n);
              },
              avoidSelectOnEnd: 1,
              nested: 1,
              ppfx: r,
              pfx: n
            });
          }
          this.sorter = this.opt.sorter || "", this.$el.data("collection", o), i && this.$el.data("model", i);
        },
        removeChildren: function removeChildren(t) {
          var e = t.viewLayer;
          e && (e.remove(), t.viewLayer = 0);
        },
        addTo: function addTo(t) {
          var e = this.collection.indexOf(t);
          this.addToCollection(t, null, e);
        },
        addToCollection: function addToCollection(t, e, n) {
          var r = this.level,
            i = this.parentView,
            a = e || null,
            s = new (0, o.a)({
              level: r,
              model: t,
              parentView: i,
              config: this.config,
              sorter: this.sorter,
              isCountable: this.isCountable,
              opened: this.opt.opened
            }).render().el;
          if (a) a.appendChild(s);else if (void 0 !== n) {
            var c = "before";
            this.$el.children().length == n && (n--, c = "after"), n < 0 ? this.$el.append(s) : this.$el.children().eq(n)[c](s);
          } else this.$el.append(s);
          return s;
        },
        isCountable: function isCountable(t, e) {
          var n = t.get("type"),
            r = t.get("tagName");
          return !(("textnode" == n || "br" == r) && e || !t.get("layerable"));
        },
        render: function render() {
          var t = this,
            e = document.createDocumentFragment(),
            n = this.el;
          return n.innerHTML = "", this.collection.each(function (n) {
            return t.addToCollection(n, e);
          }), n.appendChild(e), n.className = this.className, this;
        }
      });
    }, function (t, e, n) {
      var r = {
        "./CanvasClear": 46,
        "./CanvasClear.js": 46,
        "./CanvasMove": 47,
        "./CanvasMove.js": 47,
        "./CommandAbstract": 22,
        "./CommandAbstract.js": 22,
        "./ComponentDelete": 48,
        "./ComponentDelete.js": 48,
        "./ComponentDrag": 49,
        "./ComponentDrag.js": 49,
        "./ComponentEnter": 50,
        "./ComponentEnter.js": 50,
        "./ComponentExit": 51,
        "./ComponentExit.js": 51,
        "./ComponentNext": 52,
        "./ComponentNext.js": 52,
        "./ComponentPrev": 53,
        "./ComponentPrev.js": 53,
        "./ComponentStyleClear": 54,
        "./ComponentStyleClear.js": 54,
        "./CopyComponent": 55,
        "./CopyComponent.js": 55,
        "./DeleteComponent": 56,
        "./DeleteComponent.js": 56,
        "./DeviceDesktop": 57,
        "./DeviceDesktop.js": 57,
        "./DeviceMobile": 58,
        "./DeviceMobile.js": 58,
        "./DeviceMobilePtr": 59,
        "./DeviceMobilePtr.js": 59,
        "./DeviceTablet": 60,
        "./DeviceTablet.js": 60,
        "./ExportTemplate": 61,
        "./ExportTemplate.js": 61,
        "./Fullscreen": 62,
        "./Fullscreen.js": 62,
        "./MoveComponent": 63,
        "./MoveComponent.js": 63,
        "./OpenAssets": 64,
        "./OpenAssets.js": 64,
        "./OpenBlocks": 65,
        "./OpenBlocks.js": 65,
        "./OpenLayers": 66,
        "./OpenLayers.js": 66,
        "./OpenStyleManager": 67,
        "./OpenStyleManager.js": 67,
        "./OpenTraitManager": 68,
        "./OpenTraitManager.js": 68,
        "./PasteComponent": 69,
        "./PasteComponent.js": 69,
        "./Preview": 70,
        "./Preview.js": 70,
        "./Resize": 71,
        "./Resize.js": 71,
        "./SaveDb": 72,
        "./SaveDb.js": 72,
        "./SelectComponent": 14,
        "./SelectComponent.js": 14,
        "./SelectPosition": 27,
        "./SelectPosition.js": 27,
        "./ShowOffset": 73,
        "./ShowOffset.js": 73,
        "./SwitchVisibility": 74,
        "./SwitchVisibility.js": 74
      };
      function i(t) {
        var e = o(t);
        return n(e);
      }
      function o(t) {
        if (!n.o(r, t)) {
          var e = new Error("Cannot find module '" + t + "'");
          throw e.code = "MODULE_NOT_FOUND", e;
        }
        return r[t];
      }
      i.keys = function () {
        return Object.keys(r);
      }, i.resolve = o, t.exports = i, i.id = 99;
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(8),
        i = n.n(r),
        o = n(2),
        a = n.n(o),
        s = n(1),
        c = n.n(s),
        l = n(0),
        u = {
          stylePrefix: "comp-",
          wrapperId: "wrapper",
          wrapperName: "Body",
          wrapper: {
            removable: !1,
            copyable: !1,
            draggable: !1,
            components: [],
            traits: [],
            stylable: ["background", "background-color", "background-image", "background-repeat", "background-attachment", "background-position", "background-size"]
          },
          components: [],
          draggableComponents: 1,
          storeWrapper: 0,
          processor: 0,
          voidElements: ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"]
        },
        d = n(5),
        h = n(21),
        f = n(6),
        p = n(35);
      function g(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function v(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? g(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : g(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var m = d.default.extend({
          defaults: v(v({}, d.default.prototype.defaults), {}, {
            type: "cell",
            tagName: "td",
            draggable: ["tr"]
          })
        }, {
          isComponent: function isComponent(t) {
            var e = "",
              n = t.tagName;
            return "TD" != n && "TH" != n || (e = {
              type: "cell",
              tagName: n.toLowerCase()
            }), e;
          }
        }),
        b = f.default.extend({});
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x = d.default.extend({
          defaults: w(w({}, d.default.prototype.defaults), {}, {
            tagName: "tr",
            draggable: ["thead", "tbody", "tfoot"],
            droppable: ["th", "td"]
          })
        }, {
          isComponent: function isComponent(t) {
            return "TR" == t.tagName && !0;
          }
        }),
        O = f.default.extend({});
      function C(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function S(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? C(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : C(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var k = d.default.extend({
          defaults: S(S({}, d.default.prototype.defaults), {}, {
            type: "table",
            tagName: "table",
            droppable: ["tbody", "thead", "tfoot"]
          }),
          initialize: function initialize(t, e) {
            d.default.prototype.initialize.apply(this, arguments);
            var n = this.get("components");
            !n.length && n.add({
              type: "tbody"
            });
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "TABLE" == t.tagName && (e = {
              type: "table"
            }), e;
          }
        }),
        T = f.default.extend({
          events: {}
        });
      function j(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function E(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? j(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var P = d.default.extend({
        defaults: E(E({}, d.default.prototype.defaults), {}, {
          type: "tbody",
          tagName: "tbody",
          draggable: ["table"],
          droppable: ["tr"],
          columns: 1,
          rows: 1
        }),
        initialize: function initialize(t, e) {
          d.default.prototype.initialize.apply(this, arguments);
          var n = this.get("components"),
            r = this.get("columns"),
            i = this.get("rows");
          if (!n.length) {
            for (var o = []; i--;) {
              for (var a = [], s = r; s--;) a.push({
                type: "cell",
                classes: ["cell"]
              });
              o.push({
                type: "row",
                classes: ["row"],
                components: a
              });
            }
            n.add(o);
          }
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return "TBODY" == t.tagName && (e = {
            type: "tbody"
          }), e;
        }
      });
      function A(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function M(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? A(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : A(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var D = P.extend({
          defaults: M(M({}, P.prototype.defaults), {}, {
            type: "thead",
            tagName: "thead"
          })
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "THEAD" == t.tagName && (e = {
              type: "thead"
            }), e;
          }
        }),
        L = f.default.extend({}),
        _ = f.default.extend({});
      function N(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function I(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? N(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : N(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var R = P.extend({
          defaults: I(I({}, P.prototype.defaults), {}, {
            type: "tfoot",
            tagName: "tfoot"
          })
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "TFOOT" == t.tagName && (e = {
              type: "tfoot"
            }), e;
          }
        }),
        F = f.default.extend({});
      function V(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function z(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? V(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : V(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var H = 'xmlns="http://www.w3.org/2000/svg" width="100" viewBox="0 0 24 24" style="fill: rgba(0,0,0,0.15); transform: scale(0.75)"',
        B = d.default.extend({
          defaults: z(z({}, d.default.prototype.defaults), {}, {
            type: "image",
            tagName: "img",
            void: 1,
            droppable: 0,
            editable: 1,
            highlightable: 0,
            resizable: {
              ratioDefault: 1
            },
            traits: ["alt"],
            src: "<svg ".concat(H, '>\n        <path d="M8.5 13.5l2.5 3 3.5-4.5 4.5 6H5m16 1V5a2 2 0 0 0-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2z"></path>\n      </svg>'),
            fallback: "<svg ".concat(H, '>\n        <path d="M2.28 3L1 4.27l2 2V19c0 1.1.9 2 2 2h12.73l2 2L21 21.72 2.28 3m2.55 0L21 19.17V5a2 2 0 0 0-2-2H4.83M8.5 13.5l2.5 3 1-1.25L14.73 18H5l3.5-4.5z"></path>\n      </svg>'),
            file: ""
          }),
          initialize: function initialize(t, e) {
            d.default.prototype.initialize.apply(this, arguments);
            var n = this.get("attributes");
            n.src && this.set("src", n.src);
          },
          initToolbar: function initToolbar() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            d.default.prototype.initToolbar.apply(this, e);
            var r = this.em;
            if (r) {
              var i = r.get("Commands"),
                o = "image-editor";
              if (i.has(o)) {
                for (var a = !1, s = this.get("toolbar"), c = 0; c < s.length; c++) if ("image-editor" === s[c].command) {
                  a = !0;
                  break;
                }
                a || (s.push({
                  attributes: {
                    class: "fa fa-pencil"
                  },
                  command: o
                }), this.set("toolbar", s));
              }
            }
          },
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var r = d.default.prototype.getAttrToHTML.apply(this, e),
              i = this.getSrcResult();
            return i && (r.src = i), r;
          },
          getSrcResult: function getSrcResult() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.get(t.fallback ? "fallback" : "src") || "",
              n = e;
            return e && "<svg" === e.substr(0, 4) && (n = "data:image/svg+xml;base64,".concat(window.btoa(e))), n;
          },
          isDefaultSrc: function isDefaultSrc() {
            return this.get("src") === Object(l.result)(this, "defaults").src;
          },
          parseUri: function parseUri(t) {
            var e = document.createElement("a");
            e.href = t;
            for (var n = {}, r = e.search.substring(1).split("&"), i = 0; i < r.length; i++) {
              var o = r[i].split("="),
                a = decodeURIComponent(o[0]);
              a && (n[a] = decodeURIComponent(o[1]));
            }
            return {
              hostname: e.hostname,
              pathname: e.pathname,
              protocol: e.protocol,
              search: e.search,
              hash: e.hash,
              port: e.port,
              query: n
            };
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "IMG" == t.tagName && (e = {
              type: "image"
            }), e;
          }
        });
      function U(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function $(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? U(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : U(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var W = B.extend({
          defaults: $($({}, B.prototype.defaults), {}, {
            type: "map",
            src: "",
            void: 0,
            mapUrl: "https://maps.google.com/maps",
            tagName: "iframe",
            mapType: "q",
            address: "",
            zoom: "1",
            attributes: {
              frameborder: 0
            },
            toolbar: d.default.prototype.defaults.toolbar,
            traits: [{
              label: "Address",
              name: "address",
              placeholder: "eg. London, UK",
              changeProp: 1
            }, {
              type: "select",
              label: "Map type",
              name: "mapType",
              changeProp: 1,
              options: [{
                value: "q",
                name: "Roadmap"
              }, {
                value: "w",
                name: "Satellite"
              }]
            }, {
              label: "Zoom",
              name: "zoom",
              type: "range",
              min: "1",
              max: "20",
              changeProp: 1
            }]
          }),
          initialize: function initialize(t, e) {
            this.get("src") ? this.parseFromSrc() : this.updateSrc(), B.prototype.initialize.apply(this, arguments), this.listenTo(this, "change:address change:zoom change:mapType", this.updateSrc);
          },
          updateSrc: function updateSrc() {
            this.set("src", this.getMapUrl());
          },
          getMapUrl: function getMapUrl() {
            var t = this.get("address"),
              e = this.get("zoom"),
              n = this.get("mapType");
            return t = t ? "&q=" + t : "", e = e ? "&z=" + e : "", n = n ? "&t=" + n : "", this.get("mapUrl") + "?" + t + e + n + "&output=embed";
          },
          parseFromSrc: function parseFromSrc() {
            var t = this.parseUri(this.get("src")).query;
            t.q && this.set("address", t.q), t.z && this.set("zoom", t.z), t.t && this.set("mapType", t.t);
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "IFRAME" == t.tagName && /maps\.google\.com/.test(t.src) && (e = {
              type: "map",
              src: t.src
            }), e;
          }
        }),
        q = f.default.extend({
          tagName: "img",
          events: {
            dblclick: "onActive",
            click: "initResize",
            error: "onError",
            load: "onLoad",
            dragstart: "noDrag"
          },
          initialize: function initialize(t) {
            var e = this.model;
            f.default.prototype.initialize.apply(this, arguments), this.listenTo(e, "change:src", this.updateSrc), this.classEmpty = "".concat(this.ppfx, "plh-image");
            var n = this.config;
            n.modal && (this.modal = n.modal), n.am && (this.am = n.am), this.fetchFile();
          },
          fetchFile: function fetchFile() {
            if (!this.modelOpt.temporary) {
              var t = this.model,
                e = t.get("file");
              e && (this.em.get("AssetManager").FileUploader().uploadFile({
                dataTransfer: {
                  files: [e]
                }
              }, function (e) {
                var n = e && e.data && e.data[0],
                  r = n && (Object(l.isString)(n) ? n : n.src);
                r && t.set({
                  src: r
                });
              }), t.set("file", ""));
            }
          },
          updateSrc: function updateSrc() {
            var t = this.model,
              e = this.classEmpty,
              n = this.$el,
              r = t.getSrcResult(),
              i = r && !t.isDefaultSrc();
            t.addAttributes({
              src: r
            }), n[i ? "removeClass" : "addClass"](e);
          },
          onActive: function onActive(t) {
            t && t.stopPropagation();
            var e = this.opts.config.em,
              n = e ? e.get("Editor") : "";
            n && this.model.get("editable") && n.runCommand("open-assets", {
              target: this.model,
              types: ["image"],
              accept: "image/*",
              onSelect: function onSelect() {
                n.Modal.close(), n.AssetManager.setTarget(null);
              }
            });
          },
          onError: function onError() {
            var t = this.model.getSrcResult({
              fallback: 1
            });
            t && (this.el.src = t);
          },
          onLoad: function onLoad() {
            this.em.trigger("change:canvasOffset");
          },
          noDrag: function noDrag(t) {
            return t.preventDefault(), !1;
          },
          render: function render() {
            this.renderAttributes(), this.updateSrc();
            var t = this.$el,
              e = this.model,
              n = t.attr("class") || "";
            return !e.get("src") && t.attr("class", "".concat(n, " ").concat(this.classEmpty).trim()), this.postRender(), this;
          }
        }),
        G = q.extend({
          tagName: "div",
          events: {},
          initialize: function initialize(t) {
            q.prototype.initialize.apply(this, arguments), this.classEmpty = this.ppfx + "plh-map";
          },
          updateSrc: function updateSrc() {
            this.getIframe().src = this.model.get("src");
          },
          getIframe: function getIframe() {
            if (!this.iframe) {
              var t = document.createElement("iframe");
              t.src = this.model.get("src"), t.frameBorder = 0, t.style.height = "100%", t.style.width = "100%", t.className = this.ppfx + "no-pointer", this.iframe = t;
            }
            return this.iframe;
          },
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            return q.prototype.render.apply(this, e), this.updateClasses(), this.el.appendChild(this.getIframe()), this;
          }
        });
      function Y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function K(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Y(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var X = d.default.extend({
        defaults: K(K({}, d.default.prototype.defaults), {}, {
          type: "text",
          droppable: !1,
          editable: !0
        }),
        toHTML: function toHTML() {
          return this.trigger("sync:content", {
            silent: 1
          }), d.default.prototype.toHTML.apply(this, arguments);
        }
      });
      function J(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Z(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? J(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : J(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Q = X.extend({
          defaults: Z(Z({}, X.prototype.defaults), {}, {
            type: "link",
            tagName: "a",
            traits: ["title", "href", "target"]
          }),
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var r = X.prototype.getAttrToHTML.apply(this, e);
            return delete r.onmousedown, r;
          }
        }, {
          isComponent: function isComponent(t) {
            var e;
            if ("A" == t.tagName) {
              e = {
                type: "link",
                editable: 0
              };
              var n = t.childNodes,
                r = n.length;
              r || delete e.editable;
              for (var i = 0; i < r; i++) {
                var o = n[i];
                if (3 == o.nodeType && "" != o.textContent.trim()) {
                  delete e.editable;
                  break;
                }
              }
            }
            return e;
          }
        }),
        tt = n(3);
      function et(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function nt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? et(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : et(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var rt = f.default.prototype,
        it = f.default.extend({
          events: {
            dblclick: "onActive",
            input: "onInput"
          },
          initialize: function initialize(t) {
            rt.initialize.apply(this, arguments), this.disableEditing = this.disableEditing.bind(this);
            var e = this.model,
              n = this.em;
            this.listenTo(e, "focus", this.onActive), this.listenTo(e, "change:content", this.updateContentText), this.listenTo(e, "sync:content", this.syncContent), this.rte = n && n.get("RichTextEditor");
          },
          updateContentText: function updateContentText(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            !n.fromDisable && this.disableEditing();
          },
          onActive: function onActive(t) {
            if (!this.rteEnabled && this.model.get("editable")) {
              t && t.stopPropagation && t.stopPropagation();
              var e = this.rte,
                n = this.em;
              if (e) try {
                this.activeRte = e.enable(this, this.activeRte);
              } catch (t) {
                n.logError(t);
              }
              this.toggleEvents(1);
            }
          },
          onDisable: function onDisable() {
            this.disableEditing();
          },
          disableEditing: function disableEditing() {
            var t = this.model,
              e = this.rte,
              n = this.activeRte,
              r = this.em,
              i = t.get("editable");
            if (e && i) {
              try {
                e.disable(this, n);
              } catch (t) {
                r.logError(t);
              }
              this.syncContent();
            }
            this.toggleEvents();
          },
          getContent: function getContent() {
            var t = this.activeRte;
            return t && "function" == typeof t.getContent ? t.getContent() : this.getChildrenContainer().innerHTML;
          },
          syncContent: function syncContent() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = this.rte,
              r = this.rteEnabled;
            if (r || t.force) {
              var i = this.getContent(),
                o = e.components(),
                a = nt({
                  fromDisable: 1
                }, t);
              if (o.length && o.reset(null, t), e.set("content", "", a), n.customRte) e.set("content", i, a);else {
                var s = function e(n) {
                  var r = !!n.get("textable"),
                    i = !["text", "default", ""].some(function (t) {
                      return n.is(t);
                    }) || r;
                  n.set(nt({
                    _innertext: !i,
                    editable: i && n.get("editable"),
                    selectable: i,
                    hoverable: i,
                    removable: r,
                    draggable: r,
                    highlightable: 0,
                    copyable: r
                  }, !r && {
                    toolbar: ""
                  }), t), n.get("components").each(function (t) {
                    return e(t);
                  });
                };
                !t.silent && e.trigger("change:content", e, "", a), o.add(i, t), o.each(function (t) {
                  return s(t);
                }), o.trigger("resetNavigator");
              }
            }
          },
          getModelsFromEl: function getModelsFromEl(t) {
            for (var e = [], n = (t || this.el).childNodes, r = 0; r < n.length; r++) {
              var i = n[r],
                o = i.__cashData && i.__cashData.model;
              o && (o.components = this.getModelsFromEl(i), o.get("content") && (o.attributes.content = i.textContent), e.push(o));
            }
            return e;
          },
          onInput: function onInput() {
            var t = this.em,
              e = ["".concat("component", ":update"), "".concat("component", ":input")].join(" ");
            t && t.trigger(e, this.model);
          },
          disablePropagation: function disablePropagation(t) {
            t.stopPropagation();
          },
          toggleEvents: function toggleEvents(t) {
            var e = this.em,
              n = {
                on: tt.u,
                off: tt.t
              },
              r = t ? "on" : "off";
            e.setEditing(t), this.rteEnabled = !!t;
            var i = [this.el.ownerDocument, document];
            if (n.off(i, "mousedown", this.disableEditing), n[r](i, "mousedown", this.disableEditing), e[r]("toolbar:run:before", this.disableEditing), this.$el.off("mousedown", this.disablePropagation), this.$el[r]("mousedown", this.disablePropagation), this.config.draggableComponents) for (var o = this.el; o;) o.draggable = !t, (o = o.parentNode) && "BODY" == o.tagName && (o = 0);
          }
        }),
        ot = it.extend({
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            return it.prototype.render.apply(this, e), this.el.addEventListener("click", this.prevDef, !0), this;
          }
        });
      function at(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function st(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? at(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : at(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var ct = X.extend({
          defaults: st(st({}, X.prototype.defaults), {}, {
            tagName: "label",
            traits: ["id", "title", "for"]
          })
        }, {
          isComponent: function isComponent(t) {
            if ("LABEL" == t.tagName) return {
              type: "label"
            };
          }
        }),
        lt = ot.extend({
          tagName: "span"
        });
      function ut(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function dt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? ut(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ut(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var ht = "yt",
        ft = "vi",
        pt = "ytnc",
        gt = B.extend({
          defaults: dt(dt({}, B.prototype.defaults), {}, {
            type: "video",
            tagName: "video",
            videoId: "",
            void: 0,
            provider: ht,
            ytUrl: "https://www.youtube.com/embed/",
            ytncUrl: "https://www.youtube-nocookie.com/embed/",
            viUrl: "https://player.vimeo.com/video/",
            loop: 0,
            poster: "",
            muted: 0,
            autoplay: 0,
            controls: 1,
            color: "",
            list: "",
            rel: 1,
            modestbranding: 0,
            sources: [],
            attributes: {
              allowfullscreen: "allowfullscreen"
            },
            src: "Bizu6v9k5Uc"
          }),
          initialize: function initialize(t, e) {
            this.em = e.em, this.get("src") && this.parseFromSrc(), this.updateTraits(), this.listenTo(this, "change:provider", this.updateTraits), this.listenTo(this, "change:videoId change:provider", this.updateSrc), B.prototype.initialize.apply(this, arguments);
          },
          updateTraits: function updateTraits() {
            var t,
              e = "iframe";
            switch (this.get("provider")) {
              case ht:
                this.setAttributes(a()({}, "data-video-type", "youtube")), t = this.getYoutubeTraits();
                break;
              case pt:
                this.setAttributes(a()({}, "data-video-type", "youtube-nocookie")), t = this.getYoutubeTraits();
                break;
              case ft:
                this.setAttributes(a()({}, "data-video-type", "vimeo")), t = this.getVimeoTraits();
                break;
              default:
                this.setAttributes(a()({}, "data-video-type", "video")), e = "video", t = this.getSourceTraits();
            }
            this.set({
              tagName: e
            }, {
              silent: 1
            }), this.set({
              traits: t
            }), this.em.trigger("component:toggled");
          },
          parseFromSrc: function parseFromSrc() {
            var t = this.get("provider"),
              e = this.parseUri(this.get("src")),
              n = e.query;
            switch (t) {
              case ht:
              case pt:
              case ft:
                var r = e.pathname.split("/").pop();
                this.set("videoId", r), n.list && this.set("list", n.list), n.autoplay && this.set("autoplay", 1), n.loop && this.set("loop", 1), 0 === parseInt(n.controls) && this.set("controls", 0), n.color && this.set("color", n.color), "0" === n.rel && this.set("rel", 0), "1" === n.modestbranding && this.set("modestbranding", 1);
            }
          },
          updateSrc: function updateSrc() {
            var t = "";
            switch (this.get("provider")) {
              case ht:
                t = this.getYoutubeSrc();
                break;
              case pt:
                t = this.getYoutubeNoCookieSrc();
                break;
              case ft:
                t = this.getVimeoSrc();
            }
            this.set({
              src: t
            });
          },
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var r = B.prototype.getAttrToHTML.apply(this, e),
              i = this.get("provider");
            switch (i) {
              case ht:
              case pt:
              case ft:
                break;
              default:
                this.get("loop") && (r.loop = "loop"), this.get("autoplay") && (r.autoplay = "autoplay"), this.get("controls") && (r.controls = "controls");
            }
            return r;
          },
          getProviderTrait: function getProviderTrait() {
            return {
              type: "select",
              label: "Provider",
              name: "provider",
              changeProp: 1,
              options: [{
                value: "so",
                name: "HTML5 Source"
              }, {
                value: ht,
                name: "Youtube"
              }, {
                value: pt,
                name: "Youtube (no cookie)"
              }, {
                value: ft,
                name: "Vimeo"
              }]
            };
          },
          getSourceTraits: function getSourceTraits() {
            return [this.getProviderTrait(), {
              label: "Source",
              name: "src",
              placeholder: "eg. ./media/video.mp4",
              changeProp: 1
            }, {
              label: "Poster",
              name: "poster",
              placeholder: "eg. ./media/image.jpg"
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), this.getWebconnectVideoTrait()];
          },
          getYoutubeTraits: function getYoutubeTraits() {
            return [this.getProviderTrait(), {
              label: "Video ID",
              name: "videoId",
              placeholder: "eg. jNQXAC9IVRw",
              changeProp: 1
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), {
              type: "checkbox",
              label: "Related",
              name: "rel",
              changeProp: 1
            }, {
              type: "checkbox",
              label: "Modest",
              name: "modestbranding",
              changeProp: 1
            }, this.getWebconnectVideoTrait()];
          },
          getVimeoTraits: function getVimeoTraits() {
            return [this.getProviderTrait(), {
              label: "Video ID",
              name: "videoId",
              placeholder: "eg. 123456789",
              changeProp: 1
            }, {
              label: "Color",
              name: "color",
              placeholder: "eg. FF0000",
              changeProp: 1
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getWebconnectVideoTrait()];
          },
          getAutoplayTrait: function getAutoplayTrait() {
            return {
              type: "checkbox",
              label: "Autoplay",
              name: "autoplay",
              changeProp: 1
            };
          },
          getLoopTrait: function getLoopTrait() {
            return {
              type: "checkbox",
              label: "Loop",
              name: "loop",
              changeProp: 1
            };
          },
          getControlsTrait: function getControlsTrait() {
            return {
              type: "checkbox",
              label: "Controls",
              name: "controls",
              changeProp: 1
            };
          },
          getYoutubeSrc: function getYoutubeSrc() {
            var t = this.get("videoId"),
              e = this.get("ytUrl"),
              n = this.get("list");
            return e += t + (t.indexOf("?") < 0 ? "?" : ""), e += n ? "&list=".concat(n) : "", e += this.get("autoplay") ? "&autoplay=1" : "", e += this.get("controls") ? "" : "&controls=0&showinfo=0", e += this.get("loop") ? "&loop=1&playlist=".concat(t) : "", (e += this.get("rel") ? "" : "&rel=0") + (this.get("modestbranding") ? "&modestbranding=1" : "");
          },
          getYoutubeNoCookieSrc: function getYoutubeNoCookieSrc() {
            var t = this.getYoutubeSrc();
            return t.replace(this.get("ytUrl"), this.get("ytncUrl"));
          },
          getVimeoSrc: function getVimeoSrc() {
            var t = this.get("viUrl");
            return t += this.get("videoId") + "?", t += this.get("autoplay") ? "&autoplay=1" : "", t += this.get("loop") ? "&loop=1" : "", (t += this.get("controls") ? "" : "&title=0&portrait=0&badge=0") + (this.get("color") ? "&color=" + this.get("color") : "");
          },
          getWebconnectVideoTrait: function getWebconnectVideoTrait() {
            return {
              type: "webconnect-video",
              label: !1,
              content: "Insert your text here"
            };
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "",
              n = /youtube\.com\/embed/.test(t.src),
              r = /youtube-nocookie\.com\/embed/.test(t.src),
              i = /player\.vimeo\.com\/video/.test(t.src),
              o = n || r || i;
            return ("VIDEO" == t.tagName || "IFRAME" == t.tagName && o) && (e = {
              type: "video"
            }, t.src && (e.src = t.src), o && (n ? e.provider = ht : r ? e.provider = pt : i && (e.provider = ft))), e;
          }
        }),
        vt = q.extend({
          tagName: "div",
          events: {},
          initialize: function initialize(t) {
            f.default.prototype.initialize.apply(this, arguments);
            var e = this.model,
              n = ["loop", "autoplay", "controls", "color", "rel", "modestbranding", "poster"],
              r = n.map(function (t) {
                return "change:".concat(t);
              }).join(" ");
            this.listenTo(e, "change:provider", this.updateProvider), this.listenTo(e, "change:src", this.updateSrc), this.listenTo(e, r, this.updateVideo);
          },
          updateProvider: function updateProvider() {
            var t = this.model.get("provider");
            this.el.innerHTML = "", this.el.appendChild(this.renderByProvider(t));
          },
          updateSrc: function updateSrc() {
            var t = this.model,
              e = this.videoEl;
            if (e) {
              var n = t.get("provider"),
                r = t.get("src");
              switch (n) {
                case "yt":
                  r = t.getYoutubeSrc();
                  break;
                case "ytnc":
                  r = t.getYoutubeNoCookieSrc();
                  break;
                case "vi":
                  r = t.getVimeoSrc();
              }
              e.src = r;
            }
          },
          updateVideo: function updateVideo() {
            var t = this.model.get("provider"),
              e = this.videoEl,
              n = this.model;
            switch (t) {
              case "yt":
              case "ytnc":
              case "vi":
                this.model.trigger("change:videoId");
                break;
              default:
                e.loop = n.get("loop"), e.autoplay = n.get("autoplay"), e.controls = n.get("controls"), e.poster = n.get("poster");
            }
          },
          renderByProvider: function renderByProvider(t) {
            var e;
            switch (t) {
              case "yt":
                e = this.renderYoutube();
                break;
              case "ytnc":
                e = this.renderYoutubeNoCookie();
                break;
              case "vi":
                e = this.renderVimeo();
                break;
              default:
                e = this.renderSource();
            }
            return this.videoEl = e, e;
          },
          renderSource: function renderSource() {
            var t = document.createElement("video");
            return t.src = this.model.get("src"), this.initVideoEl(t), t;
          },
          renderYoutube: function renderYoutube() {
            var t = document.createElement("iframe");
            return t.src = this.model.getYoutubeSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
          },
          renderYoutubeNoCookie: function renderYoutubeNoCookie() {
            var t = document.createElement("iframe");
            return t.src = this.model.getYoutubeNoCookieSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
          },
          renderVimeo: function renderVimeo() {
            var t = document.createElement("iframe");
            return t.src = this.model.getVimeoSrc(), t.frameBorder = 0, t.setAttribute("allowfullscreen", !0), this.initVideoEl(t), t;
          },
          initVideoEl: function initVideoEl(t) {
            t.className = this.ppfx + "no-pointer", t.style.height = "100%", t.style.width = "100%";
          },
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            q.prototype.render.apply(this, e), this.updateClasses();
            var r = this.model.get("provider");
            return this.el.appendChild(this.renderByProvider(r)), this.updateVideo(), this;
          }
        });
      function mt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function bt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? mt(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : mt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var yt = B.extend({
          defaults: bt(bt({}, B.prototype.defaults), {}, {
            type: "audio",
            tagName: "audio",
            void: 0,
            provider: "hso",
            loop: 0,
            muted: 0,
            autoplay: 0,
            controls: 1,
            list: "",
            sources: [],
            attributes: {},
            src: "https://cdn.pixabay.com/download/audio/2022/01/12/audio_45cacdef8f.mp3"
          }),
          initialize: function initialize(t, e) {
            this.em = e.em, this.updateTraits(), B.prototype.initialize.apply(this, arguments);
          },
          updateTraits: function updateTraits() {
            var t = this.getSourceTraits();
            this.setAttributes(a()({}, "data-audio-type", "url")), this.set({
              tagName: "audio"
            }, {
              silent: 1
            }), this.set({
              traits: t
            }), this.em.trigger("component:toggled");
          },
          updateSrc: function updateSrc() {
            this.set({
              src: ""
            });
          },
          getAttrToHTML: function getAttrToHTML() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            var r = B.prototype.getAttrToHTML.apply(this, e);
            return this.get("loop") && (r.loop = "loop"), this.get("autoplay") && (r.autoplay = "autoplay"), this.get("controls") && (r.controls = "controls"), r;
          },
          getSourceTraits: function getSourceTraits() {
            return [{
              label: "Source",
              name: "src",
              placeholder: "eg. ./media/audio.mp3",
              changeProp: 1
            }, this.getAutoplayTrait(), this.getLoopTrait(), this.getControlsTrait(), this.getWebconnectAudioTrait()];
          },
          getAutoplayTrait: function getAutoplayTrait() {
            return {
              type: "checkbox",
              label: "Autoplay",
              name: "autoplay",
              changeProp: 1
            };
          },
          getLoopTrait: function getLoopTrait() {
            return {
              type: "checkbox",
              label: "Loop",
              name: "loop",
              changeProp: 1
            };
          },
          getControlsTrait: function getControlsTrait() {
            return {
              type: "checkbox",
              label: "Controls",
              name: "controls",
              changeProp: 1
            };
          },
          getWebconnectAudioTrait: function getWebconnectAudioTrait() {
            return {
              type: "drapcode-audio",
              label: !1,
              content: "Insert audio URL here"
            };
          }
        }, {
          isComponent: function isComponent(t) {
            var e = "";
            return "AUDIO" == t.tagName && (e = {
              type: "audio"
            }, t.src && (e.src = t.src)), e;
          }
        }),
        wt = q.extend({
          tagName: "div",
          events: {},
          initialize: function initialize(t) {
            f.default.prototype.initialize.apply(this, arguments);
            var e = this.model,
              n = ["loop", "autoplay", "controls"],
              r = n.map(function (t) {
                return "change:".concat(t);
              }).join(" ");
            this.listenTo(e, "change:src", this.updateSrc), this.listenTo(e, r, this.updateAudio);
          },
          updateProvider: function updateProvider() {
            var t = this.model.get("provider");
            this.el.innerHTML = "", this.el.appendChild(this.renderByProvider(t));
          },
          updateSrc: function updateSrc() {
            var t = this.model,
              e = this.audioEl;
            if (e) {
              var n = t.get("src");
              e.src = n;
            }
          },
          updateAudio: function updateAudio() {
            var t = this.audioEl,
              e = this.model;
            t.loop = e.get("loop"), t.autoplay = e.get("autoplay"), t.controls = e.get("controls");
          },
          renderByProvider: function renderByProvider(t) {
            var e;
            return e = this.renderSource(), this.audioEl = e, e;
          },
          renderSource: function renderSource() {
            var t = document.createElement("audio");
            return t.src = this.model.get("src"), this.initAudioEl(t), t;
          },
          initAudioEl: function initAudioEl(t) {
            t.className = this.ppfx + "no-pointer", t.style.height = "100%", t.style.width = "100%";
          },
          render: function render() {
            for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) e[n] = arguments[n];
            q.prototype.render.apply(this, e), this.updateClasses();
            var r = this.model.get("provider");
            return this.el.appendChild(this.renderByProvider(r)), this.updateAudio(), this;
          }
        });
      function xt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Ot(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? xt(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var Ct = d.default.extend({
          defaults: Ot(Ot({}, d.default.prototype.defaults), {}, {
            type: "script",
            droppable: !1,
            draggable: !1,
            layerable: !1
          })
        }, {
          isComponent: function isComponent(t) {
            if ("SCRIPT" == t.tagName) {
              var e = {
                type: "script"
              };
              return t.src && (e.src = t.src, e.onload = t.onload), e;
            }
          }
        }),
        St = q.extend({
          tagName: "script",
          events: {},
          render: function render() {
            var t = this.model,
              e = t.get("src"),
              n = this.em,
              r = n && n.get("scriptCount") ? n.get("scriptCount") : 0,
              i = "";
            if (e) {
              var o = t.get("onload"),
                a = "script" + r,
                s = "script" + (r + 1);
              i = "var " + a + " = document.createElement('script');\n" + a + ".onload = function(){\n" + (o ? o + "();\n" : "") + "typeof " + s + "Start == 'function' && " + s + "Start();\n};\n" + a + ".src = '" + e + "';\nfunction " + a + "Start() { document.body.appendChild(" + a + "); };\n" + (r ? "" : a + "Start();"), n && n.set("scriptCount", r + 1);
            } else i = t.get("content");
            return this.el.innerHTML = i, this.postRender(), this;
          }
        });
      function kt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Tt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? kt(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : kt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var jt = d.default.extend({
        defaults: Tt(Tt({}, d.default.prototype.defaults), {}, {
          resizable: {
            ratioDefault: 1
          },
          highlightable: 0
        }),
        getName: function getName() {
          var t = this.get("tagName"),
            e = this.get("custom-name");
          return t = t.charAt(0).toUpperCase() + t.slice(1), e || t;
        }
      }, {
        isComponent: function isComponent(t) {
          if (SVGElement && t instanceof SVGElement) return {
            tagName: t.tagName,
            type: "svg"
          };
        }
      });
      function Et(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Pt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Et(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Et(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var At = jt.extend({
          defaults: Pt(Pt({}, jt.prototype.defaults), {}, {
            selectable: !1,
            hoverable: !1,
            layerable: !1
          })
        }, {
          isComponent: function isComponent(t) {
            if (jt.isComponent(t) && "svg" !== t.tagName.toLowerCase()) return {
              tagName: t.tagName,
              type: "svg-in"
            };
          }
        }),
        Mt = f.default.extend({
          _createElement: function _createElement(t) {
            return document.createElementNS("http://www.w3.org/2000/svg", t);
          }
        });
      function Dt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Lt(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? Dt(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Dt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var _t = d.default.extend({
        defaults: Lt(Lt({}, d.default.prototype.defaults), {}, {
          droppable: !1,
          layerable: !1,
          editable: !0
        }),
        toHTML: function toHTML() {
          return this.get("content").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        }
      }, {
        isComponent: function isComponent(t) {
          var e = "";
          return 3 === t.nodeType && (e = {
            type: "textnode",
            content: t.textContent
          }), e;
        }
      });
      function Nt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      var It = _t.extend({
          defaults: function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = null != arguments[e] ? arguments[e] : {};
              e % 2 ? Nt(Object(n), !0).forEach(function (e) {
                a()(t, e, n[e]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Nt(Object(n)).forEach(function (e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
              });
            }
            return t;
          }({}, _t.prototype.defaults),
          toHTML: function toHTML() {
            return "\x3c!--".concat(this.get("content"), "--\x3e");
          }
        }, {
          isComponent: function isComponent(t) {
            if (8 == t.nodeType) return {
              tagName: "NULL",
              type: "comment",
              content: t.textContent
            };
          }
        }),
        Rt = f.default.extend({
          initialize: function initialize() {
            f.default.prototype.initialize.apply(this, arguments);
          },
          _setAttributes: function _setAttributes() {},
          renderAttributes: function renderAttributes() {},
          setAttribute: function setAttribute() {},
          updateAttributes: function updateAttributes() {},
          initClasses: function initClasses() {},
          initComponents: function initComponents() {},
          delegateEvents: function delegateEvents() {},
          _createElement: function _createElement() {
            return document.createTextNode("");
          },
          render: function render() {
            var t = this.model,
              e = this.el;
            return t.opt.temporary || (e.textContent = t.get("content")), this;
          }
        }),
        Ft = Rt.extend({
          _createElement: function _createElement() {
            return document.createComment(this.model.get("content"));
          }
        }),
        Vt = d.default.extend({}, {
          isComponent: function isComponent() {
            return !1;
          }
        });
      function zt(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function Ht(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? zt(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : zt(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          r = {},
          o = {},
          a = [{
            id: "cell",
            model: m,
            view: b
          }, {
            id: "row",
            model: x,
            view: O
          }, {
            id: "table",
            model: k,
            view: T
          }, {
            id: "thead",
            model: D,
            view: L
          }, {
            id: "tbody",
            model: P,
            view: _
          }, {
            id: "tfoot",
            model: R,
            view: F
          }, {
            id: "map",
            model: W,
            view: G
          }, {
            id: "link",
            model: Q,
            view: ot
          }, {
            id: "label",
            model: ct,
            view: lt
          }, {
            id: "video",
            model: gt,
            view: vt
          }, {
            id: "audio",
            model: yt,
            view: wt
          }, {
            id: "image",
            model: B,
            view: q
          }, {
            id: "script",
            model: Ct,
            view: St
          }, {
            id: "svg-in",
            model: At,
            view: Mt
          }, {
            id: "svg",
            model: jt,
            view: Mt
          }, {
            id: "comment",
            model: It,
            view: Ft
          }, {
            id: "textnode",
            model: _t,
            view: Rt
          }, {
            id: "text",
            model: X,
            view: it
          }, {
            id: "wrapper",
            model: Vt,
            view: f.default
          }, {
            id: "default",
            model: d.default,
            view: f.default
          }];
        return {
          Component: d.default,
          Components: h.a,
          ComponentsView: p.a,
          componentTypes: a,
          componentsById: o,
          name: "DomComponents",
          getConfig: function getConfig() {
            return r;
          },
          storageKey: function storageKey() {
            var t = [],
              e = r.stm && r.stm.getConfig() || {};
            return e.storeHtml && t.push("html"), e.storeComponents && t.push("components"), t;
          },
          init: function init(i) {
            var o = this;
            for (var s in t = (r = i || {}).em, this.em = t, t && (r.components = t.config.components || r.components), u) s in r || (r[s] = u[s]);
            var c = r.pStylePrefix;
            if (c && (r.stylePrefix = c + r.stylePrefix), t) {
              r.modal = t.get("Modal") || "", r.popover = t.get("Popover") || "", r.am = t.get("AssetManager") || "", t.get("Parser").compTypes = a, t.on("change:componentHovered", this.componentHovered, this);
              var l = t.get("selected");
              t.listenTo(l, "add", function (t, e, n) {
                return o.selectAdd(t, n);
              }), t.listenTo(l, "remove", function (t, e, n) {
                return o.selectRemove(t, n);
              });
            }
            var h = r.components,
              p = Ht({}, r.wrapper);
            return p["custom-name"] = r.wrapperName, p.wrapper = 1, p.type = "wrapper", h && h.constructor === Object && h.wrapper && (p = Ht({}, h), h = h.components || [], p.components = [], t && (t.config.components = h, r.components = h)), (e = new d.default(p, {
              em: t,
              config: r,
              componentTypes: a,
              domc: this
            })).set({
              attributes: {
                id: "wrapper"
              }
            }), n = new f.default({
              model: e,
              config: r,
              componentTypes: a
            }), this;
          },
          onLoad: function onLoad() {
            this.setComponents(r.components);
          },
          postLoad: function postLoad(t) {
            this.handleChanges(this.getWrapper(), null, {
              avoidStore: 1
            });
          },
          handleChanges: function handleChanges(e, n) {
            var r = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = e.components(),
              a = t.get("UndoManager"),
              s = t.handleUpdates.bind(t),
              c = this.handleChanges.bind(this),
              l = this.handleChangesColl.bind(this),
              u = this.handleRemoves.bind(this);
            a && a.add(e), a && o && a.add(o);
            var d = "change:style change:content change:attributes change:src";
            [[e, d, s], [e, "change:components", l], [o, "add", c], [o, "remove", u], [e.get("classes"), "add remove", s]].forEach(function (e) {
              t.stopListening(e[0], e[1], e[2]), t.listenTo(e[0], e[1], e[2]);
            }), !i.avoidStore && s("", "", i), o.each(function (t) {
              return r.handleChanges(t, n, i);
            });
          },
          handleChangesColl: function handleChangesColl(e, n) {
            var r = t.get("UndoManager");
            if (r && n instanceof c.a.Collection) {
              var i = this.handleChanges.bind(this),
                o = this.handleRemoves.bind(this);
              r.add(n), [[n, "add", i], [n, "remove", o]].forEach(function (e) {
                t.stopListening(e[0], e[1], e[2]), t.listenTo(e[0], e[1], e[2]);
              });
            }
          },
          handleRemoves: function handleRemoves(e, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            !r.avoidStore && t.handleUpdates(e, n, r);
          },
          load: function load() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              e = this.em,
              n = "";
            !t && r.stm && (t = r.em.getCacheLoad());
            var i = t,
              o = i.components,
              a = i.html;
            if (o) {
              if (Object(l.isObject)(o) || Object(l.isArray)(o)) n = o;else try {
                n = JSON.parse(o);
              } catch (t) {
                e && e.logError(t);
              }
            } else a && (n = a);
            var s = n && n.constructor === Object;
            return (n && n.length || s) && (this.clear(), s ? this.getWrapper().set(n) : this.getComponents().add(n)), n;
          },
          store: function store(t) {
            if (r.stm) {
              var e = {},
                n = this.storageKey();
              if (n.indexOf("html") >= 0 && (e.html = r.em.getHtml()), n.indexOf("components") >= 0) {
                this.em;
                var i = r.storeWrapper ? this.getWrapper() : this.getComponents();
                e.components = JSON.stringify(i);
              }
              return t || r.stm.store(e), e;
            }
          },
          getComponent: function getComponent() {
            return e;
          },
          getWrapper: function getWrapper() {
            return this.getComponent();
          },
          getComponents: function getComponents() {
            return this.getWrapper().get("components");
          },
          addComponent: function addComponent(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.getComponents().add(t, e);
          },
          render: function render() {
            return n.render().el;
          },
          clear: function clear() {
            return this.getComponents().map(function (t) {
              return t;
            }).forEach(function (t) {
              return t.remove();
            }), this;
          },
          setComponents: function setComponents(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.clear().addComponent(t, e);
          },
          addType: function addType(t, e) {
            var n = this.em,
              r = e.model,
              o = void 0 === r ? {} : r,
              s = e.view,
              c = void 0 === s ? {} : s,
              u = e.isComponent,
              d = e.extend,
              h = e.extendView,
              f = e.extendFn,
              p = void 0 === f ? [] : f,
              g = e.extendFnView,
              v = void 0 === g ? [] : g,
              m = this.getType(t),
              b = this.getType(d),
              y = this.getType(h),
              w = b || m || this.getType("default"),
              x = w.model,
              O = y ? y.view : w.view,
              C = function C(t, e, n) {
                return t.reduce(function (t, r) {
                  var i = e[r],
                    o = n.prototype[r];
                  return i && o && (t[r] = function () {
                    o.bind(this).apply(void 0, arguments), i.bind(this).apply(void 0, arguments);
                  }), t;
                }, {});
              };
            "object" === i()(o) && (e.model = x.extend(Ht(Ht(Ht({}, o), C(p, o, x)), {}, {
              defaults: Ht(Ht({}, x.prototype.defaults), Object(l.result)(o, "defaults") || {})
            }), {
              isComponent: !m || b || u ? u || function () {
                return 0;
              } : x.isComponent
            })), "object" === i()(c) && (e.view = O.extend(Ht(Ht({}, c), C(v, c, O)))), m ? (m.model = e.model, m.view = e.view) : (e.id = t, a.unshift(e));
            var S = "component:type:".concat(m ? "update" : "add");
            return n && n.trigger(S, m || e), this;
          },
          getType: function getType(t) {
            for (var e = a, n = 0; n < e.length; n++) if (e[n].id == t) return e[n];
          },
          removeType: function removeType(t) {
            var e = a,
              n = this.getType(t);
            if (n) {
              var r = e.indexOf(n);
              return e.splice(r, 1), n;
            }
          },
          getTypes: function getTypes() {
            return a;
          },
          selectAdd: function selectAdd(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            t && (t.set({
              status: "selected"
            }), ["component:selected", "component:toggled"].forEach(function (r) {
              return e.em.trigger(r, t, n);
            }));
          },
          selectRemove: function selectRemove(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            t && (this.em, t.set({
              status: "",
              state: ""
            }), ["component:deselected", "component:toggled"].forEach(function (r) {
              return e.em.trigger(r, t, n);
            }));
          },
          componentHovered: function componentHovered() {
            var t = r.em,
              e = t.get("componentHovered"),
              n = t.previous("componentHovered");
            n && "hovered" == n.get("status") && n.set({
              status: "",
              state: ""
            }), e && Object(l.isEmpty)(e.get("status")) && e.set("status", "hovered");
          },
          allById: function allById() {
            return o;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(9),
        i = n.n(r),
        o = n(2),
        a = n.n(o),
        s = n(3),
        c = n(0),
        l = n(15),
        u = n.n(l),
        d = n(16),
        h = n.n(d),
        f = function () {
          function t(e, n) {
            var r = this;
            u()(this, t), this.em = e;
            var i = n || e.get("Canvas").getFrames().map(function (t) {
                return t.get("root").getEl();
              }),
              o = Array.isArray(i) ? i : [i];
            return this.el = i, this.counter = 0, Object(c.bindAll)(this, "handleDragEnter", "handleDragOver", "handleDrop", "handleDragLeave"), o.forEach(function (t) {
              return r.toggleEffects(t, 1);
            }), this;
          }
          return h()(t, [{
            key: "toggleEffects",
            value: function value(t, e) {
              var n = {
                  on: s.u,
                  off: s.t
                },
                r = e ? "on" : "off";
              n[r](t, "dragenter", this.handleDragEnter), n[r](t, "dragover", this.handleDragOver), n[r](t, "drop", this.handleDrop), n[r](t, "dragleave", this.handleDragLeave);
            }
          }, {
            key: "endDrop",
            value: function value(t, e) {
              var n = this.em,
                r = this.dragStop;
              this.counter = 0, this.over = 0, r && r(t), n.runDefault({
                preserveSelected: 1
              }), n.trigger("canvas:dragend", e);
            }
          }, {
            key: "handleDragLeave",
            value: function value(t) {
              this.updateCounter(-1, t);
            }
          }, {
            key: "updateCounter",
            value: function value(t, e) {
              this.counter += t, 0 === this.counter && this.endDrop(1, e);
            }
          }, {
            key: "handleDragEnter",
            value: function value(t) {
              var e = this,
                n = this.em,
                r = t.dataTransfer;
              if (this.updateCounter(1, t), !this.over) {
                this.over = 1;
                var i,
                  o,
                  a = n.get("Utils"),
                  s = n.get("Canvas"),
                  c = s.getBody(),
                  l = n.get("dragContent") || "<br>";
                if (n.stopDefault(), n.inAbsoluteMode()) {
                  var u = n.get("DomComponents").getWrapper(),
                    d = u.append({})[0],
                    h = n.get("Commands").run("core:component-drag", {
                      event: t,
                      guidesInfo: 1,
                      center: 1,
                      target: d,
                      onEnd: function onEnd(t, n, i) {
                        if (!i.cancelled) {
                          var o = u.append(l)[0],
                            a = d.getStyle(),
                            s = a.left,
                            c = a.top,
                            h = a.position;
                          o.addStyle({
                            left: s,
                            top: c,
                            position: h
                          }), e.handleDragEnd(o, r);
                        }
                        d.remove();
                      }
                    });
                  i = function i(e) {
                    return h.stop(t, {
                      cancel: e
                    });
                  }, o = function o(t) {
                    return l = t;
                  };
                } else {
                  var f = new a.Sorter({
                    em: n,
                    wmargin: 1,
                    nested: 1,
                    canvasRelative: 1,
                    direction: "a",
                    container: c,
                    placer: s.getPlacerEl(),
                    containerSel: "*",
                    itemSel: "*",
                    pfx: "gjs-",
                    onEndMove: function onEndMove(t) {
                      return e.handleDragEnd(t, r);
                    },
                    document: s.getFrameEl().contentDocument
                  });
                  f.setDropContent(l), f.startSort(), this.sorter = f, i = function i(t) {
                    t && (f.moved = 0), f.endMove();
                  }, o = function o(t) {
                    return f.setDropContent(t);
                  };
                }
                this.dragStop = i, this.dragContent = o, n.trigger("canvas:dragenter", r, l);
              }
            }
          }, {
            key: "handleDragEnd",
            value: function value(t, e) {
              if (t) {
                var n = this.em;
                n.set("dragResult", t), n.trigger("canvas:drop", e, t);
              }
            }
          }, {
            key: "handleDragOver",
            value: function value(t) {
              t.preventDefault(), this.em.trigger("canvas:dragover", t);
            }
          }, {
            key: "handleDrop",
            value: function value(t) {
              t.preventDefault();
              var e = this.dragContent,
                n = t.dataTransfer,
                r = this.getContentByData(n).content;
              t.target.style.border = "", r && e && e(r), this.endDrop(!r, t);
            }
          }, {
            key: "getContentByData",
            value: function value(t) {
              var e = this.em,
                n = t.types,
                r = t.files || [],
                i = e.get("dragContent"),
                o = t.getData("text");
              if (r.length) {
                o = [];
                for (var a = 0; a < r.length; a++) {
                  var s = r[a],
                    l = s.type.split("/")[0];
                  "image" == l && o.push({
                    type: l,
                    file: s,
                    attributes: {
                      alt: s.name
                    }
                  });
                }
              } else if (i) o = i;else if (Object(c.indexOf)(n, "text/html") >= 0) o = t.getData("text/html").replace(/<\/?meta[^>]*>/g, "");else if (Object(c.indexOf)(n, "text/uri-list") >= 0) o = {
                type: "link",
                attributes: {
                  href: o
                },
                content: o
              };else if (Object(c.indexOf)(n, "text/json") >= 0) {
                var u = t.getData("text/json");
                u && (o = JSON.parse(u));
              }
              var d = {
                content: o
              };
              return e.trigger("canvas:dragdata", t, d), d;
            }
          }]), t;
        }(),
        p = {
          stylePrefix: "cv-",
          scripts: [],
          styles: [],
          customBadgeLabel: "",
          autoscrollLimit: 50,
          notTextable: ["button", "a", "input[type=checkbox]", "input[type=radio]"]
        },
        g = n(1),
        v = n.n(g),
        m = n(5),
        b = n(33);
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var x = v.a.Model.extend({
          defaults: {
            wrapper: "",
            width: null,
            height: null,
            head: "",
            x: 0,
            y: 0,
            root: 0,
            components: 0,
            styles: 0,
            attributes: {}
          },
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.attributes,
              r = n.root,
              i = n.styles,
              o = n.components;
            this.set("head", []), this.em = e.em;
            var a = {
              em: e.em,
              config: e.em.get("DomComponents").getConfig(),
              frame: this
            };
            !r && this.set("root", new m.default({
              type: "wrapper",
              components: o || []
            }, a)), (!i || Object(c.isString)(i)) && this.set("styles", new b.a(i, a));
          },
          remove: function remove() {
            this.view = 0;
            var t = this.collection;
            return t && t.remove(this);
          },
          getHead: function getHead() {
            return i()(this.get("head"));
          },
          setHead: function setHead(t) {
            return this.set("head", i()(t));
          },
          addHeadItem: function addHeadItem(t) {
            var e = this.getHead();
            e.push(t), this.setHead(e);
          },
          getHeadByAttr: function getHeadByAttr(t, e, n) {
            return this.getHead().filter(function (r) {
              return r.attributes && r.attributes[t] == e && (!n || n === r.tag);
            })[0];
          },
          removeHeadByAttr: function removeHeadByAttr(t, e, n) {
            var r = this.getHead(),
              i = this.getHeadByAttr(t, e, n),
              o = r.indexOf(i);
            o >= 0 && (r.splice(o, 1), this.setHead(r));
          },
          addLink: function addLink(t) {
            !this.getHeadByAttr("href", t, "link") && this.addHeadItem({
              tag: "link",
              attributes: {
                href: t,
                rel: "stylesheet"
              }
            });
          },
          removeLink: function removeLink(t) {
            this.removeHeadByAttr("href", t, "link");
          },
          addScript: function addScript(t) {
            !this.getHeadByAttr("src", t, "script") && this.addHeadItem({
              tag: "script",
              attributes: {
                src: t
              }
            });
          },
          removeScript: function removeScript(t) {
            this.removeHeadByAttr("src", t, "script");
          },
          _emitUpdated: function _emitUpdated() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.em.trigger("frame:updated", w({
              frame: this
            }, t));
          }
        }),
        O = v.a.Collection.extend({
          model: x,
          initialize: function initialize() {
            Object(c.bindAll)(this, "itemLoaded");
          },
          itemLoaded: function itemLoaded() {
            this.loadedItems++, this.loadedItems >= this.itemsToLoad && (this.trigger("loaded:all"), this.listenToLoadItems(0));
          },
          listenToLoad: function listenToLoad() {
            this.loadedItems = 0, this.itemsToLoad = this.length, this.listenToLoadItems(1);
          },
          listenToLoadItems: function listenToLoadItems(t) {
            var e = this;
            this.forEach(function (n) {
              return n[t ? "on" : "off"]("loaded", e.itemLoaded);
            });
          }
        }),
        C = v.a.Model.extend({
          defaults: {
            frame: "",
            frames: "",
            wrapper: "",
            rulers: !1,
            zoom: 100,
            x: 0,
            y: 0
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.em,
              n = t.styles,
              r = void 0 === n ? [] : n,
              i = t.scripts,
              o = void 0 === i ? [] : i,
              a = e && e.getWrapper(),
              s = e && e.getStyle(),
              c = new x({
                root: a,
                styles: s
              }, t);
            r.forEach(function (t) {
              return c.addLink(t);
            }), o.forEach(function (t) {
              return c.addScript(t);
            }), this.em = e, this.set("frame", c), this.set("frames", new O([c], t)), this.listenTo(this, "change:zoom", this.onZoomChange), this.listenTo(e, "change:device", this.updateDevice);
          },
          updateDevice: function updateDevice() {
            var t = this.em,
              e = t.getDeviceModel(),
              n = t.getCurrentFrameModel();
            if (n && e) {
              var r = e.attributes,
                i = r.width,
                o = r.height;
              n.set({
                width: i,
                height: o
              });
            }
          },
          onZoomChange: function onZoomChange() {
            this.get("zoom") < 1 && this.set("zoom", 1);
          }
        }),
        S = n(20),
        k = n(37),
        T = n(6),
        j = n(7);
      function E(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function P(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? E(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : E(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var A = v.a.View.extend({
          tagName: "iframe",
          attributes: {
            allowfullscreen: "allowfullscreen",
            "data-frame-el": !0,
            "data-hj-allow-iframe": !0
          },
          initialize: function initialize(t) {
            Object(c.bindAll)(this, "updateClientY", "stopAutoscroll", "autoscroll", "_emitUpdate");
            var e = this.model,
              n = this.el;
            this.config = P(P({}, t.config || {}), {}, {
              frameView: this
            }), this.ppfx = this.config.pStylePrefix || "", this.em = this.config.em, this.listenTo(e, "change:head", this.updateHead), e.view = this, Object(s.v)(n, this);
          },
          updateHead: function updateHead() {
            var t = this.getHead();
            Object(j.f)(t), Object(j.c)(t, this.model.getHead());
          },
          getEl: function getEl() {
            return this.el;
          },
          getWindow: function getWindow() {
            return this.getEl().contentWindow;
          },
          getDoc: function getDoc() {
            return this.getEl().contentDocument;
          },
          getHead: function getHead() {
            return this.getDoc() ? this.getDoc().querySelector("head") : null;
          },
          getBody: function getBody() {
            return this.getDoc() ? this.getDoc().querySelector("body") : null;
          },
          getWrapper: function getWrapper() {
            return this.getBody() ? this.getBody().querySelector("[data-gjs-type=wrapper]") : null;
          },
          getJsContainer: function getJsContainer() {
            return this.jsContainer || (console.log("Creating div element"), this.jsContainer = Object(j.e)("div", {
              class: "".concat(this.ppfx, "js-cont")
            })), this.jsContainer;
          },
          getToolsEl: function getToolsEl() {
            var t = this.config.frameWrapView;
            return t && t.elTools;
          },
          getGlobalToolsEl: function getGlobalToolsEl() {
            return this.em.get("Canvas").getGlobalToolsEl();
          },
          getHighlighter: function getHighlighter() {
            return this._getTool("[data-hl]");
          },
          getBadgeEl: function getBadgeEl() {
            return this._getTool("[data-badge]");
          },
          getOffsetViewerEl: function getOffsetViewerEl() {
            return this._getTool("[data-offset]");
          },
          getRect: function getRect() {
            return this.rect || (this.rect = this.el.getBoundingClientRect()), this.rect;
          },
          getOffsetRect: function getOffsetRect() {
            var t = this.el,
              e = this.getBody(),
              n = e.scrollTop,
              r = e.scrollLeft,
              i = t.offsetHeight,
              o = t.offsetWidth;
            return {
              top: t.offsetTop,
              left: t.offsetLeft,
              height: i,
              width: o,
              scrollTop: n,
              scrollLeft: r,
              scrollBottom: n + i,
              scrollRight: r + o
            };
          },
          _getTool: function _getTool(t) {
            var e = this.getToolsEl();
            return this[t] || (this[t] = e.querySelector(t)), this[t];
          },
          remove: function remove() {
            var t = this.root,
              e = this.model;
            this._toggleEffects(), v.a.View.prototype.remove.apply(this, arguments), t.remove(), e.remove();
          },
          startAutoscroll: function startAutoscroll() {
            var t = this;
            this.lastMaxHeight = this.getWrapper().offsetHeight - this.el.offsetHeight, setTimeout(function () {
              t._toggleAutoscrollFx(1), requestAnimationFrame(t.autoscroll);
            }, 0);
          },
          autoscroll: function autoscroll() {
            if (this.dragging) {
              var t = this.em.get("Canvas"),
                e = this.getWindow(),
                n = this.getBody().scrollTop,
                r = this.lastClientY || 0,
                i = t.getConfig().autoscrollLimit,
                o = this.getRect().height - i,
                a = n;
              r < i && (a -= i - r), r > o && (a += r - o), a !== n && a > 0 && a < this.lastMaxHeight && (this.getGlobalToolsEl().style.opacity = 0, this.showGlobalTools(), e.scrollTo(0, a)), requestAnimationFrame(this.autoscroll);
            }
          },
          updateClientY: function updateClientY(t) {
            t.preventDefault(), this.lastClientY = Object(s.h)(t).clientY * this.em.getZoomDecimal();
          },
          showGlobalTools: Object(c.debounce)(function () {
            this.getGlobalToolsEl().style.opacity = "";
          }, 50),
          stopAutoscroll: function stopAutoscroll() {
            this.dragging && this._toggleAutoscrollFx();
          },
          _toggleAutoscrollFx: function _toggleAutoscrollFx(t) {
            this.dragging = t;
            var e = this.getWindow(),
              n = t ? "on" : "off",
              r = {
                on: s.u,
                off: s.t
              };
            r[n](e, "mousemove dragover", this.updateClientY), r[n](e, "mouseup", this.stopAutoscroll);
          },
          render: function render() {
            var t = this.el,
              e = this.$el,
              n = this.ppfx,
              r = this.config;
            return e.attr({
              class: n + "frame"
            }), r.scripts.length ? this.renderScripts() : r.renderContent && (t.onload = this.renderBody.bind(this)), this;
          },
          renderScripts: function renderScripts() {
            var t = this,
              e = this.el,
              n = this.config;
            e.onload = function () {
              return function n(r) {
                if (r.length > 0) {
                  var i = r.shift(),
                    o = Object(j.e)("script", P({
                      type: "text/javascript"
                    }, Object(c.isString)(i) ? {
                      src: i
                    } : i));
                  o.onerror = o.onload = n.bind(null, r), e.contentDocument.head.appendChild(o);
                } else t.renderBody();
              }(i()(n.scripts));
            };
          },
          renderBody: function renderBody() {
            var t = this,
              e = this.config,
              n = this.model,
              r = this.ppfx,
              i = n.get("root"),
              o = n.get("styles"),
              a = e.em,
              l = this.getDoc(),
              u = this.getHead(),
              d = this.getBody(),
              h = this.getWindow(),
              f = a.get("Config"),
              p = [];
            h._isEditor = !0, e.styles.forEach(function (t) {
              return p.push(Object(c.isString)(t) ? {
                tag: "link",
                attributes: {
                  href: t,
                  rel: "stylesheet"
                }
              } : {
                tag: "link",
                attributes: P({
                  rel: "stylesheet"
                }, t)
              });
            }), p.length && Object(j.c)(u, p), Object(j.a)(d, "<style>\n      ".concat(f.baseCss || "", "\n\n      .").concat(r, "dashed *[data-highlightable] {\n        outline: 1px dashed rgba(170,170,170,0.7);\n        outline-offset: -2px;\n      }\n\n      .").concat(r, "selected {\n        outline: 3px solid #3b97e3 !important;\n        outline-offset: -3px;\n      }\n\n      .").concat(r, "selected-parent {\n        outline: 2px solid ").concat("#ffca6f", " !important\n      }\n\n      .").concat(r, "no-select {\n        user-select: none;\n        -webkit-user-select:none;\n        -moz-user-select: none;\n      }\n\n      .").concat(r, "freezed {\n        opacity: 0.5;\n        pointer-events: none;\n      }\n\n      .").concat(r, "no-pointer {\n        pointer-events: none;\n      }\n\n      .").concat(r, "plh-image {\n        background: #f5f5f5;\n        border: none;\n        height: 100px;\n        width: 100px;\n        display: block;\n        outline: 3px solid #ffca6f;\n        cursor: pointer;\n        outline-offset: -2px\n      }\n\n      .").concat(r, "grabbing {\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n      }\n\n      .").concat(r, "is__grabbing {\n        overflow-x: hidden;\n      }\n\n      .").concat(r, "is__grabbing,\n      .").concat(r, "is__grabbing * {\n        cursor: grabbing !important;\n      }\n\n      ").concat(f.canvasCss || "", "\n      ").concat(f.protectedCss || "", "\n    </style>")), this.root = new T.default({
              model: i,
              config: P(P({}, i.config), {}, {
                frameView: this
              })
            }).render(), Object(j.a)(d, this.root.el), Object(j.a)(d, new k.a({
              collection: o,
              config: P(P({}, a.get("CssComposer").getConfig()), {}, {
                frameView: this
              })
            }).render().el), Object(j.a)(d, this.getJsContainer()), Object(s.u)(d, "click", function (t) {
              return t && "A" == t.target.tagName && t.preventDefault();
            }), Object(s.u)(d, "submit", function (t) {
              return t && t.preventDefault();
            }), [{
              event: "keydown keyup keypress",
              class: "KeyboardEvent"
            }, {
              event: "mousemove",
              class: "MouseEvent"
            }, {
              event: "wheel",
              class: "WheelEvent"
            }].forEach(function (e) {
              return e.event.split(" ").forEach(function (n) {
                l.addEventListener(n, function (n) {
                  return t.el.dispatchEvent(Object(j.d)(n, e.class));
                });
              });
            }), this._toggleEffects(1), n.trigger("loaded");
          },
          _toggleEffects: function _toggleEffects(t) {
            (t ? s.u : s.t)(this.getWindow(), "".concat(j.i, " resize"), this._emitUpdate);
          },
          _emitUpdate: function _emitUpdate() {
            this.model._emitUpdated();
          }
        }),
        M = n(17);
      function D(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function L(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? D(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var _ = v.a.View.extend({
          events: {
            "click [data-action-remove]": "remove",
            "mousedown [data-action-move]": "startDrag"
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Object(c.bindAll)(this, "onScroll", "frameLoaded", "updateOffset", "remove", "startDrag");
            var n = this.model,
              r = L(L({}, t.config || e), {}, {
                frameWrapView: this
              }),
              i = r.canvasView,
              o = r.em;
            this.cv = i, this.config = r, this.em = o, this.canvas = o && o.get("Canvas"), this.ppfx = r.pStylePrefix || "", this.frame = new A({
              model: n,
              config: r
            }), this.classAnim = "".concat(this.ppfx, "frame-wrapper--anim"), this.listenTo(n, "loaded", this.frameLoaded), this.listenTo(n, "change:x change:y", this.updatePos), this.listenTo(n, "change:width change:height", this.updateSize), this.updatePos(), this.setupDragger();
          },
          setupDragger: function setupDragger() {
            var t,
              e,
              n,
              r = this,
              i = this.canvas,
              o = this.model,
              a = function a(t) {
                i.toggleFramesEvents(t);
              };
            this.dragger = new M.a({
              onStart: function onStart() {
                var i = o.attributes,
                  s = i.x,
                  c = i.y;
                n = r.em.getZoomMultiplier(), t = s, e = c, a();
              },
              onEnd: function onEnd() {
                return a(1);
              },
              setPosition: function setPosition(r) {
                o.set({
                  x: t + r.x * n,
                  y: e + r.y * n
                });
              }
            });
          },
          startDrag: function startDrag(t) {
            t && this.dragger.start(t);
          },
          remove: function remove() {
            return v.a.View.prototype.remove.apply(this, arguments), this.frame.remove(), this;
          },
          updateOffset: Object(c.debounce)(function () {
            var t = this.em,
              e = this.$el,
              n = this.frame;
            t.runDefault({
              preserveSelected: 1
            }), e.removeClass(this.classAnim), n.model._emitUpdated();
          }),
          updatePos: function updatePos(t) {
            var e = this.model,
              n = this.el,
              r = e.attributes,
              i = r.x,
              o = r.y,
              a = n.style;
            this.frame.rect = 0, a.left = isNaN(i) ? i : "".concat(i, "px"), a.top = isNaN(o) ? o : "".concat(o, "px"), t && this.updateOffset();
          },
          updateSize: Object(c.debounce)(function () {
            this.updateDim();
          }),
          updateDim: function updateDim() {
            var t = this.em,
              e = this.el,
              n = this.$el,
              r = this.model,
              i = this.classAnim,
              o = r.attributes,
              a = o.width,
              s = o.height,
              l = e.style,
              u = l.width || "",
              d = l.height || "",
              h = a || "",
              f = s || "",
              p = u == h && d == f;
            if (this.frame.rect = 0, n.addClass(i), l.width = Object(c.isNumber)(h) ? "".concat(h).concat("px") : h, l.height = Object(c.isNumber)(f) ? "".concat(f).concat("px") : f, Object(c.isNull)(a) || Object(c.isNull)(s)) {
              var g = L(L({}, a ? {} : {
                width: e.offsetWidth
              }), s ? {} : {
                height: e.offsetHeight
              });
              r.set(g, {
                silent: 1
              });
            }
            t.stopDefault({
              preserveSelected: 1
            }), p ? this.updateOffset() : n.one(j.i, this.updateOffset);
          },
          onScroll: function onScroll() {
            var t = this.frame;
            this.em.trigger("frame:scroll", {
              frame: t,
              body: t.getBody(),
              target: t.getWindow()
            });
          },
          frameLoaded: function frameLoaded() {
            this.frame.getWindow().onscroll = this.onScroll, this.updateDim();
          },
          render: function render() {
            var t = this.frame,
              e = this.$el,
              n = this.ppfx,
              r = this.cv,
              i = this.model,
              o = this.el,
              a = i.attributes.onRender;
            t.render(), e.empty().attr({
              class: "".concat(n, "frame-wrapper")
            }).append('\n      <div class="'.concat(n, 'frame-wrapper__top gjs-two-color" data-frame-top>\n        <div class="').concat(n, 'frame-wrapper__name" data-action-move>\n          ').concat(i.get("name") || "", '\n        </div>\n        <div class="').concat(n, 'frame-wrapper__top-r">\n          <div class="').concat(n, 'frame-wrapper__icon" data-action-remove style="display: none">\n            <svg viewBox="0 0 24 24"><path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z"></path></svg>\n          </div>\n        </div>\n      </div>\n      <div class="').concat(n, 'frame-wrapper__right" data-frame-right></div>\n      <div class="').concat(n, 'frame-wrapper__left" data-frame-left></div>\n      <div class="').concat(n, 'frame-wrapper__bottom" data-frame-bottom></div>\n      ')).append(t.el), console.log("Create div element frame");
            var s = Object(j.e)("div", {
              class: "".concat(n, "tools"),
              style: "pointer-events:none; opacity: 0"
            }, '\n      <div class="'.concat(n, 'highlighter" data-hl></div>\n      <div class="').concat(n, 'badge" data-badge></div>\n      <div class="').concat(n, 'placeholder">\n        <div class="').concat(n, 'placeholder-int"></div>\n      </div>\n      <div class="').concat(n, 'ghost"></div>\n      <div class="').concat(n, 'toolbar" style="pointer-events:all"></div>\n      <div class="').concat(n, 'resizer"></div>\n      <div class="').concat(n, 'offset-v" data-offset>\n        <div class="gjs-marginName" data-offset-m>\n          <div class="gjs-margin-v-el gjs-margin-v-top" data-offset-m-t></div>\n          <div class="gjs-margin-v-el gjs-margin-v-bottom" data-offset-m-b></div>\n          <div class="gjs-margin-v-el gjs-margin-v-left" data-offset-m-l></div>\n          <div class="gjs-margin-v-el gjs-margin-v-right" data-offset-m-r></div>\n        </div>\n        <div class="gjs-paddingName" data-offset-m>\n          <div class="gjs-padding-v-el gjs-padding-v-top" data-offset-p-t></div>\n          <div class="gjs-padding-v-el gjs-padding-v-bottom" data-offset-p-b></div>\n          <div class="gjs-padding-v-el gjs-padding-v-left" data-offset-p-l></div>\n          <div class="gjs-padding-v-el gjs-padding-v-right" data-offset-p-r></div>\n        </div>\n      </div>\n      <div class="').concat(n, 'offset-fixed-v"></div>\n    '));
            return this.elTools = s, r.toolsWrapper.appendChild(s), a && a({
              el: o,
              elTop: o.querySelector("[data-frame-top]"),
              elRight: o.querySelector("[data-frame-right]"),
              elBottom: o.querySelector("[data-frame-bottom]"),
              elLeft: o.querySelector("[data-frame-left]"),
              frame: i,
              frameWrapperView: this,
              remove: this.remove,
              startDrag: this.startDrag
            }), this;
          }
        }),
        N = S.a.extend({
          itemView: _,
          autoAdd: 1,
          init: function init() {
            this.listenTo(this.collection, "reset", this.render);
          },
          onRender: function onRender() {
            var t = this.config,
              e = this.$el,
              n = t.em;
            n && e.attr({
              class: "".concat(n.getConfig("stylePrefix"), "frames")
            });
          }
        });
      function I(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function R(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? I(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : I(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var F,
        V = v.a.$,
        z = v.a.View.extend({
          events: {
            wheel: "onWheel"
          },
          template: function template() {
            var t = this.pfx;
            return '\n      <div class="'.concat(t, 'canvas__frames" data-frames></div>\n      <div id="').concat(t, 'tools" class="').concat(t, 'canvas__tools" data-tools></div>\n    ');
          },
          initialize: function initialize(t) {
            Object(c.bindAll)(this, "clearOff", "onKeyPress", "onCanvasMove"), Object(s.u)(window, "scroll resize", this.clearOff);
            var e = this.model,
              n = e.get("frames");
            this.config = t.config || {}, this.em = this.config.em || {}, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.className = this.config.stylePrefix + "canvas";
            var r = this.em,
              i = this.config;
            this.frames = new N({
              collection: n,
              config: R(R({}, i), {}, {
                canvasView: this,
                renderContent: 1
              })
            }), this.listenTo(r, "change:canvasOffset", this.clearOff), this.listenTo(r, "component:selected", this.checkSelected), this.listenTo(e, "change:zoom change:x change:y", this.updateFrames), this.listenTo(n, "loaded:all", function () {
              return r.trigger("loaded");
            }), this.toggleListeners(1);
          },
          checkSelected: function checkSelected(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.scroll,
              r = this.em.get("currentFrame");
            n && t.views.forEach(function (t) {
              t._getFrame() !== r && t.scrollIntoView(n);
            });
          },
          remove: function remove() {
            v.a.View.prototype.remove.apply(this, arguments), this.toggleListeners();
          },
          preventDefault: function preventDefault(t) {
            t && (t.preventDefault(), t._parentEvent && t._parentEvent.preventDefault());
          },
          onCanvasMove: function onCanvasMove(t) {},
          toggleListeners: function toggleListeners(t) {
            this.el, (t ? s.u : s.t)(document, "keypress", this.onKeyPress);
          },
          onKeyPress: function onKeyPress(t) {
            var e = this.em;
            " " !== Object(s.f)(t) || 1 === e.getZoomDecimal() || e.get("Canvas").isInputFocused() || (this.preventDefault(t), e.get("Editor").runCommand("core:canvas-move"));
          },
          onWheel: function onWheel(t) {
            if ((t.ctrlKey || t.metaKey) && this.em.getConfig("multiFrames")) {
              this.preventDefault(t);
              var e = this.model,
                n = Math.max(-1, Math.min(1, t.wheelDelta || -t.detail)),
                r = e.get("zoom");
              e.set("zoom", r + 2 * n);
            }
          },
          updateFrames: function updateFrames(t) {
            var e = this.em,
              n = this.model.attributes,
              r = n.x,
              i = n.y,
              o = this.getZoom(),
              a = {
                preserveSelected: 1
              },
              s = o ? 1 / o : 1;
            this.framesArea.style.transform = "scale(".concat(o, ") translate(").concat(r * s, "px, ").concat(i * s, "px)"), this.clearOff(), e.stopDefault(a), e.trigger("canvas:update", t), F && clearTimeout(F), F = setTimeout(function () {
              return e.runDefault(a);
            }, 300);
          },
          getZoom: function getZoom() {
            return this.em.getZoomDecimal();
          },
          isElInViewport: function isElInViewport(t) {
            var e = Object(s.e)(t),
              n = Object(s.d)(e),
              r = this.getFrameOffset(e),
              i = n.top,
              o = n.left;
            return i >= 0 && o >= 0 && i <= r.height && o <= r.width;
          },
          offset: function offset(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Object(s.d)(t),
              r = t.ownerDocument.body,
              i = e.noScroll;
            return {
              top: n.top + (i ? 0 : r.scrollTop),
              left: n.left + (i ? 0 : r.scrollLeft),
              width: n.width,
              height: n.height
            };
          },
          clearOff: function clearOff() {
            this.frmOff = null, this.cvsOff = null;
          },
          getFrameOffset: function getFrameOffset(t) {
            if (!this.frmOff || t) {
              var e = this.frame.el,
                n = t ? t.ownerDocument.defaultView.frameElement : e;
              this.frmOff = this.offset(n || e);
            }
            return this.frmOff;
          },
          getCanvasOffset: function getCanvasOffset() {
            return this.cvsOff || (this.cvsOff = this.offset(this.el)), this.cvsOff;
          },
          getElementPos: function getElementPos(t, e) {
            var n = this.getZoom(),
              r = e || {},
              i = this.getFrameOffset(t),
              o = this.getCanvasOffset(),
              a = this.offset(t, e),
              s = r.avoidFrameOffset ? 0 : i.top,
              c = r.avoidFrameOffset ? 0 : i.left;
            return {
              top: a.top * n + s - o.top,
              left: a.left * n + c - o.left,
              height: a.height * n,
              width: a.width * n,
              zoom: n,
              rect: a
            };
          },
          getElementOffsets: function getElementOffsets(t) {
            var e = this;
            if (!t || Object(s.q)(t)) return {};
            var n = {},
              r = window.getComputedStyle(t);
            return ["marginTop", "marginRight", "marginBottom", "marginLeft", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft"].forEach(function (t) {
              n[t] = parseFloat(r[t]) * e.getZoom();
            }), n;
          },
          getPosition: function getPosition() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.frame.el.contentDocument;
            if (e) {
              var n = e.body,
                r = this.getZoom(),
                i = this.getFrameOffset(),
                o = this.getCanvasOffset(),
                a = t.noScroll;
              return {
                top: i.top + (a ? 0 : n.scrollTop) * r - o.top,
                left: i.left + (a ? 0 : n.scrollLeft) * r - o.left,
                width: o.width,
                height: o.height
              };
            }
          },
          updateScript: function updateScript(t) {
            var e = t.model,
              n = e.getId();
            t.scriptContainer || (t.scriptContainer = V('<div data-id="'.concat(n, '">')), this.getJsContainer().appendChild(t.scriptContainer.get(0))), t.el.id = n, t.scriptContainer.html("");
            var r = document.createElement("script");
            r.innerHTML = "\n        setTimeout(function() {\n          var item = document.getElementById('".concat(n, "');\n          if (!item) return;\n          (function(){\n            ").concat(e.getScriptString(), ";\n          }.bind(item))()\n        }, 1);"), setTimeout(function () {
              return t.scriptContainer.get(0).appendChild(r);
            }, 0);
          },
          getJsContainer: function getJsContainer(t) {
            var e = this.getFrameView(t);
            return e && e.getJsContainer();
          },
          getFrameView: function getFrameView(t) {
            return t && t._getFrame() || this.em.get("currentFrame");
          },
          render: function render() {
            var t = this.el,
              e = this.$el,
              n = this.ppfx,
              r = this.model,
              i = this.em,
              o = this.frames,
              a = i.get("CssComposer"),
              s = r.get("wrapper");
            e.html(this.template());
            var c = e.find("[data-frames]");
            this.framesArea = c.get(0), this.wrapper = s, s && "function" == typeof s.render && r.get("frame").set({
              wrapper: s,
              root: s.getWrapper(),
              styles: a.getAll()
            });
            var l = e.find("[data-tools]");
            this.toolsWrapper = l.get(0), l.append('\n      <div class="'.concat(n, "tools ").concat(n, 'tools-gl" style="pointer-events:none">\n        <div class="').concat(n, 'placeholder">\n          <div class="').concat(n, 'placeholder-int"></div>\n        </div>\n      </div>\n      <div id="').concat(n, 'tools" style="pointer-events:none">\n        <div class="').concat(n, 'badge"></div>\n        <div class="').concat(n, 'ghost"></div>\n        <div class="').concat(n, 'toolbar" style="pointer-events:all"></div>\n        <div class="').concat(n, 'resizer"></div>\n        <div class="').concat(n, 'offset-v"></div>\n        <div class="').concat(n, 'offset-fixed-v"></div>\n      </div>\n    '));
            var u = t.querySelector("#".concat(n, "tools"));
            this.hlEl = t.querySelector(".".concat(n, "highlighter")), this.badgeEl = t.querySelector(".".concat(n, "badge")), this.placerEl = t.querySelector(".".concat(n, "placeholder")), this.ghostEl = t.querySelector(".".concat(n, "ghost")), this.toolbarEl = t.querySelector(".".concat(n, "toolbar")), this.resizerEl = t.querySelector(".".concat(n, "resizer")), this.offsetEl = t.querySelector(".".concat(n, "offset-v")), this.fixedOffsetEl = t.querySelector(".".concat(n, "offset-fixed-v")), this.toolsGlobEl = t.querySelector(".".concat(n, "tools-gl")), this.toolsEl = u, this.el.className = this.className;
            var d = r.get("frames");
            return d.listenToLoad(), o.render(), i.setCurrentFrame(d.at(0).view), c.append(o.el), this.frame = d.at(0).view, this;
          }
        });
      function H(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function B(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? H(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : H(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      window.requestAnimationFrame, e.default = function () {
        var t,
          e,
          n = {};
        return {
          getCanvasView: function getCanvasView() {
            return e;
          },
          name: "Canvas",
          init: function init() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            n = B(B(B({}, p), r), {}, {
              module: this
            }), this.em = n.em;
            var i = n.pStylePrefix;
            i && (n.stylePrefix = i + n.stylePrefix), t = new C(r), e = new z({
              model: t,
              config: n
            });
            var o = n.em.get("DomComponents");
            return o && this.setWrapper(o), this.model = t, this.startAutoscroll = this.startAutoscroll.bind(this), this.stopAutoscroll = this.stopAutoscroll.bind(this), this;
          },
          getConfig: function getConfig() {
            return n;
          },
          setWrapper: function setWrapper(e) {
            t.set("wrapper", e);
          },
          getElement: function getElement() {
            return e.el;
          },
          getFrame: function getFrame(e) {
            return e ? this.getFrames()[e] : t.get("frame");
          },
          getFrameEl: function getFrameEl() {
            var t = e.frame;
            return t && t.el;
          },
          getFramesEl: function getFramesEl() {
            return e.framesArea;
          },
          getWindow: function getWindow() {
            return this.getFrameEl().contentWindow;
          },
          getDocument: function getDocument() {
            var t = this.getFrameEl();
            return t && t.contentDocument;
          },
          getBody: function getBody() {
            var t = this.getDocument();
            return t && t.body;
          },
          getWrapperEl: function getWrapperEl() {
            var t = this.getBody();
            return t && t.querySelector("#wrapper");
          },
          _getCompFrame: function _getCompFrame(t) {
            return t && t._getFrame();
          },
          _getLocalEl: function _getLocalEl(t, e, n) {
            var r = t,
              i = this._getCompFrame(e);
            return i ? i[n]() : r;
          },
          getGlobalToolsEl: function getGlobalToolsEl() {
            return e.toolsGlobEl;
          },
          getToolsEl: function getToolsEl(t) {
            return this._getLocalEl(e.toolsEl, t, "getToolsEl");
          },
          getHighlighter: function getHighlighter(t) {
            return this._getLocalEl(e.hlEl, t, "getHighlighter");
          },
          getBadgeEl: function getBadgeEl(t) {
            return this._getLocalEl(e.badgeEl, t, "getBadgeEl");
          },
          getPlacerEl: function getPlacerEl() {
            return e.placerEl;
          },
          getGhostEl: function getGhostEl() {
            return e.ghostEl;
          },
          getToolbarEl: function getToolbarEl() {
            return e.toolbarEl;
          },
          getResizerEl: function getResizerEl() {
            return e.resizerEl;
          },
          getOffsetViewerEl: function getOffsetViewerEl(t) {
            return this._getLocalEl(e.offsetEl, t, "getOffsetViewerEl");
          },
          getFixedOffsetViewerEl: function getFixedOffsetViewerEl() {
            return e.fixedOffsetEl;
          },
          render: function render() {
            return e.render().el;
          },
          getOffset: function getOffset() {
            var t = this.offset(this.getFrameEl()),
              e = this.offset(this.getElement());
            return {
              top: t.top - e.top,
              left: t.left - e.left
            };
          },
          offset: function offset(t) {
            return e.offset(t);
          },
          setCustomBadgeLabel: function setCustomBadgeLabel(t) {
            n.customBadgeLabel = t;
          },
          getElementPos: function getElementPos(t, n) {
            return e.getElementPos(t, n);
          },
          getElementOffsets: function getElementOffsets(t) {
            return e.getElementOffsets(t);
          },
          getRect: function getRect() {
            var t = e.getPosition(),
              n = t.top,
              r = t.left;
            return B(B({}, e.getCanvasOffset()), {}, {
              topScroll: n,
              leftScroll: r
            });
          },
          getTargetToElementDim: function getTargetToElementDim(t, r) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = i || {},
              a = e.getPosition();
            if (a) {
              var s = o.elPos || e.getElementPos(r),
                c = i.toRight || 0,
                l = o.targetHeight || t.offsetHeight,
                u = o.targetWidth || t.offsetWidth,
                d = o.event || null,
                h = s.top - l,
                f = s.left;
              f += c ? s.width : 0;
              var p = (f = c ? f - u : f) < a.left ? a.left : f,
                g = h < a.top ? a.top : h,
                v = {
                  top: g = g > s.top + s.height ? s.top + s.height : g,
                  left: p,
                  elementTop: s.top,
                  elementLeft: s.left,
                  elementWidth: s.width,
                  elementHeight: s.height,
                  targetWidth: t.offsetWidth,
                  targetHeight: t.offsetHeight,
                  canvasTop: a.top,
                  canvasLeft: a.left,
                  canvasWidth: a.width,
                  canvasHeight: a.height
                };
              return d && n.em && n.em.trigger(d, v), v;
            }
          },
          canvasRectOffset: function canvasRectOffset(t, e) {
            var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = function i(t) {
                var e = t.defaultView;
                return e && e.frameElement;
              },
              o = function o(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                  o = arguments.length > 2 ? arguments[2] : void 0,
                  a = n.em.getZoomDecimal(),
                  s = e ? "top" : "left",
                  c = t.ownerDocument,
                  l = r.offset ? i(c) : {},
                  u = l.offsetTop,
                  d = void 0 === u ? 0 : u,
                  h = l.offsetLeft,
                  f = void 0 === h ? 0 : h,
                  p = c.body || {},
                  g = p.scrollTop,
                  v = void 0 === g ? 0 : g,
                  m = p.scrollLeft,
                  b = void 0 === m ? 0 : m,
                  y = e ? v : b,
                  w = e ? d : f;
                return o[s] - (y - w) * a;
              };
            return {
              top: o(t, 1, e),
              left: o(t, 0, e)
            };
          },
          getTargetToElementFixed: function getTargetToElementFixed(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = n.pos || this.getElementPos(t),
              i = n.canvasOff || this.canvasRectOffset(t, r),
              o = e.offsetHeight || 0,
              a = e.offsetWidth || 0,
              s = r.left + r.width,
              c = this.getCanvasView(),
              l = c.getPosition(),
              u = c.getFrameOffset(t),
              d = n.event,
              h = -o,
              f = r.width - a;
            f = r.left < -f ? -r.left : f, f = s > l.width ? f - (s - l.width) : f;
            var p = r.height + o,
              g = p < u.height;
            i.top < o && (g ? h += p : h = -i.top < r.height ? -i.top : r.height);
            var v = {
              top: h,
              left: f,
              canvasOffsetTop: i.top,
              canvasOffsetLeft: i.left
            };
            return d && this.em.trigger(d, v), v;
          },
          getMouseRelativePos: function getMouseRelativePos(t, e) {
            var n = 0,
              r = 0,
              i = (e || {}).subWinOffset,
              o = t.target.ownerDocument,
              a = o.defaultView || o.parentWindow,
              s = a.frameElement,
              c = i ? a.pageYOffset : 0,
              l = i ? a.pageXOffset : 0;
            if (s) {
              var u = s.getBoundingClientRect();
              n = u.top || 0, r = u.left || 0;
            }
            return {
              y: t.clientY + n - c,
              x: t.clientX + r - l
            };
          },
          getMouseRelativeCanvas: function getMouseRelativeCanvas(t, n) {
            var r = this.getZoomDecimal(),
              i = e.getPosition(n),
              o = i.top,
              a = i.left;
            return {
              y: t.clientY * r + o,
              x: t.clientX * r + a
            };
          },
          hasFocus: function hasFocus() {
            return this.getDocument().hasFocus();
          },
          isInputFocused: function isInputFocused() {
            var t = this.getDocument(),
              e = this.getFrameEl(),
              n = ["body"].concat(i()(this.getConfig().notTextable)),
              r = e && document.activeElement === e ? t && t.activeElement : document.activeElement;
            return r && !n.some(function (t) {
              return r.matches(t);
            });
          },
          scrollTo: function scrollTo(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Object(s.e)(t),
              r = n && Object(s.j)(n);
            r && r.scrollIntoView(e);
          },
          startAutoscroll: function startAutoscroll(t) {
            var e = t && t.view || this.em.getCurrentFrame();
            e && e.startAutoscroll();
          },
          stopAutoscroll: function stopAutoscroll(t) {
            var e = t && t.view || this.em.getCurrentFrame();
            e && e.stopAutoscroll();
          },
          postRender: function postRender() {
            Object(s.k)(n.em) && (this.droppable = new f(n.em));
          },
          setZoom: function setZoom(e) {
            return t.set("zoom", parseFloat(e)), this;
          },
          getZoom: function getZoom() {
            return parseFloat(t.get("zoom"));
          },
          getZoomDecimal: function getZoomDecimal() {
            return this.getZoom() / 100;
          },
          getZoomMultiplier: function getZoomMultiplier() {
            var t = this.getZoomDecimal();
            return t ? 1 / t : 1;
          },
          toggleFramesEvents: function toggleFramesEvents(t) {
            this.getFramesEl().style.pointerEvents = t ? "" : "none";
          },
          getFrameWrapperEl: function getFrameWrapperEl() {
            return e.frame.getWrapper();
          },
          getFrames: function getFrames() {
            return t.get("frames").map(function (t) {
              return t;
            });
          },
          addFrame: function addFrame() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return t.get("frames").add(B({}, e), B(B({}, n), {}, {
              em: this.em
            }));
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(11),
        a = {
          stylePrefix: "gjs-",
          components: "",
          style: "",
          fromElement: 0,
          noticeOnUnload: !0,
          showOffsets: !1,
          showOffsetsSelected: !1,
          forceClass: !0,
          height: "900px",
          width: "100%",
          log: ["warning", "error"],
          baseCss: "\n    * {\n      box-sizing: border-box;\n    }\n    html, body, [data-gjs-type=wrapper] {\n      min-height: 100%;\n    }\n    body {\n      margin: 0;\n      height: 100%;\n      background-color: #fff\n    }\n    [data-gjs-type=wrapper] {\n      overflow: auto;\n      overflow-x: hidden;\n    }\n\n    * ::-webkit-scrollbar-track {\n      background: rgba(0, 0, 0, 0.1)\n    }\n\n    * ::-webkit-scrollbar-thumb {\n      background: rgba(255, 255, 255, 0.2)\n    }\n\n    * ::-webkit-scrollbar {\n      width: 10px\n    }\n  ",
          protectedCss: "* { box-sizing: border-box; } body {margin: 0;}",
          canvasCss: "",
          defaultCommand: "select-comp",
          showToolbar: 1,
          allowScripts: 0,
          showDevices: 1,
          devicePreviewMode: 0,
          mediaCondition: "max-width",
          tagVarStart: "{[ ",
          tagVarEnd: " ]}",
          keepEmptyTextNodes: 0,
          jsInHtml: !0,
          nativeDnD: 1,
          multipleSelection: 1,
          exportWrapper: 0,
          wrapperIsBody: 1,
          avoidInlineStyle: 1,
          avoidDefaults: 1,
          clearStyles: 0,
          dragMode: 0,
          listenToEl: [],
          cssIcons: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css",
          el: "",
          i18n: {},
          undoManager: {},
          assetManager: {},
          canvas: {},
          layers: {},
          storageManager: {},
          richTextEditor: {},
          domComponents: {},
          modal: {},
          popover: {},
          codeManager: {},
          panels: {},
          commands: {},
          cssComposer: {},
          selectorManager: {},
          deviceManager: {
            devices: [{
              id: "desktop",
              name: "Desktop",
              width: ""
            }, {
              id: "tablet",
              name: "Tablet",
              width: "768px",
              widthMedia: "992px"
            }, {
              id: "mobileLandscape",
              name: "Mobile landscape",
              width: "568px",
              widthMedia: "768px"
            }, {
              id: "mobilePortrait",
              name: "Mobile portrait",
              width: "320px",
              widthMedia: "480px"
            }]
          },
          styleManager: {
            sectors: [{
              name: "General",
              open: !1,
              buildProps: ["float", "display", "position", "top", "right", "left", "bottom"]
            }, {
              name: "Flex",
              open: !1,
              buildProps: ["flex-direction", "flex-wrap", "justify-content", "align-items", "align-content", "order", "flex-basis", "flex-grow", "flex-shrink", "align-self"]
            }, {
              name: "Dimension",
              open: !1,
              buildProps: ["width", "height", "max-width", "min-height", "margin", "padding"]
            }, {
              name: "Typography",
              open: !1,
              buildProps: ["font-family", "font-size", "font-weight", "letter-spacing", "color", "line-height", "text-align", "text-shadow"],
              properties: [{
                property: "text-align",
                list: [{
                  value: "left",
                  className: "fa fa-align-left"
                }, {
                  value: "center",
                  className: "fa fa-align-center"
                }, {
                  value: "right",
                  className: "fa fa-align-right"
                }, {
                  value: "justify",
                  className: "fa fa-align-justify"
                }]
              }]
            }, {
              name: "Decorations",
              open: !1,
              buildProps: ["border-radius-c", "background-color", "border-radius", "border", "box-shadow", "background"]
            }, {
              name: "Extra",
              open: !1,
              buildProps: ["transition", "perspective", "transform"]
            }]
          },
          blockManager: {},
          traitManager: {},
          textViewCode: "Code",
          keepUnusedStyles: 0,
          multiFrames: 0
        },
        s = n(0),
        c = n(1),
        l = n.n(c),
        u = n(3);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      l.a.$ = o.default;
      var f,
        p,
        g = [n(115), n(116), n(85), n(86), n(110), n(109), n(111), n(112), n(107), n(113), n(114), n(108), n(106), n(117), n(103), n(118), n(104), n(100), n(75), n(101), n(119), n(105)],
        v = l.a.Collection;
      !function (t) {
        var e = t.$;
        if (e && "jQuery" !== e.prototype.constructor.name) {
          var n = e.fn;
          n.hide = function () {
            return this.css("display", "none");
          }, n.show = function () {
            return this.css("display", "block");
          }, n.focus = function () {
            var t = this.get(0);
            return t && t.focus(), this;
          }, n.bind = function (t, e) {
            return this.on(t, e);
          }, n.unbind = function (t, e) {
            if (Object(s.isObject)(t)) {
              for (var n in t) t.hasOwnProperty(n) && this.off(n, t[n]);
              return this;
            }
            return this.off(t, e);
          }, n.click = function (t) {
            return t ? this.on("click", t) : this.trigger("click");
          }, n.change = function (t) {
            return t ? this.on("change", t) : this.trigger("change");
          }, n.keydown = function (t) {
            return t ? this.on("keydown", t) : this.trigger("keydown");
          }, n.delegate = function (t, e, n, r) {
            return r || (r = n), this.on(e, t, function (t) {
              t.data = n, r(t);
            });
          }, n.scrollLeft = function () {
            var t = this.get(0),
              e = (t = 9 == t.nodeType ? t.defaultView : t) instanceof Window ? t : null;
            return e ? e.pageXOffset : t.scrollLeft || 0;
          }, n.scrollTop = function () {
            var t = this.get(0),
              e = (t = 9 == t.nodeType ? t.defaultView : t) instanceof Window ? t : null;
            return e ? e.pageYOffset : t.scrollTop || 0;
          };
          var r = e.prototype.offset;
          n.offset = function (t) {
            var e, n;
            return t && (e = t.top, n = t.left), void 0 !== e && this.css("top", "".concat(e, "px")), void 0 !== n && this.css("left", "".concat(n, "px")), r.call(this);
          }, e.map = function (t, e) {
            for (var n = [], r = 0; r < t.length; r++) n.push(e(t[r], r));
            return n;
          };
          var i = Array.prototype.indexOf;
          e.inArray = function (t, e, n) {
            return null == e ? -1 : i.call(e, t, n);
          }, e.Event = function (t, n) {
            if (!(this instanceof e.Event)) return new e.Event(t, n);
            this.type = t, this.isDefaultPrevented = function () {
              return !1;
            };
          };
        }
      }({
        Backbone: l.a,
        $: l.a.$
      });
      var m = {
          debug: console.log,
          info: console.info,
          warning: console.warn,
          error: console.error
        },
        b = l.a.Model.extend({
          defaults: function defaults() {
            return {
              editing: 0,
              selected: new v(),
              clipboard: null,
              dmode: 0,
              componentHovered: null,
              previousModel: null,
              changesCount: 0,
              storables: [],
              modules: [],
              toLoad: [],
              opened: {},
              device: ""
            };
          },
          initialize: function initialize() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = e, this.set("Config", e), this.set("modules", []), this.set("toLoad", []), this.set("storables", []), this.set("selected", new v()), this.set("dmode", e.dragMode);
            var n = e.el,
              r = e.log,
              i = !0 === r ? Object(s.keys)(m) : Object(s.isArray)(r) ? r : [];
            Object(s.bindAll)(this, "initBaseColorPicker"), n && e.fromElement && (this.config.components = n.innerHTML), this.attrsOrig = n ? Object(s.toArray)(n.attributes).reduce(function (t, e) {
              return t[e.nodeName] = e.nodeValue, t;
            }, {}) : "", g.forEach(function (e) {
              return t.loadModule(e);
            }), this.on("change:componentHovered", this.componentHovered, this), this.on("change:changesCount", this.updateChanges, this), i.forEach(function (e) {
              return t.listenLog(e);
            }), [{
              from: "change:selectedComponent",
              to: "component:toggled"
            }].forEach(function (e) {
              var n = e.from,
                r = e.to;
              t.listenTo(t, n, function () {
                for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
                t.trigger.apply(t, [r].concat(i)), t.logWarning("The event '".concat(n, "' is deprecated, replace it with '").concat(r, "'"));
              });
            });
          },
          getContainer: function getContainer() {
            return this.config.el;
          },
          listenLog: function listenLog(t) {
            this.listenTo(this, "log:".concat(t), m[t]);
          },
          getConfig: function getConfig(t) {
            var e = this.config;
            return Object(s.isUndefined)(t) ? e : e[t];
          },
          loadOnStart: function loadOnStart() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              n = this.get("StorageManager");
            this.get("toLoad").forEach(function (t) {
              t.onLoad();
            });
            var r = function r() {
              var n = t.get("modules");
              n && n.forEach(function (e) {
                return e.postLoad && e.postLoad(t);
              }), e && e();
            };
            n && n.canAutoload() ? this.load(r) : r();
          },
          updateChanges: function updateChanges() {
            var t = this,
              e = this.get("StorageManager"),
              n = this.get("changesCount");
            p && clearTimeout(p), p = setTimeout(function () {
              return t.trigger("update");
            });
            var r = document.querySelector(".btn-save");
            n ? r.classList.add("text-warning") : r.classList.remove("text-warning"), this.config.noticeOnUnload && (window.onbeforeunload = n ? function (t) {
              return 1;
            } : null), e.isAutosave() && n >= e.getStepsBeforeSave() && this.store();
          },
          loadModule: function loadModule(t) {
            var e = this.config,
              n = new (t.default || t)(),
              r = n.name.charAt(0).toLowerCase() + n.name.slice(1),
              i = Object(s.isUndefined)(e[r]) ? e[n.name] : e[r],
              o = i || {},
              a = this.get("StorageManager");
            if (o.pStylePrefix = e.pStylePrefix || "", Object(s.isUndefined)(i) || i || (o._disable = 1), n.storageKey && n.store && n.load && a) {
              o.stm = a;
              var c = "domComponents" == r ? "unshift" : "push";
              this.get("storables")[c](n);
            }
            return o.em = this, n.init(h({}, o)), !n.private && this.set(n.name, n), n.onLoad && this.get("toLoad").push(n), this.get("modules").push(n), this;
          },
          init: function init(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.destroyed && (this.initialize(e), this.destroyed = 0), this.set("Editor", t);
          },
          getEditor: function getEditor() {
            return this.get("Editor");
          },
          handleUpdates: function handleUpdates(t, e) {
            var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            r.temporary || (f && clearInterval(f), f = setTimeout(function () {
              r.avoidStore || n.set("changesCount", n.get("changesCount") + 1, r);
            }, 0));
          },
          componentHovered: function componentHovered(t, e, n) {
            var r = this.previous("componentHovered");
            r && this.trigger("component:unhovered", r, n), e && this.trigger("component:hovered", e, n);
          },
          getSelected: function getSelected() {
            return this.get("selected").last();
          },
          getSelectedAll: function getSelectedAll() {
            var t = this.get("selected");
            return t && t.models || [];
          },
          setSelected: function setSelected(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = Object(s.isArray)(t),
              i = r ? t : [t],
              a = this.get("selected");
            r && this.removeSelected(a.filter(function (t) {
              return !Object(s.contains)(i, t);
            })), i.forEach(function (t) {
              var i = Object(u.g)(t, o.default);
              i && !i.get("selectable") || (!r && e.removeSelected(a.filter(function (t) {
                return t !== i;
              })), e.addSelected(i, n));
            });
          },
          addSelected: function addSelected(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = Object(u.g)(t, o.default),
              i = Object(s.isArray)(r) ? r : [r];
            i.forEach(function (t) {
              if (!t || t.get("selectable")) {
                var r = e.get("selected");
                n.forceChange && r.remove(t, n), r.push(t, n);
              }
            });
          },
          removeSelected: function removeSelected(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.get("selected").remove(Object(u.g)(t, o.default), e);
          },
          toggleSelected: function toggleSelected(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = Object(u.g)(t, o.default),
              i = Object(s.isArray)(r) ? r : [r];
            i.forEach(function (t) {
              e.get("selected").contains(t) ? e.removeSelected(t, n) : e.addSelected(t, n);
            });
          },
          setHovered: function setHovered(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Object(u.g)(t, o.default);
            n && !n.get("hoverable") || (e.forceChange && this.set("componentHovered", ""), this.set("componentHovered", n, e));
          },
          getHovered: function getHovered() {
            return this.get("componentHovered");
          },
          setComponents: function setComponents(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.get("DomComponents").setComponents(t, e);
          },
          getComponents: function getComponents() {
            var t = this.get("DomComponents"),
              e = this.get("CodeManager");
            if (t && e) {
              var n = t.getComponents();
              return e.getCode(n, "json");
            }
          },
          setStyle: function setStyle(t) {
            for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.get("CssComposer").getAll(), r = 0, i = n.length; r < i; r++) n.pop();
            return n.add(t, e), this;
          },
          getStyle: function getStyle() {
            return this.get("CssComposer").getAll();
          },
          setState: function setState(t) {
            return this.set("state", t), this;
          },
          getState: function getState() {
            return this.get("state");
          },
          getHtml: function getHtml() {
            var t = this.config,
              e = t.exportWrapper,
              n = t.wrapperIsBody,
              r = t.jsInHtml ? this.getJs() : "",
              i = this.get("DomComponents").getComponent();
            return this.get("CodeManager").getCode(i, "html", {
              exportWrapper: e,
              wrapperIsBody: n
            }) + (r ? "<script>".concat(r, "<\/script>") : "");
          },
          getCss: function getCss() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.config,
              n = e.wrapperIsBody,
              r = t.avoidProtected,
              i = Object(s.isUndefined)(t.keepUnusedStyles) ? e.keepUnusedStyles : t.keepUnusedStyles,
              o = this.get("CssComposer"),
              a = this.get("DomComponents").getComponent(),
              c = r ? "" : e.protectedCss;
            return c + this.get("CodeManager").getCode(a, "css", {
              cssc: o,
              wrapperIsBody: n,
              keepUnusedStyles: i
            });
          },
          getJs: function getJs() {
            var t = this.get("DomComponents").getWrapper();
            return this.get("CodeManager").getCode(t, "js").trim();
          },
          store: function store(t) {
            var e = this,
              n = this.get("StorageManager"),
              r = {};
            if (n) return this.get("storables").forEach(function (t) {
              var e = t.store(1);
              for (var n in e) r[n] = e[n];
            }), n.store(r, function (n) {
              t && t(n), e.set("changesCount", 0), e.trigger("storage:store", r);
            }), r;
          },
          load: function load() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
            this.getCacheLoad(1, function (n) {
              t.get("storables") && t.get("storables").forEach(function (e) {
                e.load(n), e.postLoad && e.postLoad(t);
              }), e && e(n);
            });
          },
          getCacheLoad: function getCacheLoad(t, e) {
            var n = this;
            if (this.cacheLoad && !t) return this.cacheLoad;
            var r = this.get("StorageManager"),
              i = [];
            if (!r) return {};
            this.get("storables").forEach(function (t) {
              var e = t.storageKey;
              e = Object(s.isFunction)(e) ? e() : e, (Object(s.isArray)(e) ? e : [e]).forEach(function (t) {
                return i.push(t);
              });
            }), r.load(i, function (t) {
              n.cacheLoad = t, e && e(t), setTimeout(function () {
                return n.trigger("storage:load", t);
              });
            });
          },
          getDeviceModel: function getDeviceModel() {
            var t = this.get("device");
            return this.get("DeviceManager").get(t);
          },
          runDefault: function runDefault() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.get("Commands").get(this.config.defaultCommand);
            e && !this.defaultRunning && (e.stop(this, this, t), e.run(this, this, t), this.defaultRunning = 1);
          },
          stopDefault: function stopDefault() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.get("Commands"),
              n = e.get(this.config.defaultCommand);
            n && (n.stop(this, this, t), this.defaultRunning = 0);
          },
          refreshCanvas: function refreshCanvas() {
            this.set("canvasOffset", null), this.set("canvasOffset", this.get("Canvas").getOffset());
          },
          clearSelection: function clearSelection(t) {
            (t || window).getSelection().removeAllRanges();
          },
          getCurrentMedia: function getCurrentMedia() {
            var t = this.config,
              e = this.getDeviceModel(),
              n = t.mediaCondition,
              r = t.devicePreviewMode,
              i = e && e.get("widthMedia");
            return e && i && !r ? "(".concat(n, ": ").concat(i, ")") : "";
          },
          getWrapper: function getWrapper() {
            return this.get("DomComponents").getWrapper();
          },
          setCurrentFrame: function setCurrentFrame(t) {
            return this.set("currentFrame", t);
          },
          getCurrentFrame: function getCurrentFrame() {
            return this.get("currentFrame");
          },
          getCurrentFrameModel: function getCurrentFrameModel() {
            return (this.getCurrentFrame() || {}).model;
          },
          getDirtyCount: function getDirtyCount() {
            return this.get("changesCount");
          },
          getZoomDecimal: function getZoomDecimal() {
            return this.get("Canvas").getZoomDecimal();
          },
          getZoomMultiplier: function getZoomMultiplier() {
            return this.get("Canvas").getZoomMultiplier();
          },
          setDragMode: function setDragMode(t) {
            return this.set("dmode", t);
          },
          t: function t() {
            var t;
            return (t = this.get("I18n")).t.apply(t, arguments);
          },
          inAbsoluteMode: function inAbsoluteMode() {
            return "absolute" === this.get("dmode");
          },
          destroyAll: function destroyAll() {
            var t = this.config,
              e = this.getEditor(),
              n = (t.grapesjs || {}).editors,
              r = void 0 === n ? [] : n,
              i = this.attributes,
              a = i.DomComponents,
              s = i.CssComposer,
              c = i.UndoManager,
              l = i.Panels,
              u = i.Canvas,
              d = i.Keymaps,
              h = i.RichTextEditor;
            this.stopDefault(), a.clear(), s.clear(), c.clear().removeAll(), l.getPanels().reset(), u.getCanvasView().remove(), d.removeAll(), h.destroy(), this.view.remove(), this.stopListening(), this.clear({
              silent: !0
            }), this.destroyed = 1, r.splice(r.indexOf(e), 1), Object(o.default)(t.el).empty().attr(this.attrsOrig);
          },
          setEditing: function setEditing(t) {
            return this.set("editing", t), this;
          },
          isEditing: function isEditing() {
            return !!this.get("editing");
          },
          log: function log(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.ns,
              r = e.level,
              i = void 0 === r ? "debug" : r;
            if (this.trigger("log", t, e), i && this.trigger("log:".concat(i), t, e), n) {
              var o = "log-".concat(n);
              this.trigger(o, t, e), i && this.trigger("".concat(o, ":").concat(i), t, e);
            }
          },
          logInfo: function logInfo(t, e) {
            this.log(t, h(h({}, e), {}, {
              level: "info"
            }));
          },
          logWarning: function logWarning(t, e) {
            this.log(t, h(h({}, e), {}, {
              level: "warning"
            }));
          },
          logError: function logError(t, e) {
            this.log(t, h(h({}, e), {}, {
              level: "error"
            }));
          },
          initBaseColorPicker: function initBaseColorPicker(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.getConfig(),
              r = n.colorPicker,
              i = void 0 === r ? {} : r,
              a = n.el,
              s = n.stylePrefix;
            return Object(o.default)(t).spectrum(h(h({
              containerClassName: "".concat(s, "one-bg ").concat(s, "two-color"),
              appendTo: a || "body",
              maxSelectionSize: 8,
              showPalette: !0,
              palette: [],
              showAlpha: !0,
              chooseText: "Ok",
              cancelText: "⨯"
            }, e), i));
          },
          data: function data(t, e, n) {
            if (t["_gjs-data"] || (t["_gjs-data"] = {}), Object(s.isUndefined)(n)) return t["_gjs-data"][e];
            t["_gjs-data"][e] = n;
          }
        }),
        y = l.a.$,
        w = l.a.View.extend({
          initialize: function initialize() {
            var t = this,
              e = this.model;
            e.view = this, this.conf = e.config, this.pn = e.get("Panels"), this.cv = e.get("Canvas"), e.on("loaded", function () {
              t.pn.active(), t.pn.disableButtons(), setTimeout(function () {
                e.runDefault(), e.trigger("load", e.get("Editor"));
              });
            });
          },
          render: function render() {
            this.model;
            var t = this.$el,
              e = this.conf,
              n = e.stylePrefix,
              r = y(e.el || "body ".concat(e.container));
            return Object(u.a)(e.cssIcons, {
              unique: 1,
              prepand: 1
            }), t.empty(), e.width && r.css("width", e.width), e.height && r.css("height", e.height), t.append(this.cv.render()), t.append(this.pn.render()), t.attr("class", "".concat(n, "editor ").concat(n, "one-bg ").concat(n, "two-color")), r.addClass("".concat(n, "editor-cont")).empty().append(t), this;
          }
        });
      function x(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function O(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? x(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var C = function C() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = O(O({}, a), t);
          e.pStylePrefix = e.stylePrefix;
          var n = new b(e),
            r = new w({
              model: n,
              config: e
            });
          return {
            $: o.default,
            editor: n,
            init: function init() {
              var t = this,
                i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              return n.init(this, O(O({}, e), i)), ["I18n", "Utils", "Config", "Commands", "Keymaps", "Modal", "Popover", "Panels", "Canvas", "Parser", "CodeManager", "UndoManager", "RichTextEditor", "DomComponents", ["Components", "DomComponents"], "LayerManager", ["Layers", "LayerManager"], "CssComposer", ["Css", "CssComposer"], "StorageManager", ["Storage", "StorageManager"], "AssetManager", ["Assets", "AssetManager"], "BlockManager", ["Blocks", "BlockManager"], "TraitManager", ["Traits", "TraitManager"], "SelectorManager", ["Selectors", "SelectorManager"], "StyleManager", ["Styles", "StyleManager"], "DeviceManager", ["Devices", "DeviceManager"]].forEach(function (e) {
                Array.isArray(e) ? t[e[0]] = n.get(e[1]) : t[e] = n.get(e);
              }), n.on("loaded", function () {
                t.UndoManager.clear(), n.get("modules").forEach(function (t) {
                  t.postRender && t.postRender(r);
                });
              }), this;
            },
            getConfig: function getConfig(t) {
              return n.getConfig(t);
            },
            getHtml: function getHtml(t) {
              return n.getHtml(t);
            },
            getCss: function getCss(t) {
              return n.getCss(t);
            },
            getJs: function getJs() {
              return n.getJs();
            },
            getComponents: function getComponents() {
              return n.get("DomComponents").getComponents();
            },
            getWrapper: function getWrapper() {
              return n.get("DomComponents").getWrapper();
            },
            setComponents: function setComponents(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.setComponents(t, e), this;
            },
            addComponents: function addComponents(t, e) {
              return this.getWrapper().append(t, e);
            },
            getStyle: function getStyle() {
              return n.get("CssComposer").getAll();
            },
            setStyle: function setStyle(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.setStyle(t, e), this;
            },
            getSelected: function getSelected() {
              return n.getSelected();
            },
            getSelectedAll: function getSelectedAll() {
              return n.getSelectedAll();
            },
            getSelectedToStyle: function getSelectedToStyle() {
              var t = n.getSelected();
              if (t) return this.StyleManager.getModelToStyle(t);
            },
            select: function select(t, e) {
              return n.setSelected(t, e), this;
            },
            selectAdd: function selectAdd(t) {
              return n.addSelected(t), this;
            },
            selectRemove: function selectRemove(t) {
              return n.removeSelected(t), this;
            },
            selectToggle: function selectToggle(t) {
              return n.toggleSelected(t), this;
            },
            setDevice: function setDevice(t) {
              return n.set("device", t), this;
            },
            getDevice: function getDevice() {
              return n.get("device");
            },
            runCommand: function runCommand(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.get("Commands").run(t, e);
            },
            stopCommand: function stopCommand(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.get("Commands").stop(t, e);
            },
            store: function store(t) {
              return n.store(t);
            },
            load: function load(t) {
              return n.load(t);
            },
            getContainer: function getContainer() {
              return e.el;
            },
            getDirtyCount: function getDirtyCount() {
              return n.getDirtyCount();
            },
            refresh: function refresh() {
              n.refreshCanvas();
            },
            setCustomRte: function setCustomRte(t) {
              this.RichTextEditor.customRte = t;
            },
            setCustomParserCss: function setCustomParserCss(t) {
              return this.Parser.getConfig().parserCss = t, this;
            },
            setDragMode: function setDragMode(t) {
              return n.setDragMode(t), this;
            },
            log: function log(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return n.log(t, e), this;
            },
            t: function t() {
              return n.t.apply(n, arguments);
            },
            on: function on(t, e) {
              return n.on(t, e), this;
            },
            once: function once(t, e) {
              return n.once(t, e), this;
            },
            off: function off(t, e) {
              return n.off(t, e), this;
            },
            trigger: function trigger(t) {
              return n.trigger.apply(n, arguments), this;
            },
            destroy: function destroy() {
              return n.destroyAll();
            },
            getEl: function getEl() {
              return r.el;
            },
            getModel: function getModel() {
              return n;
            },
            render: function render() {
              return r.render(), r.el;
            }
          };
        },
        S = {
          plugins: []
        };
      function k(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function T(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? k(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      !function () {
        if (function () {
          for (var t, e = window.navigator.userAgent, n = [["edge", /Edge\/([0-9\._]+)/], ["ie", /MSIE\s(7\.0)/], ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/], ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/]], r = 0; r < n.length && !(t = n[r][1].exec(e)); r++);
          return !!t;
        }()) {
          var t = DOMImplementation.prototype.createHTMLDocument;
          DOMImplementation.prototype.createHTMLDocument = function (e) {
            return e || (e = ""), t.apply(document.implementation, [e]);
          };
        }
      }();
      var j = new function (t) {
          var e = void 0 || {};
          for (var n in S) n in e || (e[n] = S[n]);
          var r = {};
          return {
            add: function add(t, e) {
              return r[t] ? r[t] : (r[t] = e, e);
            },
            get: function get(t) {
              return r[t];
            },
            getAll: function getAll() {
              return r;
            }
          };
        }(),
        E = [],
        P = {
          autorender: 1,
          plugins: [],
          pluginsOpts: {}
        };
      e.default = {
        $: o.default,
        editors: E,
        plugins: j,
        version: "0.1.18",
        init: function init() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.container;
          if (!e) throw new Error("'container' is required");
          (t = T(T(T({}, P), t), {}, {
            grapesjs: this
          })).el = Object(s.isElement)(e) ? e : document.querySelector(e);
          var n = new C(t).init();
          return t.plugins.forEach(function (e) {
            var r = j.get(e),
              i = t.pluginsOpts[e] || {};
            if (!r) {
              var o = window[e];
              r = o && o.default ? o.default : o;
            }
            r ? r(n, i) : Object(s.isFunction)(e) && e(n, i);
          }), n.getModel().loadOnStart(), t.autorender && n.render(), E.push(n), n;
        }
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = {
          assets: [],
          noAssets: "",
          stylePrefix: "am-",
          upload: 0,
          uploadName: "files",
          headers: {},
          params: {},
          credentials: "include",
          multiUpload: !0,
          autoAdd: 1,
          customFetch: "",
          uploadFile: "",
          embedAsBase64: 1,
          handleAdd: "",
          dropzone: 0,
          openAssetsOnDrop: 1,
          dropzoneContent: "",
          beforeUpload: null,
          showUrlInput: !0
        },
        i = n(1),
        o = n.n(i),
        a = n(2),
        s = n.n(a),
        c = o.a.Model.extend({
          idAttribute: "src",
          defaults: {
            type: "",
            src: ""
          },
          getFilename: function getFilename() {
            return this.get("src").split("/").pop();
          },
          getExtension: function getExtension() {
            return this.getFilename().split(".").pop();
          }
        });
      function l(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? l(Object(n), !0).forEach(function (e) {
            s()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var d = c.extend({
          defaults: u(u({}, c.prototype.defaults), {}, {
            type: "image",
            unitDim: "px",
            height: 0,
            width: 0
          })
        }),
        h = n(0),
        f = o.a.View.extend({
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.options = t, this.collection = t.collection;
            var e = t.config || {};
            this.config = e, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.em = e.em, this.className = this.pfx + "asset", this.listenTo(this.model, "destroy remove", this.remove), this.model.view = this;
            var n = this.init && this.init.bind(this);
            n && n(t);
          },
          template: function template() {
            var t = this.pfx;
            return '\n      <div class="'.concat(t, 'preview-cont">\n        ').concat(this.getPreview(), '\n      </div>\n      <div class="').concat(t, 'meta">\n        ').concat(this.getInfo(), '\n      </div>\n      <div class="').concat(t, 'close" data-toggle="asset-remove">\n        &Cross;\n      </div>\n    ');
          },
          updateTarget: function updateTarget(t) {
            t && t.set && (t.set("attributes", Object(h.clone)(t.get("attributes"))), t.set("src", this.model.get("src")));
          },
          getPreview: function getPreview() {
            return "";
          },
          getInfo: function getInfo() {
            return "";
          },
          render: function render() {
            var t = this.el;
            return t.innerHTML = this.template(this, this.model), t.className = this.className, this;
          }
        }).extend({
          events: {
            "click [data-toggle=asset-remove]": "onRemove",
            click: "onClick",
            dblclick: "onDblClick"
          },
          getPreview: function getPreview() {
            var t = this.pfx,
              e = this.model.get("src");
            return '\n      <div class="'.concat(t, 'preview" style="background-image: url(\'').concat(e, '\');"></div>\n      <div class="').concat(t, "preview-bg ").concat(this.ppfx, 'checker-bg"></div>\n    ');
          },
          getInfo: function getInfo() {
            var t = this.pfx,
              e = this.model,
              n = e.get("name"),
              r = e.get("width"),
              i = e.get("height"),
              o = e.get("unitDim"),
              a = r && i ? "".concat(r, "x").concat(i).concat(o) : "";
            return n = n || e.getFilename(), '\n      <div class="'.concat(t, 'name">').concat(n, '</div>\n      <div class="').concat(t, 'dimensions">').concat(a, "</div>\n    ");
          },
          init: function init(t) {
            var e = this.pfx;
            this.className += " ".concat(e, "asset-image");
          },
          onClick: function onClick() {
            var t = this.config.onClick,
              e = this.model;
            this.collection.trigger("deselectAll"), this.$el.addClass(this.pfx + "highlight"), Object(h.isFunction)(t) ? t(e) : this.updateTarget(this.collection.target);
          },
          onDblClick: function onDblClick() {
            var t = this.em,
              e = this.model,
              n = this.config.onDblClick;
            Object(h.isFunction)(n) ? n(e) : (this.updateTarget(this.collection.target), t && t.get("Modal").close());
            var r = this.collection.onSelect;
            Object(h.isFunction)(r) && r(e);
          },
          onRemove: function onRemove(t) {
            t.stopImmediatePropagation(), this.model.collection.remove(this.model);
          }
        }),
        p = n(30),
        g = o.a.Collection.extend(p.a).extend({
          types: [{
            id: "image",
            model: d,
            view: f,
            isType: function isType(t) {
              return "string" == typeof t ? {
                type: "image",
                src: t
              } : t;
            }
          }]
        }),
        v = n(25),
        m = n.n(v),
        b = ["pfx", "ppfx", "em"],
        y = o.a.View.extend({
          events: {
            submit: "handleSubmit"
          },
          template: function template(t) {
            var e = t.pfx,
              n = t.ppfx,
              r = t.em,
              i = (m()(t, b), "");
            return this.config.showUrlInput && (i = '\n          <form class="'.concat(e, 'add-asset">\n            <div class="').concat(n, "field ").concat(e, 'add-field">\n              <input placeholder="').concat(r && r.t("assetManager.inputPlh"), '"/>\n            </div>\n            <button class="').concat(n, 'btn-prim">').concat(r && r.t("assetManager.addButton"), '</button>\n            <div style="clear:both"></div>\n          </form>\n      ')), '\n    <div class="'.concat(e, 'assets-cont">\n      <div class="').concat(e, 'assets-header">\n        ').concat(i, '\n      </div>\n      <div class="').concat(e, 'assets" data-el="assets"></div>\n      <div style="clear:both"></div>\n    </div>\n    ');
          },
          initialize: function initialize(t) {
            this.options = t, this.config = t.config, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.em = this.config.em;
            var e = this.collection;
            this.listenTo(e, "reset", this.renderAssets), this.listenTo(e, "add", this.addToAsset), this.listenTo(e, "remove", this.removedAsset), this.listenTo(e, "deselectAll", this.deselectAll);
          },
          handleSubmit: function handleSubmit(t) {
            t.preventDefault();
            var e = this.getAddInput(),
              n = e && e.value.trim(),
              r = this.config.handleAdd;
            n && (e.value = "", this.getAssetsEl().scrollTop = 0, r ? r.bind(this)(n) : this.options.globalCollection.add(n, {
              at: 0
            }));
          },
          getAssetsEl: function getAssetsEl() {
            return this.el.querySelector(".".concat(this.pfx, "assets"));
          },
          getAddInput: function getAddInput() {
            return this.inputUrl && this.inputUrl.value || (this.inputUrl = this.el.querySelector(".".concat(this.pfx, "add-asset input"))), this.inputUrl;
          },
          removedAsset: function removedAsset(t) {
            this.collection.length || this.toggleNoAssets();
          },
          addToAsset: function addToAsset(t) {
            1 == this.collection.length && this.toggleNoAssets(1), this.addAsset(t);
          },
          addAsset: function addAsset(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              n = e,
              r = this.collection,
              i = this.config,
              o = new t.typeView({
                model: t,
                collection: r,
                config: i
              }).render().el;
            if (n) n.appendChild(o);else {
              var a = this.getAssetsEl();
              a && a.insertBefore(o, a.firstChild);
            }
            return o;
          },
          toggleNoAssets: function toggleNoAssets(t) {
            var e = this.$el.find(".".concat(this.pfx, "assets"));
            if (t) e.empty();else {
              var n = this.config.noAssets;
              n && e.append(n);
            }
          },
          deselectAll: function deselectAll() {
            var t = this.pfx;
            this.$el.find(".".concat(t, "highlight")).removeClass("".concat(t, "highlight"));
          },
          renderAssets: function renderAssets() {
            var t = this,
              e = document.createDocumentFragment(),
              n = this.$el.find(".".concat(this.pfx, "assets"));
            n.empty(), this.toggleNoAssets(this.collection.length), this.collection.each(function (n) {
              return t.addAsset(n, e);
            }), n.append(e);
          },
          render: function render() {
            var t = this.options.fu.render().el;
            return this.$el.empty(), this.$el.append(t).append(this.template(this)), this.el.className = "".concat(this.ppfx, "asset-manager"), this.renderAssets(), this.rendered = 1, this;
          }
        }),
        w = n(28);
      function x(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
      }
      var O = o.a.View.extend({
        template: Object(h.template)('\n  <form>\n    <div id="<%= pfx %>title"><%= title %></div>\n    <input type="file" id="<%= uploadId %>" name="file" accept="*/*" <%= disabled ? \'disabled\' : \'\' %> <%= multiUpload ? \'multiple\' : \'\' %>/>\n    <div style="clear:both;"></div>\n  </form>\n  '),
        events: {},
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.options = t;
          var e = t.config || {};
          this.config = e, this.em = this.config.em, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.target = this.options.globalCollection || {}, this.uploadId = this.pfx + "uploadFile", this.disabled = void 0 !== e.disableUpload ? e.disableUpload : !e.upload && !e.embedAsBase64, this.multiUpload = void 0 === e.multiUpload || e.multiUpload, this.events["change #" + this.uploadId] = "uploadFile";
          var n = e.uploadFile;
          n ? this.uploadFile = n.bind(this) : !e.upload && e.embedAsBase64 && (this.uploadFile = this.constructor.embedAsBase64), this.delegateEvents();
        },
        onUploadStart: function onUploadStart() {
          var t = this.config.em;
          t && t.trigger("asset:upload:start");
        },
        onUploadEnd: function onUploadEnd(t) {
          var e = this.$el,
            n = this.config.em;
          n && n.trigger("asset:upload:end", t);
          var r = e.find("input");
          r && r.val("");
        },
        onUploadError: function onUploadError(t) {
          var e = this.config.em;
          this.onUploadEnd(t), e && e.trigger("asset:upload:error", t);
        },
        onUploadResponse: function onUploadResponse(t, e) {
          var n,
            r = this.config.em,
            i = this.config,
            o = this.target;
          try {
            n = "string" == typeof t ? JSON.parse(t) : t;
          } catch (e) {
            n = t;
          }
          r && r.trigger("asset:upload:response", n), i.autoAdd && o && o.add(n.data, {
            at: 0
          }), this.onUploadEnd(t), e && e(n);
        },
        uploadFile: function uploadFile(t, e) {
          var n = this,
            r = t.dataTransfer ? t.dataTransfer.files : t.target.files,
            i = this.config,
            o = i.beforeUpload;
          if (!1 !== (o && o(r))) {
            var a = new FormData(),
              s = i.params,
              c = i.customFetch;
            for (var l in s) a.append(l, s[l]);
            if (this.multiUpload) for (var u = 0; u < r.length; u++) a.append("".concat(i.uploadName, "[]"), r[u]);else r.length && a.append(i.uploadName, r[0]);
            this.target;
            var d = i.upload,
              h = i.headers;
            if (void 0 === h["X-Requested-With"] && (h["X-Requested-With"] = "XMLHttpRequest"), d) {
              this.onUploadStart();
              var f = {
                method: "post",
                credentials: i.credentials || "include",
                headers: h,
                body: a
              };
              return (c ? c(d, f) : Object(w.a)(d, f).then(function (t) {
                return 1 == (t.status / 200 | 0) ? t.text() : t.text().then(function (t) {
                  return Promise.reject(t);
                });
              })).then(function (t) {
                return n.onUploadResponse(t, e);
              }).catch(function (t) {
                return n.onUploadError(t);
              });
            }
          }
        },
        initDrop: function initDrop() {
          var t = this;
          !this.uploadForm && (this.uploadForm = this.$el.find("form").get(0), "draggable" in this.uploadForm) && (this.uploadFile, this.uploadForm.ondragover = function () {
            return this.className = t.pfx + "hover", !1;
          }, this.uploadForm.ondragleave = function () {
            return this.className = "", !1;
          }, this.uploadForm.ondrop = function (e) {
            this.className = "", e.preventDefault(), t.uploadFile(e);
          });
        },
        initDropzone: function initDropzone(t) {
          var e = this,
            n = 0,
            r = this.config,
            i = t.model,
            o = t.el,
            a = i.get("Editor"),
            s = (i.get("Config").el, i.get("Canvas").getBody()),
            c = this.ppfx,
            l = "".concat(c, "dropzone-active"),
            u = "".concat(c, "dropzone"),
            d = function d() {
              o.className = o.className.replace(l, "").trim(), n = 0;
            },
            h = function h() {
              return n || (o.className += " ".concat(l), n = 1), !1;
            },
            f = function f() {
              return d(), !1;
            },
            p = function p(t) {
              if (d(), t.preventDefault(), t.stopPropagation(), e.uploadFile(t), r.openAssetsOnDrop && a) {
                var n = a.getSelected();
                a.runCommand("open-assets", {
                  target: n,
                  onSelect: function onSelect() {
                    a.Modal.close(), a.AssetManager.setTarget(null);
                  }
                });
              }
              return !1;
            };
          t.$el.append('<div class="'.concat(u, '">').concat(r.dropzoneContent, "</div>")), d(), "draggable" in o && [o, s].forEach(function (t) {
            t.ondragover = h, t.ondragleave = f, t.ondrop = p;
          });
        },
        render: function render() {
          var t = this.$el,
            e = this.pfx,
            n = this.em;
          return t.html(this.template({
            title: n && n.t("assetManager.uploadTitle"),
            uploadId: this.uploadId,
            disabled: this.disabled,
            multiUpload: this.multiUpload,
            pfx: e
          })), this.initDrop(), t.attr("class", e + "file-uploader"), this;
        }
      }, {
        embedAsBase64: function embedAsBase64(t, e) {
          var n = this,
            r = t.dataTransfer ? t.dataTransfer.files : t.target.files,
            i = {
              data: []
            };
          if (FileReader) {
            var o,
              a = [],
              s = /^(.+)\/(.+)$/,
              c = function (t, e) {
                var _n13 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
                if (!_n13) {
                  if (Array.isArray(t) || (_n13 = function (t, e) {
                    if (t) {
                      if ("string" == typeof t) return x(t, e);
                      var n = Object.prototype.toString.call(t).slice(8, -1);
                      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? x(t, e) : void 0;
                    }
                  }(t)) || e && t && "number" == typeof t.length) {
                    _n13 && (t = _n13);
                    var r = 0,
                      i = function i() {};
                    return {
                      s: i,
                      n: function n() {
                        return r >= t.length ? {
                          done: !0
                        } : {
                          done: !1,
                          value: t[r++]
                        };
                      },
                      e: function e(t) {
                        throw t;
                      },
                      f: i
                    };
                  }
                  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var o,
                  a = !0,
                  s = !1;
                return {
                  s: function s() {
                    _n13 = _n13.call(t);
                  },
                  n: function n() {
                    var t = _n13.next();
                    return a = t.done, t;
                  },
                  e: function e(t) {
                    s = !0, o = t;
                  },
                  f: function f() {
                    try {
                      a || null == _n13.return || _n13.return();
                    } finally {
                      if (s) throw o;
                    }
                  }
                };
              }(r);
            try {
              var l = function l() {
                var t = o.value,
                  e = new Promise(function (e, n) {
                    var r = new FileReader();
                    r.addEventListener("load", function (i) {
                      var o,
                        a = t.name,
                        c = s.exec(t.type);
                      if ("image" === (o = c ? c[1] : t.type)) {
                        var l = {
                            src: r.result,
                            name: a,
                            type: o,
                            height: 0,
                            width: 0
                          },
                          u = new Image();
                        u.addEventListener("error", function (t) {
                          n(t);
                        }), u.addEventListener("load", function () {
                          l.height = u.height, l.width = u.width, e(l);
                        }), u.src = l.src;
                      } else e(o ? {
                        src: r.result,
                        name: a,
                        type: o
                      } : r.result);
                    }), r.addEventListener("error", function (t) {
                      n(t);
                    }), r.addEventListener("abort", function (t) {
                      n("Aborted");
                    }), r.readAsDataURL(t);
                  });
                a.push(e);
              };
              for (c.s(); !(o = c.n()).done;) l();
            } catch (t) {
              c.e(t);
            } finally {
              c.f();
            }
            Promise.all(a).then(function (t) {
              i.data = t, n.onUploadResponse(i, e);
            }, function (t) {
              n.onUploadError(t);
            });
          } else this.onUploadError(new Error("Unsupported platform, FileReader is not defined"));
        }
      });
      e.default = function () {
        var t,
          e,
          n,
          i = {};
        return {
          name: "AssetManager",
          storageKey: "assets",
          getConfig: function getConfig() {
            return i;
          },
          init: function init(o) {
            var a = this;
            for (var s in i = o || {}, r) s in i || (i[s] = r[s]);
            var c = i.pStylePrefix,
              l = i.em;
            c && (i.stylePrefix = c + i.stylePrefix), t = new g([]);
            var u = {
              collection: new g([]),
              globalCollection: t,
              config: i
            };
            return n = new O(u), u.fu = n, e = new y(u), t.listenTo(t, "add", function (t) {
              a.getAllVisible().add(t), l && l.trigger("asset:add", t);
            }), t.listenTo(t, "remove", function (t) {
              a.getAllVisible().remove(t), l && l.trigger("asset:remove", t);
            }), this;
          },
          add: function add(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return void 0 === n.at && (n.at = 0), t.add(e, n);
          },
          get: function get(e) {
            return t.where({
              src: e
            })[0];
          },
          getAll: function getAll() {
            return t;
          },
          getAllVisible: function getAllVisible() {
            return e.collection;
          },
          remove: function remove(t) {
            var e = this.get(t);
            return this.getAll().remove(e), this;
          },
          store: function store(t) {
            var e = {},
              n = JSON.stringify(this.getAll().toJSON());
            return e[this.storageKey] = n, !t && i.stm && i.stm.store(e), e;
          },
          load: function load() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.storageKey,
              n = t[e] || [];
            if ("string" == typeof n) try {
              n = JSON.parse(t[e]);
            } catch (t) {}
            return n && n.length && this.getAll().reset(n), n;
          },
          getContainer: function getContainer() {
            return e.el;
          },
          getAssetsEl: function getAssetsEl() {
            return e.el.querySelector("[data-el=assets]");
          },
          render: function render(t) {
            var n = t || this.getAll().models;
            return e.rendered || e.render(), e.collection.reset(n), this.getContainer();
          },
          addType: function addType(t, e) {
            this.getAll().addType(t, e);
          },
          getType: function getType(t) {
            return this.getAll().getType(t);
          },
          getTypes: function getTypes() {
            return this.getAll().getTypes();
          },
          AssetsView: function AssetsView() {
            return e;
          },
          FileUploader: function FileUploader() {
            return n;
          },
          onLoad: function onLoad() {
            this.getAll().reset(i.assets);
          },
          postRender: function postRender(t) {
            i.dropzone && n.initDropzone(t);
          },
          setTarget: function setTarget(t) {
            e.collection.target = t;
          },
          onSelect: function onSelect(t) {
            e.collection.onSelect = t;
          },
          onClick: function onClick(t) {
            i.onClick = t;
          },
          onDblClick: function onDblClick(t) {
            i.onDblClick = t;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0),
        i = {
          stylePrefix: "trt-",
          appendTo: "",
          optionsTarget: [{
            value: !1
          }, {
            value: "_blank"
          }]
        },
        o = n(20),
        a = n(2),
        s = n.n(a),
        c = n(80),
        l = n.n(c),
        u = n(1),
        d = n.n(u),
        h = n(3);
      function f(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function p(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? f(Object(n), !0).forEach(function (e) {
            s()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var g = d.a.$,
        v = d.a.View.extend({
          events: {},
          eventCapture: ["change"],
          appendInput: 1,
          attributes: function attributes() {
            return this.model.get("attributes");
          },
          templateLabel: function templateLabel() {
            var t = this.ppfx,
              e = this.getLabel(),
              n = this.getLabelTitle(),
              r = this.getLabelTitleInfo();
            return '<div class="'.concat(t, 'label" title="').concat(n, '">').concat(e).concat(r, "</div>");
          },
          templateInput: function templateInput() {
            var t = this.clsField;
            return '<div class="'.concat(t, '" data-input></div>');
          },
          initialize: function initialize() {
            var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = e.config,
              r = void 0 === n ? {} : n,
              i = this.model,
              o = this.eventCapture,
              a = i.target,
              s = i.attributes.type;
            this.config = r, this.em = r.em, this.pfx = r.stylePrefix || "", this.ppfx = r.pStylePrefix || "", this.target = a;
            var c = this.ppfx;
            this.clsField = "".concat(c, "field ").concat(c, "field-").concat(s), [["change:value", this.onValueChange], ["remove", this.removeView]].forEach(function (e) {
              var n = l()(e, 2),
                r = n[0],
                o = n[1];
              i.off(r, o), t.listenTo(i, r, o);
            }), i.view = this, this.listenTo(i, "change:label", this.render), this.listenTo(i, "change:placeholder", this.rerender), o.forEach(function (e) {
              return t.events[e] = "onChange";
            }), this.delegateEvents(), this.init();
          },
          getClbOpts: function getClbOpts() {
            return {
              component: this.target,
              trait: this.model,
              elInput: this.getInputElem()
            };
          },
          removeView: function removeView() {
            this.remove(), this.removed();
          },
          init: function init() {},
          removed: function removed() {},
          onRender: function onRender() {},
          onUpdate: function onUpdate() {},
          onEvent: function onEvent() {},
          onChange: function onChange(t) {
            var e = this.getInputElem();
            e && !Object(r.isUndefined)(e.value) && this.model.set("value", e.value), this.onEvent(p(p({}, this.getClbOpts()), {}, {
              event: t
            }));
          },
          getValueForTarget: function getValueForTarget() {
            return this.model.get("value");
          },
          setInputValue: function setInputValue(t) {
            var e = this.getInputElem();
            e && (e.value = t);
          },
          onValueChange: function onValueChange(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            if (n.fromTarget) this.setInputValue(t.get("value")), this.postUpdate();else {
              var r = this.getValueForTarget();
              t.setTargetValue(r, n);
            }
          },
          renderLabel: function renderLabel() {
            var t = this.$el,
              e = this.target,
              n = this.getLabel(),
              r = this.templateLabel(e);
            this.createLabel && (r = this.createLabel({
              label: n,
              component: e,
              trait: this
            }) || ""), t.find("[data-label]").append(r);
          },
          getLabel: function getLabel() {
            var t = this.em,
              e = this.model.attributes,
              n = e.label,
              r = e.name;
            return t.t("traitManager.traits.labels.".concat(r)) || Object(h.c)(n || r).replace(/-/g, " ");
          },
          getLabelTitle: function getLabelTitle() {
            var t = this.em,
              e = this.model.attributes,
              n = e.label,
              r = e.name,
              i = e.title;
            return i ? Object(h.c)(i).replace(/-/g, " ") : t.t("traitManager.traits.labels.".concat(r)) || Object(h.c)(n || r).replace(/-/g, " ");
          },
          getLabelTitleInfo: function getLabelTitleInfo() {
            var t = this.model.attributes,
              e = t.info,
              n = t.infoStyle;
            return e ? '<i class="gjs-block__info-fa fa fa-info-circle" style="'.concat(n || "margin-left: 5px", '" title="').concat(e, '"></i>') : "";
          },
          getComponent: function getComponent() {
            return this.target;
          },
          getInputEl: function getInputEl() {
            if (!this.$input) {
              var t = this.em,
                e = this.model,
                n = e,
                i = e.attributes.name,
                o = n.get("placeholder") || n.get("default") || "",
                a = n.get("type") || "text",
                s = n.get("min"),
                c = n.get("max"),
                l = this.getModelValue(),
                u = g('<input type="'.concat(a, '" placeholder="').concat(o, '">')),
                d = t.t("traitManager.traits.attributes.".concat(i)) || {};
              u.attr(d), Object(r.isUndefined)(l) || (n.set({
                value: l
              }, {
                silent: !0
              }), u.prop("value", l)), s && u.prop("min", s), c && u.prop("max", c), this.$input = u;
            }
            return this.$input.get(0);
          },
          getInputElem: function getInputElem() {
            var t = this.input,
              e = this.$input;
            return t || e && e.get && e.get(0) || this.getElInput();
          },
          getModelValue: function getModelValue() {
            var t,
              e = this.model,
              n = this.target,
              i = e.get("name");
            if (e.get("changeProp")) t = n.get(i);else {
              var o = n.get("attributes");
              t = e.get("value") || o[i];
            }
            return Object(r.isUndefined)(t) ? "" : t;
          },
          getElInput: function getElInput() {
            return this.elInput;
          },
          renderField: function renderField() {
            var t = this.$el,
              e = this.appendInput,
              n = this.model,
              i = t.find("[data-input]"),
              o = i[i.length - 1],
              a = n.el;
            a || (a = this.createInput ? this.createInput(this.getClbOpts()) : this.getInputEl()), Object(r.isString)(a) ? (o.innerHTML = a, this.elInput = o.firstChild) : (e ? o.appendChild(a) : o.insertBefore(a, o.firstChild), this.elInput = a), n.el = this.elInput;
          },
          hasLabel: function hasLabel() {
            var t = this.model.attributes.label;
            return !this.noLabel && !1 !== t;
          },
          rerender: function rerender() {
            this.model.el = null, this.render();
          },
          postUpdate: function postUpdate() {
            this.onUpdate(this.getClbOpts());
          },
          render: function render() {
            var t = this.$el,
              e = this.pfx,
              n = this.ppfx,
              i = this.model.attributes.type,
              o = this.hasLabel && this.hasLabel(),
              a = "".concat(e, "trait");
            this.$input = null;
            var s = '<div class="'.concat(a, " ").concat(a, "--").concat(i, '">\n      ').concat(o ? '<div class="'.concat(n, 'label-wrp" data-label></div>') : "", '\n      <div class="').concat(n, "field-wrp ").concat(n, "field-wrp--").concat(i, '" data-input>\n        ').concat(this.templateInput ? Object(r.isFunction)(this.templateInput) ? this.templateInput(this.getClbOpts()) : this.templateInput : "", "\n      </div>\n    </div>");
            return t.empty().append(s), o && this.renderLabel(), this.renderField(), this.el.className = "".concat(a, "__wrp"), this.postUpdate(), this.onRender(this.getClbOpts()), this;
          }
        }),
        m = d.a.$,
        b = v.extend({
          init: function init() {
            this.listenTo(this.model, "change:options", this.rerender);
          },
          templateInput: function templateInput() {
            var t = this.ppfx,
              e = this.clsField;
            return '<div class="'.concat(e, '">\n      <div data-input></div>\n      <div class="').concat(t, 'sel-arrow">\n        <div class="').concat(t, 'd-s-arrow"></div>\n      </div>\n    </div>');
          },
          getInputEl: function getInputEl() {
            if (!this.$input) {
              var t = this.model,
                e = this.em,
                n = t.get("name"),
                i = t.get("options") || [],
                o = [],
                a = "<select>";
              i.forEach(function (t) {
                var i,
                  s,
                  c,
                  l = "";
                Object(r.isString)(t) ? (i = t, s = t) : (i = t.name || t.label || t.value, s = "".concat(Object(r.isUndefined)(t.value) ? t.id : t.value).replace(/"/g, "&quot;"), l += (c = t.style ? t.style.replace(/"/g, "&quot;") : "") ? ' style="'.concat(c, '"') : "");
                var u = e.t("traitManager.traits.options.".concat(n, ".").concat(s)) || i;
                a += '<option value="'.concat(s, '"').concat(l, ">").concat(u, "</option>"), o.push(s);
              }), a += "</select>", this.$input = m(a);
              var s = t.getTargetValue(),
                c = o.indexOf(s) >= 0 ? s : t.get("default");
              !Object(r.isUndefined)(c) && this.$input.val(c);
            }
            return this.$input.get(0);
          }
        }),
        y = v.extend({
          appendInput: 0,
          templateInput: function templateInput() {
            var t = this.ppfx,
              e = this.clsField;
            return '<label class="'.concat(e, '" data-input>\n    <i class="').concat(t, 'chk-icon"></i>\n  </label>');
          },
          onChange: function onChange() {
            var t = this.getInputElem().checked;
            this.model.set("value", this.getCheckedValue(t));
          },
          getCheckedValue: function getCheckedValue(t) {
            var e = t,
              n = this.model.attributes,
              i = n.valueTrue,
              o = n.valueFalse;
            return e && !Object(r.isUndefined)(i) && (e = i), e || Object(r.isUndefined)(o) || (e = o), e;
          },
          getInputEl: function getInputEl() {
            for (var t = !this.$input, e = arguments.length, n = new Array(e), i = 0; i < e; i++) n[i] = arguments[i];
            var o = v.prototype.getInputEl.apply(this, n);
            if (t) {
              var a,
                s,
                c = this.model,
                l = this.target,
                u = c.attributes,
                d = (u.valueTrue, u.valueFalse),
                h = c.get("name");
              c.get("changeProp") ? s = a = l.get(h) : a = !(!(s = l.get("attributes")[h]) && "" !== s), Object(r.isUndefined)(d) || s !== d || (a = !1), o.checked = a;
            }
            return o;
          }
        }),
        w = n(32),
        x = v.extend({
          getValueForTarget: function getValueForTarget() {
            var t = this.model.attributes,
              e = t.value,
              n = t.unit;
            return e ? e + n : "";
          },
          getInputEl: function getInputEl() {
            if (!this.input) {
              var t = this.getModelValue(),
                e = new w.a({
                  contClass: this.ppfx + "field-int",
                  model: this.model,
                  ppfx: this.ppfx
                });
              this.input = e.render(), this.$input = this.input.inputEl, this.$unit = this.input.unitEl, this.model.set("value", t), this.$input.val(t), this.input = e.el;
            }
            return this.input;
          }
        }),
        O = n(38),
        C = v.extend({
          templateInput: "",
          getInputEl: function getInputEl() {
            if (!this.input) {
              var t = this.model,
                e = this.getModelValue(),
                n = new O.a({
                  model: t,
                  target: this.config.em,
                  contClass: this.ppfx + "field-color",
                  ppfx: this.ppfx
                }).render();
              n.setValue(e, {
                fromTarget: 1
              }), this.input = n.el;
            }
            return this.input;
          }
        }),
        S = v.extend({
          events: {
            "click button": "handleClick"
          },
          templateInput: "",
          handleClick: function handleClick() {
            var t = this.model,
              e = this.em,
              n = t.get("command");
            n && (Object(r.isString)(n) ? e.get("Commands").run(n) : n(e.get("Editor"), t));
          },
          renderLabel: function renderLabel() {
            this.model.get("label") && v.prototype.renderLabel.apply(this, arguments);
          },
          getInputEl: function getInputEl() {
            var t = this.model,
              e = this.ppfx,
              n = t.props(),
              r = n.labelButton,
              i = n.text,
              o = n.full,
              a = r || i,
              s = "".concat(e, "btn");
            return '<button type="button" class="'.concat(s, "-prim").concat(o ? " ".concat(s, "--full") : "", '">').concat(a, "</button>");
          }
        }),
        k = o.a.extend({
          ns: "Traits",
          itemView: v,
          reuseView: 1,
          itemsView: {
            text: v,
            number: x,
            select: b,
            checkbox: y,
            color: C,
            button: S
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.config || {};
            this.config = e, this.em = t.editor, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.className = this.pfx + "traits";
            var n = "component:toggled";
            this.listenTo(this.em, n, this.updatedCollection), this.updatedCollection();
          },
          updatedCollection: function updatedCollection() {
            var t = this.ppfx,
              e = this.em.getSelected();
            this.el.className = "".concat(this.className, " ").concat(t, "one-bg ").concat(t, "two-color"), this.collection = e ? e.get("traits") : [], this.render();
          }
        });
      e.default = function () {
        var t,
          e = {};
        return {
          TraitsView: k,
          name: "TraitManager",
          getConfig: function getConfig() {
            return e;
          },
          init: function init() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            e = n, Object(r.defaults)(e, i);
            var o = e.pStylePrefix;
            return o && (e.stylePrefix = "".concat(o).concat(e.stylePrefix)), t = new k({
              collection: [],
              editor: e.em,
              config: e
            }), this;
          },
          postRender: function postRender() {
            var t = this.getConfig().appendTo;
            t && (Object(r.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
          },
          getTraitsViewer: function getTraitsViewer() {
            return t;
          },
          addType: function addType(e, n) {
            var r = t.itemView;
            t.itemsView[e] = r.extend(n);
          },
          getType: function getType(e) {
            return t.itemsView[e];
          },
          render: function render() {
            return t.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(0),
        a = {
          appendTo: "",
          appendOnClick: 0,
          appendOnDblClick: 0,
          blocks: []
        },
        s = n(1),
        c = n.n(s),
        l = c.a.Model.extend({
          defaults: {
            id: "",
            label: "",
            open: !0,
            attributes: {}
          }
        }),
        u = c.a.Model.extend({
          defaults: {
            activate: 0,
            select: 0,
            resetId: 0,
            label: "",
            disable: 0,
            media: "",
            content: "",
            category: "",
            attributes: {}
          },
          initialize: function initialize() {
            var t = this.get("category");
            t && "string" == typeof t && new l({
              id: t,
              label: t
            });
          }
        }),
        d = c.a.Collection.extend({
          model: u
        }),
        h = c.a.Collection.extend({
          model: l
        }),
        f = n(3),
        p = c.a.View.extend({
          events: {
            click: "handleClick",
            dblclick: "handleDblClick",
            mousedown: "startDrag",
            dragstart: "handleDragStart",
            drag: "handleDrag",
            dragend: "handleDragEnd"
          },
          initialize: function initialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.model;
            this.em = e.em, this.config = e, this.endDrag = this.endDrag.bind(this), this.ppfx = e.pStylePrefix || "", this.listenTo(n, "destroy remove", this.remove), this.listenTo(n, "change", this.render);
          },
          handleClick: function handleClick() {
            var t = this.config,
              e = this.model,
              n = this.em;
            if (t.appendOnClick) {
              var r,
                i = t.getSorter(),
                o = e.get("content"),
                a = n.getSelected();
              if (i.setDropContent(o), a) if (i.validTarget(a.getEl(), o).valid) r = a;else {
                var s = a.parent();
                i.validTarget(s.getEl(), o).valid && (r = s);
              }
              if (!r) {
                var c = n.getWrapper();
                i.validTarget(c.getEl(), o).valid && (r = c);
              }
              var l = r && r.append(o)[0];
              l && n.setSelected(l, {
                scroll: 1
              });
            }
          },
          handleDblClick: function handleDblClick() {
            var t = this.config,
              e = this.model,
              n = this.em;
            if (t.appendOnDblClick) {
              var r,
                i = t.getSorter(),
                o = e.get("content"),
                a = n.getSelected();
              if (i.setDropContent(o), a) {
                var s = a.parent();
                void 0 === s ? i.validTarget(a.getEl(), o).valid && (r = a) : i.validTarget(s.getEl(), o).valid && (r = s);
              }
              if (!r) {
                var c = n.getWrapper();
                i.validTarget(c.getEl(), o).valid && (r = c);
              }
              var l = r && r.append(o)[0];
              l && n.setSelected(l, {
                scroll: 1
              });
            }
          },
          startDrag: function startDrag(t) {
            var e = this.config,
              n = this.em,
              r = this.model.get("disable");
            if (0 === t.button && e.getSorter && !this.el.draggable && !r) {
              n.refreshCanvas();
              var i = e.getSorter();
              i.setDragHelper(this.el, t), i.setDropContent(this.model.get("content")), i.startSort(this.el), Object(f.u)(document, "mouseup", this.endDrag);
            }
          },
          handleDragStart: function handleDragStart(t) {
            var e = this.em,
              n = this.model,
              r = n.get("content"),
              i = Object(o.isObject)(r) ? JSON.stringify(r) : r;
            e.set("dragResult"), t.dataTransfer.setData("text", i), e.set("dragContent", r), e.trigger("block:drag:start", n, t);
          },
          handleDrag: function handleDrag(t) {
            this.em.trigger("block:drag", this.model, t);
          },
          handleDragEnd: function handleDragEnd() {
            var t = this.em,
              e = this.model,
              n = t.get("dragResult");
            if (n) {
              var r = n.get && n.get("activeOnRender");
              (e.get("activate") || r) && (n.trigger("active"), n.set("activeOnRender", 0)), e.get("select") && t.setSelected(n), e.get("resetId") && n.onAll(function (t) {
                return t.resetId();
              });
            }
            t.set({
              dragResult: null,
              dragContent: null
            }), t.trigger("block:drag:stop", n, e);
          },
          endDrag: function endDrag(t) {
            Object(f.t)(document, "mouseup", this.endDrag);
            var e = this.config.getSorter();
            e.moved = 0, e.endMove();
          },
          render: function render() {
            var t = this.em,
              e = this.el,
              n = this.$el,
              r = this.ppfx,
              i = this.model,
              o = i.get("disable"),
              a = i.get("attributes") || {},
              s = a.class || "",
              c = a.title || "",
              l = "".concat(r, "block"),
              u = t && t.t("blockManager.labels.".concat(i.id)) || i.get("label"),
              d = i.get("render"),
              h = i.get("media"),
              p = o ? "".concat(l, "--disable") : "".concat(r, "four-color-h");
            n.attr(a), e.className = "".concat(s, " ").concat(l, " ").concat(r, "one-bg ").concat(p).trim(), e.innerHTML = "\n      ".concat(h ? '<div class="'.concat(l, '__media">').concat(h, "</div>") : "", '\n      <div class="').concat(l, '-label">').concat(u, "</div>\n    "), e.title = e.textContent.trim().startsWith(".") ? c : e.textContent.trim(), e.setAttribute("draggable", !(!Object(f.k)(t) || o));
            var g = d && d({
              el: e,
              model: i,
              className: l,
              prefix: r
            });
            return g && (e.innerHTML = g), this;
          }
        }),
        g = c.a.View.extend({
          template: Object(o.template)('\n  <div class="<%= pfx %>title">\n    <i class="<%= pfx %>caret-icon"></i>\n    <%= label %>\n  </div>\n  <div class="<%= pfx %>blocks-c"></div>\n  '),
          events: {},
          initialize: function initialize() {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.config = t;
            var e = t.pStylePrefix || "";
            this.em = t.em, this.pfx = e, this.caretR = "fa fa-caret-right", this.caretD = "fa fa-caret-down", this.iconClass = "".concat(e, "caret-icon"), this.activeClass = "".concat(e, "open"), this.className = "".concat(e, "block-category"), this.events["click .".concat(e, "title")] = "toggle", this.listenTo(this.model, "change:open", this.updateVisibility), this.delegateEvents();
          },
          updateVisibility: function updateVisibility() {
            this.model.get("open") ? this.open() : this.close();
          },
          open: function open() {
            this.el.className = "".concat(this.className, " ").concat(this.activeClass), this.getIconEl().className = "".concat(this.iconClass, " ").concat(this.caretD), this.getBlocksEl().style.display = "";
          },
          close: function close() {
            this.el.className = this.className, this.getIconEl().className = "".concat(this.iconClass, " ").concat(this.caretR), this.getBlocksEl().style.display = "none";
          },
          toggle: function toggle() {
            var t = this.model;
            t.set("open", !t.get("open"));
          },
          getIconEl: function getIconEl() {
            return this.iconEl || (this.iconEl = this.el.querySelector("." + this.iconClass)), this.iconEl;
          },
          getBlocksEl: function getBlocksEl() {
            return this.blocksEl || (this.blocksEl = this.el.querySelector("." + this.pfx + "blocks-c")), this.blocksEl;
          },
          append: function append(t) {
            this.getBlocksEl().appendChild(t);
          },
          render: function render() {
            var t = this.em,
              e = this.el,
              n = this.$el,
              r = this.model,
              i = t.t("blockManager.categories.".concat(r.id)) || r.get("label");
            return e.innerHTML = this.template({
              pfx: this.pfx,
              label: i
            }), e.className = this.className, n.css({
              order: r.get("order")
            }), this.updateVisibility(), this;
          }
        });
      function v(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function m(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? v(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var b = c.a.View.extend({
        initialize: function initialize(t, e) {
          Object(o.bindAll)(this, "getSorter", "onDrag", "onDrop"), this.config = e || {}, this.categories = t.categories || "", this.renderedCategories = [];
          var n = this.config.pStylePrefix || "";
          this.ppfx = n, this.noCatClass = "".concat(n, "blocks-no-cat"), this.blockContClass = "".concat(n, "blocks-c"), this.catsClass = "".concat(n, "block-categories");
          var r = this.collection;
          this.listenTo(r, "add", this.addTo), this.listenTo(r, "reset", this.render), this.em = this.config.em, this.tac = "test-tac", this.grabbingCls = this.ppfx + "grabbing", this.em && (this.config.getSorter = this.getSorter, this.canvas = this.em.get("Canvas"));
        },
        updateConfig: function updateConfig() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.config = m(m({}, this.config), t);
        },
        getSorter: function getSorter() {
          if (this.em) {
            if (!this.sorter) {
              var t = this.em.get("Utils"),
                e = this.canvas;
              this.sorter = new t.Sorter({
                container: e.getBody(),
                placer: e.getPlacerEl(),
                containerSel: "*",
                itemSel: "*",
                pfx: this.ppfx,
                onStart: this.onDrag,
                onEndMove: this.onDrop,
                onMove: this.onMove,
                document: e.getFrameEl().contentDocument,
                direction: "a",
                wmargin: 1,
                nested: 1,
                em: this.em,
                canvasRelative: 1
              });
            }
            return this.sorter;
          }
        },
        onDrag: function onDrag(t) {
          this.em.stopDefault(), this.em.trigger("block:drag:start", t);
        },
        onMove: function onMove(t) {
          this.em.trigger("block:drag:move", t);
        },
        onDrop: function onDrop(t) {
          var e = this.em;
          e.runDefault(), t && t.get && (t.get("activeOnRender") && (t.trigger("active"), t.set("activeOnRender", 0)), e.trigger("block:drag:stop", t));
        },
        addTo: function addTo(t) {
          this.add(t);
        },
        add: function add(t, e) {
          var n = this.config,
            r = e || null,
            i = new p({
              model: t,
              attributes: t.get("attributes")
            }, n).render().el,
            a = t.get("category");
          if (a && this.categories && !n.ignoreCategories) {
            Object(o.isString)(a) ? a = {
              id: a,
              label: a
            } : Object(o.isObject)(a) && !a.id && (a.id = a.label);
            var s = this.categories.add(a),
              c = s.get("id"),
              l = this.renderedCategories[c],
              u = this.getCategoriesEl();
            return t.set("category", s), !l && u && (l = new g({
              model: s
            }, this.config).render(), this.renderedCategories[c] = l, u.appendChild(l.el)), void (l && l.append(i));
          }
          r ? r.appendChild(i) : this.append(i);
        },
        getCategoriesEl: function getCategoriesEl() {
          return this.catsEl || (this.catsEl = this.el.querySelector(".".concat(this.catsClass))), this.catsEl;
        },
        getBlocksEl: function getBlocksEl() {
          return this.blocksEl || (this.blocksEl = this.el.querySelector(".".concat(this.noCatClass, " .").concat(this.blockContClass))), this.blocksEl;
        },
        append: function append(t) {
          var e = this.getBlocksEl();
          e && e.appendChild(t);
        },
        render: function render() {
          var t = this,
            e = this.ppfx,
            n = document.createDocumentFragment();
          this.catsEl = null, this.blocksEl = null, this.renderedCategories = [], this.el.innerHTML = '\n      <div class="'.concat(this.catsClass, '"></div>\n      <div class="').concat(this.noCatClass, '">\n        <div class="').concat(this.blockContClass, '"></div>\n      </div>\n    '), this.collection.each(function (e) {
            return t.add(e, n);
          }), this.append(n);
          var r = "".concat(this.blockContClass, "s ").concat(e, "one-bg ").concat(e, "two-color");
          return this.$el.addClass(r), this;
        }
      });
      function y(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function w(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? y(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          r = {},
          i = [];
        return {
          name: "BlockManager",
          init: function init(n) {
            var o = (r = n || {}).em;
            for (var s in a) s in r || (r[s] = a[s]);
            return t = new d([]), e = new d([]), i = new h(), t.listenTo(t, "add", function (t) {
              e.add(t), o && o.trigger("block:add", t);
            }), t.listenTo(t, "remove", function (t) {
              e.remove(t), o && o.trigger("block:remove", t);
            }), t.listenTo(t, "reset", function (t) {
              e.reset(t.models);
            }), this;
          },
          getConfig: function getConfig() {
            return r;
          },
          onLoad: function onLoad() {
            var t = this.getAll();
            !t.length && t.reset(r.blocks);
          },
          postRender: function postRender() {
            n = new b({
              collection: e,
              categories: i
            }, r);
            var t = this.getConfig().appendTo;
            t && (Object(o.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render(e.models));
          },
          add: function add(e, n) {
            var r = n || {};
            return r.id = e, t.add(r);
          },
          get: function get(e) {
            return t.get(e);
          },
          getAll: function getAll() {
            return t;
          },
          getAllVisible: function getAllVisible() {
            return e;
          },
          remove: function remove(e) {
            return t.remove(e);
          },
          getCategories: function getCategories() {
            return i;
          },
          getContainer: function getContainer() {
            return n.el;
          },
          render: function render(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = t || this.getAll().models;
            if (e.external) {
              var a = new d(o);
              return new b({
                collection: a,
                categories: i
              }, w(w({}, r), e)).render().el;
            }
            return n && (n.updateConfig(e), n.collection.reset(o), n.rendered || (n.render(), n.rendered = 1)), this.getContainer();
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = "sw-visibility",
        i = "open-layers",
        o = {
          stylePrefix: "pn-",
          defaults: [{
            id: "commands",
            buttons: [{}]
          }, {
            id: "devices-c",
            buttons: [{
              active: !0,
              id: "set-device-desktop",
              className: "fa fa-desktop",
              command: "set-device-desktop",
              attributes: {
                title: "Desktop"
              }
            }, {
              id: "set-device-tablet",
              className: "fa fa-tablet",
              command: "set-device-tablet",
              attributes: {
                title: "Tablet"
              }
            }, {
              id: "set-device-mobile-ptr",
              className: "fa fa-mobile",
              command: "set-device-mobile-ptr",
              attributes: {
                title: "Mobile"
              }
            }, {
              id: "set-device-mobile",
              className: "fa fa-mobile",
              command: "set-device-mobile",
              attributes: {
                title: "Mobile Landscape"
              }
            }, {
              id: "versions",
              className: "fa fa-code-fork",
              command: "switch-version",
              attributes: {
                title: "Switch Version"
              }
            }, {
              id: "shortcut",
              className: "fa fa-search",
              command: "shortcut",
              attributes: {
                title: "Shortcut"
              }
            }, {
              id: "custom-open-blocks",
              className: "fa fa-plus-circle btn btn-theme-primary--light btn-xs",
              command: "custom-open-blocks",
              togglable: 1,
              attributes: {
                title: "Add Components",
                id: "add-components"
              }
            }]
          }, {
            id: "options",
            buttons: [{
              active: !0,
              id: r,
              className: "fa fa-square-o",
              command: r,
              context: r,
              attributes: {
                title: "View components"
              }
            }, {
              id: "preview",
              className: "fa fa-eye",
              command: "custom-preview",
              context: "preview",
              attributes: {
                title: "Preview"
              }
            }, {
              id: "build",
              className: "fa fa-paper-plane-o",
              command: "custom-build",
              context: "build",
              attributes: {
                title: "Production"
              }
            }, {
              id: "code-editor",
              className: "wb webconnect-layout-text-sidebar-reverse",
              command: "code-editor-open",
              attributes: {
                title: "View Code"
              }
            }, {
              id: "undo",
              className: "fa fa-undo",
              command: function command(t) {
                return t.runCommand("core:undo");
              }
            }, {
              id: "redo",
              className: "fa fa-repeat",
              command: function command(t) {
                return t.runCommand("core:redo");
              }
            }, {
              id: "save-db",
              className: "fa fa-save btn-save",
              command: "save-db",
              context: "save-db",
              attributes: {
                title: "Save"
              }
            }, {
              id: "cmd-clear",
              className: "fa fa-trash",
              command: "cmd-clear",
              context: "cmd-clear",
              attributes: {
                title: "Clear"
              }
            }]
          }, {
            id: "views",
            buttons: [{
              id: "open-sm",
              className: "fa fa-paint-brush",
              command: "open-sm",
              active: !0,
              togglable: 0,
              attributes: {
                title: "Open Style Manager"
              }
            }, {
              id: "open-tm",
              className: "fa fa-cog",
              command: "open-tm",
              togglable: 0,
              attributes: {
                title: "Settings"
              }
            }, {
              id: i,
              className: "fa fa-bars",
              command: i,
              togglable: 0,
              attributes: {
                title: "Open Layer Manager"
              }
            }]
          }],
          em: null,
          delayBtnsShow: 300
        },
        a = n(1),
        s = n.n(a),
        c = n(41),
        l = s.a.Model.extend({
          defaults: {
            id: "",
            content: "",
            visible: !0,
            buttons: [],
            attributes: {}
          },
          initialize: function initialize(t) {
            this.btn = this.get("buttons") || [], this.buttons = new c.default(this.btn), this.set("buttons", this.buttons);
          }
        }),
        u = s.a.Collection.extend({
          model: l
        }),
        d = n(2),
        h = n.n(d),
        f = n(0);
      function p(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function g(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? p(Object(n), !0).forEach(function (e) {
            h()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      s.a.$;
      var v = s.a.View.extend({
          tagName: function tagName() {
            return this.model.get("tagName");
          },
          events: {
            click: "clicked"
          },
          initialize: function initialize(t) {
            var e = this.model.get("className");
            this.config = t.config || {}, this.em = this.config.em || {};
            var n = this.config.stylePrefix || "",
              r = this.config.pStylePrefix || "";
            this.pfx = n, this.ppfx = this.config.pStylePrefix || "", this.id = n + this.model.get("id"), this.activeCls = "".concat(n, "active ").concat(r, "four-color"), this.disableCls = "".concat(r, "disabled"), this.btnsVisCls = "".concat(n, "visible"), this.className = n + "btn" + (e ? " " + e : ""), this.listenTo(this.model, "change", this.render), this.listenTo(this.model, "change:active updateActive", this.updateActive), this.listenTo(this.model, "checkActive", this.checkActive), this.listenTo(this.model, "change:bntsVis", this.updateBtnsVis), this.listenTo(this.model, "change:attributes", this.updateAttributes), this.listenTo(this.model, "change:className", this.updateClassName), this.listenTo(this.model, "change:disable", this.updateDisable), this.em && this.em.get && (this.commands = this.em.get("Commands"));
          },
          updateClassName: function updateClassName() {
            var t = this.model,
              e = this.pfx,
              n = t.get("className"),
              r = t.get("attributes").class,
              i = "".concat(r || "", " ").concat(e, "btn ").concat(n || "");
            this.$el.attr("class", i.trim());
          },
          updateAttributes: function updateAttributes() {
            var t = this.em,
              e = this.model,
              n = this.$el,
              r = e.get("attributes") || {},
              i = t && t.t && t.t("panels.buttons.titles.".concat(e.id));
            n.attr(r), i && n.attr({
              title: i
            }), this.updateClassName();
          },
          updateBtnsVis: function updateBtnsVis() {
            this.$buttons && (this.model.get("bntsVis") ? this.$buttons.addClass(this.btnsVisCls) : this.$buttons.removeClass(this.btnsVisCls));
          },
          updateActive: function updateActive() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = this.model,
              n = this.commands,
              r = this.$el,
              i = this.activeCls,
              o = t.fromCollection,
              a = e.get("context"),
              s = e.get("options"),
              c = e.get("command"),
              l = {};
            n && Object(f.isString)(c) ? l = n.get(c) || {} : Object(f.isFunction)(c) ? l = n.create({
              run: c
            }) : null !== c && Object(f.isObject)(c) && (l = n.create(c)), e.get("active") ? (!o && e.collection.deactivateAll(a, e), e.set("active", !0, {
              silent: !0
            }).trigger("checkActive"), n.runCommand(l, g(g({}, s), {}, {
              sender: e
            })), l.noStop && e.set("active", !1)) : (r.removeClass(i), n.stopCommand(l, g(g({}, s), {}, {
              sender: e,
              force: 1
            })));
          },
          updateDisable: function updateDisable() {
            var t = this.disableCls,
              e = this.model.get("disable");
            this.$el[e ? "addClass" : "removeClass"](t);
          },
          checkActive: function checkActive() {
            var t = this.model,
              e = this.$el,
              n = this.activeCls;
            t.get("active") ? e.addClass(n) : e.removeClass(n);
          },
          clicked: function clicked(t) {
            this.model.get("bntsVis") || this.model.get("disable") || this.toggleActive();
          },
          toggleActive: function toggleActive() {
            var t = this.model,
              e = t.attributes,
              n = e.active,
              r = e.togglable;
            n && !r || (t.set("active", !n), this.em.get("Commands").get("select-comp"), n ? t.get("runDefaultCommand") && this.em.runDefault() : t.get("stopDefaultCommand") && this.em.stopDefault());
          },
          render: function render() {
            var t = this.model.get("label"),
              e = this.$el;
            return e.empty(), this.updateAttributes(), t && e.append(t), this.checkActive(), this.updateDisable(), this;
          }
        }),
        m = s.a.View.extend({
          initialize: function initialize(t) {
            this.opt = t || {}, this.config = this.opt.config || {}, this.pfx = this.config.stylePrefix || "", this.parentM = this.opt.parentM || null, this.listenTo(this.collection, "add", this.addTo), this.listenTo(this.collection, "reset remove", this.render), this.className = this.pfx + "buttons";
          },
          addTo: function addTo(t) {
            this.addToCollection(t);
          },
          addToCollection: function addToCollection(t, e) {
            var n = e || null,
              r = new v({
                model: t,
                config: this.config,
                parentM: this.parentM
              }).render().el;
            return n ? n.appendChild(r) : this.$el.append(r), r;
          },
          render: function render() {
            var t = document.createDocumentFragment();
            return this.$el.empty(), this.collection.each(function (e) {
              this.addToCollection(e, t);
            }, this), this.$el.append(t), this.$el.attr("class", Object(f.result)(this, "className")), this;
          }
        });
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      var y = s.a.View.extend({
          initialize: function initialize(t) {
            var e = t.config || {},
              n = this.model;
            this.config = e, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.buttons = n.get("buttons"), this.className = this.pfx + "panel", this.id = this.pfx + n.get("id"), this.listenTo(n, "change:appendContent", this.appendContent), this.listenTo(n, "change:content", this.updateContent), this.listenTo(n, "change:visible", this.toggleVisible), n.view = this;
          },
          appendContent: function appendContent() {
            this.$el.append(this.model.get("appendContent"));
          },
          updateContent: function updateContent() {
            this.$el.html(this.model.get("content"));
          },
          toggleVisible: function toggleVisible() {
            this.model.get("visible") ? this.$el.removeClass("".concat(this.ppfx, "hidden")) : this.$el.addClass("".concat(this.ppfx, "hidden"));
          },
          attributes: function attributes() {
            return this.model.get("attributes");
          },
          initResize: function initResize() {
            var t = this.config.em,
              e = t ? t.get("Editor") : "",
              n = this.model.get("resizable");
            if (e && n) {
              var r,
                i,
                o,
                a = !0 === n ? [1, 1, 1, 1] : n,
                s = a.length,
                c = 0;
              2 == s ? (r = a[0], o = a[0], i = a[1], c = a[1]) : 4 == s && (r = a[0], i = a[1], o = a[2], c = a[3]);
              var l = e.Utils.Resizer.init(function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var n = null != arguments[e] ? arguments[e] : {};
                  e % 2 ? b(Object(n), !0).forEach(function (e) {
                    h()(t, e, n[e]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                  });
                }
                return t;
              }({
                tc: r,
                cr: i,
                bc: o,
                cl: c,
                tl: 0,
                tr: 0,
                bl: 0,
                br: 0,
                appendTo: this.el,
                silentFrames: 1,
                avoidContainerUpdate: 1,
                prefix: e.getConfig().stylePrefix,
                onEnd: function onEnd() {
                  t && t.trigger("change:canvasOffset");
                },
                posFetcher: function posFetcher(t, e) {
                  var n = e.target,
                    r = t.style,
                    i = l.getConfig(),
                    o = i.keyWidth,
                    a = i.keyHeight,
                    s = t.getBoundingClientRect(),
                    c = "container" == n,
                    u = r[o],
                    d = r[a];
                  return {
                    left: 0,
                    top: 0,
                    width: u && !c ? parseFloat(u) : s.width,
                    height: d && !c ? parseFloat(d) : s.height
                  };
                }
              }, n));
              l.blur = function () {}, l.focus(this.el);
            }
          },
          render: function render() {
            var t = this.$el,
              e = this.ppfx,
              n = "".concat(this.className, " ").concat(this.id, " ").concat(e, "one-bg ").concat(e, "two-color");
            if (t.addClass(n), this.buttons.length) {
              var r = new m({
                collection: this.buttons,
                config: this.config
              });
              t.append(r.render().el);
            }
            return t.append(this.model.get("content")), this;
          }
        }),
        w = s.a.View.extend({
          initialize: function initialize(t) {
            this.opt = t || {}, this.config = this.opt.config || {}, this.pfx = this.config.stylePrefix || "";
            var e = this.collection;
            this.listenTo(e, "add", this.addTo), this.listenTo(e, "reset", this.render), this.listenTo(e, "remove", this.onRemove), this.className = this.pfx + "panels";
          },
          onRemove: function onRemove(t) {
            var e = t.view;
            e && e.remove();
          },
          addTo: function addTo(t) {
            this.addToCollection(t);
          },
          addToCollection: function addToCollection(t, e) {
            var n = e || null,
              r = this.config,
              i = t.get("el"),
              o = new y({
                el: i,
                model: t,
                config: r
              }),
              a = o.render().el,
              s = t.get("appendTo");
            return i || (s ? document.querySelector(s).appendChild(a) : n ? n.appendChild(a) : this.$el.append(a)), o.initResize(), a;
          },
          render: function render() {
            var t = this,
              e = this.$el,
              n = document.createDocumentFragment();
            return e.empty(), this.collection.each(function (e) {
              return t.addToCollection(e, n);
            }), e.append(n), e.attr("class", this.className), this;
          }
        });
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          name: "Panels",
          init: function init(r) {
            for (var i in n = r || {}, o) i in n || (n[i] = o[i]);
            var a = n.pStylePrefix;
            return a && (n.stylePrefix = a + n.stylePrefix), t = new u(n.defaults), e = new w({
              collection: t,
              config: n
            }), this;
          },
          getPanels: function getPanels() {
            return t;
          },
          getPanelsEl: function getPanelsEl() {
            return e.el;
          },
          addPanel: function addPanel(e) {
            return t.add(e);
          },
          removePanel: function removePanel(e) {
            return t.remove(e);
          },
          getPanel: function getPanel(e) {
            var n = t.where({
              id: e
            });
            return n.length ? n[0] : null;
          },
          addButton: function addButton(t, e) {
            var n = this.getPanel(t);
            return n ? n.get("buttons").add(e) : null;
          },
          removeButton: function removeButton(t, e) {
            var n = this.getPanel(t);
            return n && n.get("buttons").remove(e);
          },
          getButton: function getButton(t, e) {
            var n = this.getPanel(t);
            if (n) {
              var r = n.get("buttons").where({
                id: e
              });
              return r.length ? r[0] : null;
            }
            return null;
          },
          render: function render() {
            return e.render().el;
          },
          active: function active() {
            this.getPanels().each(function (t) {
              t.get("buttons").each(function (t) {
                t.get("active") && t.trigger("updateActive");
              });
            });
          },
          disableButtons: function disableButtons() {
            this.getPanels().each(function (t) {
              t.get("buttons").each(function (t) {
                t.get("disable") && t.trigger("change:disable");
              });
            });
          },
          Panel: l
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(0),
        a = {
          stylePrefix: "sm-",
          sectors: [],
          appendTo: "",
          hideNotStylable: !0,
          highlightChanged: !0,
          highlightComputed: !0,
          showComputed: !0,
          clearProperties: 0,
          avoidComputed: ["width", "height"]
        },
        s = n(1),
        c = n.n(s),
        l = n(24),
        u = function u() {
          return {
            build: function build(t) {
              var e = [];
              "string" == typeof t && (t = [t]);
              for (var n = 0, r = t.length; n < r; n++) {
                var i = {},
                  o = t[n];
                switch (i.property = o, o) {
                  case "border-radius-c":
                    i.property = "border-radius";
                }
                switch (o) {
                  case "top":
                  case "right":
                  case "bottom":
                  case "left":
                  case "margin-top":
                  case "margin-right":
                  case "margin-bottom":
                  case "margin-left":
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "width":
                  case "max-width":
                  case "min-width":
                  case "height":
                  case "max-height":
                  case "min-height":
                  case "flex-basis":
                    i.fixedValues = ["initial", "inherit", "auto", "min-content", "max-content"];
                    break;
                  case "font-size":
                    i.fixedValues = ["medium", "xx-small", "x-small", "small", "large", "x-large", "xx-large", "smaller", "larger", "length", "initial", "inherit"];
                    break;
                  case "letter-spacing":
                  case "line-height":
                    i.fixedValues = ["normal", "initial", "inherit"];
                }
                switch (o) {
                  case "float":
                  case "position":
                  case "text-align":
                    i.type = "radio";
                    break;
                  case "display":
                  case "flex-direction":
                  case "flex-wrap":
                  case "justify-content":
                  case "align-items":
                  case "align-content":
                  case "align-self":
                  case "font-family":
                  case "font-weight":
                  case "border-style":
                  case "box-shadow-type":
                  case "background-repeat":
                  case "background-position":
                  case "background-attachment":
                  case "background-size":
                  case "transition-property":
                  case "transition-timing-function":
                  case "cursor":
                  case "overflow":
                  case "overflow-x":
                  case "overflow-y":
                    i.type = "select";
                    break;
                  case "top":
                  case "right":
                  case "bottom":
                  case "left":
                  case "margin-top":
                  case "margin-right":
                  case "margin-bottom":
                  case "margin-left":
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "min-height":
                  case "min-width":
                  case "max-height":
                  case "max-width":
                  case "width":
                  case "height":
                  case "font-size":
                  case "letter-spacing":
                  case "line-height":
                  case "text-shadow-h":
                  case "text-shadow-v":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                  case "border-width":
                  case "box-shadow-h":
                  case "box-shadow-v":
                  case "box-shadow-blur":
                  case "box-shadow-spread":
                  case "transition-duration":
                  case "perspective":
                  case "transform-rotate-x":
                  case "transform-rotate-y":
                  case "transform-rotate-z":
                  case "transform-scale-x":
                  case "transform-scale-y":
                  case "transform-scale-z":
                  case "order":
                  case "flex-grow":
                  case "flex-shrink":
                  case "flex-basis":
                    i.type = "integer";
                    break;
                  case "margin":
                  case "padding":
                  case "border-radius":
                  case "border":
                  case "transform":
                    i.type = "composite";
                    break;
                  case "color":
                  case "text-shadow-color":
                  case "background-color":
                  case "border-color":
                  case "box-shadow-color":
                    i.type = "color";
                    break;
                  case "text-shadow":
                  case "box-shadow":
                  case "background":
                  case "transition":
                    i.type = "stack";
                    break;
                  case "background-image":
                    i.type = "file";
                }
                switch (o) {
                  case "float":
                  case "background-color":
                  case "text-shadow":
                    i.defaults = "none";
                    break;
                  case "display":
                    i.defaults = "block";
                    break;
                  case "flex-direction":
                    i.defaults = "row";
                    break;
                  case "flex-wrap":
                    i.defaults = "nowrap";
                    break;
                  case "justify-content":
                    i.defaults = "flex-start";
                    break;
                  case "align-items":
                  case "align-content":
                    i.defaults = "stretch";
                    break;
                  case "align-self":
                    i.defaults = "auto";
                    break;
                  case "position":
                    i.defaults = "static";
                    break;
                  case "margin-top":
                  case "margin-right":
                  case "margin-bottom":
                  case "margin-left":
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "text-shadow-h":
                  case "text-shadow-v":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "box-shadow-h":
                  case "box-shadow-v":
                  case "box-shadow-spread":
                  case "perspective":
                  case "transform-rotate-x":
                  case "transform-rotate-y":
                  case "transform-rotate-z":
                  case "order":
                  case "flex-grow":
                    i.defaults = 0;
                    break;
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                    i.defaults = "0px";
                    break;
                  case "transform-scale-x":
                  case "transform-scale-y":
                  case "transform-scale-z":
                  case "flex-shrink":
                    i.defaults = 1;
                    break;
                  case "box-shadow-blur":
                    i.defaults = "5px";
                    break;
                  case "top":
                  case "right":
                  case "bottom":
                  case "left":
                  case "min-height":
                  case "min-width":
                  case "max-height":
                  case "max-width":
                  case "width":
                  case "height":
                  case "background-size":
                  case "cursor":
                  case "flex-basis":
                    i.defaults = "auto";
                    break;
                  case "font-family":
                    i.defaults = "Arial, Helvetica, sans-serif";
                    break;
                  case "font-size":
                  case "border-width":
                    i.defaults = "medium";
                    break;
                  case "font-weight":
                    i.defaults = "400";
                    break;
                  case "letter-spacing":
                  case "line-height":
                    i.defaults = "normal";
                    break;
                  case "color":
                  case "text-shadow-color":
                  case "border-color":
                  case "box-shadow-color":
                    i.defaults = "black";
                    break;
                  case "text-align":
                    i.defaults = "left";
                    break;
                  case "border-style":
                    i.defaults = "solid";
                    break;
                  case "box-shadow-type":
                    i.defaults = "";
                    break;
                  case "background-repeat":
                    i.defaults = "repeat";
                    break;
                  case "background-position":
                    i.defaults = "left top";
                    break;
                  case "background-attachment":
                    i.defaults = "scroll";
                    break;
                  case "transition-property":
                    i.defaults = "width";
                    break;
                  case "transition-duration":
                    i.defaults = "2";
                    break;
                  case "transition-timing-function":
                    i.defaults = "ease";
                    break;
                  case "overflow":
                  case "overflow-x":
                  case "overflow-y":
                    i.defaults = "visible";
                }
                switch (o) {
                  case "flex-direction":
                  case "flex-wrap":
                  case "justify-content":
                  case "align-items":
                  case "align-content":
                    i.requires = {
                      display: ["flex"]
                    };
                    break;
                  case "order":
                  case "flex-basis":
                  case "flex-grow":
                  case "flex-shrink":
                  case "align-self":
                    i.requiresParent = {
                      display: ["flex"]
                    };
                }
                switch (o) {
                  case "top":
                  case "bottom":
                  case "margin-top":
                  case "margin-bottom":
                  case "padding-top":
                  case "padding-bottom":
                  case "min-height":
                  case "max-height":
                  case "height":
                    i.units = ["px", "%", "vh", "em", "rem"];
                    break;
                  case "right":
                  case "left":
                  case "margin-right":
                  case "margin-left":
                  case "padding-right":
                  case "padding-left":
                  case "min-width":
                  case "max-width":
                  case "width":
                    i.units = ["px", "%", "vw", "em", "rem"];
                    break;
                  case "flex-basis":
                    i.units = ["px", "%", "vw", "vh"];
                    break;
                  case "text-shadow-v":
                  case "text-shadow-h":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                  case "box-shadow-h":
                  case "box-shadow-v":
                    i.units = ["px", "%"];
                    break;
                  case "font-size":
                  case "letter-spacing":
                  case "line-height":
                    i.units = ["px", "em", "rem", "%", "vw", "vh"];
                    break;
                  case "border-width":
                    i.units = ["px", "em"];
                    break;
                  case "box-shadow-blur":
                  case "box-shadow-spread":
                  case "perspective":
                    i.units = ["px"];
                    break;
                  case "transition-duration":
                    i.units = ["s"];
                    break;
                  case "transform-rotate-x":
                  case "transform-rotate-y":
                  case "transform-rotate-z":
                    i.units = ["deg"];
                }
                switch (o) {
                  case "padding-top":
                  case "padding-right":
                  case "padding-bottom":
                  case "padding-left":
                  case "min-height":
                  case "min-width":
                  case "max-height":
                  case "max-width":
                  case "width":
                  case "height":
                  case "font-size":
                  case "text-shadow-blur":
                  case "border-radius-c":
                  case "border-top-left-radius":
                  case "border-top-right-radius":
                  case "border-bottom-left-radius":
                  case "border-bottom-right-radius":
                  case "border-width":
                  case "box-shadow-blur":
                  case "transition-duration":
                  case "perspective":
                  case "flex-basis":
                    i.min = 0;
                }
                switch (o) {
                  case "text-shadow":
                  case "box-shadow":
                  case "background":
                    i.preview = !0;
                }
                switch (o) {
                  case "background":
                    i.detached = !0;
                }
                switch (o) {
                  case "transform-rotate-x":
                    i.functionName = "rotateX";
                    break;
                  case "transform-rotate-y":
                    i.functionName = "rotateY";
                    break;
                  case "transform-rotate-z":
                    i.functionName = "rotateZ";
                    break;
                  case "transform-scale-x":
                    i.functionName = "scaleX";
                    break;
                  case "transform-scale-y":
                    i.functionName = "scaleY";
                    break;
                  case "transform-scale-z":
                    i.functionName = "scaleZ";
                    break;
                  case "background-image":
                    i.functionName = "url";
                }
                switch (o) {
                  case "float":
                    i.list = [{
                      value: "none"
                    }, {
                      value: "left"
                    }, {
                      value: "right"
                    }];
                    break;
                  case "display":
                    i.list = [{
                      value: "block"
                    }, {
                      value: "inline"
                    }, {
                      value: "inline-block"
                    }, {
                      value: "flex"
                    }, {
                      value: "none"
                    }];
                    break;
                  case "flex-direction":
                    i.list = [{
                      value: "row"
                    }, {
                      value: "row-reverse"
                    }, {
                      value: "column"
                    }, {
                      value: "column-reverse"
                    }];
                    break;
                  case "flex-wrap":
                    i.list = [{
                      value: "nowrap"
                    }, {
                      value: "wrap"
                    }, {
                      value: "wrap-reverse"
                    }];
                    break;
                  case "justify-content":
                    i.list = [{
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "space-between"
                    }, {
                      value: "space-around"
                    }, {
                      value: "space-evenly"
                    }];
                    break;
                  case "align-items":
                    i.list = [{
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "baseline"
                    }, {
                      value: "stretch"
                    }];
                    break;
                  case "align-content":
                    i.list = [{
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "space-between"
                    }, {
                      value: "space-around"
                    }, {
                      value: "stretch"
                    }];
                    break;
                  case "align-self":
                    i.list = [{
                      value: "auto"
                    }, {
                      value: "flex-start"
                    }, {
                      value: "flex-end"
                    }, {
                      value: "center"
                    }, {
                      value: "baseline"
                    }, {
                      value: "stretch"
                    }];
                    break;
                  case "position":
                    i.list = [{
                      value: "static"
                    }, {
                      value: "relative"
                    }, {
                      value: "absolute"
                    }, {
                      value: "fixed"
                    }, {
                      value: "sticky"
                    }];
                    break;
                  case "font-family":
                    var a = ", sans-serif",
                      s = ["Arial, Helvetica" + a, "Arial Black, Gadget" + a, "Brush Script MT" + a, "Comic Sans MS, cursive" + a, "Courier New, Courier, monospace", "Georgia, serif", "Helvetica" + a, "Impact, Charcoal" + a, "Lucida Sans Unicode, Lucida Grande" + a, "Tahoma, Geneva" + a, "Times New Roman, Times, serif", "Trebuchet MS, Helvetica" + a, "Verdana, Geneva" + a];
                    i.list = [];
                    for (var c = 0, l = s.length; c < l; c++) {
                      var u = {};
                      u.value = s[c], u.name = s[c].split(",")[0], i.list.push(u);
                    }
                    break;
                  case "font-weight":
                    i.list = [{
                      value: "100",
                      name: "Thin"
                    }, {
                      value: "200",
                      name: "Extra-Light"
                    }, {
                      value: "300",
                      name: "Light"
                    }, {
                      value: "400",
                      name: "Normal"
                    }, {
                      value: "500",
                      name: "Medium"
                    }, {
                      value: "600",
                      name: "Semi-Bold"
                    }, {
                      value: "700",
                      name: "Bold"
                    }, {
                      value: "800",
                      name: "Extra-Bold"
                    }, {
                      value: "900",
                      name: "Ultra-Bold"
                    }];
                    break;
                  case "text-align":
                    i.list = [{
                      value: "left"
                    }, {
                      value: "center"
                    }, {
                      value: "right"
                    }, {
                      value: "justify"
                    }];
                    break;
                  case "border-style":
                    i.list = [{
                      value: "none"
                    }, {
                      value: "solid"
                    }, {
                      value: "dotted"
                    }, {
                      value: "dashed"
                    }, {
                      value: "double"
                    }, {
                      value: "groove"
                    }, {
                      value: "ridge"
                    }, {
                      value: "inset"
                    }, {
                      value: "outset"
                    }];
                    break;
                  case "box-shadow-type":
                    i.list = [{
                      value: "",
                      name: "Outside"
                    }, {
                      value: "inset",
                      name: "Inside"
                    }];
                    break;
                  case "background-repeat":
                    i.list = [{
                      value: "repeat"
                    }, {
                      value: "repeat-x"
                    }, {
                      value: "repeat-y"
                    }, {
                      value: "no-repeat"
                    }];
                    break;
                  case "background-position":
                    i.list = [{
                      value: "left top"
                    }, {
                      value: "left center"
                    }, {
                      value: "left bottom"
                    }, {
                      value: "right top"
                    }, {
                      value: "right center"
                    }, {
                      value: "right bottom"
                    }, {
                      value: "center top"
                    }, {
                      value: "center center"
                    }, {
                      value: "center bottom"
                    }];
                    break;
                  case "background-attachment":
                    i.list = [{
                      value: "scroll"
                    }, {
                      value: "fixed"
                    }, {
                      value: "local"
                    }];
                    break;
                  case "background-size":
                    i.list = [{
                      value: "auto"
                    }, {
                      value: "cover"
                    }, {
                      value: "contain"
                    }];
                    break;
                  case "transition-property":
                    i.list = [{
                      value: "all"
                    }, {
                      value: "width"
                    }, {
                      value: "height"
                    }, {
                      value: "background-color"
                    }, {
                      value: "transform"
                    }, {
                      value: "box-shadow"
                    }, {
                      value: "opacity"
                    }];
                    break;
                  case "transition-timing-function":
                    i.list = [{
                      value: "linear"
                    }, {
                      value: "ease"
                    }, {
                      value: "ease-in"
                    }, {
                      value: "ease-out"
                    }, {
                      value: "ease-in-out"
                    }];
                    break;
                  case "cursor":
                    i.list = [{
                      value: "auto"
                    }, {
                      value: "default"
                    }, {
                      value: "none"
                    }, {
                      value: "initial"
                    }, {
                      value: "inherit"
                    }, {
                      value: "pointer"
                    }, {
                      value: "copy"
                    }, {
                      value: "crosshair"
                    }, {
                      value: "grab"
                    }, {
                      value: "grabbing"
                    }, {
                      value: "help"
                    }, {
                      value: "move"
                    }, {
                      value: "text"
                    }, {
                      value: "context-menu"
                    }, {
                      value: "progress"
                    }, {
                      value: "wait"
                    }, {
                      value: "vertical-text"
                    }, {
                      value: "alias"
                    }, {
                      value: "no-drop"
                    }, {
                      value: "not-allowed"
                    }];
                    break;
                  case "overflow":
                  case "overflow-x":
                  case "overflow-y":
                    i.list = [{
                      value: "visible"
                    }, {
                      value: "hidden"
                    }, {
                      value: "scroll"
                    }, {
                      value: "auto"
                    }];
                }
                switch (o) {
                  case "margin":
                    i.properties = this.build(["margin-top", "margin-right", "margin-bottom", "margin-left"]);
                    break;
                  case "padding":
                    i.properties = this.build(["padding-top", "padding-right", "padding-bottom", "padding-left"]);
                    break;
                  case "text-shadow":
                    i.properties = this.build(["text-shadow-h", "text-shadow-v", "text-shadow-blur", "text-shadow-color"]);
                    break;
                  case "border":
                    i.properties = this.build(["border-width", "border-style", "border-color"]);
                    break;
                  case "border-radius":
                    i.properties = this.build(["border-top-left-radius", "border-top-right-radius", "border-bottom-right-radius", "border-bottom-left-radius"]);
                    break;
                  case "box-shadow":
                    i.properties = this.build(["box-shadow-h", "box-shadow-v", "box-shadow-blur", "box-shadow-spread", "box-shadow-color", "box-shadow-type"]);
                    break;
                  case "background":
                    i.properties = this.build(["background-image", "background-repeat", "background-position", "background-attachment", "background-size"]);
                    break;
                  case "transition":
                    i.properties = this.build(["transition-property", "transition-duration", "transition-timing-function"]);
                    break;
                  case "transform":
                    i.properties = this.build(["transform-rotate-x", "transform-rotate-y", "transform-rotate-z", "transform-scale-x", "transform-scale-y", "transform-scale-z"]);
                }
                e.push(i);
              }
              return e;
            }
          };
        },
        d = c.a.Model.extend({
          defaults: {
            id: "",
            name: "",
            open: !0,
            buildProps: "",
            extendBuilded: 1,
            properties: []
          },
          initialize: function initialize(t) {
            var e,
              n = t || {},
              r = this.buildProperties(n.buildProps),
              i = this.get("name") || "";
            !this.get("id") && this.set("id", i.replace(/ /g, "_").toLowerCase()), e = r ? this.extendProperties(r) : this.get("properties");
            var o = new l.default(e);
            o.sector = this, this.set("properties", o);
          },
          extendProperties: function extendProperties(t, e, n) {
            for (var r = t.length, i = e || this.get("properties"), a = this.get("extendBuilded"), s = [], c = 0, l = i.length; c < l; c++) {
              for (var u = i[c], d = 0, h = 0; h < r; h++) {
                var f = t[h];
                if (u.property != f.property && u.id != f.property) ;else {
                  var p = u.properties;
                  p && p.length && (u.properties = this.extendProperties(f.properties || [], p, 1)), t[h] = a ? Object(o.extend)(f, u) : u, s[h] = t[h], d = 1;
                }
              }
              d || (t.push(u), s.push(u));
            }
            return n ? s.filter(function (t) {
              return t;
            }) : t;
          },
          buildProperties: function buildProperties(t) {
            var e = t || [];
            if (e.length) return this.propFactory || (this.propFactory = new u()), this.propFactory.build(e);
          }
        }),
        h = c.a.Collection.extend({
          model: d
        }),
        f = n(3),
        p = n(7),
        g = n(19),
        v = c.a.View.extend({
          template: Object(o.template)('\n  <div class="<%= pfx %>title" data-sector-title>\n    <i id="<%= pfx %>caret" class="fa"></i>\n    <%= label %>\n  </div>'),
          events: {
            "click [data-sector-title]": "toggle"
          },
          initialize: function initialize(t) {
            this.config = t.config || {}, this.em = this.config.em, this.pfx = this.config.stylePrefix || "", this.target = t.target || {}, this.propTarget = t.propTarget || {}, this.caretR = "fa-caret-right", this.caretD = "fa-caret-down";
            var e = this.model;
            this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "updateVisibility", this.updateVisibility), this.listenTo(e, "destroy remove", this.remove);
          },
          updateVisibility: function updateVisibility() {
            var t;
            this.model.get("properties").each(function (e) {
              e.get("visible") && (t = 1);
            }), this.el.style.display = t ? "block" : "none";
          },
          updateOpen: function updateOpen() {
            this.model.get("open") ? this.show() : this.hide();
          },
          show: function show() {
            this.$el.addClass(this.pfx + "open"), this.getPropertiesEl().style.display = "", this.$caret.removeClass(this.caretR).addClass(this.caretD);
          },
          hide: function hide() {
            this.$el.removeClass(this.pfx + "open"), this.getPropertiesEl().style.display = "none", this.$caret.removeClass(this.caretD).addClass(this.caretR);
          },
          getPropertiesEl: function getPropertiesEl() {
            return this.$el.find(".".concat(this.pfx, "properties")).get(0);
          },
          toggle: function toggle(t) {
            var e = this.model.get("open") ? 0 : 1;
            this.model.set("open", e);
          },
          render: function render() {
            var t = this.pfx,
              e = this.model,
              n = this.em,
              r = this.$el,
              i = e.attributes,
              o = i.id,
              a = i.name,
              s = n && n.t("styleManager.sectors.".concat(o)) || a;
            return r.html(this.template({
              pfx: t,
              label: s
            })), this.$caret = r.find("#".concat(t, "caret")), this.renderProperties(), r.attr("class", "".concat(t, "sector ").concat(t, "sector__").concat(o, " no-select")), this.updateOpen(), this;
          },
          renderProperties: function renderProperties() {
            var t = this.model.get("properties");
            if (t) {
              var e = new g.default({
                collection: t,
                target: this.target,
                propTarget: this.propTarget,
                config: this.config
              });
              this.$el.append(e.render().el);
            }
          }
        });
      function m(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function b(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? m(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var y = c.a.View.extend({
        initialize: function initialize() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.config || {};
          this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.target = t.target || {}, this.config = e;
          var n = {};
          Object(o.extend)(n, c.a.Events);
          var r = document.body,
            i = document.createElement("el-".concat(new Date().getTime()));
          r.appendChild(i), n.computedDefault = b({}, window.getComputedStyle(i)), r.removeChild(i), this.propTarget = n;
          var a = this.collection,
            s = "component:toggled component:update:classes change:state change:device frame:resized";
          this.listenTo(a, "add", this.addTo), this.listenTo(a, "reset", this.render), this.listenTo(this.target, s, this.targetUpdated);
        },
        addTo: function addTo(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          this.addToCollection(t, null, n);
        },
        toggleStateCls: function toggleStateCls() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            e = arguments.length > 1 ? arguments[1] : void 0;
          t.forEach(function (t) {
            var n = t.getEl();
            n && n.classList && n.classList[e ? "add" : "remove"]("hc-state");
          });
        },
        targetUpdated: function targetUpdated(t) {
          var e = this.target,
            n = this.propTarget,
            r = e.getSelectedAll(),
            i = e.getSelected(),
            o = t && t.toHTML ? t : i;
          if (o && this.toggleStateCls([o]), i) {
            var a = e.get("Config").devicePreviewMode ? "" : e.get("state"),
              s = e.get("SelectorManager").getConfig().componentFirst,
              c = i.getEl();
            if (n.helper = null, n.targets = null, c && Object(f.p)(c)) {
              var l = a ? ":".concat(a) : null;
              n.computed = window.getComputedStyle(c, l);
            }
            i = e.get("StyleManager").getModelToStyle(i), a && (function () {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                r = e.get("CssComposer"),
                i = r.getAll(),
                o = r.getClassRule("hc-state");
              o ? (i.remove(o), i.add(o)) : o = r.setClassRule("hc-state"), o.set("important", 1), o.setStyle(t), n.helper = o;
            }(i.getStyle()), this.toggleStateCls(r, 1)), n.model = i, s && (n.targets = r), n.trigger("update");
          }
        },
        setTarget: function setTarget(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = this.target,
            r = Object(o.isArray)(t) ? t : [t],
            i = e.targetIsClass,
            a = e.stylable,
            s = [];
          r.forEach(function (t) {
            var e = t;
            if (Object(o.isString)(t)) {
              var r,
                c = n.get("CssComposer").getAll();
              i && (r = c.filter(function (e) {
                return e.get("selectors").getFullString() === t;
              })[0]), r || (r = c.filter(function (e) {
                return e.get("selectorsAdd") === t;
              })[0]), r || (r = c.add({
                selectors: [],
                selectorsAdd: t
              })), a && r.set({
                stylable: a
              }), e = r;
            }
            s.push(e);
          });
          var c = this.propTarget;
          return c.targets = s, c.trigger("update"), s;
        },
        addToCollection: function addToCollection(t, e) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = this.pfx,
            i = this.target,
            o = this.propTarget,
            a = this.config,
            s = this.el,
            c = e || s,
            l = new v({
              model: t,
              id: "".concat(r).concat(t.get("id")),
              name: t.get("name"),
              properties: t.get("properties"),
              target: i,
              propTarget: o,
              config: a
            }).render().el;
          return Object(p.b)(c, l, n.at), l;
        },
        render: function render() {
          var t = this,
            e = document.createDocumentFragment(),
            n = this.$el,
            r = this.pfx,
            i = this.ppfx;
          return n.empty(), this.collection.each(function (n) {
            return t.addToCollection(n, e);
          }), n.append(e), n.addClass("".concat(r, "sectors ").concat(i, "one-bg ").concat(i, "two-color")), this;
        }
      });
      function w(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function x(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? w(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          r = {};
        return {
          name: "StyleManager",
          getConfig: function getConfig() {
            return r;
          },
          init: function init(i) {
            var o = (r = x(x({}, a), i)).pStylePrefix;
            return this.em = r.em, o && (r.stylePrefix = o + r.stylePrefix), t = new l.default(), e = new h([], r), n = new y({
              collection: e,
              target: r.em,
              config: r
            }), this;
          },
          onLoad: function onLoad() {
            e.add(r.sectors, {
              silent: !0
            });
          },
          postRender: function postRender() {
            var t = this.getConfig().appendTo;
            t && (Object(o.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render());
          },
          addSector: function addSector(t, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = this.getSector(t);
            return i || (n.id = t, i = e.add(n, r)), i;
          },
          getSector: function getSector(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = e.where({
                id: t
              })[0];
            return !r && n.warn && this._logNoSector(t), r;
          },
          removeSector: function removeSector(t) {
            return this.getSectors().remove(this.getSector(t, {
              warn: 1
            }));
          },
          getSectors: function getSectors() {
            return e;
          },
          addProperty: function addProperty(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = this.getSector(t, {
                warn: 1
              }),
              i = null;
            return r && (i = r.get("properties").add(e, n)), i;
          },
          getProperty: function getProperty(t, e) {
            var n,
              r = this.getSector(t, {
                warn: 1
              });
            return r && (n = r.get("properties").filter(function (t) {
              return t.get("property") === e || t.get("id") === e;
            })[0]), n || null;
          },
          removeProperty: function removeProperty(t, e) {
            var n = this.getProperties(t);
            return n && n.remove(this.getProperty(t, e));
          },
          getProperties: function getProperties(t) {
            var e = null,
              n = this.getSector(t, {
                warn: 1
              });
            return n && (e = n.get("properties")), e;
          },
          getModelToStyle: function getModelToStyle(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = r.em,
              i = e.skipAdd,
              o = t.get("classes"),
              a = t.getId();
            if (n) {
              var s,
                c = n.getConfig(),
                l = n.get("UndoManager"),
                u = n.get("CssComposer"),
                d = n.get("SelectorManager"),
                h = d ? d.getConfig() : {},
                f = c.devicePreviewMode ? "" : n.get("state"),
                p = o.getStyleable(),
                g = p.length,
                v = !h.componentFirst || e.useClasses,
                m = {
                  state: f
                };
              if (l.stop(), g && v) {
                var b = n.getCurrentMedia();
                (s = u.get(p, f, b)) || i || (s = u.add(p, f, b));
              } else c.avoidInlineStyle && (!(s = u.getIdRule(a, m)) && !i && (s = u.setIdRule(a, {}, m)), t.is("wrapper") && s.set("wrapper", 1));
              s && (t = s), l.start();
            }
            return t;
          },
          addType: function addType(e, n) {
            t.addType(e, n);
          },
          getType: function getType(e) {
            return t.getType(e);
          },
          getTypes: function getTypes() {
            return t.getTypes();
          },
          createType: function createType(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.model,
              i = void 0 === n ? {} : n,
              o = e.view,
              a = void 0 === o ? {} : o,
              s = this.getType(t);
            if (s) return new s.view(x({
              model: new s.model(i),
              config: r
            }, a));
          },
          setTarget: function setTarget(t, e) {
            return n.setTarget(t, e);
          },
          getEmitter: function getEmitter() {
            return n.propTarget;
          },
          render: function render() {
            return n.render().el;
          },
          _logNoSector: function _logNoSector(t) {
            var e = this.em;
            e && e.logWarning("'".concat(t, "' sector not found"));
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(0),
        i = {
          stylePrefix: "cm-",
          inlineCss: !1
        },
        o = n(2),
        a = n.n(o),
        s = n(1),
        c = n.n(s);
      function l(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function u(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? l(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var d = c.a.Model.extend({
          build: function build(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = t.get("components");
            return e.exportWrapper ? t.toHTML(u({}, e.wrapperIsBody && {
              tag: "body"
            })) : this.buildModels(n);
          },
          buildModels: function buildModels(t) {
            var e = "";
            return t.each(function (t) {
              e += t.toHTML();
            }), e;
          }
        }),
        h = n(31),
        f = c.a.Model.extend({
          build: function build(t) {
            var e = t.toJSON();
            return this.beforeEach(e), Object(r.each)(e, function (t, n) {
              var r = e[n];
              if (r instanceof c.a.Model) e[n] = this.build(r);else if (r instanceof c.a.Collection) {
                var i = r;
                e[n] = [], i.length && i.each(function (t, r) {
                  e[n][r] = this.build(t);
                }, this);
              }
            }, this), e;
          },
          beforeEach: function beforeEach(t) {
            delete t.status;
          }
        }),
        p = c.a.Model.extend({
          mapModel: function mapModel(t) {
            var e = "",
              n = t.get("script-export") || t.get("script"),
              i = t.get("type"),
              o = t.get("components"),
              a = t.getId();
            if (n) {
              var s = t.get("attributes");
              s = Object(r.extend)({}, s, {
                id: a
              }), t.set("attributes", s, {
                silent: 1
              });
              var c = t.getScriptString(n);
              if (t.get("scriptUpdated")) this.mapJs[i + "-" + a] = {
                ids: [a],
                code: c
              };else {
                var l = this.mapJs[i];
                l ? l.ids.push(a) : this.mapJs[i] = {
                  ids: [a],
                  code: c
                };
              }
            }
            return o.each(function (t) {
              e += this.mapModel(t);
            }, this), e;
          },
          build: function build(t) {
            this.mapJs = {}, this.mapModel(t);
            var e = "";
            for (var n in this.mapJs) {
              var r = this.mapJs[n],
                i = "#" + r.ids.join(", #");
              e += "\n        var items = document.querySelectorAll('".concat(i, "');\n        for (var i = 0, len = items.length; i < len; i++) {\n          (function(){").concat(r.code, "}.bind(items[i]))();\n        }");
            }
            return e;
          }
        }),
        g = n(13),
        v = n.n(g);
      function m(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      n(91), n(45), n(94);
      var b = c.a.Model.extend({
          defaults: {
            input: "",
            label: "",
            codeName: "",
            theme: "hopscotch",
            readOnly: !0,
            lineNumbers: !0
          },
          init: function init(t) {
            return Object(r.bindAll)(this, "onChange"), this.editor = v.a.fromTextArea(t, function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var n = null != arguments[e] ? arguments[e] : {};
                e % 2 ? m(Object(n), !0).forEach(function (e) {
                  a()(t, e, n[e]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (e) {
                  Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                });
              }
              return t;
            }({
              dragDrop: !1,
              lineWrapping: !0,
              mode: this.get("codeName")
            }, this.attributes)), this.element = t, this.editor.on("change", this.onChange), this;
          },
          onChange: function onChange() {
            this.trigger("update", this);
          },
          getEditor: function getEditor() {
            return this.editor;
          },
          getElement: function getElement() {
            return this.element;
          },
          setElement: function setElement(t) {
            return this.element = t, this;
          },
          refresh: function refresh() {
            return this.getEditor().refresh(), this;
          },
          focus: function focus() {
            return this.getEditor().focus(), this;
          },
          getContent: function getContent() {
            var t = this.getEditor();
            return t && t.getValue();
          },
          setContent: function setContent(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.editor;
            r && (r.setValue(t), r.autoFormatRange && (v.a.commands.selectAll(r), r.autoFormatRange(r.getCursor(!0), r.getCursor(!1)), v.a.commands.goDocStart(r)), !n.noRefresh && setTimeout(function () {
              return e.refresh();
            }));
          }
        }),
        y = c.a.View.extend({
          template: Object(r.template)('\n  <div class="<%= pfx %>editor" id="<%= pfx %><%= codeName %>">\n  \t<div id="<%= pfx %>title"><%= label %></div>\n  \t<div id="<%= pfx %>code"></div>\n  </div>'),
          initialize: function initialize(t) {
            this.config = t.config || {}, this.pfx = this.config.stylePrefix;
          },
          render: function render() {
            var t = this.model.toJSON();
            return t.pfx = this.pfx, this.$el.html(this.template(t)), this.$el.attr("class", this.pfx + "editor-c"), this.$el.find("#" + this.pfx + "code").append(this.model.get("input")), this;
          }
        });
      e.default = function () {
        var t = {},
          e = {},
          n = {},
          o = {},
          a = {};
        return {
          getConfig: function getConfig() {
            return t;
          },
          config: t,
          EditorView: y,
          name: "CodeManager",
          init: function init(e) {
            for (var r in t = e || {}, i) r in t || (t[r] = i[r]);
            var o = t.pStylePrefix;
            return o && (t.stylePrefix = o + t.stylePrefix), n.html = new d(), n.css = new h.a(), n.json = new f(), n.js = new p(), a.CodeMirror = new b(), this.loadDefaultGenerators().loadDefaultViewers(), this;
          },
          addGenerator: function addGenerator(t, n) {
            return e[t] = n, this;
          },
          getGenerator: function getGenerator(t) {
            return e[t] || null;
          },
          getGenerators: function getGenerators() {
            return e;
          },
          addViewer: function addViewer(t, e) {
            return o[t] = e, this;
          },
          getViewer: function getViewer(t) {
            return o[t] || null;
          },
          getViewers: function getViewers() {
            return o;
          },
          createViewer: function createViewer() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = Object(r.isUndefined)(t.type) ? "CodeMirror" : t.type,
              n = this.getViewer(e) && this.getViewer(e).clone();
            console.log("Creating div element codemanager:index");
            var i = document.createElement("div"),
              o = document.createElement("textarea");
            return i.appendChild(o), n.set(t), n.init(o), n.setElement(i), n;
          },
          updateViewer: function updateViewer(t, e) {
            t.setContent(e);
          },
          getCode: function getCode(e, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            r.em = t.em;
            var i = this.getGenerator(n);
            return i ? i.build(e, r) : "";
          },
          loadDefaultGenerators: function loadDefaultGenerators() {
            for (var t in n) this.addGenerator(t, n[t]);
            return this;
          },
          loadDefaultViewers: function loadDefaultViewers() {
            for (var t in a) this.addViewer(t, a[t]);
            return this;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = {
          devices: []
        },
        a = n(1),
        s = n.n(a),
        c = s.a.Model.extend({
          idAttribute: "name",
          defaults: {
            name: "",
            width: null,
            height: "",
            widthMedia: null,
            priority: null
          },
          initialize: function initialize() {
            var t = this;
            null === this.get("widthMedia") && this.set("widthMedia", this.get("width")), null === this.get("width") && this.set("width", this.get("widthMedia")), !this.get("priority") && this.set("priority", parseFloat(this.get("widthMedia")) || 0), ["width", "height", "widthMedia"].forEach(function (e) {
              return t.checkUnit(e);
            });
          },
          checkUnit: function checkUnit(t) {
            var e = this.get(t) || "";
            (parseFloat(e) || 0).toString() === e.toString() && this.set(t, "".concat(e, "px"));
          }
        }),
        l = s.a.Collection.extend({
          model: c,
          comparator: function comparator(t, e) {
            var n = Number.MAX_VALUE;
            return (e.get("priority") || n) - (t.get("priority") || n);
          },
          getSorted: function getSorted() {
            return this.sort();
          }
        }),
        u = n(0),
        d = s.a.View.extend({
          template: Object(u.template)('\n    <div class="<%= ppfx %>device-label"><%= deviceLabel %></div>\n    <div class="<%= ppfx %>field <%= ppfx %>select">\n      <span id="<%= ppfx %>input-holder">\n        <select class="<%= ppfx %>devices"></select>\n      </span>\n      <div class="<%= ppfx %>sel-arrow">\n        <div class="<%= ppfx %>d-s-arrow"></div>\n      </div>\n    </div>\n    <button style="display:none" class="<%= ppfx %>add-trasp">+</button>'),
          events: {
            change: "updateDevice"
          },
          initialize: function initialize(t) {
            this.config = t.config || {}, this.em = this.config.em, this.ppfx = this.config.pStylePrefix || "", this.events["click ." + this.ppfx + "add-trasp"] = this.startAdd, this.listenTo(this.em, "change:device", this.updateSelect), this.delegateEvents();
          },
          startAdd: function startAdd() {},
          updateDevice: function updateDevice() {
            var t = this.em;
            if (t) {
              var e = this.devicesEl,
                n = e ? e.val() : "";
              t.set("device", n);
            }
          },
          updateSelect: function updateSelect() {
            var t = this.em,
              e = this.devicesEl;
            if (t && t.getDeviceModel && e) {
              var n = t.getDeviceModel(),
                r = n ? n.get("name") : "";
              e.val(r);
            }
          },
          getOptions: function getOptions() {
            var t = this.collection,
              e = this.em,
              n = "";
            return t.each(function (t) {
              var r = t.attributes,
                i = r.name,
                o = r.id,
                a = e && e.t && e.t("deviceManager.devices.".concat(o)) || i;
              n += '<option value="'.concat(i, '">').concat(a, "</option>");
            }), n;
          },
          render: function render() {
            var t = this.em,
              e = this.ppfx,
              n = this.$el,
              r = this.el;
            return n.html(this.template({
              ppfx: e,
              deviceLabel: t && t.t && t.t("deviceManager.device")
            })), this.devicesEl = n.find(".".concat(e, "devices")), this.devicesEl.append(this.getOptions()), r.className = "".concat(e, "devices-c"), this;
          }
        });
      function h(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function f(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? h(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          name: "DeviceManager",
          init: function init(r) {
            var i = this;
            for (var a in n = r || {}, o) a in n || (n[a] = o[a]);
            return t = new l(), (n.devices || []).forEach(function (t) {
              return i.add(t.id || t.name, t.width, t);
            }), e = new d({
              collection: t,
              config: n
            }), this;
          },
          add: function add(e, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = f(f({}, r), {}, {
                id: e,
                name: r.name || e,
                width: n
              });
            return t.add(i);
          },
          get: function get(e) {
            return t.get(e);
          },
          getAll: function getAll() {
            return t;
          },
          render: function render() {
            return e.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = {
          id: "gjs-",
          autosave: 1,
          autoload: 1,
          type: "local",
          stepsBeforeSave: 1,
          storeComponents: 1,
          storeStyles: 1,
          storeHtml: 1,
          storeCss: 1,
          checkLocal: 1,
          params: {},
          headers: {},
          urlStore: "",
          urlLoad: "",
          beforeSend: function beforeSend(t, e) {},
          onComplete: function onComplete(t, e) {},
          contentTypeJson: !0,
          credentials: "include",
          fetchOptions: ""
        },
        a = n(1),
        s = n.n(a),
        c = s.a.Model.extend({
          defaults: {
            checkLocal: !0
          },
          store: function store(t, e) {
            for (var n in this.checkStorageEnvironment(), t) localStorage.setItem(n, t[n]);
            "function" == typeof e && e();
          },
          load: function load(t, e) {
            this.checkStorageEnvironment();
            for (var n = {}, r = 0, i = t.length; r < i; r++) {
              var o = localStorage.getItem(t[r]);
              o && (n[t[r]] = o);
            }
            return "function" == typeof e && e(n), n;
          },
          remove: function remove(t) {
            this.checkStorageEnvironment();
            for (var e = 0, n = t.length; e < n; e++) localStorage.removeItem(t[e]);
          },
          checkStorageEnvironment: function checkStorageEnvironment() {
            this.get("checkLocal") && !localStorage && console.warn("Your browser doesn't support localStorage");
          }
        }),
        l = n(28),
        u = n(0);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var f = s.a.Model.extend({
        fetch: l.a,
        defaults: {
          urlStore: "",
          urlLoad: "",
          params: {},
          beforeSend: function beforeSend() {},
          onComplete: function onComplete() {},
          contentTypeJson: !1,
          credentials: "include",
          fetchOptions: ""
        },
        onStart: function onStart() {
          this.get("em");
          var t = this.get("beforeSend");
          t && t();
        },
        onError: function onError(t, e) {
          var n = document.querySelector(".btn-save");
          if (t ? n.classList.add("text-warning") : n.classList.remove("text-warning"), e) {
            var r = this.get("em");
            r && r.logError(t), e(t);
          } else {
            var i = this.get("em");
            console.error(t), i && i.logError(t), i && i.trigger("storage:error", t);
          }
        },
        onResponse: function onResponse(t, e) {
          var n = this.get("em"),
            r = this.get("onComplete"),
            i = this.get("contentTypeJson") && t && "string" == typeof t ? JSON.parse(t) : t;
          r && r(i), e && e(i), n && n.trigger("storage:response", i);
        },
        store: function store(t, e, n) {
          var r = {};
          for (var i in t) r[i] = t[i];
          var o = this.get("urlStore");
          this.get("isDeleteContent") && (o += "/delete"), this.request(o, {
            body: r
          }, e, n), this.resetAttributes();
        },
        resetAttributes: function resetAttributes() {
          this.set("isDeleteContent", !1);
        },
        load: function load(t, e, n) {
          this.request(this.get("urlLoad"), {
            method: "get"
          }, e, n);
        },
        request: function request(t) {
          var e,
            n,
            r = this,
            i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
            s = this.get("contentTypeJson"),
            c = this.get("headers") || {},
            l = this.get("params"),
            d = "X-Requested-With",
            f = "Content-Type",
            p = i.body || {};
          for (var g in l) p[g] = l[g];
          if (Object(u.isUndefined)(c[d]) && (c[d] = "XMLHttpRequest"), Object(u.isUndefined)(c[f]) && s && (c[f] = "application/json; charset=utf-8"), s) n = JSON.stringify(p);else for (var v in n = new FormData(), p) n.append(v, p[v]);
          "post" === (e = {
            method: i.method || "post",
            credentials: this.get("credentials"),
            headers: c
          }).method && (e.body = n);
          var m = this.get("fetchOptions") || {},
            b = Object(u.isFunction)(m) ? m(e) : e;
          this.onStart(), this.fetch(t, h(h({}, e), b || {})).then(function (t) {
            return 1 == (t.status / 200 | 0) ? t.text() : t.text().then(function (t) {
              return Promise.reject(t);
            });
          }).then(function (t) {
            return r.onResponse(t, o);
          }).catch(function (t) {
            return r.onError(t, a);
          });
        }
      });
      function p(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function g(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? p(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e = {},
          n = {},
          r = {};
        return {
          name: "StorageManager",
          init: function init() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return e = g(g({}, o), n), t = e.em, e._disable && (e.type = 0), r.remote = new f(e), r.local = new c(e), e.currentStorage = e.type, this.loadDefaultProviders().setCurrent(e.type), this;
          },
          getConfig: function getConfig() {
            return e;
          },
          isAutosave: function isAutosave() {
            return !!e.autosave;
          },
          setAutosave: function setAutosave(t) {
            return e.autosave = !!t, this;
          },
          getStepsBeforeSave: function getStepsBeforeSave() {
            return e.stepsBeforeSave;
          },
          setStepsBeforeSave: function setStepsBeforeSave(t) {
            return e.stepsBeforeSave = t, this;
          },
          add: function add(t, e) {
            return n[t] = e, this;
          },
          get: function get(t) {
            return n[t] || null;
          },
          getStorages: function getStorages() {
            return n;
          },
          getCurrent: function getCurrent() {
            return e.currentStorage;
          },
          setCurrent: function setCurrent(t) {
            return e.currentStorage = t, this;
          },
          store: function store(t, n) {
            var r = this,
              i = this.get(this.getCurrent()),
              o = {};
            for (var a in this.onStart("store", t), t) o[e.id + a] = t[a];
            return i ? i.store(o, function (t) {
              n && n(t), r.onEnd("store", t);
            }, function (t) {
              r.onError("store", t);
            }) : null;
          },
          load: function load(t, n) {
            var r = this,
              i = this.get(this.getCurrent()),
              o = [],
              a = {};
            "string" == typeof t && (t = [t]), this.onStart("load", t);
            for (var s = 0, c = t.length; s < c; s++) o.push(e.id + t[s]);
            i ? i.load(o, function (t) {
              var i = new RegExp("^" + e.id);
              for (var o in t) {
                var s = o.replace(i, "");
                a[s] = t[o];
              }
              n && n(a), r.onEnd("load", a);
            }, function (t) {
              n && n(a), r.onError("load", t);
            }) : n && n(a);
          },
          loadDefaultProviders: function loadDefaultProviders() {
            for (var t in r) this.add(t, r[t]);
            return this;
          },
          getCurrentStorage: function getCurrentStorage() {
            return this.get(this.getCurrent());
          },
          onStart: function onStart(e, n) {
            t && (t.trigger("storage:start"), e && t.trigger("".concat("storage:start", ":").concat(e), n));
          },
          onEnd: function onEnd(e, n) {
            t && (t.trigger("storage:end"), e && t.trigger("".concat("storage:end", ":").concat(e), n));
          },
          onError: function onError(e, n) {
            t && (t.trigger("storage:error", n), e && t.trigger("".concat("storage:error", ":").concat(e), n), this.onEnd(e, n));
          },
          canAutoload: function canAutoload() {
            return this.getCurrentStorage() && this.getConfig().autoload;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = {
          textTags: ["br", "b", "i", "u", "a", "ul", "ol"],
          parserCss: null,
          parserHtml: null
        },
        a = n(0),
        s = {
          4: "media",
          5: "font-face",
          6: "page",
          7: "keyframes",
          11: "counter-style",
          12: "supports",
          13: "document",
          14: "font-feature-values",
          15: "viewport"
        },
        c = Object(a.keys)(s),
        l = ["5", "6", "11", "15"],
        u = ["font-face", "page", "counter-style", "viewport"],
        d = function d() {
          for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", e = [], n = [], r = t.split(","), i = 0, o = r.length; i < o; i++) {
            var a = r[i].trim();
            if (/^(\.{1}[\w\-]+)+(:{1,2}[\w\-()]+)?$/gi.test(a) || /^(#{1}[\w\-]+){1}(:{1,2}[\w\-()]+)?$/gi.test(a)) {
              var s = a.split(".").filter(Boolean);
              n.push(s);
            } else e.push(a);
          }
          return {
            result: n,
            add: e
          };
        },
        h = function h(t) {
          for (var e = t.style, n = {}, r = 0, i = e.length; r < i; r++) {
            var o = e[r],
              a = e.getPropertyValue(o),
              s = e.getPropertyPriority(o);
            n[o] = "".concat(a).concat(s ? " !".concat(s) : "");
          }
          return n;
        },
        f = function f(t) {
          return (t.conditionText || t.media && t.media.mediaText || t.name || t.selectorText || "").trim();
        },
        p = function p(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = {},
            i = t.length,
            o = t[i - 1],
            a = o ? o.split(/:(.+)/) : [],
            s = a[1],
            c = n.atRule,
            l = n.selectorsAdd,
            d = n.mediaText,
            h = u.indexOf(c) >= 0;
          return h && (r.singleAtRule = 1), c && (r.atRuleType = c), l && (r.selectorsAdd = l), d && (r.mediaText = d), s && (t[i - 1] = a[0], r.state = s, a.splice(a.length - 1, 1)), r.selectors = t, r.style = e, r;
        },
        g = function g(t) {
          var e = document.createElement("style");
          e.innerHTML = t, document.head.appendChild(e);
          var n = e.sheet;
          return document.head.removeChild(e), function t(e) {
            for (var n = [], r = e.cssRules || [], i = 0, o = r.length; i < o; i++) {
              var a = r[i],
                u = a.type.toString(),
                g = 0,
                v = "",
                m = "",
                b = a.selectorText || a.keyText,
                y = l.indexOf(u) >= 0;
              if (y) g = 1, v = s[u], m = f(a);else if (c.indexOf(u) >= 0) {
                var w = t(a);
                m = f(a);
                for (var x = 0, O = w.length; x < O; x++) {
                  var C = w[x];
                  m && (C.mediaText = m), C.atRuleType = s[u];
                }
                n = n.concat(w);
              }
              if (b || y) {
                for (var S = h(a), k = d(b), T = k.add, j = void 0, E = 0, P = (b = k.result).length; E < P; E++) {
                  var A = p(b[E], S, {
                    atRule: s[u]
                  });
                  n.push(A), j = A;
                }
                if (T.length) {
                  var M = T.join(", ");
                  if (j) j.selectorsAdd = M;else {
                    var D = {
                      selectors: [],
                      selectorsAdd: M,
                      style: S
                    };
                    g && (D.singleAtRule = g), v && (D.atRuleType = v), m && (D.mediaText = m), n.push(D);
                  }
                }
              }
            }
            return n;
          }(n);
        },
        v = function v() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return {
            parse: function parse(e) {
              var n = this,
                r = [],
                i = t.parserCss,
                o = t.em,
                a = void 0 === o ? {} : o,
                s = a && a.get && a.get("Editor");
              return (i ? i(e, s) : g(e)).forEach(function (t) {
                return r = r.concat(n.checkNode(t));
              }), r;
            },
            checkNode: function checkNode(t) {
              var e = t,
                n = e.selectors,
                r = e.style;
              if (Object(a.isString)(n)) {
                var i = [],
                  o = d(n),
                  s = o.result,
                  c = o.add.join(", "),
                  l = {
                    atRule: t.atRule,
                    mediaText: t.params
                  };
                s.length ? s.forEach(function (t) {
                  i.push(p(t, r, l));
                }) : i.push(p([], r, l)), c && (i[i.length - 1].selectorsAdd = c), t = i;
              }
              return t;
            }
          };
        },
        m = n(29);
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function y(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? b(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {};
        return {
          compTypes: "",
          parserCss: null,
          parserHtml: null,
          name: "Parser",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return (n = y(y({}, o), r)).Parser = this, t = new m.a(n), e = new v(n), this.em = n.em, this.parserCss = e, this.parserHtml = t, this;
          },
          parseHtml: function parseHtml(n) {
            var r = this.em,
              i = this.compTypes;
            return t.compTypes = r ? r.get("DomComponents").getTypes() : i, t.parse(n, e);
          },
          parseCss: function parseCss(t) {
            return e.parse(t);
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(0),
        a = n(3),
        s = {
          stylePrefix: "clm-",
          appendTo: "",
          selectors: [],
          states: [{
            name: "hover"
          }, {
            name: "active"
          }, {
            name: "nth-of-type(2n)"
          }],
          escapeName: 0,
          selectedName: 0,
          iconAdd: '<svg viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></svg>',
          iconSync: '<svg viewBox="0 0 24 24"><path d="M12 18c-3.31 0-6-2.69-6-6 0-1 .25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 0 0 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4m0-11V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8z"></path></svg>',
          iconTagOn: '<svg viewBox="0 0 24 24"><path d="M19 19H5V5h10V3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8h-2m-11.09-.92L6.5 11.5 11 16 21 6l-1.41-1.42L11 13.17l-3.09-3.09z"></path></svg>',
          iconTagOff: '<svg viewBox="0 0 24 24"><path d="M19 3H5c-1.11 0-2 .89-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5h14z"></path></svg>',
          iconTagRemove: '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg>',
          render: 0,
          componentFirst: 0
        },
        c = n(10),
        l = n(12),
        u = n(9),
        d = n.n(u),
        h = n(1),
        f = n.n(h),
        p = f.a.View.extend({
          template: function template() {
            var t = this.pfx,
              e = this.model,
              n = this.config,
              r = e.get("label") || "";
            return '\n      <span id="'.concat(t, 'checkbox" class="').concat(t, 'tag-status" data-tag-status></span>\n      <span id="').concat(t, 'tag-label" data-tag-name>').concat(r, '</span>\n      <span id="').concat(t, 'close" class="').concat(t, 'tag-close" data-tag-remove>\n        ').concat(n.iconTagRemove, "\n      </span>\n    ");
          },
          events: {
            "click [data-tag-remove]": "removeTag",
            "click [data-tag-status]": "changeStatus",
            "dblclick [data-tag-name]": "startEditTag",
            "focusout [data-tag-name]": "endEditTag"
          },
          initialize: function initialize(t) {
            var e = t.config || {};
            this.config = e, this.coll = t.coll || null, this.pfx = e.stylePrefix || "", this.ppfx = e.pStylePrefix || "", this.em = e.em, this.listenTo(this.model, "change:active", this.updateStatus);
          },
          getInputEl: function getInputEl() {
            return this.inputEl || (this.inputEl = this.el.querySelector("[data-tag-name]")), this.inputEl;
          },
          startEditTag: function startEditTag() {
            var t = this.em,
              e = this.getInputEl();
            e.contentEditable = !0, e.focus(), t && t.setEditing(1);
          },
          endEditTag: function endEditTag() {
            var t = this.model,
              e = this.getInputEl(),
              n = e.textContent,
              r = this.em,
              i = r && r.get("SelectorManager");
            if (e.contentEditable = !1, r && r.setEditing(0), i) {
              var o = i.escapeName(n);
              i.get(o) ? e.innerText = t.get("label") : t.set({
                name: o,
                label: n
              });
            }
          },
          changeStatus: function changeStatus() {
            var t = this.model;
            t.set("active", !t.get("active"));
          },
          removeTag: function removeTag() {
            var t = this.em,
              e = this.model;
            (t && t.getSelectedAll()).forEach(function (t) {
              !e.get("protected") && t && t.getSelectors().remove(e);
            });
          },
          updateStatus: function updateStatus() {
            var t = this.model,
              e = this.$el,
              n = this.config,
              r = n.iconTagOn,
              i = n.iconTagOff,
              o = e.find("[data-tag-status]");
            t.get("active") ? (o.html(r), e.removeClass("opac50")) : (o.html(i), e.addClass("opac50"));
          },
          render: function render() {
            var t = this.pfx,
              e = this.ppfx;
            return this.$el.html(this.template()), this.$el.attr("class", "".concat(t, "tag ").concat(e, "three-bg")), this.updateStatus(), this;
          }
        }),
        g = f.a.View.extend({
          template: function template(t) {
            var e = t.labelInfo,
              n = t.labelStates,
              r = t.labelHead,
              i = t.iconSync,
              o = t.iconAdd,
              a = t.pfx,
              s = t.ppfx;
            return '\n    <div id="'.concat(a, 'up" class="').concat(a, 'header">\n      <div id="').concat(a, 'label" class="').concat(a, 'header-label">').concat(r, '</div>\n      <div id="').concat(a, 'status-c" class="').concat(a, 'header-status">\n        <span id="').concat(a, 'input-c" data-states-c>\n          <div class="').concat(s, "field ").concat(s, 'select">\n            <span id="').concat(s, 'input-holder">\n              <select id="').concat(a, 'states" data-states>\n                <option value="">').concat(n, '</option>\n              </select>\n            </span>\n            <div class="').concat(s, 'sel-arrow">\n              <div class="').concat(s, 'd-s-arrow"></div>\n            </div>\n          </div>\n        </span>\n      </div>\n    </div>\n    <div id="').concat(a, 'tags-field" class="').concat(s, 'field">\n      <div id="').concat(a, 'tags-c" data-selectors></div>\n      <input id="').concat(a, 'new" data-input/>\n      <span id="').concat(a, 'add-tag" class="').concat(a, "tags-btn ").concat(a, 'tags-btn__add" data-add>\n        ').concat(o, '\n      </span>\n      <span class="').concat(a, "tags-btn ").concat(a, 'tags-btn__sync" style="display: none" data-sync-style>\n        ').concat(i, '\n      </span>\n    </div>\n    <div class="').concat(a, 'sels-info">\n      <div class="').concat(a, 'label-sel">').concat(e, ':</div>\n      <div class="').concat(a, 'sels" data-selected></div>\n      <div style="clear:both"></div>\n    </div>');
          },
          events: {
            "change [data-states]": "stateChanged",
            "click [data-add]": "startNewTag",
            "focusout [data-input]": "endNewTag",
            "keyup [data-input]": "onInputKeyUp",
            "click [data-sync-style]": "syncStyle"
          },
          initialize: function initialize() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.config = t.config || {}, this.pfx = this.config.stylePrefix || "", this.ppfx = this.config.pStylePrefix || "", this.className = this.pfx + "tags", this.stateInputId = this.pfx + "states", this.stateInputC = this.pfx + "input-c", this.states = this.config.states || [];
            var e = this.config.em,
              n = this.getStyleEmitter(),
              r = this.collection;
            this.target = this.config.em, this.em = e;
            var i = "component:toggled component:update:classes",
              o = "component:update:classes change:state";
            this.listenTo(e, i, this.componentChanged), this.listenTo(n, "styleManager:update", this.componentChanged), this.listenTo(e, o, this.__handleStateChange), this.listenTo(e, "styleable:change change:device", this.checkSync), this.listenTo(r, "add", this.addNew), this.listenTo(r, "reset", this.renderClasses), this.listenTo(r, "remove", this.tagRemoved), this.delegateEvents();
          },
          syncStyle: function syncStyle() {
            var t,
              e = this.em,
              n = this.getTarget(),
              r = e.get("CssComposer"),
              i = this.getCommonSelectors({
                opts: {
                  noDisabled: 1
                }
              }),
              o = e.get("state"),
              a = e.getCurrentMedia(),
              s = [],
              c = r.get(i, o, a) || r.add(i, o, a);
            this.getTargets().forEach(function (e) {
              var n = r.getIdRule(e.getId(), {
                state: o,
                mediaText: a
              });
              t = n.getStyle(), n.setStyle({}), s.push(n);
            }), t && c.addStyle(t), e.trigger("component:toggled"), e.trigger("component:sync-style", {
              component: n,
              selectors: i,
              mediaText: a,
              rule: c,
              ruleComponents: s,
              state: o
            });
          },
          getStyleEmitter: function getStyleEmitter() {
            var t = this.em,
              e = t && t.get("StyleManager");
            return e && e.getEmitter() || {};
          },
          tagRemoved: function tagRemoved(t) {
            this.updateStateVis();
          },
          getStateOptions: function getStateOptions() {
            var t = this.states,
              e = this.em,
              n = [];
            return t.forEach(function (t) {
              return n.push('<option value="'.concat(t.name, '">').concat(e.t("selectorManager.states.".concat(t.name)) || t.label || t.name, "</option>"));
            }), n.join("");
          },
          addNew: function addNew(t) {
            this.addToClasses(t);
          },
          startNewTag: function startNewTag() {
            this.$addBtn.css({
              display: "none"
            }), this.$input.show().focus();
          },
          endNewTag: function endNewTag() {
            this.$addBtn.css({
              display: ""
            }), this.$input.hide().val("");
          },
          onInputKeyUp: function onInputKeyUp(t) {
            13 === t.keyCode ? this.addNewTag(this.$input.val()) : 27 === t.keyCode && this.endNewTag();
          },
          checkStates: function checkStates() {
            var t = this.em.getState(),
              e = this.getStates();
            e && e.val(t);
          },
          componentChanged: Object(o.debounce)(function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.targets;
            this.updateSelection(e);
          }),
          updateSelection: function updateSelection(t) {
            var e = t || this.getTargets(),
              n = [];
            return (e = Object(o.isArray)(e) ? e : [e]) && e.length && (n = this.getCommonSelectors({
              targets: e
            }), this.checkSync({
              validSelectors: n
            })), this.collection.reset(n), this.updateStateVis(e), n;
          },
          getCommonSelectors: function getCommonSelectors() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = t.targets,
              n = t.opts,
              r = void 0 === n ? {} : n,
              i = e || this.getTargets(),
              o = i.map(function (t) {
                return t.getSelectors && t.getSelectors().getValid(r);
              }).filter(function (t) {
                return t;
              });
            return this._commonSelectors.apply(this, d()(o));
          },
          _commonSelectors: function _commonSelectors() {
            for (var t = this, e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
            return n.length ? 1 === n.length ? n[0] : 2 === n.length ? n[0].filter(function (t) {
              return n[1].indexOf(t) >= 0;
            }) : n.slice(1).reduce(function (e, n) {
              return t._commonSelectors(e, n);
            }, n[0]) : [];
          },
          checkSync: Object(o.debounce)(function () {
            var t,
              e = this.$btnSyncEl,
              n = this.config,
              r = this.collection,
              i = this.getTarget();
            if (i && n.componentFirst && r.length) {
              var a = i.getStyle();
              t = !Object(o.isEmpty)(a);
            }
            e && e[t ? "show" : "hide"]();
          }),
          getTarget: function getTarget() {
            return this.target.getSelected();
          },
          getTargets: function getTargets() {
            return this.target.getSelectedAll();
          },
          updateStateVis: function updateStateVis(t) {
            var e = this.em,
              n = e && e.getConfig("avoidInlineStyle"),
              r = this.collection.length || n ? "" : "none";
            this.getStatesC().css("display", r), this.updateSelector(t);
          },
          __handleStateChange: function __handleStateChange() {
            this.updateSelector(this.getTargets());
          },
          updateSelector: function updateSelector(t) {
            var e = this,
              n = this.el.querySelector("[data-selected]"),
              r = [],
              i = t || this.getTargets();
            (i = Object(o.isArray)(i) ? i : [i]).forEach(function (t) {
              return r.push(e.__getName(t));
            }), n && (n.innerHTML = r.join(", ")), this.checkStates();
          },
          __getName: function __getName(t) {
            var e,
              n = this.pfx,
              r = this.config,
              i = this.em,
              a = r.selectedName,
              s = r.componentFirst;
            if (Object(o.isString)(t)) e = '<span class="'.concat(n, 'sel-gen">').concat(t, "</span>");else {
              if (!t || !t.get) return;
              var c = t.getSelectors().getStyleable(),
                l = i.get("state"),
                u = t.getId ? '<span class="'.concat(n, 'sel-cmp">').concat(t.getName(), '</span><span class="').concat(n, 'sel-id">#').concat(t.getId(), "</span>") : "";
              e = (e = this.collection.getFullString(c)) ? '<span class="'.concat(n, 'sel-rule">').concat(e, "</span>") : t.get("selectorsAdd") || u, e = s && u ? u : e, e += l ? '<span class="'.concat(n, 'sel-state">:').concat(l, "</span>") : "", e = a ? a({
                result: e,
                state: l,
                target: t
              }) : e;
            }
            return e && '<span class="'.concat(n, 'sel">').concat(e, "</span>");
          },
          stateChanged: function stateChanged(t) {
            var e = this.em,
              n = t.target.value;
            e.set("state", n);
          },
          addNewTag: function addNewTag(t) {
            var e = this,
              n = this.em;
            if (t.trim()) {
              if (n) {
                var r = n.get("SelectorManager").add({
                  label: t
                });
                this.getTargets().forEach(function (t) {
                  t.getSelectors().add(r), e.collection.add(r), e.updateStateVis();
                });
              }
              this.endNewTag();
            }
          },
          addToClasses: function addToClasses(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
              n = e,
              r = this.getClasses(),
              i = new p({
                model: t,
                config: this.config,
                coll: this.collection
              }).render().el;
            return n ? n.appendChild(i) : r.append(i), i;
          },
          renderClasses: function renderClasses() {
            var t = this,
              e = document.createDocumentFragment(),
              n = this.getClasses();
            n.empty(), this.collection.each(function (n) {
              return t.addToClasses(n, e);
            }), n.append(e);
          },
          getClasses: function getClasses() {
            return this.$el.find("[data-selectors]");
          },
          getStates: function getStates() {
            if (!this.$states) {
              var t = this.$el.find("[data-states]");
              this.$states = t[0] && t;
            }
            return this.$states;
          },
          getStatesC: function getStatesC() {
            return this.$statesC || (this.$statesC = this.$el.find("#" + this.stateInputC)), this.$statesC;
          },
          render: function render() {
            var t = this.em,
              e = this.pfx,
              n = this.ppfx,
              r = this.config,
              i = this.$el,
              o = this.el,
              a = r.render,
              s = {
                iconSync: r.iconSync,
                iconAdd: r.iconAdd,
                labelHead: t.t("selectorManager.label"),
                labelStates: t.t("selectorManager.emptyState"),
                labelInfo: t.t("selectorManager.selected"),
                ppfx: n,
                pfx: e,
                el: o
              };
            i.html(this.template(s));
            var c = a && a(s);
            c && c !== o && i.empty().append(c), this.$input = i.find("[data-input]"), this.$addBtn = i.find("[data-add]"), this.$classes = i.find("#" + e + "tags-c"), this.$btnSyncEl = i.find("[data-sync-style]"), this.$input.hide();
            var l = this.getStates();
            return l && l.append(this.getStateOptions()), this.renderClasses(), i.attr("class", "".concat(this.className, " ").concat(n, "one-bg ").concat(n, "two-color")), this;
          }
        });
      function v(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function m(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? v(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var b = function b(t) {
          return Object(o.isString)(t) && "#" == t[0];
        },
        y = function y(t) {
          return Object(o.isString)(t) && "." == t[0];
        };
      e.default = function (t) {
        var e,
          n = t || {};
        return {
          Selector: c.a,
          Selectors: l.a,
          name: "SelectorManager",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = (n = m(m({}, s), t)).em,
              i = n.pStylePrefix;
            return this.em = r, i && (n.stylePrefix = i + n.stylePrefix), this.selectorTags = new g({
              collection: new l.a([], {
                em: r,
                config: n
              }),
              config: n
            }), (e = new l.a(n.selectors)).on("add", function (t) {
              return r.trigger("selector:add", t);
            }), e.on("remove", function (t) {
              return r.trigger("selector:remove", t);
            }), e.on("change", function (t) {
              return r.trigger("selector:update", t, t.previousAttributes(), t.changedAttributes());
            }), r.on("change:state", function (t, e) {
              return r.trigger("selector:state", e);
            }), this;
          },
          postRender: function postRender() {
            var t = this.getConfig().appendTo;
            t && (Object(o.isElement)(t) ? t : document.querySelector(t)).appendChild(this.render([]));
          },
          select: function select(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = Array.isArray(t) ? t : [t],
              r = this.em.get("StyleManager").setTarget(n, e),
              i = r.filter(function (t) {
                return t;
              }).map(function (t) {
                return Object(a.l)(t) || Object(a.o)(t) && !t.get("selectorsAdd") ? t : t.getSelectorsString();
              });
            return this.selectorTags.componentChanged({
              targets: i
            }), this;
          },
          setState: function setState(t) {
            return this.em.setState(t), this;
          },
          getState: function getState() {
            return this.em.setState();
          },
          addSelector: function addSelector(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = m({}, r);
            Object(o.isObject)(t) ? i = t : i.name = t, b(i.name) ? (i.name = i.name.substr(1), i.type = c.a.TYPE_ID) : y(i.name) && (i.name = i.name.substr(1)), i.label && !i.name && (i.name = this.escapeName(i.label));
            var a = i.name,
              s = a ? this.get(a, i.type) : e.where(i)[0];
            return s || e.add(i, {
              config: n
            });
          },
          getSelector: function getSelector(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.a.TYPE_CLASS;
            return b(t) ? (t = t.substr(1), n = c.a.TYPE_ID) : y(t) && (t = t.substr(1)), e.where({
              name: t,
              type: n
            })[0];
          },
          add: function add(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return Object(o.isArray)(t) ? t.map(function (t) {
              return e.addSelector(t, n);
            }) : this.addSelector(t, n);
          },
          addClass: function addClass(t) {
            var e = this,
              n = [];
            return Object(o.isString)(t) && (t = t.trim().split(" ")), t.forEach(function (t) {
              return n.push(e.addSelector(t));
            }), n;
          },
          get: function get(t, e) {
            var n = this;
            if (Object(o.isArray)(t)) {
              var r = [];
              return t.map(function (t) {
                return n.getSelector(t);
              }).filter(function (t) {
                return t;
              }).forEach(function (t) {
                return r.indexOf(t) < 0 && r.push(t);
              }), r;
            }
            return this.getSelector(t, e);
          },
          getAll: function getAll() {
            return e;
          },
          escapeName: function escapeName(t) {
            var e = n.escapeName;
            return e ? e(t) : c.a.escapeName(t);
          },
          render: function render(t) {
            return t ? (this.selectorTags = new g({
              collection: new l.a(t),
              config: n
            }), this.selectorTags.render().el) : this.selectorTags.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = {
          stylePrefix: "mdl-",
          title: "",
          content: "",
          backdrop: !0
        },
        a = n(1),
        s = n.n(a),
        c = s.a.Model.extend({
          defaults: {
            title: "",
            content: "",
            open: !1
          }
        }),
        l = s.a.View.extend({
          template: function template(t) {
            var e = t.pfx,
              n = t.ppfx,
              r = t.content,
              i = t.title;
            return '<div class="'.concat(e, "dialog ").concat(n, "one-bg ").concat(n, 'two-color">\n      <div class="').concat(e, 'header">\n        <div class="').concat(e, 'title">').concat(i, '</div>\n        <div class="').concat(e, 'btn-close" data-close-modal>&Cross;</div>\n      </div>\n      <div class="').concat(e, 'content">\n        <div id="').concat(e, 'c">').concat(r, '</div>\n        <div style="clear:both"></div>\n      </div>\n    </div>\n    <div class="').concat(e, 'collector" style="display: none"></div>');
          },
          events: {
            click: "onClick",
            "click [data-close-modal]": "hide"
          },
          initialize: function initialize(t) {
            var e = this.model,
              n = t.config || {},
              r = n.stylePrefix || "";
            this.config = n, this.pfx = r, this.ppfx = n.pStylePrefix || "", this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "change:title", this.updateTitle), this.listenTo(e, "change:content", this.updateContent);
          },
          onClick: function onClick(t) {
            this.config.backdrop && t.target === this.el && this.hide();
          },
          getCollector: function getCollector() {
            return this.$collector || (this.$collector = this.$el.find("." + this.pfx + "collector")), this.$collector;
          },
          getContent: function getContent() {
            var t = this.pfx;
            return this.$content || (this.$content = this.$el.find(".".concat(t, "content #").concat(t, "c"))), this.$content;
          },
          getTitle: function getTitle() {
            return this.$title || (this.$title = this.$el.find("." + this.pfx + "title")), this.$title.get(0);
          },
          updateContent: function updateContent() {
            var t = this.getContent(),
              e = t.children(),
              n = this.getCollector(),
              r = this.model.get("content");
            e.length && n.append(e), t.empty().append(r);
          },
          updateTitle: function updateTitle() {
            var t = this.getTitle();
            t && (t.innerHTML = this.model.get("title"));
          },
          updateOpen: function updateOpen() {
            this.el.style.display = this.model.get("open") ? "" : "none";
          },
          hide: function hide() {
            this.model.set("open", 0);
          },
          show: function show() {
            this.model.set("open", 1);
          },
          render: function render() {
            var t = this.$el,
              e = this.pfx,
              n = (this.ppfx, this.model.toJSON());
            return n.pfx = this.pfx, n.ppfx = this.ppfx, t.html(this.template(n)), t.attr("class", "".concat(e, "container")), this.updateOpen(), this;
          }
        });
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {},
          r = function r(t, e) {
            e && e.trigger("modal:".concat(t ? "open" : "close"));
          };
        return {
          name: "Modal",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              a = (n = d(d({}, o), i)).em;
            this.em = a;
            var s = n.pStylePrefix;
            return s && (n.stylePrefix = s + n.stylePrefix), (t = new c(n)).on("change:open", function (t, e) {
              return r(e, a);
            }), e = new l({
              model: t,
              config: n
            }), this;
          },
          postRender: function postRender(t) {
            var e = t.model.getConfig().el || t.el;
            this.render().appendTo(e);
          },
          open: function open() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return t.title && this.setTitle(t.title), t.content && this.setContent(t.content), e.show(), this;
          },
          close: function close() {
            return e.hide(), this;
          },
          onceClose: function onceClose(t) {
            return this.em.once("modal:close", t), this;
          },
          onceOpen: function onceOpen(t) {
            return this.em.once("modal:open", t), this;
          },
          isOpen: function isOpen() {
            return !!t.get("open");
          },
          setTitle: function setTitle(e) {
            return t.set("title", e), this;
          },
          getTitle: function getTitle() {
            return t.get("title");
          },
          setContent: function setContent(e) {
            return t.set("content", " "), t.set("content", e), this;
          },
          getContent: function getContent() {
            return t.get("content");
          },
          getContentEl: function getContentEl() {
            return e.getContent().get(0);
          },
          getModel: function getModel() {
            return t;
          },
          render: function render() {
            return e.render().$el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = {
          stylePrefix: "pop-",
          title: "",
          content: "",
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backdrop: !0
        },
        a = n(1),
        s = n.n(a),
        c = s.a.Model.extend({
          defaults: {
            title: "",
            content: "",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            open: !1
          }
        }),
        l = s.a.View.extend({
          template: function template(t) {
            var e = t.pfx,
              n = t.ppfx,
              r = t.content,
              i = t.title;
            return t.top, t.bottom, t.left, t.right, '<div class="'.concat(e, "dialog ").concat(n, "one-bg ").concat(n, 'two-color">\n      <div class="').concat(e, 'header">\n        <div class="').concat(e, 'title">').concat(i, '</div>\n        <div class="').concat(e, 'btn-close" data-close-popover>&Cross;</div>\n      </div>\n      <div class="').concat(e, 'content">\n        <div id="').concat(e, 'c">').concat(r, '</div>\n        <div style="clear:both"></div>\n      </div>\n    </div>\n    <div class="').concat(e, 'collector" style="display: none"></div>');
          },
          events: {
            click: "onClick",
            "click [data-close-popover]": "hide"
          },
          initialize: function initialize(t) {
            var e = this.model,
              n = t.config || {},
              r = n.stylePrefix || "";
            this.config = n, this.pfx = r, this.ppfx = n.pStylePrefix || "", this.listenTo(e, "change:open", this.updateOpen), this.listenTo(e, "change:title", this.updateTitle), this.listenTo(e, "change:content", this.updateContent);
          },
          onClick: function onClick(t) {
            this.config.backdrop && t.target === this.el && this.hide();
          },
          getCollector: function getCollector() {
            return this.$collector || (this.$collector = this.$el.find("." + this.pfx + "collector")), this.$collector;
          },
          getContent: function getContent() {
            var t = this.pfx;
            return this.$content || (this.$content = this.$el.find(".".concat(t, "content #").concat(t, "c"))), this.$content;
          },
          getTitle: function getTitle() {
            return this.$title || (this.$title = this.$el.find("." + this.pfx + "title")), this.$title.get(0);
          },
          updateContent: function updateContent() {
            var t = this.getContent(),
              e = t.children(),
              n = this.getCollector(),
              r = this.model.get("content");
            e.length && n.append(e), t.empty().append(r);
          },
          updateTitle: function updateTitle() {
            var t = this.getTitle();
            t && (t.innerHTML = this.model.get("title"));
          },
          updateOpen: function updateOpen() {
            this.el.style.display = this.model.get("open") ? "" : "none", this.el.style.top = this.model.get("top") + "px", this.el.style.bottom = this.model.get("bottom") + "px", this.el.style.right = this.model.get("right") + "px", this.el.style.left = this.model.get("left") + "px";
          },
          hide: function hide() {
            this.model.set("open", 0);
          },
          show: function show() {
            this.model.set("open", 1);
          },
          render: function render() {
            var t = this.$el,
              e = this.pfx,
              n = (this.ppfx, this.model.toJSON());
            return n.pfx = this.pfx, n.ppfx = this.ppfx, t.html(this.template(n)), t.attr("class", "".concat(e, "container")), this.updateOpen(), this;
          }
        });
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n = {},
          r = function r(t, e) {
            e && e.trigger("popover:".concat(t ? "open" : "close"));
          };
        return {
          name: "Popover",
          getConfig: function getConfig() {
            return n;
          },
          init: function init() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              a = (n = d(d({}, o), i)).em;
            this.em = a;
            var s = n.pStylePrefix;
            return s && (n.stylePrefix = s + n.stylePrefix), (t = new c(n)).on("change:open", function (t, e) {
              return r(e, a);
            }), e = new l({
              model: t,
              config: n
            }), this;
          },
          postRender: function postRender(t) {
            var e = t.model.getConfig().el || t.el;
            this.render().appendTo(e);
          },
          open: function open() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return t.title && this.setTitle(t.title), t.content && this.setContent(t.content), t.top && this.setTop(t.top), t.bottom && this.setBottom(t.bottom), t.left && this.setLeft(t.left), t.right && this.setRight(t.right), e.show(), this;
          },
          close: function close() {
            return e.hide(), this;
          },
          onceClose: function onceClose(t) {
            return this.em.once("popover:close", t), this;
          },
          onceOpen: function onceOpen(t) {
            return this.em.once("popover:open", t), this;
          },
          isOpen: function isOpen() {
            return !!t.get("open");
          },
          setTitle: function setTitle(e) {
            return t.set("title", e), this;
          },
          getTitle: function getTitle() {
            return t.get("title");
          },
          setContent: function setContent(e) {
            return t.set("content", " "), t.set("content", e), this;
          },
          getContent: function getContent() {
            return t.get("content");
          },
          getContentEl: function getContentEl() {
            return e.getContent().get(0);
          },
          setTop: function setTop(e) {
            return t.set("top", e), this;
          },
          getTop: function getTop() {
            return t.get("top");
          },
          setBottom: function setBottom(e) {
            return t.set("bottom", e), this;
          },
          getBottom: function getBottom() {
            return t.get("bottom");
          },
          setLeft: function setLeft(e) {
            return t.set("left", e), this;
          },
          getLeft: function getLeft() {
            return t.get("left");
          },
          setRight: function setRight(e) {
            return t.set("right", e), this;
          },
          getRight: function getRight() {
            return t.get("right");
          },
          getModel: function getModel() {
            return t;
          },
          render: function render() {
            return e.render().$el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(17),
        i = n(2),
        o = n.n(i),
        a = n(1),
        s = n.n(a),
        c = n(0),
        l = n(3);
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var h = s.a.$,
        f = s.a.View.extend({
          initialize: function initialize(t) {
            this.opt = t || {}, Object(c.bindAll)(this, "startSort", "onMove", "endMove", "rollback", "updateOffset", "moveDragHelper");
            var e = t || {};
            this.elT = 0, this.elL = 0, this.borderOffset = e.borderOffset || 10;
            var n = e.container;
            this.el = "string" == typeof n ? document.querySelector(n) : n, this.$el = h(this.el), this.containerSel = e.containerSel || "div", this.itemSel = e.itemSel || "div", this.draggable = e.draggable || !0, this.nested = e.nested || 0, this.pfx = e.pfx || "", this.ppfx = e.ppfx || "", this.freezeClass = e.freezeClass || this.pfx + "freezed", this.onStart = e.onStart || "", this.onEndMove = e.onEndMove || "", this.direction = e.direction || "v", this.onMoveClb = e.onMove || "", this.relative = e.relative || 0, this.ignoreViewChildren = e.ignoreViewChildren || 0, this.ignoreModels = e.ignoreModels || 0, this.plh = e.placer || "", this.wmargin = e.wmargin || 0, this.offTop = e.offsetTop || 0, this.offLeft = e.offsetLeft || 0, this.document = e.document || document, this.$document = h(this.document), this.dropContent = null, this.em = e.em || "", this.dragHelper = null, this.canvasRelative = e.canvasRelative || 0, this.selectOnEnd = !e.avoidSelectOnEnd, this.scale = e.scale, this.activeTextModel = null, this.em && this.em.on && (this.em.on("change:canvasOffset", this.updateOffset), this.updateOffset());
          },
          getScale: function getScale() {
            return Object(c.result)(this, scale) || 1;
          },
          getContainerEl: function getContainerEl(t) {
            if (t && (this.el = t), !this.el) {
              var e = this.opt.container;
              this.el = "string" == typeof e ? document.querySelector(e) : e, this.$el = h(this.el);
            }
            return this.el;
          },
          getDocuments: function getDocuments(t) {
            var e = this.em,
              n = t ? t.ownerDocument : e && e.get("Canvas").getBody().ownerDocument,
              r = [document];
            return n && r.push(n), r;
          },
          updateOffset: function updateOffset() {
            var t = this.em.get("canvasOffset") || {};
            this.offTop = t.top, this.offLeft = t.left;
          },
          setDropContent: function setDropContent(t) {
            this.dropModel = null, this.dropContent = t;
          },
          updateTextViewCursorPosition: function updateTextViewCursorPosition(t) {
            var e = this.em.get("Canvas"),
              n = e.getDocument(),
              r = null;
            if (n.caretRangeFromPoint) {
              var i = Object(l.h)(t);
              r = n.caretRangeFromPoint(i.clientX, i.clientY);
            } else t.rangeParent && (r = n.createRange()).setStart(t.rangeParent, t.rangeOffset);
            var o = e.getWindow().getSelection();
            e.getFrameEl().focus(), o.removeAllRanges(), r && o.addRange(r);
          },
          setContentEditable: function setContentEditable(t, e) {
            if (t) {
              var n = t.getEl();
              n.contentEditable != e && (n.contentEditable = e);
            }
          },
          toggleSortCursor: function toggleSortCursor(t) {
            var e = this.em,
              n = e && e.get("Canvas");
            n && (t ? n.startAutoscroll() : n.stopAutoscroll());
          },
          setDragHelper: function setDragHelper(t, e) {
            for (var n = e || "", r = t.cloneNode(1), i = t.getBoundingClientRect(), o = getComputedStyle(t), a = "", s = 0; s < o.length; s++) {
              var c = o[s];
              a += "".concat(c, ":").concat(o.getPropertyValue(c), ";");
            }
            document.body.appendChild(r), r.className += " ".concat(this.pfx, "bdrag"), r.setAttribute("style", a), this.dragHelper = r, r.style.width = "".concat(i.width, "px"), r.style.height = "".concat(i.height, "px"), n && this.moveDragHelper(n), this.em && h(this.em.get("Canvas").getBody().ownerDocument).off("mousemove", this.moveDragHelper).on("mousemove", this.moveDragHelper), h(document).off("mousemove", this.moveDragHelper).on("mousemove", this.moveDragHelper);
          },
          moveDragHelper: function moveDragHelper(t) {
            var e = t.target.ownerDocument;
            if (this.dragHelper && e) {
              var n = t.pageY,
                r = t.pageX,
                i = 0,
                o = 0,
                a = (e.defaultView || e.parentWindow).frameElement,
                s = this.dragHelper.style;
              if (a) {
                var c = a.getBoundingClientRect();
                i = c.top + document.documentElement.scrollTop, o = c.left + document.documentElement.scrollLeft, n = t.clientY, r = t.clientX;
              }
              s.top = n + i + "px", s.left = r + o + "px";
            }
          },
          matches: function matches(t, e, n) {
            return l.r.call(t, e);
          },
          closest: function closest(t, e) {
            if (t) {
              for (var n = t.parentNode; n && 1 === n.nodeType;) {
                if (this.matches(n, e)) return n;
                n = n.parentNode;
              }
              return null;
            }
          },
          offset: function offset(t) {
            var e = t.getBoundingClientRect();
            return {
              top: e.top + document.body.scrollTop,
              left: e.left + document.body.scrollLeft
            };
          },
          createPlaceholder: function createPlaceholder() {
            var t = this.pfx,
              e = document.createElement("div"),
              n = document.createElement("div");
            return e.className = t + "placeholder", e.style.display = "none", e.style["pointer-events"] = "none", n.className = t + "placeholder-int", e.appendChild(n), e;
          },
          startSort: function startSort(t) {
            var e,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.em,
              i = this.itemSel,
              o = this.containerSel,
              a = this.getContainerEl(n.container),
              s = this.getDocuments(t),
              c = this.onStart,
              u = this.plh;
            this.dropModel = null, this.target = null, this.prevTarget = null, this.moved = 0, t && !this.matches(t, "".concat(i, ", ").concat(o)) && (t = this.closest(t, i)), this.eV = t, u || (u = this.createPlaceholder(), a.appendChild(u), this.plh = u), t && ((e = this.getSourceModel(t)) && e.set && e.set("status", "freezed"), this.srcModel = e), Object(l.u)(a, "mousemove dragover", this.onMove), Object(l.u)(s, "mouseup dragend touchend", this.endMove), Object(l.u)(s, "keydown", this.rollback), c && c({
              target: e,
              parent: e && e.parent(),
              index: e && e.index()
            }), r && r.clearSelection(), this.toggleSortCursor(1), r && r.trigger("sorter:drag:start", t, e);
          },
          getTargetModel: function getTargetModel(t) {
            var e = t || this.target;
            return h(e).data("model");
          },
          getSourceModel: function getSourceModel(t) {
            var e = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.target,
              i = n.avoidChildren,
              o = void 0 === i ? 1 : i,
              a = this.em,
              s = this.eV,
              c = t || s,
              l = this.dropModel,
              u = this.dropContent,
              f = function f(t) {
                return t && r && t.opt && t.opt.avoidChildren && e.isTextableActive(t, r);
              };
            if (u && a) {
              if (f(l) && (l = null), !l) {
                var p = a.get("DomComponents").getComponents(),
                  g = {
                    avoidChildren: o,
                    avoidStore: 1,
                    avoidUpdateStyle: 1
                  },
                  v = p.add(u, d(d({}, g), {}, {
                    temporary: 1
                  }));
                if (l = (l = p.remove(v, g)) instanceof Array ? l[0] : l, this.dropModel = l, f(l)) return this.getSourceModel(c, {
                  target: r,
                  avoidChildren: 0
                });
              }
              return l;
            }
            return c && h(c).data("model");
          },
          selectTargetModel: function selectTargetModel(t, e) {
            if (!(t instanceof s.a.Collection || e && e === t)) {
              var n = this.targetModel;
              n && n !== this.srcModel && n.set("status", ""), t && t.set && (t.set("status", "selected-parent"), this.targetModel = t);
            }
          },
          onMove: function onMove(t) {
            var e = t,
              n = this.em,
              r = this.onMoveClb,
              i = this.plh;
            this.moved = 1;
            var o = i.style.display;
            o && "none" !== o || (i.style.display = "block");
            var a = this.offset(this.el);
            this.elT = this.wmargin ? Math.abs(a.top) : a.top, this.elL = this.wmargin ? Math.abs(a.left) : a.left;
            var s = t.pageY - this.elT + this.el.scrollTop,
              l = t.pageX - this.elL + this.el.scrollLeft;
            if (this.canvasRelative && n) {
              var u = n.get("Canvas").getMouseRelativeCanvas(t, {
                noScroll: 1
              });
              l = u.x, s = u.y;
            }
            this.rX = l, this.rY = s, this.eventMove = t;
            var d = this.getSourceModel(),
              f = this.dimsFromTarget(t.target, l, s),
              p = this.target,
              g = p && this.getTargetModel(p);
            if (this.selectTargetModel(g, d), g || (i.style.display = "none"), p) {
              this.lastDims = f;
              var v = this.findPosition(f, l, s);
              this.isTextableActive(d, g) ? (this.activeTextModel = g, this.setContentEditable(g, !0), i.style.display = "none", this.lastPos = v, this.updateTextViewCursorPosition(e)) : (this.disableTextable(), this.activeTextModel = null, this.lastPos && this.lastPos.index == v.index && this.lastPos.method == v.method || (this.movePlaceholder(this.plh, f, v, this.prevTargetDim), this.$plh || (this.$plh = h(this.plh)), this.canvasRelative || (this.offTop && this.$plh.css("top", "+=" + this.offTop + "px"), this.offLeft && this.$plh.css("left", "+=" + this.offLeft + "px")), this.lastPos = v)), Object(c.isFunction)(r) && r({
                event: t,
                target: d,
                parent: g,
                index: v.index + ("after" == v.method ? 1 : 0)
              }), n && n.trigger("sorter:drag", {
                target: p,
                targetModel: g,
                sourceModel: d,
                dims: f,
                pos: v,
                x: l,
                y: s
              });
            }
          },
          isTextableActive: function isTextableActive(t, e) {
            return t && t.get && t.get("textable") && e && e.is("text");
          },
          disableTextable: function disableTextable() {
            var t = this.activeTextModel;
            t && t.getView().disableEditing();
          },
          isInFlow: function isInFlow(t, e) {
            if (!t) return !1;
            e = e || document.body;
            var n = t;
            return n.offsetHeight, !!this.styleInFlow(n, e);
          },
          styleInFlow: function styleInFlow(t, e) {
            if (!Object(l.q)(t)) {
              var n = t.style || {},
                r = h(t),
                i = e && h(e);
              if (!(n.overflow && "visible" !== n.overflow || "none" !== r.css("float") || i && "flex" == i.css("display") && "column" !== i.css("flex-direction"))) {
                switch (n.position) {
                  case "static":
                  case "relative":
                  case "":
                    break;
                  default:
                    return;
                }
                switch (t.tagName) {
                  case "TR":
                  case "TBODY":
                  case "THEAD":
                  case "TFOOT":
                    return !0;
                }
                switch (r.css("display")) {
                  case "block":
                  case "list-item":
                  case "table":
                  case "flex":
                    return !0;
                }
              }
            }
          },
          validTarget: function validTarget(t, e) {
            var n = this.getTargetModel(t),
              r = this.getSourceModel(e, {
                target: n
              }),
              i = {
                valid: !0,
                src: e = r && r.view && r.view.el,
                srcModel: r,
                trg: t = n && n.view && n.view.el,
                trgModel: n
              };
            if (!e || !t) return i.valid = !1, i;
            var o = r.get("draggable");
            o = o instanceof Array ? o.join(", ") : o, i.dragInfo = o, o = Object(c.isString)(o) ? this.matches(t, o) : o, i.draggable = o;
            var a = n.get("droppable");
            return a = (a = a instanceof s.a.Collection ? 1 : a) instanceof Array ? a.join(", ") : a, i.dropInfo = a, a = Object(c.isString)(a) ? this.matches(e, a) : a, a = o && this.isTextableActive(r, n) ? 1 : a, i.droppable = a, a && o || (i.valid = !1), i;
          },
          dimsFromTarget: function dimsFromTarget(t, e, n) {
            var r = this.em,
              i = [];
            if (!t) return i;
            if (this.matches(t, "".concat(this.itemSel, ", ").concat(this.containerSel)) || (t = this.closest(t, this.itemSel)), this.draggable instanceof Array && (t = this.closest(t, this.draggable.join(","))), !t) return i;
            if (this.prevTarget && this.prevTarget != t && (this.prevTarget = null), !this.prevTarget) {
              this.targetP = this.closest(t, this.containerSel);
              var o = this.validTarget(t);
              if (r && r.trigger("sorter:drag:validation", o), !o.valid && this.targetP) return this.dimsFromTarget(this.targetP, e, n);
              this.prevTarget = t, this.prevTargetDim = this.getDim(t), this.cacheDimsP = this.getChildrenDim(this.targetP), this.cacheDims = this.getChildrenDim(t);
            }
            if (this.prevTarget == t && (i = this.cacheDims), this.target = this.prevTarget, this.nearBorders(this.prevTargetDim, e, n) || !this.nested && !this.cacheDims.length) {
              var a = this.targetP;
              a && this.validTarget(a).valid && (i = this.cacheDimsP, this.target = a);
            }
            return this.lastPos = null, i;
          },
          getTargetFromEl: function getTargetFromEl(t) {
            var e,
              n = t,
              r = this.targetPrev,
              i = this.em,
              o = this.containerSel,
              a = this.itemSel;
            if (this.matches(n, "".concat(a, ", ").concat(o)) || (n = this.closest(n, a)), this.draggable instanceof Array && (n = this.closest(n, this.draggable.join(","))), r && r != n && (this.targetPrev = ""), !this.targetPrev) {
              e = this.closest(n, o);
              var s = this.validTarget(n);
              if (i && i.trigger("sorter:drag:validation", s), !s.valid && e) return this.getTargetFromEl(e);
              this.targetPrev = n;
            }
            return this.nearElBorders(n) && (e = this.closest(n, o)) && this.validTarget(e).valid && (n = e), n;
          },
          nearElBorders: function nearElBorders(t) {
            var e = t.getBoundingClientRect(),
              n = t.ownerDocument.body,
              r = this.getCurrentPos(),
              i = r.x,
              o = r.y,
              a = e.top + n.scrollTop,
              s = e.left + n.scrollLeft,
              c = e.width,
              l = e.height;
            if (o < a + 10 || o > a + l - 10 || i < s + 10 || i > s + c - 10) return 1;
          },
          getCurrentPos: function getCurrentPos() {
            var t = this.eventMove;
            return {
              x: t.pageX || 0,
              y: t.pageY || 0
            };
          },
          getDim: function getDim(t) {
            var e,
              n,
              r,
              i,
              o = this.em;
            if (this.canvasRelative && o) {
              var a = o.get("Canvas"),
                s = a.getElementPos(t, {
                  noScroll: 1
                }),
                c = a.getElementOffsets(t);
              e = s.top - c.marginTop, n = s.left - c.marginLeft, r = s.height + c.marginTop + c.marginBottom, i = s.width + c.marginLeft + c.marginRight;
            } else {
              var l = this.offset(t);
              e = this.relative ? t.offsetTop : l.top - (this.wmargin ? -1 : 1) * this.elT, n = this.relative ? t.offsetLeft : l.left - (this.wmargin ? -1 : 1) * this.elL, r = t.offsetHeight, i = t.offsetWidth;
            }
            return [e, n, r, i];
          },
          getChildrenDim: function getChildrenDim(t) {
            var e = this,
              n = [];
            if (!t) return n;
            var r = this.getTargetModel(t);
            if (r && r.view && !this.ignoreViewChildren) {
              var i = r.getCurrentView ? r.getCurrentView() : r.view;
              t = i.getChildrenContainer();
            }
            return Object(c.each)(t.children, function (r, i) {
              var o = Object(l.g)(r, h),
                a = o && o.index ? o.index() : i;
              if (Object(l.q)(r) || e.matches(r, e.itemSel)) {
                var s = e.getDim(r),
                  c = e.direction;
                c = "v" == c || "h" != c && e.isInFlow(r, t), s.push(c, r, a), n.push(s);
              }
            }), n;
          },
          nearBorders: function nearBorders(t, e, n) {
            var r = 0,
              i = this.borderOffset,
              o = e || 0,
              a = n || 0,
              s = t[0],
              c = t[1],
              l = t[2],
              u = t[3];
            return (s + i > a || a > s + l - i || c + i > o || o > c + u - i) && (r = 1), !!r;
          },
          findPosition: function findPosition(t, e, n) {
            for (var r = {
                index: 0,
                indexEl: 0,
                method: "before"
              }, i = 0, o = 0, a = 0, s = 0, c = 0, l = 0, u = 0, d = 0, h = 0, f = t.length; h < f; h++) if (a = (d = t[h])[1] + d[3], u = d[0] + d[2], c = d[1] + d[3] / 2, l = d[0] + d[2] / 2, !(o && d[1] > o || s && l >= s || i && a < i)) if (r.index = h, r.indexEl = d[6], d[4]) {
              if (n < l) {
                r.method = "before";
                break;
              }
              r.method = "after";
            } else n < u && (s = u), e < c ? (o = c, r.method = "before") : (i = c, r.method = "after");
            return r;
          },
          movePlaceholder: function movePlaceholder(t, e, n, r) {
            var i = 0,
              o = 0,
              a = 0,
              s = 0,
              c = "px",
              l = n.method,
              u = e[n.index];
            if (t.classList.remove("vertical"), t.classList.add("horizontal"), u) u[4] ? (a = u[3] + c, s = "auto", i = "before" == l ? u[0] - 0 : u[0] + u[2] - 0, o = u[1]) : (a = "auto", s = u[2] - 0 + c, i = u[0] + 0, o = "before" == l ? u[1] - 0 : u[1] + u[3] - 0, t.classList.remove("horizontal"), t.classList.add("vertical"));else {
              if (!this.nested) return void (t.style.display = "none");
              r && (i = r[0] + 5, o = r[1] + 5, a = parseInt(r[3]) - 10 + c, s = "auto");
            }
            t.style.top = i + c, t.style.left = o + c, a && (t.style.width = a), s && (t.style.height = s);
          },
          endMove: function endMove(t) {
            var e,
              n = this,
              r = this.eV,
              i = [],
              o = this.getDocuments(),
              a = this.getContainerEl(),
              s = this.onEndMove,
              u = this.target,
              h = this.lastPos;
            if (Object(l.t)(a, "mousemove dragover", this.onMove), Object(l.t)(o, "mouseup dragend touchend", this.endMove), Object(l.t)(o, "keydown", this.rollback), this.plh.style.display = "none", r && (e = this.getSourceModel(), this.selectOnEnd && e && e.set && (e.set("status", ""), e.set("status", "selected"))), this.moved) {
              var f = this.toMove;
              (Object(c.isArray)(f) ? f : f ? [f] : [r]).forEach(function (t) {
                i.push(n.move(u, t, h));
              });
            }
            this.plh && (this.plh.style.display = "none");
            var p = this.dragHelper;
            if (p && (p.parentNode.removeChild(p), this.dragHelper = null), this.disableTextable(), this.selectTargetModel(), this.toggleSortCursor(), this.toMove = null, this.eventMove = 0, this.dropModel = null, Object(c.isFunction)(s)) {
              var g = {
                target: e,
                parent: e && e.parent(),
                index: e && e.index()
              };
              i.length ? i.forEach(function (t) {
                return s(t, n, g);
              }) : s(null, this, d(d({}, g), {}, {
                cancelled: 1
              }));
            }
          },
          move: function move(t, e, n) {
            var r = this.em,
              i = this.activeTextModel,
              o = this.dropContent,
              a = Object(l.e)(e);
            r && r.trigger("component:dragEnd:before", t, a, n);
            var c,
              u,
              f,
              p = [],
              g = n.indexEl,
              v = this.validTarget(t, a),
              m = h(t).data("collection"),
              b = v.srcModel,
              y = v.droppable,
              w = v.draggable,
              x = v.dropInfo,
              O = v.dragInfo,
              C = v.trgModel;
            y = C instanceof s.a.Collection ? 1 : y;
            var S = this.isTextableActive(b, C);
            if (m && y && w) {
              var k = {
                at: g = "after" === n.method ? g + 1 : g,
                noIncrement: 1
              };
              if (o ? (c = o, k.silent = !1, k.avoidUpdateStyle = 1) : (k.temporary = 1, u = m.add({}, d({}, k)), b.collection && (c = b.collection.remove(b, {
                temporary: 1
              }))), S) {
                var T = i.getView();
                i.trigger("active");
                var j = T.activeRte,
                  E = b.getEl();
                delete b.opt.temporary, b.getView().render(), E.setAttribute("data-gjs-textable", "true");
                var P = E.outerHTML;
                j.insertHTML && j.insertHTML(P);
              } else f = m.add(c, k);
              o ? this.dropContent = null : m.remove(u), this.prevTarget = null;
            } else m || p.push("Target collection not found"), y || p.push("Target is not droppable, accepts [".concat(x, "]")), w || p.push("Component not draggable, acceptable by [".concat(O, "]")), console.warn("Invalid target position: " + p.join(", "));
            return r && r.trigger("component:dragEnd", m, c, p), r && r.trigger("sorter:drag:end", {
              targetCollection: m,
              modelToDrop: c,
              warns: p,
              validResult: v,
              dst: t,
              srcEl: a
            }), f;
          },
          rollback: function rollback(t) {
            Object(l.t)(this.getDocuments(), "keydown", this.rollback), 27 == (t.which || t.keyCode) && (this.moved = 0, this.endMove());
          }
        }),
        p = n(15),
        g = n.n(p),
        v = n(16),
        m = n.n(v);
      function b(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function y(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? b(Object(n), !0).forEach(function (e) {
            o()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var w = {
          mousePosFetcher: null,
          updateTarget: null,
          ratioDefault: 0,
          posFetcher: null,
          onStart: null,
          onMove: null,
          onEnd: null,
          onUpdateContainer: function onUpdateContainer() {},
          step: 1,
          minDim: 32,
          maxDim: "",
          unitHeight: "px",
          unitWidth: "px",
          keyHeight: "height",
          keyWidth: "width",
          currentUnit: 1,
          silentFrames: 0,
          avoidContainerUpdate: 0,
          keepAutoHeight: !1,
          keepAutoWidth: !1,
          autoHeight: !1,
          autoWidth: !1,
          tl: 1,
          tc: 1,
          tr: 1,
          cl: 1,
          cr: 1,
          bl: 1,
          bc: 1,
          br: 1
        },
        x = function x(t, e) {
          var n = e || window,
            r = t.getBoundingClientRect();
          return {
            left: r.left + n.pageXOffset,
            top: r.top + n.pageYOffset,
            width: r.width,
            height: r.height
          };
        },
        O = function () {
          function t() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return g()(this, t), this.setOptions(e), Object(c.bindAll)(this, "handleKeyDown", "handleMouseDown", "move", "stop"), this;
          }
          return m()(t, [{
            key: "getConfig",
            value: function value() {
              return this.opts;
            }
          }, {
            key: "setOptions",
            value: function value() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              this.opts = Object(c.defaults)(t, w), this.setup();
            }
          }, {
            key: "setup",
            value: function value() {
              var t = this.opts,
                e = t.prefix || "",
                n = t.appendTo || document.body,
                r = this.container;
              for (r || ((r = document.createElement("div")).className = "".concat(e, "resizer-c"), n.appendChild(r), this.container = r); r.firstChild;) r.removeChild(r.firstChild);
              var i = {};
              for (var o in ["tl", "tc", "tr", "cl", "cr", "bl", "bc", "br"].forEach(function (e) {
                return i[e] = t[e] ? function (t, e) {
                  var n = e.prefix || "",
                    r = document.createElement("i");
                  return r.className = n + "resizer-h " + n + "resizer-h-" + t, r.setAttribute("data-" + n + "handler", t), r;
                }(e, t) : "";
              }), i) {
                var a = i[o];
                a && r.appendChild(a);
              }
              this.handlers = i, this.mousePosFetcher = t.mousePosFetcher, this.updateTarget = t.updateTarget, this.posFetcher = t.posFetcher, this.onStart = t.onStart, this.onMove = t.onMove, this.onEnd = t.onEnd, this.onUpdateContainer = t.onUpdateContainer;
            }
          }, {
            key: "toggleFrames",
            value: function value(t) {
              if (this.opts.silentFrames) {
                var e = document.querySelectorAll("iframe");
                Object(c.each)(e, function (e) {
                  return e.style.pointerEvents = t ? "none" : "";
                });
              }
            }
          }, {
            key: "isHandler",
            value: function value(t) {
              var e = this.handlers;
              for (var n in e) if (e[n] === t) return !0;
              return !1;
            }
          }, {
            key: "getFocusedEl",
            value: function value() {
              return this.el;
            }
          }, {
            key: "getDocumentEl",
            value: function value() {
              return [this.el.ownerDocument, document];
            }
          }, {
            key: "getElementPos",
            value: function value(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = this.posFetcher || "";
              return n ? n(t, e) : x(t);
            }
          }, {
            key: "focus",
            value: function value(t) {
              t && t === this.el || (this.el = t, this.updateContainer({
                forceShow: 1
              }), Object(l.u)(this.getDocumentEl(), "mousedown", this.handleMouseDown));
            }
          }, {
            key: "blur",
            value: function value() {
              this.container.style.display = "none", this.el && (Object(l.t)(this.getDocumentEl(), "mousedown", this.handleMouseDown), this.el = null);
            }
          }, {
            key: "start",
            value: function value(t) {
              if (0 === t.button) {
                t.preventDefault(), t.stopPropagation();
                var e = this.el,
                  n = this.opts || {},
                  r = "data-" + n.prefix + "handler",
                  i = this.getElementPos(e, {
                    target: "el"
                  });
                this.handlerAttr = t.target.getAttribute(r), this.clickedHandler = t.target, this.startDim = {
                  t: i.top,
                  l: i.left,
                  w: i.width,
                  h: i.height
                }, this.rectDim = {
                  t: i.top,
                  l: i.left,
                  w: i.width,
                  h: i.height
                }, this.startPos = {
                  x: t.clientX,
                  y: t.clientY
                };
                var o = this.getDocumentEl();
                Object(l.u)(o, "mousemove", this.move), Object(l.u)(o, "keydown", this.handleKeyDown), Object(l.u)(o, "mouseup", this.stop), Object(c.isFunction)(this.onStart) && this.onStart(t, {
                  docs: o,
                  config: n,
                  el: e,
                  resizer: this
                }), this.toggleFrames(1), this.move(t);
              }
            }
          }, {
            key: "move",
            value: function value(t) {
              var e = this.onMove,
                n = this.mousePosFetcher,
                r = n ? n(t) : {
                  x: t.clientX,
                  y: t.clientY
                };
              this.currentPos = r, this.delta = {
                x: r.x - this.startPos.x,
                y: r.y - this.startPos.y
              }, this.keys = {
                shift: t.shiftKey,
                ctrl: t.ctrlKey,
                alt: t.altKey
              }, this.rectDim = this.calc(this), this.updateRect(0), e && e(t), 0 === t.which && this.stop(t);
            }
          }, {
            key: "stop",
            value: function value(t) {
              var e = this.opts,
                n = this.getDocumentEl();
              Object(l.t)(n, "mousemove", this.move), Object(l.t)(n, "keydown", this.handleKeyDown), Object(l.t)(n, "mouseup", this.stop), this.updateRect(1), this.toggleFrames(), Object(c.isFunction)(this.onEnd) && this.onEnd(t, {
                docs: n,
                config: e
              });
            }
          }, {
            key: "updateRect",
            value: function value(t) {
              var e = this.el,
                n = this.opts,
                r = this.rectDim,
                i = this.updateTarget,
                o = this.getSelectedHandler(),
                a = n.unitHeight,
                s = n.unitWidth,
                l = n.keyWidth,
                u = n.keyHeight;
              if (Object(c.isFunction)(i)) i(e, r, {
                store: t,
                selectedHandler: o,
                resizer: this,
                config: n
              });else {
                var d = e.style;
                d[l] = r.w + s, d[u] = r.h + a;
              }
              this.updateContainer();
            }
          }, {
            key: "updateContainer",
            value: function value() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = this.opts,
                n = this.container,
                r = this.el,
                i = n.style;
              !e.avoidContainerUpdate && r && t.forceShow && (i.display = "block"), this.onUpdateContainer({
                el: n,
                resizer: this,
                opts: y(y({}, e), t)
              });
            }
          }, {
            key: "getSelectedHandler",
            value: function value() {
              var t = this.handlers;
              if (this.selectedHandler) for (var e in t) if (t[e] === this.selectedHandler) return e;
            }
          }, {
            key: "handleKeyDown",
            value: function value(t) {
              27 === t.keyCode && (this.rectDim = this.startDim, this.stop(t));
            }
          }, {
            key: "handleMouseDown",
            value: function value(t) {
              var e = t.target;
              this.isHandler(e) ? (this.selectedHandler = e, this.start(t)) : e !== this.el && (this.selectedHandler = "", this.blur());
            }
          }, {
            key: "calc",
            value: function value(t) {
              var e,
                n = this.opts || {},
                r = n.step,
                i = this.startDim,
                o = n.minDim,
                a = n.maxDim,
                s = t.delta.x,
                c = t.delta.y,
                u = i.w,
                d = i.h,
                h = {
                  t: 0,
                  l: 0,
                  w: u,
                  h: d
                };
              if (t) {
                var f = t.handlerAttr;
                ~f.indexOf("r") && (e = Object(l.s)(u + s * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.w = e), ~f.indexOf("b") && (e = Object(l.s)(d + c * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.h = e), ~f.indexOf("l") && (e = Object(l.s)(u - s * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.w = e), ~f.indexOf("t") && (e = Object(l.s)(d - c * r, r), e = Math.max(o, e), a && (e = Math.min(a, e)), h.h = e);
                var p = n.ratioDefault ? !t.keys.shift : t.keys.shift;
                if (f.indexOf("c") < 0 && p) {
                  var g = i.w / i.h;
                  h.w / h.h > g ? h.h = Math.round(h.w / g) : h.w = Math.round(h.h * g);
                }
                return ~f.indexOf("l") && (h.l = i.w - h.w), ~f.indexOf("t") && (h.t = i.h - h.h), h;
              }
            }
          }]), t;
        }(),
        C = {
          init: function init(t) {
            return new O(t);
          }
        };
      e.default = function () {
        return {
          name: "Utils",
          init: function init() {
            return this;
          },
          Sorter: f,
          Resizer: C,
          Dragger: r.a
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(8),
        a = n.n(o),
        s = n(0),
        c = {
          placeholder: "eg. Text here"
        },
        l = {
          locale: "en",
          localeFallback: "en",
          detectLocale: 1,
          debug: 0,
          messages: {
            en: {
              assetManager: {
                addButton: "Add image",
                inputPlh: "http://path/to/the/image.jpg",
                modalTitle: "Select Image",
                uploadTitle: "Drop files here or click to upload"
              },
              blockManager: {
                labels: {},
                categories: {}
              },
              domComponents: {
                names: {
                  "": "Box",
                  wrapper: "Body",
                  text: "Text",
                  comment: "Comment",
                  image: "Image",
                  video: "Video",
                  audio: "Audio",
                  label: "Label",
                  link: "Link",
                  map: "Map",
                  tfoot: "Table foot",
                  tbody: "Table body",
                  thead: "Table head",
                  table: "Table",
                  row: "Table row",
                  cell: "Table cell"
                }
              },
              deviceManager: {
                device: "Device",
                devices: {
                  desktop: "Desktop",
                  tablet: "Tablet",
                  mobileLandscape: "Mobile Landscape",
                  mobilePortrait: "Mobile Portrait"
                }
              },
              panels: {
                buttons: {
                  titles: {
                    preview: "Preview",
                    fullscreen: "Fullscreen",
                    "sw-visibility": "View components",
                    "export-template": "View code",
                    "open-sm": "Open Style Manager",
                    "open-tm": "Settings",
                    "open-layers": "Open Layer Manager",
                    "open-blocks": "Open Blocks"
                  }
                }
              },
              selectorManager: {
                label: "Classes",
                selected: "Selected",
                emptyState: "- State -",
                states: {
                  hover: "Hover",
                  active: "Click",
                  "nth-of-type(2n)": "Even/Odd"
                }
              },
              styleManager: {
                empty: "Select an element before using Style Manager",
                layer: "Layer",
                fileButton: "Images",
                sectors: {
                  general: "General",
                  layout: "Layout",
                  typography: "Typography",
                  decorations: "Decorations",
                  extra: "Extra",
                  flex: "Flex",
                  dimension: "Dimension"
                },
                properties: {}
              },
              traitManager: {
                empty: "Select an element before using Trait Manager",
                label: "Component settings",
                traits: {
                  labels: {},
                  attributes: {
                    id: c,
                    alt: c,
                    title: c,
                    href: {
                      placeholder: "eg. https://google.com"
                    }
                  },
                  options: {
                    target: {
                      false: "This window",
                      _blank: "New window"
                    }
                  }
                }
              }
            }
          }
        };
      function u(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function d(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var h = function h(t) {
        return !Array.isArray(t) && null !== t && "object" === a()(t);
      };
      e.default = function () {
        return {
          name: "I18n",
          config: l,
          init: function init() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this.config = d(d(d({}, l), t), {}, {
              messages: d(d({}, l.messages), t.messages || {})
            }), this.config.detectLocale && (this.config.locale = this._localLang()), this.em = t.em, this;
          },
          getConfig: function getConfig() {
            return this.config;
          },
          setLocale: function setLocale(t) {
            var e = this.em,
              n = this.config,
              r = {
                value: t,
                valuePrev: n.locale
              };
            return e && e.trigger("i18n:locale", r), n.locale = t, this;
          },
          getLocale: function getLocale() {
            return this.config.locale;
          },
          getMessages: function getMessages(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.config.messages;
            return t && !n[t] && this._debug("'".concat(t, "' i18n lang not found"), e), t ? n[t] : n;
          },
          setMessages: function setMessages(t) {
            var e = this.em;
            return this.config.messages = t, e && e.trigger("i18n:update", t), this;
          },
          addMessages: function addMessages(t) {
            var e = this.em,
              n = this.config.messages;
            return e && e.trigger("i18n:add", t), this.setMessages(function t() {
              for (var e = d({}, arguments.length <= 0 ? void 0 : arguments[0]), n = 1; n < arguments.length; n++) {
                var r = d({}, n < 0 || arguments.length <= n ? void 0 : arguments[n]);
                for (var i in r) {
                  var o = e[i],
                    a = r[i];
                  h(o) && h(a) ? e[i] = t(o, a) : e[i] = a;
                }
              }
              return e;
            }(n, t)), this;
          },
          t: function t(_t10) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.config,
              r = e.params || {},
              i = e.l || this.getLocale(),
              o = e.lFlb || n.localeFallback,
              a = this._getMsg(_t10, i, e);
            return a || (a = this._getMsg(_t10, o, e)), !a && this._debug("'".concat(_t10, "' i18n key not found in '").concat(i, "' lang"), e), a && Object(s.isString)(a) ? this._addParams(a, r) : a;
          },
          _localLang: function _localLang() {
            var t = window.navigator || {},
              e = t.language || t.userLanguage;
            return e ? e.split("-")[0] : "en";
          },
          _addParams: function _addParams(t, e) {
            var n = new RegExp("{([\\w\\d-]*)}", "g");
            return t.replace(n, function (t, n) {
              return e[n] || "";
            }).trim();
          },
          _getMsg: function _getMsg(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = this.getMessages(e, n);
            if (r) {
              var i = r[t];
              return !i && t.indexOf(".") > 0 && (i = t.split(".").reduce(function (t, e) {
                if (!Object(s.isUndefined)(t)) return t[e];
              }, r)), i;
            }
          },
          _debug: function _debug(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.em,
              r = this.config;
            (e.debug || r.debug) && n && n.logWarning(t);
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(9),
        i = n.n(r),
        o = n(2),
        a = n.n(o),
        s = n(15),
        c = n.n(s),
        l = n(16),
        u = n.n(l),
        d = n(3);
      function h(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function f(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? h(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      var p = 1,
        g = 0,
        v = -1,
        m = function m(t) {
          var e = t.selection().anchorNode,
            n = e && e.parentNode,
            r = e && e.nextSibling;
          return n && "A" == n.nodeName || r && "A" == r.nodeName;
        },
        b = {
          bold: {
            name: "bold",
            icon: "<b>B</b>",
            attributes: {
              title: "Bold"
            },
            result: function result(t) {
              return t.exec("bold");
            }
          },
          italic: {
            name: "italic",
            icon: "<i>I</i>",
            attributes: {
              title: "Italic"
            },
            result: function result(t) {
              return t.exec("italic");
            }
          },
          underline: {
            name: "underline",
            icon: "<u>U</u>",
            attributes: {
              title: "Underline"
            },
            result: function result(t) {
              return t.exec("underline");
            }
          },
          strikethrough: {
            name: "strikethrough",
            icon: "<s>S</s>",
            attributes: {
              title: "Strike-through"
            },
            result: function result(t) {
              return t.insertHTML("<s>".concat(t.selection(), "</s>"));
            }
          },
          link: {
            icon: '<span style="transform:rotate(45deg)">&supdsub;</span>',
            name: "link",
            attributes: {
              style: "font-size:1.4rem;padding:0 4px 2px;",
              title: "Link"
            },
            state: function state(t, e) {
              return t && t.selection() && m(t) ? p : g;
            },
            result: function result(t) {
              m(t) ? t.exec("unlink") : t.insertHTML('<a class="link" href="">'.concat(t.selection(), "</a>"));
            }
          }
        },
        y = function () {
          function t() {
            var e = this,
              n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            c()(this, t);
            var r = n.el;
            if (r._rte) return r._rte;
            r._rte = this, this.setEl(r), this.updateActiveActions = this.updateActiveActions.bind(this);
            var i = n.actions || [];
            i.forEach(function (t, e) {
              "string" == typeof t ? t = b[t] : b[t.name] && (t = f(f({}, b[t.name]), t)), i[e] = t;
            });
            var o = i.length ? i : Object.keys(b).map(function (t) {
              return b[t];
            });
            n.classes = f(f({}, {
              actionbar: "actionbar",
              button: "action",
              active: "active",
              disabled: "disabled",
              inactive: "inactive"
            }), n.classes);
            var a = n.classes,
              s = n.actionbar;
            if (this.actionbar = s, this.settings = n, this.classes = a, this.actions = o, !s) {
              var l = n.actionbarContainer;
              (s = document.createElement("div")).className = a.actionbar, l.appendChild(s), this.actionbar = s, o.forEach(function (t) {
                return e.addAction(t);
              });
            }
            return n.styleWithCSS && this.exec("styleWithCSS"), this.syncActions(), this;
          }
          return u()(t, [{
            key: "destroy",
            value: function value() {
              this.el = 0, this.doc = 0, this.actionbar = 0, this.settings = {}, this.classes = {}, this.actions = [];
            }
          }, {
            key: "setEl",
            value: function value(t) {
              this.el = t, this.doc = t.ownerDocument;
            }
          }, {
            key: "updateActiveActions",
            value: function value() {
              var t = this;
              this.getActions().forEach(function (e) {
                var n = e.btn,
                  r = e.update,
                  i = f({}, t.classes),
                  o = i.active,
                  a = i.inactive,
                  s = i.disabled,
                  c = e.state,
                  l = e.name,
                  u = t.doc;
                if (n.className = n.className.replace(o, "").trim(), n.className = n.className.replace(a, "").trim(), n.className = n.className.replace(s, "").trim(), c) switch (c(t, u)) {
                  case p:
                    n.className += " ".concat(o);
                    break;
                  case g:
                    n.className += " ".concat(a);
                    break;
                  case v:
                    n.className += " ".concat(s);
                } else u.queryCommandSupported(l) && u.queryCommandState(l) && (n.className += " ".concat(o));
                r && r(t, e);
              });
            }
          }, {
            key: "enable",
            value: function value() {
              return this.enabled || (this.actionbarEl().style.display = "", this.el.contentEditable = !0, Object(d.u)(this.el, "mouseup keyup", this.updateActiveActions), this.syncActions(), this.updateActiveActions(), this.el.focus(), this.enabled = 1), this;
            }
          }, {
            key: "disable",
            value: function value() {
              return this.actionbarEl().style.display = "none", this.el.contentEditable = !1, Object(d.t)(this.el, "mouseup keyup", this.updateActiveActions), this.enabled = 0, this;
            }
          }, {
            key: "syncActions",
            value: function value() {
              var t = this;
              this.getActions().forEach(function (e) {
                if (t.settings.actionbar && (!e.state || e.state && e.state(t, t.doc) >= 0)) {
                  var n = e.event || "click";
                  e.btn["on".concat(n)] = function (n) {
                    e.result(t, e), t.updateActiveActions();
                  };
                }
              });
            }
          }, {
            key: "addAction",
            value: function value(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = e.sync,
                r = document.createElement("span"),
                i = t.icon,
                o = t.attributes || {};
              for (var a in r.className = this.classes.button, t.btn = r, o) r.setAttribute(a, o[a]);
              "string" == typeof i ? r.innerHTML = i : r.appendChild(i), this.actionbarEl().appendChild(r), n && (this.actions.push(t), this.syncActions());
            }
          }, {
            key: "getActions",
            value: function value() {
              return this.actions;
            }
          }, {
            key: "selection",
            value: function value() {
              return this.doc.getSelection();
            }
          }, {
            key: "exec",
            value: function value(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
              this.doc.execCommand(t, !1, e);
            }
          }, {
            key: "actionbarEl",
            value: function value() {
              return this.actionbar;
            }
          }, {
            key: "insertHTML",
            value: function value(t) {
              var e = this.doc,
                n = e.getSelection();
              if (n && n.rangeCount) {
                var r = e.createElement("div"),
                  i = n.getRangeAt(0);
                i.deleteContents(), r.innerHTML = t, Array.prototype.slice.call(r.childNodes).forEach(function (t) {
                  i.insertNode(t);
                }), n.removeAllRanges(), n.addRange(i), this.el.focus();
              }
            }
          }]), t;
        }(),
        w = {
          stylePrefix: "rte-",
          adjustToolbar: 1,
          actions: ["bold", "italic", "underline", "strikethrough", "link"]
        };
      function x(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function O(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? x(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          r = {},
          o = function o() {
            var e = t.style;
            e.top = "-1000px", e.left = "-1000px", e.display = "none";
          };
        return {
          customRte: null,
          name: "RichTextEditor",
          getConfig: function getConfig() {
            return r;
          },
          init: function init() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              i = (r = O(O({}, w), e)).pStylePrefix;
            return i && (r.stylePrefix = i + r.stylePrefix), this.pfx = r.stylePrefix, r.actions, (t = document.createElement("div")).className = "".concat(i, "rte-toolbar ").concat(i, "one-bg"), n = this.initRte(document.createElement("div")), Object(d.u)(t, "mousedown", function (t) {
              return t.stopPropagation();
            }), this;
          },
          destroy: function destroy() {
            var e = this.customRte;
            n && n.destroy(), e && e.destroy && e.destroy(), t = 0, n = 0, this.actionbar = 0, this.actions = 0;
          },
          postRender: function postRender(e) {
            var n = e.model.get("Canvas");
            t.style.pointerEvents = "all", o(), n.getToolsEl().appendChild(t);
          },
          initRte: function initRte(e) {
            var o = this.pfx,
              a = t,
              s = this.actionbar,
              c = this.actions || i()(r.actions),
              l = {
                actionbar: "".concat(o, "actionbar"),
                button: "".concat(o, "action"),
                active: "".concat(o, "active"),
                inactive: "".concat(o, "inactive"),
                disabled: "".concat(o, "disabled")
              },
              u = new y({
                el: e,
                classes: l,
                actions: c,
                actionbar: s,
                actionbarContainer: a
              });
            return n && n.setEl(e), u.actionbar && (this.actionbar = u.actionbar), u.actions && (this.actions = u.actions), u;
          },
          add: function add(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            e.name = t, n.addAction(e, {
              sync: 1
            });
          },
          get: function get(t) {
            var e;
            return n.getActions().forEach(function (n) {
              n.name == t && (e = n);
            }), e;
          },
          getAll: function getAll() {
            return n.getActions();
          },
          remove: function remove(t) {
            var e = this.getAll(),
              n = this.get(t);
            if (n) {
              var r = n.btn,
                i = e.indexOf(n);
              r.parentNode.removeChild(r), e.splice(i, 1);
            }
            return n;
          },
          getToolbarEl: function getToolbarEl() {
            return t;
          },
          updatePosition: function updatePosition() {
            var n = r.em.get("Canvas"),
              i = t.style,
              o = n.getTargetToElementFixed(e, t, {
                event: "rteToolbarPosUpdate"
              });
            i.top = o.top + "px", i.left = "0px";
          },
          enable: function enable(n, i) {
            e = n.el;
            var o = r.em.get("Canvas"),
              a = r.em,
              s = n.getChildrenContainer(),
              c = this.customRte;
            if (o.getElementPos(e), t.style.display = "", i = c ? c.enable(s, i) : this.initRte(s).enable(), a) {
              setTimeout(this.updatePosition.bind(this), 0);
              var l = "change:canvasOffset canvasScroll frame:scroll component:update";
              a.off(l, this.updatePosition, this), a.on(l, this.updatePosition, this), a.trigger("rte:enable", n, i);
            }
            return i;
          },
          disable: function disable(t, e) {
            var n = r.em,
              i = this.customRte,
              a = t.getChildrenContainer();
            i ? i.disable(a, e) : e && e.disable(), o(), n && n.trigger("rte:disable", t, e);
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(2),
        i = n.n(r),
        o = n(0),
        a = {
          stylePrefix: "css-",
          staticRules: "",
          rules: []
        },
        s = n(34),
        c = n(33),
        l = n(37),
        u = n(12),
        d = n(10);
      function h(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function f(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? h(Object(n), !0).forEach(function (e) {
            i()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e,
          n,
          r = {};
        return {
          Selectors: u.a,
          name: "CssComposer",
          getConfig: function getConfig() {
            return r;
          },
          storageKey: function storageKey() {
            var t = [],
              e = r.stm && r.stm.getConfig() || {};
            return e.storeCss && t.push("css"), e.storeStyles && t.push("styles"), t;
          },
          init: function init(i) {
            for (var o in r = i || {}, a) o in r || (r[o] = a[o]);
            var s = r.pStylePrefix;
            s && (r.stylePrefix = s + r.stylePrefix);
            var u = r.em && r.em.config.style || "";
            return r.rules = u || r.rules, t = r.em, e = new c.a([], r), n = new l.a({
              collection: e,
              config: r
            }), this;
          },
          onLoad: function onLoad() {
            e.add(r.rules);
          },
          postLoad: function postLoad(t) {
            var e = this,
              n = "add remove",
              r = this.getAll(),
              i = t.get("UndoManager");
            i && i.add(r), t.stopListening(r, n, this.handleChange), t.listenTo(r, n, this.handleChange), r.each(function (t) {
              return e.handleChange(t, {
                avoidStore: 1
              });
            });
          },
          handleChange: function handleChange(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = "change:style",
              i = t.get("UndoManager");
            i && i.add(e);
            var o = t.handleUpdates.bind(t);
            t.stopListening(e, r, o), t.listenTo(e, r, o), !n.avoidStore && o("", "", n);
          },
          load: function load(t) {
            var n = t || "";
            !n && r.stm && (n = r.em.getCacheLoad());
            var i = n.styles || "";
            if (n.styles) try {
              i = JSON.parse(n.styles);
            } catch (t) {} else n.css && (i = r.em.get("Parser").parseCss(n.css));
            return Object(o.isArray)(i) ? i.length && e.reset(i) : i && e.reset(i), i;
          },
          store: function store(t) {
            if (r.stm) {
              var n = {},
                i = this.storageKey();
              return i.indexOf("css") >= 0 && (n.css = r.em.getCss()), i.indexOf("styles") >= 0 && (n.styles = JSON.stringify(e)), t || r.stm.store(n), n;
            }
          },
          add: function add(t, n, i) {
            var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              a = n || "",
              c = i || "",
              l = f({}, o),
              u = this.get(t, a, c, l);
            return u && u.config && !u.config.singleAtRule || (l.state = a, l.mediaText = c, l.selectors = [], (u = new s.a(l, r)).get("selectors").add(t), e.add(u)), u;
          },
          get: function get(t, n, r, i) {
            var o = null;
            return e.each(function (e) {
              o || e.compare(t, n, r, i) && (o = e);
            }), o;
          },
          getAll: function getAll() {
            return e;
          },
          clear: function clear() {
            return this.getAll().reset(), this;
          },
          addCollection: function addCollection(t) {
            for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = [], i = t instanceof Array ? t : [t], o = 0, a = i.length; o < a; o++) {
              var s = i[o] || {};
              if (s.selectors) {
                var c = r.em && r.em.get("SelectorManager");
                c || console.warn("Selector Manager not found");
                for (var l = s.selectors, u = l instanceof Array ? l : [l], d = [], h = 0, p = u.length; h < p; h++) {
                  var g = c.add(u[h]);
                  d.push(g);
                }
                var v = this.get(d, s.state, s.mediaText, s),
                  m = this.add(d, s.state, s.mediaText, s),
                  b = !v || !e.avoidUpdateStyle,
                  y = s.style || {};
                if (b) {
                  var w = e.extend ? f(f({}, m.get("style")), y) : y;
                  m.set("style", w);
                }
                n.push(m);
              }
            }
            return n;
          },
          setRule: function setRule(e, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = r.atRuleType,
              o = r.atRuleParams,
              a = t.get("Parser").parserCss.checkNode({
                selectors: e,
                style: n
              })[0],
              s = a.state,
              c = a.selectorsAdd,
              l = t.get("SelectorManager"),
              u = l.add(a.selectors),
              d = this.add(u, s, o, {
                selectorsAdd: c,
                atRule: i
              });
            return d.setStyle(n, r), d;
          },
          getRule: function getRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = t.get("SelectorManager"),
              i = t.get("Parser").parserCss.checkNode({
                selectors: e
              })[0],
              o = r.get(i.selectors),
              a = i.state,
              s = i.selectorsAdd,
              c = n.atRuleType,
              l = n.atRuleParams;
            return o && this.get(o, a, l, {
              selectorsAdd: s,
              atRule: c
            });
          },
          setIdRule: function setIdRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = r.state || "",
              o = r.mediaText || t.getCurrentMedia(),
              a = t.get("SelectorManager"),
              s = a.add({
                name: e,
                type: d.a.TYPE_ID
              }),
              c = this.add(s, i, o);
            return c.setStyle(n, r), c;
          },
          getIdRule: function getIdRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.state || "",
              i = n.mediaText || t.getCurrentMedia(),
              o = t.get("SelectorManager").get(e, d.a.TYPE_ID);
            return o && this.get(o, r, i);
          },
          setClassRule: function setClassRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = r.state || "",
              o = r.mediaText || t.getCurrentMedia(),
              a = t.get("SelectorManager"),
              s = a.add({
                name: e,
                type: d.a.TYPE_CLASS
              }),
              c = this.add(s, i, o);
            return c.setStyle(n, r), c;
          },
          getClassRule: function getClassRule(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.state || "",
              i = n.mediaText || t.getCurrentMedia(),
              o = t.get("SelectorManager").get(e, d.a.TYPE_CLASS);
            return o && this.get(o, r, i);
          },
          render: function render() {
            return n.render().el;
          }
        };
      };
    }, function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n(9),
        i = n.n(r),
        o = n(2),
        a = n.n(o),
        s = n(0),
        c = n(22),
        l = {
          stylePrefix: "com-",
          defaults: [],
          strict: 1
        },
        u = n(5);
      function d(t, e) {
        var n = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }
        return n;
      }
      function h(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? d(Object(n), !0).forEach(function (e) {
            a()(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }
        return t;
      }
      e.default = function () {
        var t,
          e = {},
          r = {},
          o = {},
          a = {},
          d = [["preview", "Preview", "preview"], ["resize", "Resize", "resize"], ["fullscreen", "Fullscreen", "fullscreen"], ["copy", "CopyComponent"], ["paste", "PasteComponent"], ["canvas-move", "CanvasMove"], ["canvas-clear", "CanvasClear"], ["open-code", "ExportTemplate", "export-template"], ["open-layers", "OpenLayers", "open-layers"], ["open-styles", "OpenStyleManager", "open-sm"], ["open-traits", "OpenTraitManager", "open-tm"], ["open-blocks", "OpenBlocks", "open-blocks"], ["open-assets", "OpenAssets", "open-assets"], ["save-db", "SaveDb", "save-db"], ["cmd-clear", "CanvasClear", "cmd-clear"], ["component-select", "SelectComponent", "select-comp"], ["component-outline", "SwitchVisibility", "sw-visibility"], ["component-offset", "ShowOffset", "show-offset"], ["component-move", "MoveComponent", "move-comp"], ["component-next", "ComponentNext"], ["component-prev", "ComponentPrev"], ["component-enter", "ComponentEnter"], ["component-exit", "ComponentExit", "select-parent"], ["component-delete", "ComponentDelete"], ["component-style-clear", "ComponentStyleClear"], ["component-drag", "ComponentDrag"], ["set-device-desktop", "DeviceDesktop", "set-device-desktop"], ["set-device-tablet", "DeviceTablet", "set-device-tablet"], ["set-device-mobile", "DeviceMobile", "set-device-mobile"], ["set-device-mobile-ptr", "DeviceMobilePtr", "set-device-mobile-ptr"]];
        return {
          CommandAbstract: c.default,
          name: "Commands",
          init: function init() {
            var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            e = h(h({}, l), r), t = e.em;
            var a = e.pStylePrefix;
            for (var c in a && (e.stylePrefix = a + e.stylePrefix), e.defaults) {
              var f = e.defaults[c];
              f.id && this.add(f.id, f);
            }
            return o["tlb-delete"] = {
              run: function run(t) {
                return t.runCommand("core:component-delete");
              }
            }, o["tlb-clone"] = {
              run: function run(t) {
                t.runCommand("core:copy"), t.runCommand("core:paste");
              }
            }, o["tlb-trait-setting"] = {
              run: function run(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                  r = n && n.event,
                  i = n.target,
                  o = (i || t.getSelected(), r.clientX, r.clientY, t.TraitManager),
                  a = o.getTraitsViewer();
                t.Popover.open({
                  title: "Settings",
                  content: a.render().el
                }).getModel().once("change:open");
              }
            }, o["tlb-move"] = {
              run: function run(t, e) {
                var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                  r = t.getModel(),
                  o = n && n.event,
                  a = n.target,
                  c = a || t.getSelected(),
                  l = a ? [a] : i()(t.getSelectedAll()),
                  d = o && "dragstart" == o.type,
                  h = {
                    preserveSelected: 1
                  },
                  f = ["absolute", "translate"],
                  p = c.get("dmode") || r.get("dmode"),
                  g = function g() {
                    return r.stopDefault(h);
                  },
                  v = Object(s.includes)(f, p);
                if (l.forEach(function (t) {
                  return t.trigger("disable");
                }), !c || !c.get("draggable")) return r.logWarning("The element is not draggable");
                d ? setTimeout(g, 0) : g();
                var m = function m(t) {
                    r.trigger("".concat(u.eventDrag, ":start"), t);
                  },
                  b = function b(t) {
                    r.trigger(u.eventDrag, t);
                  },
                  y = function y(e, n, i) {
                    r.runDefault(h), l.forEach(function (t) {
                      return t.set("status", "selected");
                    }), t.select(l), c.emitUpdate(), r.trigger("".concat(u.eventDrag, ":end"), i), (v || i.cancelled) && r.set("_cmpDrag", 1);
                  };
                if (v) t.runCommand("core:component-drag", {
                  guidesInfo: 1,
                  mode: p,
                  target: c,
                  onStart: m,
                  onDrag: b,
                  onEnd: y,
                  event: o
                });else {
                  d && o.dataTransfer.setDragImage(c.view.el, 0, 0);
                  var w = t.Commands.get("move-comp");
                  w.onStart = m, w.onDrag = b, w.onEndMoveFromModel = y, w.initSorterFromModels(l);
                }
                l.forEach(function (t) {
                  return t.set("status", "freezed-selected");
                });
              }
            }, o["core:undo"] = function (t) {
              return t.UndoManager.undo();
            }, o["core:redo"] = function (t) {
              return t.UndoManager.redo();
            }, d.forEach(function (e) {
              var r = e[2],
                i = n(99)("./".concat(e[1])).default,
                a = "core:".concat(e[0]);
              o[a] = i, r && (o[r] = i, ["run", "stop"].forEach(function (e) {
                t.on("".concat(e, ":").concat(r), function () {
                  for (var n, r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
                  return (n = t).trigger.apply(n, ["".concat(e, ":").concat(a)].concat(i));
                });
              }));
            }), e.em && (e.model = e.em.get("Canvas")), this.loadDefaultCommands(), this;
          },
          add: function add(t, e) {
            return Object(s.isFunction)(e) && (e = {
              run: e
            }), e.stop || (e.noStop = 1), delete e.initialize, e.id = t, r[t] = c.default.extend(e), this;
          },
          get: function get(n) {
            var i = r[n];
            return Object(s.isFunction)(i) ? (i = new i(e), r[n] = i) : i || t.logWarning("'".concat(n, "' command not found")), i;
          },
          extend: function extend(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.get(t);
            if (n) {
              var r = h(h({}, n.constructor.prototype), e);
              this.add(t, r);
              var i = d.filter(function (e) {
                return "core:".concat(e[0]) === t && e[2];
              })[0];
              i && this.add(i[2], r);
            }
            return this;
          },
          has: function has(t) {
            return !!r[t];
          },
          getAll: function getAll() {
            return r;
          },
          run: function run(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.runCommand(this.get(t), e);
          },
          stop: function stop(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return this.stopCommand(this.get(t), e);
          },
          isActive: function isActive(t) {
            return this.getActive().hasOwnProperty(t);
          },
          getActive: function getActive() {
            return a;
          },
          loadDefaultCommands: function loadDefaultCommands() {
            for (var t in o) this.add(t, o[t]);
            return this;
          },
          runCommand: function runCommand(n) {
            var r,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (n && n.run) {
              var o = n.id,
                s = t.get("Editor");
              this.isActive(o) && !i.force && e.strict || (r = n.callRun(s, i), o && n.stop && !n.noStop && !i.abort && (a[o] = r));
            }
            return r;
          },
          stopCommand: function stopCommand(n) {
            var r,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (n && n.run) {
              var o = n.id,
                s = t.get("Editor");
              (this.isActive(o) || i.force || !e.strict) && (o && delete a[o], r = n.callStop(s, i));
            }
            return r;
          },
          create: function create(t) {
            return t.stop || (t.noStop = 1), new (c.default.extend(t))(e);
          }
        };
      };
    }]).default);
  }, function (t, e) {
    var n,
      r,
      i = t.exports = {};
    function o() {
      throw new Error('setTimeout has not been defined');
    }
    function a() {
      throw new Error('clearTimeout has not been defined');
    }
    function s(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);
      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }
    !function () {
      try {
        n = 'function' == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }
      try {
        r = 'function' == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        r = a;
      }
    }();
    var c,
      l = [],
      u = !1,
      d = -1;
    function h() {
      u && c && (u = !1, c.length ? l = c.concat(l) : d = -1, l.length && f());
    }
    function f() {
      if (!u) {
        var t = s(h);
        u = !0;
        for (var e = l.length; e;) {
          for (c = l, l = []; ++d < e;) c && c[d].run();
          d = -1, e = l.length;
        }
        c = null, u = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);
          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }
    function p(t, e) {
      this.fun = t, this.array = e;
    }
    function g() {}
    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
      l.push(new p(t, e)), 1 !== l.length || u || s(f);
    }, p.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = 'browser', i.browser = !0, i.env = {}, i.argv = [], i.version = '', i.versions = {}, i.on = g, i.addListener = g, i.once = g, i.off = g, i.removeListener = g, i.removeAllListeners = g, i.emit = g, i.prependListener = g, i.prependOnceListener = g, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error('process.binding is not supported');
    }, i.cwd = function () {
      return '/';
    }, i.chdir = function (t) {
      throw new Error('process.chdir is not supported');
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r = n(11),
        i = n(12),
        o = n(13);
      function a() {
        return c.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }
      function s(t, e) {
        if (a() < e) throw new RangeError('Invalid typed array length');
        return c.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = c.prototype : (null === t && (t = new c(e)), t.length = e), t;
      }
      function c(t, e, n) {
        if (!(c.TYPED_ARRAY_SUPPORT || this instanceof c)) return new c(t, e, n);
        if ('number' == typeof t) {
          if ('string' == typeof e) throw new Error('If encoding is specified then the first argument must be a string');
          return d(this, t);
        }
        return l(this, t, e, n);
      }
      function l(t, e, n, r) {
        if ('number' == typeof e) throw new TypeError('"value" argument must not be a number');
        return 'undefined' != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, n, r) {
          if (e.byteLength, n < 0 || e.byteLength < n) throw new RangeError('\'offset\' is out of bounds');
          if (e.byteLength < n + (r || 0)) throw new RangeError('\'length\' is out of bounds');
          e = void 0 === n && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, n) : new Uint8Array(e, n, r);
          c.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = c.prototype : t = h(t, e);
          return t;
        }(t, e, n, r) : 'string' == typeof e ? function (t, e, n) {
          'string' == typeof n && '' !== n || (n = 'utf8');
          if (!c.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
          var r = 0 | p(e, n),
            i = (t = s(t, r)).write(e, n);
          i !== r && (t = t.slice(0, i));
          return t;
        }(t, e, n) : function (t, e) {
          if (c.isBuffer(e)) {
            var n = 0 | f(e.length);
            return 0 === (t = s(t, n)).length || e.copy(t, 0, 0, n), t;
          }
          if (e) {
            if ('undefined' != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || 'length' in e) return 'number' != typeof e.length || (r = e.length) != r ? s(t, 0) : h(t, e);
            if ('Buffer' === e.type && o(e.data)) return h(t, e.data);
          }
          var r;
          throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
        }(t, e);
      }
      function u(t) {
        if ('number' != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }
      function d(t, e) {
        if (u(e), t = s(t, e < 0 ? 0 : 0 | f(e)), !c.TYPED_ARRAY_SUPPORT) for (var n = 0; n < e; ++n) t[n] = 0;
        return t;
      }
      function h(t, e) {
        var n = e.length < 0 ? 0 : 0 | f(e.length);
        t = s(t, n);
        for (var r = 0; r < n; r += 1) t[r] = 255 & e[r];
        return t;
      }
      function f(t) {
        if (t >= a()) throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + a().toString(16) + ' bytes');
        return 0 | t;
      }
      function p(t, e) {
        if (c.isBuffer(t)) return t.length;
        if ('undefined' != typeof ArrayBuffer && 'function' == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        'string' != typeof t && (t = '' + t);
        var n = t.length;
        if (0 === n) return 0;
        for (var r = !1;;) switch (e) {
          case 'ascii':
          case 'latin1':
          case 'binary':
            return n;
          case 'utf8':
          case 'utf-8':
          case void 0:
            return H(t).length;
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return 2 * n;
          case 'hex':
            return n >>> 1;
          case 'base64':
            return B(t).length;
          default:
            if (r) return H(t).length;
            e = ('' + e).toLowerCase(), r = !0;
        }
      }
      function g(t, e, n) {
        var r = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return '';
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return '';
        if ((n >>>= 0) <= (e >>>= 0)) return '';
        for (t || (t = 'utf8'); 1;) switch (t) {
          case 'hex':
            return A(this, e, n);
          case 'utf8':
          case 'utf-8':
            return T(this, e, n);
          case 'ascii':
            return E(this, e, n);
          case 'latin1':
          case 'binary':
            return P(this, e, n);
          case 'base64':
            return k(this, e, n);
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return M(this, e, n);
          default:
            if (r) throw new TypeError('Unknown encoding: ' + t);
            t = (t + '').toLowerCase(), r = !0;
        }
      }
      function v(t, e, n) {
        var r = t[e];
        t[e] = t[n], t[n] = r;
      }
      function m(t, e, n, r, i) {
        if (0 === t.length) return -1;
        if ('string' == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : t.length - 1), n < 0 && (n = t.length + n), n >= t.length) {
          if (i) return -1;
          n = t.length - 1;
        } else if (n < 0) {
          if (!i) return -1;
          n = 0;
        }
        if ('string' == typeof e && (e = c.from(e, r)), c.isBuffer(e)) return 0 === e.length ? -1 : b(t, e, n, r, i);
        if ('number' == typeof e) return e &= 255, c.TYPED_ARRAY_SUPPORT && 'function' == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, n) : Uint8Array.prototype.lastIndexOf.call(t, e, n) : b(t, [e], n, r, i);
        throw new TypeError('val must be string, number or Buffer');
      }
      function b(t, e, n, r, i) {
        var o,
          a = 1,
          s = t.length,
          c = e.length;
        if (void 0 !== r && ('ucs2' === (r = String(r).toLowerCase()) || 'ucs-2' === r || 'utf16le' === r || 'utf-16le' === r)) {
          if (t.length < 2 || e.length < 2) return -1;
          a = 2, s /= 2, c /= 2, n /= 2;
        }
        function l(t, e) {
          return 1 === a ? t[e] : t.readUInt16BE(e * a);
        }
        if (i) {
          var u = -1;
          for (o = n; o < s; o++) if (l(t, o) === l(e, -1 === u ? 0 : o - u)) {
            if (-1 === u && (u = o), o - u + 1 === c) return u * a;
          } else -1 !== u && (o -= o - u), u = -1;
        } else for (n + c > s && (n = s - c), o = n; o >= 0; o--) {
          for (var d = !0, h = 0; h < c; h++) if (l(t, o + h) !== l(e, h)) {
            d = !1;
            break;
          }
          if (d) return o;
        }
        return -1;
      }
      function y(t, e, n, r) {
        n = Number(n) || 0;
        var i = t.length - n;
        r ? (r = Number(r)) > i && (r = i) : r = i;
        var o = e.length;
        if (o % 2 != 0) throw new TypeError('Invalid hex string');
        r > o / 2 && (r = o / 2);
        for (var a = 0; a < r; ++a) {
          var s = parseInt(e.substr(2 * a, 2), 16);
          if (isNaN(s)) return a;
          t[n + a] = s;
        }
        return a;
      }
      function w(t, e, n, r) {
        return U(H(e, t.length - n), t, n, r);
      }
      function x(t, e, n, r) {
        return U(function (t) {
          for (var e = [], n = 0; n < t.length; ++n) e.push(255 & t.charCodeAt(n));
          return e;
        }(e), t, n, r);
      }
      function O(t, e, n, r) {
        return x(t, e, n, r);
      }
      function C(t, e, n, r) {
        return U(B(e), t, n, r);
      }
      function S(t, e, n, r) {
        return U(function (t, e) {
          for (var n, r, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) n = t.charCodeAt(a), r = n >> 8, i = n % 256, o.push(i), o.push(r);
          return o;
        }(e, t.length - n), t, n, r);
      }
      function k(t, e, n) {
        return 0 === e && n === t.length ? r.fromByteArray(t) : r.fromByteArray(t.slice(e, n));
      }
      function T(t, e, n) {
        n = Math.min(t.length, n);
        for (var r = [], i = e; i < n;) {
          var o,
            a,
            s,
            c,
            l = t[i],
            u = null,
            d = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
          if (i + d <= n) switch (d) {
            case 1:
              l < 128 && (u = l);
              break;
            case 2:
              128 == (192 & (o = t[i + 1])) && (c = (31 & l) << 6 | 63 & o) > 127 && (u = c);
              break;
            case 3:
              o = t[i + 1], a = t[i + 2], 128 == (192 & o) && 128 == (192 & a) && (c = (15 & l) << 12 | (63 & o) << 6 | 63 & a) > 2047 && (c < 55296 || c > 57343) && (u = c);
              break;
            case 4:
              o = t[i + 1], a = t[i + 2], s = t[i + 3], 128 == (192 & o) && 128 == (192 & a) && 128 == (192 & s) && (c = (15 & l) << 18 | (63 & o) << 12 | (63 & a) << 6 | 63 & s) > 65535 && c < 1114112 && (u = c);
          }
          null === u ? (u = 65533, d = 1) : u > 65535 && (u -= 65536, r.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), r.push(u), i += d;
        }
        return function (t) {
          var e = t.length;
          if (e <= j) return String.fromCharCode.apply(String, t);
          var n = '',
            r = 0;
          for (; r < e;) n += String.fromCharCode.apply(String, t.slice(r, r += j));
          return n;
        }(r);
      }
      e.Buffer = c, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return c.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, c.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && 'function' == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = a(), c.poolSize = 8192, c._augment = function (t) {
        return t.__proto__ = c.prototype, t;
      }, c.from = function (t, e, n) {
        return l(null, t, e, n);
      }, c.TYPED_ARRAY_SUPPORT && (c.prototype.__proto__ = Uint8Array.prototype, c.__proto__ = Uint8Array, 'undefined' != typeof Symbol && Symbol.species && c[Symbol.species] === c && Object.defineProperty(c, Symbol.species, {
        value: null,
        configurable: !0
      })), c.alloc = function (t, e, n) {
        return function (t, e, n, r) {
          return u(e), e <= 0 ? s(t, e) : void 0 !== n ? 'string' == typeof r ? s(t, e).fill(n, r) : s(t, e).fill(n) : s(t, e);
        }(null, t, e, n);
      }, c.allocUnsafe = function (t) {
        return d(null, t);
      }, c.allocUnsafeSlow = function (t) {
        return d(null, t);
      }, c.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, c.compare = function (t, e) {
        if (!c.isBuffer(t) || !c.isBuffer(e)) throw new TypeError('Arguments must be Buffers');
        if (t === e) return 0;
        for (var n = t.length, r = e.length, i = 0, o = Math.min(n, r); i < o; ++i) if (t[i] !== e[i]) {
          n = t[i], r = e[i];
          break;
        }
        return n < r ? -1 : r < n ? 1 : 0;
      }, c.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case 'hex':
          case 'utf8':
          case 'utf-8':
          case 'ascii':
          case 'latin1':
          case 'binary':
          case 'base64':
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return !0;
          default:
            return !1;
        }
      }, c.concat = function (t, e) {
        if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return c.alloc(0);
        var n;
        if (void 0 === e) for (e = 0, n = 0; n < t.length; ++n) e += t[n].length;
        var r = c.allocUnsafe(e),
          i = 0;
        for (n = 0; n < t.length; ++n) {
          var a = t[n];
          if (!c.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(r, i), i += a.length;
        }
        return r;
      }, c.byteLength = p, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
        for (var e = 0; e < t; e += 2) v(this, e, e + 1);
        return this;
      }, c.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
        for (var e = 0; e < t; e += 4) v(this, e, e + 3), v(this, e + 1, e + 2);
        return this;
      }, c.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
        for (var e = 0; e < t; e += 8) v(this, e, e + 7), v(this, e + 1, e + 6), v(this, e + 2, e + 5), v(this, e + 3, e + 4);
        return this;
      }, c.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? '' : 0 === arguments.length ? T(this, 0, t) : g.apply(this, arguments);
      }, c.prototype.equals = function (t) {
        if (!c.isBuffer(t)) throw new TypeError('Argument must be a Buffer');
        return this === t || 0 === c.compare(this, t);
      }, c.prototype.inspect = function () {
        var t = '',
          n = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString('hex', 0, n).match(/.{2}/g).join(' '), this.length > n && (t += ' ... ')), '<Buffer ' + t + '>';
      }, c.prototype.compare = function (t, e, n, r, i) {
        if (!c.isBuffer(t)) throw new TypeError('Argument must be a Buffer');
        if (void 0 === e && (e = 0), void 0 === n && (n = t ? t.length : 0), void 0 === r && (r = 0), void 0 === i && (i = this.length), e < 0 || n > t.length || r < 0 || i > this.length) throw new RangeError('out of range index');
        if (r >= i && e >= n) return 0;
        if (r >= i) return -1;
        if (e >= n) return 1;
        if (this === t) return 0;
        for (var o = (i >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (e >>>= 0), s = Math.min(o, a), l = this.slice(r, i), u = t.slice(e, n), d = 0; d < s; ++d) if (l[d] !== u[d]) {
          o = l[d], a = u[d];
          break;
        }
        return o < a ? -1 : a < o ? 1 : 0;
      }, c.prototype.includes = function (t, e, n) {
        return -1 !== this.indexOf(t, e, n);
      }, c.prototype.indexOf = function (t, e, n) {
        return m(this, t, e, n, !0);
      }, c.prototype.lastIndexOf = function (t, e, n) {
        return m(this, t, e, n, !1);
      }, c.prototype.write = function (t, e, n, r) {
        if (void 0 === e) r = 'utf8', n = this.length, e = 0;else if (void 0 === n && 'string' == typeof e) r = e, n = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
          e |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = 'utf8')) : (r = n, n = void 0);
        }
        var i = this.length - e;
        if ((void 0 === n || n > i) && (n = i), t.length > 0 && (n < 0 || e < 0) || e > this.length) throw new RangeError('Attempt to write outside buffer bounds');
        r || (r = 'utf8');
        for (var o = !1;;) switch (r) {
          case 'hex':
            return y(this, t, e, n);
          case 'utf8':
          case 'utf-8':
            return w(this, t, e, n);
          case 'ascii':
            return x(this, t, e, n);
          case 'latin1':
          case 'binary':
            return O(this, t, e, n);
          case 'base64':
            return C(this, t, e, n);
          case 'ucs2':
          case 'ucs-2':
          case 'utf16le':
          case 'utf-16le':
            return S(this, t, e, n);
          default:
            if (o) throw new TypeError('Unknown encoding: ' + r);
            r = ('' + r).toLowerCase(), o = !0;
        }
      }, c.prototype.toJSON = function () {
        return {
          type: 'Buffer',
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var j = 4096;
      function E(t, e, n) {
        var r = '';
        n = Math.min(t.length, n);
        for (var i = e; i < n; ++i) r += String.fromCharCode(127 & t[i]);
        return r;
      }
      function P(t, e, n) {
        var r = '';
        n = Math.min(t.length, n);
        for (var i = e; i < n; ++i) r += String.fromCharCode(t[i]);
        return r;
      }
      function A(t, e, n) {
        var r = t.length;
        (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);
        for (var i = '', o = e; o < n; ++o) i += z(t[o]);
        return i;
      }
      function M(t, e, n) {
        for (var r = t.slice(e, n), i = '', o = 0; o < r.length; o += 2) i += String.fromCharCode(r[o] + 256 * r[o + 1]);
        return i;
      }
      function D(t, e, n) {
        if (t % 1 != 0 || t < 0) throw new RangeError('offset is not uint');
        if (t + e > n) throw new RangeError('Trying to access beyond buffer length');
      }
      function L(t, e, n, r, i, o) {
        if (!c.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
        if (n + r > t.length) throw new RangeError('Index out of range');
      }
      function _(t, e, n, r) {
        e < 0 && (e = 65535 + e + 1);
        for (var i = 0, o = Math.min(t.length - n, 2); i < o; ++i) t[n + i] = (e & 255 << 8 * (r ? i : 1 - i)) >>> 8 * (r ? i : 1 - i);
      }
      function N(t, e, n, r) {
        e < 0 && (e = 4294967295 + e + 1);
        for (var i = 0, o = Math.min(t.length - n, 4); i < o; ++i) t[n + i] = e >>> 8 * (r ? i : 3 - i) & 255;
      }
      function I(t, e, n, r, i, o) {
        if (n + r > t.length) throw new RangeError('Index out of range');
        if (n < 0) throw new RangeError('Index out of range');
      }
      function R(t, e, n, r, o) {
        return o || I(t, 0, n, 4), i.write(t, e, n, r, 23, 4), n + 4;
      }
      function F(t, e, n, r, o) {
        return o || I(t, 0, n, 8), i.write(t, e, n, r, 52, 8), n + 8;
      }
      c.prototype.slice = function (t, e) {
        var n,
          r = this.length;
        if ((t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = void 0 === e ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t), c.TYPED_ARRAY_SUPPORT) (n = this.subarray(t, e)).__proto__ = c.prototype;else {
          var i = e - t;
          n = new c(i, void 0);
          for (var o = 0; o < i; ++o) n[o] = this[o + t];
        }
        return n;
      }, c.prototype.readUIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || D(t, e, this.length);
        for (var r = this[t], i = 1, o = 0; ++o < e && (i *= 256);) r += this[t + o] * i;
        return r;
      }, c.prototype.readUIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || D(t, e, this.length);
        for (var r = this[t + --e], i = 1; e > 0 && (i *= 256);) r += this[t + --e] * i;
        return r;
      }, c.prototype.readUInt8 = function (t, e) {
        return e || D(t, 1, this.length), this[t];
      }, c.prototype.readUInt16LE = function (t, e) {
        return e || D(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, c.prototype.readUInt16BE = function (t, e) {
        return e || D(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, c.prototype.readUInt32LE = function (t, e) {
        return e || D(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, c.prototype.readUInt32BE = function (t, e) {
        return e || D(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, c.prototype.readIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || D(t, e, this.length);
        for (var r = this[t], i = 1, o = 0; ++o < e && (i *= 256);) r += this[t + o] * i;
        return r >= (i *= 128) && (r -= Math.pow(2, 8 * e)), r;
      }, c.prototype.readIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || D(t, e, this.length);
        for (var r = e, i = 1, o = this[t + --r]; r > 0 && (i *= 256);) o += this[t + --r] * i;
        return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
      }, c.prototype.readInt8 = function (t, e) {
        return e || D(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, c.prototype.readInt16LE = function (t, e) {
        e || D(t, 2, this.length);
        var n = this[t] | this[t + 1] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, c.prototype.readInt16BE = function (t, e) {
        e || D(t, 2, this.length);
        var n = this[t + 1] | this[t] << 8;
        return 32768 & n ? 4294901760 | n : n;
      }, c.prototype.readInt32LE = function (t, e) {
        return e || D(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, c.prototype.readInt32BE = function (t, e) {
        return e || D(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, c.prototype.readFloatLE = function (t, e) {
        return e || D(t, 4, this.length), i.read(this, t, !0, 23, 4);
      }, c.prototype.readFloatBE = function (t, e) {
        return e || D(t, 4, this.length), i.read(this, t, !1, 23, 4);
      }, c.prototype.readDoubleLE = function (t, e) {
        return e || D(t, 8, this.length), i.read(this, t, !0, 52, 8);
      }, c.prototype.readDoubleBE = function (t, e) {
        return e || D(t, 8, this.length), i.read(this, t, !1, 52, 8);
      }, c.prototype.writeUIntLE = function (t, e, n, r) {
        (t = +t, e |= 0, n |= 0, r) || L(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        var i = 1,
          o = 0;
        for (this[e] = 255 & t; ++o < n && (i *= 256);) this[e + o] = t / i & 255;
        return e + n;
      }, c.prototype.writeUIntBE = function (t, e, n, r) {
        (t = +t, e |= 0, n |= 0, r) || L(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        var i = n - 1,
          o = 1;
        for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) this[e + i] = t / o & 255;
        return e + n;
      }, c.prototype.writeUInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 1, 255, 0), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, c.prototype.writeUInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : _(this, t, e, !0), e + 2;
      }, c.prototype.writeUInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : _(this, t, e, !1), e + 2;
      }, c.prototype.writeUInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : N(this, t, e, !0), e + 4;
      }, c.prototype.writeUInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
      }, c.prototype.writeIntLE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          L(this, t, e, n, i - 1, -i);
        }
        var o = 0,
          a = 1,
          s = 0;
        for (this[e] = 255 & t; ++o < n && (a *= 256);) t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
        return e + n;
      }, c.prototype.writeIntBE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var i = Math.pow(2, 8 * n - 1);
          L(this, t, e, n, i - 1, -i);
        }
        var o = n - 1,
          a = 1,
          s = 0;
        for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
        return e + n;
      }, c.prototype.writeInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 1, 127, -128), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, c.prototype.writeInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : _(this, t, e, !0), e + 2;
      }, c.prototype.writeInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : _(this, t, e, !1), e + 2;
      }, c.prototype.writeInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 4, 2147483647, -2147483648), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : N(this, t, e, !0), e + 4;
      }, c.prototype.writeInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || L(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : N(this, t, e, !1), e + 4;
      }, c.prototype.writeFloatLE = function (t, e, n) {
        return R(this, t, e, !0, n);
      }, c.prototype.writeFloatBE = function (t, e, n) {
        return R(this, t, e, !1, n);
      }, c.prototype.writeDoubleLE = function (t, e, n) {
        return F(this, t, e, !0, n);
      }, c.prototype.writeDoubleBE = function (t, e, n) {
        return F(this, t, e, !1, n);
      }, c.prototype.copy = function (t, e, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), e >= t.length && (e = t.length), e || (e = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError('targetStart out of bounds');
        if (n < 0 || n >= this.length) throw new RangeError('sourceStart out of bounds');
        if (r < 0) throw new RangeError('sourceEnd out of bounds');
        r > this.length && (r = this.length), t.length - e < r - n && (r = t.length - e + n);
        var i,
          o = r - n;
        if (this === t && n < e && e < r) for (i = o - 1; i >= 0; --i) t[i + e] = this[i + n];else if (o < 1e3 || !c.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) t[i + e] = this[i + n];else Uint8Array.prototype.set.call(t, this.subarray(n, n + o), e);
        return o;
      }, c.prototype.fill = function (t, e, n, r) {
        if ('string' == typeof t) {
          if ('string' == typeof e ? (r = e, e = 0, n = this.length) : 'string' == typeof n && (r = n, n = this.length), 1 === t.length) {
            var i = t.charCodeAt(0);
            i < 256 && (t = i);
          }
          if (void 0 !== r && 'string' != typeof r) throw new TypeError('encoding must be a string');
          if ('string' == typeof r && !c.isEncoding(r)) throw new TypeError('Unknown encoding: ' + r);
        } else 'number' == typeof t && (t &= 255);
        if (e < 0 || this.length < e || this.length < n) throw new RangeError('Out of range index');
        if (n <= e) return this;
        var o;
        if (e >>>= 0, n = void 0 === n ? this.length : n >>> 0, t || (t = 0), 'number' == typeof t) for (o = e; o < n; ++o) this[o] = t;else {
          var a = c.isBuffer(t) ? t : H(new c(t, r).toString()),
            s = a.length;
          for (o = 0; o < n - e; ++o) this[o + e] = a[o % s];
        }
        return this;
      };
      var V = /[^+\/0-9A-Za-z-_]/g;
      function z(t) {
        return t < 16 ? '0' + t.toString(16) : t.toString(16);
      }
      function H(t, e) {
        var n;
        e = e || 1 / 0;
        for (var r = t.length, i = null, o = [], a = 0; a < r; ++a) {
          if ((n = t.charCodeAt(a)) > 55295 && n < 57344) {
            if (!i) {
              if (n > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }
              if (a + 1 === r) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }
              i = n;
              continue;
            }
            if (n < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), i = n;
              continue;
            }
            n = (i - 55296 << 10 | n - 56320) + 65536;
          } else i && (e -= 3) > -1 && o.push(239, 191, 189);
          if (i = null, n < 128) {
            if ((e -= 1) < 0) break;
            o.push(n);
          } else if (n < 2048) {
            if ((e -= 2) < 0) break;
            o.push(n >> 6 | 192, 63 & n | 128);
          } else if (n < 65536) {
            if ((e -= 3) < 0) break;
            o.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
          } else {
            if (!(n < 1114112)) throw new Error('Invalid code point');
            if ((e -= 4) < 0) break;
            o.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
          }
        }
        return o;
      }
      function B(t) {
        return r.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, '');
          }(t).replace(V, '')).length < 2) return '';
          for (; t.length % 4 != 0;) t += '=';
          return t;
        }(t));
      }
      function U(t, e, n, r) {
        for (var i = 0; i < r && !(i + n >= e.length || i >= t.length); ++i) e[i + n] = t[i];
        return i;
      }
    }).call(this, n(7));
  }, function (t, e, n) {
    "use strict";

    e.byteLength = function (t) {
      var e = l(t),
        n = e[0],
        r = e[1];
      return 3 * (n + r) / 4 - r;
    }, e.toByteArray = function (t) {
      var e,
        n,
        r = l(t),
        a = r[0],
        s = r[1],
        c = new o(function (t, e, n) {
          return 3 * (e + n) / 4 - n;
        }(0, a, s)),
        u = 0,
        d = s > 0 ? a - 4 : a;
      for (n = 0; n < d; n += 4) e = i[t.charCodeAt(n)] << 18 | i[t.charCodeAt(n + 1)] << 12 | i[t.charCodeAt(n + 2)] << 6 | i[t.charCodeAt(n + 3)], c[u++] = e >> 16 & 255, c[u++] = e >> 8 & 255, c[u++] = 255 & e;
      2 === s && (e = i[t.charCodeAt(n)] << 2 | i[t.charCodeAt(n + 1)] >> 4, c[u++] = 255 & e);
      1 === s && (e = i[t.charCodeAt(n)] << 10 | i[t.charCodeAt(n + 1)] << 4 | i[t.charCodeAt(n + 2)] >> 2, c[u++] = e >> 8 & 255, c[u++] = 255 & e);
      return c;
    }, e.fromByteArray = function (t) {
      for (var e, n = t.length, i = n % 3, o = [], a = 16383, s = 0, c = n - i; s < c; s += a) o.push(u(t, s, s + a > c ? c : s + a));
      1 === i ? (e = t[n - 1], o.push(r[e >> 2] + r[e << 4 & 63] + '==')) : 2 === i && (e = (t[n - 2] << 8) + t[n - 1], o.push(r[e >> 10] + r[e >> 4 & 63] + r[e << 2 & 63] + '='));
      return o.join('');
    };
    for (var r = [], i = [], o = 'undefined' != typeof Uint8Array ? Uint8Array : Array, a = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', s = 0, c = a.length; s < c; ++s) r[s] = a[s], i[a.charCodeAt(s)] = s;
    function l(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
      var n = t.indexOf('=');
      return -1 === n && (n = e), [n, n === e ? 0 : 4 - n % 4];
    }
    function u(t, e, n) {
      for (var i, o, a = [], s = e; s < n; s += 3) i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(r[(o = i) >> 18 & 63] + r[o >> 12 & 63] + r[o >> 6 & 63] + r[63 & o]);
      return a.join('');
    }
    i['-'.charCodeAt(0)] = 62, i['_'.charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, n, r, i) {
      var o,
        a,
        s = 8 * i - r - 1,
        c = (1 << s) - 1,
        l = c >> 1,
        u = -7,
        d = n ? i - 1 : 0,
        h = n ? -1 : 1,
        f = t[e + d];
      for (d += h, o = f & (1 << -u) - 1, f >>= -u, u += s; u > 0; o = 256 * o + t[e + d], d += h, u -= 8);
      for (a = o & (1 << -u) - 1, o >>= -u, u += r; u > 0; a = 256 * a + t[e + d], d += h, u -= 8);
      if (0 === o) o = 1 - l;else {
        if (o === c) return a ? NaN : (f ? -1 : 1) * (1 / 0);
        a += Math.pow(2, r), o -= l;
      }
      return (f ? -1 : 1) * a * Math.pow(2, o - r);
    }, e.write = function (t, e, n, r, i, o) {
      var a,
        s,
        c,
        l = 8 * o - i - 1,
        u = (1 << l) - 1,
        d = u >> 1,
        h = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        f = r ? 0 : o - 1,
        p = r ? 1 : -1,
        g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = u) : (a = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), (e += a + d >= 1 ? h / c : h * Math.pow(2, 1 - d)) * c >= 2 && (a++, c /= 2), a + d >= u ? (s = 0, a = u) : a + d >= 1 ? (s = (e * c - 1) * Math.pow(2, i), a += d) : (s = e * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; t[n + f] = 255 & s, f += p, s /= 256, i -= 8);
      for (a = a << i | s, l += i; l > 0; t[n + f] = 255 & a, f += p, a /= 256, l -= 8);
      t[n + f - p] |= 128 * g;
    };
  }, function (t, e) {
    var n = {}.toString;
    t.exports = Array.isArray || function (t) {
      return '[object Array]' == n.call(t);
    };
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var r = n(8),
      i = n.n(r);
    var o = function o(t, e, n, r) {
      t.add(r, {
        label: "\n      <svg xmlns=\"http://www.w3.org/2000/svg\"   viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-link\"><path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\"></path><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\"></path></svg>\n          <div>".concat(n, "</div>\n      "),
        category: e,
        content: {
          type: "link",
          content: "Link text",
          classes: ["btn", "btn-primary"]
        },
        render: function render(t) {
          var e = t.model,
            r = t.className;
          return "\n      <div class=\"".concat(r, "-label ").concat(r, "__drapcode-wrap\">\n      ").concat(e.get("label"), "\n      </div>\n  \n      <span class=\"").concat(r, "__info\">\n        <a target=\"_blank\" href=\"https://academy.drapcode.com/docs/app-builder/basic-component-link\" draggable=\"false\">\n          <i class=\"").concat(r, "__info-fa fa fa-info-circle\" style=\"margin-left: 5px\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </span>\n    ");
        }
      }), t.add(r + "frequently_used", {
        label: "\n      <svg xmlns=\"http://www.w3.org/2000/svg\"   viewBox=\"0 0 24 24\" width=\"32\" height=\"50\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-link\"><path d=\"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71\"></path><path d=\"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71\"></path></svg>\n          <div>".concat(n, "</div>\n      "),
        category: "Frequently Used",
        attributes: {
          style: "order: 1"
        },
        content: {
          type: "link",
          content: "Link text",
          classes: ["btn", "btn-primary"]
        },
        render: function render(t) {
          var e = t.model,
            r = t.className;
          return "\n      <div class=\"".concat(r, "-label ").concat(r, "__drapcode-wrap\">\n      ").concat(e.get("label"), "\n      </div>\n  \n      <span class=\"").concat(r, "__info\">\n        <a target=\"_blank\" href=\"https://academy.drapcode.com/docs/app-builder/basic-component-link\" draggable=\"false\">\n          <i class=\"").concat(r, "__info-fa fa fa-info-circle\" style=\"margin-left: 5px\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </span>\n    ");
        }
      });
    };
    var a = function a(t, e, n, r, i) {
      var o = t.getType("default").model;
      t.addType(r, {
        model: {
          defaults: {
            resizable: !0,
            editable: !0,
            traits: [{
              type: "webconnect-href",
              name: "href",
              label: !1,
              content: "Link Text"
            }, {
              type: "webconnect-link",
              label: !1,
              content: "Insert your text here"
            }, {
              type: "webconnect-event",
              label: "Event",
              name: "onclick"
            }, {
              label: "Prevent Double Click",
              type: "checkbox",
              name: "data-prevent-dblclick"
            }, {
              label: "Disable Duration (milliseconds)",
              type: "number",
              name: "data-disable-duration",
              placeholder: "eg. 5000",
              min: 1e3,
              max: 15e3,
              step: 500,
              default: 5e3
            }].concat(o.prototype.defaults.traits)
          },
          init: function init() {}
        }
      });
    };
    var s = function s(t, e, n, r) {
      var i = "<style>\n    .".concat(n, " {\n      text-align: center;\n      font-family: Helvetica, serif;\n    }\n    .").concat(n, "-block {\n      display: inline-block;\n      margin: 0 10px;\n      padding: 10px;\n    }\n    .").concat(n, "-digit {\n      font-size: 5rem;\n    }\n    .").concat(n, "-endtext {\n      font-size: 5rem;\n    }\n    .").concat(n, "-cont,\n    .").concat(n, "-block {\n      display: inline-block;\n    }\n  </style>");
      t.add(r, {
        label: "\n    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" width=\"32\" height=\"50\"><path d=\"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z\"/></svg>\n\n    <div>".concat(n, "</div>"),
        category: e,
        content: "\n        <div class=\"".concat(n, "\" data-gjs-type=\"countdown\"></div>\n        ").concat(i, "\n      "),
        render: function render(t) {
          var e = t.model,
            r = t.className;
          return "\n      <div class=\"".concat(r, "-label ").concat(r, "__drapcode-wrap\">\n      ").concat(e.get("label"), "\n      </div>\n\n      <span class=\"").concat(r, "__info no-doc\">\n        <a target=\"_blank\" href=\"#\" draggable=\"false\">\n          <i class=\"").concat(r, "__info-fa fa fa-info-circle\" style=\"margin-left: 5px\" title=\"Check how to use ").concat(n, "?\"></i>\n        </a>\n      </span>\n    ");
        }
      });
    };
    var c = function c(t, e, n, r) {
      var i = t.getType("default"),
        o = i.view,
        a = i.model;
      t.addType(n, {
        model: a.extend({
          defaults: _objectSpread({}, a.prototype.defaults, {
            startfrom: r.labels.startTime,
            endText: r.labels.endText,
            droppable: !1,
            traits: [{
              label: "Start",
              name: "startfrom",
              changeProp: 1,
              type: r.labels.dateInputType
            }, {
              label: "End text",
              name: "endText",
              changeProp: 1
            }],
            script: function script() {
              var t = "{[ endText ]}",
                e = new Date("{[ startfrom ]}").getTime(),
                n = this.querySelector("[data-js=countdown]"),
                r = this.querySelector("[data-js=countdown-endtext]"),
                i = this.querySelector("[data-js=countdown-day]"),
                o = this.querySelector("[data-js=countdown-hour]"),
                a = this.querySelector("[data-js=countdown-minute]"),
                s = this.querySelector("[data-js=countdown-second]"),
                c = this.gjs_countdown_interval;
              c && c && clearInterval(c);
              var l = function l(t, e, n, r) {
                  i.innerHTML = t < 10 ? "0" + t : t, o.innerHTML = e < 10 ? "0" + e : e, a.innerHTML = n < 10 ? "0" + n : n, s.innerHTML = r < 10 ? "0" + r : r;
                },
                u = function u() {
                  var i = new Date().getTime(),
                    o = e - i,
                    a = Math.floor(o / 864e5),
                    s = Math.floor(o % 864e5 / 36e5),
                    c = Math.floor(o % 36e5 / 6e4),
                    u = Math.floor(o % 6e4 / 1e3);
                  l(a, s, c, u), o < 0 && (clearInterval(d), r.innerHTML = t, n.style.display = "none", r.style.display = "");
                };
              if (e) {
                var d = setInterval(u, 1e3);
                this.gjs_countdown_interval = d, r.style.display = "none", n.style.display = "", u();
              } else l(0, 0, 0, 0);
            }
          })
        }, {
          isComponent: function isComponent(t) {
            if (t.getAttribute && t.getAttribute("data-gjs-type") == n) return {
              type: n
            };
          }
        }),
        view: o.extend({
          init: function init() {
            this.listenTo(this.model, "change:startfrom change:endText", this.updateScript);
            var t = this.model.get("components");
            t.length || (t.reset(), t.add("\n            <span data-js=\"countdown\" class=\"".concat(e, "-cont\">\n              <div class=\"").concat(e, "-block\">\n                <div data-js=\"countdown-day\" class=\"").concat(e, "-digit\"></div>\n                <div class=\"").concat(e, "-label\">").concat(r.labels.labelDays, "</div>\n              </div>\n              <div class=\"").concat(e, "-block\">\n                <div data-js=\"countdown-hour\" class=\"").concat(e, "-digit\"></div>\n                <div class=\"").concat(e, "-label\">").concat(r.labels.labelHours, "</div>\n              </div>\n              <div class=\"").concat(e, "-block\">\n                <div data-js=\"countdown-minute\" class=\"").concat(e, "-digit\"></div>\n                <div class=\"").concat(e, "-label\">").concat(r.labels.labelMinutes, "</div>\n              </div>\n              <div class=\"").concat(e, "-block\">\n                <div data-js=\"countdown-second\" class=\"").concat(e, "-digit\"></div>\n                <div class=\"").concat(e, "-label\">").concat(r.labels.labelSeconds, "</div>\n              </div>\n            </span>\n            <span data-js=\"countdown-endtext\" class=\"").concat(e, "-endtext\"></span>\n          ")));
          }
        })
      });
    };
    var l = function l(t, e, n, r, i) {
      var o = i.blockCustomCode;
      t.add(r, _objectSpread({
        label: "\n    <svg viewBox=\"0 0 24 24\" width=\"32\" height=\"50\">\n        <path d=\"M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z\"></path>\n      </svg>\n\n    <div>".concat(n, "</div>"),
        category: e,
        activate: !0,
        select: !0,
        content: {
          type: r
        },
        render: function render(t) {
          var e = t.model,
            r = t.className;
          return "\n    <div class=\"".concat(r, "-label ").concat(r, "__drapcode-wrap\">\n    ").concat(e.get("label"), "\n    </div>\n\n    <span class=\"").concat(r, "__info\">\n      <a target=\"_blank\" href=\"https://academy.drapcode.com/docs/app-builder/basic-component-custom-code\" draggable=\"false\">\n        <i class=\"").concat(r, "__info-fa fa fa-info-circle\" style=\"margin-left: 5px\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </span>\n  ");
        }
      }, o)), t.add(r + "frequently_used", _objectSpread({
        label: "\n    <svg viewBox=\"0 0 24 24\" width=\"32\" height=\"50\">\n        <path d=\"M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z\"></path>\n      </svg>\n\n    <div>".concat(n, "</div>"),
        category: "Frequently Used",
        attributes: {
          style: "order: 9"
        },
        activate: !0,
        select: !0,
        content: {
          type: r
        },
        render: function render(t) {
          var e = t.model,
            r = t.className;
          return "\n    <div class=\"".concat(r, "-label ").concat(r, "__drapcode-wrap\">\n    ").concat(e.get("label"), "\n    </div>\n\n    <span class=\"").concat(r, "__info\">\n      <a target=\"_blank\" href=\"https://academy.drapcode.com/docs/app-builder/basic-component-custom-code\" draggable=\"false\">\n        <i class=\"").concat(r, "__info-fa fa fa-info-circle\" style=\"margin-left: 5px\" title=\"Check how to use ").concat(n, "?\"></i>\n      </a>\n    </span>\n  ");
        }
      }, o));
    };
    var u = function u(t, e, n, r) {
      var i = t.getType("default"),
        o = i.model,
        a = r.toolbarBtnCustomCode,
        s = r.refs,
        c = r.commands;
      var l;
      t.addType("script", {
        view: {
          onRender: function onRender() {
            this.model.closestType(n) && (this.el.innerHTML = "");
          }
        }
      }), t.addType(n, {
        model: o.extend({
          defaults: _objectSpread({}, o.prototype.defaults, {
            name: e,
            icon: "<svg viewBox=\"0 0 24 24\">\n                  <path d=\"M14.6 16.6l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4m-5.2 0L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4z\"></path>\n                </svg>",
            editable: !0
          }, r.propsCustomCode),
          init: function init() {
            this.listenTo(this, "change:".concat(s.keyCustomCode), this.onCustomCodeChange);
            var t = this.get(s.keyCustomCode) || r.placeholderContent;
            !this.components().length && this.components(t);
          },
          onCustomCodeChange: function onCustomCodeChange() {
            this.components(this.get(s.keyCustomCode));
          }
        }, {
          isComponent: function isComponent() {
            return !1;
          }
        }),
        view: i.view.extend({
          init: function init() {
            this.listenTo(this.model.components(), "add remove reset", this.onComponentsChange), this.onComponentsChange();
          },
          onComponentsChange: function onComponentsChange() {
            var _this = this;
            l && clearInterval(l), l = setTimeout(function () {
              var t = _this.model;
              var e = 1;
              (t.get(s.keyCustomCode) || "").indexOf("<script") >= 0 && (_this.el.innerHTML = r.placeholderScript, e = 0), t.set({
                droppable: e
              });
            }, 0);
          },
          onActive: function onActive() {
            var t = this.model;
            this.em.get("Commands").run(c.custom_code, {
              target: t
            });
          }
        })
      });
    };
    var d = function d(t, e, n, r, i) {
        t.add(r, {
          label: "<i class=\"webconnect-twitter\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            script: function script() {
              var t = document.createElement("script");
              t.src = "https://platform.twitter.com/widgets.js", document.body.appendChild(t);
            },
            components: [{
              tagName: "a",
              content: i
            }]
          }
        });
      },
      h = function h(t, e, n, r, i) {
        t.add(r, {
          label: "<i class=\"webconnect-elfsight\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            script: function script() {
              var t = document.createElement("script");
              t.src = "https://apps.elfsight.com/p/platform.js", document.body.appendChild(t);
            },
            components: [{
              tagName: "div",
              content: i
            }]
          }
        });
      },
      f = function f(t, e, n, r, i) {
        t.add(r, {
          label: "<i class=\"webconnect-facebook\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            components: [{
              tagName: "div",
              content: i
            }]
          }
        });
      },
      p = function p(t, e, n, r) {
        t.add(r, {
          label: "<i class=\"webconnect-getsitecontrol\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            type: r
          }
        });
      };
    var g = function g(t, e, n) {
      t.addType(e, {
        model: {
          defaults: {}
        },
        view: {
          onRender: function onRender(t) {
            var e = t.el;
            var r = document.createElement("script");
            r.src = n, e.appendChild(r);
          }
        }
      });
    };
    var v = function v(t, e, n, r, i) {
        t.add(r, {
          label: "<i class=\"webconnect-surveyMonkey\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            script: i
          }
        });
      },
      m = function m(t, e, n, r, i) {
        t.add(r, {
          label: "<i class=\"webconnect-pinterest\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            script: function script() {
              var t = document.createElement("script");
              t.src = "//assets.pinterest.com/js/pinit.js", document.body.appendChild(t);
            },
            components: [{
              content: i
            }]
          }
        });
      },
      b = function b(t, e, n, r, i, o) {
        t.add(r, {
          label: "<i class=\"webconnect-typeform\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            script: i,
            components: [{
              content: o
            }]
          }
        });
      },
      y = function y(t, e, n, r, i) {
        t.add(r, {
          label: "<i class=\"webconnect-calendly\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            script: function script() {
              var t = document.createElement("script");
              t.src = "https://assets.calendly.com/assets/external/widget.js", document.body.appendChild(t);
            },
            components: [{
              content: i
            }]
          }
        });
      },
      w = function w(t, e, n, r, i, o) {
        t.add(r, {
          label: "<i class=\"webconnect-landbot\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            script: i,
            components: [{
              content: o
            }]
          }
        });
      },
      x = function x(t, e, n, r, i) {
        t.add(r, {
          label: "<i class=\"webconnect-youtube\"></i><div>".concat(n, "</div>"),
          category: e,
          content: {
            components: [{
              content: i
            }]
          }
        });
      };
    var O = function O(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var n = t.DomComponents,
          r = t.BlockManager,
          i = e.projectId,
          O = e.types,
          C = e.labels,
          S = e.blocks,
          k = e.traits,
          T = e.labelWebConnectBasicCategory,
          j = e.labelWebConnectWidgetsCategory,
          E = e.labelWebConnectAdvancedCategory;
        S.link && (o(r, T, C.link, O.link), a(n, 0, C.link, O.link, k.link)), S.countdown && (s(r, E, C.countdown, O.countdown), c(n, C.countdown, O.countdown, e)), S.custom_code && (l(r, T, C.custom_code, O.custom_code, e), u(n, C.custom_code, O.custom_code, e)), S.twitter && d(r, j, C.twitter, O.twitter, e.twitterWidget.setting.code), S.facebook && f(r, j, C.facebook, O.facebook, e.facebookWidget.setting.iframe), S.getsitecontrol && (p(r, j, C.getsitecontrol, O.getsitecontrol), g(n, O.getsitecontrol, e.getsitecontrole.setting.code)), S.surveyMonkey && v(r, j, C.surveyMonkey, O.surveyMonkey, e.surveyMonkey.setting.code), S.elfsight && h(r, j, C.elfsight, O.elfsight, e.elfsightWidget.setting.code), S.pinterest && m(r, j, C.pinterest, O.pinterest, e.pinterestWidget.setting.code), S.typeform && b(r, j, C.typeform, O.typeform, e.typeform.setting.scriptCode, e.typeform.setting.htmlCode), S.calendly && y(r, j, C.calendly, O.calendly, e.calendly.setting.code), S.landbot && w(r, j, C.landbot, O.landbot, e.landbot.setting.script, e.landbot.setting.code), S.youtube && x(r, j, C.youtube, O.youtube, e.youtube.setting.iframe);
      },
      C = n(3),
      S = function S(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var n = t.Commands,
          r = e.modalTitle,
          i = e.codeViewOptions,
          o = e.commandCustomCode,
          a = e.refs,
          s = e.commands,
          c = e.labels,
          l = e.projectId,
          u = e.version,
          d = e.uri;
        var h = !1;
        var f = a.keyCustomCode,
          p = function p(t, e) {
            e instanceof HTMLElement ? t.appendChild(e) : e && t.insertAdjacentHTML("beforeend", e);
          };
        n.add(s.custom_code, _objectSpread({
          keyCustomCode: f,
          run: function run(t, e) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            this.editor = t, this.options = n, this.target = n.target || t.getSelected();
            var r = this.target;
            r && r.get("editable") && this.showCustomCode(r);
          },
          stop: function stop(t) {
            t.Modal.close();
          },
          showCustomCode: function showCustomCode(t) {
            var _this2 = this;
            var e = this.editor,
              n = this.options,
              r = this.getContent(),
              i = t.get(f) || "\x3c!-- Place your custom code below. --\x3e\n      <h2>\n        Add your custom HTML code.\n      </h2>";
            e.Modal.open({
              title: "Insert your code <span class='small'>(<b>Note:</b> By default, included CSS and JS will be stored in the project's Global CSS/JS)</span>",
              content: r
            }).getModel().once("change:open", function () {
              return e.stopCommand(_this2.id);
            }), this.getCodeViewer().setContent(i);
          },
          getPreContent: function getPreContent() {},
          getPostContent: function getPostContent() {},
          getContent: function getContent() {
            var t = this.editor,
              e = document.createElement("div"),
              n = this.getCodeViewer(),
              r = t.getConfig("stylePrefix");
            return e.className = "".concat(r, "custom-code"), p(e, this.getPreContent()), e.appendChild(n.getElement()), p(e, this.getPostContent()), p(e, this.getPrivateContentActions()), p(e, this.getContentActions()), n.refresh(), setTimeout(function () {
              return n.focus();
            }, 0), e;
          },
          getPrivateContentActions: function getPrivateContentActions() {
            var t = document.createElement("div");
            t.className = "form-check-inline";
            var e = document.createElement("input");
            e.type = "checkbox", e.id = "pageScopeCheckbox", e.className = "m-lg-2";
            var n = document.createElement("label");
            n.htmlFor = "pageScopeCheckbox";
            var r = this.checkForSnippet(d);
            n.textContent = "Add included JS code in current ".concat(r ? "Snippet" : "Page");
            var i = document.createElement("span");
            return i.className = "small", i.textContent = "(Default: Add in the project's Global CSS/JS)", t.appendChild(e), t.appendChild(n), t.appendChild(i), e.addEventListener("change", function () {
              e.checked ? (console.log("Add included JS code in current page/snippet checkbox is checked."), h = !0) : (console.log("Add included JS code in current page/snippet checkbox is unchecked."), h = !1);
            }), t;
          },
          checkForSnippet: function checkForSnippet(t) {
            var e = !1;
            return t && t.includes("/snippet-templates/") && (e = !0), e;
          },
          getContentActions: function getContentActions() {
            var _this3 = this;
            var t = this.editor,
              e = document.createElement("button"),
              n = t.getConfig("stylePrefix");
            return e.innerHTML = c.customCodeBtnLabel, e.className = "".concat(n, "btn-prim ").concat(n, "btn-import__custom-code btn btn-theme-submit btn-sm mt-2"), e.title = c.customCodeBtnLabel, e.style = "float: right;", e.onclick = function () {
              return new Promise(function (t, e) {
                try {
                  _this3.handleSave(), t(!0);
                } catch (t) {
                  e(t);
                }
              });
            }, e;
          },
          handleSave: function () {
            var _handleSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
              var t, e, n, r;
              return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    t = this.editor, e = this.target;
                    n = this.getCodeViewer().getContent();
                    r = this.extractTags(n);
                    r.cleanedContent && (n = r.cleanedContent.trim());
                    e.replaceWith(n);
                    t.Modal.close();
                    _context6.next = 8;
                    return Object(C["a"])(l, u, d, h, r);
                  case 8:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6, this);
            }));
            function handleSave() {
              return _handleSave.apply(this, arguments);
            }
            return handleSave;
          }(),
          extractTags: function extractTags(t) {
            var e = /<script\b[^>]*>([\s\S]*?)<\/script>/gim,
              n = /<style\b[^>]*>([\s\S]*?)<\/style>/gim;
            var r = t;
            var i = [];
            var o;
            for (; null !== (o = e.exec(t));) i.push(o[0]);
            var a = [];
            for (; null !== (o = n.exec(t));) a.push(o[0]);
            return r = r.replace(n, ""), r = r.replace(e, ""), {
              scripts: i,
              styles: a,
              cleanedContent: r
            };
          },
          getCodeViewer: function getCodeViewer() {
            var t = this.editor;
            return this.codeViewer || (this.codeViewer = t.CodeManager.createViewer(_objectSpread({
              codeName: "htmlmixed",
              theme: "hopscotch",
              readOnly: 0
            }, i))), this.codeViewer;
          }
        }, o));
      },
      k = function k(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var n = t.TraitManager;
        n.addType(e.traits.link.type, {
          createInput: function createInput(t) {
            var n = t.trait;
            var r = n.get("options") || [],
              i = document.createElement("div");
            i.classList.add("custom-field"), i.innerHTML = "<div class=\"gjs-tab\">\n      <button class=\"gjs-tablinks active webconnect-link__ext\">\n        <i class=\"webconnect-link-solid\"></i>\n      </button>\n      <button class=\"gjs-tablinks webconnect-link__page\">\n        <i class=\"webconnect-file-alt\"></i>\n      </button>\n      <button class=\"gjs-tablinks webconnect-link__mail\">\n        <i class=\"webconnect-pencil\"></i>\n      </button>\n      <button class=\"gjs-tablinks webconnect-link__add\">\n        <i class=\"webconnect-address-card\"></i>\n      </button>\n    </div>\n    \n    <div id=\"URL\" class=\"gjs-tabcontent\" style=\"display: block;\">\n    <div class=\"gjs-container\">\n      <div class=\"gjs-row\">\n        <div class=\"col-25\"><label>URL</label></div>\n        <div class=\"col-75\">\n          <input type=\"text\" class=\"webconnect-link__url\" placeholder=\"ex: www.google.co.in\"/>\n        </div>\n      </div>\n      <div class=\"gjs-row\">\n      <div class=\"col-25\">\n        <input type=\"checkbox\" class=\"webconnect-link__newtab\" name=\"newtab\"/>\n        <span class=\"checkmark\"></span>\n      </div>\n      <div class=\"col-75\">\n        <label>Open in new tab</label></div>\n      </div>\n    </div>\n    </div>\n    <div id=\"PAGE\" class=\"gjs-tabcontent\">\n    <div class=\"gjs-container\">\n      <div class=\"gjs-row\">\n        <div class=\"col-25\">\n          <label>Page</label>\n        </div>\n        <div class=\"col-75\">\n          <select class=\"webconnect-link__type\">\n          ".concat(r.map(function (t) {
              return "<option value=\"".concat(t.id, "\" data-collectionId=\"").concat(t.collectionId, "\">").concat(t.name, "</option>");
            }).join(""), "\n          </select>\n        </div>\n      </div>\n      <div class=\"gjs-row webconnect-link__pathFieldDiv\" style=\"display: none\">\n        <div class=\"col-25\">\n          <label>Path Field</label>\n        </div>\n        <div class=\"col-75\">\n          <select class=\"webconnect-link__pathField\">\n          </select>\n        </div>\n      </div>\n      <div class=\"gjs-row\">\n        <div class=\"col-25\">\n          <input type=\"checkbox\" class=\"webconnect-link__newtab\" name=\"newtab\"/>\n          <span class=\"checkmark\"></span>\n        </div>\n        <div class=\"col-75\">\n          <label>Open in new tab</label>\n        </div>\n      </div>\n      <div class=\"gjs-row\">\n        <div class=\"col-25\">\n          <label>Param</label>\n        </div>\n        <div class=\"col-75\">\n          <input type=\"text\" class=\"webconnect-link__params\" placeholder=\"name=vijay&age=20\"/>\n        </div>\n      </div>\n    </div>\n    </div>\n    <div id=\"EMAIL\" class=\"gjs-tabcontent\">\n      <div class=\"gjs-container\">\n        <div class=\"gjs-row\">\n          <div class=\"col-25\"><label>Email</label></div>\n          <div class=\"col-75\">\n            <input type=\"email\" class=\"webconnect-link__email\" placeholder=\"Email\"/>\n          </div>\n        </div>\n        <div class=\"gjs-row\">\n          <div class=\"col-25\"><label>Sub.</label></div>\n          <div class=\"col-75\">\n            <input type=\"email\" class=\"webconnect-link__subject\" placeholder=\"Subject\"/>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div id=\"PHONE\" class=\"gjs-tabcontent\">\n      <div class=\"gjs-container\">\n        <div class=\"gjs-row\">\n          <div class=\"col-25\"><label>Phone</label></div>\n          <div class=\"col-75\">\n            <input type=\"text\" class=\"webconnect-link__phone\" placeholder=\"+1 0000000000\"/>\n          </div>\n        </div>\n      </div>\n    </div>\n    ");
            var o = i.querySelector(".webconnect-link__phone"),
              a = i.querySelector(".webconnect-link__subject"),
              s = i.querySelector(".webconnect-link__email"),
              c = i.querySelector(".webconnect-link__params"),
              l = i.querySelector(".webconnect-link__newtab"),
              u = i.querySelector(".webconnect-link__url"),
              d = i.querySelector(".webconnect-link__type"),
              h = i.querySelector(".webconnect-link__ext"),
              f = i.querySelector("#URL"),
              p = i.querySelector(".webconnect-link__page"),
              g = i.querySelector("#PAGE"),
              v = i.querySelector(".webconnect-link__mail"),
              m = i.querySelector("#EMAIL"),
              b = i.querySelector(".webconnect-link__add"),
              y = i.querySelector("#PHONE");
            h.addEventListener("click", function (t) {
              t.currentTarget.className += " active", p.classList.remove("active"), v.classList.remove("active"), b.classList.remove("active"), f.style.display = "block", g.style.display = "none", m.style.display = "none", y.style.display = "none", o.value = "", a.value = "", s.value = "", c.value = "", d.value = "", l.checked = !1;
            }), p.addEventListener("click", function (t) {
              t.currentTarget.className += " active", h.classList.remove("active"), v.classList.remove("active"), b.classList.remove("active"), f.style.display = "none", g.style.display = "block", m.style.display = "none", y.style.display = "none", u.value = "", o.value = "", a.value = "", s.value = "", l.checked = !1;
            }), v.addEventListener("click", function (t) {
              t.currentTarget.className += " active", h.classList.remove("active"), p.classList.remove("active"), b.classList.remove("active"), f.style.display = "none", g.style.display = "none", m.style.display = "block", y.style.display = "none", u.value = "", o.value = "", c.value = "", d.value = "", l.value = "";
            }), b.addEventListener("click", function (t) {
              t.currentTarget.className += " active", h.classList.remove("active"), p.classList.remove("active"), v.classList.remove("active"), f.style.display = "none", g.style.display = "none", m.style.display = "none", y.style.display = "block", u.value = "", a.value = "", s.value = "", c.value = "", d.value = "", l.checked = !1;
            });
            var w = i.querySelector(".webconnect-link__pathFieldDiv"),
              x = i.querySelector(".webconnect-link__pathField");
            return d.addEventListener("change", /*#__PURE__*/function () {
              var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(t) {
                var n, _t11, _r7;
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      n = t.target.options[t.target.options.selectedIndex].getAttribute("data-collectionid");
                      if (!(void 0 !== n)) {
                        _context7.next = 10;
                        break;
                      }
                      w.style.display = "block";
                      _context7.next = 5;
                      return Object(C["b"])(e.projectId, n);
                    case 5:
                      _t11 = _context7.sent;
                      _r7 = "".concat(_t11.map(function (t) {
                        return "<option value=\"".concat(t.id, "\">").concat(t.name, "</option>");
                      }).join(""), "\n                       ");
                      x.innerHTML = _r7;
                      _context7.next = 11;
                      break;
                    case 10:
                      w.style.display = "none", x.innerHTML = "";
                    case 11:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }));
              return function (_x23) {
                return _ref18.apply(this, arguments);
              };
            }()), i;
          },
          onEvent: function onEvent(t) {
            var e = t.elInput,
              n = t.component;
            var r = e.querySelector(".webconnect-link__url").value,
              i = e.querySelector(".webconnect-link__newtab").checked,
              o = e.querySelector(".webconnect-link__params").value,
              a = e.querySelector(".webconnect-link__email").value,
              s = e.querySelector(".webconnect-link__subject").value,
              c = e.querySelector(".webconnect-link__phone").value,
              l = e.querySelector(".webconnect-link__type"),
              u = l.value,
              d = e.querySelector(".webconnect-link__pathField").value;
            var h = "",
              f = "",
              p = "",
              g = "",
              v = "";
            c ? h = "tel:".concat(c) : a ? h = "mailto:".concat(a).concat(s ? "?subject=".concat(s) : "") : r ? (h = r, f = i || "true" === i ? "_blank" : "") : (v = u, p = l.options[l.options.selectedIndex].getAttribute("data-collectionid"), g = d, h = p && d ? v + "/" + p + "/" + g : v, o && (h += "?".concat(o)), f = i || "true" === i ? "_blank" : ""), n.addAttributes({
              href: h,
              target: f,
              "data-path-collection-name": p,
              "data-path-field-name": g,
              "data-page-slug": v
            });
          },
          onUpdate: function () {
            var _onUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(t) {
              var n, r, i, o, a, s, c, l, u, d, h, f, p, g, v, m, b, y, w, x, O, S, k, T, _t12, _e16, _n14, _t13, _t14, _t15, _n15;
              return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    n = t.elInput, r = t.component;
                    i = n.querySelector(".webconnect-link__url"), o = n.querySelector(".webconnect-link__ext"), a = n.querySelector("#URL"), s = n.querySelector(".webconnect-link__page"), c = n.querySelector("#PAGE"), l = n.querySelector(".webconnect-link__mail"), u = n.querySelector("#EMAIL"), d = n.querySelector(".webconnect-link__add"), h = n.querySelector("#PHONE"), f = n.querySelector(".webconnect-link__newtab"), p = n.querySelector(".webconnect-link__params"), g = n.querySelector(".webconnect-link__email"), v = n.querySelector(".webconnect-link__subject"), m = n.querySelector(".webconnect-link__phone"), b = n.querySelector(".webconnect-link__type"), y = n.querySelector(".webconnect-link__pathField"), w = n.querySelector(".webconnect-link__pathFieldDiv"), x = r.getAttributes().href || "", O = r.getAttributes().target || "", S = r.getAttributes()["data-path-collection-name"] || "", k = r.getAttributes()["data-path-field-name"] || "", T = r.getAttributes()["data-page-slug"] || "";
                    if (!(void 0 === x || "undefined" === x)) {
                      _context8.next = 6;
                      break;
                    }
                    ;
                    _context8.next = 28;
                    break;
                  case 6:
                    if (!(0 === x.indexOf("mailto:"))) {
                      _context8.next = 11;
                      break;
                    }
                    _t12 = x.replace("mailto:", "").split("?"), _e16 = _t12[0], _n14 = (_t12[1] || "").split("&").reduce(function (t, e) {
                      var n = e.split("=");
                      return t[n[0]] = n[1], t;
                    }, {});
                    g.value = _e16 || "", v.value = _n14.subject || "", u.style.display = "block", l.classList.add("active"), o.classList.remove("active"), s.classList.remove("active"), d.classList.remove("active"), a.style.display = "none", c.style.display = "none", h.style.display = "none";
                    _context8.next = 28;
                    break;
                  case 11:
                    if (!(0 === x.indexOf("tel:"))) {
                      _context8.next = 16;
                      break;
                    }
                    _t13 = x.replace("tel:", "");
                    m.value = _t13, h.style.display = "block", d.classList.add("active"), o.classList.remove("active"), s.classList.remove("active"), l.classList.remove("active"), a.style.display = "none", c.style.display = "none", u.style.display = "none";
                    _context8.next = 28;
                    break;
                  case 16:
                    if (!(x.includes("http://") || x.includes("https://"))) {
                      _context8.next = 20;
                      break;
                    }
                    "_blank" === O && (f.checked = !0), i.value = x, a.style.display = "block", o.classList.add("active"), d.classList.remove("active"), s.classList.remove("active"), l.classList.remove("active"), h.style.display = "none", c.style.display = "none", u.style.display = "none";
                    _context8.next = 28;
                    break;
                  case 20:
                    _t14 = x.split("?");
                    if (!(p.value = _t14[1] || "", b.value = T || "", k)) {
                      _context8.next = 27;
                      break;
                    }
                    _context8.next = 24;
                    return Object(C["b"])(e.projectId, S);
                  case 24:
                    _t15 = _context8.sent;
                    _n15 = "".concat(_t15.map(function (t) {
                      return "<option value=\"".concat(t.id, "\">").concat(t.name, "</option>");
                    }).join(""), "\n                       ");
                    y.innerHTML = _n15, w.style.display = "block", y.value = k;
                  case 27:
                    "_blank" === O && (f.checked = !0), c.style.display = "block", s.classList.add("active"), o.classList.remove("active"), d.classList.remove("active"), l.classList.remove("active"), a.style.display = "none", h.style.display = "none", u.style.display = "none";
                  case 28:
                  case "end":
                    return _context8.stop();
                }
              }, _callee8);
            }));
            function onUpdate(_x24) {
              return _onUpdate.apply(this, arguments);
            }
            return onUpdate;
          }()
        });
      };
    e["default"] = i.a.plugins.add("common-plugin", function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = e;
      var r = {
          link: !0,
          countdown: !0,
          custom_code: !0,
          twitter: !!e.twitterWidget,
          facebook: !!e.facebookWidget,
          getsitecontrol: !!e.getsitecontrole,
          surveyMonkey: !!e.surveyMonkey,
          elfsight: !!e.elfsightWidget,
          pinterest: !!e.pinterestWidget,
          typeform: !!e.typeform,
          calendly: !!e.calendly,
          landbot: !!e.landbot,
          youtube: !!e.youtube
        },
        i = {
          link: "link",
          countdown: "countdown",
          custom_code: "custom_code",
          twitter: "twitter",
          facebook: "facebook",
          getsitecontrol: "getsitecontrol",
          surveyMonkey: "surveyMonkey",
          elfsight: "elfsight",
          pinterest: "pinterest",
          typeform: "typeform",
          calendly: "calendly",
          landbot: "landbot",
          youtube: "youtube"
        },
        o = {
          link: "Link",
          countdown: "Countdown",
          startTime: "",
          endText: "EXPIRED",
          dateInputType: "date",
          labelDays: "days",
          labelHours: "hours",
          labelMinutes: "minutes",
          labelSeconds: "seconds",
          custom_code: "Custom HTML Code",
          buttonLabel: "Save",
          customCodeBtnLabel: "Embed Code",
          twitter: "Twitter",
          facebook: "Facebook",
          getsitecontrol: "Getsitecontrol",
          surveyMonkey: "SurveyMonkey",
          elfsight: "Elfsight",
          pinterest: "Pinterest",
          typeform: "Typeform",
          calendly: "Calendly",
          landbot: "Landbot",
          youtube: "Youtube"
        },
        a = {
          custom_code: "custom-code:open-modal"
        },
        s = {
          countdownRef: "countdown",
          keyCustomCode: "custom-code-plugin__code"
        },
        c = {
          link: {
            type: "webconnect-link",
            name: "href",
            label: !1
          }
        },
        l = _objectSpread({
          blocks: r,
          labels: o,
          types: i,
          traits: c,
          commands: a,
          refs: s,
          labelWebConnectBasicCategory: "Basic",
          labelWebConnectAdvancedCategory: "Advanced",
          labelWebConnectWidgetsCategory: "Widgets",
          blockCustomCode: {},
          propsCustomCode: {},
          placeholderContent: "<span>Insert here your custom code</span>",
          toolbarBtnCustomCode: {},
          placeholderScript: "<div style=\"pointer-events: none; padding: 10px;\">\n      <svg viewBox=\"0 0 24 24\" style=\"height: 30px; vertical-align: middle;\">\n        <path d=\"M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z\"></path>\n        </svg>\n      Custom code with <i>&lt;script&gt;</i> can't be rendered on the canvas\n    </div>",
          modalTitle: "Insert your code",
          codeViewOptions: {
            lineWrapping: !1
          },
          commandCustomCode: {}
        }, e);
      for (var _t16 in l) _t16 in n || (n[_t16] = l[_t16]);
      k(t, l), O(t, e), S(t, l);
    });
  }]);
});